/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AlarmAcknowledgeDto {
  comment?: string;
  systemAck?: boolean;
}

export interface AlarmAcknowledgementDto {
  /** @default true */
  needed?: boolean;
  /** @default false */
  value?: boolean;
  /** @default null */
  ackedBy?: {
    /** @format uuid */
    _id: string;
    _ref: "User";
  } | null;
  /** @default null */
  comment?: string | null;
  /** @default null */
  ackedAt?: string | null;
}

export interface AlarmCallEventAudioCancelDto {
  /** @format uuid */
  participant: string;
  /** @format uuid */
  idempotencyKey: string;
}

export interface AlarmCallEventAudioHeartbeatDto {
  /** @format uuid */
  participant: string;
  /** @format uuid */
  idempotencyKey: string;
}

export interface AlarmCallEventChatHeartbeatDto {
  /** @format uuid */
  participant: string;
  /** @format uuid */
  idempotencyKey: string;
}

export interface AlarmCallEventChatPublishDto {
  /** @format uuid */
  participant: string;
  /** @format uuid */
  idempotencyKey: string;
  text: string;
}

export interface AlarmCallEventOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  alarmCall: {
    /** @format uuid */
    _id: string;
    _ref: "AlarmCall";
  };
  /** @maxLength 1024 */
  participant: string;
  asset?: {
    /** @format uuid */
    _id: string;
    _ref: "Asset";
  };
  user?: {
    /** @format uuid */
    _id: string;
    _ref: "User";
  };
  content:
    | {
        type: "chat";
        state:
          | {
              phase: "started";
              /** @format date-time */
              startedAt: string;
              canceledAt: any;
              publishedAt: any;
              text: any;
            }
          | {
              phase: "canceled";
              /** @format date-time */
              startedAt: string;
              /** @format date-time */
              canceledAt: string;
              publishedAt: any;
              text: any;
            }
          | {
              phase: "published";
              /** @format date-time */
              startedAt: string;
              canceledAt: any;
              /** @format date-time */
              publishedAt: string;
              /** @maxLength 1024 */
              text: string;
            };
        /** @format date-time */
        lastHeartbeatAt: string;
        /** @format uuid */
        idempotencyKey: string;
      }
    | {
        type: "audio";
        state:
          | {
              phase: "started";
              /** @format date-time */
              startedAt: string;
              canceledAt: any;
              processingAt: any;
              publishedAt: any;
              deletedAt: any;
              metadata: any;
              src: any;
            }
          | {
              phase: "canceled";
              /** @format date-time */
              startedAt: string;
              /** @format date-time */
              canceledAt: string;
              processingAt: any;
              publishedAt: any;
              deletedAt: any;
              metadata: any;
              src: any;
            }
          | {
              phase: "processing";
              /** @format date-time */
              startedAt: string;
              canceledAt: any;
              /** @format date-time */
              processingAt: string;
              publishedAt: any;
              deletedAt: any;
              metadata: {
                lengthBytes: number;
                durationMs: number;
                waveform: number[];
                /** @maxLength 4096 */
                transcript: string | null;
              };
              src: any;
            }
          | {
              phase: "published";
              /** @format date-time */
              startedAt: string;
              canceledAt: any;
              /** @format date-time */
              processingAt: string;
              /** @format date-time */
              publishedAt: string;
              deletedAt: any;
              metadata: {
                lengthBytes: number;
                durationMs: number;
                waveform: number[];
                /** @maxLength 4096 */
                transcript: string | null;
              };
              /** @maxLength 1024 */
              src: string;
            }
          | {
              phase: "deleted";
              /** @format date-time */
              startedAt: string;
              canceledAt: any;
              /** @format date-time */
              processingAt: string;
              /** @format date-time */
              publishedAt: string;
              /** @format date-time */
              deletedAt: string;
              metadata: any;
              src: any;
            };
        /** @format date-time */
        lastHeartbeatAt: string;
        /** @format uuid */
        idempotencyKey: string;
      }
    | {
        type: "event.positionUpdate";
      };
}

export interface AlarmCallOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  alarm: {
    /** @format uuid */
    _id: string;
    _ref: "Alarm";
  } | null;
  asset: {
    /** @format uuid */
    _id: string;
    _ref: "Asset";
  } | null;
  type: "alarmCall" | "helperCall";
  /** @maxLength 1024 */
  callSid: string;
  /** @maxLength 1024 */
  conferenceSid: string | null;
  /** @format date-time */
  endedAt: string | null;
}

export interface AlarmCallParticipantOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  alarmCall: {
    /** @format uuid */
    _id: string;
    _ref: "AlarmCall";
  };
  ref:
    | {
        /** @format uuid */
        _id: string;
        _ref: "User";
      }
    | {
        /** @format uuid */
        _id: string;
        _ref: "Asset";
      }
    | null;
  /** @maxLength 1024 */
  name: string;
  state: {
    /** @maxLength 1024 */
    sid: string;
    muted: boolean;
    speaking: boolean;
    /** @format date-time */
    connectedAt: string | null;
    /** @format date-time */
    disconnectedAt: string | null;
  };
}

export interface AlarmCallTwimlCreateDto {
  alarmId?: string;
  assetId?: string;
  Caller: string;
  CallSid: string;
}

export interface AlarmCallTwimlStatusDto {
  alarmId?: string;
  assetId?: string;
  Caller?: string;
  StatusCallbackEvent?: string;
  CallStatus?: string;
  ConferenceSid?: string;
  FriendlyName?: string;
  Muted?: string;
  Hold?: string;
  CallSid?: string;
}

export interface AlarmCountResponseDto {
  open: number;
  closed: number;
}

export interface AlarmCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
  asset: {
    /** @format uuid */
    _id: string;
    _ref: "Asset";
  };
  /** @default {"needed":true,"value":false,"ackedBy":null,"comment":null,"ackedAt":null} */
  ack?: {
    /** @default true */
    needed?: boolean;
    /** @default false */
    value?: boolean;
    /** @default null */
    ackedBy?: {
      /** @format uuid */
      _id: string;
      _ref: "User";
    } | null;
    /** @default null */
    comment?: string | null;
    /** @default null */
    ackedAt?: string | null;
  };
  /**
   * PII
   * @default null
   */
  position?: {
    type: "Point";
    /** PII */
    coordinates: number[];
    properties: {
      accuracy?: number;
      heading?: number;
      headingAccuracy?: number;
      speed?: number;
      speedAccuracy?: number;
      altitude?: number;
      altitudeAccuracy?: number;
      /** PII */
      address?: {
        /** @maxLength 1024 */
        countryCode?: string | null;
        /** @maxLength 1024 */
        state?: string | null;
        /** @maxLength 1024 */
        city?: string | null;
        /** @maxLength 1024 */
        streetName?: string | null;
        /** @maxLength 1024 */
        streetNumber?: string | null;
        floor?: number | null;
        /** @maxLength 1024 */
        formattedAddress?: string;
      };
      /** @format date-time */
      dateTime?: string;
      /** @maxLength 1024 */
      provider?: string;
    };
  };
  severity: "red" | "orange" | "green";
  /**
   * PII
   * @maxLength 4096
   */
  procedure: string | null;
  meta?: {
    observationTrigger?: {
      /** @format uuid */
      _id: string;
      /** @format date-time */
      createdAt: string;
      /** @format date-time */
      updatedAt: string;
      telluId?: number | null;
      migrationFinalised?: boolean | null;
      /** @format date-time */
      migrationFinalisedDate?: string | null;
      customer: {
        /** @format uuid */
        _id: string;
        _ref: "Customer";
      };
      /** @default {"type":"parents","extra":[]} */
      share?: {
        type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
        extra?: {
          /** @format uuid */
          _id: string;
          _ref: "Customer";
        }[];
      };
      /** @maxLength 1024 */
      name: string;
      eventCodes: string[];
      /** @maxLength 1024 */
      description: string;
      status: "active" | "inactive";
      actions: (
        | {
            type: "alarm";
            config: {
              severity: "red" | "orange" | "green";
              type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
              /** @maxLength 4096 */
              procedure: string | null;
              /** @maxLength 1024 */
              name: string;
            };
          }
        | {
            type: "sms";
            config: {
              /** PII */
              toRaw: string[];
              toContactList: {
                /** @format uuid */
                _id: string;
                _ref: "ContactList";
              }[];
              toTriggerUser: boolean;
              /** @maxLength 1024 */
              message: string;
            };
          }
        | {
            type: "email";
            config: {
              /** PII */
              toRaw: string[];
              toContactList: {
                /** @format uuid */
                _id: string;
                _ref: "ContactList";
              }[];
              toTriggerUser: boolean;
              /** @maxLength 1024 */
              message: string;
              /** @maxLength 1024 */
              subject: string;
              /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
              locale?: string;
            };
          }
        | {
            type: "assetUpdate";
            config: {
              available?: boolean;
              app?: {
                mode: "off" | "on" | "risk";
              };
            };
          }
      )[];
      filter:
        | {
            type: "operator/and";
            operands: (
              | {
                  type: "operator/or";
                  operands: (
                    | {
                        type: "operator/not";
                        operand:
                          | {
                              type: "constraint/asset";
                              assets: {
                                /** @format uuid */
                                _id: string;
                                _ref: "Asset";
                              }[];
                            }
                          | {
                              type: "constraint/assetGroup";
                              groups: {
                                /** @format uuid */
                                _id: string;
                                _ref: "AssetGroup";
                              }[];
                            }
                          | {
                              type: "constraint/zone";
                              zone: {
                                /** @format uuid */
                                _id: string;
                                _ref: "Zone";
                              };
                            }
                          | {
                              type: "constraint/schedule";
                              schedule: {
                                entries: {
                                  daysOfWeek: number[];
                                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                  timeStart: string;
                                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                  timeEnd: string;
                                }[];
                              };
                            };
                      }
                    | {
                        type: "constraint/asset";
                        assets: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Asset";
                        }[];
                      }
                    | {
                        type: "constraint/assetGroup";
                        groups: {
                          /** @format uuid */
                          _id: string;
                          _ref: "AssetGroup";
                        }[];
                      }
                    | {
                        type: "constraint/zone";
                        zone: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Zone";
                        };
                      }
                    | {
                        type: "constraint/schedule";
                        schedule: {
                          entries: {
                            daysOfWeek: number[];
                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                            timeStart: string;
                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                            timeEnd: string;
                          }[];
                        };
                      }
                  )[];
                }
              | {
                  type: "constraint/asset";
                  assets: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Asset";
                  }[];
                }
              | {
                  type: "constraint/assetGroup";
                  groups: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[];
                }
              | {
                  type: "constraint/zone";
                  zone: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Zone";
                  };
                }
              | {
                  type: "constraint/schedule";
                  schedule: {
                    entries: {
                      daysOfWeek: number[];
                      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                      timeStart: string;
                      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                      timeEnd: string;
                    }[];
                  };
                }
            )[];
          }
        | {
            type: "constraint/asset";
            assets: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            }[];
          }
        | {
            type: "constraint/assetGroup";
            groups: {
              /** @format uuid */
              _id: string;
              _ref: "AssetGroup";
            }[];
          }
        | {
            type: "constraint/zone";
            zone: {
              /** @format uuid */
              _id: string;
              _ref: "Zone";
            };
          }
        | {
            type: "constraint/schedule";
            schedule: {
              entries: {
                daysOfWeek: number[];
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeStart: string;
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeEnd: string;
              }[];
            };
          };
    };
    /** PII */
    observation?: {
      /** @format uuid */
      _id: string;
      /** @maxLength 1024 */
      event: string;
      asset: {
        /** @format uuid */
        _id: string;
        /** @format date-time */
        createdAt: string;
        /** @format date-time */
        updatedAt: string;
        telluId?: number | null;
        migrationFinalised?: boolean | null;
        /** @format date-time */
        migrationFinalisedDate?: string | null;
        customer: {
          /** @format uuid */
          _id: string;
          _ref: "Customer";
        };
        /** @default {"type":"parents","extra":[]} */
        share?: {
          type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
          extra?: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          }[];
        };
        user: {
          /** @format uuid */
          _id: string;
          _ref: "User";
        } | null;
        /**
         * PII
         * @maxLength 1024
         */
        name: string;
        /**
         * PII
         * @maxLength 1024
         */
        externalId?: string | null;
        propertiesOwnership?: "override" | "inherit";
        /** @default {} */
        properties?: {
          /**
           * PII
           * @maxLength 1024
           */
          phoneNumber?: string | null;
          /**
           * PII
           * @maxLength 1024
           */
          smsNumber?: string | null;
          /**
           * PII
           * @maxLength 1024
           */
          email?: string | null;
          /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
          locale?: string | null;
          /**
           * PII
           * @maxLength 1024
           */
          image?: string | null;
          /** PII */
          rSim?: {
            /**
             * PII
             * @maxLength 1024
             */
            euicc: string;
            primary: {
              /**
               * PII
               * @maxLength 1024
               */
              msisdn: string;
              /**
               * PII
               * @maxLength 1024
               */
              iccid: string;
            };
            secondary: {
              /**
               * PII
               * @maxLength 1024
               */
              msisdn: string;
              /**
               * PII
               * @maxLength 1024
               */
              iccid: string;
            };
            enabled: boolean;
          } | null;
        };
        /**
         * PII
         * @default null
         */
        position?: {
          type: "Point";
          /** PII */
          coordinates: number[];
          properties: {
            accuracy?: number;
            heading?: number;
            headingAccuracy?: number;
            speed?: number;
            speedAccuracy?: number;
            altitude?: number;
            altitudeAccuracy?: number;
            /** PII */
            address?: {
              /** @maxLength 1024 */
              countryCode?: string | null;
              /** @maxLength 1024 */
              state?: string | null;
              /** @maxLength 1024 */
              city?: string | null;
              /** @maxLength 1024 */
              streetName?: string | null;
              /** @maxLength 1024 */
              streetNumber?: string | null;
              floor?: number | null;
              /** @maxLength 1024 */
              formattedAddress?: string;
            };
            /** @format date-time */
            dateTime?: string;
            /** @maxLength 1024 */
            provider?: string;
          };
        };
        available: boolean;
        /** @default true */
        allowContactOnOwnAlarms?: boolean;
        app?: {
          mode: "off" | "on" | "risk";
        } | null;
        insideZones: {
          /** @format uuid */
          _id: string;
          _ref: "Zone";
        }[];
        assetGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        /** @default [] */
        staticResponders?: {
          staticResponder: {
            /** @format uuid */
            _id: string;
            _ref: "StaticResponder";
          };
          priority: number;
        }[];
        /** @format date-time */
        lastObservationAt?: string;
        /** @default false */
        invisibleResponder?: boolean;
        /**
         * PII
         * @maxLength 4096
         */
        description?: string;
        /** @default [] */
        certifications?: {
          /** @format uuid */
          _id: string;
          certificationCategory: {
            /** @format uuid */
            _id: string;
            _ref: "CertificationCategory";
          };
          /** @format date-time */
          firstIssuedOn: string;
          /** @format date-time */
          lastReceivedOn: string;
          /** @format date-time */
          expiryDate: string;
          /**
           * @format date-time
           * @default null
           */
          plannedRenewalDate?: string | null;
          /** @maxLength 1024 */
          documentaryProof?: string | null;
        }[];
        type?: "default" | "kiosk";
        _ref: "Asset";
      };
      customer: {
        /** @format uuid */
        _id: string;
        _ref: "Customer";
      };
      device: {
        /** @format uuid */
        _id: string;
        _ref: "Device";
      };
      user: {
        /** @format uuid */
        _id: string;
        _ref: "User";
      };
      /** PII */
      position?: {
        type: "Point";
        /** PII */
        coordinates: number[];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      };
      beacons?:
        | {
            /** @maxLength 1024 */
            code: string;
            rssi: number;
            battery?: number;
            /** @format date-time */
            dateTime: string;
            beacon: {
              /** @format uuid */
              _id: string;
              _ref: "Beacon";
            } | null;
            calc: number | null;
            valid: boolean;
          }[]
        | {
            /** @maxLength 1024 */
            code: string;
            rssi: number;
            battery?: number;
            /** @format date-time */
            dateTime: string;
          }[];
      /** PII */
      meta?: {
        asset?: {
          /** @format uuid */
          _id: string;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          telluId?: number | null;
          migrationFinalised?: boolean | null;
          /** @format date-time */
          migrationFinalisedDate?: string | null;
          customer: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          };
          /** @default {"type":"parents","extra":[]} */
          share?: {
            type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
            extra?: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            }[];
          };
          user: {
            /** @format uuid */
            _id: string;
            _ref: "User";
          } | null;
          /**
           * PII
           * @maxLength 1024
           */
          name: string;
          /**
           * PII
           * @maxLength 1024
           */
          externalId?: string | null;
          propertiesOwnership?: "override" | "inherit";
          /** @default {} */
          properties?: {
            /**
             * PII
             * @maxLength 1024
             */
            phoneNumber?: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            smsNumber?: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            email?: string | null;
            /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
            locale?: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            image?: string | null;
            /** PII */
            rSim?: {
              /**
               * PII
               * @maxLength 1024
               */
              euicc: string;
              primary: {
                /**
                 * PII
                 * @maxLength 1024
                 */
                msisdn: string;
                /**
                 * PII
                 * @maxLength 1024
                 */
                iccid: string;
              };
              secondary: {
                /**
                 * PII
                 * @maxLength 1024
                 */
                msisdn: string;
                /**
                 * PII
                 * @maxLength 1024
                 */
                iccid: string;
              };
              enabled: boolean;
            } | null;
          };
          /**
           * PII
           * @default null
           */
          position?: {
            type: "Point";
            /** PII */
            coordinates: number[];
            properties: {
              accuracy?: number;
              heading?: number;
              headingAccuracy?: number;
              speed?: number;
              speedAccuracy?: number;
              altitude?: number;
              altitudeAccuracy?: number;
              /** PII */
              address?: {
                /** @maxLength 1024 */
                countryCode?: string | null;
                /** @maxLength 1024 */
                state?: string | null;
                /** @maxLength 1024 */
                city?: string | null;
                /** @maxLength 1024 */
                streetName?: string | null;
                /** @maxLength 1024 */
                streetNumber?: string | null;
                floor?: number | null;
                /** @maxLength 1024 */
                formattedAddress?: string;
              };
              /** @format date-time */
              dateTime?: string;
              /** @maxLength 1024 */
              provider?: string;
            };
          };
          available: boolean;
          /** @default true */
          allowContactOnOwnAlarms?: boolean;
          app?: {
            mode: "off" | "on" | "risk";
          } | null;
          insideZones: {
            /** @format uuid */
            _id: string;
            _ref: "Zone";
          }[];
          assetGroups: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
          /** @default [] */
          staticResponders?: {
            staticResponder: {
              /** @format uuid */
              _id: string;
              _ref: "StaticResponder";
            };
            priority: number;
          }[];
          /** @format date-time */
          lastObservationAt?: string;
          /** @default false */
          invisibleResponder?: boolean;
          /**
           * PII
           * @maxLength 4096
           */
          description?: string;
          /** @default [] */
          certifications?: {
            /** @format uuid */
            _id: string;
            certificationCategory: {
              /** @format uuid */
              _id: string;
              _ref: "CertificationCategory";
            };
            /** @format date-time */
            firstIssuedOn: string;
            /** @format date-time */
            lastReceivedOn: string;
            /** @format date-time */
            expiryDate: string;
            /**
             * @format date-time
             * @default null
             */
            plannedRenewalDate?: string | null;
            /** @maxLength 1024 */
            documentaryProof?: string | null;
          }[];
          type?: "default" | "kiosk";
        };
        battery?: number;
        rssi?: number;
        snr?: number;
        /** @format date-time */
        dateTime?: string;
        /** @format date-time */
        deviceDateTime?: string;
        /** @format date-time */
        gatewayDateTime?: string;
        insideGpsZones?: {
          /** @format uuid */
          _id: string;
          _ref: "Zone";
        }[];
        insideIpsZones?: {
          /** @format uuid */
          _id: string;
          _ref: "Zone";
        }[];
        zone?: {
          /** @format uuid */
          _id: string;
          _ref: "Zone";
        };
        callRequest?: boolean;
        forceLoraCustomer?: {
          /** @format uuid */
          _id: string;
          _ref: "Customer";
        };
        knnResult?: {
          distance: number;
          debugInfo?: any;
        };
        available?: boolean;
      };
      deltas?: {
        main: {
          /** @format date-time */
          start: string;
          /** @format date-time */
          end: string;
          value?: number;
        };
        steps?: {
          gps?: {
            /** @format date-time */
            start: string;
            /** @format date-time */
            end: string;
            value?: number;
          };
          ips?: {
            /** @format date-time */
            start: string;
            /** @format date-time */
            end: string;
            value?: number;
          };
          context?: {
            /** @format date-time */
            start: string;
            /** @format date-time */
            end: string;
            value?: number;
          };
        };
      };
      validPosition?: {
        value: boolean;
        /** @maxLength 1024 */
        reason?: string;
      };
      isSystemEvent?: boolean;
    };
    /** PII */
    frozenInfo?: {
      staticResponse: {
        type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
        priority: number;
        zone?: {
          /** @format uuid */
          _id: string;
          customer?: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          };
          type?:
            | "default"
            | "responseArea"
            | "policeDepartment"
            | "assetMonitoredArea"
            | "fingerprinted"
            | "building"
            | "evacuationPoint";
          /** PII */
          location:
            | {
                type: "Point";
                /** PII */
                coordinates: number[];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              }
            | {
                type: "Polygon";
                /** PII */
                coordinates: number[][][];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              }
            | {
                type: "MultiPolygon";
                coordinates: number[][][][];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              };
          /** @maxLength 1024 */
          name: string;
          staticResponders: {
            staticResponder: {
              /** @format uuid */
              _id: string;
              _ref: "StaticResponder";
            };
            priority: number;
          }[];
        };
        responders: {
          info: {
            /** @format uuid */
            _id: string;
            _ref: "Asset" | "StaticResponder";
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /**
             * PII
             * @maxLength 1024
             */
            image: string | null;
            /** PII */
            position: {
              type: "Point";
              /** PII */
              coordinates: number[];
              properties: {
                accuracy?: number;
                heading?: number;
                headingAccuracy?: number;
                speed?: number;
                speedAccuracy?: number;
                altitude?: number;
                altitudeAccuracy?: number;
                /** PII */
                address?: {
                  /** @maxLength 1024 */
                  countryCode?: string | null;
                  /** @maxLength 1024 */
                  state?: string | null;
                  /** @maxLength 1024 */
                  city?: string | null;
                  /** @maxLength 1024 */
                  streetName?: string | null;
                  /** @maxLength 1024 */
                  streetNumber?: string | null;
                  floor?: number | null;
                  /** @maxLength 1024 */
                  formattedAddress?: string;
                };
                /** @format date-time */
                dateTime?: string;
                /** @maxLength 1024 */
                provider?: string;
              };
            };
            /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
            locale: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            contactCode: string | null;
          };
          distanceKm: number | null;
          actions: {
            /**
             * PII
             * @maxLength 1024
             */
            call: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            sms: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            email: string | null;
            notification: boolean;
          };
          priority: number;
          professionalResponder?: {
            available: boolean;
            inProgress: boolean;
          };
        }[];
      }[];
      dynamicResponse: {
        type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
        priority: number;
        zone?: {
          /** @format uuid */
          _id: string;
          customer?: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          };
          type?:
            | "default"
            | "responseArea"
            | "policeDepartment"
            | "assetMonitoredArea"
            | "fingerprinted"
            | "building"
            | "evacuationPoint";
          /** PII */
          location:
            | {
                type: "Point";
                /** PII */
                coordinates: number[];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              }
            | {
                type: "Polygon";
                /** PII */
                coordinates: number[][][];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              }
            | {
                type: "MultiPolygon";
                coordinates: number[][][][];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              };
          /** @maxLength 1024 */
          name: string;
          staticResponders: {
            staticResponder: {
              /** @format uuid */
              _id: string;
              _ref: "StaticResponder";
            };
            priority: number;
          }[];
        };
        responders: {
          info: {
            /** @format uuid */
            _id: string;
            _ref: "Asset" | "StaticResponder";
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /**
             * PII
             * @maxLength 1024
             */
            image: string | null;
            /** PII */
            position: {
              type: "Point";
              /** PII */
              coordinates: number[];
              properties: {
                accuracy?: number;
                heading?: number;
                headingAccuracy?: number;
                speed?: number;
                speedAccuracy?: number;
                altitude?: number;
                altitudeAccuracy?: number;
                /** PII */
                address?: {
                  /** @maxLength 1024 */
                  countryCode?: string | null;
                  /** @maxLength 1024 */
                  state?: string | null;
                  /** @maxLength 1024 */
                  city?: string | null;
                  /** @maxLength 1024 */
                  streetName?: string | null;
                  /** @maxLength 1024 */
                  streetNumber?: string | null;
                  floor?: number | null;
                  /** @maxLength 1024 */
                  formattedAddress?: string;
                };
                /** @format date-time */
                dateTime?: string;
                /** @maxLength 1024 */
                provider?: string;
              };
            };
            /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
            locale: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            contactCode: string | null;
          };
          distanceKm: number | null;
          actions: {
            /**
             * PII
             * @maxLength 1024
             */
            call: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            sms: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            email: string | null;
            notification: boolean;
          };
          priority: number;
          professionalResponder?: {
            available: boolean;
            inProgress: boolean;
          };
        }[];
      }[];
      professionalResponders?: {
        /** @format uuid */
        _id: string;
        /** @format date-time */
        createdAt: string;
        /** @format date-time */
        updatedAt: string;
        telluId?: number | null;
        migrationFinalised?: boolean | null;
        /** @format date-time */
        migrationFinalisedDate?: string | null;
        customer: {
          /** @format uuid */
          _id: string;
          _ref: "Customer";
        };
        /** @default {"type":"parents","extra":[]} */
        share?: {
          type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
          extra?: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          }[];
        };
        type: "sequrix";
        active: boolean;
        status: "invited" | "accepted" | "rejected" | "started" | "onLocation" | "finished" | "error" | "canceled";
        alarm: {
          /** @format uuid */
          _id: string;
          _ref: "Alarm";
        };
        asset: {
          /** @format uuid */
          _id: string;
          _ref: "Asset";
        };
        staticResponder: {
          /** @format uuid */
          _id: string;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          telluId?: number | null;
          migrationFinalised?: boolean | null;
          /** @format date-time */
          migrationFinalisedDate?: string | null;
          customer: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          };
          /** @default {"type":"parents","extra":[]} */
          share?: {
            type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
            extra?: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            }[];
          };
          /**
           * PII
           * @maxLength 1024
           */
          name: string;
          /**
           * PII
           * @maxLength 1024
           */
          externalId: string | null;
          contact: {
            /**
             * PII
             * @pattern ^([\w+\-.]+@([\w-]+\.)+[\w-]{2,}[, ]*?)+?$
             */
            email: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            phone: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            sms: string | null;
            /** @maxLength 1024 */
            camera: string | null;
          };
          schedule: {
            entries: {
              daysOfWeek: number[];
              /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
              timeStart: string;
              /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
              timeEnd: string;
            }[];
          } | null;
          /** @maxLength 1024 */
          migrationKey?: string;
          integrations?: {
            sequrix: {
              enabled: boolean;
              /**
               * PII
               * @maxLength 1024
               */
              objectCode: string;
            };
          };
          /** PII */
          statistics?: {
            /**
             * @maxItems 10
             * @minItems 0
             */
            acceptSpeeds: {
              /** @format date-time */
              timestamp: string;
              /**
               * @min 0
               * @exclusiveMin false
               */
              speedMs: number;
            }[];
            /**
             * @maxItems 10
             * @minItems 0
             */
            onLocationSpeeds: {
              /** @format date-time */
              timestamp: string;
              /**
               * @min 0
               * @exclusiveMin false
               */
              speedMs: number;
            }[];
            /**
             * @maxItems 10
             * @minItems 0
             */
            finishSpeeds: {
              /** @format date-time */
              timestamp: string;
              /**
               * @min 0
               * @exclusiveMin false
               */
              speedMs: number;
            }[];
            /**
             * @min 0
             * @exclusiveMin false
             */
            amountRejected: number;
            /**
             * @min 0
             * @exclusiveMin false
             */
            amountAccepted: number;
          };
          _ref: "StaticResponder";
        };
        /** PII */
        statistics: {
          /** @format date-time */
          invitedAt: string;
          /** @format date-time */
          acceptedAt: string | null;
          /** @format date-time */
          rejectedAt: string | null;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          onLocationAt: string | null;
          /** @format date-time */
          finishedAt: string | null;
        };
        meta: {
          /**
           * PII
           * @maxLength 4096
           */
          comment?: string;
          /** PII */
          photos?: {
            /** @format date-time */
            timestamp: string;
            /** @maxLength 1024 */
            url: string;
          }[];
          /**
           * PII
           * @maxLength 1024
           */
          overridePhoneNumber?: string;
        };
        supersededBy: {
          /** @format uuid */
          _id: string;
          _ref: "AlarmProfessionalResponder";
        } | null;
      }[];
    };
  };
}

export type AlarmCreateProfessionalResponderDto = object;

export interface AlarmEventCreateBase {
  text: string;
  /** @default "user" */
  type?: "user" | "system" | "action" | "hidden";
  /** @default "ACTION_CHAT" */
  action?: string;
  /** @default {} */
  meta?: Record<string, any>;
}

export interface AlarmHelperDto {
  confirmedHelping: boolean;
}

export interface AlarmHelperPutDto {
  asset?: {
    /** @format uuid */
    _id: string;
    _ref: "Asset";
  };
  /** @default null */
  confirmedHelping?: boolean | null;
}

export interface AlarmMassAcknowledgeDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  comment?: string;
  alarmIds?: string[];
}

export interface AlarmOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
    /**
     * PII
     * @maxLength 1024
     */
    name: string;
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
  asset: {
    /** @format uuid */
    _id: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    telluId?: number | null;
    migrationFinalised?: boolean | null;
    /** @format date-time */
    migrationFinalisedDate?: string | null;
    customer: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    };
    /** @default {"type":"parents","extra":[]} */
    share?: {
      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
      extra?: {
        /** @format uuid */
        _id: string;
        _ref: "Customer";
      }[];
    };
    user: {
      /** @format uuid */
      _id: string;
      _ref: "User";
    } | null;
    /**
     * PII
     * @maxLength 1024
     */
    name: string;
    /**
     * PII
     * @maxLength 1024
     */
    externalId?: string | null;
    propertiesOwnership?: "override" | "inherit";
    /** @default {} */
    properties?: {
      /**
       * PII
       * @maxLength 1024
       */
      phoneNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      smsNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      email?: string | null;
      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
      locale?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      image?: string | null;
      /** PII */
      rSim?: {
        /**
         * PII
         * @maxLength 1024
         */
        euicc: string;
        primary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        secondary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        enabled: boolean;
      } | null;
    };
    /**
     * PII
     * @default null
     */
    position?: {
      type: "Point";
      /** PII */
      coordinates: number[];
      properties: {
        accuracy?: number;
        heading?: number;
        headingAccuracy?: number;
        speed?: number;
        speedAccuracy?: number;
        altitude?: number;
        altitudeAccuracy?: number;
        /** PII */
        address?: {
          /** @maxLength 1024 */
          countryCode?: string | null;
          /** @maxLength 1024 */
          state?: string | null;
          /** @maxLength 1024 */
          city?: string | null;
          /** @maxLength 1024 */
          streetName?: string | null;
          /** @maxLength 1024 */
          streetNumber?: string | null;
          floor?: number | null;
          /** @maxLength 1024 */
          formattedAddress?: string;
        };
        /** @format date-time */
        dateTime?: string;
        /** @maxLength 1024 */
        provider?: string;
      };
    };
    available: boolean;
    /** @default true */
    allowContactOnOwnAlarms?: boolean;
    app?: {
      mode: "off" | "on" | "risk";
    } | null;
    insideZones: {
      /** @format uuid */
      _id: string;
      _ref: "Zone";
    }[];
    assetGroups: {
      /** @format uuid */
      _id: string;
      _ref: "AssetGroup";
    }[];
    /** @default [] */
    staticResponders?: {
      staticResponder: {
        /** @format uuid */
        _id: string;
        _ref: "StaticResponder";
      };
      priority: number;
    }[];
    /** @format date-time */
    lastObservationAt?: string;
    /** @default false */
    invisibleResponder?: boolean;
    /**
     * PII
     * @maxLength 4096
     */
    description?: string;
    /** @default [] */
    certifications?: {
      /** @format uuid */
      _id: string;
      certificationCategory: {
        /** @format uuid */
        _id: string;
        _ref: "CertificationCategory";
      };
      /** @format date-time */
      firstIssuedOn: string;
      /** @format date-time */
      lastReceivedOn: string;
      /** @format date-time */
      expiryDate: string;
      /**
       * @format date-time
       * @default null
       */
      plannedRenewalDate?: string | null;
      /** @maxLength 1024 */
      documentaryProof?: string | null;
    }[];
    type?: "default" | "kiosk";
  };
  ack: {
    needed: boolean;
    value: boolean;
    ackedBy: {
      /** @format uuid */
      _id: string;
      _ref: "User";
      /**
       * PII
       * @maxLength 1024
       */
      name: string;
    } | null;
    /**
     * PII
     * @maxLength 1024
     */
    comment: string | null;
    /** @format date-time */
    ackedAt: string | null;
  };
  /** PII */
  position: {
    type: "Point";
    /** PII */
    coordinates: number[];
    properties: {
      accuracy?: number;
      heading?: number;
      headingAccuracy?: number;
      speed?: number;
      speedAccuracy?: number;
      altitude?: number;
      altitudeAccuracy?: number;
      /** PII */
      address?: {
        /** @maxLength 1024 */
        countryCode?: string | null;
        /** @maxLength 1024 */
        state?: string | null;
        /** @maxLength 1024 */
        city?: string | null;
        /** @maxLength 1024 */
        streetName?: string | null;
        /** @maxLength 1024 */
        streetNumber?: string | null;
        floor?: number | null;
        /** @maxLength 1024 */
        formattedAddress?: string;
      };
      /** @format date-time */
      dateTime?: string;
      /** @maxLength 1024 */
      provider?: string;
    };
  };
  severity: "red" | "orange" | "green";
  /**
   * PII
   * @maxLength 4096
   */
  procedure: string | null;
  meta?: {
    observationTrigger?: {
      /** @format uuid */
      _id: string;
      /** @format date-time */
      createdAt: string;
      /** @format date-time */
      updatedAt: string;
      telluId?: number | null;
      migrationFinalised?: boolean | null;
      /** @format date-time */
      migrationFinalisedDate?: string | null;
      customer: {
        /** @format uuid */
        _id: string;
        _ref: "Customer";
      };
      /** @default {"type":"parents","extra":[]} */
      share?: {
        type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
        extra?: {
          /** @format uuid */
          _id: string;
          _ref: "Customer";
        }[];
      };
      /** @maxLength 1024 */
      name: string;
      eventCodes: string[];
      /** @maxLength 1024 */
      description: string;
      status: "active" | "inactive";
      actions: (
        | {
            type: "alarm";
            config: {
              severity: "red" | "orange" | "green";
              type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
              /** @maxLength 4096 */
              procedure: string | null;
              /** @maxLength 1024 */
              name: string;
            };
          }
        | {
            type: "sms";
            config: {
              /** PII */
              toRaw: string[];
              toContactList: {
                /** @format uuid */
                _id: string;
                _ref: "ContactList";
              }[];
              toTriggerUser: boolean;
              /** @maxLength 1024 */
              message: string;
            };
          }
        | {
            type: "email";
            config: {
              /** PII */
              toRaw: string[];
              toContactList: {
                /** @format uuid */
                _id: string;
                _ref: "ContactList";
              }[];
              toTriggerUser: boolean;
              /** @maxLength 1024 */
              message: string;
              /** @maxLength 1024 */
              subject: string;
              /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
              locale?: string;
            };
          }
        | {
            type: "assetUpdate";
            config: {
              available?: boolean;
              app?: {
                mode: "off" | "on" | "risk";
              };
            };
          }
      )[];
      filter:
        | {
            type: "operator/and";
            operands: (
              | {
                  type: "operator/or";
                  operands: (
                    | {
                        type: "operator/not";
                        operand:
                          | {
                              type: "constraint/asset";
                              assets: {
                                /** @format uuid */
                                _id: string;
                                _ref: "Asset";
                              }[];
                            }
                          | {
                              type: "constraint/assetGroup";
                              groups: {
                                /** @format uuid */
                                _id: string;
                                _ref: "AssetGroup";
                              }[];
                            }
                          | {
                              type: "constraint/zone";
                              zone: {
                                /** @format uuid */
                                _id: string;
                                _ref: "Zone";
                              };
                            }
                          | {
                              type: "constraint/schedule";
                              schedule: {
                                entries: {
                                  daysOfWeek: number[];
                                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                  timeStart: string;
                                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                  timeEnd: string;
                                }[];
                              };
                            };
                      }
                    | {
                        type: "constraint/asset";
                        assets: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Asset";
                        }[];
                      }
                    | {
                        type: "constraint/assetGroup";
                        groups: {
                          /** @format uuid */
                          _id: string;
                          _ref: "AssetGroup";
                        }[];
                      }
                    | {
                        type: "constraint/zone";
                        zone: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Zone";
                        };
                      }
                    | {
                        type: "constraint/schedule";
                        schedule: {
                          entries: {
                            daysOfWeek: number[];
                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                            timeStart: string;
                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                            timeEnd: string;
                          }[];
                        };
                      }
                  )[];
                }
              | {
                  type: "constraint/asset";
                  assets: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Asset";
                  }[];
                }
              | {
                  type: "constraint/assetGroup";
                  groups: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[];
                }
              | {
                  type: "constraint/zone";
                  zone: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Zone";
                  };
                }
              | {
                  type: "constraint/schedule";
                  schedule: {
                    entries: {
                      daysOfWeek: number[];
                      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                      timeStart: string;
                      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                      timeEnd: string;
                    }[];
                  };
                }
            )[];
          }
        | {
            type: "constraint/asset";
            assets: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            }[];
          }
        | {
            type: "constraint/assetGroup";
            groups: {
              /** @format uuid */
              _id: string;
              _ref: "AssetGroup";
            }[];
          }
        | {
            type: "constraint/zone";
            zone: {
              /** @format uuid */
              _id: string;
              _ref: "Zone";
            };
          }
        | {
            type: "constraint/schedule";
            schedule: {
              entries: {
                daysOfWeek: number[];
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeStart: string;
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeEnd: string;
              }[];
            };
          };
    };
    /** PII */
    observation?: {
      /** @format uuid */
      _id: string;
      /** @maxLength 1024 */
      event: string;
      asset: {
        /** @format uuid */
        _id: string;
        /** @format date-time */
        createdAt: string;
        /** @format date-time */
        updatedAt: string;
        telluId?: number | null;
        migrationFinalised?: boolean | null;
        /** @format date-time */
        migrationFinalisedDate?: string | null;
        customer: {
          /** @format uuid */
          _id: string;
          _ref: "Customer";
        };
        /** @default {"type":"parents","extra":[]} */
        share?: {
          type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
          extra?: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          }[];
        };
        user: {
          /** @format uuid */
          _id: string;
          _ref: "User";
        } | null;
        /**
         * PII
         * @maxLength 1024
         */
        name: string;
        /**
         * PII
         * @maxLength 1024
         */
        externalId?: string | null;
        propertiesOwnership?: "override" | "inherit";
        /** @default {} */
        properties?: {
          /**
           * PII
           * @maxLength 1024
           */
          phoneNumber?: string | null;
          /**
           * PII
           * @maxLength 1024
           */
          smsNumber?: string | null;
          /**
           * PII
           * @maxLength 1024
           */
          email?: string | null;
          /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
          locale?: string | null;
          /**
           * PII
           * @maxLength 1024
           */
          image?: string | null;
          /** PII */
          rSim?: {
            /**
             * PII
             * @maxLength 1024
             */
            euicc: string;
            primary: {
              /**
               * PII
               * @maxLength 1024
               */
              msisdn: string;
              /**
               * PII
               * @maxLength 1024
               */
              iccid: string;
            };
            secondary: {
              /**
               * PII
               * @maxLength 1024
               */
              msisdn: string;
              /**
               * PII
               * @maxLength 1024
               */
              iccid: string;
            };
            enabled: boolean;
          } | null;
        };
        /**
         * PII
         * @default null
         */
        position?: {
          type: "Point";
          /** PII */
          coordinates: number[];
          properties: {
            accuracy?: number;
            heading?: number;
            headingAccuracy?: number;
            speed?: number;
            speedAccuracy?: number;
            altitude?: number;
            altitudeAccuracy?: number;
            /** PII */
            address?: {
              /** @maxLength 1024 */
              countryCode?: string | null;
              /** @maxLength 1024 */
              state?: string | null;
              /** @maxLength 1024 */
              city?: string | null;
              /** @maxLength 1024 */
              streetName?: string | null;
              /** @maxLength 1024 */
              streetNumber?: string | null;
              floor?: number | null;
              /** @maxLength 1024 */
              formattedAddress?: string;
            };
            /** @format date-time */
            dateTime?: string;
            /** @maxLength 1024 */
            provider?: string;
          };
        };
        available: boolean;
        /** @default true */
        allowContactOnOwnAlarms?: boolean;
        app?: {
          mode: "off" | "on" | "risk";
        } | null;
        insideZones: {
          /** @format uuid */
          _id: string;
          _ref: "Zone";
        }[];
        assetGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        /** @default [] */
        staticResponders?: {
          staticResponder: {
            /** @format uuid */
            _id: string;
            _ref: "StaticResponder";
          };
          priority: number;
        }[];
        /** @format date-time */
        lastObservationAt?: string;
        /** @default false */
        invisibleResponder?: boolean;
        /**
         * PII
         * @maxLength 4096
         */
        description?: string;
        /** @default [] */
        certifications?: {
          /** @format uuid */
          _id: string;
          certificationCategory: {
            /** @format uuid */
            _id: string;
            _ref: "CertificationCategory";
          };
          /** @format date-time */
          firstIssuedOn: string;
          /** @format date-time */
          lastReceivedOn: string;
          /** @format date-time */
          expiryDate: string;
          /**
           * @format date-time
           * @default null
           */
          plannedRenewalDate?: string | null;
          /** @maxLength 1024 */
          documentaryProof?: string | null;
        }[];
        type?: "default" | "kiosk";
        _ref: "Asset";
      };
      customer: {
        /** @format uuid */
        _id: string;
        _ref: "Customer";
      };
      device: {
        /** @format uuid */
        _id: string;
        _ref: "Device";
      };
      user: {
        /** @format uuid */
        _id: string;
        _ref: "User";
      };
      /** PII */
      position?: {
        type: "Point";
        /** PII */
        coordinates: number[];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      };
      beacons?:
        | {
            /** @maxLength 1024 */
            code: string;
            rssi: number;
            battery?: number;
            /** @format date-time */
            dateTime: string;
            beacon: {
              /** @format uuid */
              _id: string;
              _ref: "Beacon";
            } | null;
            calc: number | null;
            valid: boolean;
          }[]
        | {
            /** @maxLength 1024 */
            code: string;
            rssi: number;
            battery?: number;
            /** @format date-time */
            dateTime: string;
          }[];
      /** PII */
      meta?: {
        asset?: {
          /** @format uuid */
          _id: string;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          telluId?: number | null;
          migrationFinalised?: boolean | null;
          /** @format date-time */
          migrationFinalisedDate?: string | null;
          customer: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          };
          /** @default {"type":"parents","extra":[]} */
          share?: {
            type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
            extra?: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            }[];
          };
          user: {
            /** @format uuid */
            _id: string;
            _ref: "User";
          } | null;
          /**
           * PII
           * @maxLength 1024
           */
          name: string;
          /**
           * PII
           * @maxLength 1024
           */
          externalId?: string | null;
          propertiesOwnership?: "override" | "inherit";
          /** @default {} */
          properties?: {
            /**
             * PII
             * @maxLength 1024
             */
            phoneNumber?: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            smsNumber?: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            email?: string | null;
            /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
            locale?: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            image?: string | null;
            /** PII */
            rSim?: {
              /**
               * PII
               * @maxLength 1024
               */
              euicc: string;
              primary: {
                /**
                 * PII
                 * @maxLength 1024
                 */
                msisdn: string;
                /**
                 * PII
                 * @maxLength 1024
                 */
                iccid: string;
              };
              secondary: {
                /**
                 * PII
                 * @maxLength 1024
                 */
                msisdn: string;
                /**
                 * PII
                 * @maxLength 1024
                 */
                iccid: string;
              };
              enabled: boolean;
            } | null;
          };
          /**
           * PII
           * @default null
           */
          position?: {
            type: "Point";
            /** PII */
            coordinates: number[];
            properties: {
              accuracy?: number;
              heading?: number;
              headingAccuracy?: number;
              speed?: number;
              speedAccuracy?: number;
              altitude?: number;
              altitudeAccuracy?: number;
              /** PII */
              address?: {
                /** @maxLength 1024 */
                countryCode?: string | null;
                /** @maxLength 1024 */
                state?: string | null;
                /** @maxLength 1024 */
                city?: string | null;
                /** @maxLength 1024 */
                streetName?: string | null;
                /** @maxLength 1024 */
                streetNumber?: string | null;
                floor?: number | null;
                /** @maxLength 1024 */
                formattedAddress?: string;
              };
              /** @format date-time */
              dateTime?: string;
              /** @maxLength 1024 */
              provider?: string;
            };
          };
          available: boolean;
          /** @default true */
          allowContactOnOwnAlarms?: boolean;
          app?: {
            mode: "off" | "on" | "risk";
          } | null;
          insideZones: {
            /** @format uuid */
            _id: string;
            _ref: "Zone";
          }[];
          assetGroups: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
          /** @default [] */
          staticResponders?: {
            staticResponder: {
              /** @format uuid */
              _id: string;
              _ref: "StaticResponder";
            };
            priority: number;
          }[];
          /** @format date-time */
          lastObservationAt?: string;
          /** @default false */
          invisibleResponder?: boolean;
          /**
           * PII
           * @maxLength 4096
           */
          description?: string;
          /** @default [] */
          certifications?: {
            /** @format uuid */
            _id: string;
            certificationCategory: {
              /** @format uuid */
              _id: string;
              _ref: "CertificationCategory";
            };
            /** @format date-time */
            firstIssuedOn: string;
            /** @format date-time */
            lastReceivedOn: string;
            /** @format date-time */
            expiryDate: string;
            /**
             * @format date-time
             * @default null
             */
            plannedRenewalDate?: string | null;
            /** @maxLength 1024 */
            documentaryProof?: string | null;
          }[];
          type?: "default" | "kiosk";
        };
        battery?: number;
        rssi?: number;
        snr?: number;
        /** @format date-time */
        dateTime?: string;
        /** @format date-time */
        deviceDateTime?: string;
        /** @format date-time */
        gatewayDateTime?: string;
        insideGpsZones?: {
          /** @format uuid */
          _id: string;
          _ref: "Zone";
        }[];
        insideIpsZones?: {
          /** @format uuid */
          _id: string;
          _ref: "Zone";
        }[];
        zone?: {
          /** @format uuid */
          _id: string;
          _ref: "Zone";
        };
        callRequest?: boolean;
        forceLoraCustomer?: {
          /** @format uuid */
          _id: string;
          _ref: "Customer";
        };
        knnResult?: {
          distance: number;
          debugInfo?: any;
        };
        available?: boolean;
      };
      deltas?: {
        main: {
          /** @format date-time */
          start: string;
          /** @format date-time */
          end: string;
          value?: number;
        };
        steps?: {
          gps?: {
            /** @format date-time */
            start: string;
            /** @format date-time */
            end: string;
            value?: number;
          };
          ips?: {
            /** @format date-time */
            start: string;
            /** @format date-time */
            end: string;
            value?: number;
          };
          context?: {
            /** @format date-time */
            start: string;
            /** @format date-time */
            end: string;
            value?: number;
          };
        };
      };
      validPosition?: {
        value: boolean;
        /** @maxLength 1024 */
        reason?: string;
      };
      isSystemEvent?: boolean;
    };
    /** PII */
    frozenInfo?: {
      staticResponse: {
        type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
        priority: number;
        zone?: {
          /** @format uuid */
          _id: string;
          customer?: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          };
          type?:
            | "default"
            | "responseArea"
            | "policeDepartment"
            | "assetMonitoredArea"
            | "fingerprinted"
            | "building"
            | "evacuationPoint";
          /** PII */
          location:
            | {
                type: "Point";
                /** PII */
                coordinates: number[];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              }
            | {
                type: "Polygon";
                /** PII */
                coordinates: number[][][];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              }
            | {
                type: "MultiPolygon";
                coordinates: number[][][][];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              };
          /** @maxLength 1024 */
          name: string;
          staticResponders: {
            staticResponder: {
              /** @format uuid */
              _id: string;
              _ref: "StaticResponder";
            };
            priority: number;
          }[];
        };
        responders: {
          info: {
            /** @format uuid */
            _id: string;
            _ref: "Asset" | "StaticResponder";
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /**
             * PII
             * @maxLength 1024
             */
            image: string | null;
            /** PII */
            position: {
              type: "Point";
              /** PII */
              coordinates: number[];
              properties: {
                accuracy?: number;
                heading?: number;
                headingAccuracy?: number;
                speed?: number;
                speedAccuracy?: number;
                altitude?: number;
                altitudeAccuracy?: number;
                /** PII */
                address?: {
                  /** @maxLength 1024 */
                  countryCode?: string | null;
                  /** @maxLength 1024 */
                  state?: string | null;
                  /** @maxLength 1024 */
                  city?: string | null;
                  /** @maxLength 1024 */
                  streetName?: string | null;
                  /** @maxLength 1024 */
                  streetNumber?: string | null;
                  floor?: number | null;
                  /** @maxLength 1024 */
                  formattedAddress?: string;
                };
                /** @format date-time */
                dateTime?: string;
                /** @maxLength 1024 */
                provider?: string;
              };
            };
            /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
            locale: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            contactCode: string | null;
          };
          distanceKm: number | null;
          actions: {
            /**
             * PII
             * @maxLength 1024
             */
            call: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            sms: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            email: string | null;
            notification: boolean;
          };
          priority: number;
          professionalResponder?: {
            available: boolean;
            inProgress: boolean;
          };
        }[];
      }[];
      dynamicResponse: {
        type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
        priority: number;
        zone?: {
          /** @format uuid */
          _id: string;
          customer?: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          };
          type?:
            | "default"
            | "responseArea"
            | "policeDepartment"
            | "assetMonitoredArea"
            | "fingerprinted"
            | "building"
            | "evacuationPoint";
          /** PII */
          location:
            | {
                type: "Point";
                /** PII */
                coordinates: number[];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              }
            | {
                type: "Polygon";
                /** PII */
                coordinates: number[][][];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              }
            | {
                type: "MultiPolygon";
                coordinates: number[][][][];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              };
          /** @maxLength 1024 */
          name: string;
          staticResponders: {
            staticResponder: {
              /** @format uuid */
              _id: string;
              _ref: "StaticResponder";
            };
            priority: number;
          }[];
        };
        responders: {
          info: {
            /** @format uuid */
            _id: string;
            _ref: "Asset" | "StaticResponder";
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /**
             * PII
             * @maxLength 1024
             */
            image: string | null;
            /** PII */
            position: {
              type: "Point";
              /** PII */
              coordinates: number[];
              properties: {
                accuracy?: number;
                heading?: number;
                headingAccuracy?: number;
                speed?: number;
                speedAccuracy?: number;
                altitude?: number;
                altitudeAccuracy?: number;
                /** PII */
                address?: {
                  /** @maxLength 1024 */
                  countryCode?: string | null;
                  /** @maxLength 1024 */
                  state?: string | null;
                  /** @maxLength 1024 */
                  city?: string | null;
                  /** @maxLength 1024 */
                  streetName?: string | null;
                  /** @maxLength 1024 */
                  streetNumber?: string | null;
                  floor?: number | null;
                  /** @maxLength 1024 */
                  formattedAddress?: string;
                };
                /** @format date-time */
                dateTime?: string;
                /** @maxLength 1024 */
                provider?: string;
              };
            };
            /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
            locale: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            contactCode: string | null;
          };
          distanceKm: number | null;
          actions: {
            /**
             * PII
             * @maxLength 1024
             */
            call: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            sms: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            email: string | null;
            notification: boolean;
          };
          priority: number;
          professionalResponder?: {
            available: boolean;
            inProgress: boolean;
          };
        }[];
      }[];
      professionalResponders?: {
        /** @format uuid */
        _id: string;
        /** @format date-time */
        createdAt: string;
        /** @format date-time */
        updatedAt: string;
        telluId?: number | null;
        migrationFinalised?: boolean | null;
        /** @format date-time */
        migrationFinalisedDate?: string | null;
        customer: {
          /** @format uuid */
          _id: string;
          _ref: "Customer";
        };
        /** @default {"type":"parents","extra":[]} */
        share?: {
          type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
          extra?: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          }[];
        };
        type: "sequrix";
        active: boolean;
        status: "invited" | "accepted" | "rejected" | "started" | "onLocation" | "finished" | "error" | "canceled";
        alarm: {
          /** @format uuid */
          _id: string;
          _ref: "Alarm";
        };
        asset: {
          /** @format uuid */
          _id: string;
          _ref: "Asset";
        };
        staticResponder: {
          /** @format uuid */
          _id: string;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          telluId?: number | null;
          migrationFinalised?: boolean | null;
          /** @format date-time */
          migrationFinalisedDate?: string | null;
          customer: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          };
          /** @default {"type":"parents","extra":[]} */
          share?: {
            type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
            extra?: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            }[];
          };
          /**
           * PII
           * @maxLength 1024
           */
          name: string;
          /**
           * PII
           * @maxLength 1024
           */
          externalId: string | null;
          contact: {
            /**
             * PII
             * @pattern ^([\w+\-.]+@([\w-]+\.)+[\w-]{2,}[, ]*?)+?$
             */
            email: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            phone: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            sms: string | null;
            /** @maxLength 1024 */
            camera: string | null;
          };
          schedule: {
            entries: {
              daysOfWeek: number[];
              /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
              timeStart: string;
              /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
              timeEnd: string;
            }[];
          } | null;
          /** @maxLength 1024 */
          migrationKey?: string;
          integrations?: {
            sequrix: {
              enabled: boolean;
              /**
               * PII
               * @maxLength 1024
               */
              objectCode: string;
            };
          };
          /** PII */
          statistics?: {
            /**
             * @maxItems 10
             * @minItems 0
             */
            acceptSpeeds: {
              /** @format date-time */
              timestamp: string;
              /**
               * @min 0
               * @exclusiveMin false
               */
              speedMs: number;
            }[];
            /**
             * @maxItems 10
             * @minItems 0
             */
            onLocationSpeeds: {
              /** @format date-time */
              timestamp: string;
              /**
               * @min 0
               * @exclusiveMin false
               */
              speedMs: number;
            }[];
            /**
             * @maxItems 10
             * @minItems 0
             */
            finishSpeeds: {
              /** @format date-time */
              timestamp: string;
              /**
               * @min 0
               * @exclusiveMin false
               */
              speedMs: number;
            }[];
            /**
             * @min 0
             * @exclusiveMin false
             */
            amountRejected: number;
            /**
             * @min 0
             * @exclusiveMin false
             */
            amountAccepted: number;
          };
          _ref: "StaticResponder";
        };
        /** PII */
        statistics: {
          /** @format date-time */
          invitedAt: string;
          /** @format date-time */
          acceptedAt: string | null;
          /** @format date-time */
          rejectedAt: string | null;
          /** @format date-time */
          startedAt: string | null;
          /** @format date-time */
          onLocationAt: string | null;
          /** @format date-time */
          finishedAt: string | null;
        };
        meta: {
          /**
           * PII
           * @maxLength 4096
           */
          comment?: string;
          /** PII */
          photos?: {
            /** @format date-time */
            timestamp: string;
            /** @maxLength 1024 */
            url: string;
          }[];
          /**
           * PII
           * @maxLength 1024
           */
          overridePhoneNumber?: string;
        };
        supersededBy: {
          /** @format uuid */
          _id: string;
          _ref: "AlarmProfessionalResponder";
        } | null;
      }[];
    };
  };
  alarmCenter: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
    /**
     * PII
     * @maxLength 1024
     */
    name: string;
  } | null;
  /** @format date-time */
  lastMergedAt?: string;
  /** @format date-time */
  lastPublishedToStreamAt?: string;
  /** PII */
  mergeHistory?: {
    /** @format uuid */
    _id: string;
    /** @maxLength 1024 */
    name: string;
    /** @format date-time */
    createdAt: string;
    /** PII */
    position: {
      type: "Point";
      /** PII */
      coordinates: number[];
      properties: {
        accuracy?: number;
        heading?: number;
        headingAccuracy?: number;
        speed?: number;
        speedAccuracy?: number;
        altitude?: number;
        altitudeAccuracy?: number;
        /** PII */
        address?: {
          /** @maxLength 1024 */
          countryCode?: string | null;
          /** @maxLength 1024 */
          state?: string | null;
          /** @maxLength 1024 */
          city?: string | null;
          /** @maxLength 1024 */
          streetName?: string | null;
          /** @maxLength 1024 */
          streetNumber?: string | null;
          floor?: number | null;
          /** @maxLength 1024 */
          formattedAddress?: string;
        };
        /** @format date-time */
        dateTime?: string;
        /** @maxLength 1024 */
        provider?: string;
      };
    };
    meta?: {
      observationTrigger?: {
        /** @format uuid */
        _id: string;
        /** @format date-time */
        createdAt: string;
        /** @format date-time */
        updatedAt: string;
        telluId?: number | null;
        migrationFinalised?: boolean | null;
        /** @format date-time */
        migrationFinalisedDate?: string | null;
        customer: {
          /** @format uuid */
          _id: string;
          _ref: "Customer";
        };
        /** @default {"type":"parents","extra":[]} */
        share?: {
          type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
          extra?: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          }[];
        };
        /** @maxLength 1024 */
        name: string;
        eventCodes: string[];
        /** @maxLength 1024 */
        description: string;
        status: "active" | "inactive";
        actions: (
          | {
              type: "alarm";
              config: {
                severity: "red" | "orange" | "green";
                type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
                /** @maxLength 4096 */
                procedure: string | null;
                /** @maxLength 1024 */
                name: string;
              };
            }
          | {
              type: "sms";
              config: {
                /** PII */
                toRaw: string[];
                toContactList: {
                  /** @format uuid */
                  _id: string;
                  _ref: "ContactList";
                }[];
                toTriggerUser: boolean;
                /** @maxLength 1024 */
                message: string;
              };
            }
          | {
              type: "email";
              config: {
                /** PII */
                toRaw: string[];
                toContactList: {
                  /** @format uuid */
                  _id: string;
                  _ref: "ContactList";
                }[];
                toTriggerUser: boolean;
                /** @maxLength 1024 */
                message: string;
                /** @maxLength 1024 */
                subject: string;
                /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                locale?: string;
              };
            }
          | {
              type: "assetUpdate";
              config: {
                available?: boolean;
                app?: {
                  mode: "off" | "on" | "risk";
                };
              };
            }
        )[];
        filter:
          | {
              type: "constraint/asset";
              assets: {
                /** @format uuid */
                _id: string;
                _ref: "Asset";
              }[];
            }
          | {
              type: "constraint/assetGroup";
              groups: {
                /** @format uuid */
                _id: string;
                _ref: "AssetGroup";
              }[];
            }
          | {
              type: "constraint/zone";
              zone: {
                /** @format uuid */
                _id: string;
                _ref: "Zone";
              };
            }
          | {
              type: "constraint/schedule";
              schedule: {
                entries: {
                  daysOfWeek: number[];
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeStart: string;
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeEnd: string;
                }[];
              };
            };
      };
      /** PII */
      observation?: {
        /** @format uuid */
        _id: string;
        /** @maxLength 1024 */
        event: string;
        asset: {
          /** @format uuid */
          _id: string;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          telluId?: number | null;
          migrationFinalised?: boolean | null;
          /** @format date-time */
          migrationFinalisedDate?: string | null;
          customer: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          };
          /** @default {"type":"parents","extra":[]} */
          share?: {
            type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
            extra?: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            }[];
          };
          user: {
            /** @format uuid */
            _id: string;
            _ref: "User";
          } | null;
          /**
           * PII
           * @maxLength 1024
           */
          name: string;
          /**
           * PII
           * @maxLength 1024
           */
          externalId?: string | null;
          propertiesOwnership?: "override" | "inherit";
          /** @default {} */
          properties?: {
            /**
             * PII
             * @maxLength 1024
             */
            phoneNumber?: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            smsNumber?: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            email?: string | null;
            /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
            locale?: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            image?: string | null;
            /** PII */
            rSim?: {
              /**
               * PII
               * @maxLength 1024
               */
              euicc: string;
              primary: {
                /**
                 * PII
                 * @maxLength 1024
                 */
                msisdn: string;
                /**
                 * PII
                 * @maxLength 1024
                 */
                iccid: string;
              };
              secondary: {
                /**
                 * PII
                 * @maxLength 1024
                 */
                msisdn: string;
                /**
                 * PII
                 * @maxLength 1024
                 */
                iccid: string;
              };
              enabled: boolean;
            } | null;
          };
          /**
           * PII
           * @default null
           */
          position?: {
            type: "Point";
            /** PII */
            coordinates: number[];
            properties: {
              accuracy?: number;
              heading?: number;
              headingAccuracy?: number;
              speed?: number;
              speedAccuracy?: number;
              altitude?: number;
              altitudeAccuracy?: number;
              /** PII */
              address?: {
                /** @maxLength 1024 */
                countryCode?: string | null;
                /** @maxLength 1024 */
                state?: string | null;
                /** @maxLength 1024 */
                city?: string | null;
                /** @maxLength 1024 */
                streetName?: string | null;
                /** @maxLength 1024 */
                streetNumber?: string | null;
                floor?: number | null;
                /** @maxLength 1024 */
                formattedAddress?: string;
              };
              /** @format date-time */
              dateTime?: string;
              /** @maxLength 1024 */
              provider?: string;
            };
          };
          available: boolean;
          /** @default true */
          allowContactOnOwnAlarms?: boolean;
          app?: {
            mode: "off" | "on" | "risk";
          } | null;
          insideZones: {
            /** @format uuid */
            _id: string;
            _ref: "Zone";
          }[];
          assetGroups: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
          /** @default [] */
          staticResponders?: {
            staticResponder: {
              /** @format uuid */
              _id: string;
              _ref: "StaticResponder";
            };
            priority: number;
          }[];
          /** @format date-time */
          lastObservationAt?: string;
          /** @default false */
          invisibleResponder?: boolean;
          /**
           * PII
           * @maxLength 4096
           */
          description?: string;
          /** @default [] */
          certifications?: {
            /** @format uuid */
            _id: string;
            certificationCategory: {
              /** @format uuid */
              _id: string;
              _ref: "CertificationCategory";
            };
            /** @format date-time */
            firstIssuedOn: string;
            /** @format date-time */
            lastReceivedOn: string;
            /** @format date-time */
            expiryDate: string;
            /**
             * @format date-time
             * @default null
             */
            plannedRenewalDate?: string | null;
            /** @maxLength 1024 */
            documentaryProof?: string | null;
          }[];
          type?: "default" | "kiosk";
          _ref: "Asset";
        };
        customer: {
          /** @format uuid */
          _id: string;
          _ref: "Customer";
        };
        device: {
          /** @format uuid */
          _id: string;
          _ref: "Device";
        };
        user: {
          /** @format uuid */
          _id: string;
          _ref: "User";
        };
        /** PII */
        position?: {
          type: "Point";
          /** PII */
          coordinates: number[];
          properties: {
            accuracy?: number;
            heading?: number;
            headingAccuracy?: number;
            speed?: number;
            speedAccuracy?: number;
            altitude?: number;
            altitudeAccuracy?: number;
            /** PII */
            address?: {
              /** @maxLength 1024 */
              countryCode?: string | null;
              /** @maxLength 1024 */
              state?: string | null;
              /** @maxLength 1024 */
              city?: string | null;
              /** @maxLength 1024 */
              streetName?: string | null;
              /** @maxLength 1024 */
              streetNumber?: string | null;
              floor?: number | null;
              /** @maxLength 1024 */
              formattedAddress?: string;
            };
            /** @format date-time */
            dateTime?: string;
            /** @maxLength 1024 */
            provider?: string;
          };
        };
        beacons?:
          | {
              /** @maxLength 1024 */
              code: string;
              rssi: number;
              battery?: number;
              /** @format date-time */
              dateTime: string;
              beacon: {
                /** @format uuid */
                _id: string;
                _ref: "Beacon";
              } | null;
              calc: number | null;
              valid: boolean;
            }[]
          | {
              /** @maxLength 1024 */
              code: string;
              rssi: number;
              battery?: number;
              /** @format date-time */
              dateTime: string;
            }[];
        /** PII */
        meta?: {
          asset?: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            telluId?: number | null;
            migrationFinalised?: boolean | null;
            /** @format date-time */
            migrationFinalisedDate?: string | null;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            user: {
              /** @format uuid */
              _id: string;
              _ref: "User";
            } | null;
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /**
             * PII
             * @maxLength 1024
             */
            externalId?: string | null;
            propertiesOwnership?: "override" | "inherit";
            /** @default {} */
            properties?: {
              /**
               * PII
               * @maxLength 1024
               */
              phoneNumber?: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              smsNumber?: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              email?: string | null;
              /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
              locale?: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              image?: string | null;
              /** PII */
              rSim?: {
                /**
                 * PII
                 * @maxLength 1024
                 */
                euicc: string;
                primary: {
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  msisdn: string;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  iccid: string;
                };
                secondary: {
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  msisdn: string;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  iccid: string;
                };
                enabled: boolean;
              } | null;
            };
            /**
             * PII
             * @default null
             */
            position?: {
              type: "Point";
              /** PII */
              coordinates: number[];
              properties: {
                accuracy?: number;
                heading?: number;
                headingAccuracy?: number;
                speed?: number;
                speedAccuracy?: number;
                altitude?: number;
                altitudeAccuracy?: number;
                /** PII */
                address?: {
                  /** @maxLength 1024 */
                  countryCode?: string | null;
                  /** @maxLength 1024 */
                  state?: string | null;
                  /** @maxLength 1024 */
                  city?: string | null;
                  /** @maxLength 1024 */
                  streetName?: string | null;
                  /** @maxLength 1024 */
                  streetNumber?: string | null;
                  floor?: number | null;
                  /** @maxLength 1024 */
                  formattedAddress?: string;
                };
                /** @format date-time */
                dateTime?: string;
                /** @maxLength 1024 */
                provider?: string;
              };
            };
            available: boolean;
            /** @default true */
            allowContactOnOwnAlarms?: boolean;
            app?: {
              mode: "off" | "on" | "risk";
            } | null;
            insideZones: {
              /** @format uuid */
              _id: string;
              _ref: "Zone";
            }[];
            assetGroups: {
              /** @format uuid */
              _id: string;
              _ref: "AssetGroup";
            }[];
            /** @default [] */
            staticResponders?: {
              staticResponder: {
                /** @format uuid */
                _id: string;
                _ref: "StaticResponder";
              };
              priority: number;
            }[];
            /** @format date-time */
            lastObservationAt?: string;
            /** @default false */
            invisibleResponder?: boolean;
            /**
             * PII
             * @maxLength 4096
             */
            description?: string;
            /** @default [] */
            certifications?: {
              /** @format uuid */
              _id: string;
              certificationCategory: {
                /** @format uuid */
                _id: string;
                _ref: "CertificationCategory";
              };
              /** @format date-time */
              firstIssuedOn: string;
              /** @format date-time */
              lastReceivedOn: string;
              /** @format date-time */
              expiryDate: string;
              /**
               * @format date-time
               * @default null
               */
              plannedRenewalDate?: string | null;
              /** @maxLength 1024 */
              documentaryProof?: string | null;
            }[];
            type?: "default" | "kiosk";
          };
          battery?: number;
          rssi?: number;
          snr?: number;
          /** @format date-time */
          dateTime?: string;
          /** @format date-time */
          deviceDateTime?: string;
          /** @format date-time */
          gatewayDateTime?: string;
          insideGpsZones?: {
            /** @format uuid */
            _id: string;
            _ref: "Zone";
          }[];
          insideIpsZones?: {
            /** @format uuid */
            _id: string;
            _ref: "Zone";
          }[];
          zone?: {
            /** @format uuid */
            _id: string;
            _ref: "Zone";
          };
          callRequest?: boolean;
          forceLoraCustomer?: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          };
          knnResult?: {
            distance: number;
            debugInfo?: any;
          };
          available?: boolean;
        };
        deltas?: {
          main: {
            /** @format date-time */
            start: string;
            /** @format date-time */
            end: string;
            value?: number;
          };
          steps?: {
            gps?: {
              /** @format date-time */
              start: string;
              /** @format date-time */
              end: string;
              value?: number;
            };
            ips?: {
              /** @format date-time */
              start: string;
              /** @format date-time */
              end: string;
              value?: number;
            };
            context?: {
              /** @format date-time */
              start: string;
              /** @format date-time */
              end: string;
              value?: number;
            };
          };
        };
        validPosition?: {
          value: boolean;
          /** @maxLength 1024 */
          reason?: string;
        };
        isSystemEvent?: boolean;
      };
      /** PII */
      frozenInfo?: {
        staticResponse: {
          type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
          priority: number;
          zone?: {
            /** @format uuid */
            _id: string;
            customer?: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            type?:
              | "default"
              | "responseArea"
              | "policeDepartment"
              | "assetMonitoredArea"
              | "fingerprinted"
              | "building"
              | "evacuationPoint";
            /** PII */
            location:
              | {
                  type: "Point";
                  /** PII */
                  coordinates: number[];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                }
              | {
                  type: "Polygon";
                  /** PII */
                  coordinates: number[][][];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                }
              | {
                  type: "MultiPolygon";
                  coordinates: number[][][][];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                };
            /** @maxLength 1024 */
            name: string;
            staticResponders: {
              staticResponder: {
                /** @format uuid */
                _id: string;
                _ref: "StaticResponder";
              };
              priority: number;
            }[];
          };
          responders: {
            info: {
              /** @format uuid */
              _id: string;
              _ref: "Asset" | "StaticResponder";
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
              /**
               * PII
               * @maxLength 1024
               */
              image: string | null;
              /** PII */
              position: {
                type: "Point";
                /** PII */
                coordinates: number[];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              };
              /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
              locale: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              contactCode: string | null;
            };
            distanceKm: number | null;
            actions: {
              /**
               * PII
               * @maxLength 1024
               */
              call: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              sms: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              email: string | null;
              notification: boolean;
            };
            priority: number;
            professionalResponder?: {
              available: boolean;
              inProgress: boolean;
            };
          }[];
        }[];
        dynamicResponse: {
          type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
          priority: number;
          zone?: {
            /** @format uuid */
            _id: string;
            customer?: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            type?:
              | "default"
              | "responseArea"
              | "policeDepartment"
              | "assetMonitoredArea"
              | "fingerprinted"
              | "building"
              | "evacuationPoint";
            /** PII */
            location:
              | {
                  type: "Point";
                  /** PII */
                  coordinates: number[];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                }
              | {
                  type: "Polygon";
                  /** PII */
                  coordinates: number[][][];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                }
              | {
                  type: "MultiPolygon";
                  coordinates: number[][][][];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                };
            /** @maxLength 1024 */
            name: string;
            staticResponders: {
              staticResponder: {
                /** @format uuid */
                _id: string;
                _ref: "StaticResponder";
              };
              priority: number;
            }[];
          };
          responders: {
            info: {
              /** @format uuid */
              _id: string;
              _ref: "Asset" | "StaticResponder";
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
              /**
               * PII
               * @maxLength 1024
               */
              image: string | null;
              /** PII */
              position: {
                type: "Point";
                /** PII */
                coordinates: number[];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              };
              /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
              locale: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              contactCode: string | null;
            };
            distanceKm: number | null;
            actions: {
              /**
               * PII
               * @maxLength 1024
               */
              call: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              sms: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              email: string | null;
              notification: boolean;
            };
            priority: number;
            professionalResponder?: {
              available: boolean;
              inProgress: boolean;
            };
          }[];
        }[];
        professionalResponders?: {
          /** @format uuid */
          _id: string;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          telluId?: number | null;
          migrationFinalised?: boolean | null;
          /** @format date-time */
          migrationFinalisedDate?: string | null;
          customer: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          };
          /** @default {"type":"parents","extra":[]} */
          share?: {
            type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
            extra?: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            }[];
          };
          type: "sequrix";
          active: boolean;
          status: "invited" | "accepted" | "rejected" | "started" | "onLocation" | "finished" | "error" | "canceled";
          alarm: {
            /** @format uuid */
            _id: string;
            _ref: "Alarm";
          };
          asset: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          };
          staticResponder: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            telluId?: number | null;
            migrationFinalised?: boolean | null;
            /** @format date-time */
            migrationFinalisedDate?: string | null;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /**
             * PII
             * @maxLength 1024
             */
            externalId: string | null;
            contact: {
              /**
               * PII
               * @pattern ^([\w+\-.]+@([\w-]+\.)+[\w-]{2,}[, ]*?)+?$
               */
              email: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              phone: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              sms: string | null;
              /** @maxLength 1024 */
              camera: string | null;
            };
            schedule: {
              entries: {
                daysOfWeek: number[];
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeStart: string;
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeEnd: string;
              }[];
            } | null;
            /** @maxLength 1024 */
            migrationKey?: string;
            integrations?: {
              sequrix: {
                enabled: boolean;
                /**
                 * PII
                 * @maxLength 1024
                 */
                objectCode: string;
              };
            };
            /** PII */
            statistics?: {
              /**
               * @maxItems 10
               * @minItems 0
               */
              acceptSpeeds: {
                /** @format date-time */
                timestamp: string;
                /**
                 * @min 0
                 * @exclusiveMin false
                 */
                speedMs: number;
              }[];
              /**
               * @maxItems 10
               * @minItems 0
               */
              onLocationSpeeds: {
                /** @format date-time */
                timestamp: string;
                /**
                 * @min 0
                 * @exclusiveMin false
                 */
                speedMs: number;
              }[];
              /**
               * @maxItems 10
               * @minItems 0
               */
              finishSpeeds: {
                /** @format date-time */
                timestamp: string;
                /**
                 * @min 0
                 * @exclusiveMin false
                 */
                speedMs: number;
              }[];
              /**
               * @min 0
               * @exclusiveMin false
               */
              amountRejected: number;
              /**
               * @min 0
               * @exclusiveMin false
               */
              amountAccepted: number;
            };
            _ref: "StaticResponder";
          };
          /** PII */
          statistics: {
            /** @format date-time */
            invitedAt: string;
            /** @format date-time */
            acceptedAt: string | null;
            /** @format date-time */
            rejectedAt: string | null;
            /** @format date-time */
            startedAt: string | null;
            /** @format date-time */
            onLocationAt: string | null;
            /** @format date-time */
            finishedAt: string | null;
          };
          meta: {
            /**
             * PII
             * @maxLength 4096
             */
            comment?: string;
            /** PII */
            photos?: {
              /** @format date-time */
              timestamp: string;
              /** @maxLength 1024 */
              url: string;
            }[];
            /**
             * PII
             * @maxLength 1024
             */
            overridePhoneNumber?: string;
          };
          supersededBy: {
            /** @format uuid */
            _id: string;
            _ref: "AlarmProfessionalResponder";
          } | null;
        }[];
      };
    };
  }[];
}

export interface AlarmPatchProfessionalResponderDto {
  status: "canceled";
}

export interface AlarmProcessCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  } | null;
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  /**
   * PII
   * @maxLength 4096
   */
  description: string;
  tasks: (
    | {
        /** @format uuid */
        _id: string;
        taskName: "call";
        dataScript: {
          scriptName: "getAssets";
          options: {
            filter: any;
            max: number;
          };
        };
        /** @maxLength 1024 */
        forceLocale?: string | null;
      }
    | {
        /** @format uuid */
        _id: string;
        taskName: "sms";
        dataScript: {
          scriptName: "getAssets";
          options: {
            filter: any;
            max: number;
          };
        };
        /** @maxLength 1024 */
        forceLocale?: string | null;
      }
    | {
        /** @format uuid */
        _id: string;
        taskName: "delay";
        delaySeconds: number;
      }
    | {
        /** @format uuid */
        _id: string;
        taskName: "split";
        tasks: (
          | {
              /** @format uuid */
              _id: string;
              taskName: "call";
              dataScript: {
                scriptName: "getAssets";
                options: {
                  filter: any;
                  max: number;
                };
              };
              /** @maxLength 1024 */
              forceLocale?: string | null;
            }
          | {
              /** @format uuid */
              _id: string;
              taskName: "sms";
              dataScript: {
                scriptName: "getAssets";
                options: {
                  filter: any;
                  max: number;
                };
              };
              /** @maxLength 1024 */
              forceLocale?: string | null;
            }
          | {
              /** @format uuid */
              _id: string;
              taskName: "delay";
              delaySeconds: number;
            }
          | {
              /** @format uuid */
              _id: string;
              taskName: "schedule";
              branches: {
                schedule: {
                  entries: {
                    daysOfWeek: number[];
                    /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                    timeStart: string;
                    /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                    timeEnd: string;
                  }[];
                };
                tasks: (
                  | {
                      /** @format uuid */
                      _id: string;
                      taskName: "call";
                      dataScript: {
                        scriptName: "getAssets";
                        options: {
                          filter: any;
                          max: number;
                        };
                      };
                      /** @maxLength 1024 */
                      forceLocale?: string | null;
                    }
                  | {
                      /** @format uuid */
                      _id: string;
                      taskName: "sms";
                      dataScript: {
                        scriptName: "getAssets";
                        options: {
                          filter: any;
                          max: number;
                        };
                      };
                      /** @maxLength 1024 */
                      forceLocale?: string | null;
                    }
                  | {
                      /** @format uuid */
                      _id: string;
                      taskName: "delay";
                      delaySeconds: number;
                    }
                  | {
                      /** @format uuid */
                      _id: string;
                      taskName: "goto";
                      /** @format uuid */
                      targetTaskId: string;
                      maxExecutions?: number;
                    }
                )[][];
              }[];
              defaultTasks?: (
                | {
                    /** @format uuid */
                    _id: string;
                    taskName: "call";
                    dataScript: {
                      scriptName: "getAssets";
                      options: {
                        filter: any;
                        max: number;
                      };
                    };
                    /** @maxLength 1024 */
                    forceLocale?: string | null;
                  }
                | {
                    /** @format uuid */
                    _id: string;
                    taskName: "sms";
                    dataScript: {
                      scriptName: "getAssets";
                      options: {
                        filter: any;
                        max: number;
                      };
                    };
                    /** @maxLength 1024 */
                    forceLocale?: string | null;
                  }
                | {
                    /** @format uuid */
                    _id: string;
                    taskName: "delay";
                    delaySeconds: number;
                  }
                | {
                    /** @format uuid */
                    _id: string;
                    taskName: "goto";
                    /** @format uuid */
                    targetTaskId: string;
                    maxExecutions?: number;
                  }
              )[][];
            }
          | {
              /** @format uuid */
              _id: string;
              taskName: "goto";
              /** @format uuid */
              targetTaskId: string;
              maxExecutions?: number;
            }
        )[][];
      }
    | {
        /** @format uuid */
        _id: string;
        taskName: "goto";
        /** @format uuid */
        targetTaskId: string;
        maxExecutions?: number;
      }
  )[][];
}

export interface AlarmProcessOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  } | null;
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  /**
   * PII
   * @maxLength 4096
   */
  description: string;
  tasks: (
    | {
        /** @format uuid */
        _id: string;
        taskName: "call";
        dataScript: {
          scriptName: "getAssets";
          options: {
            filter: any;
            max: number;
          };
        };
        /** @maxLength 1024 */
        forceLocale?: string | null;
      }
    | {
        /** @format uuid */
        _id: string;
        taskName: "sms";
        dataScript: {
          scriptName: "getAssets";
          options: {
            filter: any;
            max: number;
          };
        };
        /** @maxLength 1024 */
        forceLocale?: string | null;
      }
    | {
        /** @format uuid */
        _id: string;
        taskName: "delay";
        delaySeconds: number;
      }
    | {
        /** @format uuid */
        _id: string;
        taskName: "split";
        tasks: (
          | {
              /** @format uuid */
              _id: string;
              taskName: "call";
              dataScript: {
                scriptName: "getAssets";
                options: {
                  filter: any;
                  max: number;
                };
              };
              /** @maxLength 1024 */
              forceLocale?: string | null;
            }
          | {
              /** @format uuid */
              _id: string;
              taskName: "sms";
              dataScript: {
                scriptName: "getAssets";
                options: {
                  filter: any;
                  max: number;
                };
              };
              /** @maxLength 1024 */
              forceLocale?: string | null;
            }
          | {
              /** @format uuid */
              _id: string;
              taskName: "delay";
              delaySeconds: number;
            }
          | {
              /** @format uuid */
              _id: string;
              taskName: "schedule";
              branches: {
                schedule: {
                  entries: {
                    daysOfWeek: number[];
                    /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                    timeStart: string;
                    /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                    timeEnd: string;
                  }[];
                };
                tasks: (
                  | {
                      /** @format uuid */
                      _id: string;
                      taskName: "call";
                      dataScript: {
                        scriptName: "getAssets";
                        options: {
                          filter: any;
                          max: number;
                        };
                      };
                      /** @maxLength 1024 */
                      forceLocale?: string | null;
                    }
                  | {
                      /** @format uuid */
                      _id: string;
                      taskName: "sms";
                      dataScript: {
                        scriptName: "getAssets";
                        options: {
                          filter: any;
                          max: number;
                        };
                      };
                      /** @maxLength 1024 */
                      forceLocale?: string | null;
                    }
                  | {
                      /** @format uuid */
                      _id: string;
                      taskName: "delay";
                      delaySeconds: number;
                    }
                  | {
                      /** @format uuid */
                      _id: string;
                      taskName: "goto";
                      /** @format uuid */
                      targetTaskId: string;
                      maxExecutions?: number;
                    }
                )[][];
              }[];
              defaultTasks?: (
                | {
                    /** @format uuid */
                    _id: string;
                    taskName: "call";
                    dataScript: {
                      scriptName: "getAssets";
                      options: {
                        filter: any;
                        max: number;
                      };
                    };
                    /** @maxLength 1024 */
                    forceLocale?: string | null;
                  }
                | {
                    /** @format uuid */
                    _id: string;
                    taskName: "sms";
                    dataScript: {
                      scriptName: "getAssets";
                      options: {
                        filter: any;
                        max: number;
                      };
                    };
                    /** @maxLength 1024 */
                    forceLocale?: string | null;
                  }
                | {
                    /** @format uuid */
                    _id: string;
                    taskName: "delay";
                    delaySeconds: number;
                  }
                | {
                    /** @format uuid */
                    _id: string;
                    taskName: "goto";
                    /** @format uuid */
                    targetTaskId: string;
                    maxExecutions?: number;
                  }
              )[][];
            }
          | {
              /** @format uuid */
              _id: string;
              taskName: "goto";
              /** @format uuid */
              targetTaskId: string;
              maxExecutions?: number;
            }
        )[][];
      }
    | {
        /** @format uuid */
        _id: string;
        taskName: "goto";
        /** @format uuid */
        targetTaskId: string;
        maxExecutions?: number;
      }
  )[][];
}

export interface AlarmProcessUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  } | null;
  /**
   * PII
   * @maxLength 1024
   */
  name?: string;
  /**
   * PII
   * @maxLength 4096
   */
  description?: string;
  tasks?: (
    | {
        /** @format uuid */
        _id: string;
        taskName: "call";
        dataScript: {
          scriptName: "getAssets";
          options: {
            filter: any;
            max: number;
          };
        };
        /** @maxLength 1024 */
        forceLocale?: string | null;
      }
    | {
        /** @format uuid */
        _id: string;
        taskName: "sms";
        dataScript: {
          scriptName: "getAssets";
          options: {
            filter: any;
            max: number;
          };
        };
        /** @maxLength 1024 */
        forceLocale?: string | null;
      }
    | {
        /** @format uuid */
        _id: string;
        taskName: "delay";
        delaySeconds: number;
      }
    | {
        /** @format uuid */
        _id: string;
        taskName: "split";
        tasks: (
          | {
              /** @format uuid */
              _id: string;
              taskName: "call";
              dataScript: {
                scriptName: "getAssets";
                options: {
                  filter: any;
                  max: number;
                };
              };
              /** @maxLength 1024 */
              forceLocale?: string | null;
            }
          | {
              /** @format uuid */
              _id: string;
              taskName: "sms";
              dataScript: {
                scriptName: "getAssets";
                options: {
                  filter: any;
                  max: number;
                };
              };
              /** @maxLength 1024 */
              forceLocale?: string | null;
            }
          | {
              /** @format uuid */
              _id: string;
              taskName: "delay";
              delaySeconds: number;
            }
          | {
              /** @format uuid */
              _id: string;
              taskName: "schedule";
              branches: {
                schedule: {
                  entries: {
                    daysOfWeek: number[];
                    /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                    timeStart: string;
                    /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                    timeEnd: string;
                  }[];
                };
                tasks: (
                  | {
                      /** @format uuid */
                      _id: string;
                      taskName: "call";
                      dataScript: {
                        scriptName: "getAssets";
                        options: {
                          filter: any;
                          max: number;
                        };
                      };
                      /** @maxLength 1024 */
                      forceLocale?: string | null;
                    }
                  | {
                      /** @format uuid */
                      _id: string;
                      taskName: "sms";
                      dataScript: {
                        scriptName: "getAssets";
                        options: {
                          filter: any;
                          max: number;
                        };
                      };
                      /** @maxLength 1024 */
                      forceLocale?: string | null;
                    }
                  | {
                      /** @format uuid */
                      _id: string;
                      taskName: "delay";
                      delaySeconds: number;
                    }
                  | {
                      /** @format uuid */
                      _id: string;
                      taskName: "goto";
                      /** @format uuid */
                      targetTaskId: string;
                      maxExecutions?: number;
                    }
                )[][];
              }[];
              defaultTasks?: (
                | {
                    /** @format uuid */
                    _id: string;
                    taskName: "call";
                    dataScript: {
                      scriptName: "getAssets";
                      options: {
                        filter: any;
                        max: number;
                      };
                    };
                    /** @maxLength 1024 */
                    forceLocale?: string | null;
                  }
                | {
                    /** @format uuid */
                    _id: string;
                    taskName: "sms";
                    dataScript: {
                      scriptName: "getAssets";
                      options: {
                        filter: any;
                        max: number;
                      };
                    };
                    /** @maxLength 1024 */
                    forceLocale?: string | null;
                  }
                | {
                    /** @format uuid */
                    _id: string;
                    taskName: "delay";
                    delaySeconds: number;
                  }
                | {
                    /** @format uuid */
                    _id: string;
                    taskName: "goto";
                    /** @format uuid */
                    targetTaskId: string;
                    maxExecutions?: number;
                  }
              )[][];
            }
          | {
              /** @format uuid */
              _id: string;
              taskName: "goto";
              /** @format uuid */
              targetTaskId: string;
              maxExecutions?: number;
            }
        )[][];
      }
    | {
        /** @format uuid */
        _id: string;
        taskName: "goto";
        /** @format uuid */
        targetTaskId: string;
        maxExecutions?: number;
      }
  )[][];
}

export interface AlarmProfessionalResponderCountOutputDto {
  _id: string;
  postcode: string;
  sequrix: boolean;
  respondersSequrix: {
    _id: string;
    name: string;
  }[];
  respondersNoSequrix: {
    _id: string;
    name: string;
  }[];
}

export interface AlarmProfessionalRespondersOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  type: "sequrix";
  active: boolean;
  status: "invited" | "accepted" | "rejected" | "started" | "onLocation" | "finished" | "error" | "canceled";
  alarm: {
    /** @format uuid */
    _id: string;
    _ref: "Alarm";
  };
  asset: {
    /** @format uuid */
    _id: string;
    _ref: "Asset";
  };
  staticResponder: {
    /** @format uuid */
    _id: string;
    _ref: "StaticResponder";
  };
  /** PII */
  statistics: {
    /** @format date-time */
    invitedAt: string;
    /** @format date-time */
    acceptedAt: string | null;
    /** @format date-time */
    rejectedAt: string | null;
    /** @format date-time */
    startedAt: string | null;
    /** @format date-time */
    onLocationAt: string | null;
    /** @format date-time */
    finishedAt: string | null;
  };
  meta: {
    /**
     * PII
     * @maxLength 4096
     */
    comment?: string;
    /** PII */
    photos?: {
      /** @format date-time */
      timestamp: string;
      /** @maxLength 1024 */
      url: string;
    }[];
    /**
     * PII
     * @maxLength 1024
     */
    overridePhoneNumber?: string;
  };
  supersededBy: {
    /** @format uuid */
    _id: string;
    _ref: "AlarmProfessionalResponder";
  } | null;
}

export interface AlarmResponseResponseDto {
  result: {
    type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
    priority: number;
    zone?: {
      /** @format uuid */
      _id: string;
      customer?: {
        /** @format uuid */
        _id: string;
        _ref: "Customer";
      };
      type?:
        | "default"
        | "responseArea"
        | "policeDepartment"
        | "assetMonitoredArea"
        | "fingerprinted"
        | "building"
        | "evacuationPoint";
      /** PII */
      location:
        | {
            type: "Point";
            /** PII */
            coordinates: number[];
            properties: {
              accuracy?: number;
              heading?: number;
              headingAccuracy?: number;
              speed?: number;
              speedAccuracy?: number;
              altitude?: number;
              altitudeAccuracy?: number;
              /** PII */
              address?: {
                /** @maxLength 1024 */
                countryCode?: string | null;
                /** @maxLength 1024 */
                state?: string | null;
                /** @maxLength 1024 */
                city?: string | null;
                /** @maxLength 1024 */
                streetName?: string | null;
                /** @maxLength 1024 */
                streetNumber?: string | null;
                floor?: number | null;
                /** @maxLength 1024 */
                formattedAddress?: string;
              };
              /** @format date-time */
              dateTime?: string;
              /** @maxLength 1024 */
              provider?: string;
            };
          }
        | {
            type: "Polygon";
            /** PII */
            coordinates: number[][][];
            properties: {
              accuracy?: number;
              heading?: number;
              headingAccuracy?: number;
              speed?: number;
              speedAccuracy?: number;
              altitude?: number;
              altitudeAccuracy?: number;
              /** PII */
              address?: {
                /** @maxLength 1024 */
                countryCode?: string | null;
                /** @maxLength 1024 */
                state?: string | null;
                /** @maxLength 1024 */
                city?: string | null;
                /** @maxLength 1024 */
                streetName?: string | null;
                /** @maxLength 1024 */
                streetNumber?: string | null;
                floor?: number | null;
                /** @maxLength 1024 */
                formattedAddress?: string;
              };
              /** @format date-time */
              dateTime?: string;
              /** @maxLength 1024 */
              provider?: string;
            };
          }
        | {
            type: "MultiPolygon";
            coordinates: number[][][][];
            properties: {
              accuracy?: number;
              heading?: number;
              headingAccuracy?: number;
              speed?: number;
              speedAccuracy?: number;
              altitude?: number;
              altitudeAccuracy?: number;
              /** PII */
              address?: {
                /** @maxLength 1024 */
                countryCode?: string | null;
                /** @maxLength 1024 */
                state?: string | null;
                /** @maxLength 1024 */
                city?: string | null;
                /** @maxLength 1024 */
                streetName?: string | null;
                /** @maxLength 1024 */
                streetNumber?: string | null;
                floor?: number | null;
                /** @maxLength 1024 */
                formattedAddress?: string;
              };
              /** @format date-time */
              dateTime?: string;
              /** @maxLength 1024 */
              provider?: string;
            };
          };
      /** @maxLength 1024 */
      name: string;
      staticResponders: {
        staticResponder: {
          /** @format uuid */
          _id: string;
          _ref: "StaticResponder";
        };
        priority: number;
      }[];
    };
    responders: {
      info: {
        /** @format uuid */
        _id: string;
        _ref: "Asset" | "StaticResponder";
        /**
         * PII
         * @maxLength 1024
         */
        name: string;
        /**
         * PII
         * @maxLength 1024
         */
        image: string | null;
        /** PII */
        position: {
          type: "Point";
          /** PII */
          coordinates: number[];
          properties: {
            accuracy?: number;
            heading?: number;
            headingAccuracy?: number;
            speed?: number;
            speedAccuracy?: number;
            altitude?: number;
            altitudeAccuracy?: number;
            /** PII */
            address?: {
              /** @maxLength 1024 */
              countryCode?: string | null;
              /** @maxLength 1024 */
              state?: string | null;
              /** @maxLength 1024 */
              city?: string | null;
              /** @maxLength 1024 */
              streetName?: string | null;
              /** @maxLength 1024 */
              streetNumber?: string | null;
              floor?: number | null;
              /** @maxLength 1024 */
              formattedAddress?: string;
            };
            /** @format date-time */
            dateTime?: string;
            /** @maxLength 1024 */
            provider?: string;
          };
        };
        /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
        locale: string | null;
        /**
         * PII
         * @maxLength 1024
         */
        contactCode: string | null;
      };
      distanceKm: number | null;
      actions: {
        /**
         * PII
         * @maxLength 1024
         */
        call: string | null;
        /**
         * PII
         * @maxLength 1024
         */
        sms: string | null;
        /**
         * PII
         * @maxLength 1024
         */
        email: string | null;
        notification: boolean;
      };
      priority: number;
      professionalResponder?: {
        available: boolean;
        inProgress: boolean;
      };
    }[];
  }[];
}

export interface AlarmResponseStaticResponseDto {
  result: {
    type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
    priority: number;
    zone?: {
      /** @format uuid */
      _id: string;
      customer?: {
        /** @format uuid */
        _id: string;
        _ref: "Customer";
      };
      type?:
        | "default"
        | "responseArea"
        | "policeDepartment"
        | "assetMonitoredArea"
        | "fingerprinted"
        | "building"
        | "evacuationPoint";
      /** PII */
      location:
        | {
            type: "Point";
            /** PII */
            coordinates: number[];
            properties: {
              accuracy?: number;
              heading?: number;
              headingAccuracy?: number;
              speed?: number;
              speedAccuracy?: number;
              altitude?: number;
              altitudeAccuracy?: number;
              /** PII */
              address?: {
                /** @maxLength 1024 */
                countryCode?: string | null;
                /** @maxLength 1024 */
                state?: string | null;
                /** @maxLength 1024 */
                city?: string | null;
                /** @maxLength 1024 */
                streetName?: string | null;
                /** @maxLength 1024 */
                streetNumber?: string | null;
                floor?: number | null;
                /** @maxLength 1024 */
                formattedAddress?: string;
              };
              /** @format date-time */
              dateTime?: string;
              /** @maxLength 1024 */
              provider?: string;
            };
          }
        | {
            type: "Polygon";
            /** PII */
            coordinates: number[][][];
            properties: {
              accuracy?: number;
              heading?: number;
              headingAccuracy?: number;
              speed?: number;
              speedAccuracy?: number;
              altitude?: number;
              altitudeAccuracy?: number;
              /** PII */
              address?: {
                /** @maxLength 1024 */
                countryCode?: string | null;
                /** @maxLength 1024 */
                state?: string | null;
                /** @maxLength 1024 */
                city?: string | null;
                /** @maxLength 1024 */
                streetName?: string | null;
                /** @maxLength 1024 */
                streetNumber?: string | null;
                floor?: number | null;
                /** @maxLength 1024 */
                formattedAddress?: string;
              };
              /** @format date-time */
              dateTime?: string;
              /** @maxLength 1024 */
              provider?: string;
            };
          }
        | {
            type: "MultiPolygon";
            coordinates: number[][][][];
            properties: {
              accuracy?: number;
              heading?: number;
              headingAccuracy?: number;
              speed?: number;
              speedAccuracy?: number;
              altitude?: number;
              altitudeAccuracy?: number;
              /** PII */
              address?: {
                /** @maxLength 1024 */
                countryCode?: string | null;
                /** @maxLength 1024 */
                state?: string | null;
                /** @maxLength 1024 */
                city?: string | null;
                /** @maxLength 1024 */
                streetName?: string | null;
                /** @maxLength 1024 */
                streetNumber?: string | null;
                floor?: number | null;
                /** @maxLength 1024 */
                formattedAddress?: string;
              };
              /** @format date-time */
              dateTime?: string;
              /** @maxLength 1024 */
              provider?: string;
            };
          };
      /** @maxLength 1024 */
      name: string;
      staticResponders: {
        staticResponder: {
          /** @format uuid */
          _id: string;
          _ref: "StaticResponder";
        };
        priority: number;
      }[];
    };
    responders: {
      info: {
        /** @format uuid */
        _id: string;
        _ref: "Asset" | "StaticResponder";
        /**
         * PII
         * @maxLength 1024
         */
        name: string;
        /**
         * PII
         * @maxLength 1024
         */
        image: string | null;
        /** PII */
        position: {
          type: "Point";
          /** PII */
          coordinates: number[];
          properties: {
            accuracy?: number;
            heading?: number;
            headingAccuracy?: number;
            speed?: number;
            speedAccuracy?: number;
            altitude?: number;
            altitudeAccuracy?: number;
            /** PII */
            address?: {
              /** @maxLength 1024 */
              countryCode?: string | null;
              /** @maxLength 1024 */
              state?: string | null;
              /** @maxLength 1024 */
              city?: string | null;
              /** @maxLength 1024 */
              streetName?: string | null;
              /** @maxLength 1024 */
              streetNumber?: string | null;
              floor?: number | null;
              /** @maxLength 1024 */
              formattedAddress?: string;
            };
            /** @format date-time */
            dateTime?: string;
            /** @maxLength 1024 */
            provider?: string;
          };
        };
        /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
        locale: string | null;
        /**
         * PII
         * @maxLength 1024
         */
        contactCode: string | null;
      };
      distanceKm: number | null;
      actions: {
        /**
         * PII
         * @maxLength 1024
         */
        call: string | null;
        /**
         * PII
         * @maxLength 1024
         */
        sms: string | null;
        /**
         * PII
         * @maxLength 1024
         */
        email: string | null;
        notification: boolean;
      };
      priority: number;
      professionalResponder?: {
        available: boolean;
        inProgress: boolean;
      };
    }[];
  }[];
}

export interface AlarmUpdateDto {
  alarmCenter: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
}

export interface AssetAppUpdateDto {
  available?: boolean;
  app?: {
    mode: "off" | "on" | "risk";
  } | null;
}

export interface AssetAppUserDeleteDto {
  /** @format uuid */
  assetId: string;
  /** @default false */
  deleteAllDevices?: boolean;
}

export interface AssetCertificationCreateDto {
  certificationCategory: {
    /** @format uuid */
    _id: string;
    _ref: "CertificationCategory";
  };
  /** @format date-time */
  firstIssuedOn: string;
  /** @format date-time */
  lastReceivedOn: string;
  /** @format date-time */
  expiryDate: string;
}

export interface AssetCertificationDocumentUploadDto {
  /** @format uri */
  documentaryProof: string;
}

export interface AssetCertificationUpdateDto {
  /** @format date-time */
  firstIssuedOn?: string;
  /** @format date-time */
  lastReceivedOn?: string;
  /** @format date-time */
  expiryDate?: string;
  /**
   * @format date-time
   * @default null
   */
  plannedRenewalDate?: string | null;
}

export interface AssetCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  user: {
    /** @format uuid */
    _id: string;
    _ref: "User";
  } | null;
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  /**
   * PII
   * @maxLength 1024
   */
  externalId?: string | null;
  propertiesOwnership?: "override" | "inherit";
  /** @default {} */
  properties?: {
    /**
     * PII
     * @maxLength 1024
     */
    phoneNumber?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    smsNumber?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    email?: string | null;
    /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
    locale?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    image?: string | null;
    /** PII */
    rSim?: {
      /**
       * PII
       * @maxLength 1024
       */
      euicc: string;
      primary: {
        /**
         * PII
         * @maxLength 1024
         */
        msisdn: string;
        /**
         * PII
         * @maxLength 1024
         */
        iccid: string;
      };
      secondary: {
        /**
         * PII
         * @maxLength 1024
         */
        msisdn: string;
        /**
         * PII
         * @maxLength 1024
         */
        iccid: string;
      };
      enabled: boolean;
    } | null;
  };
  /**
   * PII
   * @default null
   */
  position?: {
    type: "Point";
    /** PII */
    coordinates: number[];
    properties: {
      accuracy?: number;
      heading?: number;
      headingAccuracy?: number;
      speed?: number;
      speedAccuracy?: number;
      altitude?: number;
      altitudeAccuracy?: number;
      /** PII */
      address?: {
        /** @maxLength 1024 */
        countryCode?: string | null;
        /** @maxLength 1024 */
        state?: string | null;
        /** @maxLength 1024 */
        city?: string | null;
        /** @maxLength 1024 */
        streetName?: string | null;
        /** @maxLength 1024 */
        streetNumber?: string | null;
        floor?: number | null;
        /** @maxLength 1024 */
        formattedAddress?: string;
      };
      /** @format date-time */
      dateTime?: string;
      /** @maxLength 1024 */
      provider?: string;
    };
  };
  available: boolean;
  /** @default true */
  allowContactOnOwnAlarms?: boolean;
  app?: {
    mode: "off" | "on" | "risk";
  } | null;
  assetGroups?: {
    /** @format uuid */
    _id: string;
    _ref: "AssetGroup";
  }[];
  /** @default [] */
  staticResponders?: {
    staticResponder: {
      /** @format uuid */
      _id: string;
      _ref: "StaticResponder";
    };
    priority: number;
  }[];
  /** @format date-time */
  lastObservationAt?: string;
  /** @default false */
  invisibleResponder?: boolean;
  /**
   * PII
   * @maxLength 4096
   */
  description?: string;
  type?: "default" | "kiosk";
}

export interface AssetGetAtsResponseDto {
  /** @format uuid */
  alarmId?: string;
  /** @format uuid */
  assetId?: string;
  /** @default true */
  isSimulated?: boolean;
  filter: Record<string, any>;
  geoNear: {
    near:
      | {
          type: "Point";
          coordinates: number[];
        }
      | number[];
    distanceField: string;
    distanceMultiplier?: number;
    includeLocs?: string;
    key?: string;
    maxDistance?: number;
    minDistance?: number;
    query?: Record<string, any>;
    spherical?: boolean;
    uniqueDocs?: boolean;
  } | null;
  contacted?: boolean;
}

export interface AssetGroupAddAssetsDto {
  assets: {
    /** @format uuid */
    _id: string;
    _ref: "Asset";
  }[];
}

export interface AssetGroupCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  /** @maxLength 1024 */
  description?: string | null;
  assets: {
    /** @format uuid */
    _id: string;
    _ref: "Asset";
  }[];
  clientConfig?: {
    app?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
    kiosk?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
  };
}

export interface AssetGroupMassUpdateDto {
  assets: {
    /** @format uuid */
    _id: string;
    _ref: "Asset";
  }[];
  assetGroups: {
    /** @format uuid */
    _id: string;
    _ref: "AssetGroup";
  }[];
  replace: boolean;
}

export interface AssetGroupOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  /** @maxLength 1024 */
  description?: string | null;
  assets: {
    /** @format uuid */
    _id: string;
    _ref: "Asset";
  }[];
  clientConfig?: {
    app?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
    kiosk?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
  };
}

export interface AssetGroupUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /**
   * PII
   * @maxLength 1024
   */
  name?: string;
  /** @maxLength 1024 */
  description?: string | null;
  assets?: {
    /** @format uuid */
    _id: string;
    _ref: "Asset";
  }[];
  clientConfig?: {
    app?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
    kiosk?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
  };
}

export interface AssetMoveDto {
  ids: string[];
  fromCustomer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  toCustomer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
}

export interface AssetOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  user: {
    /** @format uuid */
    _id: string;
    _ref: "User";
  } | null;
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  /**
   * PII
   * @maxLength 1024
   */
  externalId?: string | null;
  propertiesOwnership?: "override" | "inherit";
  /** @default {} */
  properties?: {
    /**
     * PII
     * @maxLength 1024
     */
    phoneNumber?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    smsNumber?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    email?: string | null;
    /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
    locale?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    image?: string | null;
    /** PII */
    rSim?: {
      /**
       * PII
       * @maxLength 1024
       */
      euicc: string;
      primary: {
        /**
         * PII
         * @maxLength 1024
         */
        msisdn: string;
        /**
         * PII
         * @maxLength 1024
         */
        iccid: string;
      };
      secondary: {
        /**
         * PII
         * @maxLength 1024
         */
        msisdn: string;
        /**
         * PII
         * @maxLength 1024
         */
        iccid: string;
      };
      enabled: boolean;
    } | null;
  };
  /**
   * PII
   * @default null
   */
  position?: {
    type: "Point";
    /** PII */
    coordinates: number[];
    properties: {
      accuracy?: number;
      heading?: number;
      headingAccuracy?: number;
      speed?: number;
      speedAccuracy?: number;
      altitude?: number;
      altitudeAccuracy?: number;
      /** PII */
      address?: {
        /** @maxLength 1024 */
        countryCode?: string | null;
        /** @maxLength 1024 */
        state?: string | null;
        /** @maxLength 1024 */
        city?: string | null;
        /** @maxLength 1024 */
        streetName?: string | null;
        /** @maxLength 1024 */
        streetNumber?: string | null;
        floor?: number | null;
        /** @maxLength 1024 */
        formattedAddress?: string;
      };
      /** @format date-time */
      dateTime?: string;
      /** @maxLength 1024 */
      provider?: string;
    };
  };
  available: boolean;
  /** @default true */
  allowContactOnOwnAlarms?: boolean;
  app?: {
    mode: "off" | "on" | "risk";
  } | null;
  insideZones: {
    /** @format uuid */
    _id: string;
    _ref: "Zone";
  }[];
  assetGroups: {
    /** @format uuid */
    _id: string;
    _ref: "AssetGroup";
  }[];
  /** @default [] */
  staticResponders?: {
    staticResponder: {
      /** @format uuid */
      _id: string;
      _ref: "StaticResponder";
    };
    priority: number;
  }[];
  /** @format date-time */
  lastObservationAt?: string;
  /** @default false */
  invisibleResponder?: boolean;
  /**
   * PII
   * @maxLength 4096
   */
  description?: string;
  /** @default [] */
  certifications?: {
    /** @format uuid */
    _id: string;
    certificationCategory: {
      /** @format uuid */
      _id: string;
      _ref: "CertificationCategory";
    };
    /** @format date-time */
    firstIssuedOn: string;
    /** @format date-time */
    lastReceivedOn: string;
    /** @format date-time */
    expiryDate: string;
    /**
     * @format date-time
     * @default null
     */
    plannedRenewalDate?: string | null;
    /** @maxLength 1024 */
    documentaryProof?: string | null;
  }[];
  type?: "default" | "kiosk";
}

export interface AssetPropertyVerificationCreateDto {
  type: "phoneNumber" | "email";
  /**
   * PII
   * @maxLength 1024
   */
  value: string;
  /** @maxLength 1024 */
  sentCode?: string;
  /**
   * PII
   * @maxLength 1024
   */
  appUniqueId: string;
  androidAppHash?: string;
  /** @default false */
  call?: boolean;
}

export interface AssetPropertyVerificationOutputDto {
  success: boolean;
}

export interface AssetPropertyVerifyCodeDto {
  type: "phoneNumber" | "email";
  value: string;
  appUniqueId: string;
  code: string;
}

export interface AssetUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  user?: {
    /** @format uuid */
    _id: string;
    _ref: "User";
  } | null;
  /**
   * PII
   * @maxLength 1024
   */
  name?: string;
  /**
   * PII
   * @maxLength 1024
   */
  externalId?: string | null;
  propertiesOwnership?: "override" | "inherit";
  /** @default {} */
  properties?: {
    /**
     * PII
     * @maxLength 1024
     */
    phoneNumber?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    smsNumber?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    email?: string | null;
    /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
    locale?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    image?: string | null;
    /** PII */
    rSim?: {
      /**
       * PII
       * @maxLength 1024
       */
      euicc: string;
      primary: {
        /**
         * PII
         * @maxLength 1024
         */
        msisdn: string;
        /**
         * PII
         * @maxLength 1024
         */
        iccid: string;
      };
      secondary: {
        /**
         * PII
         * @maxLength 1024
         */
        msisdn: string;
        /**
         * PII
         * @maxLength 1024
         */
        iccid: string;
      };
      enabled: boolean;
    } | null;
  };
  /**
   * PII
   * @default null
   */
  position?: {
    type: "Point";
    /** PII */
    coordinates: number[];
    properties: {
      accuracy?: number;
      heading?: number;
      headingAccuracy?: number;
      speed?: number;
      speedAccuracy?: number;
      altitude?: number;
      altitudeAccuracy?: number;
      /** PII */
      address?: {
        /** @maxLength 1024 */
        countryCode?: string | null;
        /** @maxLength 1024 */
        state?: string | null;
        /** @maxLength 1024 */
        city?: string | null;
        /** @maxLength 1024 */
        streetName?: string | null;
        /** @maxLength 1024 */
        streetNumber?: string | null;
        floor?: number | null;
        /** @maxLength 1024 */
        formattedAddress?: string;
      };
      /** @format date-time */
      dateTime?: string;
      /** @maxLength 1024 */
      provider?: string;
    };
  };
  available?: boolean;
  /** @default true */
  allowContactOnOwnAlarms?: boolean;
  app?: {
    mode: "off" | "on" | "risk";
  } | null;
  assetGroups?: {
    /** @format uuid */
    _id: string;
    _ref: "AssetGroup";
  }[];
  /** @default [] */
  staticResponders?: {
    staticResponder: {
      /** @format uuid */
      _id: string;
      _ref: "StaticResponder";
    };
    priority: number;
  }[];
  /** @format date-time */
  lastObservationAt?: string;
  /** @default false */
  invisibleResponder?: boolean;
  /**
   * PII
   * @maxLength 4096
   */
  description?: string;
  type?: "default" | "kiosk";
}

export interface AttendeeUpdateDto {
  /** PII */
  personalInformation?: {
    /** @format uuid */
    _id: string;
    _ref: "Visitor";
  };
  checkInRecord?: {
    /** @format date-time */
    timestamp: string;
    /** PII */
    kiosk: {
      /** @format uuid */
      _id: string;
      _ref: "Asset";
    };
  };
  checkOutRecord?: {
    /** @format date-time */
    timestamp: string;
    /** PII */
    kiosk: {
      /** @format uuid */
      _id: string;
      _ref: "Asset";
    };
  };
}

export interface BeaconCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  codes: string[];
  /**
   * @min 0
   * @exclusiveMin false
   */
  rssiAddend: number;
  type: "default" | "tag";
  zone?: {
    /** @format uuid */
    _id: string;
    _ref: "Zone";
  } | null;
  /** PII */
  location?:
    | {
        type: "Point";
        /** PII */
        coordinates: number[];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      }
    | {
        type: "Polygon";
        /** PII */
        coordinates: number[][][];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      }
    | {
        type: "MultiPolygon";
        coordinates: number[][][][];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      };
}

export interface BeaconOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  codes: string[];
  /**
   * @min 0
   * @exclusiveMin false
   */
  rssiAddend: number;
  type: "default" | "tag";
  state: {
    lastSeenBy?: {
      /** @format uuid */
      _id: string;
      _ref: "Asset";
    } | null;
    /** @format date-time */
    lastSeenAt?: string | null;
    battery?: number | null;
  };
  zone?: {
    /** @format uuid */
    _id: string;
    _ref: "Zone";
  } | null;
  /** PII */
  location?:
    | {
        type: "Point";
        /** PII */
        coordinates: number[];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      }
    | {
        type: "Polygon";
        /** PII */
        coordinates: number[][][];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      }
    | {
        type: "MultiPolygon";
        coordinates: number[][][][];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      };
}

export interface BeaconUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  codes?: string[];
  /**
   * @min 0
   * @exclusiveMin false
   */
  rssiAddend?: number;
  type?: "default" | "tag";
  zone?: {
    /** @format uuid */
    _id: string;
    _ref: "Zone";
  } | null;
  /** PII */
  location?:
    | {
        type: "Point";
        /** PII */
        coordinates: number[];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      }
    | {
        type: "Polygon";
        /** PII */
        coordinates: number[][][];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      }
    | {
        type: "MultiPolygon";
        coordinates: number[][][][];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      };
}

export interface BHVKnopAddAddtionalPaidResourcesDto {
  key: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  products: {
    /**
     * @min 0
     * @exclusiveMin false
     */
    button: number;
    /**
     * @min 0
     * @exclusiveMin false
     */
    gateway: number;
  };
  billingAddress: {
    companyName: string;
    postcode: string;
    houseNumber: string;
    street: string;
    city: string;
  };
  shippingAddress?: {
    companyName: string;
    postcode: string;
    houseNumber: string;
    street: string;
    city: string;
  };
  prices: {
    yearly: number;
    single: number;
    vat: number;
    totalNoVat: number;
    totalWithVat: number;
  };
}

export interface BHVKnopAddDevicesDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  devices: {
    name?: string;
    /** PII */
    position: {
      type: "Point";
      /** PII */
      coordinates: number[];
      properties: {
        accuracy?: number;
        heading?: number;
        headingAccuracy?: number;
        speed?: number;
        speedAccuracy?: number;
        altitude?: number;
        altitudeAccuracy?: number;
        /** PII */
        address?: {
          /** @maxLength 1024 */
          countryCode?: string | null;
          /** @maxLength 1024 */
          state?: string | null;
          /** @maxLength 1024 */
          city?: string | null;
          /** @maxLength 1024 */
          streetName?: string | null;
          /** @maxLength 1024 */
          streetNumber?: string | null;
          floor?: number | null;
          /** @maxLength 1024 */
          formattedAddress?: string;
        };
        /** @format date-time */
        dateTime?: string;
        /** @maxLength 1024 */
        provider?: string;
      };
    };
    type: "appDevice" | "lora" | "loraGateway" | "flic" | "generic" | "kiosk";
  }[];
}

export interface BHVKnopAssetsWithDeviceListResponseDto {
  result: {
    /** @format uuid */
    _id: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    customer: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    };
    /** @default {"type":"parents","extra":[]} */
    share?: {
      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
      extra?: {
        /** @format uuid */
        _id: string;
        _ref: "Customer";
      }[];
    };
    user: {
      /** @format uuid */
      _id: string;
      _ref: "User";
    } | null;
    /**
     * PII
     * @maxLength 1024
     */
    name: string;
    /**
     * PII
     * @maxLength 1024
     */
    externalId?: string | null;
    propertiesOwnership?: "override" | "inherit";
    /** @default {} */
    properties?: {
      /**
       * PII
       * @maxLength 1024
       */
      phoneNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      smsNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      email?: string | null;
      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
      locale?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      image?: string | null;
      /** PII */
      rSim?: {
        /**
         * PII
         * @maxLength 1024
         */
        euicc: string;
        primary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        secondary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        enabled: boolean;
      } | null;
    };
    /**
     * PII
     * @default null
     */
    position?: {
      type: "Point";
      /** PII */
      coordinates: number[];
      properties: {
        accuracy?: number;
        heading?: number;
        headingAccuracy?: number;
        speed?: number;
        speedAccuracy?: number;
        altitude?: number;
        altitudeAccuracy?: number;
        /** PII */
        address?: {
          /** @maxLength 1024 */
          countryCode?: string | null;
          /** @maxLength 1024 */
          state?: string | null;
          /** @maxLength 1024 */
          city?: string | null;
          /** @maxLength 1024 */
          streetName?: string | null;
          /** @maxLength 1024 */
          streetNumber?: string | null;
          floor?: number | null;
          /** @maxLength 1024 */
          formattedAddress?: string;
        };
        /** @format date-time */
        dateTime?: string;
        /** @maxLength 1024 */
        provider?: string;
      };
    };
    available: boolean;
    /** @default true */
    allowContactOnOwnAlarms?: boolean;
    app?: {
      mode: "off" | "on" | "risk";
    } | null;
    insideZones: {
      /** @format uuid */
      _id: string;
      _ref: "Zone";
    }[];
    assetGroups: {
      /** @format uuid */
      _id: string;
      _ref: "AssetGroup";
    }[];
    /** @default [] */
    staticResponders?: {
      staticResponder: {
        /** @format uuid */
        _id: string;
        _ref: "StaticResponder";
      };
      priority: number;
    }[];
    /** @format date-time */
    lastObservationAt?: string;
    /** @default false */
    invisibleResponder?: boolean;
    /**
     * PII
     * @maxLength 4096
     */
    description?: string;
    /** @default [] */
    certifications?: {
      /** @format uuid */
      _id: string;
      certificationCategory: {
        /** @format uuid */
        _id: string;
        _ref: "CertificationCategory";
      };
      /** @format date-time */
      firstIssuedOn: string;
      /** @format date-time */
      lastReceivedOn: string;
      /** @format date-time */
      expiryDate: string;
      /**
       * @format date-time
       * @default null
       */
      plannedRenewalDate?: string | null;
      /** @maxLength 1024 */
      documentaryProof?: string | null;
    }[];
    type?: "default" | "kiosk";
    device: {
      /** @format uuid */
      _id: string;
      /** @format date-time */
      createdAt: string;
      /** @format date-time */
      updatedAt: string;
      customer: {
        /** @format uuid */
        _id: string;
        _ref: "Customer";
      };
      /** @default {"type":"parents","extra":[]} */
      share?: {
        type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
        extra?: {
          /** @format uuid */
          _id: string;
          _ref: "Customer";
        }[];
      };
      asset: {
        /** @format uuid */
        _id: string;
        _ref: "Asset";
      } | null;
      /**
       * PII
       * @maxLength 1024
       */
      name?: string;
      /**
       * PII
       * @maxLength 1024
       */
      deviceId: string;
      type: "appDevice" | "lora" | "loraGateway" | "flic" | "generic" | "kiosk";
      loraConfig?:
        | {
            type: "adeunis.arf8123aa";
            config: {
              /** @maxLength 1024 */
              fieldTest: string;
            };
          }
        | {
            type: "iotracker.v2";
            config: {
              /** @maxLength 1024 */
              beaconScan: string;
              /** @maxLength 1024 */
              gps: string;
              /** @maxLength 1024 */
              preMandown: string;
              /** @maxLength 1024 */
              mandown: string;
              /** @maxLength 1024 */
              movement: string;
              /** @maxLength 1024 */
              alarmSeverity: string;
              /** @maxLength 1024 */
              alive: string;
            };
          }
        | {
            type: "milesight.ws101";
            config: {
              /** @maxLength 1024 */
              beaconScan: string;
              /** @maxLength 1024 */
              alarmSeverity: string;
              /** @maxLength 1024 */
              alive: string;
            };
          }
        | {
            type: "sensative.1301001";
            config: {
              /** @maxLength 1024 */
              alarmSeverity: string;
              /** @maxLength 1024 */
              alive: string;
              /** @maxLength 1024 */
              floodDetected: string;
              /** @maxLength 1024 */
              noFloodDetected: string;
            };
          }
        | null;
      kioskConfig?: {
        /** @default false */
        managed?: boolean;
        zone?: {
          /** @format uuid */
          _id: string;
          _ref: "Zone";
        } | null;
        exposeAssets?:
          | {
              /** @format uuid */
              _id: string;
              _ref: "AssetGroup";
            }[]
          | null;
        exposeLabels?:
          | {
              /** @format uuid */
              _id: string;
              _ref: "AssetGroup";
              countLabel?: boolean;
            }[]
          | null;
        schedule?: {
          entries: {
            daysOfWeek: number[];
            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
            timeStart: string;
            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
            timeEnd: string;
          }[];
        } | null;
        homepage?: {
          incidentCounter?: {
            /** @default true */
            enabled?: boolean;
            /** @format date-time */
            countFromDate?: string | null;
            /**
             * @min 0
             * @exclusiveMin false
             * @default 0
             */
            threshold?: number;
          };
          /** @default true */
          anonymous?: boolean;
          /** @format uri */
          logo?: string | null;
        };
        alarm?: {
          /** @default true */
          enabled?: boolean;
          focus?: {
            red?: {
              flash?: boolean | null;
              sound?: {
                enabled: boolean;
                /**
                 * @min 0
                 * @exclusiveMin false
                 * @max 100
                 * @exclusiveMax false
                 */
                volume?: number | null;
                sound?:
                  | "alarm"
                  | "alarmClock"
                  | "alarmRetro"
                  | "announcement"
                  | "attention"
                  | "bassPulse"
                  | "beepBeep"
                  | "beepBurglar"
                  | "beepContinuous"
                  | "beepHighSoft"
                  | "beepIncremental"
                  | "bell"
                  | "car"
                  | "chickens"
                  | "chime"
                  | "chirpSoft"
                  | "clockMelody"
                  | "countdownSonar"
                  | "doorbell"
                  | "escalate"
                  | "fancy"
                  | "fastAndNervous"
                  | "harp"
                  | "incomingPhone"
                  | "introduction"
                  | "intrusive"
                  | "invasion"
                  | "jungle"
                  | "lofiChords"
                  | "loopLow"
                  | "melodySoft"
                  | "notifySubtle"
                  | "onOff"
                  | "orchestral"
                  | "pling"
                  | "plingHigh"
                  | "plingLow"
                  | "pluckSong"
                  | "quick"
                  | "scanning"
                  | "shake"
                  | "silence"
                  | "sirenHigh"
                  | "sirenLow"
                  | "soft"
                  | "spaceship"
                  | "startup"
                  | "threeTones"
                  | "tornado"
                  | "wailing"
                  | "wakeup"
                  | null;
                /**
                 * @min 0
                 * @exclusiveMin false
                 */
                stopAfterSeconds?: number | null;
                stopAfterTouch?: boolean | null;
              };
            };
            orange?: {
              flash?: boolean | null;
              sound?: {
                enabled: boolean;
                /**
                 * @min 0
                 * @exclusiveMin false
                 * @max 100
                 * @exclusiveMax false
                 */
                volume?: number | null;
                sound?:
                  | "alarm"
                  | "alarmClock"
                  | "alarmRetro"
                  | "announcement"
                  | "attention"
                  | "bassPulse"
                  | "beepBeep"
                  | "beepBurglar"
                  | "beepContinuous"
                  | "beepHighSoft"
                  | "beepIncremental"
                  | "bell"
                  | "car"
                  | "chickens"
                  | "chime"
                  | "chirpSoft"
                  | "clockMelody"
                  | "countdownSonar"
                  | "doorbell"
                  | "escalate"
                  | "fancy"
                  | "fastAndNervous"
                  | "harp"
                  | "incomingPhone"
                  | "introduction"
                  | "intrusive"
                  | "invasion"
                  | "jungle"
                  | "lofiChords"
                  | "loopLow"
                  | "melodySoft"
                  | "notifySubtle"
                  | "onOff"
                  | "orchestral"
                  | "pling"
                  | "plingHigh"
                  | "plingLow"
                  | "pluckSong"
                  | "quick"
                  | "scanning"
                  | "shake"
                  | "silence"
                  | "sirenHigh"
                  | "sirenLow"
                  | "soft"
                  | "spaceship"
                  | "startup"
                  | "threeTones"
                  | "tornado"
                  | "wailing"
                  | "wakeup"
                  | null;
                /**
                 * @min 0
                 * @exclusiveMin false
                 */
                stopAfterSeconds?: number | null;
                stopAfterTouch?: boolean | null;
              };
            };
            green?: {
              flash?: boolean | null;
              sound?: {
                enabled: boolean;
                /**
                 * @min 0
                 * @exclusiveMin false
                 * @max 100
                 * @exclusiveMax false
                 */
                volume?: number | null;
                sound?:
                  | "alarm"
                  | "alarmClock"
                  | "alarmRetro"
                  | "announcement"
                  | "attention"
                  | "bassPulse"
                  | "beepBeep"
                  | "beepBurglar"
                  | "beepContinuous"
                  | "beepHighSoft"
                  | "beepIncremental"
                  | "bell"
                  | "car"
                  | "chickens"
                  | "chime"
                  | "chirpSoft"
                  | "clockMelody"
                  | "countdownSonar"
                  | "doorbell"
                  | "escalate"
                  | "fancy"
                  | "fastAndNervous"
                  | "harp"
                  | "incomingPhone"
                  | "introduction"
                  | "intrusive"
                  | "invasion"
                  | "jungle"
                  | "lofiChords"
                  | "loopLow"
                  | "melodySoft"
                  | "notifySubtle"
                  | "onOff"
                  | "orchestral"
                  | "pling"
                  | "plingHigh"
                  | "plingLow"
                  | "pluckSong"
                  | "quick"
                  | "scanning"
                  | "shake"
                  | "silence"
                  | "sirenHigh"
                  | "sirenLow"
                  | "soft"
                  | "spaceship"
                  | "startup"
                  | "threeTones"
                  | "tornado"
                  | "wailing"
                  | "wakeup"
                  | null;
                /**
                 * @min 0
                 * @exclusiveMin false
                 */
                stopAfterSeconds?: number | null;
                stopAfterTouch?: boolean | null;
              };
            };
          };
          /** @default true */
          showPositionLabels?: boolean;
          /** @default true */
          anonymous?: boolean;
          acknowledge?: {
            enabled?: boolean;
            /** @pattern ^[0-9]{4,6}$ */
            pin?: string | null;
            messagePresets?: string[] | null;
          };
          mode?: "zoneBased" | "customerBased" | null;
        };
        manageAvailability?: {
          /** @default true */
          enabled?: boolean;
          /** @pattern ^[0-9]{4,6}$ */
          pin?: string | null;
          /** @default true */
          showAppBanner?: boolean;
          /** @default false */
          forceShowSearch?: boolean;
          /** @default false */
          forceShowLabelFilter?: boolean;
        };
        hardware?: {
          /**
           * @min 0
           * @exclusiveMin false
           * @max 100
           * @exclusiveMax false
           */
          screenBrightness?: number | null;
        };
      };
      battery?: number;
      rssi?: number;
      snr?: number;
      app?: {
        permissions?: {
          calendar?: {
            status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
            /** @default false */
            alreadyAsked?: boolean;
          };
          camera?: {
            status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
            /** @default false */
            alreadyAsked?: boolean;
          };
          contacts?: {
            status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
            /** @default false */
            alreadyAsked?: boolean;
          };
          microphone?: {
            status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
            /** @default false */
            alreadyAsked?: boolean;
          };
          notifications?: {
            status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
            /** @default false */
            alreadyAsked?: boolean;
          };
          criticalNotifications?: {
            status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
            /** @default false */
            alreadyAsked?: boolean;
          };
          motion?: {
            status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
            /** @default false */
            alreadyAsked?: boolean;
          };
          bluetooth?: {
            status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
            /** @default false */
            alreadyAsked?: boolean;
          };
          locationAlways?: {
            status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
            /** @default false */
            alreadyAsked?: boolean;
          };
          locationWhenInUse?: {
            status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
            /** @default false */
            alreadyAsked?: boolean;
          };
          physical?: {
            status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
            /** @default false */
            alreadyAsked?: boolean;
          };
          batteryOptimization?: {
            status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
            /** @default false */
            alreadyAsked?: boolean;
          };
          overlay?: {
            status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
            /** @default false */
            alreadyAsked?: boolean;
          };
        };
        deviceOs?: {
          osType: "ios" | "android";
          /** @maxLength 1024 */
          osVersion: string;
          /** @maxLength 1024 */
          osId?: string;
          /** @maxLength 1024 */
          buildNumber?: string;
          /** @maxLength 1024 */
          bundleId?: string;
        };
        profile?: {
          /** @maxLength 1024 */
          name?: string;
          /** @maxLength 1024 */
          brand?: string;
          /** @maxLength 1024 */
          model?: string;
          /** @maxLength 1024 */
          carrier?: string;
        };
      } | null;
      clientConfig?: {
        app?: {
          definitions: (
            | {
                type: "key";
                key: string;
                value: any;
                editableBy?: ("AssetGroup" | "Device")[];
              }
            | {
                type: "group";
                group: {
                  /** @format uuid */
                  _id: string;
                  _ref: "ClientConfigGroup";
                };
              }
          )[];
          filter?: {
            type: "osFilter";
            osType: "ios" | "android";
            /** @maxLength 1024 */
            osVersionRange?: string;
          };
        }[];
        kiosk?: {
          definitions: (
            | {
                type: "key";
                key: string;
                value: any;
                editableBy?: ("AssetGroup" | "Device")[];
              }
            | {
                type: "group";
                group: {
                  /** @format uuid */
                  _id: string;
                  _ref: "ClientConfigGroup";
                };
              }
          )[];
          filter?: {
            type: "osFilter";
            osType: "ios" | "android";
            /** @maxLength 1024 */
            osVersionRange?: string;
          };
        }[];
      };
    };
  }[];
  total: number;
  max: number;
  offset: number;
}

export interface BHVKnopAssignHardwareDto {
  key: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  buttons: {
    /** @pattern ^[a-z0-9](?:[-]?[a-z0-9]){2,}$ */
    devEui: string;
    sequenceNumber: number;
    device?: {
      /** @format uuid */
      _id: string;
      _ref: "Device";
    };
  }[];
  gateways: {
    /** @pattern ^[a-z0-9](?:[-]?[a-z0-9]){2,}$ */
    gatewayEui: string;
    /** @pattern ^\+[0-9]{5,}$ */
    phoneNumber: string;
    sequenceNumber: number;
    device?: {
      /** @format uuid */
      _id: string;
      _ref: "Device";
    };
  }[];
}

export type BHVKnopAssignHardwareResponseDto = object;

export interface BHVKnopCreateOrConvertToPaidDto {
  key: string;
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  name: string;
  /** @format email */
  email: string;
  products: {
    /**
     * @min 1
     * @exclusiveMin false
     */
    button: number;
    /**
     * @min 1
     * @exclusiveMin false
     */
    gateway: number;
  };
  billingAddress: {
    companyName: string;
    postcode: string;
    houseNumber: string;
    street: string;
    city: string;
  };
  shippingAddress?: {
    companyName: string;
    postcode: string;
    houseNumber: string;
    street: string;
    city: string;
  };
  sepa: {
    iban: string;
    bankName: string;
  };
  prices: {
    yearly: number;
    single: number;
    vat: number;
    totalNoVat: number;
    totalWithVat: number;
  };
}

export interface BHVKnopCreateOrConvertToPaidResponseDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  converted?: boolean;
  token?: string;
  refreshToken?: string;
}

export interface BHVKnopCreateTrialDto {
  key: string;
  /** @format email */
  email: string;
  companyName: string;
}

export interface BHVKnopCreateTrialResponseDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  token: string;
  refreshToken: string;
}

export interface BHVKnopGetNextSequenceNumberDto {
  key: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  type: "appDevice" | "lora" | "loraGateway" | "flic" | "generic" | "kiosk";
}

export interface BHVKnopGetNextSequenceNumberResponseDto {
  /**
   * @min 1
   * @exclusiveMin false
   */
  next: number;
}

export interface BHVKnopGetSequenceNumbersDto {
  key?: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  assets: {
    /** @format uuid */
    _id: string;
    _ref: "Asset";
  }[];
}

export interface BHVKnopGetSequenceNumbersResponseDto {
  assets: {
    asset: {
      /** @format uuid */
      _id: string;
      _ref: "Asset";
    };
    sequenceNumber: number;
  }[];
}

export interface BHVKnopRemoveDevicesDto {
  assets: {
    /** @format uuid */
    _id: string;
    _ref: "Asset";
  }[];
}

export interface BHVKnopUpdateMonitoredZonesDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
}

export interface CertificationCategoryCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** @maxLength 1024 */
  name: string;
  /** @maxLength 1024 */
  description?: string | null;
  validityPeriod: {
    type: "day" | "week" | "month" | "year";
    value: number;
  };
  reminderPeriods: {
    type: "day" | "week" | "month" | "year";
    value: number;
  }[];
  notifiedPeople: {
    peopleToNotify: {
      /** @format uuid */
      _id: string;
      _ref: "Asset";
    }[];
    /** @default true */
    isCertificationHolderNotified?: boolean;
    /** PII */
    emails: string[];
  };
  /** @default false */
  isDocumentaryProofRequired?: boolean;
}

export interface CertificationCategoryOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** @maxLength 1024 */
  name: string;
  /** @maxLength 1024 */
  description?: string | null;
  validityPeriod: {
    type: "day" | "week" | "month" | "year";
    value: number;
  };
  reminderPeriods: {
    type: "day" | "week" | "month" | "year";
    value: number;
  }[];
  notifiedPeople: {
    peopleToNotify: {
      /** @format uuid */
      _id: string;
      _ref: "Asset";
    }[];
    /** @default true */
    isCertificationHolderNotified?: boolean;
    /** PII */
    emails: string[];
  };
  /** @default false */
  isDocumentaryProofRequired?: boolean;
}

export interface CertificationCategoryUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** @maxLength 1024 */
  name?: string;
  /** @maxLength 1024 */
  description?: string | null;
  validityPeriod?: {
    type: "day" | "week" | "month" | "year";
    value: number;
  };
  reminderPeriods?: {
    type: "day" | "week" | "month" | "year";
    value: number;
  }[];
  notifiedPeople?: {
    peopleToNotify: {
      /** @format uuid */
      _id: string;
      _ref: "Asset";
    }[];
    /** @default true */
    isCertificationHolderNotified?: boolean;
    /** PII */
    emails: string[];
  };
  /** @default false */
  isDocumentaryProofRequired?: boolean;
}

export interface CheckInOutRecordDto {
  checkInOutRecord: {
    /** @format date-time */
    timestamp: string;
    /** PII */
    kiosk: {
      /** @format uuid */
      _id: string;
      _ref: "Asset";
    };
  };
}

export interface ClientConfigGroupCreateDto {
  /** PII */
  name: string;
  clientConfig: {
    app?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
    kiosk?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
  };
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  } | null;
}

export interface ClientConfigGroupOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** PII */
  name: string;
  clientConfig: {
    app?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
    kiosk?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
  };
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  } | null;
}

export interface ClientConfigGroupUpdateDto {
  /** PII */
  name?: string;
  clientConfig?: {
    app?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
    kiosk?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
  };
}

export interface ClientConfigKeyOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  platform: "app" | "kiosk";
  editableBy: ("Customer" | "AssetGroup" | "Device")[];
  key: string;
  defaultValue: any;
  overrides?: {
    value: any;
    editableBy?: ("Customer" | "AssetGroup" | "Device")[];
    filter: {
      type: "osFilter";
      osType: "ios" | "android";
      /** @maxLength 1024 */
      osVersionRange?: string;
    };
  }[];
  version: number;
  manuallyUpdated?: boolean;
}

export interface ClientConfigKeyUpdateDto {
  editableBy?: ("Customer" | "AssetGroup" | "Device")[];
  defaultValue?: any;
  overrides?: {
    value: any;
    editableBy?: ("Customer" | "AssetGroup" | "Device")[];
    filter: {
      type: "osFilter";
      osType: "ios" | "android";
      /** @maxLength 1024 */
      osVersionRange?: string;
    };
  }[];
  version?: number;
}

export interface ClientConfigResolveAppV0Dto {
  config: {
    websocket: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      swapInterval: number;
      connectTimeout: {
        minWait: number;
        maxWait: number;
        factor: number;
      };
      connectRetry: {
        minWait: number;
        maxWait: number;
        factor: number;
      };
    };
    agenda: {
      enabled: boolean;
      /**
       * @min 0
       * @exclusiveMin true
       */
      syncTTL: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      eventTimeMargin: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      eventMaxDistance: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      syncFullTime: number;
      microsoftClientId: string;
      readMethod: "classic" | "day" | "sync";
      agendas: {
        type: "microsoft" | "internal";
        id: string;
      }[];
    };
    address: {
      radius: {
        /**
         * @min 0
         * @exclusiveMin false
         */
        minValue: number;
        /**
         * @min 0
         * @exclusiveMin true
         */
        maxValue: number;
        /**
         * @min 0
         * @exclusiveMin true
         */
        step: number;
        /**
         * @min 0
         * @exclusiveMin false
         */
        defaultValue: number;
      };
      temporaryAddressDuration: {
        /**
         * @min 0
         * @exclusiveMin false
         */
        minValue: number;
        /**
         * @min 0
         * @exclusiveMin true
         */
        maxValue: number;
        /**
         * @min 0
         * @exclusiveMin true
         */
        step: number;
        /**
         * @min 0
         * @exclusiveMin false
         */
        defaultValue: number;
      };
    };
    ams: {
      enabled: boolean;
      notification: boolean;
      rules: {
        id: string;
        enabled: boolean;
        rule:
          | {
              type: "time";
              conditions?: object;
            }
          | {
              type: "location";
              conditions?: object;
              address: string;
            }
          | {
              type: "charger";
              conditions?: object;
            };
        actionIn?: {
          mode?: {
            value: "off" | "on" | "risk";
            enabled: boolean;
          };
          available?: {
            value: boolean;
            enabled: boolean;
          };
        };
        actionOut?: {
          mode?: {
            value: "off" | "on" | "risk";
            enabled: boolean;
          };
          available?: {
            value: boolean;
            enabled: boolean;
          };
        };
      }[];
    };
    auth: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      showRetryAfterMs: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      retryTimeMs: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      smsTimeout: number;
    };
    contacts: {
      urls: {
        /** @format uri */
        setFavorite: string;
        /** @format uri */
        adjustDontDisturb: string;
      };
    };
    navigation: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      defaultInteractionThrottle: number;
    };
    environment: {
      key: "staging" | "production";
      mainApiUrl: string;
      authApiUrl: string;
      observationApiUrl: string;
      wsApiUrl: string;
      fusionAuthClientId: string;
      microsoftAuthEndpoint: string;
      microsoftTokenEndpoint: string;
      xguard: {
        company: {
          name: string;
          address: string;
          registrationNumber: string;
          alarmPhoneNumber: string;
        };
        privacy: {
          nl: string;
          en: string;
        };
        termsAndConditions: {
          nl: string;
          en: string;
        };
        microsoftRedirectUrl: string;
      };
      bhvknop: {
        company: {
          name: string;
          address: string;
          registrationNumber: string;
          alarmPhoneNumber: string;
        };
        privacy: {
          nl: string;
          en: string;
        };
        termsAndConditions: {
          nl: string;
          en: string;
        };
        microsoftRedirectUrl: string;
      };
    };
    supportChat: {
      portalId: string;
      hublet: string;
      environment: string;
      defaultChatFlow: string;
      /**
       * @min 0
       * @exclusiveMin true
       */
      staleChatThresholdMs: number;
      scheduleTimeZone: string;
      schedule:
        | {
            daysOfWeek: number[];
            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
            timeStart: string;
            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
            timeEnd: string;
          }[]
        | null;
    };
    otherEnvironment: {
      key: "staging" | "production";
      mainApiUrl: string;
    };
    translation: {
      substitutions: {
        key: string;
        value: string;
      }[];
    };
    registration: {
      supportedCCA2: {
        code: string;
        enabled: boolean;
      }[];
      /**
       * @min 0
       * @exclusiveMin true
       */
      policyMaxAge: number;
      publicCode: string;
      pageTransitionDelay: number;
    };
    observations: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      panicTimeout: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      timeout: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      blockGPSTimeout: number;
      retry: {
        /**
         * @min 0
         * @exclusiveMin true
         */
        maxAttempts: number;
        /**
         * @min 0
         * @exclusiveMin true
         */
        baseDelayMs: number;
        /**
         * @min 0
         * @exclusiveMin false
         * @max 1
         * @exclusiveMax false
         */
        jitterFactor: number;
      };
      limits: {
        event:
          | "ALARM_RED"
          | "ALARM_ORANGE"
          | "ALARM_GREEN"
          | "RELEASED_RED"
          | "RELEASED_ORANGE"
          | "RELEASED_GREEN"
          | "BATLOAD"
          | "BATLOW"
          | "BATNORMAL"
          | "BATFULL"
          | "EXTPOWER"
          | "BATPOWER"
          | "APP_START"
          | "BATLEVEL"
          | "GPS"
          | "BEACON"
          | "TAG"
          | "MANDOWN"
          | "NFC"
          | "XOOR"
          | "MOVSTART"
          | "MOVSTOP"
          | "GEOIN"
          | "GEOOUT"
          | "DWELL"
          | "APPROX"
          | "MODE_OFF_ON"
          | "MODE_OFF_OFF"
          | "MODE_ON_ON"
          | "MODE_ON_OFF"
          | "MODE_RISK_ON"
          | "MODE_RISK_OFF"
          | "PRE_ALARM_HEADSET"
          | "PRE_ALARM_HARDWARE_BUTTON"
          | "PRE_ALARM_MANDOWN"
          | "PRE_ALARM_FLIC"
          | "PRE_ALARM_CANCELLED"
          | "HANGUP_CLIENT"
          | "HANGUP_REMOTE"
          | "ALIVE"
          | "LOGOUT"
          | "LOGIN"
          | "START_CALL"
          | "AVAILABLE_ON"
          | "AVAILABLE_OFF"
          | "SOCKET_CONNECT"
          | "SOCKET_DISCONNECT"
          | "FLIC_BATLOW"
          | "FLIC_BATNORMAL"
          | "FLIC_CLICK"
          | "FLIC_DOUBLE_CLICK"
          | "FLIC_HOLD"
          | "INCOMING_ALARM_FOREGROUND";
        /**
         * @min 0
         * @exclusiveMin true
         */
        rateLimitDefault?: number | null;
        /**
         * @min 0
         * @exclusiveMin true
         */
        rateLimitPanic?: number | null;
        /**
         * @min 0
         * @exclusiveMin true
         */
        rateLimitSlow?: number | null;
        /**
         * @min 0
         * @exclusiveMin true
         */
        timeout?: number | null;
      }[];
    };
    logger: {
      entryMaxAge: {
        error: {
          /**
           * @min 0
           * @exclusiveMin true
           */
          maxAge: number;
          /**
           * @min 0
           * @exclusiveMin true
           */
          leftPadding: number | null;
          /**
           * @min 0
           * @exclusiveMin true
           */
          rightPadding: number | null;
        };
        warning: {
          /**
           * @min 0
           * @exclusiveMin true
           */
          maxAge: number;
          /**
           * @min 0
           * @exclusiveMin true
           */
          leftPadding: number | null;
          /**
           * @min 0
           * @exclusiveMin true
           */
          rightPadding: number | null;
        };
        info: {
          /**
           * @min 0
           * @exclusiveMin true
           */
          maxAge: number;
          /**
           * @min 0
           * @exclusiveMin true
           */
          leftPadding: number | null;
          /**
           * @min 0
           * @exclusiveMin true
           */
          rightPadding: number | null;
        };
        debug: {
          /**
           * @min 0
           * @exclusiveMin true
           */
          maxAge: number;
          /**
           * @min 0
           * @exclusiveMin true
           */
          leftPadding: number | null;
          /**
           * @min 0
           * @exclusiveMin true
           */
          rightPadding: number | null;
        };
      };
      /**
       * @min 0
       * @exclusiveMin true
       */
      dbMaxSize: number;
      enableLogUpload: boolean;
      /**
       * @min 0
       * @exclusiveMin true
       */
      flushEntriesOnCount: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      flushEntriesOnTimeout: number;
      uploadOptions: number[];
    };
    notifier: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      duration: number;
    };
    alarms: {
      allowWhenOff: boolean;
      buttons: {
        severity: "red" | "orange" | "green";
        type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
        overrideColor?: "green" | "blue" | "yellow" | "orange" | "red";
        overrideLabel?: string;
        allowWhenOff?: boolean;
        visible?: boolean;
        order?: number;
        height?: "small" | "large";
        width?: "full" | "half";
      }[];
      /**
       * @min 0
       * @exclusiveMin true
       */
      buttonPressDuration: number;
    };
    evacuation: {
      buttons: {
        type: "fire" | "gasLeak" | "workplaceAccident" | "smokeDevelopment" | "generalEvacuation" | "evacuationDrill";
        color?: "green" | "blue" | "yellow" | "orange" | "red";
      }[];
      /**
       * @min 0
       * @exclusiveMin true
       */
      recentObservationThreshold: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      buildingZonesProximityRadius: number;
      evacuationMap: {
        /**
         * @min 0
         * @exclusiveMin true
         */
        clusterPxRadius: number;
        /**
         * @min 0
         * @exclusiveMin false
         */
        clusterMaxZoom: number;
        /**
         * @min 0
         * @exclusiveMin false
         */
        mapMaxZoom: number;
      };
    };
    incomingAlarms: {
      list: {
        /**
         * @min 0
         * @exclusiveMin true
         */
        pageSize: number;
      };
      alarmCard: {
        confirmOverrideText: string | null;
        rejectOverrideText: string | null;
        summaryTypeOverrides: {
          type: "static" | "person";
          alarmTypes?: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[];
          alarmSeverities?: ("red" | "orange" | "green")[];
          includeAssetGroups?: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
          excludeAssetGroups?: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
        }[];
        rejectConfirmEnabled: boolean;
      };
      componentOrder: (
        | "summary"
        | "helpers"
        | "locations"
        | "response"
        | "call"
        | "logbook"
        | "escalation"
        | "acknowledge"
      )[];
      alarmSheet: {
        snapPoints: number[];
      };
      notification: {
        mode: "call" | "notification";
        sound: {
          sound:
            | "alarm"
            | "alarmclock"
            | "beepbeep"
            | "bell_sound"
            | "escalate"
            | "invasion"
            | "intrusive"
            | "pling"
            | "pling_high"
            | "pling_low"
            | "shake"
            | "silence"
            | "tf012"
            | "tf015"
            | "tf019"
            | "tf021"
            | "tf026"
            | "tf029"
            | "tf200"
            | "tf201"
            | "tf202"
            | "tf203"
            | "tf204"
            | "tf205"
            | "tf206"
            | "tf207"
            | "tf208"
            | "tf209"
            | "tf210"
            | "tf211"
            | "tf212"
            | "tf213"
            | "tf214"
            | "tf215"
            | "tf216"
            | "tf217"
            | "tf218"
            | "tf219"
            | "tf220"
            | "tf221"
            | "tf222"
            | "tf223"
            | "tf224"
            | "tf225"
            | "tf226"
            | "tf227"
            | "tf228"
            | "tf229"
            | "tf230"
            | "tornado"
            | "wakeup";
          /**
           * @min 0
           * @exclusiveMin false
           * @max 1
           * @exclusiveMax false
           */
          volume: number;
          loop: boolean;
          enabled: boolean;
          overrides: {
            sound?:
              | "alarm"
              | "alarmclock"
              | "beepbeep"
              | "bell_sound"
              | "escalate"
              | "invasion"
              | "intrusive"
              | "pling"
              | "pling_high"
              | "pling_low"
              | "shake"
              | "silence"
              | "tf012"
              | "tf015"
              | "tf019"
              | "tf021"
              | "tf026"
              | "tf029"
              | "tf200"
              | "tf201"
              | "tf202"
              | "tf203"
              | "tf204"
              | "tf205"
              | "tf206"
              | "tf207"
              | "tf208"
              | "tf209"
              | "tf210"
              | "tf211"
              | "tf212"
              | "tf213"
              | "tf214"
              | "tf215"
              | "tf216"
              | "tf217"
              | "tf218"
              | "tf219"
              | "tf220"
              | "tf221"
              | "tf222"
              | "tf223"
              | "tf224"
              | "tf225"
              | "tf226"
              | "tf227"
              | "tf228"
              | "tf229"
              | "tf230"
              | "tornado"
              | "wakeup";
            /**
             * @min 0
             * @exclusiveMin false
             * @max 1
             * @exclusiveMax false
             */
            volume?: number;
            loop?: boolean;
            enabled?: boolean;
            severity: "red" | "orange" | "green";
            type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
          }[];
        };
      };
      modal: {
        doubleConfirm: boolean;
      };
      map: {
        /**
         * @min 0
         * @exclusiveMin true
         */
        pxPadding: number;
        /**
         * @min 0
         * @exclusiveMin true
         */
        coordinatePadding: number;
        /**
         * @min 0
         * @exclusiveMin true
         */
        animationDuration: number;
        /**
         * @min 0
         * @exclusiveMin true
         */
        ownPositionMaxDistanceBounds: number;
      };
      acknowledgeAlarm: {
        instant: boolean;
        pages: (
          | {
              id: string;
              title: string;
              description?: string;
              visible: boolean;
              required?: boolean;
              buttons?: {
                id: string;
                variant:
                  | "white"
                  | "green"
                  | "blue"
                  | "yellow"
                  | "red"
                  | "whiteOutline"
                  | "greenOutline"
                  | "blueOutline"
                  | "yellowOutline"
                  | "redOutline";
                label: string;
              }[];
              type: "form";
              fields: (
                | {
                    id: string;
                    visible: boolean;
                    required: boolean;
                    type: "checkbox";
                    label: string;
                    defaultValue?: boolean;
                  }
                | {
                    id: string;
                    visible: boolean;
                    required: boolean;
                    type: "text";
                    label?: string;
                    placeholder?: string;
                    multiline?: boolean;
                    /**
                     * @min 0
                     * @exclusiveMin false
                     */
                    minLength?: number;
                    /**
                     * @min 0
                     * @exclusiveMin true
                     */
                    maxLength?: number;
                  }
                | {
                    id: string;
                    visible: boolean;
                    required: boolean;
                    type: "textarea";
                    label?: string;
                    placeholder?: string;
                    /**
                     * @min 0
                     * @exclusiveMin false
                     */
                    minLength?: number;
                    /**
                     * @min 0
                     * @exclusiveMin true
                     */
                    maxLength?: number;
                  }
                | {
                    id: string;
                    visible: boolean;
                    required: boolean;
                    type: "photo";
                    label: string;
                    /**
                     * @min 0
                     * @exclusiveMin false
                     */
                    minCount?: number;
                    /**
                     * @min 0
                     * @exclusiveMin true
                     */
                    maxCount?: number;
                  }
                | {
                    id: string;
                    visible: boolean;
                    required: boolean;
                    type: "select";
                    /** @minItems 1 */
                    options: {
                      value: string;
                      label: string;
                    }[];
                    multiple?: boolean;
                  }
                | {
                    id: string;
                    visible: boolean;
                    required: boolean;
                    type: "header";
                    value: string;
                  }
                | {
                    id: string;
                    visible: boolean;
                    required: boolean;
                    type: "description";
                    value: string;
                  }
              )[];
            }
          | {
              id: string;
              title: string;
              description?: string;
              visible: boolean;
              required?: boolean;
              buttons?: {
                id: string;
                variant:
                  | "white"
                  | "green"
                  | "blue"
                  | "yellow"
                  | "red"
                  | "whiteOutline"
                  | "greenOutline"
                  | "blueOutline"
                  | "yellowOutline"
                  | "redOutline";
                label: string;
              }[];
              type: "confirm";
              confirmLabel?: string;
            }
        )[];
        /**
         * @min 0
         * @exclusiveMin true
         */
        modalTimer: number;
      };
    };
    tokens: {
      mapboxRetry: {
        minWait: number;
        maxWait: number;
        factor: number;
      };
    };
    components: {
      hidden: {
        key:
          | "call.messages"
          | "call.mic"
          | "call.speaker"
          | "dashboard.alarmButtons"
          | "dashboard.alarmButtons.testCentre"
          | "dashboard.modeSwitch"
          | "dashboard.modeSwitch.available"
          | "dashboard.modeSwitch.available.off"
          | "dashboard.modeSwitch.available.on"
          | "dashboard.modeSwitch.mode"
          | "dashboard.modeSwitch.mode.off"
          | "dashboard.modeSwitch.mode.on"
          | "dashboard.modeSwitch.mode.risk"
          | "dashboard.quickMenu.evacuation"
          | "dashboard.quickMenu.incomingAlarms"
          | "dashboard.quickMenu.info"
          | "dashboard.quickMenu.logout"
          | "dashboard.quickMenu.profile"
          | "dashboard.quickMenu.settings"
          | "dashboard.quickMenu.support"
          | "dashboard.topBar"
          | "dashboard.topBar.logo"
          | "dashboard.topBar.quickMenuButton"
          | "hardwareButtons.add"
          | "hardwareButtons.flic.menu.advanced"
          | "hardwareButtons.flic.menu.delete"
          | "hardwareButtons.test"
          | "incomingAlarm.helpers.grid"
          | "incomingAlarm.helpers.total"
          | "incomingAlarm.helpers.unconfirmed"
          | "incomingAlarm.map.locationRow.alarm"
          | "incomingAlarm.map.locationRow.asset"
          | "incomingAlarm.map.marker.alarm"
          | "incomingAlarm.map.marker.asset"
          | "incomingAlarm.map.marker.own"
          | "incomingAlarm.map.overlays"
          | "incomingAlarm.summary.createdBy"
          | "incomingAlarm.summary.header"
          | "incomingAlarm.summary.image"
          | "incomingAlarm.summary.mapsLink"
          | "incomingAlarm.summary.position"
          | "incomingAlarmList.alarmCard.closeAlarm"
          | "incomingAlarmList.alarmCard.createdBy"
          | "incomingAlarmList.alarmCard.header"
          | "incomingAlarmList.alarmCard.helpers"
          | "incomingAlarmList.alarmCard.helpers.list"
          | "incomingAlarmList.alarmCard.helpers.total"
          | "incomingAlarmList.alarmCard.image"
          | "incomingAlarmList.alarmCard.map"
          | "incomingAlarmList.alarmCard.map.marker.alarm"
          | "incomingAlarmList.alarmCard.map.marker.asset"
          | "incomingAlarmList.alarmCard.map.marker.own"
          | "incomingAlarmList.alarmCard.map.overlays"
          | "incomingAlarmList.alarmCard.mapsLink"
          | "incomingAlarmList.alarmCard.position"
          | "incomingAlarmList.alarmCard.staticPosition"
          | "incomingAlarmList.closedAlarms"
          | "info.account"
          | "info.deviceInfo"
          | "info.licences"
          | "info.permissions"
          | "info.privacy"
          | "info.terms"
          | "info.updateApp"
          | "info.uploadLog"
          | "info.warnings"
          | "settings.addressList"
          | "settings.agenda"
          | "settings.alarmButtons"
          | "settings.contacts"
          | "settings.location"
          | "settings.mandown"
          | "settings.notifications";
        hidden: boolean;
      }[];
      disabled: {
        key:
          | "dashboard.modeSwitch.available.off"
          | "dashboard.modeSwitch.available.on"
          | "dashboard.modeSwitch.mode.off"
          | "dashboard.modeSwitch.mode.on"
          | "dashboard.modeSwitch.mode.risk";
        disabled: boolean;
      }[];
    };
    modes: {
      appMode: {
        needPermissionForUsage: boolean;
      };
      available: {
        needPermissionForUsage: boolean;
      };
    };
    mandown: {
      sensitivityMode: "low" | "medium" | "high";
      sensitivityChangePreAlarm: boolean;
      sensitivitySliderSettings: {
        /**
         * @min 0
         * @exclusiveMin false
         */
        minValue: number;
        /**
         * @min 0
         * @exclusiveMin true
         */
        maxValue: number;
        /**
         * @min 0
         * @exclusiveMin true
         */
        step: number;
        /**
         * @min 0
         * @exclusiveMin false
         */
        defaultValue: number;
      };
      /**
       * @min 0
       * @exclusiveMin true
       */
      sensorInterval: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      speedingFrom: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      timeBeforeOnFlat: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      onFlatOffSet: number;
      onFlatPause: boolean;
      onFlatMode: "up" | "down" | "both";
      onFlatPauseNotification: boolean;
      /**
       * @min 0
       * @exclusiveMin true
       */
      onFlatSpeedDifference: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      onFlatUnpauseMovementTime: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      onFlatUnpauseMovementTimeBetweenMovements: number;
      alarmMakeSound: boolean;
      alarmVibrate: boolean;
      alarmSendPush: boolean;
      confirmOff: boolean;
      /**
       * @min 0
       * @exclusiveMin true
       */
      confirmOffDuration: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      confirmDuration: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      duration: number;
      durationSliderSettings: {
        /**
         * @min 0
         * @exclusiveMin false
         */
        minValue: number;
        /**
         * @min 0
         * @exclusiveMin true
         */
        maxValue: number;
        /**
         * @min 0
         * @exclusiveMin true
         */
        step: number;
        /**
         * @min 0
         * @exclusiveMin false
         */
        defaultValue: number;
      };
      /**
       * @min 0
       * @exclusiveMin true
       */
      preAlarmSoundCriticalCount: number;
      cancelPreAlarmByMovement: boolean;
      cancelPreAlarmByShake: boolean;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pauseDuration: number;
      pauseDurationSliderSettings: {
        /**
         * @min 0
         * @exclusiveMin false
         */
        minValue: number;
        /**
         * @min 0
         * @exclusiveMin true
         */
        maxValue: number;
        /**
         * @min 0
         * @exclusiveMin true
         */
        step: number;
        /**
         * @min 0
         * @exclusiveMin false
         */
        defaultValue: number;
      };
      preAlarmSound: {
        sound:
          | "alarm"
          | "alarmclock"
          | "beepbeep"
          | "bell_sound"
          | "escalate"
          | "invasion"
          | "intrusive"
          | "pling"
          | "pling_high"
          | "pling_low"
          | "shake"
          | "silence"
          | "tf012"
          | "tf015"
          | "tf019"
          | "tf021"
          | "tf026"
          | "tf029"
          | "tf200"
          | "tf201"
          | "tf202"
          | "tf203"
          | "tf204"
          | "tf205"
          | "tf206"
          | "tf207"
          | "tf208"
          | "tf209"
          | "tf210"
          | "tf211"
          | "tf212"
          | "tf213"
          | "tf214"
          | "tf215"
          | "tf216"
          | "tf217"
          | "tf218"
          | "tf219"
          | "tf220"
          | "tf221"
          | "tf222"
          | "tf223"
          | "tf224"
          | "tf225"
          | "tf226"
          | "tf227"
          | "tf228"
          | "tf229"
          | "tf230"
          | "tornado"
          | "wakeup";
        /**
         * @min 0
         * @exclusiveMin false
         * @max 1
         * @exclusiveMax false
         */
        volume: number;
        loop: boolean;
        enabled: boolean;
      };
      /**
       * @min 0
       * @exclusiveMin true
       */
      keepAliveSchedule: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      keepAlivePauseSchedule: number;
      movingAverageSensitivityValues: {
        android: {
          low: {
            average: number;
            measureLength: number;
            nonMovement: number;
            sensorInterval: number;
            vibrateCounter: number;
          };
          medium: {
            average: number;
            measureLength: number;
            nonMovement: number;
            sensorInterval: number;
            vibrateCounter: number;
          };
          high: {
            average: number;
            measureLength: number;
            nonMovement: number;
            sensorInterval: number;
            vibrateCounter: number;
          };
        };
        ios: {
          low: {
            average: number;
            measureLength: number;
            nonMovement: number;
            sensorInterval: number;
            vibrateCounter: number;
          };
          medium: {
            average: number;
            measureLength: number;
            nonMovement: number;
            sensorInterval: number;
            vibrateCounter: number;
          };
          high: {
            average: number;
            measureLength: number;
            nonMovement: number;
            sensorInterval: number;
            vibrateCounter: number;
          };
        };
      };
      movingAverageSensitivityPreAlarmValues: {
        android: {
          low: {
            average: number;
            measureLength: number;
            nonMovement: number;
            sensorInterval: number;
            vibrateCounter: number;
          };
          medium: {
            average: number;
            measureLength: number;
            nonMovement: number;
            sensorInterval: number;
            vibrateCounter: number;
          };
          high: {
            average: number;
            measureLength: number;
            nonMovement: number;
            sensorInterval: number;
            vibrateCounter: number;
          };
        };
        ios: {
          low: {
            average: number;
            measureLength: number;
            nonMovement: number;
            sensorInterval: number;
            vibrateCounter: number;
          };
          medium: {
            average: number;
            measureLength: number;
            nonMovement: number;
            sensorInterval: number;
            vibrateCounter: number;
          };
          high: {
            average: number;
            measureLength: number;
            nonMovement: number;
            sensorInterval: number;
            vibrateCounter: number;
          };
        };
      };
      sensitivityPreAlarmValues: {
        android: {
          low: number;
          medium: number;
          high: number;
        };
        ios: {
          low: number;
          medium: number;
          high: number;
        };
      };
      sensitivityValues: {
        android: {
          low: number;
          medium: number;
          high: number;
        };
        ios: {
          low: number;
          medium: number;
          high: number;
        };
      };
    };
    location: {
      positionAppStateMode: "availabilityOnly" | "tracking";
      positionUpdateMode: "static" | "foregroundOnly" | "always";
      positionUpdateRate: "lowest" | "slow" | "normal" | "fast" | "continuous";
      config: {
        geolocation: {
          allowIdenticalLocations?: boolean;
          /**
           * @min 0
           * @exclusiveMin false
           */
          deferTime?: number;
          desiredAccuracy?: number;
          disableElasticity?: boolean;
          disableLocationAuthorizationAlert?: boolean;
          distanceFilter?: number;
          elasticityMultiplier?: number;
          enableTimestampMeta?: boolean;
          fastestLocationUpdateInterval?: number;
          stationaryRadius?: number;
          stopTimeout?: number;
          stopAfterElapsedMinutes?: number;
          geofenceProximityRadius?: number;
          geofenceInitialTriggerEntry?: boolean;
          geofenceModeHighAccuracy?: boolean;
          locationAuthorizationRequest?: "WhenInUse" | "Always" | "Any";
          locationUpdateInterval?: number;
          pausesLocationUpdatesAutomatically?: boolean;
          showsBackgroundLocationIndicator?: boolean;
          activityType?: number;
          useSignificantChangesOnly?: boolean;
          filter: {
            burstWindow?: number;
            filterDebug?: boolean;
            kalmanDebug?: boolean;
            kalmanProfile?: "0" | "1" | "2";
            maxBurstDistance?: number;
            maxImpliedSpeed?: number;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 500
             * @exclusiveMax false
             */
            odometerAccuracyThreshold?: number;
            odometerUseKalmanFilter?: boolean;
            policy?: "0" | "1" | "2";
            /**
             * @min 3
             * @exclusiveMin false
             * @max 20
             * @exclusiveMax false
             */
            rollingWindow?: number;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 500
             * @exclusiveMax false
             */
            trackingAccuracyThreshold?: number;
            useKalman?: boolean;
          };
          disableStopDetection?: boolean;
          stopOnStationary?: boolean;
        };
        app: {
          stopOnTerminate?: boolean;
          startOnBoot?: boolean;
          enableHeadless?: boolean;
          heartbeatInterval?: number;
          schedule?: string[];
          scheduleUseAlarmManager?: boolean;
          preventSuspend?: boolean;
          notification: {
            actions?: string[];
            channelId?: string;
            channelName?: string;
            color?: string;
            largeIcon?: string;
            layout?: string;
            /**
             * @min -2
             * @exclusiveMin false
             * @max 2
             * @exclusiveMax false
             */
            priority?: number;
            smallIcon?: string;
            sticky?: boolean;
            text?: string;
            title?: string;
          };
          backgroundPermissionRationale: {
            title?: string;
            message?: string;
            nativeAction?: string;
            positiveAction?: string;
          };
        };
        logger: {
          debug?: boolean;
          logLevel?: number;
          logMaxDays?: number;
        };
        activity: {
          /**
           * @min 500
           * @exclusiveMin false
           */
          activityRecognitionInterval?: number;
          motionTriggerDelay?: number;
          triggerActivities?:
            | "walking"
            | "on_foot"
            | "running"
            | "on_bicycle"
            | "in_vehicle"
            | ("walking" | "on_foot" | "running" | "on_bicycle" | "in_vehicle")[];
          disableMotionActivityUpdates?: boolean;
          stopDetectionDelay?: number;
          disableStopDetection?: boolean;
          /**
           * @min 0
           * @exclusiveMin false
           * @max 100
           * @exclusiveMax false
           */
          minimumActivityRecognitionConfidence?: number;
          stopOnStationary?: boolean;
        };
        persistence: {
          persistMode?: number;
          maxRecordsToPersist?: number;
          locationsOrderDirection?: "ASC" | "DESC";
          disableProviderChangeRecord?: boolean;
        };
        reset?: boolean;
      };
      configOverrides: {
        config: {
          geolocation?: {
            allowIdenticalLocations?: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             */
            deferTime?: number;
            desiredAccuracy?: number;
            disableElasticity?: boolean;
            disableLocationAuthorizationAlert?: boolean;
            distanceFilter?: number;
            elasticityMultiplier?: number;
            enableTimestampMeta?: boolean;
            fastestLocationUpdateInterval?: number;
            stationaryRadius?: number;
            stopTimeout?: number;
            stopAfterElapsedMinutes?: number;
            geofenceProximityRadius?: number;
            geofenceInitialTriggerEntry?: boolean;
            geofenceModeHighAccuracy?: boolean;
            locationAuthorizationRequest?: "WhenInUse" | "Always" | "Any";
            locationUpdateInterval?: number;
            pausesLocationUpdatesAutomatically?: boolean;
            showsBackgroundLocationIndicator?: boolean;
            activityType?: number;
            useSignificantChangesOnly?: boolean;
            filter: {
              burstWindow?: number;
              filterDebug?: boolean;
              kalmanDebug?: boolean;
              kalmanProfile?: "0" | "1" | "2";
              maxBurstDistance?: number;
              maxImpliedSpeed?: number;
              /**
               * @min 0
               * @exclusiveMin false
               * @max 500
               * @exclusiveMax false
               */
              odometerAccuracyThreshold?: number;
              odometerUseKalmanFilter?: boolean;
              policy?: "0" | "1" | "2";
              /**
               * @min 3
               * @exclusiveMin false
               * @max 20
               * @exclusiveMax false
               */
              rollingWindow?: number;
              /**
               * @min 0
               * @exclusiveMin false
               * @max 500
               * @exclusiveMax false
               */
              trackingAccuracyThreshold?: number;
              useKalman?: boolean;
            };
            disableStopDetection?: boolean;
            stopOnStationary?: boolean;
          };
          app?: {
            stopOnTerminate?: boolean;
            startOnBoot?: boolean;
            enableHeadless?: boolean;
            heartbeatInterval?: number;
            schedule?: string[];
            scheduleUseAlarmManager?: boolean;
            preventSuspend?: boolean;
            notification: {
              actions?: string[];
              channelId?: string;
              channelName?: string;
              color?: string;
              largeIcon?: string;
              layout?: string;
              /**
               * @min -2
               * @exclusiveMin false
               * @max 2
               * @exclusiveMax false
               */
              priority?: number;
              smallIcon?: string;
              sticky?: boolean;
              text?: string;
              title?: string;
            };
            backgroundPermissionRationale: {
              title?: string;
              message?: string;
              nativeAction?: string;
              positiveAction?: string;
            };
          };
          logger?: {
            debug?: boolean;
            logLevel?: number;
            logMaxDays?: number;
          };
          activity?: {
            /**
             * @min 500
             * @exclusiveMin false
             */
            activityRecognitionInterval?: number;
            motionTriggerDelay?: number;
            triggerActivities?:
              | "walking"
              | "on_foot"
              | "running"
              | "on_bicycle"
              | "in_vehicle"
              | ("walking" | "on_foot" | "running" | "on_bicycle" | "in_vehicle")[];
            disableMotionActivityUpdates?: boolean;
            stopDetectionDelay?: number;
            disableStopDetection?: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            minimumActivityRecognitionConfidence?: number;
            stopOnStationary?: boolean;
          };
          persistence?: {
            persistMode?: number;
            maxRecordsToPersist?: number;
            locationsOrderDirection?: "ASC" | "DESC";
            disableProviderChangeRecord?: boolean;
          };
          reset?: boolean;
        };
        type:
          | "availability_only_always_lowest"
          | "availability_only_always_slow"
          | "availability_only_always_normal"
          | "availability_only_always_fast"
          | "availability_only_always_continuous"
          | "availability_only_foreground"
          | "tracking_always_lowest"
          | "tracking_always_slow"
          | "tracking_always_normal"
          | "tracking_always_fast"
          | "tracking_always_continuous"
          | "tracking_foreground";
      }[];
      request: {
        normal: {
          /**
           * @min 0
           * @exclusiveMin false
           */
          maximumAge?: number;
          persist?: boolean;
          desiredAccuracy?: number;
          samples?: number;
          /**
           * @min 0
           * @exclusiveMin true
           */
          timeout?: number;
        };
        alarm: {
          /**
           * @min 0
           * @exclusiveMin false
           */
          maximumAge?: number;
          persist?: boolean;
          desiredAccuracy?: number;
          samples?: number;
          /**
           * @min 0
           * @exclusiveMin true
           */
          timeout?: number;
        };
      };
    };
    feedback: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      shakeCount: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      maxLastShakeTime: number;
    };
    geofence: {
      geofences: (
        | {
            type: "circle";
            identifier: string;
            /**
             * @min 200
             * @exclusiveMin false
             */
            radius: number;
            /**
             * @min -90
             * @exclusiveMin false
             * @max 90
             * @exclusiveMax false
             */
            latitude: number;
            /**
             * @min -180
             * @exclusiveMin false
             * @max 180
             * @exclusiveMax false
             */
            longitude: number;
            label: string;
            textual: string;
          }
        | {
            type: "polygon";
            identifier: string;
            /** @minItems 3 */
            vertices: number[][];
            label: string;
            textual: string;
          }
      )[];
      /**
       * @min 200
       * @exclusiveMin false
       */
      radius: number;
      dwell: {
        enabled: boolean;
        /**
         * @min 200
         * @exclusiveMin false
         */
        radius: number;
      };
      notification: {
        onBuild: boolean;
        onEnter: boolean;
        onExit: boolean;
        onDwell: boolean;
      };
    };
    scaling: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      referenceWidth: number;
      /**
       * @min 0
       * @exclusiveMin true
       */
      referenceHeight: number;
      units: {
        key:
          | "xxs"
          | "xs"
          | "sm"
          | "md"
          | "lg"
          | "xl"
          | "iconXs"
          | "iconSm"
          | "iconMd"
          | "iconLg"
          | "iconXl"
          | "iconXXl"
          | "fontXl"
          | "fontLg"
          | "fontMd"
          | "fontSm"
          | "fontXs";
        unit: {
          type: "hwScale";
          factor: number;
          size: number;
        };
      }[];
    };
    palettes: {
      sizes: {
        headerFont: number;
        normalFont: number;
        underLineFont: number;
        maxFontScale: number;
      };
      opacities: {
        lower: number;
        low: number;
        medium: number;
        high: number;
      };
      xguard: {
        light: {
          colors: {
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            appBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            appHeaderBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            appHeaderColor: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            overlayBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            overlayColor: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            divider: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            inputBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            text: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            lightText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeBgDark: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeColor: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeLightText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeHr: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            togglesBackground: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleOff: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleOffText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleOn: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleOnText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleRisk: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleRiskText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            panelBackground: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            panelBorder: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            qrCodeMask: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonWhiteBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonWhiteBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonWhiteText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonGreenBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonGreenBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonGreenText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonBlueBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonBlueBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonBlueText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonYellowBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonYellowBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonYellowText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonOrangeBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonOrangeBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonOrangeText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonRedBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonRedBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonRedText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageNeutralBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageNeutralBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageNeutralText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageGreenBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageGreenBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageGreenText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageBlueBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageBlueBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageBlueText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageYellowBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageYellowBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageYellowText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageOrangeBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageOrangeBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageOrangeText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageRedBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageRedBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageRedText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            loginHeaderBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            shadowColor: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor1: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor2: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor3: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor4: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor5: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor6: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor7: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor8: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor9: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor10: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor11: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor12: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor13: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor14: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor15: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            iconLight: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            iconDark: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            icon1: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            icon2: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            icon3: string;
          };
          logos: {
            tradeMark: string;
            horizontalPayoff: string;
            horizontal: string;
            vertical: string;
            verticalPayoff: string;
            appName: string;
          };
        };
        dark: {
          colors: {
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            appBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            appHeaderBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            appHeaderColor: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            overlayBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            overlayColor: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            divider: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            inputBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            text: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            lightText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeBgDark: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeColor: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeLightText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeHr: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            togglesBackground: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleOff: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleOffText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleOn: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleOnText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleRisk: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleRiskText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            panelBackground: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            panelBorder: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            qrCodeMask: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonWhiteBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonWhiteBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonWhiteText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonGreenBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonGreenBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonGreenText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonBlueBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonBlueBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonBlueText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonYellowBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonYellowBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonYellowText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonOrangeBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonOrangeBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonOrangeText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonRedBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonRedBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonRedText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageNeutralBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageNeutralBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageNeutralText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageGreenBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageGreenBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageGreenText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageBlueBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageBlueBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageBlueText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageYellowBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageYellowBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageYellowText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageOrangeBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageOrangeBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageOrangeText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageRedBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageRedBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageRedText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            loginHeaderBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            shadowColor: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor1: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor2: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor3: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor4: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor5: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor6: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor7: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor8: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor9: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor10: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor11: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor12: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor13: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor14: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor15: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            iconLight: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            iconDark: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            icon1: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            icon2: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            icon3: string;
          };
          logos: {
            tradeMark: string;
            horizontalPayoff: string;
            horizontal: string;
            vertical: string;
            verticalPayoff: string;
            appName: string;
          };
        };
      };
      bhvknop: {
        light: {
          colors: {
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            appBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            appHeaderBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            appHeaderColor: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            overlayBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            overlayColor: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            divider: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            inputBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            text: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            lightText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeBgDark: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeColor: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeLightText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeHr: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            togglesBackground: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleOff: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleOffText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleOn: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleOnText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleRisk: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleRiskText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            panelBackground: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            panelBorder: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            qrCodeMask: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonWhiteBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonWhiteBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonWhiteText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonGreenBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonGreenBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonGreenText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonBlueBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonBlueBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonBlueText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonYellowBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonYellowBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonYellowText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonOrangeBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonOrangeBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonOrangeText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonRedBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonRedBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonRedText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageNeutralBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageNeutralBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageNeutralText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageGreenBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageGreenBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageGreenText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageBlueBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageBlueBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageBlueText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageYellowBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageYellowBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageYellowText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageOrangeBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageOrangeBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageOrangeText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageRedBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageRedBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageRedText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            loginHeaderBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            shadowColor: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor1: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor2: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor3: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor4: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor5: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor6: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor7: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor8: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor9: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor10: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor11: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor12: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor13: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor14: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor15: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            iconLight: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            iconDark: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            icon1: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            icon2: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            icon3: string;
          };
          logos: {
            tradeMark: string;
            horizontalPayoff: string;
            horizontal: string;
            vertical: string;
            verticalPayoff: string;
            appName: string;
          };
        };
        dark: {
          colors: {
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            appBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            appHeaderBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            appHeaderColor: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            overlayBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            overlayColor: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            divider: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            inputBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            text: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            lightText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeBgDark: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeColor: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeLightText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            alternativeHr: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            togglesBackground: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleOff: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleOffText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleOn: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleOnText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleRisk: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            toggleRiskText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            panelBackground: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            panelBorder: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            qrCodeMask: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonWhiteBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonWhiteBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonWhiteText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonGreenBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonGreenBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonGreenText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonBlueBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonBlueBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonBlueText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonYellowBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonYellowBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonYellowText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonOrangeBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonOrangeBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonOrangeText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonRedBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonRedBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            buttonRedText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageNeutralBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageNeutralBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageNeutralText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageGreenBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageGreenBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageGreenText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageBlueBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageBlueBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageBlueText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageYellowBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageYellowBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageYellowText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageOrangeBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageOrangeBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageOrangeText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageRedBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageRedBgHover: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            messageRedText: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            loginHeaderBg: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            shadowColor: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor1: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor2: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor3: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor4: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor5: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor6: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor7: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor8: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor9: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor10: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor11: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor12: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor13: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor14: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            chatColor15: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            iconLight: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            iconDark: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            icon1: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            icon2: string;
            /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
            icon3: string;
          };
          logos: {
            tradeMark: string;
            horizontalPayoff: string;
            horizontal: string;
            vertical: string;
            verticalPayoff: string;
            appName: string;
          };
        };
      };
    };
    call: {
      alarm: {
        onSpeaker: boolean;
        muted: boolean;
        enabled: boolean;
        overrides: {
          onSpeaker?: boolean;
          muted?: boolean;
          enabled?: boolean;
          severity: "red" | "orange" | "green";
          type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
        }[];
        showCallTimer: boolean;
        /**
         * @min 0
         * @exclusiveMin true
         */
        showHangupButtonTimer: number;
      };
      helper: {
        onSpeaker: boolean;
        muted: boolean;
        enabled: boolean;
        overrides: {
          onSpeaker?: boolean;
          muted?: boolean;
          enabled?: boolean;
          severity: "red" | "orange" | "green";
          type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
        }[];
        ptt: {
          mode: "oneByOne" | "openCall" | "pttMess";
          permission: "listen" | "speak" | "overrule";
          swipeToLockMyCurrentPttSession: boolean;
          openCallDefaultMuted: boolean;
        };
        chat: {
          /**
           * @min 0
           * @exclusiveMin true
           */
          sendHeartbeatThrottle: number;
          /**
           * @min 0
           * @exclusiveMin true
           */
          sendCancelFromInactivityTimeout: number;
          /**
           * @min 0
           * @exclusiveMin true
           */
          startedChatMaxHeartbeatAge: number;
          /**
           * @min 0
           * @exclusiveMin true
           */
          startedAudioMaxHeartbeatAge: number;
        };
        audioRecording: {
          file: {
            /**
             * @min 0
             * @exclusiveMin true
             */
            sampleRate: number;
            bitDepth: "bit16" | "bit24" | "bit32";
            /**
             * @min 0
             * @exclusiveMin true
             */
            bitRate: number;
            iosQuality: "min" | "low" | "medium" | "high" | "max";
            /**
             * @min 0
             * @exclusiveMin true
             */
            channelCount: number;
          };
          /**
           * @min 0
           * @exclusiveMin true
           */
          minRecordingDuration: number;
        };
      };
    };
    permissions: {
      calendar: {
        severity: "red" | "yellow" | "none";
        platform: "android" | "ios" | "both";
      };
      camera: {
        severity: "red" | "yellow" | "none";
        platform: "android" | "ios" | "both";
      };
      contacts: {
        severity: "red" | "yellow" | "none";
        platform: "android" | "ios" | "both";
      };
      locationAlways: {
        severity: "red" | "yellow" | "none";
        platform: "android" | "ios" | "both";
      };
      locationWhenInUse: {
        severity: "red" | "yellow" | "none";
        platform: "android" | "ios" | "both";
      };
      microphone: {
        severity: "red" | "yellow" | "none";
        platform: "android" | "ios" | "both";
      };
      notification: {
        severity: "red" | "yellow" | "none";
        platform: "android" | "ios" | "both";
      };
      criticalNotification: {
        severity: "red" | "yellow" | "none";
        platform: "android" | "ios" | "both";
      };
      motion: {
        severity: "red" | "yellow" | "none";
        platform: "android" | "ios" | "both";
      };
      bluetooth: {
        severity: "red" | "yellow" | "none";
        platform: "android" | "ios" | "both";
      };
      physical: {
        severity: "red" | "yellow" | "none";
        platform: "android" | "ios" | "both";
      };
      overlay: {
        severity: "red" | "yellow" | "none";
        platform: "android" | "ios" | "both";
      };
      batteryOptimization: {
        severity: "red" | "yellow" | "none";
        platform: "android" | "ios" | "both";
      };
    };
    externalAlarmButtons: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      testButtonCloseDelay: number;
      buttons: {
        type: "flic";
        id: string;
        label?: string;
        advancedEnabled: boolean;
        /**
         * @min 0
         * @exclusiveMin true
         */
        maxEventAge?: number;
        notifications?: {
          connect: {
            enabled?: boolean;
            onlyInModesOn?: boolean;
            /**
             * @min 0
             * @exclusiveMin true
             */
            delay?: number;
          };
          disconnect: {
            enabled?: boolean;
            onlyInModesOn?: boolean;
            /**
             * @min 0
             * @exclusiveMin true
             */
            delay?: number;
          };
          alarm: boolean;
          batteryLow: boolean;
        };
        forceHoldConfig?: {
          enabled: boolean;
          /**
           * @min 0
           * @exclusiveMin true
           */
          count: number;
          /**
           * @min 0
           * @exclusiveMin true
           */
          duration: number;
        };
        alarmClickConfig?: {
          severity: "red" | "orange" | "green";
          type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
          overrideColor?: "green" | "blue" | "yellow" | "orange" | "red";
          overrideLabel?: string;
          allowWhenOff?: boolean;
          enabled: boolean;
          sound?: {
            sound:
              | "alarm"
              | "alarmclock"
              | "beepbeep"
              | "bell_sound"
              | "escalate"
              | "invasion"
              | "intrusive"
              | "pling"
              | "pling_high"
              | "pling_low"
              | "shake"
              | "silence"
              | "tf012"
              | "tf015"
              | "tf019"
              | "tf021"
              | "tf026"
              | "tf029"
              | "tf200"
              | "tf201"
              | "tf202"
              | "tf203"
              | "tf204"
              | "tf205"
              | "tf206"
              | "tf207"
              | "tf208"
              | "tf209"
              | "tf210"
              | "tf211"
              | "tf212"
              | "tf213"
              | "tf214"
              | "tf215"
              | "tf216"
              | "tf217"
              | "tf218"
              | "tf219"
              | "tf220"
              | "tf221"
              | "tf222"
              | "tf223"
              | "tf224"
              | "tf225"
              | "tf226"
              | "tf227"
              | "tf228"
              | "tf229"
              | "tf230"
              | "tornado"
              | "wakeup";
            /**
             * @min 0
             * @exclusiveMin false
             * @max 1
             * @exclusiveMax false
             */
            volume: number;
            loop: boolean;
            enabled: boolean;
          };
        };
        alarmDoubleClickConfig?: {
          severity: "red" | "orange" | "green";
          type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
          overrideColor?: "green" | "blue" | "yellow" | "orange" | "red";
          overrideLabel?: string;
          allowWhenOff?: boolean;
          enabled: boolean;
          sound?: {
            sound:
              | "alarm"
              | "alarmclock"
              | "beepbeep"
              | "bell_sound"
              | "escalate"
              | "invasion"
              | "intrusive"
              | "pling"
              | "pling_high"
              | "pling_low"
              | "shake"
              | "silence"
              | "tf012"
              | "tf015"
              | "tf019"
              | "tf021"
              | "tf026"
              | "tf029"
              | "tf200"
              | "tf201"
              | "tf202"
              | "tf203"
              | "tf204"
              | "tf205"
              | "tf206"
              | "tf207"
              | "tf208"
              | "tf209"
              | "tf210"
              | "tf211"
              | "tf212"
              | "tf213"
              | "tf214"
              | "tf215"
              | "tf216"
              | "tf217"
              | "tf218"
              | "tf219"
              | "tf220"
              | "tf221"
              | "tf222"
              | "tf223"
              | "tf224"
              | "tf225"
              | "tf226"
              | "tf227"
              | "tf228"
              | "tf229"
              | "tf230"
              | "tornado"
              | "wakeup";
            /**
             * @min 0
             * @exclusiveMin false
             * @max 1
             * @exclusiveMax false
             */
            volume: number;
            loop: boolean;
            enabled: boolean;
          };
        };
        alarmHoldConfig?: {
          severity: "red" | "orange" | "green";
          type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
          overrideColor?: "green" | "blue" | "yellow" | "orange" | "red";
          overrideLabel?: string;
          allowWhenOff?: boolean;
          enabled: boolean;
          sound?: {
            sound:
              | "alarm"
              | "alarmclock"
              | "beepbeep"
              | "bell_sound"
              | "escalate"
              | "invasion"
              | "intrusive"
              | "pling"
              | "pling_high"
              | "pling_low"
              | "shake"
              | "silence"
              | "tf012"
              | "tf015"
              | "tf019"
              | "tf021"
              | "tf026"
              | "tf029"
              | "tf200"
              | "tf201"
              | "tf202"
              | "tf203"
              | "tf204"
              | "tf205"
              | "tf206"
              | "tf207"
              | "tf208"
              | "tf209"
              | "tf210"
              | "tf211"
              | "tf212"
              | "tf213"
              | "tf214"
              | "tf215"
              | "tf216"
              | "tf217"
              | "tf218"
              | "tf219"
              | "tf220"
              | "tf221"
              | "tf222"
              | "tf223"
              | "tf224"
              | "tf225"
              | "tf226"
              | "tf227"
              | "tf228"
              | "tf229"
              | "tf230"
              | "tornado"
              | "wakeup";
            /**
             * @min 0
             * @exclusiveMin false
             * @max 1
             * @exclusiveMax false
             */
            volume: number;
            loop: boolean;
            enabled: boolean;
          };
        };
      }[];
      notifications: {
        connect: {
          enabled: boolean;
          onlyInModesOn: boolean;
          /**
           * @min 0
           * @exclusiveMin true
           */
          delay: number;
        };
        disconnect: {
          enabled: boolean;
          onlyInModesOn: boolean;
          /**
           * @min 0
           * @exclusiveMin true
           */
          delay: number;
        };
        alarm: boolean;
        batteryLow: boolean;
      };
      forceHoldConfig: {
        enabled: boolean;
        /**
         * @min 0
         * @exclusiveMin true
         */
        count: number;
        /**
         * @min 0
         * @exclusiveMin true
         */
        duration: number;
      };
      preAlarm: {
        enabled: boolean;
        sound: {
          sound:
            | "alarm"
            | "alarmclock"
            | "beepbeep"
            | "bell_sound"
            | "escalate"
            | "invasion"
            | "intrusive"
            | "pling"
            | "pling_high"
            | "pling_low"
            | "shake"
            | "silence"
            | "tf012"
            | "tf015"
            | "tf019"
            | "tf021"
            | "tf026"
            | "tf029"
            | "tf200"
            | "tf201"
            | "tf202"
            | "tf203"
            | "tf204"
            | "tf205"
            | "tf206"
            | "tf207"
            | "tf208"
            | "tf209"
            | "tf210"
            | "tf211"
            | "tf212"
            | "tf213"
            | "tf214"
            | "tf215"
            | "tf216"
            | "tf217"
            | "tf218"
            | "tf219"
            | "tf220"
            | "tf221"
            | "tf222"
            | "tf223"
            | "tf224"
            | "tf225"
            | "tf226"
            | "tf227"
            | "tf228"
            | "tf229"
            | "tf230"
            | "tornado"
            | "wakeup";
          /**
           * @min 0
           * @exclusiveMin false
           * @max 1
           * @exclusiveMax false
           */
          volume: number;
          loop: boolean;
          enabled: boolean;
        };
        /**
         * @min 0
         * @exclusiveMin true
         */
        duration: number;
      };
    };
  };
  definition: {
    key: string;
    editableBy?: ("Customer" | "AssetGroup" | "Device")[];
    mergeHistory: (
      | {
          success: boolean;
          sources: (
            | {
                /** @format uuid */
                _id: string;
                _ref: "ClientConfigKey";
              }
            | {
                /** @format uuid */
                _id: string;
                _ref: "ClientConfigGroup";
              }
            | (
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "Device";
                  }
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  }
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }
              )
          )[];
          value: any;
          editableBy?: ("Customer" | "AssetGroup" | "Device")[];
        }
      | {
          success: boolean;
          sources: (
            | {
                /** @format uuid */
                _id: string;
                _ref: "ClientConfigKey";
              }
            | {
                /** @format uuid */
                _id: string;
                _ref: "ClientConfigGroup";
              }
            | (
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "Device";
                  }
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  }
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }
              )
          )[];
          error: any;
        }
    )[];
    schema?: any;
  }[];
}

export interface ClientConfigResolveKioskV0Dto {
  config: {
    managed: boolean;
    zone: {
      /** @format uuid */
      _id: string;
      _ref: "Zone";
    } | null;
    exposeAssets:
      | {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[]
      | null;
    exposeLabels:
      | {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
          countLabel?: boolean;
        }[]
      | null;
    schedule:
      | {
          daysOfWeek: number[];
          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
          timeStart: string;
          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
          timeEnd: string;
        }[]
      | null;
    homepage: {
      incidentCounter: {
        enabled: boolean;
        /** @format date-time */
        countFromDate: string | null;
        /**
         * @min 0
         * @exclusiveMin false
         */
        threshold: number;
      };
      anonymous: boolean;
      /** @format uri */
      logo: string | null;
    };
    alarm: {
      enabled: boolean;
      focus: {
        severity: "red" | "orange" | "green";
        flash: boolean;
        sound: {
          enabled: boolean;
          /**
           * @min 0
           * @exclusiveMin false
           * @max 100
           * @exclusiveMax false
           */
          volume?: number | null;
          sound?:
            | "alarm"
            | "alarmClock"
            | "alarmRetro"
            | "announcement"
            | "attention"
            | "bassPulse"
            | "beepBeep"
            | "beepBurglar"
            | "beepContinuous"
            | "beepHighSoft"
            | "beepIncremental"
            | "bell"
            | "car"
            | "chickens"
            | "chime"
            | "chirpSoft"
            | "clockMelody"
            | "countdownSonar"
            | "doorbell"
            | "escalate"
            | "fancy"
            | "fastAndNervous"
            | "harp"
            | "incomingPhone"
            | "introduction"
            | "intrusive"
            | "invasion"
            | "jungle"
            | "lofiChords"
            | "loopLow"
            | "melodySoft"
            | "notifySubtle"
            | "onOff"
            | "orchestral"
            | "pling"
            | "plingHigh"
            | "plingLow"
            | "pluckSong"
            | "quick"
            | "scanning"
            | "shake"
            | "silence"
            | "sirenHigh"
            | "sirenLow"
            | "soft"
            | "spaceship"
            | "startup"
            | "threeTones"
            | "tornado"
            | "wailing"
            | "wakeup"
            | null;
          /**
           * @min 0
           * @exclusiveMin false
           */
          stopAfterSeconds?: number | null;
          stopAfterTouch?: boolean | null;
        };
      }[];
      showPositionLabels: boolean;
      anonymous: boolean;
      acknowledge: {
        enabled: boolean;
        /** @pattern ^[0-9]{4,6}$ */
        pin: string | null;
        messagePresets: string[] | null;
      };
      /** @default "customerBased" */
      mode?: "zoneBased" | "customerBased";
    };
    manageAvailability: {
      enabled: boolean;
      /** @pattern ^[0-9]{4,6}$ */
      pin: string | null;
      showAppBanner: boolean;
      forceShowSearch: boolean;
      forceShowLabelFilter: boolean;
    };
    hardware: {
      /**
       * @min 0
       * @exclusiveMin false
       * @max 100
       * @exclusiveMax false
       * @default 100
       */
      screenBrightness?: number;
    };
    visitorMode: {
      enableVisitorMode: boolean;
      visitorEnabledHomepage: {
        displayFastCheckInInstruction: boolean;
      };
      visitorCheckInOptions: {
        enableKeyboardCheckin: boolean;
      };
      visitorCheckInForm: {
        requireVisitorCompany: boolean;
        requireVisitDuration: boolean;
      };
      visitorWelcomeScreen: {
        heading: string | null;
        subheading: string | null;
        displayHostNotificationConfirmation: boolean;
        /**
         * @min 10
         * @exclusiveMin false
         * @max 120
         * @exclusiveMax false
         */
        screenDuration: number;
      };
      visitorExitScreen: {
        heading: string | null;
        subheading: string | null;
        /**
         * @min 10
         * @exclusiveMin false
         * @max 120
         * @exclusiveMax false
         */
        screenDuration: number;
      };
    };
  };
  definition: {
    key: string;
    editableBy?: ("Customer" | "AssetGroup" | "Device")[];
    mergeHistory: (
      | {
          success: boolean;
          sources: (
            | {
                /** @format uuid */
                _id: string;
                _ref: "ClientConfigKey";
              }
            | {
                /** @format uuid */
                _id: string;
                _ref: "ClientConfigGroup";
              }
            | (
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "Device";
                  }
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  }
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }
              )
          )[];
          value: any;
          editableBy?: ("Customer" | "AssetGroup" | "Device")[];
        }
      | {
          success: boolean;
          sources: (
            | {
                /** @format uuid */
                _id: string;
                _ref: "ClientConfigKey";
              }
            | {
                /** @format uuid */
                _id: string;
                _ref: "ClientConfigGroup";
              }
            | (
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "Device";
                  }
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  }
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }
              )
          )[];
          error: any;
        }
    )[];
    schema?: any;
  }[];
}

export interface ClientConfigUpdateAppV0Dto {
  clear?: boolean;
  index?: number;
  setKeys?: {
    "websocket.swapInterval"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "websocket.connectTimeout.minWait"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "websocket.connectTimeout.maxWait"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "websocket.connectTimeout.factor"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "websocket.connectRetry.minWait"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "websocket.connectRetry.maxWait"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "websocket.connectRetry.factor"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "agenda.enabled"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "agenda.syncTTL"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "agenda.eventTimeMargin"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "agenda.eventMaxDistance"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "agenda.syncFullTime"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "agenda.microsoftClientId"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "agenda.readMethod"?: {
      value: "classic" | "day" | "sync";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "agenda.agendas"?: {
      value: {
        type: "microsoft" | "internal";
        id: string;
      }[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "address.radius.minValue"?: {
      /**
       * @min 0
       * @exclusiveMin false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "address.radius.maxValue"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "address.radius.step"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "address.radius.defaultValue"?: {
      /**
       * @min 0
       * @exclusiveMin false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "address.temporaryAddressDuration.minValue"?: {
      /**
       * @min 0
       * @exclusiveMin false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "address.temporaryAddressDuration.maxValue"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "address.temporaryAddressDuration.step"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "address.temporaryAddressDuration.defaultValue"?: {
      /**
       * @min 0
       * @exclusiveMin false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "ams.enabled"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "ams.notification"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "ams.rules"?: {
      value: {
        id: string;
        enabled: boolean;
        rule:
          | {
              type: "time";
              conditions?: object;
            }
          | {
              type: "location";
              conditions?: object;
              address: string;
            }
          | {
              type: "charger";
              conditions?: object;
            };
        actionIn?: {
          mode?: {
            value: "off" | "on" | "risk";
            enabled: boolean;
          };
          available?: {
            value: boolean;
            enabled: boolean;
          };
        };
        actionOut?: {
          mode?: {
            value: "off" | "on" | "risk";
            enabled: boolean;
          };
          available?: {
            value: boolean;
            enabled: boolean;
          };
        };
      }[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "auth.showRetryAfterMs"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "auth.retryTimeMs"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "auth.smsTimeout"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "contacts.urls.setFavorite"?: {
      /** @format uri */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "contacts.urls.adjustDontDisturb"?: {
      /** @format uri */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "navigation.defaultInteractionThrottle"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.key"?: {
      value: "staging" | "production";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.mainApiUrl"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.authApiUrl"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.observationApiUrl"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.wsApiUrl"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.fusionAuthClientId"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.microsoftAuthEndpoint"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.microsoftTokenEndpoint"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.xguard.company.name"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.xguard.company.address"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.xguard.company.registrationNumber"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.xguard.company.alarmPhoneNumber"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.xguard.privacy.nl"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.xguard.privacy.en"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.xguard.termsAndConditions.nl"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.xguard.termsAndConditions.en"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.xguard.microsoftRedirectUrl"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.bhvknop.company.name"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.bhvknop.company.address"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.bhvknop.company.registrationNumber"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.bhvknop.company.alarmPhoneNumber"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.bhvknop.privacy.nl"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.bhvknop.privacy.en"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.bhvknop.termsAndConditions.nl"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.bhvknop.termsAndConditions.en"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "environment.bhvknop.microsoftRedirectUrl"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "supportChat.portalId"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "supportChat.hublet"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "supportChat.environment"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "supportChat.defaultChatFlow"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "supportChat.staleChatThresholdMs"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "supportChat.scheduleTimeZone"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "supportChat.schedule"?: {
      value:
        | {
            daysOfWeek: number[];
            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
            timeStart: string;
            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
            timeEnd: string;
          }[]
        | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "otherEnvironment.key"?: {
      value: "staging" | "production";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "otherEnvironment.mainApiUrl"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "translation.substitutions"?: {
      value: {
        key: string;
        value: string;
      }[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "registration.supportedCCA2"?: {
      value: {
        code: string;
        enabled: boolean;
      }[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "registration.policyMaxAge"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "registration.publicCode"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "registration.pageTransitionDelay"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "observations.panicTimeout"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "observations.timeout"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "observations.blockGPSTimeout"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "observations.retry.maxAttempts"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "observations.retry.baseDelayMs"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "observations.retry.jitterFactor"?: {
      /**
       * @min 0
       * @exclusiveMin false
       * @max 1
       * @exclusiveMax false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "observations.limits"?: {
      value: {
        event:
          | "ALARM_RED"
          | "ALARM_ORANGE"
          | "ALARM_GREEN"
          | "RELEASED_RED"
          | "RELEASED_ORANGE"
          | "RELEASED_GREEN"
          | "BATLOAD"
          | "BATLOW"
          | "BATNORMAL"
          | "BATFULL"
          | "EXTPOWER"
          | "BATPOWER"
          | "APP_START"
          | "BATLEVEL"
          | "GPS"
          | "BEACON"
          | "TAG"
          | "MANDOWN"
          | "NFC"
          | "XOOR"
          | "MOVSTART"
          | "MOVSTOP"
          | "GEOIN"
          | "GEOOUT"
          | "DWELL"
          | "APPROX"
          | "MODE_OFF_ON"
          | "MODE_OFF_OFF"
          | "MODE_ON_ON"
          | "MODE_ON_OFF"
          | "MODE_RISK_ON"
          | "MODE_RISK_OFF"
          | "PRE_ALARM_HEADSET"
          | "PRE_ALARM_HARDWARE_BUTTON"
          | "PRE_ALARM_MANDOWN"
          | "PRE_ALARM_FLIC"
          | "PRE_ALARM_CANCELLED"
          | "HANGUP_CLIENT"
          | "HANGUP_REMOTE"
          | "ALIVE"
          | "LOGOUT"
          | "LOGIN"
          | "START_CALL"
          | "AVAILABLE_ON"
          | "AVAILABLE_OFF"
          | "SOCKET_CONNECT"
          | "SOCKET_DISCONNECT"
          | "FLIC_BATLOW"
          | "FLIC_BATNORMAL"
          | "FLIC_CLICK"
          | "FLIC_DOUBLE_CLICK"
          | "FLIC_HOLD"
          | "INCOMING_ALARM_FOREGROUND";
        /**
         * @min 0
         * @exclusiveMin true
         */
        rateLimitDefault?: number | null;
        /**
         * @min 0
         * @exclusiveMin true
         */
        rateLimitPanic?: number | null;
        /**
         * @min 0
         * @exclusiveMin true
         */
        rateLimitSlow?: number | null;
        /**
         * @min 0
         * @exclusiveMin true
         */
        timeout?: number | null;
      }[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "logger.entryMaxAge.error.maxAge"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "logger.entryMaxAge.error.leftPadding"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "logger.entryMaxAge.error.rightPadding"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "logger.entryMaxAge.warning.maxAge"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "logger.entryMaxAge.warning.leftPadding"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "logger.entryMaxAge.warning.rightPadding"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "logger.entryMaxAge.info.maxAge"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "logger.entryMaxAge.info.leftPadding"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "logger.entryMaxAge.info.rightPadding"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "logger.entryMaxAge.debug.maxAge"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "logger.entryMaxAge.debug.leftPadding"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "logger.entryMaxAge.debug.rightPadding"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "logger.dbMaxSize"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "logger.enableLogUpload"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "logger.flushEntriesOnCount"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "logger.flushEntriesOnTimeout"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "logger.uploadOptions"?: {
      value: number[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "notifier.duration"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "alarms.allowWhenOff"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "alarms.buttons"?: {
      value: {
        severity: "red" | "orange" | "green";
        type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
        overrideColor?: "green" | "blue" | "yellow" | "orange" | "red";
        overrideLabel?: string;
        allowWhenOff?: boolean;
        visible?: boolean;
        order?: number;
        height?: "small" | "large";
        width?: "full" | "half";
      }[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "alarms.buttonPressDuration"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "evacuation.buttons"?: {
      value: {
        type: "fire" | "gasLeak" | "workplaceAccident" | "smokeDevelopment" | "generalEvacuation" | "evacuationDrill";
        color?: "green" | "blue" | "yellow" | "orange" | "red";
      }[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "evacuation.recentObservationThreshold"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "evacuation.buildingZonesProximityRadius"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "evacuation.evacuationMap.clusterPxRadius"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "evacuation.evacuationMap.clusterMaxZoom"?: {
      /**
       * @min 0
       * @exclusiveMin false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "evacuation.evacuationMap.mapMaxZoom"?: {
      /**
       * @min 0
       * @exclusiveMin false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.list.pageSize"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.alarmCard.confirmOverrideText"?: {
      value: string | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.alarmCard.rejectOverrideText"?: {
      value: string | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.alarmCard.summaryTypeOverrides"?: {
      value: {
        type: "static" | "person";
        alarmTypes?: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[];
        alarmSeverities?: ("red" | "orange" | "green")[];
        includeAssetGroups?: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        excludeAssetGroups?: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
      }[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.alarmCard.rejectConfirmEnabled"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.componentOrder"?: {
      value: ("summary" | "helpers" | "locations" | "response" | "call" | "logbook" | "escalation" | "acknowledge")[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.alarmSheet.snapPoints"?: {
      value: number[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.notification.mode"?: {
      value: "call" | "notification";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.notification.sound.sound"?: {
      value:
        | "alarm"
        | "alarmclock"
        | "beepbeep"
        | "bell_sound"
        | "escalate"
        | "invasion"
        | "intrusive"
        | "pling"
        | "pling_high"
        | "pling_low"
        | "shake"
        | "silence"
        | "tf012"
        | "tf015"
        | "tf019"
        | "tf021"
        | "tf026"
        | "tf029"
        | "tf200"
        | "tf201"
        | "tf202"
        | "tf203"
        | "tf204"
        | "tf205"
        | "tf206"
        | "tf207"
        | "tf208"
        | "tf209"
        | "tf210"
        | "tf211"
        | "tf212"
        | "tf213"
        | "tf214"
        | "tf215"
        | "tf216"
        | "tf217"
        | "tf218"
        | "tf219"
        | "tf220"
        | "tf221"
        | "tf222"
        | "tf223"
        | "tf224"
        | "tf225"
        | "tf226"
        | "tf227"
        | "tf228"
        | "tf229"
        | "tf230"
        | "tornado"
        | "wakeup";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.notification.sound.volume"?: {
      /**
       * @min 0
       * @exclusiveMin false
       * @max 1
       * @exclusiveMax false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.notification.sound.loop"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.notification.sound.enabled"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.notification.sound.overrides"?: {
      value: {
        sound?:
          | "alarm"
          | "alarmclock"
          | "beepbeep"
          | "bell_sound"
          | "escalate"
          | "invasion"
          | "intrusive"
          | "pling"
          | "pling_high"
          | "pling_low"
          | "shake"
          | "silence"
          | "tf012"
          | "tf015"
          | "tf019"
          | "tf021"
          | "tf026"
          | "tf029"
          | "tf200"
          | "tf201"
          | "tf202"
          | "tf203"
          | "tf204"
          | "tf205"
          | "tf206"
          | "tf207"
          | "tf208"
          | "tf209"
          | "tf210"
          | "tf211"
          | "tf212"
          | "tf213"
          | "tf214"
          | "tf215"
          | "tf216"
          | "tf217"
          | "tf218"
          | "tf219"
          | "tf220"
          | "tf221"
          | "tf222"
          | "tf223"
          | "tf224"
          | "tf225"
          | "tf226"
          | "tf227"
          | "tf228"
          | "tf229"
          | "tf230"
          | "tornado"
          | "wakeup";
        /**
         * @min 0
         * @exclusiveMin false
         * @max 1
         * @exclusiveMax false
         */
        volume?: number;
        loop?: boolean;
        enabled?: boolean;
        severity: "red" | "orange" | "green";
        type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
      }[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.modal.doubleConfirm"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.map.pxPadding"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.map.coordinatePadding"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.map.animationDuration"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.map.ownPositionMaxDistanceBounds"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.acknowledgeAlarm.instant"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.acknowledgeAlarm.pages"?: {
      value: (
        | {
            id: string;
            title: string;
            description?: string;
            visible: boolean;
            required?: boolean;
            buttons?: {
              id: string;
              variant:
                | "white"
                | "green"
                | "blue"
                | "yellow"
                | "red"
                | "whiteOutline"
                | "greenOutline"
                | "blueOutline"
                | "yellowOutline"
                | "redOutline";
              label: string;
            }[];
            type: "form";
            fields: (
              | {
                  id: string;
                  visible: boolean;
                  required: boolean;
                  type: "checkbox";
                  label: string;
                  defaultValue?: boolean;
                }
              | {
                  id: string;
                  visible: boolean;
                  required: boolean;
                  type: "text";
                  label?: string;
                  placeholder?: string;
                  multiline?: boolean;
                  /**
                   * @min 0
                   * @exclusiveMin false
                   */
                  minLength?: number;
                  /**
                   * @min 0
                   * @exclusiveMin true
                   */
                  maxLength?: number;
                }
              | {
                  id: string;
                  visible: boolean;
                  required: boolean;
                  type: "textarea";
                  label?: string;
                  placeholder?: string;
                  /**
                   * @min 0
                   * @exclusiveMin false
                   */
                  minLength?: number;
                  /**
                   * @min 0
                   * @exclusiveMin true
                   */
                  maxLength?: number;
                }
              | {
                  id: string;
                  visible: boolean;
                  required: boolean;
                  type: "photo";
                  label: string;
                  /**
                   * @min 0
                   * @exclusiveMin false
                   */
                  minCount?: number;
                  /**
                   * @min 0
                   * @exclusiveMin true
                   */
                  maxCount?: number;
                }
              | {
                  id: string;
                  visible: boolean;
                  required: boolean;
                  type: "select";
                  /** @minItems 1 */
                  options: {
                    value: string;
                    label: string;
                  }[];
                  multiple?: boolean;
                }
              | {
                  id: string;
                  visible: boolean;
                  required: boolean;
                  type: "header";
                  value: string;
                }
              | {
                  id: string;
                  visible: boolean;
                  required: boolean;
                  type: "description";
                  value: string;
                }
            )[];
          }
        | {
            id: string;
            title: string;
            description?: string;
            visible: boolean;
            required?: boolean;
            buttons?: {
              id: string;
              variant:
                | "white"
                | "green"
                | "blue"
                | "yellow"
                | "red"
                | "whiteOutline"
                | "greenOutline"
                | "blueOutline"
                | "yellowOutline"
                | "redOutline";
              label: string;
            }[];
            type: "confirm";
            confirmLabel?: string;
          }
      )[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "incomingAlarms.acknowledgeAlarm.modalTimer"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "tokens.mapboxRetry.minWait"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "tokens.mapboxRetry.maxWait"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "tokens.mapboxRetry.factor"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "components.hidden"?: {
      value: {
        key:
          | "call.messages"
          | "call.mic"
          | "call.speaker"
          | "dashboard.alarmButtons"
          | "dashboard.alarmButtons.testCentre"
          | "dashboard.modeSwitch"
          | "dashboard.modeSwitch.available"
          | "dashboard.modeSwitch.available.off"
          | "dashboard.modeSwitch.available.on"
          | "dashboard.modeSwitch.mode"
          | "dashboard.modeSwitch.mode.off"
          | "dashboard.modeSwitch.mode.on"
          | "dashboard.modeSwitch.mode.risk"
          | "dashboard.quickMenu.evacuation"
          | "dashboard.quickMenu.incomingAlarms"
          | "dashboard.quickMenu.info"
          | "dashboard.quickMenu.logout"
          | "dashboard.quickMenu.profile"
          | "dashboard.quickMenu.settings"
          | "dashboard.quickMenu.support"
          | "dashboard.topBar"
          | "dashboard.topBar.logo"
          | "dashboard.topBar.quickMenuButton"
          | "hardwareButtons.add"
          | "hardwareButtons.flic.menu.advanced"
          | "hardwareButtons.flic.menu.delete"
          | "hardwareButtons.test"
          | "incomingAlarm.helpers.grid"
          | "incomingAlarm.helpers.total"
          | "incomingAlarm.helpers.unconfirmed"
          | "incomingAlarm.map.locationRow.alarm"
          | "incomingAlarm.map.locationRow.asset"
          | "incomingAlarm.map.marker.alarm"
          | "incomingAlarm.map.marker.asset"
          | "incomingAlarm.map.marker.own"
          | "incomingAlarm.map.overlays"
          | "incomingAlarm.summary.createdBy"
          | "incomingAlarm.summary.header"
          | "incomingAlarm.summary.image"
          | "incomingAlarm.summary.mapsLink"
          | "incomingAlarm.summary.position"
          | "incomingAlarmList.alarmCard.closeAlarm"
          | "incomingAlarmList.alarmCard.createdBy"
          | "incomingAlarmList.alarmCard.header"
          | "incomingAlarmList.alarmCard.helpers"
          | "incomingAlarmList.alarmCard.helpers.list"
          | "incomingAlarmList.alarmCard.helpers.total"
          | "incomingAlarmList.alarmCard.image"
          | "incomingAlarmList.alarmCard.map"
          | "incomingAlarmList.alarmCard.map.marker.alarm"
          | "incomingAlarmList.alarmCard.map.marker.asset"
          | "incomingAlarmList.alarmCard.map.marker.own"
          | "incomingAlarmList.alarmCard.map.overlays"
          | "incomingAlarmList.alarmCard.mapsLink"
          | "incomingAlarmList.alarmCard.position"
          | "incomingAlarmList.alarmCard.staticPosition"
          | "incomingAlarmList.closedAlarms"
          | "info.account"
          | "info.deviceInfo"
          | "info.licences"
          | "info.permissions"
          | "info.privacy"
          | "info.terms"
          | "info.updateApp"
          | "info.uploadLog"
          | "info.warnings"
          | "settings.addressList"
          | "settings.agenda"
          | "settings.alarmButtons"
          | "settings.contacts"
          | "settings.location"
          | "settings.mandown"
          | "settings.notifications";
        hidden: boolean;
      }[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "components.disabled"?: {
      value: {
        key:
          | "dashboard.modeSwitch.available.off"
          | "dashboard.modeSwitch.available.on"
          | "dashboard.modeSwitch.mode.off"
          | "dashboard.modeSwitch.mode.on"
          | "dashboard.modeSwitch.mode.risk";
        disabled: boolean;
      }[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "modes.appMode.needPermissionForUsage"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "modes.available.needPermissionForUsage"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensitivityMode"?: {
      value: "low" | "medium" | "high";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensitivityChangePreAlarm"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensitivitySliderSettings.minValue"?: {
      /**
       * @min 0
       * @exclusiveMin false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensitivitySliderSettings.maxValue"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensitivitySliderSettings.step"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensitivitySliderSettings.defaultValue"?: {
      /**
       * @min 0
       * @exclusiveMin false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensorInterval"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.speedingFrom"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.timeBeforeOnFlat"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.onFlatOffSet"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.onFlatPause"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.onFlatMode"?: {
      value: "up" | "down" | "both";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.onFlatPauseNotification"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.onFlatSpeedDifference"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.onFlatUnpauseMovementTime"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.onFlatUnpauseMovementTimeBetweenMovements"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.alarmMakeSound"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.alarmVibrate"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.alarmSendPush"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.confirmOff"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.confirmOffDuration"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.confirmDuration"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.duration"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.durationSliderSettings.minValue"?: {
      /**
       * @min 0
       * @exclusiveMin false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.durationSliderSettings.maxValue"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.durationSliderSettings.step"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.durationSliderSettings.defaultValue"?: {
      /**
       * @min 0
       * @exclusiveMin false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.preAlarmSoundCriticalCount"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.cancelPreAlarmByMovement"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.cancelPreAlarmByShake"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.pauseDuration"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.pauseDurationSliderSettings.minValue"?: {
      /**
       * @min 0
       * @exclusiveMin false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.pauseDurationSliderSettings.maxValue"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.pauseDurationSliderSettings.step"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.pauseDurationSliderSettings.defaultValue"?: {
      /**
       * @min 0
       * @exclusiveMin false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.preAlarmSound.sound"?: {
      value:
        | "alarm"
        | "alarmclock"
        | "beepbeep"
        | "bell_sound"
        | "escalate"
        | "invasion"
        | "intrusive"
        | "pling"
        | "pling_high"
        | "pling_low"
        | "shake"
        | "silence"
        | "tf012"
        | "tf015"
        | "tf019"
        | "tf021"
        | "tf026"
        | "tf029"
        | "tf200"
        | "tf201"
        | "tf202"
        | "tf203"
        | "tf204"
        | "tf205"
        | "tf206"
        | "tf207"
        | "tf208"
        | "tf209"
        | "tf210"
        | "tf211"
        | "tf212"
        | "tf213"
        | "tf214"
        | "tf215"
        | "tf216"
        | "tf217"
        | "tf218"
        | "tf219"
        | "tf220"
        | "tf221"
        | "tf222"
        | "tf223"
        | "tf224"
        | "tf225"
        | "tf226"
        | "tf227"
        | "tf228"
        | "tf229"
        | "tf230"
        | "tornado"
        | "wakeup";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.preAlarmSound.volume"?: {
      /**
       * @min 0
       * @exclusiveMin false
       * @max 1
       * @exclusiveMax false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.preAlarmSound.loop"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.preAlarmSound.enabled"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.keepAliveSchedule"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.keepAlivePauseSchedule"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.android.low.average"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.android.low.measureLength"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.android.low.nonMovement"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.android.low.sensorInterval"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.android.low.vibrateCounter"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.android.medium.average"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.android.medium.measureLength"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.android.medium.nonMovement"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.android.medium.sensorInterval"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.android.medium.vibrateCounter"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.android.high.average"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.android.high.measureLength"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.android.high.nonMovement"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.android.high.sensorInterval"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.android.high.vibrateCounter"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.ios.low.average"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.ios.low.measureLength"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.ios.low.nonMovement"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.ios.low.sensorInterval"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.ios.low.vibrateCounter"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.ios.medium.average"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.ios.medium.measureLength"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.ios.medium.nonMovement"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.ios.medium.sensorInterval"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.ios.medium.vibrateCounter"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.ios.high.average"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.ios.high.measureLength"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.ios.high.nonMovement"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.ios.high.sensorInterval"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityValues.ios.high.vibrateCounter"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.android.low.average"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.android.low.measureLength"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.android.low.nonMovement"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.android.low.sensorInterval"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.android.low.vibrateCounter"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.android.medium.average"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.android.medium.measureLength"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.android.medium.nonMovement"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.android.medium.sensorInterval"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.android.medium.vibrateCounter"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.android.high.average"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.android.high.measureLength"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.android.high.nonMovement"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.android.high.sensorInterval"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.android.high.vibrateCounter"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.ios.low.average"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.ios.low.measureLength"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.ios.low.nonMovement"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.ios.low.sensorInterval"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.ios.low.vibrateCounter"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.ios.medium.average"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.ios.medium.measureLength"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.ios.medium.nonMovement"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.ios.medium.sensorInterval"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.ios.medium.vibrateCounter"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.ios.high.average"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.ios.high.measureLength"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.ios.high.nonMovement"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.ios.high.sensorInterval"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.movingAverageSensitivityPreAlarmValues.ios.high.vibrateCounter"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensitivityPreAlarmValues.android.low"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensitivityPreAlarmValues.android.medium"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensitivityPreAlarmValues.android.high"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensitivityPreAlarmValues.ios.low"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensitivityPreAlarmValues.ios.medium"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensitivityPreAlarmValues.ios.high"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensitivityValues.android.low"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensitivityValues.android.medium"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensitivityValues.android.high"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensitivityValues.ios.low"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensitivityValues.ios.medium"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "mandown.sensitivityValues.ios.high"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.positionAppStateMode"?: {
      value: "availabilityOnly" | "tracking";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.positionUpdateMode"?: {
      value: "static" | "foregroundOnly" | "always";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.positionUpdateRate"?: {
      value: "lowest" | "slow" | "normal" | "fast" | "continuous";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.allowIdenticalLocations"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.deferTime"?: {
      /**
       * @min 0
       * @exclusiveMin false
       */
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.desiredAccuracy"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.disableElasticity"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.disableLocationAuthorizationAlert"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.distanceFilter"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.elasticityMultiplier"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.enableTimestampMeta"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.fastestLocationUpdateInterval"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.stationaryRadius"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.stopTimeout"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.stopAfterElapsedMinutes"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.geofenceProximityRadius"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.geofenceInitialTriggerEntry"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.geofenceModeHighAccuracy"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.locationAuthorizationRequest"?: {
      value?: "WhenInUse" | "Always" | "Any";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.locationUpdateInterval"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.pausesLocationUpdatesAutomatically"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.showsBackgroundLocationIndicator"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.activityType"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.useSignificantChangesOnly"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.filter.burstWindow"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.filter.filterDebug"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.filter.kalmanDebug"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.filter.kalmanProfile"?: {
      value?: "0" | "1" | "2";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.filter.maxBurstDistance"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.filter.maxImpliedSpeed"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.filter.odometerAccuracyThreshold"?: {
      /**
       * @min 0
       * @exclusiveMin false
       * @max 500
       * @exclusiveMax false
       */
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.filter.odometerUseKalmanFilter"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.filter.policy"?: {
      value?: "0" | "1" | "2";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.filter.rollingWindow"?: {
      /**
       * @min 3
       * @exclusiveMin false
       * @max 20
       * @exclusiveMax false
       */
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.filter.trackingAccuracyThreshold"?: {
      /**
       * @min 0
       * @exclusiveMin false
       * @max 500
       * @exclusiveMax false
       */
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.filter.useKalman"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.disableStopDetection"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.geolocation.stopOnStationary"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.stopOnTerminate"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.startOnBoot"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.enableHeadless"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.heartbeatInterval"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.schedule"?: {
      value?: string[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.scheduleUseAlarmManager"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.preventSuspend"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.notification.actions"?: {
      value?: string[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.notification.channelId"?: {
      value?: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.notification.channelName"?: {
      value?: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.notification.color"?: {
      value?: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.notification.largeIcon"?: {
      value?: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.notification.layout"?: {
      value?: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.notification.priority"?: {
      /**
       * @min -2
       * @exclusiveMin false
       * @max 2
       * @exclusiveMax false
       */
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.notification.smallIcon"?: {
      value?: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.notification.sticky"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.notification.text"?: {
      value?: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.notification.title"?: {
      value?: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.backgroundPermissionRationale.title"?: {
      value?: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.backgroundPermissionRationale.message"?: {
      value?: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.backgroundPermissionRationale.nativeAction"?: {
      value?: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.app.backgroundPermissionRationale.positiveAction"?: {
      value?: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.logger.debug"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.logger.logLevel"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.logger.logMaxDays"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.activity.activityRecognitionInterval"?: {
      /**
       * @min 500
       * @exclusiveMin false
       */
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.activity.motionTriggerDelay"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.activity.triggerActivities"?: {
      value?:
        | "walking"
        | "on_foot"
        | "running"
        | "on_bicycle"
        | "in_vehicle"
        | ("walking" | "on_foot" | "running" | "on_bicycle" | "in_vehicle")[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.activity.disableMotionActivityUpdates"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.activity.stopDetectionDelay"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.activity.disableStopDetection"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.activity.minimumActivityRecognitionConfidence"?: {
      /**
       * @min 0
       * @exclusiveMin false
       * @max 100
       * @exclusiveMax false
       */
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.activity.stopOnStationary"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.persistence.persistMode"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.persistence.maxRecordsToPersist"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.persistence.locationsOrderDirection"?: {
      value?: "ASC" | "DESC";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.persistence.disableProviderChangeRecord"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.config.reset"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.configOverrides"?: {
      value: {
        config: {
          geolocation?: {
            allowIdenticalLocations?: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             */
            deferTime?: number;
            desiredAccuracy?: number;
            disableElasticity?: boolean;
            disableLocationAuthorizationAlert?: boolean;
            distanceFilter?: number;
            elasticityMultiplier?: number;
            enableTimestampMeta?: boolean;
            fastestLocationUpdateInterval?: number;
            stationaryRadius?: number;
            stopTimeout?: number;
            stopAfterElapsedMinutes?: number;
            geofenceProximityRadius?: number;
            geofenceInitialTriggerEntry?: boolean;
            geofenceModeHighAccuracy?: boolean;
            locationAuthorizationRequest?: "WhenInUse" | "Always" | "Any";
            locationUpdateInterval?: number;
            pausesLocationUpdatesAutomatically?: boolean;
            showsBackgroundLocationIndicator?: boolean;
            activityType?: number;
            useSignificantChangesOnly?: boolean;
            filter: {
              burstWindow?: number;
              filterDebug?: boolean;
              kalmanDebug?: boolean;
              kalmanProfile?: "0" | "1" | "2";
              maxBurstDistance?: number;
              maxImpliedSpeed?: number;
              /**
               * @min 0
               * @exclusiveMin false
               * @max 500
               * @exclusiveMax false
               */
              odometerAccuracyThreshold?: number;
              odometerUseKalmanFilter?: boolean;
              policy?: "0" | "1" | "2";
              /**
               * @min 3
               * @exclusiveMin false
               * @max 20
               * @exclusiveMax false
               */
              rollingWindow?: number;
              /**
               * @min 0
               * @exclusiveMin false
               * @max 500
               * @exclusiveMax false
               */
              trackingAccuracyThreshold?: number;
              useKalman?: boolean;
            };
            disableStopDetection?: boolean;
            stopOnStationary?: boolean;
          };
          app?: {
            stopOnTerminate?: boolean;
            startOnBoot?: boolean;
            enableHeadless?: boolean;
            heartbeatInterval?: number;
            schedule?: string[];
            scheduleUseAlarmManager?: boolean;
            preventSuspend?: boolean;
            notification: {
              actions?: string[];
              channelId?: string;
              channelName?: string;
              color?: string;
              largeIcon?: string;
              layout?: string;
              /**
               * @min -2
               * @exclusiveMin false
               * @max 2
               * @exclusiveMax false
               */
              priority?: number;
              smallIcon?: string;
              sticky?: boolean;
              text?: string;
              title?: string;
            };
            backgroundPermissionRationale: {
              title?: string;
              message?: string;
              nativeAction?: string;
              positiveAction?: string;
            };
          };
          logger?: {
            debug?: boolean;
            logLevel?: number;
            logMaxDays?: number;
          };
          activity?: {
            /**
             * @min 500
             * @exclusiveMin false
             */
            activityRecognitionInterval?: number;
            motionTriggerDelay?: number;
            triggerActivities?:
              | "walking"
              | "on_foot"
              | "running"
              | "on_bicycle"
              | "in_vehicle"
              | ("walking" | "on_foot" | "running" | "on_bicycle" | "in_vehicle")[];
            disableMotionActivityUpdates?: boolean;
            stopDetectionDelay?: number;
            disableStopDetection?: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            minimumActivityRecognitionConfidence?: number;
            stopOnStationary?: boolean;
          };
          persistence?: {
            persistMode?: number;
            maxRecordsToPersist?: number;
            locationsOrderDirection?: "ASC" | "DESC";
            disableProviderChangeRecord?: boolean;
          };
          reset?: boolean;
        };
        type:
          | "availability_only_always_lowest"
          | "availability_only_always_slow"
          | "availability_only_always_normal"
          | "availability_only_always_fast"
          | "availability_only_always_continuous"
          | "availability_only_foreground"
          | "tracking_always_lowest"
          | "tracking_always_slow"
          | "tracking_always_normal"
          | "tracking_always_fast"
          | "tracking_always_continuous"
          | "tracking_foreground";
      }[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.request.normal.maximumAge"?: {
      /**
       * @min 0
       * @exclusiveMin false
       */
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.request.normal.persist"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.request.normal.desiredAccuracy"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.request.normal.samples"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.request.normal.timeout"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.request.alarm.maximumAge"?: {
      /**
       * @min 0
       * @exclusiveMin false
       */
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.request.alarm.persist"?: {
      value?: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.request.alarm.desiredAccuracy"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.request.alarm.samples"?: {
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "location.request.alarm.timeout"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "feedback.shakeCount"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "feedback.maxLastShakeTime"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "geofence.geofences"?: {
      value: (
        | {
            type: "circle";
            identifier: string;
            /**
             * @min 200
             * @exclusiveMin false
             */
            radius: number;
            /**
             * @min -90
             * @exclusiveMin false
             * @max 90
             * @exclusiveMax false
             */
            latitude: number;
            /**
             * @min -180
             * @exclusiveMin false
             * @max 180
             * @exclusiveMax false
             */
            longitude: number;
            label: string;
            textual: string;
          }
        | {
            type: "polygon";
            identifier: string;
            /** @minItems 3 */
            vertices: number[][];
            label: string;
            textual: string;
          }
      )[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "geofence.radius"?: {
      /**
       * @min 200
       * @exclusiveMin false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "geofence.dwell.enabled"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "geofence.dwell.radius"?: {
      /**
       * @min 200
       * @exclusiveMin false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "geofence.notification.onBuild"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "geofence.notification.onEnter"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "geofence.notification.onExit"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "geofence.notification.onDwell"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "scaling.referenceWidth"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "scaling.referenceHeight"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "scaling.units"?: {
      value: {
        key:
          | "xxs"
          | "xs"
          | "sm"
          | "md"
          | "lg"
          | "xl"
          | "iconXs"
          | "iconSm"
          | "iconMd"
          | "iconLg"
          | "iconXl"
          | "iconXXl"
          | "fontXl"
          | "fontLg"
          | "fontMd"
          | "fontSm"
          | "fontXs";
        unit: {
          type: "hwScale";
          factor: number;
          size: number;
        };
      }[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.sizes.headerFont"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.sizes.normalFont"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.sizes.underLineFont"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.sizes.maxFontScale"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.opacities.lower"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.opacities.low"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.opacities.medium"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.opacities.high"?: {
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.appBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.appHeaderBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.appHeaderColor"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.overlayBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.overlayColor"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.divider"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.inputBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.text"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.lightText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.alternativeBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.alternativeBgDark"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.alternativeColor"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.alternativeLightText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.alternativeHr"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.togglesBackground"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.toggleOff"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.toggleOffText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.toggleOn"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.toggleOnText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.toggleRisk"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.toggleRiskText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.panelBackground"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.panelBorder"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.qrCodeMask"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.buttonWhiteBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.buttonWhiteBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.buttonWhiteText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.buttonGreenBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.buttonGreenBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.buttonGreenText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.buttonBlueBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.buttonBlueBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.buttonBlueText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.buttonYellowBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.buttonYellowBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.buttonYellowText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.buttonOrangeBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.buttonOrangeBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.buttonOrangeText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.buttonRedBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.buttonRedBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.buttonRedText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.messageNeutralBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.messageNeutralBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.messageNeutralText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.messageGreenBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.messageGreenBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.messageGreenText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.messageBlueBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.messageBlueBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.messageBlueText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.messageYellowBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.messageYellowBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.messageYellowText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.messageOrangeBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.messageOrangeBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.messageOrangeText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.messageRedBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.messageRedBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.messageRedText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.loginHeaderBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.shadowColor"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.chatColor1"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.chatColor2"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.chatColor3"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.chatColor4"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.chatColor5"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.chatColor6"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.chatColor7"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.chatColor8"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.chatColor9"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.chatColor10"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.chatColor11"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.chatColor12"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.chatColor13"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.chatColor14"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.chatColor15"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.iconLight"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.iconDark"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.icon1"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.icon2"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.colors.icon3"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.logos.tradeMark"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.logos.horizontalPayoff"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.logos.horizontal"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.logos.vertical"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.logos.verticalPayoff"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.light.logos.appName"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.appBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.appHeaderBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.appHeaderColor"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.overlayBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.overlayColor"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.divider"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.inputBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.text"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.lightText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.alternativeBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.alternativeBgDark"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.alternativeColor"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.alternativeLightText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.alternativeHr"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.togglesBackground"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.toggleOff"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.toggleOffText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.toggleOn"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.toggleOnText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.toggleRisk"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.toggleRiskText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.panelBackground"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.panelBorder"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.qrCodeMask"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.buttonWhiteBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.buttonWhiteBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.buttonWhiteText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.buttonGreenBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.buttonGreenBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.buttonGreenText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.buttonBlueBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.buttonBlueBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.buttonBlueText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.buttonYellowBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.buttonYellowBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.buttonYellowText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.buttonOrangeBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.buttonOrangeBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.buttonOrangeText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.buttonRedBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.buttonRedBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.buttonRedText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.messageNeutralBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.messageNeutralBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.messageNeutralText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.messageGreenBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.messageGreenBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.messageGreenText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.messageBlueBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.messageBlueBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.messageBlueText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.messageYellowBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.messageYellowBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.messageYellowText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.messageOrangeBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.messageOrangeBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.messageOrangeText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.messageRedBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.messageRedBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.messageRedText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.loginHeaderBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.shadowColor"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.chatColor1"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.chatColor2"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.chatColor3"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.chatColor4"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.chatColor5"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.chatColor6"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.chatColor7"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.chatColor8"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.chatColor9"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.chatColor10"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.chatColor11"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.chatColor12"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.chatColor13"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.chatColor14"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.chatColor15"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.iconLight"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.iconDark"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.icon1"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.icon2"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.colors.icon3"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.logos.tradeMark"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.logos.horizontalPayoff"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.logos.horizontal"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.logos.vertical"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.logos.verticalPayoff"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.xguard.dark.logos.appName"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.appBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.appHeaderBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.appHeaderColor"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.overlayBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.overlayColor"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.divider"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.inputBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.text"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.lightText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.alternativeBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.alternativeBgDark"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.alternativeColor"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.alternativeLightText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.alternativeHr"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.togglesBackground"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.toggleOff"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.toggleOffText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.toggleOn"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.toggleOnText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.toggleRisk"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.toggleRiskText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.panelBackground"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.panelBorder"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.qrCodeMask"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.buttonWhiteBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.buttonWhiteBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.buttonWhiteText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.buttonGreenBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.buttonGreenBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.buttonGreenText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.buttonBlueBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.buttonBlueBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.buttonBlueText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.buttonYellowBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.buttonYellowBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.buttonYellowText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.buttonOrangeBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.buttonOrangeBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.buttonOrangeText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.buttonRedBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.buttonRedBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.buttonRedText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.messageNeutralBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.messageNeutralBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.messageNeutralText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.messageGreenBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.messageGreenBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.messageGreenText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.messageBlueBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.messageBlueBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.messageBlueText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.messageYellowBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.messageYellowBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.messageYellowText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.messageOrangeBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.messageOrangeBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.messageOrangeText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.messageRedBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.messageRedBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.messageRedText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.loginHeaderBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.shadowColor"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.chatColor1"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.chatColor2"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.chatColor3"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.chatColor4"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.chatColor5"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.chatColor6"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.chatColor7"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.chatColor8"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.chatColor9"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.chatColor10"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.chatColor11"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.chatColor12"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.chatColor13"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.chatColor14"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.chatColor15"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.iconLight"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.iconDark"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.icon1"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.icon2"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.colors.icon3"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.logos.tradeMark"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.logos.horizontalPayoff"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.logos.horizontal"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.logos.vertical"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.logos.verticalPayoff"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.light.logos.appName"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.appBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.appHeaderBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.appHeaderColor"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.overlayBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.overlayColor"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.divider"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.inputBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.text"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.lightText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.alternativeBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.alternativeBgDark"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.alternativeColor"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.alternativeLightText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.alternativeHr"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.togglesBackground"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.toggleOff"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.toggleOffText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.toggleOn"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.toggleOnText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.toggleRisk"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.toggleRiskText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.panelBackground"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.panelBorder"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.qrCodeMask"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.buttonWhiteBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.buttonWhiteBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.buttonWhiteText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.buttonGreenBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.buttonGreenBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.buttonGreenText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.buttonBlueBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.buttonBlueBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.buttonBlueText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.buttonYellowBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.buttonYellowBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.buttonYellowText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.buttonOrangeBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.buttonOrangeBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.buttonOrangeText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.buttonRedBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.buttonRedBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.buttonRedText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.messageNeutralBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.messageNeutralBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.messageNeutralText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.messageGreenBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.messageGreenBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.messageGreenText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.messageBlueBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.messageBlueBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.messageBlueText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.messageYellowBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.messageYellowBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.messageYellowText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.messageOrangeBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.messageOrangeBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.messageOrangeText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.messageRedBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.messageRedBgHover"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.messageRedText"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.loginHeaderBg"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.shadowColor"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.chatColor1"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.chatColor2"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.chatColor3"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.chatColor4"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.chatColor5"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.chatColor6"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.chatColor7"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.chatColor8"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.chatColor9"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.chatColor10"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.chatColor11"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.chatColor12"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.chatColor13"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.chatColor14"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.chatColor15"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.iconLight"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.iconDark"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.icon1"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.icon2"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.colors.icon3"?: {
      /** @pattern (^hsl\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*\)$)|(^hsla\(\s*(\d{1,3}(?:\.\d+)?)\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*((?:-)?\d{1,3}(?:\.\d+)?)%\s*,\s*(0?\.\d+|1|0)\s*\)$) */
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.logos.tradeMark"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.logos.horizontalPayoff"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.logos.horizontal"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.logos.vertical"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.logos.verticalPayoff"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "palettes.bhvknop.dark.logos.appName"?: {
      value: string;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.alarm.onSpeaker"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.alarm.muted"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.alarm.enabled"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.alarm.overrides"?: {
      value: {
        onSpeaker?: boolean;
        muted?: boolean;
        enabled?: boolean;
        severity: "red" | "orange" | "green";
        type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
      }[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.alarm.showCallTimer"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.alarm.showHangupButtonTimer"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.helper.onSpeaker"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.helper.muted"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.helper.enabled"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.helper.overrides"?: {
      value: {
        onSpeaker?: boolean;
        muted?: boolean;
        enabled?: boolean;
        severity: "red" | "orange" | "green";
        type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
      }[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.helper.ptt.mode"?: {
      value: "oneByOne" | "openCall" | "pttMess";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.helper.ptt.permission"?: {
      value: "listen" | "speak" | "overrule";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.helper.ptt.swipeToLockMyCurrentPttSession"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.helper.ptt.openCallDefaultMuted"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.helper.chat.sendHeartbeatThrottle"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.helper.chat.sendCancelFromInactivityTimeout"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.helper.chat.startedChatMaxHeartbeatAge"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.helper.chat.startedAudioMaxHeartbeatAge"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.helper.audioRecording.file.sampleRate"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.helper.audioRecording.file.bitDepth"?: {
      value: "bit16" | "bit24" | "bit32";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.helper.audioRecording.file.bitRate"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.helper.audioRecording.file.iosQuality"?: {
      value: "min" | "low" | "medium" | "high" | "max";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.helper.audioRecording.file.channelCount"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "call.helper.audioRecording.minRecordingDuration"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.calendar.severity"?: {
      value: "red" | "yellow" | "none";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.calendar.platform"?: {
      value: "android" | "ios" | "both";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.camera.severity"?: {
      value: "red" | "yellow" | "none";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.camera.platform"?: {
      value: "android" | "ios" | "both";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.contacts.severity"?: {
      value: "red" | "yellow" | "none";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.contacts.platform"?: {
      value: "android" | "ios" | "both";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.locationAlways.severity"?: {
      value: "red" | "yellow" | "none";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.locationAlways.platform"?: {
      value: "android" | "ios" | "both";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.locationWhenInUse.severity"?: {
      value: "red" | "yellow" | "none";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.locationWhenInUse.platform"?: {
      value: "android" | "ios" | "both";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.microphone.severity"?: {
      value: "red" | "yellow" | "none";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.microphone.platform"?: {
      value: "android" | "ios" | "both";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.notification.severity"?: {
      value: "red" | "yellow" | "none";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.notification.platform"?: {
      value: "android" | "ios" | "both";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.criticalNotification.severity"?: {
      value: "red" | "yellow" | "none";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.criticalNotification.platform"?: {
      value: "android" | "ios" | "both";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.motion.severity"?: {
      value: "red" | "yellow" | "none";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.motion.platform"?: {
      value: "android" | "ios" | "both";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.bluetooth.severity"?: {
      value: "red" | "yellow" | "none";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.bluetooth.platform"?: {
      value: "android" | "ios" | "both";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.physical.severity"?: {
      value: "red" | "yellow" | "none";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.physical.platform"?: {
      value: "android" | "ios" | "both";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.overlay.severity"?: {
      value: "red" | "yellow" | "none";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.overlay.platform"?: {
      value: "android" | "ios" | "both";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.batteryOptimization.severity"?: {
      value: "red" | "yellow" | "none";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "permissions.batteryOptimization.platform"?: {
      value: "android" | "ios" | "both";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.testButtonCloseDelay"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.buttons"?: {
      value: {
        type: "flic";
        id: string;
        label?: string;
        advancedEnabled: boolean;
        /**
         * @min 0
         * @exclusiveMin true
         */
        maxEventAge?: number;
        notifications?: {
          connect: {
            enabled?: boolean;
            onlyInModesOn?: boolean;
            /**
             * @min 0
             * @exclusiveMin true
             */
            delay?: number;
          };
          disconnect: {
            enabled?: boolean;
            onlyInModesOn?: boolean;
            /**
             * @min 0
             * @exclusiveMin true
             */
            delay?: number;
          };
          alarm: boolean;
          batteryLow: boolean;
        };
        forceHoldConfig?: {
          enabled: boolean;
          /**
           * @min 0
           * @exclusiveMin true
           */
          count: number;
          /**
           * @min 0
           * @exclusiveMin true
           */
          duration: number;
        };
        alarmClickConfig?: {
          severity: "red" | "orange" | "green";
          type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
          overrideColor?: "green" | "blue" | "yellow" | "orange" | "red";
          overrideLabel?: string;
          allowWhenOff?: boolean;
          enabled: boolean;
          sound?: {
            sound:
              | "alarm"
              | "alarmclock"
              | "beepbeep"
              | "bell_sound"
              | "escalate"
              | "invasion"
              | "intrusive"
              | "pling"
              | "pling_high"
              | "pling_low"
              | "shake"
              | "silence"
              | "tf012"
              | "tf015"
              | "tf019"
              | "tf021"
              | "tf026"
              | "tf029"
              | "tf200"
              | "tf201"
              | "tf202"
              | "tf203"
              | "tf204"
              | "tf205"
              | "tf206"
              | "tf207"
              | "tf208"
              | "tf209"
              | "tf210"
              | "tf211"
              | "tf212"
              | "tf213"
              | "tf214"
              | "tf215"
              | "tf216"
              | "tf217"
              | "tf218"
              | "tf219"
              | "tf220"
              | "tf221"
              | "tf222"
              | "tf223"
              | "tf224"
              | "tf225"
              | "tf226"
              | "tf227"
              | "tf228"
              | "tf229"
              | "tf230"
              | "tornado"
              | "wakeup";
            /**
             * @min 0
             * @exclusiveMin false
             * @max 1
             * @exclusiveMax false
             */
            volume: number;
            loop: boolean;
            enabled: boolean;
          };
        };
        alarmDoubleClickConfig?: {
          severity: "red" | "orange" | "green";
          type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
          overrideColor?: "green" | "blue" | "yellow" | "orange" | "red";
          overrideLabel?: string;
          allowWhenOff?: boolean;
          enabled: boolean;
          sound?: {
            sound:
              | "alarm"
              | "alarmclock"
              | "beepbeep"
              | "bell_sound"
              | "escalate"
              | "invasion"
              | "intrusive"
              | "pling"
              | "pling_high"
              | "pling_low"
              | "shake"
              | "silence"
              | "tf012"
              | "tf015"
              | "tf019"
              | "tf021"
              | "tf026"
              | "tf029"
              | "tf200"
              | "tf201"
              | "tf202"
              | "tf203"
              | "tf204"
              | "tf205"
              | "tf206"
              | "tf207"
              | "tf208"
              | "tf209"
              | "tf210"
              | "tf211"
              | "tf212"
              | "tf213"
              | "tf214"
              | "tf215"
              | "tf216"
              | "tf217"
              | "tf218"
              | "tf219"
              | "tf220"
              | "tf221"
              | "tf222"
              | "tf223"
              | "tf224"
              | "tf225"
              | "tf226"
              | "tf227"
              | "tf228"
              | "tf229"
              | "tf230"
              | "tornado"
              | "wakeup";
            /**
             * @min 0
             * @exclusiveMin false
             * @max 1
             * @exclusiveMax false
             */
            volume: number;
            loop: boolean;
            enabled: boolean;
          };
        };
        alarmHoldConfig?: {
          severity: "red" | "orange" | "green";
          type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
          overrideColor?: "green" | "blue" | "yellow" | "orange" | "red";
          overrideLabel?: string;
          allowWhenOff?: boolean;
          enabled: boolean;
          sound?: {
            sound:
              | "alarm"
              | "alarmclock"
              | "beepbeep"
              | "bell_sound"
              | "escalate"
              | "invasion"
              | "intrusive"
              | "pling"
              | "pling_high"
              | "pling_low"
              | "shake"
              | "silence"
              | "tf012"
              | "tf015"
              | "tf019"
              | "tf021"
              | "tf026"
              | "tf029"
              | "tf200"
              | "tf201"
              | "tf202"
              | "tf203"
              | "tf204"
              | "tf205"
              | "tf206"
              | "tf207"
              | "tf208"
              | "tf209"
              | "tf210"
              | "tf211"
              | "tf212"
              | "tf213"
              | "tf214"
              | "tf215"
              | "tf216"
              | "tf217"
              | "tf218"
              | "tf219"
              | "tf220"
              | "tf221"
              | "tf222"
              | "tf223"
              | "tf224"
              | "tf225"
              | "tf226"
              | "tf227"
              | "tf228"
              | "tf229"
              | "tf230"
              | "tornado"
              | "wakeup";
            /**
             * @min 0
             * @exclusiveMin false
             * @max 1
             * @exclusiveMax false
             */
            volume: number;
            loop: boolean;
            enabled: boolean;
          };
        };
      }[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.notifications.connect.enabled"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.notifications.connect.onlyInModesOn"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.notifications.connect.delay"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.notifications.disconnect.enabled"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.notifications.disconnect.onlyInModesOn"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.notifications.disconnect.delay"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.notifications.alarm"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.notifications.batteryLow"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.forceHoldConfig.enabled"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.forceHoldConfig.count"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.forceHoldConfig.duration"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.preAlarm.enabled"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.preAlarm.sound.sound"?: {
      value:
        | "alarm"
        | "alarmclock"
        | "beepbeep"
        | "bell_sound"
        | "escalate"
        | "invasion"
        | "intrusive"
        | "pling"
        | "pling_high"
        | "pling_low"
        | "shake"
        | "silence"
        | "tf012"
        | "tf015"
        | "tf019"
        | "tf021"
        | "tf026"
        | "tf029"
        | "tf200"
        | "tf201"
        | "tf202"
        | "tf203"
        | "tf204"
        | "tf205"
        | "tf206"
        | "tf207"
        | "tf208"
        | "tf209"
        | "tf210"
        | "tf211"
        | "tf212"
        | "tf213"
        | "tf214"
        | "tf215"
        | "tf216"
        | "tf217"
        | "tf218"
        | "tf219"
        | "tf220"
        | "tf221"
        | "tf222"
        | "tf223"
        | "tf224"
        | "tf225"
        | "tf226"
        | "tf227"
        | "tf228"
        | "tf229"
        | "tf230"
        | "tornado"
        | "wakeup";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.preAlarm.sound.volume"?: {
      /**
       * @min 0
       * @exclusiveMin false
       * @max 1
       * @exclusiveMax false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.preAlarm.sound.loop"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.preAlarm.sound.enabled"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "externalAlarmButtons.preAlarm.duration"?: {
      /**
       * @min 0
       * @exclusiveMin true
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
  };
  setGroups?: {
    /** @format uuid */
    _id: string;
    _ref: "ClientConfigGroup";
  }[];
}

export interface ClientConfigUpdateKioskV0Dto {
  clear?: boolean;
  index?: number;
  setKeys?: {
    managed?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    zone?: {
      value: {
        /** @format uuid */
        _id: string;
        _ref: "Zone";
      } | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    exposeAssets?: {
      value:
        | {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[]
        | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    exposeLabels?: {
      value:
        | {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
            countLabel?: boolean;
          }[]
        | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    schedule?: {
      value:
        | {
            daysOfWeek: number[];
            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
            timeStart: string;
            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
            timeEnd: string;
          }[]
        | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "homepage.incidentCounter.enabled"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "homepage.incidentCounter.countFromDate"?: {
      /** @format date-time */
      value: string | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "homepage.incidentCounter.threshold"?: {
      /**
       * @min 0
       * @exclusiveMin false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "homepage.anonymous"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "homepage.logo"?: {
      /** @format uri */
      value: string | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "alarm.enabled"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "alarm.focus"?: {
      value: {
        severity: "red" | "orange" | "green";
        flash: boolean;
        sound: {
          enabled: boolean;
          /**
           * @min 0
           * @exclusiveMin false
           * @max 100
           * @exclusiveMax false
           */
          volume?: number | null;
          sound?:
            | "alarm"
            | "alarmClock"
            | "alarmRetro"
            | "announcement"
            | "attention"
            | "bassPulse"
            | "beepBeep"
            | "beepBurglar"
            | "beepContinuous"
            | "beepHighSoft"
            | "beepIncremental"
            | "bell"
            | "car"
            | "chickens"
            | "chime"
            | "chirpSoft"
            | "clockMelody"
            | "countdownSonar"
            | "doorbell"
            | "escalate"
            | "fancy"
            | "fastAndNervous"
            | "harp"
            | "incomingPhone"
            | "introduction"
            | "intrusive"
            | "invasion"
            | "jungle"
            | "lofiChords"
            | "loopLow"
            | "melodySoft"
            | "notifySubtle"
            | "onOff"
            | "orchestral"
            | "pling"
            | "plingHigh"
            | "plingLow"
            | "pluckSong"
            | "quick"
            | "scanning"
            | "shake"
            | "silence"
            | "sirenHigh"
            | "sirenLow"
            | "soft"
            | "spaceship"
            | "startup"
            | "threeTones"
            | "tornado"
            | "wailing"
            | "wakeup"
            | null;
          /**
           * @min 0
           * @exclusiveMin false
           */
          stopAfterSeconds?: number | null;
          stopAfterTouch?: boolean | null;
        };
      }[];
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "alarm.showPositionLabels"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "alarm.anonymous"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "alarm.acknowledge.enabled"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "alarm.acknowledge.pin"?: {
      /** @pattern ^[0-9]{4,6}$ */
      value: string | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "alarm.acknowledge.messagePresets"?: {
      value: string[] | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "alarm.mode"?: {
      /** @default "customerBased" */
      value?: "zoneBased" | "customerBased";
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "manageAvailability.enabled"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "manageAvailability.pin"?: {
      /** @pattern ^[0-9]{4,6}$ */
      value: string | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "manageAvailability.showAppBanner"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "manageAvailability.forceShowSearch"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "manageAvailability.forceShowLabelFilter"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "hardware.screenBrightness"?: {
      /**
       * @min 0
       * @exclusiveMin false
       * @max 100
       * @exclusiveMax false
       * @default 100
       */
      value?: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "visitorMode.enableVisitorMode"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "visitorMode.visitorEnabledHomepage.displayFastCheckInInstruction"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "visitorMode.visitorCheckInOptions.enableKeyboardCheckin"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "visitorMode.visitorCheckInForm.requireVisitorCompany"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "visitorMode.visitorCheckInForm.requireVisitDuration"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "visitorMode.visitorWelcomeScreen.heading"?: {
      value: string | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "visitorMode.visitorWelcomeScreen.subheading"?: {
      value: string | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "visitorMode.visitorWelcomeScreen.displayHostNotificationConfirmation"?: {
      value: boolean;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "visitorMode.visitorWelcomeScreen.screenDuration"?: {
      /**
       * @min 10
       * @exclusiveMin false
       * @max 120
       * @exclusiveMax false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "visitorMode.visitorExitScreen.heading"?: {
      value: string | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "visitorMode.visitorExitScreen.subheading"?: {
      value: string | null;
      editableBy?: ("AssetGroup" | "Device")[];
    };
    "visitorMode.visitorExitScreen.screenDuration"?: {
      /**
       * @min 10
       * @exclusiveMin false
       * @max 120
       * @exclusiveMax false
       */
      value: number;
      editableBy?: ("AssetGroup" | "Device")[];
    };
  };
  setGroups?: {
    /** @format uuid */
    _id: string;
    _ref: "ClientConfigGroup";
  }[];
}

export interface ContactListCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  /**
   * PII
   * @maxLength 1024
   * @default null
   */
  description?: string | null;
  contacts: {
    /**
     * PII
     * @maxLength 1024
     */
    name: string;
    /**
     * PII
     * @maxLength 1024
     */
    phone: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    email: string | null;
  }[];
}

export interface ContactListOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  /**
   * PII
   * @maxLength 1024
   * @default null
   */
  description?: string | null;
  contacts: {
    /**
     * PII
     * @maxLength 1024
     */
    name: string;
    /**
     * PII
     * @maxLength 1024
     */
    phone: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    email: string | null;
  }[];
}

export interface ContactListUpdateDto {
  /**
   * PII
   * @maxLength 1024
   */
  name?: string;
  /**
   * PII
   * @maxLength 1024
   * @default null
   */
  description?: string | null;
  contacts?: {
    /**
     * PII
     * @maxLength 1024
     */
    name: string;
    /**
     * PII
     * @maxLength 1024
     */
    phone: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    email: string | null;
  }[];
}

export interface CreateMapboxTokenOutputDto {
  accessToken: string;
  expiresAt: string;
}

export interface CreateSupportChatIdentityOutputDto {
  identityToken: string;
  email: string;
}

export interface CreateTwilioVoiceTokenDto {
  deviceId: string;
  platform: "ios" | "android";
  bundleId: "nl.xguard.alarm" | "nl.bhvknop.app";
}

export interface CreateTwilioVoiceTokenOutputDto {
  accessToken: string;
}

export interface CustomerAlarmCenterRelationCreateDto {
  /** @maxLength 1024 */
  migrationKey?: string;
  alarmCenter: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  enabled: boolean;
  zones:
    | {
        /** @format uuid */
        _id: string;
        _ref: "Zone";
      }[]
    | null;
  priority?: number;
}

export interface CustomerAlarmCenterRelationOutboundPhoneNumbersOutputDto {
  alarmCenter: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
    /**
     * PII
     * @maxLength 1024
     */
    name: string;
  };
  outboundPhoneNumbers: string[];
}

export interface CustomerAlarmCenterRelationOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @maxLength 1024 */
  migrationKey?: string;
  alarmCenter: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  enabled: boolean;
  zones:
    | {
        /** @format uuid */
        _id: string;
        _ref: "Zone";
      }[]
    | null;
  priority?: number;
}

export interface CustomerAlarmCenterRelationUpdateDto {
  /** @maxLength 1024 */
  migrationKey?: string;
  alarmCenter?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  enabled?: boolean;
  zones?:
    | {
        /** @format uuid */
        _id: string;
        _ref: "Zone";
      }[]
    | null;
  priority?: number;
}

export interface CustomerAlarmProcessRelationCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  alarmProcess: {
    /** @format uuid */
    _id: string;
    _ref: "AlarmProcess";
  }[];
  filter: {
    alarmSeverities: {
      include: ("red" | "orange" | "green")[];
      exclude: ("red" | "orange" | "green")[];
    };
    alarmTypes: {
      include: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[];
      exclude: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[];
    };
    assetGroups: {
      include: {
        someGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        multipleGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        exactMatchGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
      };
      exclude: {
        someGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        multipleGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        exactMatchGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
      };
    };
  }[];
}

export interface CustomerAlarmProcessRelationOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  alarmProcess: {
    /** @format uuid */
    _id: string;
    _ref: "AlarmProcess";
  }[];
  filter: {
    alarmSeverities: {
      include: ("red" | "orange" | "green")[];
      exclude: ("red" | "orange" | "green")[];
    };
    alarmTypes: {
      include: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[];
      exclude: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[];
    };
    assetGroups: {
      include: {
        someGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        multipleGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        exactMatchGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
      };
      exclude: {
        someGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        multipleGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        exactMatchGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
      };
    };
  }[];
}

export interface CustomerAlarmProcessRelationUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  alarmProcess?: {
    /** @format uuid */
    _id: string;
    _ref: "AlarmProcess";
  }[];
  filter?: {
    alarmSeverities: {
      include: ("red" | "orange" | "green")[];
      exclude: ("red" | "orange" | "green")[];
    };
    alarmTypes: {
      include: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[];
      exclude: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[];
    };
    assetGroups: {
      include: {
        someGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        multipleGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        exactMatchGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
      };
      exclude: {
        someGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        multipleGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        exactMatchGroups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
      };
    };
  }[];
}

export interface CustomerCreateDto {
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  /** @default null */
  parent?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  } | null;
  /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
  locale: string;
  /**
   * @maxLength 1024
   * @default "Europe/Amsterdam"
   */
  timeZone?: string;
  /**
   * PII
   * @default null
   */
  alarmCenter?: {
    enabled: boolean;
    /** @maxLength 1024 */
    queueName?: string;
    /**
     * PII
     * @maxLength 1024
     */
    callbackPhoneNumber?: string;
    /** PII */
    outboundPhoneNumbers?: string[];
  } | null;
  survey?: {
    enabled: boolean;
  };
  /**
   * PII
   * @default null
   */
  responsePartner?: {
    enabled: boolean;
  } | null;
  /** @default [] */
  responsePartners?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  }[];
  /** @default [] */
  billingContracts?: string[];
  preferences?: {
    alarmAgeLimit?: {
      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
      value: number;
    } | null;
    mergeConfig?: {
      enabled: boolean;
      onlyMergeWhenSame: {
        name: boolean;
        severity: boolean;
        type: boolean;
      };
      maxTimeBetweenAlarmsMs: number;
      retriggerAtsAfterMs: number;
    } | null;
    disableAutomaticGenerationOfButtonZones?: boolean | null;
    recurringTasksEnabled?: boolean | null;
    securityInventoryEnabled?: boolean | null;
    enableZoneEnterExitEvents?: boolean | null;
  };
  loraConfig?:
    | (
        | {
            type: "adeunis.arf8123aa";
            config: {
              /** @maxLength 1024 */
              fieldTest: string;
            };
          }
        | {
            type: "iotracker.v2";
            config: {
              /** @maxLength 1024 */
              beaconScan: string;
              /** @maxLength 1024 */
              gps: string;
              /** @maxLength 1024 */
              preMandown: string;
              /** @maxLength 1024 */
              mandown: string;
              /** @maxLength 1024 */
              movement: string;
              /** @maxLength 1024 */
              alarmSeverity: string;
              /** @maxLength 1024 */
              alive: string;
            };
          }
        | {
            type: "milesight.ws101";
            config: {
              /** @maxLength 1024 */
              beaconScan: string;
              /** @maxLength 1024 */
              alarmSeverity: string;
              /** @maxLength 1024 */
              alive: string;
            };
          }
        | {
            type: "sensative.1301001";
            config: {
              /** @maxLength 1024 */
              alarmSeverity: string;
              /** @maxLength 1024 */
              alive: string;
              /** @maxLength 1024 */
              floodDetected: string;
              /** @maxLength 1024 */
              noFloodDetected: string;
            };
          }
      )[]
    | null;
  kioskConfig?: {
    /** @default false */
    managed?: boolean;
    zone?: {
      /** @format uuid */
      _id: string;
      _ref: "Zone";
    } | null;
    exposeAssets?:
      | {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[]
      | null;
    exposeLabels?:
      | {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
          countLabel?: boolean;
        }[]
      | null;
    schedule?: {
      entries: {
        daysOfWeek: number[];
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeStart: string;
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeEnd: string;
      }[];
    } | null;
    homepage?: {
      incidentCounter?: {
        /** @default true */
        enabled?: boolean;
        /** @format date-time */
        countFromDate?: string | null;
        /**
         * @min 0
         * @exclusiveMin false
         * @default 0
         */
        threshold?: number;
      };
      /** @default true */
      anonymous?: boolean;
      /** @format uri */
      logo?: string | null;
    };
    alarm?: {
      /** @default true */
      enabled?: boolean;
      focus?: {
        red?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
        orange?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
        green?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
      };
      /** @default true */
      showPositionLabels?: boolean;
      /** @default true */
      anonymous?: boolean;
      acknowledge?: {
        enabled?: boolean;
        /** @pattern ^[0-9]{4,6}$ */
        pin?: string | null;
        messagePresets?: string[] | null;
      };
      mode?: "zoneBased" | "customerBased" | null;
    };
    manageAvailability?: {
      /** @default true */
      enabled?: boolean;
      /** @pattern ^[0-9]{4,6}$ */
      pin?: string | null;
      /** @default true */
      showAppBanner?: boolean;
      /** @default false */
      forceShowSearch?: boolean;
      /** @default false */
      forceShowLabelFilter?: boolean;
    };
    hardware?: {
      /**
       * @min 0
       * @exclusiveMin false
       * @max 100
       * @exclusiveMax false
       */
      screenBrightness?: number | null;
    };
  };
  type?: "default" | "bhvk_paid" | "bhvk_trial";
  userPolicies?: {
    disablePasswordlessLogin?: boolean;
  };
  clientConfig?: {
    app?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
    kiosk?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
  };
}

export interface CustomerOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  /** @default null */
  parent?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  } | null;
  parents: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  }[];
  children: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  }[];
  /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
  locale: string;
  /**
   * @maxLength 1024
   * @default "Europe/Amsterdam"
   */
  timeZone?: string;
  /**
   * PII
   * @default null
   */
  alarmCenter?: {
    enabled: boolean;
    /** @maxLength 1024 */
    queueName?: string;
    /**
     * PII
     * @maxLength 1024
     */
    callbackPhoneNumber?: string;
    /** PII */
    outboundPhoneNumbers?: string[];
  } | null;
  survey?: {
    enabled: boolean;
  };
  /**
   * PII
   * @default null
   */
  responsePartner?: {
    enabled: boolean;
  } | null;
  /** @default [] */
  responsePartners?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  }[];
  /** @default [] */
  billingContracts?: string[];
  preferences?: {
    alarmAgeLimit?: {
      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
      value: number;
    } | null;
    mergeConfig?: {
      enabled: boolean;
      onlyMergeWhenSame: {
        name: boolean;
        severity: boolean;
        type: boolean;
      };
      maxTimeBetweenAlarmsMs: number;
      retriggerAtsAfterMs: number;
    } | null;
    disableAutomaticGenerationOfButtonZones?: boolean | null;
    recurringTasksEnabled?: boolean | null;
    securityInventoryEnabled?: boolean | null;
    enableZoneEnterExitEvents?: boolean | null;
  };
  loraConfig?:
    | (
        | {
            type: "adeunis.arf8123aa";
            config: {
              /** @maxLength 1024 */
              fieldTest: string;
            };
          }
        | {
            type: "iotracker.v2";
            config: {
              /** @maxLength 1024 */
              beaconScan: string;
              /** @maxLength 1024 */
              gps: string;
              /** @maxLength 1024 */
              preMandown: string;
              /** @maxLength 1024 */
              mandown: string;
              /** @maxLength 1024 */
              movement: string;
              /** @maxLength 1024 */
              alarmSeverity: string;
              /** @maxLength 1024 */
              alive: string;
            };
          }
        | {
            type: "milesight.ws101";
            config: {
              /** @maxLength 1024 */
              beaconScan: string;
              /** @maxLength 1024 */
              alarmSeverity: string;
              /** @maxLength 1024 */
              alive: string;
            };
          }
        | {
            type: "sensative.1301001";
            config: {
              /** @maxLength 1024 */
              alarmSeverity: string;
              /** @maxLength 1024 */
              alive: string;
              /** @maxLength 1024 */
              floodDetected: string;
              /** @maxLength 1024 */
              noFloodDetected: string;
            };
          }
      )[]
    | null;
  kioskConfig?: {
    /** @default false */
    managed?: boolean;
    zone?: {
      /** @format uuid */
      _id: string;
      _ref: "Zone";
    } | null;
    exposeAssets?:
      | {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[]
      | null;
    exposeLabels?:
      | {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
          countLabel?: boolean;
        }[]
      | null;
    schedule?: {
      entries: {
        daysOfWeek: number[];
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeStart: string;
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeEnd: string;
      }[];
    } | null;
    homepage?: {
      incidentCounter?: {
        /** @default true */
        enabled?: boolean;
        /** @format date-time */
        countFromDate?: string | null;
        /**
         * @min 0
         * @exclusiveMin false
         * @default 0
         */
        threshold?: number;
      };
      /** @default true */
      anonymous?: boolean;
      /** @format uri */
      logo?: string | null;
    };
    alarm?: {
      /** @default true */
      enabled?: boolean;
      focus?: {
        red?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
        orange?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
        green?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
      };
      /** @default true */
      showPositionLabels?: boolean;
      /** @default true */
      anonymous?: boolean;
      acknowledge?: {
        enabled?: boolean;
        /** @pattern ^[0-9]{4,6}$ */
        pin?: string | null;
        messagePresets?: string[] | null;
      };
      mode?: "zoneBased" | "customerBased" | null;
    };
    manageAvailability?: {
      /** @default true */
      enabled?: boolean;
      /** @pattern ^[0-9]{4,6}$ */
      pin?: string | null;
      /** @default true */
      showAppBanner?: boolean;
      /** @default false */
      forceShowSearch?: boolean;
      /** @default false */
      forceShowLabelFilter?: boolean;
    };
    hardware?: {
      /**
       * @min 0
       * @exclusiveMin false
       * @max 100
       * @exclusiveMax false
       */
      screenBrightness?: number | null;
    };
  };
  type?: "default" | "bhvk_paid" | "bhvk_trial";
  userPolicies?: {
    disablePasswordlessLogin?: boolean;
  };
  clientConfig?: {
    app?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
    kiosk?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
  };
}

export interface CustomerUpdateDto {
  /**
   * PII
   * @maxLength 1024
   */
  name?: string;
  /** @default null */
  parent?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  } | null;
  /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
  locale?: string;
  /**
   * @maxLength 1024
   * @default "Europe/Amsterdam"
   */
  timeZone?: string;
  /**
   * PII
   * @default null
   */
  alarmCenter?: {
    enabled: boolean;
    /** @maxLength 1024 */
    queueName?: string;
    /**
     * PII
     * @maxLength 1024
     */
    callbackPhoneNumber?: string;
    /** PII */
    outboundPhoneNumbers?: string[];
  } | null;
  survey?: {
    enabled: boolean;
  };
  /**
   * PII
   * @default null
   */
  responsePartner?: {
    enabled: boolean;
  } | null;
  /** @default [] */
  responsePartners?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  }[];
  /** @default [] */
  billingContracts?: string[];
  preferences?: {
    alarmAgeLimit?: {
      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
      value: number;
    } | null;
    mergeConfig?: {
      enabled: boolean;
      onlyMergeWhenSame: {
        name: boolean;
        severity: boolean;
        type: boolean;
      };
      maxTimeBetweenAlarmsMs: number;
      retriggerAtsAfterMs: number;
    } | null;
    disableAutomaticGenerationOfButtonZones?: boolean | null;
    recurringTasksEnabled?: boolean | null;
    securityInventoryEnabled?: boolean | null;
    enableZoneEnterExitEvents?: boolean | null;
  };
  loraConfig?:
    | (
        | {
            type: "adeunis.arf8123aa";
            config: {
              /** @maxLength 1024 */
              fieldTest: string;
            };
          }
        | {
            type: "iotracker.v2";
            config: {
              /** @maxLength 1024 */
              beaconScan: string;
              /** @maxLength 1024 */
              gps: string;
              /** @maxLength 1024 */
              preMandown: string;
              /** @maxLength 1024 */
              mandown: string;
              /** @maxLength 1024 */
              movement: string;
              /** @maxLength 1024 */
              alarmSeverity: string;
              /** @maxLength 1024 */
              alive: string;
            };
          }
        | {
            type: "milesight.ws101";
            config: {
              /** @maxLength 1024 */
              beaconScan: string;
              /** @maxLength 1024 */
              alarmSeverity: string;
              /** @maxLength 1024 */
              alive: string;
            };
          }
        | {
            type: "sensative.1301001";
            config: {
              /** @maxLength 1024 */
              alarmSeverity: string;
              /** @maxLength 1024 */
              alive: string;
              /** @maxLength 1024 */
              floodDetected: string;
              /** @maxLength 1024 */
              noFloodDetected: string;
            };
          }
      )[]
    | null;
  kioskConfig?: {
    /** @default false */
    managed?: boolean;
    zone?: {
      /** @format uuid */
      _id: string;
      _ref: "Zone";
    } | null;
    exposeAssets?:
      | {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[]
      | null;
    exposeLabels?:
      | {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
          countLabel?: boolean;
        }[]
      | null;
    schedule?: {
      entries: {
        daysOfWeek: number[];
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeStart: string;
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeEnd: string;
      }[];
    } | null;
    homepage?: {
      incidentCounter?: {
        /** @default true */
        enabled?: boolean;
        /** @format date-time */
        countFromDate?: string | null;
        /**
         * @min 0
         * @exclusiveMin false
         * @default 0
         */
        threshold?: number;
      };
      /** @default true */
      anonymous?: boolean;
      /** @format uri */
      logo?: string | null;
    };
    alarm?: {
      /** @default true */
      enabled?: boolean;
      focus?: {
        red?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
        orange?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
        green?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
      };
      /** @default true */
      showPositionLabels?: boolean;
      /** @default true */
      anonymous?: boolean;
      acknowledge?: {
        enabled?: boolean;
        /** @pattern ^[0-9]{4,6}$ */
        pin?: string | null;
        messagePresets?: string[] | null;
      };
      mode?: "zoneBased" | "customerBased" | null;
    };
    manageAvailability?: {
      /** @default true */
      enabled?: boolean;
      /** @pattern ^[0-9]{4,6}$ */
      pin?: string | null;
      /** @default true */
      showAppBanner?: boolean;
      /** @default false */
      forceShowSearch?: boolean;
      /** @default false */
      forceShowLabelFilter?: boolean;
    };
    hardware?: {
      /**
       * @min 0
       * @exclusiveMin false
       * @max 100
       * @exclusiveMax false
       */
      screenBrightness?: number | null;
    };
  };
  type?: "default" | "bhvk_paid" | "bhvk_trial";
  userPolicies?: {
    disablePasswordlessLogin?: boolean;
  };
  clientConfig?: {
    app?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
    kiosk?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
  };
}

export interface CustomerUserRelationCreateAccessRequestDto {
  /** @maxLength 1024 */
  migrationKey?: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** PII */
  roles: string[];
  assetGroupRestrictions?:
    | {
        /** @format uuid */
        _id: string;
        _ref: "AssetGroup";
      }[]
    | null;
  accessRequest: {
    /** @minLength 10 */
    reason: string;
    /** @format date-time */
    validUntil: string;
  };
}

export interface CustomerUserRelationCreateDto {
  /** @maxLength 1024 */
  migrationKey?: string;
  user: {
    /** @format uuid */
    _id: string;
    _ref: "User";
  };
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** PII */
  roles: string[];
  assetGroupRestrictions?:
    | {
        /** @format uuid */
        _id: string;
        _ref: "AssetGroup";
      }[]
    | null;
  accessRequest?: {
    /** @format date-time */
    validUntil: string;
    reason: string;
    review:
      | {
          type: "approved";
          /** PII */
          reviewedBy: {
            /** @format uuid */
            _id: string;
            _ref: "User";
          };
          /** @format date-time */
          reviewedAt: string;
          forced: boolean;
        }
      | {
          type: "rejected";
          /** PII */
          reviewedBy: {
            /** @format uuid */
            _id: string;
            _ref: "User";
          };
          /** @format date-time */
          reviewedAt: string;
          reason: string;
        }
      | null;
  };
}

export interface CustomerUserRelationOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @maxLength 1024 */
  migrationKey?: string;
  user: {
    /** @format uuid */
    _id: string;
    _ref: "User";
  };
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** PII */
  roles: string[];
  assetGroupRestrictions?:
    | {
        /** @format uuid */
        _id: string;
        _ref: "AssetGroup";
      }[]
    | null;
  accessRequest?: {
    /** @format date-time */
    validUntil: string;
    reason: string;
    review:
      | {
          type: "approved";
          /** PII */
          reviewedBy: {
            /** @format uuid */
            _id: string;
            _ref: "User";
          };
          /** @format date-time */
          reviewedAt: string;
          forced: boolean;
        }
      | {
          type: "rejected";
          /** PII */
          reviewedBy: {
            /** @format uuid */
            _id: string;
            _ref: "User";
          };
          /** @format date-time */
          reviewedAt: string;
          reason: string;
        }
      | null;
  };
}

export interface CustomerUserRelationReviewAccessRequestDto {
  review:
    | {
        type: "approved";
      }
    | {
        type: "rejected";
        /** @minLength 10 */
        reason: string;
      };
}

export interface CustomerUserRelationUpdateDto {
  /** @maxLength 1024 */
  migrationKey?: string;
  user?: {
    /** @format uuid */
    _id: string;
    _ref: "User";
  };
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** PII */
  roles?: string[];
  assetGroupRestrictions?:
    | {
        /** @format uuid */
        _id: string;
        _ref: "AssetGroup";
      }[]
    | null;
  accessRequest?: {
    /** @format date-time */
    validUntil: string;
    reason: string;
    review:
      | {
          type: "approved";
          /** PII */
          reviewedBy: {
            /** @format uuid */
            _id: string;
            _ref: "User";
          };
          /** @format date-time */
          reviewedAt: string;
          forced: boolean;
        }
      | {
          type: "rejected";
          /** PII */
          reviewedBy: {
            /** @format uuid */
            _id: string;
            _ref: "User";
          };
          /** @format date-time */
          reviewedAt: string;
          reason: string;
        }
      | null;
  };
}

export interface DeviceCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  asset: {
    /** @format uuid */
    _id: string;
    _ref: "Asset";
  } | null;
  /**
   * PII
   * @maxLength 1024
   */
  name?: string;
  /**
   * PII
   * @maxLength 1024
   */
  deviceId: string;
  type: "appDevice" | "lora" | "loraGateway" | "flic" | "generic" | "kiosk";
  loraConfig?:
    | {
        type: "adeunis.arf8123aa";
        config: {
          /** @maxLength 1024 */
          fieldTest: string;
        };
      }
    | {
        type: "iotracker.v2";
        config: {
          /** @maxLength 1024 */
          beaconScan: string;
          /** @maxLength 1024 */
          gps: string;
          /** @maxLength 1024 */
          preMandown: string;
          /** @maxLength 1024 */
          mandown: string;
          /** @maxLength 1024 */
          movement: string;
          /** @maxLength 1024 */
          alarmSeverity: string;
          /** @maxLength 1024 */
          alive: string;
        };
      }
    | {
        type: "milesight.ws101";
        config: {
          /** @maxLength 1024 */
          beaconScan: string;
          /** @maxLength 1024 */
          alarmSeverity: string;
          /** @maxLength 1024 */
          alive: string;
        };
      }
    | {
        type: "sensative.1301001";
        config: {
          /** @maxLength 1024 */
          alarmSeverity: string;
          /** @maxLength 1024 */
          alive: string;
          /** @maxLength 1024 */
          floodDetected: string;
          /** @maxLength 1024 */
          noFloodDetected: string;
        };
      }
    | null;
  kioskConfig?: {
    /** @default false */
    managed?: boolean;
    zone?: {
      /** @format uuid */
      _id: string;
      _ref: "Zone";
    } | null;
    exposeAssets?:
      | {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[]
      | null;
    exposeLabels?:
      | {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
          countLabel?: boolean;
        }[]
      | null;
    schedule?: {
      entries: {
        daysOfWeek: number[];
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeStart: string;
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeEnd: string;
      }[];
    } | null;
    homepage?: {
      incidentCounter?: {
        /** @default true */
        enabled?: boolean;
        /** @format date-time */
        countFromDate?: string | null;
        /**
         * @min 0
         * @exclusiveMin false
         * @default 0
         */
        threshold?: number;
      };
      /** @default true */
      anonymous?: boolean;
      /** @format uri */
      logo?: string | null;
    };
    alarm?: {
      /** @default true */
      enabled?: boolean;
      focus?: {
        red?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
        orange?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
        green?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
      };
      /** @default true */
      showPositionLabels?: boolean;
      /** @default true */
      anonymous?: boolean;
      acknowledge?: {
        enabled?: boolean;
        /** @pattern ^[0-9]{4,6}$ */
        pin?: string | null;
        messagePresets?: string[] | null;
      };
      mode?: "zoneBased" | "customerBased" | null;
    };
    manageAvailability?: {
      /** @default true */
      enabled?: boolean;
      /** @pattern ^[0-9]{4,6}$ */
      pin?: string | null;
      /** @default true */
      showAppBanner?: boolean;
      /** @default false */
      forceShowSearch?: boolean;
      /** @default false */
      forceShowLabelFilter?: boolean;
    };
    hardware?: {
      /**
       * @min 0
       * @exclusiveMin false
       * @max 100
       * @exclusiveMax false
       */
      screenBrightness?: number | null;
    };
  };
  battery?: number;
  rssi?: number;
  snr?: number;
  app?: {
    permissions?: {
      calendar?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      camera?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      contacts?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      microphone?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      notifications?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      criticalNotifications?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      motion?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      bluetooth?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      locationAlways?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      locationWhenInUse?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      physical?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      batteryOptimization?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      overlay?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
    };
    deviceOs?: {
      osType: "ios" | "android";
      /** @maxLength 1024 */
      osVersion: string;
      /** @maxLength 1024 */
      osId?: string;
      /** @maxLength 1024 */
      buildNumber?: string;
      /** @maxLength 1024 */
      bundleId?: string;
    };
    profile?: {
      /** @maxLength 1024 */
      name?: string;
      /** @maxLength 1024 */
      brand?: string;
      /** @maxLength 1024 */
      model?: string;
      /** @maxLength 1024 */
      carrier?: string;
    };
  } | null;
  clientConfig?: {
    app?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
    kiosk?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
  };
}

export interface DeviceGetSyncToAmsZonesRequestDto {
  /** @format uuid */
  deviceId: string;
}

export interface DeviceGetSyncToAmsZonesResponseDto {
  geofence: {
    radius: number;
    center: number[];
  };
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  telluId?: number | null;
  migrationFinalised?: boolean | null;
  /** @format date-time */
  migrationFinalisedDate?: string | null;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  type:
    | "default"
    | "responseArea"
    | "policeDepartment"
    | "assetMonitoredArea"
    | "fingerprinted"
    | "building"
    | "evacuationPoint";
  /** PII */
  location:
    | {
        type: "Polygon";
        /** PII */
        coordinates: number[][][];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      }
    | {
        type: "MultiPolygon";
        coordinates: number[][][][];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      };
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  /**
   * PII
   * @maxLength 1024
   * @default null
   */
  description?: string | null;
  /** @default [] */
  staticResponders?: {
    staticResponder: {
      /** @format uuid */
      _id: string;
      _ref: "StaticResponder";
    };
    priority: number;
  }[];
  /** @default null */
  responsePriority?: number | null;
  assetsInside: {
    /** @format uuid */
    _id: string;
    _ref: "Asset";
  }[];
  syncToAms?: boolean;
}

export interface DeviceHasBeaconsOrFingerprintsRequestDto {
  /** @format uuid */
  deviceId: string;
}

export interface DeviceHasBeaconsOrFingerprintsResponseDto {
  hasBeaconsOrFingerprints: boolean;
}

export interface DeviceLogUploadCreateDto {
  device: {
    /** @format uuid */
    _id: string;
    _ref: "Device";
  };
  /** @minItems 1 */
  entries: {
    severity: "debug" | "info" | "warning" | "error";
    location: string;
    message: string;
    timestamp: number;
    ctx: Record<string, any>;
  }[];
}

export interface DeviceLogUploadOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  device: {
    /** @format uuid */
    _id: string;
    _ref: "Device";
  };
  logCount: number;
  logCountBySeverity: {
    debug: number;
    info: number;
    warning: number;
    error: number;
  };
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
}

export interface DeviceOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  asset: {
    /** @format uuid */
    _id: string;
    _ref: "Asset";
  } | null;
  /**
   * PII
   * @maxLength 1024
   */
  name?: string;
  /**
   * PII
   * @maxLength 1024
   */
  deviceId: string;
  type: "appDevice" | "lora" | "loraGateway" | "flic" | "generic" | "kiosk";
  loraConfig?:
    | {
        type: "adeunis.arf8123aa";
        config: {
          /** @maxLength 1024 */
          fieldTest: string;
        };
      }
    | {
        type: "iotracker.v2";
        config: {
          /** @maxLength 1024 */
          beaconScan: string;
          /** @maxLength 1024 */
          gps: string;
          /** @maxLength 1024 */
          preMandown: string;
          /** @maxLength 1024 */
          mandown: string;
          /** @maxLength 1024 */
          movement: string;
          /** @maxLength 1024 */
          alarmSeverity: string;
          /** @maxLength 1024 */
          alive: string;
        };
      }
    | {
        type: "milesight.ws101";
        config: {
          /** @maxLength 1024 */
          beaconScan: string;
          /** @maxLength 1024 */
          alarmSeverity: string;
          /** @maxLength 1024 */
          alive: string;
        };
      }
    | {
        type: "sensative.1301001";
        config: {
          /** @maxLength 1024 */
          alarmSeverity: string;
          /** @maxLength 1024 */
          alive: string;
          /** @maxLength 1024 */
          floodDetected: string;
          /** @maxLength 1024 */
          noFloodDetected: string;
        };
      }
    | null;
  kioskConfig?: {
    /** @default false */
    managed?: boolean;
    zone?: {
      /** @format uuid */
      _id: string;
      _ref: "Zone";
    } | null;
    exposeAssets?:
      | {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[]
      | null;
    exposeLabels?:
      | {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
          countLabel?: boolean;
        }[]
      | null;
    schedule?: {
      entries: {
        daysOfWeek: number[];
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeStart: string;
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeEnd: string;
      }[];
    } | null;
    homepage?: {
      incidentCounter?: {
        /** @default true */
        enabled?: boolean;
        /** @format date-time */
        countFromDate?: string | null;
        /**
         * @min 0
         * @exclusiveMin false
         * @default 0
         */
        threshold?: number;
      };
      /** @default true */
      anonymous?: boolean;
      /** @format uri */
      logo?: string | null;
    };
    alarm?: {
      /** @default true */
      enabled?: boolean;
      focus?: {
        red?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
        orange?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
        green?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
      };
      /** @default true */
      showPositionLabels?: boolean;
      /** @default true */
      anonymous?: boolean;
      acknowledge?: {
        enabled?: boolean;
        /** @pattern ^[0-9]{4,6}$ */
        pin?: string | null;
        messagePresets?: string[] | null;
      };
      mode?: "zoneBased" | "customerBased" | null;
    };
    manageAvailability?: {
      /** @default true */
      enabled?: boolean;
      /** @pattern ^[0-9]{4,6}$ */
      pin?: string | null;
      /** @default true */
      showAppBanner?: boolean;
      /** @default false */
      forceShowSearch?: boolean;
      /** @default false */
      forceShowLabelFilter?: boolean;
    };
    hardware?: {
      /**
       * @min 0
       * @exclusiveMin false
       * @max 100
       * @exclusiveMax false
       */
      screenBrightness?: number | null;
    };
  };
  battery?: number;
  rssi?: number;
  snr?: number;
  app?: {
    permissions?: {
      calendar?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      camera?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      contacts?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      microphone?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      notifications?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      criticalNotifications?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      motion?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      bluetooth?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      locationAlways?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      locationWhenInUse?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      physical?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      batteryOptimization?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      overlay?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
    };
    deviceOs?: {
      osType: "ios" | "android";
      /** @maxLength 1024 */
      osVersion: string;
      /** @maxLength 1024 */
      osId?: string;
      /** @maxLength 1024 */
      buildNumber?: string;
      /** @maxLength 1024 */
      bundleId?: string;
    };
    profile?: {
      /** @maxLength 1024 */
      name?: string;
      /** @maxLength 1024 */
      brand?: string;
      /** @maxLength 1024 */
      model?: string;
      /** @maxLength 1024 */
      carrier?: string;
    };
  } | null;
  clientConfig?: {
    app?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
    kiosk?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
  };
}

export interface DeviceReloginNotificationDto {
  deviceId: string;
}

export interface DeviceUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  asset?: {
    /** @format uuid */
    _id: string;
    _ref: "Asset";
  } | null;
  /**
   * PII
   * @maxLength 1024
   */
  name?: string;
  /**
   * PII
   * @maxLength 1024
   */
  deviceId?: string;
  type?: "appDevice" | "lora" | "loraGateway" | "flic" | "generic" | "kiosk";
  loraConfig?:
    | {
        type: "adeunis.arf8123aa";
        config: {
          /** @maxLength 1024 */
          fieldTest: string;
        };
      }
    | {
        type: "iotracker.v2";
        config: {
          /** @maxLength 1024 */
          beaconScan: string;
          /** @maxLength 1024 */
          gps: string;
          /** @maxLength 1024 */
          preMandown: string;
          /** @maxLength 1024 */
          mandown: string;
          /** @maxLength 1024 */
          movement: string;
          /** @maxLength 1024 */
          alarmSeverity: string;
          /** @maxLength 1024 */
          alive: string;
        };
      }
    | {
        type: "milesight.ws101";
        config: {
          /** @maxLength 1024 */
          beaconScan: string;
          /** @maxLength 1024 */
          alarmSeverity: string;
          /** @maxLength 1024 */
          alive: string;
        };
      }
    | {
        type: "sensative.1301001";
        config: {
          /** @maxLength 1024 */
          alarmSeverity: string;
          /** @maxLength 1024 */
          alive: string;
          /** @maxLength 1024 */
          floodDetected: string;
          /** @maxLength 1024 */
          noFloodDetected: string;
        };
      }
    | null;
  kioskConfig?: {
    /** @default false */
    managed?: boolean;
    zone?: {
      /** @format uuid */
      _id: string;
      _ref: "Zone";
    } | null;
    exposeAssets?:
      | {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[]
      | null;
    exposeLabels?:
      | {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
          countLabel?: boolean;
        }[]
      | null;
    schedule?: {
      entries: {
        daysOfWeek: number[];
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeStart: string;
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeEnd: string;
      }[];
    } | null;
    homepage?: {
      incidentCounter?: {
        /** @default true */
        enabled?: boolean;
        /** @format date-time */
        countFromDate?: string | null;
        /**
         * @min 0
         * @exclusiveMin false
         * @default 0
         */
        threshold?: number;
      };
      /** @default true */
      anonymous?: boolean;
      /** @format uri */
      logo?: string | null;
    };
    alarm?: {
      /** @default true */
      enabled?: boolean;
      focus?: {
        red?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
        orange?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
        green?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
      };
      /** @default true */
      showPositionLabels?: boolean;
      /** @default true */
      anonymous?: boolean;
      acknowledge?: {
        enabled?: boolean;
        /** @pattern ^[0-9]{4,6}$ */
        pin?: string | null;
        messagePresets?: string[] | null;
      };
      mode?: "zoneBased" | "customerBased" | null;
    };
    manageAvailability?: {
      /** @default true */
      enabled?: boolean;
      /** @pattern ^[0-9]{4,6}$ */
      pin?: string | null;
      /** @default true */
      showAppBanner?: boolean;
      /** @default false */
      forceShowSearch?: boolean;
      /** @default false */
      forceShowLabelFilter?: boolean;
    };
    hardware?: {
      /**
       * @min 0
       * @exclusiveMin false
       * @max 100
       * @exclusiveMax false
       */
      screenBrightness?: number | null;
    };
  };
  battery?: number;
  rssi?: number;
  snr?: number;
  app?: {
    permissions?: {
      calendar?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      camera?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      contacts?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      microphone?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      notifications?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      criticalNotifications?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      motion?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      bluetooth?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      locationAlways?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      locationWhenInUse?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      physical?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      batteryOptimization?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
      overlay?: {
        status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
        /** @default false */
        alreadyAsked?: boolean;
      };
    };
    deviceOs?: {
      osType: "ios" | "android";
      /** @maxLength 1024 */
      osVersion: string;
      /** @maxLength 1024 */
      osId?: string;
      /** @maxLength 1024 */
      buildNumber?: string;
      /** @maxLength 1024 */
      bundleId?: string;
    };
    profile?: {
      /** @maxLength 1024 */
      name?: string;
      /** @maxLength 1024 */
      brand?: string;
      /** @maxLength 1024 */
      model?: string;
      /** @maxLength 1024 */
      carrier?: string;
    };
  } | null;
  clientConfig?: {
    app?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
    kiosk?: {
      definitions: (
        | {
            type: "key";
            key: string;
            value: any;
            editableBy?: ("AssetGroup" | "Device")[];
          }
        | {
            type: "group";
            group: {
              /** @format uuid */
              _id: string;
              _ref: "ClientConfigGroup";
            };
          }
      )[];
      filter?: {
        type: "osFilter";
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersionRange?: string;
      };
    }[];
  };
}

export interface DisableTwoFactorAuthRequestDto {
  methodId: string;
  code: string;
}

export interface DisableTwoFactorAuthResponseDto {
  success: boolean;
}

export interface DomainLinkCreateDto {
  customers: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  }[];
  /** PII */
  domains: string[];
}

export interface DomainLinkOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customers: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  }[];
  /** PII */
  domains: string[];
}

export interface DomainLinkUpdateDto {
  customers?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  }[];
  /** PII */
  domains?: string[];
}

export interface EmailContactDto {
  to: string[];
  subject: string;
  text?: string;
  html?: string;
}

export interface EnableTwoFactorAuthRequestDto {
  method: "authenticator";
  secretBase32Encoded: string;
  code: string;
}

export interface EnableTwoFactorAuthResponseDto {
  recoveryCodes?: string[];
}

export interface FingerprintCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  zone: {
    /** @format uuid */
    _id: string;
    _ref: "Zone";
  };
  /** PII */
  deviceInfo: {
    /** @maxLength 1024 */
    name: string;
    /** @maxLength 1024 */
    osName: string;
    /** @maxLength 1024 */
    osVersion: string;
    /** @maxLength 1024 */
    brand: string;
    /** @maxLength 1024 */
    model: string;
    /** @maxLength 1024 */
    appBundleId: string;
    /** @maxLength 1024 */
    appVersion: string;
  };
  data: {
    /** @maxLength 1024 */
    code: string;
    rssi: number;
  }[][];
  beaconCodes?: string[];
  enabled?: boolean;
  description?: string;
}

export interface FingerPrintCustomerDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
}

export interface FingerprintOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  zone: {
    /** @format uuid */
    _id: string;
    _ref: "Zone";
  };
  /** PII */
  deviceInfo: {
    /** @maxLength 1024 */
    name: string;
    /** @maxLength 1024 */
    osName: string;
    /** @maxLength 1024 */
    osVersion: string;
    /** @maxLength 1024 */
    brand: string;
    /** @maxLength 1024 */
    model: string;
    /** @maxLength 1024 */
    appBundleId: string;
    /** @maxLength 1024 */
    appVersion: string;
  };
  /**
   * @maxLength 1024
   * @default null
   */
  description?: string | null;
  data: {
    /** @maxLength 1024 */
    code: string;
    rssi: number;
  }[][];
  beaconCodes?: string[];
  user: {
    /** @format uuid */
    _id: string;
    _ref: "User";
  };
  dataCount: number;
  enabled: boolean;
}

export interface FingerprintUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  zone?: {
    /** @format uuid */
    _id: string;
    _ref: "Zone";
  };
  /** PII */
  deviceInfo?: {
    /** @maxLength 1024 */
    name: string;
    /** @maxLength 1024 */
    osName: string;
    /** @maxLength 1024 */
    osVersion: string;
    /** @maxLength 1024 */
    brand: string;
    /** @maxLength 1024 */
    model: string;
    /** @maxLength 1024 */
    appBundleId: string;
    /** @maxLength 1024 */
    appVersion: string;
  };
  /**
   * @maxLength 1024
   * @default null
   */
  description?: string | null;
  beaconCodes?: string[];
  user?: {
    /** @format uuid */
    _id: string;
    _ref: "User";
  };
  enabled?: boolean;
}

export interface GetContextResponse {
  user: {
    /** @format uuid */
    _id: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    telluId?: number | null;
    migrationFinalised?: boolean | null;
    /** @format date-time */
    migrationFinalisedDate?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    username: string;
    /**
     * PII
     * @maxLength 1024
     */
    name: string;
    properties: {
      /**
       * PII
       * @maxLength 1024
       */
      phoneNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      smsNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      email?: string | null;
      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
      locale?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      image?: string | null;
      /** PII */
      rSim?: {
        /**
         * PII
         * @maxLength 1024
         */
        euicc: string;
        primary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        secondary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        enabled: boolean;
      } | null;
    };
    /** @default [] */
    globalRoles?: string[];
    /** @default [] */
    specialPermissions?: string[];
    isServiceAccount?: boolean;
    /**
     * PII
     * @format date-time
     */
    lastActiveAt?: string;
    type?: "default" | "serviceAccount" | "kiosk";
    userPolicies?: {
      disablePasswordlessLogin?: boolean;
    };
  };
  asset: {
    /** @format uuid */
    _id: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    telluId?: number | null;
    migrationFinalised?: boolean | null;
    /** @format date-time */
    migrationFinalisedDate?: string | null;
    customer: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    };
    /** @default {"type":"parents","extra":[]} */
    share?: {
      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
      extra?: {
        /** @format uuid */
        _id: string;
        _ref: "Customer";
      }[];
    };
    user: {
      /** @format uuid */
      _id: string;
      _ref: "User";
    } | null;
    /**
     * PII
     * @maxLength 1024
     */
    name: string;
    /**
     * PII
     * @maxLength 1024
     */
    externalId?: string | null;
    propertiesOwnership?: "override" | "inherit";
    /** @default {} */
    properties?: {
      /**
       * PII
       * @maxLength 1024
       */
      phoneNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      smsNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      email?: string | null;
      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
      locale?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      image?: string | null;
      /** PII */
      rSim?: {
        /**
         * PII
         * @maxLength 1024
         */
        euicc: string;
        primary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        secondary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        enabled: boolean;
      } | null;
    };
    /**
     * PII
     * @default null
     */
    position?: {
      type: "Point";
      /** PII */
      coordinates: number[];
      properties: {
        accuracy?: number;
        heading?: number;
        headingAccuracy?: number;
        speed?: number;
        speedAccuracy?: number;
        altitude?: number;
        altitudeAccuracy?: number;
        /** PII */
        address?: {
          /** @maxLength 1024 */
          countryCode?: string | null;
          /** @maxLength 1024 */
          state?: string | null;
          /** @maxLength 1024 */
          city?: string | null;
          /** @maxLength 1024 */
          streetName?: string | null;
          /** @maxLength 1024 */
          streetNumber?: string | null;
          floor?: number | null;
          /** @maxLength 1024 */
          formattedAddress?: string;
        };
        /** @format date-time */
        dateTime?: string;
        /** @maxLength 1024 */
        provider?: string;
      };
    };
    available: boolean;
    /** @default true */
    allowContactOnOwnAlarms?: boolean;
    app?: {
      mode: "off" | "on" | "risk";
    } | null;
    insideZones: {
      /** @format uuid */
      _id: string;
      _ref: "Zone";
    }[];
    assetGroups: {
      /** @format uuid */
      _id: string;
      _ref: "AssetGroup";
    }[];
    /** @default [] */
    staticResponders?: {
      staticResponder: {
        /** @format uuid */
        _id: string;
        _ref: "StaticResponder";
      };
      priority: number;
    }[];
    /** @format date-time */
    lastObservationAt?: string;
    /** @default false */
    invisibleResponder?: boolean;
    /**
     * PII
     * @maxLength 4096
     */
    description?: string;
    /** @default [] */
    certifications?: {
      /** @format uuid */
      _id: string;
      certificationCategory: {
        /** @format uuid */
        _id: string;
        _ref: "CertificationCategory";
      };
      /** @format date-time */
      firstIssuedOn: string;
      /** @format date-time */
      lastReceivedOn: string;
      /** @format date-time */
      expiryDate: string;
      /**
       * @format date-time
       * @default null
       */
      plannedRenewalDate?: string | null;
      /** @maxLength 1024 */
      documentaryProof?: string | null;
    }[];
    type?: "default" | "kiosk";
  };
  device: {
    /** @format uuid */
    _id: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    telluId?: number | null;
    migrationFinalised?: boolean | null;
    /** @format date-time */
    migrationFinalisedDate?: string | null;
    customer: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    };
    /** @default {"type":"parents","extra":[]} */
    share?: {
      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
      extra?: {
        /** @format uuid */
        _id: string;
        _ref: "Customer";
      }[];
    };
    asset: {
      /** @format uuid */
      _id: string;
      _ref: "Asset";
    } | null;
    /**
     * PII
     * @maxLength 1024
     */
    name?: string;
    /**
     * PII
     * @maxLength 1024
     */
    deviceId: string;
    type: "appDevice" | "lora" | "loraGateway" | "flic" | "generic" | "kiosk";
    loraConfig?:
      | {
          type: "adeunis.arf8123aa";
          config: {
            /** @maxLength 1024 */
            fieldTest: string;
          };
        }
      | {
          type: "iotracker.v2";
          config: {
            /** @maxLength 1024 */
            beaconScan: string;
            /** @maxLength 1024 */
            gps: string;
            /** @maxLength 1024 */
            preMandown: string;
            /** @maxLength 1024 */
            mandown: string;
            /** @maxLength 1024 */
            movement: string;
            /** @maxLength 1024 */
            alarmSeverity: string;
            /** @maxLength 1024 */
            alive: string;
          };
        }
      | {
          type: "milesight.ws101";
          config: {
            /** @maxLength 1024 */
            beaconScan: string;
            /** @maxLength 1024 */
            alarmSeverity: string;
            /** @maxLength 1024 */
            alive: string;
          };
        }
      | {
          type: "sensative.1301001";
          config: {
            /** @maxLength 1024 */
            alarmSeverity: string;
            /** @maxLength 1024 */
            alive: string;
            /** @maxLength 1024 */
            floodDetected: string;
            /** @maxLength 1024 */
            noFloodDetected: string;
          };
        }
      | null;
    kioskConfig?: {
      /** @default false */
      managed?: boolean;
      zone?: {
        /** @format uuid */
        _id: string;
        _ref: "Zone";
      } | null;
      exposeAssets?:
        | {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[]
        | null;
      exposeLabels?:
        | {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
            countLabel?: boolean;
          }[]
        | null;
      schedule?: {
        entries: {
          daysOfWeek: number[];
          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
          timeStart: string;
          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
          timeEnd: string;
        }[];
      } | null;
      homepage?: {
        incidentCounter?: {
          /** @default true */
          enabled?: boolean;
          /** @format date-time */
          countFromDate?: string | null;
          /**
           * @min 0
           * @exclusiveMin false
           * @default 0
           */
          threshold?: number;
        };
        /** @default true */
        anonymous?: boolean;
        /** @format uri */
        logo?: string | null;
      };
      alarm?: {
        /** @default true */
        enabled?: boolean;
        focus?: {
          red?: {
            flash?: boolean | null;
            sound?: {
              enabled: boolean;
              /**
               * @min 0
               * @exclusiveMin false
               * @max 100
               * @exclusiveMax false
               */
              volume?: number | null;
              sound?:
                | "alarm"
                | "alarmClock"
                | "alarmRetro"
                | "announcement"
                | "attention"
                | "bassPulse"
                | "beepBeep"
                | "beepBurglar"
                | "beepContinuous"
                | "beepHighSoft"
                | "beepIncremental"
                | "bell"
                | "car"
                | "chickens"
                | "chime"
                | "chirpSoft"
                | "clockMelody"
                | "countdownSonar"
                | "doorbell"
                | "escalate"
                | "fancy"
                | "fastAndNervous"
                | "harp"
                | "incomingPhone"
                | "introduction"
                | "intrusive"
                | "invasion"
                | "jungle"
                | "lofiChords"
                | "loopLow"
                | "melodySoft"
                | "notifySubtle"
                | "onOff"
                | "orchestral"
                | "pling"
                | "plingHigh"
                | "plingLow"
                | "pluckSong"
                | "quick"
                | "scanning"
                | "shake"
                | "silence"
                | "sirenHigh"
                | "sirenLow"
                | "soft"
                | "spaceship"
                | "startup"
                | "threeTones"
                | "tornado"
                | "wailing"
                | "wakeup"
                | null;
              /**
               * @min 0
               * @exclusiveMin false
               */
              stopAfterSeconds?: number | null;
              stopAfterTouch?: boolean | null;
            };
          };
          orange?: {
            flash?: boolean | null;
            sound?: {
              enabled: boolean;
              /**
               * @min 0
               * @exclusiveMin false
               * @max 100
               * @exclusiveMax false
               */
              volume?: number | null;
              sound?:
                | "alarm"
                | "alarmClock"
                | "alarmRetro"
                | "announcement"
                | "attention"
                | "bassPulse"
                | "beepBeep"
                | "beepBurglar"
                | "beepContinuous"
                | "beepHighSoft"
                | "beepIncremental"
                | "bell"
                | "car"
                | "chickens"
                | "chime"
                | "chirpSoft"
                | "clockMelody"
                | "countdownSonar"
                | "doorbell"
                | "escalate"
                | "fancy"
                | "fastAndNervous"
                | "harp"
                | "incomingPhone"
                | "introduction"
                | "intrusive"
                | "invasion"
                | "jungle"
                | "lofiChords"
                | "loopLow"
                | "melodySoft"
                | "notifySubtle"
                | "onOff"
                | "orchestral"
                | "pling"
                | "plingHigh"
                | "plingLow"
                | "pluckSong"
                | "quick"
                | "scanning"
                | "shake"
                | "silence"
                | "sirenHigh"
                | "sirenLow"
                | "soft"
                | "spaceship"
                | "startup"
                | "threeTones"
                | "tornado"
                | "wailing"
                | "wakeup"
                | null;
              /**
               * @min 0
               * @exclusiveMin false
               */
              stopAfterSeconds?: number | null;
              stopAfterTouch?: boolean | null;
            };
          };
          green?: {
            flash?: boolean | null;
            sound?: {
              enabled: boolean;
              /**
               * @min 0
               * @exclusiveMin false
               * @max 100
               * @exclusiveMax false
               */
              volume?: number | null;
              sound?:
                | "alarm"
                | "alarmClock"
                | "alarmRetro"
                | "announcement"
                | "attention"
                | "bassPulse"
                | "beepBeep"
                | "beepBurglar"
                | "beepContinuous"
                | "beepHighSoft"
                | "beepIncremental"
                | "bell"
                | "car"
                | "chickens"
                | "chime"
                | "chirpSoft"
                | "clockMelody"
                | "countdownSonar"
                | "doorbell"
                | "escalate"
                | "fancy"
                | "fastAndNervous"
                | "harp"
                | "incomingPhone"
                | "introduction"
                | "intrusive"
                | "invasion"
                | "jungle"
                | "lofiChords"
                | "loopLow"
                | "melodySoft"
                | "notifySubtle"
                | "onOff"
                | "orchestral"
                | "pling"
                | "plingHigh"
                | "plingLow"
                | "pluckSong"
                | "quick"
                | "scanning"
                | "shake"
                | "silence"
                | "sirenHigh"
                | "sirenLow"
                | "soft"
                | "spaceship"
                | "startup"
                | "threeTones"
                | "tornado"
                | "wailing"
                | "wakeup"
                | null;
              /**
               * @min 0
               * @exclusiveMin false
               */
              stopAfterSeconds?: number | null;
              stopAfterTouch?: boolean | null;
            };
          };
        };
        /** @default true */
        showPositionLabels?: boolean;
        /** @default true */
        anonymous?: boolean;
        acknowledge?: {
          enabled?: boolean;
          /** @pattern ^[0-9]{4,6}$ */
          pin?: string | null;
          messagePresets?: string[] | null;
        };
        mode?: "zoneBased" | "customerBased" | null;
      };
      manageAvailability?: {
        /** @default true */
        enabled?: boolean;
        /** @pattern ^[0-9]{4,6}$ */
        pin?: string | null;
        /** @default true */
        showAppBanner?: boolean;
        /** @default false */
        forceShowSearch?: boolean;
        /** @default false */
        forceShowLabelFilter?: boolean;
      };
      hardware?: {
        /**
         * @min 0
         * @exclusiveMin false
         * @max 100
         * @exclusiveMax false
         */
        screenBrightness?: number | null;
      };
    };
    battery?: number;
    rssi?: number;
    snr?: number;
    app?: {
      permissions?: {
        calendar?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        camera?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        contacts?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        microphone?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        notifications?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        criticalNotifications?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        motion?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        bluetooth?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        locationAlways?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        locationWhenInUse?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        physical?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        batteryOptimization?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        overlay?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
      };
      deviceOs?: {
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersion: string;
        /** @maxLength 1024 */
        osId?: string;
        /** @maxLength 1024 */
        buildNumber?: string;
        /** @maxLength 1024 */
        bundleId?: string;
      };
      profile?: {
        /** @maxLength 1024 */
        name?: string;
        /** @maxLength 1024 */
        brand?: string;
        /** @maxLength 1024 */
        model?: string;
        /** @maxLength 1024 */
        carrier?: string;
      };
    } | null;
    clientConfig?: {
      app?: {
        definitions: (
          | {
              type: "key";
              key: string;
              value: any;
              editableBy?: ("AssetGroup" | "Device")[];
            }
          | {
              type: "group";
              group: {
                /** @format uuid */
                _id: string;
                _ref: "ClientConfigGroup";
              };
            }
        )[];
        filter?: {
          type: "osFilter";
          osType: "ios" | "android";
          /** @maxLength 1024 */
          osVersionRange?: string;
        };
      }[];
      kiosk?: {
        definitions: (
          | {
              type: "key";
              key: string;
              value: any;
              editableBy?: ("AssetGroup" | "Device")[];
            }
          | {
              type: "group";
              group: {
                /** @format uuid */
                _id: string;
                _ref: "ClientConfigGroup";
              };
            }
        )[];
        filter?: {
          type: "osFilter";
          osType: "ios" | "android";
          /** @maxLength 1024 */
          osVersionRange?: string;
        };
      }[];
    };
  }[];
  customerUserRelations: {
    /** @format uuid */
    _id: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    telluId?: number | null;
    migrationFinalised?: boolean | null;
    /** @format date-time */
    migrationFinalisedDate?: string | null;
    /** @maxLength 1024 */
    migrationKey?: string;
    user: {
      /** @format uuid */
      _id: string;
      _ref: "User";
    };
    customer: {
      /** @format uuid */
      _id: string | null;
      name?: string;
      isAlarmCenter?: boolean;
      isResponsePartner?: boolean;
      children: {
        /** @format uuid */
        _id: string | null;
        name?: string;
        isAlarmCenter?: boolean;
        isResponsePartner?: boolean;
        children: any;
      }[];
    };
    /** PII */
    roles: string[];
    assetGroupRestrictions: (
      | {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }
      | {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          telluId?: number | null;
          migrationFinalised?: boolean | null;
          /** @format date-time */
          migrationFinalisedDate?: string | null;
          customer: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          };
          /** @default {"type":"parents","extra":[]} */
          share?: {
            type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
            extra?: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            }[];
          };
          /**
           * PII
           * @maxLength 1024
           */
          name: string;
          /** @maxLength 1024 */
          description?: string | null;
          assets: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          }[];
          clientConfig?: {
            app?: {
              definitions: (
                | {
                    type: "key";
                    key: string;
                    value: any;
                    editableBy?: ("AssetGroup" | "Device")[];
                  }
                | {
                    type: "group";
                    group: {
                      /** @format uuid */
                      _id: string;
                      _ref: "ClientConfigGroup";
                    };
                  }
              )[];
              filter?: {
                type: "osFilter";
                osType: "ios" | "android";
                /** @maxLength 1024 */
                osVersionRange?: string;
              };
            }[];
            kiosk?: {
              definitions: (
                | {
                    type: "key";
                    key: string;
                    value: any;
                    editableBy?: ("AssetGroup" | "Device")[];
                  }
                | {
                    type: "group";
                    group: {
                      /** @format uuid */
                      _id: string;
                      _ref: "ClientConfigGroup";
                    };
                  }
              )[];
              filter?: {
                type: "osFilter";
                osType: "ios" | "android";
                /** @maxLength 1024 */
                osVersionRange?: string;
              };
            }[];
          };
        }
    )[];
    accessRequest?: {
      /** @format date-time */
      validUntil: string;
      reason: string;
      review:
        | {
            type: "approved";
            /** PII */
            reviewedBy: {
              /** @format uuid */
              _id: string;
              _ref: "User";
            };
            /** @format date-time */
            reviewedAt: string;
            forced: boolean;
          }
        | {
            type: "rejected";
            /** PII */
            reviewedBy: {
              /** @format uuid */
              _id: string;
              _ref: "User";
            };
            /** @format date-time */
            reviewedAt: string;
            reason: string;
          }
        | null;
    };
  }[];
  customerTree: {
    /** @format uuid */
    _id: string | null;
    name?: string;
    isAlarmCenter?: boolean;
    isResponsePartner?: boolean;
    children: any;
  }[];
  customerTreeFlat: {
    /** @format uuid */
    _id: string | null;
    name?: string;
    isAlarmCenter?: boolean;
    isResponsePartner?: boolean;
    children: any;
  }[];
  customerTreeById: Record<
    string,
    {
      /** @format uuid */
      _id: string | null;
      name?: string;
      isAlarmCenter?: boolean;
      isResponsePartner?: boolean;
      children: any;
    }
  >;
  permissions: {
    action: string | string[];
    subject?: string | string[];
    conditions: any;
  }[];
}

export interface ImageUploadDto {
  image: string | null;
}

export interface IntersectsPointDto {
  /** PII */
  position: {
    type: "Point";
    /** PII */
    coordinates: number[];
  };
  forceCustomer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
}

export interface KioskMoveCustomerDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
}

export interface KioskUserCreateDto {
  user: {
    /**
     * PII
     * @maxLength 1024
     */
    username?: string;
    properties: {
      /**
       * PII
       * @maxLength 1024
       */
      phoneNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      smsNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      email?: string | null;
      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
      locale?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      image?: string | null;
      /** PII */
      rSim?: {
        /**
         * PII
         * @maxLength 1024
         */
        euicc: string;
        primary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        secondary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        enabled: boolean;
      } | null;
    };
  };
  device: {
    kioskConfig?: {
      /** @default false */
      managed?: boolean;
      zone?: {
        /** @format uuid */
        _id: string;
        _ref: "Zone";
      } | null;
      exposeAssets?:
        | {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[]
        | null;
      exposeLabels?:
        | {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
            countLabel?: boolean;
          }[]
        | null;
      schedule?: {
        entries: {
          daysOfWeek: number[];
          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
          timeStart: string;
          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
          timeEnd: string;
        }[];
      } | null;
      homepage?: {
        incidentCounter?: {
          /** @default true */
          enabled?: boolean;
          /** @format date-time */
          countFromDate?: string | null;
          /**
           * @min 0
           * @exclusiveMin false
           * @default 0
           */
          threshold?: number;
        };
        /** @default true */
        anonymous?: boolean;
        /** @format uri */
        logo?: string | null;
      };
      alarm?: {
        /** @default true */
        enabled?: boolean;
        focus?: {
          red?: {
            flash?: boolean | null;
            sound?: {
              enabled: boolean;
              /**
               * @min 0
               * @exclusiveMin false
               * @max 100
               * @exclusiveMax false
               */
              volume?: number | null;
              sound?:
                | "alarm"
                | "alarmClock"
                | "alarmRetro"
                | "announcement"
                | "attention"
                | "bassPulse"
                | "beepBeep"
                | "beepBurglar"
                | "beepContinuous"
                | "beepHighSoft"
                | "beepIncremental"
                | "bell"
                | "car"
                | "chickens"
                | "chime"
                | "chirpSoft"
                | "clockMelody"
                | "countdownSonar"
                | "doorbell"
                | "escalate"
                | "fancy"
                | "fastAndNervous"
                | "harp"
                | "incomingPhone"
                | "introduction"
                | "intrusive"
                | "invasion"
                | "jungle"
                | "lofiChords"
                | "loopLow"
                | "melodySoft"
                | "notifySubtle"
                | "onOff"
                | "orchestral"
                | "pling"
                | "plingHigh"
                | "plingLow"
                | "pluckSong"
                | "quick"
                | "scanning"
                | "shake"
                | "silence"
                | "sirenHigh"
                | "sirenLow"
                | "soft"
                | "spaceship"
                | "startup"
                | "threeTones"
                | "tornado"
                | "wailing"
                | "wakeup"
                | null;
              /**
               * @min 0
               * @exclusiveMin false
               */
              stopAfterSeconds?: number | null;
              stopAfterTouch?: boolean | null;
            };
          };
          orange?: {
            flash?: boolean | null;
            sound?: {
              enabled: boolean;
              /**
               * @min 0
               * @exclusiveMin false
               * @max 100
               * @exclusiveMax false
               */
              volume?: number | null;
              sound?:
                | "alarm"
                | "alarmClock"
                | "alarmRetro"
                | "announcement"
                | "attention"
                | "bassPulse"
                | "beepBeep"
                | "beepBurglar"
                | "beepContinuous"
                | "beepHighSoft"
                | "beepIncremental"
                | "bell"
                | "car"
                | "chickens"
                | "chime"
                | "chirpSoft"
                | "clockMelody"
                | "countdownSonar"
                | "doorbell"
                | "escalate"
                | "fancy"
                | "fastAndNervous"
                | "harp"
                | "incomingPhone"
                | "introduction"
                | "intrusive"
                | "invasion"
                | "jungle"
                | "lofiChords"
                | "loopLow"
                | "melodySoft"
                | "notifySubtle"
                | "onOff"
                | "orchestral"
                | "pling"
                | "plingHigh"
                | "plingLow"
                | "pluckSong"
                | "quick"
                | "scanning"
                | "shake"
                | "silence"
                | "sirenHigh"
                | "sirenLow"
                | "soft"
                | "spaceship"
                | "startup"
                | "threeTones"
                | "tornado"
                | "wailing"
                | "wakeup"
                | null;
              /**
               * @min 0
               * @exclusiveMin false
               */
              stopAfterSeconds?: number | null;
              stopAfterTouch?: boolean | null;
            };
          };
          green?: {
            flash?: boolean | null;
            sound?: {
              enabled: boolean;
              /**
               * @min 0
               * @exclusiveMin false
               * @max 100
               * @exclusiveMax false
               */
              volume?: number | null;
              sound?:
                | "alarm"
                | "alarmClock"
                | "alarmRetro"
                | "announcement"
                | "attention"
                | "bassPulse"
                | "beepBeep"
                | "beepBurglar"
                | "beepContinuous"
                | "beepHighSoft"
                | "beepIncremental"
                | "bell"
                | "car"
                | "chickens"
                | "chime"
                | "chirpSoft"
                | "clockMelody"
                | "countdownSonar"
                | "doorbell"
                | "escalate"
                | "fancy"
                | "fastAndNervous"
                | "harp"
                | "incomingPhone"
                | "introduction"
                | "intrusive"
                | "invasion"
                | "jungle"
                | "lofiChords"
                | "loopLow"
                | "melodySoft"
                | "notifySubtle"
                | "onOff"
                | "orchestral"
                | "pling"
                | "plingHigh"
                | "plingLow"
                | "pluckSong"
                | "quick"
                | "scanning"
                | "shake"
                | "silence"
                | "sirenHigh"
                | "sirenLow"
                | "soft"
                | "spaceship"
                | "startup"
                | "threeTones"
                | "tornado"
                | "wailing"
                | "wakeup"
                | null;
              /**
               * @min 0
               * @exclusiveMin false
               */
              stopAfterSeconds?: number | null;
              stopAfterTouch?: boolean | null;
            };
          };
        };
        /** @default true */
        showPositionLabels?: boolean;
        /** @default true */
        anonymous?: boolean;
        acknowledge?: {
          enabled?: boolean;
          /** @pattern ^[0-9]{4,6}$ */
          pin?: string | null;
          messagePresets?: string[] | null;
        };
        mode?: "zoneBased" | "customerBased" | null;
      };
      manageAvailability?: {
        /** @default true */
        enabled?: boolean;
        /** @pattern ^[0-9]{4,6}$ */
        pin?: string | null;
        /** @default true */
        showAppBanner?: boolean;
        /** @default false */
        forceShowSearch?: boolean;
        /** @default false */
        forceShowLabelFilter?: boolean;
      };
      hardware?: {
        /**
         * @min 0
         * @exclusiveMin false
         * @max 100
         * @exclusiveMax false
         */
        screenBrightness?: number | null;
      };
    };
  };
  asset: {
    /**
     * PII
     * @maxLength 1024
     */
    name: string;
    /**
     * PII
     * @maxLength 1024
     */
    externalId?: string | null;
    /**
     * PII
     * @default null
     */
    position?: {
      type: "Point";
      /** PII */
      coordinates: number[];
      properties: {
        accuracy?: number;
        heading?: number;
        headingAccuracy?: number;
        speed?: number;
        speedAccuracy?: number;
        altitude?: number;
        altitudeAccuracy?: number;
        /** PII */
        address?: {
          /** @maxLength 1024 */
          countryCode?: string | null;
          /** @maxLength 1024 */
          state?: string | null;
          /** @maxLength 1024 */
          city?: string | null;
          /** @maxLength 1024 */
          streetName?: string | null;
          /** @maxLength 1024 */
          streetNumber?: string | null;
          floor?: number | null;
          /** @maxLength 1024 */
          formattedAddress?: string;
        };
        /** @format date-time */
        dateTime?: string;
        /** @maxLength 1024 */
        provider?: string;
      };
    };
    /** @default {} */
    properties?: {
      /**
       * PII
       * @maxLength 1024
       */
      phoneNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      smsNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      email?: string | null;
      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
      locale?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      image?: string | null;
      /** PII */
      rSim?: {
        /**
         * PII
         * @maxLength 1024
         */
        euicc: string;
        primary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        secondary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        enabled: boolean;
      } | null;
    };
  };
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  password?: string;
}

export interface KioskUserObserveAsset {
  asset: {
    /** @format uuid */
    _id: string;
    _ref: "Asset";
  };
  available: boolean;
}

export interface KioskUserOutputDto {
  _id: string;
  user: {
    /** @format uuid */
    _id: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    telluId?: number | null;
    migrationFinalised?: boolean | null;
    /** @format date-time */
    migrationFinalisedDate?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    username: string;
    /**
     * PII
     * @maxLength 1024
     */
    name: string;
    properties: {
      /**
       * PII
       * @maxLength 1024
       */
      phoneNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      smsNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      email?: string | null;
      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
      locale?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      image?: string | null;
      /** PII */
      rSim?: {
        /**
         * PII
         * @maxLength 1024
         */
        euicc: string;
        primary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        secondary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        enabled: boolean;
      } | null;
    };
    /** @default [] */
    globalRoles?: string[];
    /** @default [] */
    specialPermissions?: string[];
    isServiceAccount?: boolean;
    /**
     * PII
     * @format date-time
     */
    lastActiveAt?: string;
    type?: "default" | "serviceAccount" | "kiosk";
    userPolicies?: {
      disablePasswordlessLogin?: boolean;
    };
  };
  device: {
    /** @format uuid */
    _id: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    telluId?: number | null;
    migrationFinalised?: boolean | null;
    /** @format date-time */
    migrationFinalisedDate?: string | null;
    customer: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    };
    /** @default {"type":"parents","extra":[]} */
    share?: {
      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
      extra?: {
        /** @format uuid */
        _id: string;
        _ref: "Customer";
      }[];
    };
    asset: {
      /** @format uuid */
      _id: string;
      _ref: "Asset";
    } | null;
    /**
     * PII
     * @maxLength 1024
     */
    name?: string;
    /**
     * PII
     * @maxLength 1024
     */
    deviceId: string;
    type: "appDevice" | "lora" | "loraGateway" | "flic" | "generic" | "kiosk";
    loraConfig?:
      | {
          type: "adeunis.arf8123aa";
          config: {
            /** @maxLength 1024 */
            fieldTest: string;
          };
        }
      | {
          type: "iotracker.v2";
          config: {
            /** @maxLength 1024 */
            beaconScan: string;
            /** @maxLength 1024 */
            gps: string;
            /** @maxLength 1024 */
            preMandown: string;
            /** @maxLength 1024 */
            mandown: string;
            /** @maxLength 1024 */
            movement: string;
            /** @maxLength 1024 */
            alarmSeverity: string;
            /** @maxLength 1024 */
            alive: string;
          };
        }
      | {
          type: "milesight.ws101";
          config: {
            /** @maxLength 1024 */
            beaconScan: string;
            /** @maxLength 1024 */
            alarmSeverity: string;
            /** @maxLength 1024 */
            alive: string;
          };
        }
      | {
          type: "sensative.1301001";
          config: {
            /** @maxLength 1024 */
            alarmSeverity: string;
            /** @maxLength 1024 */
            alive: string;
            /** @maxLength 1024 */
            floodDetected: string;
            /** @maxLength 1024 */
            noFloodDetected: string;
          };
        }
      | null;
    kioskConfig?: {
      /** @default false */
      managed?: boolean;
      zone?: {
        /** @format uuid */
        _id: string;
        _ref: "Zone";
      } | null;
      exposeAssets?:
        | {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[]
        | null;
      exposeLabels?:
        | {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
            countLabel?: boolean;
          }[]
        | null;
      schedule?: {
        entries: {
          daysOfWeek: number[];
          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
          timeStart: string;
          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
          timeEnd: string;
        }[];
      } | null;
      homepage?: {
        incidentCounter?: {
          /** @default true */
          enabled?: boolean;
          /** @format date-time */
          countFromDate?: string | null;
          /**
           * @min 0
           * @exclusiveMin false
           * @default 0
           */
          threshold?: number;
        };
        /** @default true */
        anonymous?: boolean;
        /** @format uri */
        logo?: string | null;
      };
      alarm?: {
        /** @default true */
        enabled?: boolean;
        focus?: {
          red?: {
            flash?: boolean | null;
            sound?: {
              enabled: boolean;
              /**
               * @min 0
               * @exclusiveMin false
               * @max 100
               * @exclusiveMax false
               */
              volume?: number | null;
              sound?:
                | "alarm"
                | "alarmClock"
                | "alarmRetro"
                | "announcement"
                | "attention"
                | "bassPulse"
                | "beepBeep"
                | "beepBurglar"
                | "beepContinuous"
                | "beepHighSoft"
                | "beepIncremental"
                | "bell"
                | "car"
                | "chickens"
                | "chime"
                | "chirpSoft"
                | "clockMelody"
                | "countdownSonar"
                | "doorbell"
                | "escalate"
                | "fancy"
                | "fastAndNervous"
                | "harp"
                | "incomingPhone"
                | "introduction"
                | "intrusive"
                | "invasion"
                | "jungle"
                | "lofiChords"
                | "loopLow"
                | "melodySoft"
                | "notifySubtle"
                | "onOff"
                | "orchestral"
                | "pling"
                | "plingHigh"
                | "plingLow"
                | "pluckSong"
                | "quick"
                | "scanning"
                | "shake"
                | "silence"
                | "sirenHigh"
                | "sirenLow"
                | "soft"
                | "spaceship"
                | "startup"
                | "threeTones"
                | "tornado"
                | "wailing"
                | "wakeup"
                | null;
              /**
               * @min 0
               * @exclusiveMin false
               */
              stopAfterSeconds?: number | null;
              stopAfterTouch?: boolean | null;
            };
          };
          orange?: {
            flash?: boolean | null;
            sound?: {
              enabled: boolean;
              /**
               * @min 0
               * @exclusiveMin false
               * @max 100
               * @exclusiveMax false
               */
              volume?: number | null;
              sound?:
                | "alarm"
                | "alarmClock"
                | "alarmRetro"
                | "announcement"
                | "attention"
                | "bassPulse"
                | "beepBeep"
                | "beepBurglar"
                | "beepContinuous"
                | "beepHighSoft"
                | "beepIncremental"
                | "bell"
                | "car"
                | "chickens"
                | "chime"
                | "chirpSoft"
                | "clockMelody"
                | "countdownSonar"
                | "doorbell"
                | "escalate"
                | "fancy"
                | "fastAndNervous"
                | "harp"
                | "incomingPhone"
                | "introduction"
                | "intrusive"
                | "invasion"
                | "jungle"
                | "lofiChords"
                | "loopLow"
                | "melodySoft"
                | "notifySubtle"
                | "onOff"
                | "orchestral"
                | "pling"
                | "plingHigh"
                | "plingLow"
                | "pluckSong"
                | "quick"
                | "scanning"
                | "shake"
                | "silence"
                | "sirenHigh"
                | "sirenLow"
                | "soft"
                | "spaceship"
                | "startup"
                | "threeTones"
                | "tornado"
                | "wailing"
                | "wakeup"
                | null;
              /**
               * @min 0
               * @exclusiveMin false
               */
              stopAfterSeconds?: number | null;
              stopAfterTouch?: boolean | null;
            };
          };
          green?: {
            flash?: boolean | null;
            sound?: {
              enabled: boolean;
              /**
               * @min 0
               * @exclusiveMin false
               * @max 100
               * @exclusiveMax false
               */
              volume?: number | null;
              sound?:
                | "alarm"
                | "alarmClock"
                | "alarmRetro"
                | "announcement"
                | "attention"
                | "bassPulse"
                | "beepBeep"
                | "beepBurglar"
                | "beepContinuous"
                | "beepHighSoft"
                | "beepIncremental"
                | "bell"
                | "car"
                | "chickens"
                | "chime"
                | "chirpSoft"
                | "clockMelody"
                | "countdownSonar"
                | "doorbell"
                | "escalate"
                | "fancy"
                | "fastAndNervous"
                | "harp"
                | "incomingPhone"
                | "introduction"
                | "intrusive"
                | "invasion"
                | "jungle"
                | "lofiChords"
                | "loopLow"
                | "melodySoft"
                | "notifySubtle"
                | "onOff"
                | "orchestral"
                | "pling"
                | "plingHigh"
                | "plingLow"
                | "pluckSong"
                | "quick"
                | "scanning"
                | "shake"
                | "silence"
                | "sirenHigh"
                | "sirenLow"
                | "soft"
                | "spaceship"
                | "startup"
                | "threeTones"
                | "tornado"
                | "wailing"
                | "wakeup"
                | null;
              /**
               * @min 0
               * @exclusiveMin false
               */
              stopAfterSeconds?: number | null;
              stopAfterTouch?: boolean | null;
            };
          };
        };
        /** @default true */
        showPositionLabels?: boolean;
        /** @default true */
        anonymous?: boolean;
        acknowledge?: {
          enabled?: boolean;
          /** @pattern ^[0-9]{4,6}$ */
          pin?: string | null;
          messagePresets?: string[] | null;
        };
        mode?: "zoneBased" | "customerBased" | null;
      };
      manageAvailability?: {
        /** @default true */
        enabled?: boolean;
        /** @pattern ^[0-9]{4,6}$ */
        pin?: string | null;
        /** @default true */
        showAppBanner?: boolean;
        /** @default false */
        forceShowSearch?: boolean;
        /** @default false */
        forceShowLabelFilter?: boolean;
      };
      hardware?: {
        /**
         * @min 0
         * @exclusiveMin false
         * @max 100
         * @exclusiveMax false
         */
        screenBrightness?: number | null;
      };
    };
    battery?: number;
    rssi?: number;
    snr?: number;
    app?: {
      permissions?: {
        calendar?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        camera?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        contacts?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        microphone?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        notifications?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        criticalNotifications?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        motion?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        bluetooth?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        locationAlways?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        locationWhenInUse?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        physical?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        batteryOptimization?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
        overlay?: {
          status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
          /** @default false */
          alreadyAsked?: boolean;
        };
      };
      deviceOs?: {
        osType: "ios" | "android";
        /** @maxLength 1024 */
        osVersion: string;
        /** @maxLength 1024 */
        osId?: string;
        /** @maxLength 1024 */
        buildNumber?: string;
        /** @maxLength 1024 */
        bundleId?: string;
      };
      profile?: {
        /** @maxLength 1024 */
        name?: string;
        /** @maxLength 1024 */
        brand?: string;
        /** @maxLength 1024 */
        model?: string;
        /** @maxLength 1024 */
        carrier?: string;
      };
    } | null;
    clientConfig?: {
      app?: {
        definitions: (
          | {
              type: "key";
              key: string;
              value: any;
              editableBy?: ("AssetGroup" | "Device")[];
            }
          | {
              type: "group";
              group: {
                /** @format uuid */
                _id: string;
                _ref: "ClientConfigGroup";
              };
            }
        )[];
        filter?: {
          type: "osFilter";
          osType: "ios" | "android";
          /** @maxLength 1024 */
          osVersionRange?: string;
        };
      }[];
      kiosk?: {
        definitions: (
          | {
              type: "key";
              key: string;
              value: any;
              editableBy?: ("AssetGroup" | "Device")[];
            }
          | {
              type: "group";
              group: {
                /** @format uuid */
                _id: string;
                _ref: "ClientConfigGroup";
              };
            }
        )[];
        filter?: {
          type: "osFilter";
          osType: "ios" | "android";
          /** @maxLength 1024 */
          osVersionRange?: string;
        };
      }[];
    };
  };
  asset: {
    /** @format uuid */
    _id: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    telluId?: number | null;
    migrationFinalised?: boolean | null;
    /** @format date-time */
    migrationFinalisedDate?: string | null;
    customer: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    };
    /** @default {"type":"parents","extra":[]} */
    share?: {
      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
      extra?: {
        /** @format uuid */
        _id: string;
        _ref: "Customer";
      }[];
    };
    user: {
      /** @format uuid */
      _id: string;
      _ref: "User";
    } | null;
    /**
     * PII
     * @maxLength 1024
     */
    name: string;
    /**
     * PII
     * @maxLength 1024
     */
    externalId?: string | null;
    propertiesOwnership?: "override" | "inherit";
    /** @default {} */
    properties?: {
      /**
       * PII
       * @maxLength 1024
       */
      phoneNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      smsNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      email?: string | null;
      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
      locale?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      image?: string | null;
      /** PII */
      rSim?: {
        /**
         * PII
         * @maxLength 1024
         */
        euicc: string;
        primary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        secondary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        enabled: boolean;
      } | null;
    };
    /**
     * PII
     * @default null
     */
    position?: {
      type: "Point";
      /** PII */
      coordinates: number[];
      properties: {
        accuracy?: number;
        heading?: number;
        headingAccuracy?: number;
        speed?: number;
        speedAccuracy?: number;
        altitude?: number;
        altitudeAccuracy?: number;
        /** PII */
        address?: {
          /** @maxLength 1024 */
          countryCode?: string | null;
          /** @maxLength 1024 */
          state?: string | null;
          /** @maxLength 1024 */
          city?: string | null;
          /** @maxLength 1024 */
          streetName?: string | null;
          /** @maxLength 1024 */
          streetNumber?: string | null;
          floor?: number | null;
          /** @maxLength 1024 */
          formattedAddress?: string;
        };
        /** @format date-time */
        dateTime?: string;
        /** @maxLength 1024 */
        provider?: string;
      };
    };
    available: boolean;
    /** @default true */
    allowContactOnOwnAlarms?: boolean;
    app?: {
      mode: "off" | "on" | "risk";
    } | null;
    insideZones: {
      /** @format uuid */
      _id: string;
      _ref: "Zone";
    }[];
    assetGroups: {
      /** @format uuid */
      _id: string;
      _ref: "AssetGroup";
    }[];
    /** @default [] */
    staticResponders?: {
      staticResponder: {
        /** @format uuid */
        _id: string;
        _ref: "StaticResponder";
      };
      priority: number;
    }[];
    /** @format date-time */
    lastObservationAt?: string;
    /** @default false */
    invisibleResponder?: boolean;
    /**
     * PII
     * @maxLength 4096
     */
    description?: string;
    /** @default [] */
    certifications?: {
      /** @format uuid */
      _id: string;
      certificationCategory: {
        /** @format uuid */
        _id: string;
        _ref: "CertificationCategory";
      };
      /** @format date-time */
      firstIssuedOn: string;
      /** @format date-time */
      lastReceivedOn: string;
      /** @format date-time */
      expiryDate: string;
      /**
       * @format date-time
       * @default null
       */
      plannedRenewalDate?: string | null;
      /** @maxLength 1024 */
      documentaryProof?: string | null;
    }[];
    type?: "default" | "kiosk";
  };
  kioskConfig: {
    /** @default false */
    managed?: boolean;
    zone: {
      /** @format uuid */
      _id: string;
      _ref: "Zone";
    } | null;
    exposeAssets:
      | {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[]
      | null;
    exposeLabels:
      | {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
          countLabel?: boolean;
        }[]
      | null;
    schedule: {
      entries: {
        daysOfWeek: number[];
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeStart: string;
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeEnd: string;
      }[];
    } | null;
    homepage: {
      incidentCounter: {
        /** @default true */
        enabled?: boolean;
        /** @format date-time */
        countFromDate: string | null;
        /**
         * @min 0
         * @exclusiveMin false
         * @default 0
         */
        threshold?: number;
      };
      /** @default true */
      anonymous?: boolean;
      /** @format uri */
      logo: string | null;
    };
    alarm: {
      /** @default true */
      enabled?: boolean;
      focus?: {
        red?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
        orange?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
        green?: {
          flash?: boolean | null;
          sound?: {
            enabled: boolean;
            /**
             * @min 0
             * @exclusiveMin false
             * @max 100
             * @exclusiveMax false
             */
            volume?: number | null;
            sound?:
              | "alarm"
              | "alarmClock"
              | "alarmRetro"
              | "announcement"
              | "attention"
              | "bassPulse"
              | "beepBeep"
              | "beepBurglar"
              | "beepContinuous"
              | "beepHighSoft"
              | "beepIncremental"
              | "bell"
              | "car"
              | "chickens"
              | "chime"
              | "chirpSoft"
              | "clockMelody"
              | "countdownSonar"
              | "doorbell"
              | "escalate"
              | "fancy"
              | "fastAndNervous"
              | "harp"
              | "incomingPhone"
              | "introduction"
              | "intrusive"
              | "invasion"
              | "jungle"
              | "lofiChords"
              | "loopLow"
              | "melodySoft"
              | "notifySubtle"
              | "onOff"
              | "orchestral"
              | "pling"
              | "plingHigh"
              | "plingLow"
              | "pluckSong"
              | "quick"
              | "scanning"
              | "shake"
              | "silence"
              | "sirenHigh"
              | "sirenLow"
              | "soft"
              | "spaceship"
              | "startup"
              | "threeTones"
              | "tornado"
              | "wailing"
              | "wakeup"
              | null;
            /**
             * @min 0
             * @exclusiveMin false
             */
            stopAfterSeconds?: number | null;
            stopAfterTouch?: boolean | null;
          };
        };
      };
      /** @default true */
      showPositionLabels?: boolean;
      /** @default true */
      anonymous?: boolean;
      acknowledge?: {
        enabled: boolean;
        /** @pattern ^[0-9]{4,6}$ */
        pin: string | null;
        messagePresets: string[] | null;
      };
      mode?: "zoneBased" | "customerBased" | null;
    };
    manageAvailability: {
      /** @default true */
      enabled?: boolean;
      /** @pattern ^[0-9]{4,6}$ */
      pin: string | null;
      /** @default true */
      showAppBanner?: boolean;
      /** @default false */
      forceShowSearch?: boolean;
      /** @default false */
      forceShowLabelFilter?: boolean;
    };
    hardware: {
      /**
       * @min 0
       * @exclusiveMin false
       * @max 100
       * @exclusiveMax false
       */
      screenBrightness: number | null;
    };
  };
  password?: string;
}

export interface KioskUserSafetyScoreboardOutputDto {
  /** @format date-time */
  lastCreatedAt: string | null;
}

export interface KioskUserUpdateDto {
  user: {
    properties: {
      /**
       * PII
       * @maxLength 1024
       */
      phoneNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      smsNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      email?: string | null;
      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
      locale?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      image?: string | null;
      /** PII */
      rSim?: {
        /**
         * PII
         * @maxLength 1024
         */
        euicc: string;
        primary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        secondary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        enabled: boolean;
      } | null;
    };
  };
  device: {
    kioskConfig?: {
      /** @default false */
      managed?: boolean;
      zone?: {
        /** @format uuid */
        _id: string;
        _ref: "Zone";
      } | null;
      exposeAssets?:
        | {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[]
        | null;
      exposeLabels?:
        | {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
            countLabel?: boolean;
          }[]
        | null;
      schedule?: {
        entries: {
          daysOfWeek: number[];
          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
          timeStart: string;
          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
          timeEnd: string;
        }[];
      } | null;
      homepage?: {
        incidentCounter?: {
          /** @default true */
          enabled?: boolean;
          /** @format date-time */
          countFromDate?: string | null;
          /**
           * @min 0
           * @exclusiveMin false
           * @default 0
           */
          threshold?: number;
        };
        /** @default true */
        anonymous?: boolean;
        /** @format uri */
        logo?: string | null;
      };
      alarm?: {
        /** @default true */
        enabled?: boolean;
        focus?: {
          red?: {
            flash?: boolean | null;
            sound?: {
              enabled: boolean;
              /**
               * @min 0
               * @exclusiveMin false
               * @max 100
               * @exclusiveMax false
               */
              volume?: number | null;
              sound?:
                | "alarm"
                | "alarmClock"
                | "alarmRetro"
                | "announcement"
                | "attention"
                | "bassPulse"
                | "beepBeep"
                | "beepBurglar"
                | "beepContinuous"
                | "beepHighSoft"
                | "beepIncremental"
                | "bell"
                | "car"
                | "chickens"
                | "chime"
                | "chirpSoft"
                | "clockMelody"
                | "countdownSonar"
                | "doorbell"
                | "escalate"
                | "fancy"
                | "fastAndNervous"
                | "harp"
                | "incomingPhone"
                | "introduction"
                | "intrusive"
                | "invasion"
                | "jungle"
                | "lofiChords"
                | "loopLow"
                | "melodySoft"
                | "notifySubtle"
                | "onOff"
                | "orchestral"
                | "pling"
                | "plingHigh"
                | "plingLow"
                | "pluckSong"
                | "quick"
                | "scanning"
                | "shake"
                | "silence"
                | "sirenHigh"
                | "sirenLow"
                | "soft"
                | "spaceship"
                | "startup"
                | "threeTones"
                | "tornado"
                | "wailing"
                | "wakeup"
                | null;
              /**
               * @min 0
               * @exclusiveMin false
               */
              stopAfterSeconds?: number | null;
              stopAfterTouch?: boolean | null;
            };
          };
          orange?: {
            flash?: boolean | null;
            sound?: {
              enabled: boolean;
              /**
               * @min 0
               * @exclusiveMin false
               * @max 100
               * @exclusiveMax false
               */
              volume?: number | null;
              sound?:
                | "alarm"
                | "alarmClock"
                | "alarmRetro"
                | "announcement"
                | "attention"
                | "bassPulse"
                | "beepBeep"
                | "beepBurglar"
                | "beepContinuous"
                | "beepHighSoft"
                | "beepIncremental"
                | "bell"
                | "car"
                | "chickens"
                | "chime"
                | "chirpSoft"
                | "clockMelody"
                | "countdownSonar"
                | "doorbell"
                | "escalate"
                | "fancy"
                | "fastAndNervous"
                | "harp"
                | "incomingPhone"
                | "introduction"
                | "intrusive"
                | "invasion"
                | "jungle"
                | "lofiChords"
                | "loopLow"
                | "melodySoft"
                | "notifySubtle"
                | "onOff"
                | "orchestral"
                | "pling"
                | "plingHigh"
                | "plingLow"
                | "pluckSong"
                | "quick"
                | "scanning"
                | "shake"
                | "silence"
                | "sirenHigh"
                | "sirenLow"
                | "soft"
                | "spaceship"
                | "startup"
                | "threeTones"
                | "tornado"
                | "wailing"
                | "wakeup"
                | null;
              /**
               * @min 0
               * @exclusiveMin false
               */
              stopAfterSeconds?: number | null;
              stopAfterTouch?: boolean | null;
            };
          };
          green?: {
            flash?: boolean | null;
            sound?: {
              enabled: boolean;
              /**
               * @min 0
               * @exclusiveMin false
               * @max 100
               * @exclusiveMax false
               */
              volume?: number | null;
              sound?:
                | "alarm"
                | "alarmClock"
                | "alarmRetro"
                | "announcement"
                | "attention"
                | "bassPulse"
                | "beepBeep"
                | "beepBurglar"
                | "beepContinuous"
                | "beepHighSoft"
                | "beepIncremental"
                | "bell"
                | "car"
                | "chickens"
                | "chime"
                | "chirpSoft"
                | "clockMelody"
                | "countdownSonar"
                | "doorbell"
                | "escalate"
                | "fancy"
                | "fastAndNervous"
                | "harp"
                | "incomingPhone"
                | "introduction"
                | "intrusive"
                | "invasion"
                | "jungle"
                | "lofiChords"
                | "loopLow"
                | "melodySoft"
                | "notifySubtle"
                | "onOff"
                | "orchestral"
                | "pling"
                | "plingHigh"
                | "plingLow"
                | "pluckSong"
                | "quick"
                | "scanning"
                | "shake"
                | "silence"
                | "sirenHigh"
                | "sirenLow"
                | "soft"
                | "spaceship"
                | "startup"
                | "threeTones"
                | "tornado"
                | "wailing"
                | "wakeup"
                | null;
              /**
               * @min 0
               * @exclusiveMin false
               */
              stopAfterSeconds?: number | null;
              stopAfterTouch?: boolean | null;
            };
          };
        };
        /** @default true */
        showPositionLabels?: boolean;
        /** @default true */
        anonymous?: boolean;
        acknowledge?: {
          enabled?: boolean;
          /** @pattern ^[0-9]{4,6}$ */
          pin?: string | null;
          messagePresets?: string[] | null;
        };
        mode?: "zoneBased" | "customerBased" | null;
      };
      manageAvailability?: {
        /** @default true */
        enabled?: boolean;
        /** @pattern ^[0-9]{4,6}$ */
        pin?: string | null;
        /** @default true */
        showAppBanner?: boolean;
        /** @default false */
        forceShowSearch?: boolean;
        /** @default false */
        forceShowLabelFilter?: boolean;
      };
      hardware?: {
        /**
         * @min 0
         * @exclusiveMin false
         * @max 100
         * @exclusiveMax false
         */
        screenBrightness?: number | null;
      };
    };
  };
  asset: {
    /**
     * PII
     * @maxLength 1024
     */
    externalId?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    name: string;
    /**
     * PII
     * @default null
     */
    position?: {
      type: "Point";
      /** PII */
      coordinates: number[];
      properties: {
        accuracy?: number;
        heading?: number;
        headingAccuracy?: number;
        speed?: number;
        speedAccuracy?: number;
        altitude?: number;
        altitudeAccuracy?: number;
        /** PII */
        address?: {
          /** @maxLength 1024 */
          countryCode?: string | null;
          /** @maxLength 1024 */
          state?: string | null;
          /** @maxLength 1024 */
          city?: string | null;
          /** @maxLength 1024 */
          streetName?: string | null;
          /** @maxLength 1024 */
          streetNumber?: string | null;
          floor?: number | null;
          /** @maxLength 1024 */
          formattedAddress?: string;
        };
        /** @format date-time */
        dateTime?: string;
        /** @maxLength 1024 */
        provider?: string;
      };
    };
  };
}

export interface LastObservationDto {
  secret: string;
  /** Minutes passed in which to search for new observations */
  timeframe: number;
  /** Number of assets which have sent a new observation */
  numberOfAssetsWithNewObservation: number;
}

export interface ObservationTriggerCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** @maxLength 1024 */
  name: string;
  eventCodes: string[];
  /** @maxLength 1024 */
  description: string;
  status: "active" | "inactive";
  actions: (
    | {
        type: "alarm";
        config: {
          severity: "red" | "orange" | "green";
          type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
          /** @maxLength 4096 */
          procedure: string | null;
          /** @maxLength 1024 */
          name: string;
        };
      }
    | {
        type: "sms";
        config: {
          /** PII */
          toRaw: string[];
          toContactList: {
            /** @format uuid */
            _id: string;
            _ref: "ContactList";
          }[];
          toTriggerUser: boolean;
          /** @maxLength 1024 */
          message: string;
        };
      }
    | {
        type: "email";
        config: {
          /** PII */
          toRaw: string[];
          toContactList: {
            /** @format uuid */
            _id: string;
            _ref: "ContactList";
          }[];
          toTriggerUser: boolean;
          /** @maxLength 1024 */
          message: string;
          /** @maxLength 1024 */
          subject: string;
          /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
          locale?: string;
        };
      }
    | {
        type: "assetUpdate";
        config: {
          available?: boolean;
          app?: {
            mode: "off" | "on" | "risk";
          };
        };
      }
  )[];
  filter:
    | {
        type: "operator/and";
        operands: (
          | {
              type: "operator/or";
              operands: (
                | {
                    type: "operator/not";
                    operand:
                      | {
                          type: "constraint/asset";
                          assets: {
                            /** @format uuid */
                            _id: string;
                            _ref: "Asset";
                          }[];
                        }
                      | {
                          type: "constraint/assetGroup";
                          groups: {
                            /** @format uuid */
                            _id: string;
                            _ref: "AssetGroup";
                          }[];
                        }
                      | {
                          type: "constraint/zone";
                          zone: {
                            /** @format uuid */
                            _id: string;
                            _ref: "Zone";
                          };
                        }
                      | {
                          type: "constraint/schedule";
                          schedule: {
                            entries: {
                              daysOfWeek: number[];
                              /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                              timeStart: string;
                              /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                              timeEnd: string;
                            }[];
                          };
                        };
                  }
                | {
                    type: "constraint/asset";
                    assets: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset";
                    }[];
                  }
                | {
                    type: "constraint/assetGroup";
                    groups: {
                      /** @format uuid */
                      _id: string;
                      _ref: "AssetGroup";
                    }[];
                  }
                | {
                    type: "constraint/zone";
                    zone: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    };
                  }
                | {
                    type: "constraint/schedule";
                    schedule: {
                      entries: {
                        daysOfWeek: number[];
                        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                        timeStart: string;
                        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                        timeEnd: string;
                      }[];
                    };
                  }
              )[];
            }
          | {
              type: "constraint/asset";
              assets: {
                /** @format uuid */
                _id: string;
                _ref: "Asset";
              }[];
            }
          | {
              type: "constraint/assetGroup";
              groups: {
                /** @format uuid */
                _id: string;
                _ref: "AssetGroup";
              }[];
            }
          | {
              type: "constraint/zone";
              zone: {
                /** @format uuid */
                _id: string;
                _ref: "Zone";
              };
            }
          | {
              type: "constraint/schedule";
              schedule: {
                entries: {
                  daysOfWeek: number[];
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeStart: string;
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeEnd: string;
                }[];
              };
            }
        )[];
      }
    | {
        type: "constraint/asset";
        assets: {
          /** @format uuid */
          _id: string;
          _ref: "Asset";
        }[];
      }
    | {
        type: "constraint/assetGroup";
        groups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
      }
    | {
        type: "constraint/zone";
        zone: {
          /** @format uuid */
          _id: string;
          _ref: "Zone";
        };
      }
    | {
        type: "constraint/schedule";
        schedule: {
          entries: {
            daysOfWeek: number[];
            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
            timeStart: string;
            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
            timeEnd: string;
          }[];
        };
      };
}

export interface ObservationTriggerOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** @maxLength 1024 */
  name: string;
  eventCodes: string[];
  /** @maxLength 1024 */
  description: string;
  status: "active" | "inactive";
  actions: (
    | {
        type: "alarm";
        config: {
          severity: "red" | "orange" | "green";
          type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
          /** @maxLength 4096 */
          procedure: string | null;
          /** @maxLength 1024 */
          name: string;
        };
      }
    | {
        type: "sms";
        config: {
          /** PII */
          toRaw: string[];
          toContactList: {
            /** @format uuid */
            _id: string;
            _ref: "ContactList";
          }[];
          toTriggerUser: boolean;
          /** @maxLength 1024 */
          message: string;
        };
      }
    | {
        type: "email";
        config: {
          /** PII */
          toRaw: string[];
          toContactList: {
            /** @format uuid */
            _id: string;
            _ref: "ContactList";
          }[];
          toTriggerUser: boolean;
          /** @maxLength 1024 */
          message: string;
          /** @maxLength 1024 */
          subject: string;
          /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
          locale?: string;
        };
      }
    | {
        type: "assetUpdate";
        config: {
          available?: boolean;
          app?: {
            mode: "off" | "on" | "risk";
          };
        };
      }
  )[];
  filter:
    | {
        type: "operator/and";
        operands: (
          | {
              type: "operator/or";
              operands: (
                | {
                    type: "operator/not";
                    operand:
                      | {
                          type: "constraint/asset";
                          assets: {
                            /** @format uuid */
                            _id: string;
                            _ref: "Asset";
                          }[];
                        }
                      | {
                          type: "constraint/assetGroup";
                          groups: {
                            /** @format uuid */
                            _id: string;
                            _ref: "AssetGroup";
                          }[];
                        }
                      | {
                          type: "constraint/zone";
                          zone: {
                            /** @format uuid */
                            _id: string;
                            _ref: "Zone";
                          };
                        }
                      | {
                          type: "constraint/schedule";
                          schedule: {
                            entries: {
                              daysOfWeek: number[];
                              /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                              timeStart: string;
                              /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                              timeEnd: string;
                            }[];
                          };
                        };
                  }
                | {
                    type: "constraint/asset";
                    assets: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset";
                    }[];
                  }
                | {
                    type: "constraint/assetGroup";
                    groups: {
                      /** @format uuid */
                      _id: string;
                      _ref: "AssetGroup";
                    }[];
                  }
                | {
                    type: "constraint/zone";
                    zone: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    };
                  }
                | {
                    type: "constraint/schedule";
                    schedule: {
                      entries: {
                        daysOfWeek: number[];
                        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                        timeStart: string;
                        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                        timeEnd: string;
                      }[];
                    };
                  }
              )[];
            }
          | {
              type: "constraint/asset";
              assets: {
                /** @format uuid */
                _id: string;
                _ref: "Asset";
              }[];
            }
          | {
              type: "constraint/assetGroup";
              groups: {
                /** @format uuid */
                _id: string;
                _ref: "AssetGroup";
              }[];
            }
          | {
              type: "constraint/zone";
              zone: {
                /** @format uuid */
                _id: string;
                _ref: "Zone";
              };
            }
          | {
              type: "constraint/schedule";
              schedule: {
                entries: {
                  daysOfWeek: number[];
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeStart: string;
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeEnd: string;
                }[];
              };
            }
        )[];
      }
    | {
        type: "constraint/asset";
        assets: {
          /** @format uuid */
          _id: string;
          _ref: "Asset";
        }[];
      }
    | {
        type: "constraint/assetGroup";
        groups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
      }
    | {
        type: "constraint/zone";
        zone: {
          /** @format uuid */
          _id: string;
          _ref: "Zone";
        };
      }
    | {
        type: "constraint/schedule";
        schedule: {
          entries: {
            daysOfWeek: number[];
            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
            timeStart: string;
            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
            timeEnd: string;
          }[];
        };
      };
}

export interface ObservationTriggerUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** @maxLength 1024 */
  name?: string;
  eventCodes?: string[];
  /** @maxLength 1024 */
  description?: string;
  status?: "active" | "inactive";
  actions?: (
    | {
        type: "alarm";
        config: {
          severity: "red" | "orange" | "green";
          type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
          /** @maxLength 4096 */
          procedure: string | null;
          /** @maxLength 1024 */
          name: string;
        };
      }
    | {
        type: "sms";
        config: {
          /** PII */
          toRaw: string[];
          toContactList: {
            /** @format uuid */
            _id: string;
            _ref: "ContactList";
          }[];
          toTriggerUser: boolean;
          /** @maxLength 1024 */
          message: string;
        };
      }
    | {
        type: "email";
        config: {
          /** PII */
          toRaw: string[];
          toContactList: {
            /** @format uuid */
            _id: string;
            _ref: "ContactList";
          }[];
          toTriggerUser: boolean;
          /** @maxLength 1024 */
          message: string;
          /** @maxLength 1024 */
          subject: string;
          /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
          locale?: string;
        };
      }
    | {
        type: "assetUpdate";
        config: {
          available?: boolean;
          app?: {
            mode: "off" | "on" | "risk";
          };
        };
      }
  )[];
  filter?:
    | {
        type: "operator/and";
        operands: (
          | {
              type: "operator/or";
              operands: (
                | {
                    type: "operator/not";
                    operand:
                      | {
                          type: "constraint/asset";
                          assets: {
                            /** @format uuid */
                            _id: string;
                            _ref: "Asset";
                          }[];
                        }
                      | {
                          type: "constraint/assetGroup";
                          groups: {
                            /** @format uuid */
                            _id: string;
                            _ref: "AssetGroup";
                          }[];
                        }
                      | {
                          type: "constraint/zone";
                          zone: {
                            /** @format uuid */
                            _id: string;
                            _ref: "Zone";
                          };
                        }
                      | {
                          type: "constraint/schedule";
                          schedule: {
                            entries: {
                              daysOfWeek: number[];
                              /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                              timeStart: string;
                              /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                              timeEnd: string;
                            }[];
                          };
                        };
                  }
                | {
                    type: "constraint/asset";
                    assets: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset";
                    }[];
                  }
                | {
                    type: "constraint/assetGroup";
                    groups: {
                      /** @format uuid */
                      _id: string;
                      _ref: "AssetGroup";
                    }[];
                  }
                | {
                    type: "constraint/zone";
                    zone: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    };
                  }
                | {
                    type: "constraint/schedule";
                    schedule: {
                      entries: {
                        daysOfWeek: number[];
                        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                        timeStart: string;
                        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                        timeEnd: string;
                      }[];
                    };
                  }
              )[];
            }
          | {
              type: "constraint/asset";
              assets: {
                /** @format uuid */
                _id: string;
                _ref: "Asset";
              }[];
            }
          | {
              type: "constraint/assetGroup";
              groups: {
                /** @format uuid */
                _id: string;
                _ref: "AssetGroup";
              }[];
            }
          | {
              type: "constraint/zone";
              zone: {
                /** @format uuid */
                _id: string;
                _ref: "Zone";
              };
            }
          | {
              type: "constraint/schedule";
              schedule: {
                entries: {
                  daysOfWeek: number[];
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeStart: string;
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeEnd: string;
                }[];
              };
            }
        )[];
      }
    | {
        type: "constraint/asset";
        assets: {
          /** @format uuid */
          _id: string;
          _ref: "Asset";
        }[];
      }
    | {
        type: "constraint/assetGroup";
        groups: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
      }
    | {
        type: "constraint/zone";
        zone: {
          /** @format uuid */
          _id: string;
          _ref: "Zone";
        };
      }
    | {
        type: "constraint/schedule";
        schedule: {
          entries: {
            daysOfWeek: number[];
            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
            timeStart: string;
            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
            timeEnd: string;
          }[];
        };
      };
}

export interface ObserveBeaconsDto {
  device: {
    _id: string;
    _ref: "Device";
  };
  scans: {
    code: string;
    /** @format date-time */
    dateTime: string;
    battery?: number;
  }[];
}

export interface ObserveBeaconsResponse {
  beacons: {
    /** @format uuid */
    _id: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    telluId?: number | null;
    migrationFinalised?: boolean | null;
    /** @format date-time */
    migrationFinalisedDate?: string | null;
    customer: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    };
    /** @default {"type":"parents","extra":[]} */
    share?: {
      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
      extra?: {
        /** @format uuid */
        _id: string;
        _ref: "Customer";
      }[];
    };
    codes: string[];
    /**
     * @min 0
     * @exclusiveMin false
     */
    rssiAddend: number;
    type: "default" | "tag";
    state: {
      lastSeenBy?: {
        /** @format uuid */
        _id: string;
        _ref: "Asset";
      } | null;
      /** @format date-time */
      lastSeenAt?: string | null;
      battery?: number | null;
    };
    zone: {
      /** @format uuid */
      _id: string;
      /** @format date-time */
      createdAt: string;
      /** @format date-time */
      updatedAt: string;
      telluId?: number | null;
      migrationFinalised?: boolean | null;
      /** @format date-time */
      migrationFinalisedDate?: string | null;
      customer: {
        /** @format uuid */
        _id: string;
        _ref: "Customer";
      };
      /** @default {"type":"parents","extra":[]} */
      share?: {
        type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
        extra?: {
          /** @format uuid */
          _id: string;
          _ref: "Customer";
        }[];
      };
      type:
        | "default"
        | "responseArea"
        | "policeDepartment"
        | "assetMonitoredArea"
        | "fingerprinted"
        | "building"
        | "evacuationPoint";
      /** PII */
      location:
        | {
            type: "Polygon";
            /** PII */
            coordinates: number[][][];
            properties: {
              accuracy?: number;
              heading?: number;
              headingAccuracy?: number;
              speed?: number;
              speedAccuracy?: number;
              altitude?: number;
              altitudeAccuracy?: number;
              /** PII */
              address?: {
                /** @maxLength 1024 */
                countryCode?: string | null;
                /** @maxLength 1024 */
                state?: string | null;
                /** @maxLength 1024 */
                city?: string | null;
                /** @maxLength 1024 */
                streetName?: string | null;
                /** @maxLength 1024 */
                streetNumber?: string | null;
                floor?: number | null;
                /** @maxLength 1024 */
                formattedAddress?: string;
              };
              /** @format date-time */
              dateTime?: string;
              /** @maxLength 1024 */
              provider?: string;
            };
          }
        | {
            type: "MultiPolygon";
            coordinates: number[][][][];
            properties: {
              accuracy?: number;
              heading?: number;
              headingAccuracy?: number;
              speed?: number;
              speedAccuracy?: number;
              altitude?: number;
              altitudeAccuracy?: number;
              /** PII */
              address?: {
                /** @maxLength 1024 */
                countryCode?: string | null;
                /** @maxLength 1024 */
                state?: string | null;
                /** @maxLength 1024 */
                city?: string | null;
                /** @maxLength 1024 */
                streetName?: string | null;
                /** @maxLength 1024 */
                streetNumber?: string | null;
                floor?: number | null;
                /** @maxLength 1024 */
                formattedAddress?: string;
              };
              /** @format date-time */
              dateTime?: string;
              /** @maxLength 1024 */
              provider?: string;
            };
          };
      /**
       * PII
       * @maxLength 1024
       */
      name: string;
      /**
       * PII
       * @maxLength 1024
       * @default null
       */
      description?: string | null;
      /** @default [] */
      staticResponders?: {
        staticResponder: {
          /** @format uuid */
          _id: string;
          _ref: "StaticResponder";
        };
        priority: number;
      }[];
      /** @default null */
      responsePriority?: number | null;
      assetsInside: {
        /** @format uuid */
        _id: string;
        _ref: "Asset";
      }[];
      syncToAms?: boolean;
    };
    /** PII */
    location?:
      | {
          type: "Point";
          /** PII */
          coordinates: number[];
          properties: {
            accuracy?: number;
            heading?: number;
            headingAccuracy?: number;
            speed?: number;
            speedAccuracy?: number;
            altitude?: number;
            altitudeAccuracy?: number;
            /** PII */
            address?: {
              /** @maxLength 1024 */
              countryCode?: string | null;
              /** @maxLength 1024 */
              state?: string | null;
              /** @maxLength 1024 */
              city?: string | null;
              /** @maxLength 1024 */
              streetName?: string | null;
              /** @maxLength 1024 */
              streetNumber?: string | null;
              floor?: number | null;
              /** @maxLength 1024 */
              formattedAddress?: string;
            };
            /** @format date-time */
            dateTime?: string;
            /** @maxLength 1024 */
            provider?: string;
          };
        }
      | {
          type: "Polygon";
          /** PII */
          coordinates: number[][][];
          properties: {
            accuracy?: number;
            heading?: number;
            headingAccuracy?: number;
            speed?: number;
            speedAccuracy?: number;
            altitude?: number;
            altitudeAccuracy?: number;
            /** PII */
            address?: {
              /** @maxLength 1024 */
              countryCode?: string | null;
              /** @maxLength 1024 */
              state?: string | null;
              /** @maxLength 1024 */
              city?: string | null;
              /** @maxLength 1024 */
              streetName?: string | null;
              /** @maxLength 1024 */
              streetNumber?: string | null;
              floor?: number | null;
              /** @maxLength 1024 */
              formattedAddress?: string;
            };
            /** @format date-time */
            dateTime?: string;
            /** @maxLength 1024 */
            provider?: string;
          };
        }
      | {
          type: "MultiPolygon";
          coordinates: number[][][][];
          properties: {
            accuracy?: number;
            heading?: number;
            headingAccuracy?: number;
            speed?: number;
            speedAccuracy?: number;
            altitude?: number;
            altitudeAccuracy?: number;
            /** PII */
            address?: {
              /** @maxLength 1024 */
              countryCode?: string | null;
              /** @maxLength 1024 */
              state?: string | null;
              /** @maxLength 1024 */
              city?: string | null;
              /** @maxLength 1024 */
              streetName?: string | null;
              /** @maxLength 1024 */
              streetNumber?: string | null;
              floor?: number | null;
              /** @maxLength 1024 */
              formattedAddress?: string;
            };
            /** @format date-time */
            dateTime?: string;
            /** @maxLength 1024 */
            provider?: string;
          };
        };
  }[];
}

export interface OpenAlarmDto {
  secret: string;
  /** Minutes passed since alarm is created (not acknowledged) */
  timePassed: number;
  /** Customer ids that should not be included */
  customerIds?: string[];
}

export interface OverlayCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** @format uri */
  imageUrl: string | null;
  /** @default 0 */
  level?: number;
  /** PII */
  points: {
    sw: {
      lat: number;
      lng: number;
    };
    ne: {
      lat: number;
      lng: number;
    };
    nw: {
      lat: number;
      lng: number;
    };
    se: {
      lat: number;
      lng: number;
    };
  };
}

export interface OverlayOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** @format uri */
  imageUrl: string | null;
  /** @default 0 */
  level?: number;
  /** PII */
  points: {
    sw: {
      lat: number;
      lng: number;
    };
    ne: {
      lat: number;
      lng: number;
    };
    nw: {
      lat: number;
      lng: number;
    };
    se: {
      lat: number;
      lng: number;
    };
  };
}

export interface OverlayUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** @format uri */
  imageUrl?: string | null;
  /** @default 0 */
  level?: number;
  /** PII */
  points?: {
    sw: {
      lat: number;
      lng: number;
    };
    ne: {
      lat: number;
      lng: number;
    };
    nw: {
      lat: number;
      lng: number;
    };
    se: {
      lat: number;
      lng: number;
    };
  };
}

export interface PublishCertificationsToReportDto {
  secret: string;
}

export interface PublishInventoryItemsToReportDto {
  secret: string;
  inventoryItemsType: "inventoryItemsExpiring" | "inventoryItemsExpired";
}

export interface RegistrationDto {
  code: string;
  name: string;
  username: string;
  available: boolean;
  properties: {
    phoneNumber: string;
    smsNumber: string;
    /** @format email */
    email: string;
    locale?: "en" | "nl" | "no" | "fr" | "de";
    image?: string;
  };
}

export interface RegistrationTemplateCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** @maxLength 1024 */
  name: string;
  profile: {
    /** @default [] */
    assetGroups?: {
      /** @format uuid */
      _id: string;
      _ref: "AssetGroup";
    }[];
    /** @default [] */
    configGroups?: {
      /** @format uuid */
      _id: string;
      _ref: "ClientConfigGroup";
    }[];
    /** @default [] */
    assetGroupLimit?: {
      /** @format uuid */
      _id: string;
      _ref: "AssetGroup";
    }[];
    /** @default [] */
    legacyConfigGroups?: string[];
  };
}

export interface RegistrationTemplateOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** @maxLength 1024 */
  name: string;
  code: string[];
  numberUsed: number;
  /** @format date-time */
  lastUsed: string | null;
  profile: {
    /** @default [] */
    assetGroups?: {
      /** @format uuid */
      _id: string;
      _ref: "AssetGroup";
    }[];
    /** @default [] */
    configGroups?: {
      /** @format uuid */
      _id: string;
      _ref: "ClientConfigGroup";
    }[];
    /** @default [] */
    assetGroupLimit?: {
      /** @format uuid */
      _id: string;
      _ref: "AssetGroup";
    }[];
    /** @default [] */
    legacyConfigGroups?: string[];
  };
}

export interface RegistrationTemplateUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** @maxLength 1024 */
  name?: string;
  profile?: {
    /** @default [] */
    assetGroups?: {
      /** @format uuid */
      _id: string;
      _ref: "AssetGroup";
    }[];
    /** @default [] */
    configGroups?: {
      /** @format uuid */
      _id: string;
      _ref: "ClientConfigGroup";
    }[];
    /** @default [] */
    assetGroupLimit?: {
      /** @format uuid */
      _id: string;
      _ref: "AssetGroup";
    }[];
    /** @default [] */
    legacyConfigGroups?: string[];
  };
}

export interface ReportTriggerAdhocPopulateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  channels: (
    | {
        type: "email";
        /** PII */
        address?: string[];
        contactLists?: {
          /** @format uuid */
          _id: string;
          _ref: "ContactList";
        }[];
        getters?: {
          /** @maxLength 1024 */
          path: string;
        }[];
        assets?: {
          /** @format uuid */
          _id: string;
          _ref: "Asset";
        }[];
        assetGroups?: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        config?: {
          /**
           * PII
           * @maxLength 1024
           */
          subjectOverride?: string;
          /**
           * PII
           * @maxLength 4096
           */
          headerOverride?: string;
        };
      }
    | {
        type: "sms";
        /** PII */
        numbers: string[];
        contactLists: {
          /** @format uuid */
          _id: string;
          _ref: "ContactList";
        }[];
      }
    | {
        type: "alarm";
        config: {
          severity: "red" | "orange" | "green";
          type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
          /**
           * PII
           * @maxLength 4096
           */
          procedure: string | null;
          /**
           * PII
           * @maxLength 1024
           */
          name: string;
        };
      }
    | {
        type: "observation";
      }
  )[];
}

export interface ReportTriggerChannelResultUpdateDto {
  success: boolean;
  data?: any;
}

export interface ReportTriggerCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  } | null;
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  config:
    | {
        type: "accessRequestAlert";
        filter?: {
          forced?: boolean;
        };
        theme?: "bhvk" | "default";
      }
    | {
        type: "accessRequestOverview";
        theme?: "bhvk" | "default";
        pagination: {
          /** @format date-time */
          after: string;
          order: "asc" | "desc";
          max: number;
        };
      }
    | {
        type: "alarmCenterStatus";
        exclude?: {
          /** @format uuid */
          _id: string;
          _ref: "Customer";
        }[];
        timeframe: {
          type: "month" | "week" | "day" | "hour" | "minute";
          value: number;
          floorTo?: "month" | "week" | "day" | "hour" | "minute";
        };
        theme?: "bhvk" | "default";
      }
    | {
        type: "alarmCenterAnalytics";
        timeSeries: {
          granularity: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          timeframe: {
            type: "month" | "week" | "day" | "hour" | "minute";
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
        };
        theme?: "bhvk" | "default";
      }
    | {
        type: "alarms";
        excelFormat: "default" | "smc";
        excelColumns?: (
          | "customer"
          | "name"
          | "severity"
          | "type"
          | "asset"
          | "createdAt"
          | "timeOfFirstHelper"
          | "timeUntilFirstHelper"
          | "alarmCenter"
          | "ackedAt"
          | "ackMessage"
          | "position"
          | "assetPosition"
          | "helperCount.true"
          | "helperCount.null"
          | "helperCount.false"
          | "helperName.true"
          | "helperName.null"
          | "helperName.false"
          | "alarmManager"
          | "alarmId"
          | "assetId"
          | "hubspotId"
          | "alarmDate"
          | "customerName"
          | "assetName"
          | "simpleDescription"
          | "contractDeliveryDate"
          | "alarmName"
          | "onHelpProtocol"
          | "policeCalled"
        )[];
        filter?: {
          assets?: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          }[];
          assetGroups?: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
        };
        severities?: ("red" | "orange" | "green")[] | null;
        alarmTypes?: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[] | null;
        timeSeries: {
          granularity: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          timeframe: {
            type: "month" | "week" | "day" | "hour" | "minute";
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
        };
        theme?: "bhvk" | "default";
      }
    | {
        type: "appUsage";
        mode?: "hourlyUsage" | "license";
        filter?: {
          assets?: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          }[];
          assetGroups?: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
        };
        timeSeries: {
          granularity: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          timeframe: {
            type: "month" | "week";
            /**
             * @min 1
             * @max 1
             */
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
        };
        inactivityThreshold?:
          | {
              type: "minute";
              value: number;
            }
          | {
              type: "hour";
              value: number;
            }
          | {
              type: "day";
              /**
               * @min 1
               * @exclusiveMin false
               * @max 14
               * @exclusiveMax false
               */
              value: number;
            };
        reduceEmailSize?: boolean;
        theme?: "bhvk" | "default";
      }
    | {
        type: "assetCertificationExpiryBulk";
      }
    | {
        type: "assetCertificationExpiry";
      }
    | {
        type: "assetHistory";
        asset: {
          /** @format uuid */
          _id: string;
          _ref: "Asset";
        };
        timeSeries: {
          granularity: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          timeframe: {
            type: "month" | "week" | "day" | "hour" | "minute";
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
        };
        aggregatorOptions: {
          includeRaw: boolean;
          includeSimple: boolean;
        };
        theme?: "bhvk" | "default";
      }
    | {
        type: "assetVerificationCode";
        theme?: "bhvk" | "default";
      }
    | {
        type: "auditLog";
        subject?: (
          | "Alarm"
          | "AlarmCall"
          | "AlarmCallEvent"
          | "AlarmCallParticipant"
          | "AlarmEvent"
          | "AlarmHelper"
          | "AlarmPushSubscription"
          | "AlarmProfessionalResponder"
          | "Asset"
          | "AssetGroup"
          | "AssetPropertyVerification"
          | "AuditLog"
          | "Beacon"
          | "BillingAuditLog"
          | "BillingContract"
          | "BillingCustomer"
          | "BillingInvoice"
          | "ContactList"
          | "Customer"
          | "CustomerAlarmCenterRelation"
          | "CustomerUserRelation"
          | "Device"
          | "DeviceLogUpload"
          | "DomainLink"
          | "Observation"
          | "ObservationTrigger"
          | "Overlay"
          | "RegistrationTemplate"
          | "ReportTrigger"
          | "ReportTriggerRun"
          | "Role"
          | "StaticResponder"
          | "Webhook"
          | "User"
          | "Zone"
          | "Fingerprint"
          | "Visitor"
          | "VisitRecord"
          | "Report"
          | "DeviceLogUploadBatch"
          | "all"
        )[];
        operation?: string[];
        user?: {
          /** @format uuid */
          _id: string;
          _ref: "User";
        }[];
        reasonKey?: string[];
        ids?: string[];
        pagination: {
          /** @format date-time */
          after: string;
          order: "asc" | "desc";
          max: number;
        };
        exposeUsers?: boolean;
        exposeHistory?: boolean;
      }
    | {
        type: "badReviewOnSurvey";
        omitPiiFields?: ("phone" | "email")[];
      }
    | {
        type: "deviceLog";
        device?: {
          /** @format uuid */
          _id: string;
          _ref: "Device";
        }[];
        deviceLogUpload?: {
          /** @format uuid */
          _id: string;
          _ref: "DeviceLogUpload";
        }[];
        severity?: ("debug" | "info" | "warning" | "error")[];
        message?: string[];
        location?: string[];
        pagination: {
          /** @format date-time */
          after: string;
          order: "asc" | "desc";
          max: number;
        };
      }
    | {
        type: "gatewayAlive";
        lastSeenThreshold: {
          type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
          value: number;
        };
      }
    | {
        type: "inactivityMonitor";
        lastSeenThreshold: {
          type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
          value: number;
        };
        assets?: {
          /** @format uuid */
          _id: string;
          _ref: "Asset";
        }[];
        assetGroups?: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        appMode?: ("off" | "on" | "risk")[];
        timeout?: {
          type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
          value: number;
        };
        theme?: "bhvk" | "default";
        omitPiiFields?: "address"[];
      }
    | {
        type: "inventoryItemsExpiry";
      }
    | {
        type: "newAlarm";
        filter?: {
          severities?: ("red" | "orange" | "green")[];
          alarmTypes?: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[];
          assets?: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          }[];
          assetGroups?: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
        };
        procedure?: string;
        info?: string;
        hideOpenInAppButton?: boolean;
        exposeAlarmCreatorProperties?: ("smsNumber" | "phoneNumber" | "email")[];
        theme?: "bhvk" | "default";
      }
    | {
        type: "surveyInvitation";
      }
    | {
        type: "surveyOverview";
        timeframe: {
          type: "month" | "week" | "day" | "hour" | "minute";
          value: number;
          floorTo?: "month" | "week" | "day" | "hour" | "minute";
        };
      }
    | {
        type: "unhealthyBeacons";
        lastSeenThreshold: {
          type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
          value: number;
        };
        theme?: "bhvk" | "default";
      }
    | {
        type: "zoneOverview";
        inactivityThreshold?: {
          type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
          value: number;
        };
        timeSeries: {
          granularity: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          timeframe: {
            type: "month" | "week" | "day" | "hour" | "minute";
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
        };
        minOccupancyMode?: "alert" | "overview";
        minOccupancy?: {
          /**
           * @min 0
           * @exclusiveMin false
           * @max 1
           * @exclusiveMax false
           */
          ratioThreshold: number;
          /**
           * @min 0
           * @exclusiveMin false
           */
          assetCount: number;
        };
        attachment?: {
          granularity: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          /**
           * @min 0
           * @exclusiveMin false
           * @max 1
           * @exclusiveMax false
           */
          availabilityThresholdRatio?: number;
        };
        zones?: {
          /** @format uuid */
          _id: string;
          _ref: "Zone";
        }[];
        assets?: {
          /** @format uuid */
          _id: string;
          _ref: "Asset";
        }[];
        assetGroups?: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        schedule?:
          | {
              entries: {
                daysOfWeek: number[];
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeStart: string;
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeEnd: string;
                /**
                 * @min 0
                 * @exclusiveMin false
                 */
                minOccupancy: number;
              }[];
            }
          | {
              entries: {
                daysOfWeek: number[];
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeStart: string;
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeEnd: string;
              }[];
            };
        theme?: "bhvk" | "default";
        disableCompressTimeseries?: boolean;
      }
    | {
        type: "visitorRegistrationQrCode";
      };
  channelOverrides?: {
    /** PII */
    unsubscribedEmails: string[];
  };
  channels: (
    | {
        type: "email";
        /** PII */
        address?: string[];
        contactLists?: {
          /** @format uuid */
          _id: string;
          _ref: "ContactList";
        }[];
        getters?: {
          /** @maxLength 1024 */
          path: string;
        }[];
        assets?: {
          /** @format uuid */
          _id: string;
          _ref: "Asset";
        }[];
        assetGroups?: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        config?: {
          /**
           * PII
           * @maxLength 1024
           */
          subjectOverride?: string;
          /**
           * PII
           * @maxLength 4096
           */
          headerOverride?: string;
        };
      }
    | {
        type: "sms";
        /** PII */
        numbers: string[];
        contactLists: {
          /** @format uuid */
          _id: string;
          _ref: "ContactList";
        }[];
      }
    | {
        type: "alarm";
        config: {
          severity: "red" | "orange" | "green";
          type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
          /**
           * PII
           * @maxLength 4096
           */
          procedure: string | null;
          /**
           * PII
           * @maxLength 1024
           */
          name: string;
        };
      }
    | {
        type: "observation";
      }
  )[];
  /** @default null */
  scheduleTrigger?: {
    interval: {
      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
      value: number;
    };
    cooldown?: {
      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
      value: number;
    };
    /** @format date-time */
    nextAt: string | null;
    /** @format date-time */
    lastAt: string | null;
    /** @format date-time */
    lastAttemptedAt: string | null;
  };
  /** @default null */
  eventTrigger?: {
    events: string[];
    executionDelay?: {
      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
      value: number;
    };
    schedule?: {
      entries: {
        daysOfWeek: number[];
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeStart: string;
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeEnd: string;
      }[];
    };
  } | null;
  enabled: boolean;
  /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
  locale?: string;
  /** @maxLength 1024 */
  timezone?: string;
}

export interface ReportTriggerOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  } | null;
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  config:
    | {
        type: "accessRequestAlert";
        filter?: {
          forced?: boolean;
        };
        theme?: "bhvk" | "default";
      }
    | {
        type: "accessRequestOverview";
        theme?: "bhvk" | "default";
        pagination: {
          /** @format date-time */
          after: string;
          order: "asc" | "desc";
          max: number;
        };
      }
    | {
        type: "alarmCenterStatus";
        exclude?: {
          /** @format uuid */
          _id: string;
          _ref: "Customer";
        }[];
        timeframe: {
          type: "month" | "week" | "day" | "hour" | "minute";
          value: number;
          floorTo?: "month" | "week" | "day" | "hour" | "minute";
        };
        theme?: "bhvk" | "default";
      }
    | {
        type: "alarmCenterAnalytics";
        timeSeries: {
          granularity: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          timeframe: {
            type: "month" | "week" | "day" | "hour" | "minute";
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
        };
        theme?: "bhvk" | "default";
      }
    | {
        type: "alarms";
        excelFormat: "default" | "smc";
        excelColumns?: (
          | "customer"
          | "name"
          | "severity"
          | "type"
          | "asset"
          | "createdAt"
          | "timeOfFirstHelper"
          | "timeUntilFirstHelper"
          | "alarmCenter"
          | "ackedAt"
          | "ackMessage"
          | "position"
          | "assetPosition"
          | "helperCount.true"
          | "helperCount.null"
          | "helperCount.false"
          | "helperName.true"
          | "helperName.null"
          | "helperName.false"
          | "alarmManager"
          | "alarmId"
          | "assetId"
          | "hubspotId"
          | "alarmDate"
          | "customerName"
          | "assetName"
          | "simpleDescription"
          | "contractDeliveryDate"
          | "alarmName"
          | "onHelpProtocol"
          | "policeCalled"
        )[];
        filter?: {
          assets?: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          }[];
          assetGroups?: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
        };
        severities?: ("red" | "orange" | "green")[] | null;
        alarmTypes?: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[] | null;
        timeSeries: {
          granularity: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          timeframe: {
            type: "month" | "week" | "day" | "hour" | "minute";
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
        };
        theme?: "bhvk" | "default";
      }
    | {
        type: "appUsage";
        mode?: "hourlyUsage" | "license";
        filter?: {
          assets?: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          }[];
          assetGroups?: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
        };
        timeSeries: {
          granularity: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          timeframe: {
            type: "month" | "week";
            /**
             * @min 1
             * @max 1
             */
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
        };
        inactivityThreshold?:
          | {
              type: "minute";
              value: number;
            }
          | {
              type: "hour";
              value: number;
            }
          | {
              type: "day";
              /**
               * @min 1
               * @exclusiveMin false
               * @max 14
               * @exclusiveMax false
               */
              value: number;
            };
        reduceEmailSize?: boolean;
        theme?: "bhvk" | "default";
      }
    | {
        type: "assetCertificationExpiryBulk";
      }
    | {
        type: "assetCertificationExpiry";
      }
    | {
        type: "assetHistory";
        asset: {
          /** @format uuid */
          _id: string;
          _ref: "Asset";
        };
        timeSeries: {
          granularity: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          timeframe: {
            type: "month" | "week" | "day" | "hour" | "minute";
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
        };
        aggregatorOptions: {
          includeRaw: boolean;
          includeSimple: boolean;
        };
        theme?: "bhvk" | "default";
      }
    | {
        type: "assetVerificationCode";
        theme?: "bhvk" | "default";
      }
    | {
        type: "auditLog";
        subject?: (
          | "Alarm"
          | "AlarmCall"
          | "AlarmCallEvent"
          | "AlarmCallParticipant"
          | "AlarmEvent"
          | "AlarmHelper"
          | "AlarmPushSubscription"
          | "AlarmProfessionalResponder"
          | "Asset"
          | "AssetGroup"
          | "AssetPropertyVerification"
          | "AuditLog"
          | "Beacon"
          | "BillingAuditLog"
          | "BillingContract"
          | "BillingCustomer"
          | "BillingInvoice"
          | "ContactList"
          | "Customer"
          | "CustomerAlarmCenterRelation"
          | "CustomerUserRelation"
          | "Device"
          | "DeviceLogUpload"
          | "DomainLink"
          | "Observation"
          | "ObservationTrigger"
          | "Overlay"
          | "RegistrationTemplate"
          | "ReportTrigger"
          | "ReportTriggerRun"
          | "Role"
          | "StaticResponder"
          | "Webhook"
          | "User"
          | "Zone"
          | "Fingerprint"
          | "Visitor"
          | "VisitRecord"
          | "Report"
          | "DeviceLogUploadBatch"
          | "all"
        )[];
        operation?: string[];
        user?: {
          /** @format uuid */
          _id: string;
          _ref: "User";
        }[];
        reasonKey?: string[];
        ids?: string[];
        pagination: {
          /** @format date-time */
          after: string;
          order: "asc" | "desc";
          max: number;
        };
        exposeUsers?: boolean;
        exposeHistory?: boolean;
      }
    | {
        type: "badReviewOnSurvey";
        omitPiiFields?: ("phone" | "email")[];
      }
    | {
        type: "deviceLog";
        device?: {
          /** @format uuid */
          _id: string;
          _ref: "Device";
        }[];
        deviceLogUpload?: {
          /** @format uuid */
          _id: string;
          _ref: "DeviceLogUpload";
        }[];
        severity?: ("debug" | "info" | "warning" | "error")[];
        message?: string[];
        location?: string[];
        pagination: {
          /** @format date-time */
          after: string;
          order: "asc" | "desc";
          max: number;
        };
      }
    | {
        type: "gatewayAlive";
        lastSeenThreshold: {
          type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
          value: number;
        };
      }
    | {
        type: "inactivityMonitor";
        lastSeenThreshold: {
          type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
          value: number;
        };
        assets?: {
          /** @format uuid */
          _id: string;
          _ref: "Asset";
        }[];
        assetGroups?: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        appMode?: ("off" | "on" | "risk")[];
        timeout?: {
          type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
          value: number;
        };
        theme?: "bhvk" | "default";
        omitPiiFields?: "address"[];
      }
    | {
        type: "inventoryItemsExpiry";
      }
    | {
        type: "newAlarm";
        filter?: {
          severities?: ("red" | "orange" | "green")[];
          alarmTypes?: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[];
          assets?: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          }[];
          assetGroups?: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
        };
        procedure?: string;
        info?: string;
        hideOpenInAppButton?: boolean;
        exposeAlarmCreatorProperties?: ("smsNumber" | "phoneNumber" | "email")[];
        theme?: "bhvk" | "default";
      }
    | {
        type: "surveyInvitation";
      }
    | {
        type: "surveyOverview";
        timeframe: {
          type: "month" | "week" | "day" | "hour" | "minute";
          value: number;
          floorTo?: "month" | "week" | "day" | "hour" | "minute";
        };
      }
    | {
        type: "unhealthyBeacons";
        lastSeenThreshold: {
          type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
          value: number;
        };
        theme?: "bhvk" | "default";
      }
    | {
        type: "zoneOverview";
        inactivityThreshold?: {
          type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
          value: number;
        };
        timeSeries: {
          granularity: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          timeframe: {
            type: "month" | "week" | "day" | "hour" | "minute";
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
        };
        minOccupancyMode?: "alert" | "overview";
        minOccupancy?: {
          /**
           * @min 0
           * @exclusiveMin false
           * @max 1
           * @exclusiveMax false
           */
          ratioThreshold: number;
          /**
           * @min 0
           * @exclusiveMin false
           */
          assetCount: number;
        };
        attachment?: {
          granularity: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          /**
           * @min 0
           * @exclusiveMin false
           * @max 1
           * @exclusiveMax false
           */
          availabilityThresholdRatio?: number;
        };
        zones?: {
          /** @format uuid */
          _id: string;
          _ref: "Zone";
        }[];
        assets?: {
          /** @format uuid */
          _id: string;
          _ref: "Asset";
        }[];
        assetGroups?: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        schedule?:
          | {
              entries: {
                daysOfWeek: number[];
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeStart: string;
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeEnd: string;
                /**
                 * @min 0
                 * @exclusiveMin false
                 */
                minOccupancy: number;
              }[];
            }
          | {
              entries: {
                daysOfWeek: number[];
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeStart: string;
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeEnd: string;
              }[];
            };
        theme?: "bhvk" | "default";
        disableCompressTimeseries?: boolean;
      }
    | {
        type: "visitorRegistrationQrCode";
      };
  channelOverrides?: {
    /** PII */
    unsubscribedEmails: string[];
  };
  channels: (
    | {
        type: "email";
        /** PII */
        address?: string[];
        contactLists?: {
          /** @format uuid */
          _id: string;
          _ref: "ContactList";
        }[];
        getters?: {
          /** @maxLength 1024 */
          path: string;
        }[];
        assets?: {
          /** @format uuid */
          _id: string;
          _ref: "Asset";
        }[];
        assetGroups?: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        config?: {
          /**
           * PII
           * @maxLength 1024
           */
          subjectOverride?: string;
          /**
           * PII
           * @maxLength 4096
           */
          headerOverride?: string;
        };
      }
    | {
        type: "sms";
        /** PII */
        numbers: string[];
        contactLists: {
          /** @format uuid */
          _id: string;
          _ref: "ContactList";
        }[];
      }
    | {
        type: "alarm";
        config: {
          severity: "red" | "orange" | "green";
          type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
          /**
           * PII
           * @maxLength 4096
           */
          procedure: string | null;
          /**
           * PII
           * @maxLength 1024
           */
          name: string;
        };
      }
    | {
        type: "observation";
      }
  )[];
  /** @default null */
  scheduleTrigger?: {
    interval: {
      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
      value: number;
    };
    cooldown?: {
      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
      value: number;
    };
    /** @format date-time */
    nextAt: string | null;
    /** @format date-time */
    lastAt: string | null;
    /** @format date-time */
    lastAttemptedAt: string | null;
  };
  /** @default null */
  eventTrigger?: {
    events: string[];
    executionDelay?: {
      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
      value: number;
    };
    schedule?: {
      entries: {
        daysOfWeek: number[];
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeStart: string;
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeEnd: string;
      }[];
    };
  } | null;
  enabled: boolean;
  /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
  locale?: string;
  /** @maxLength 1024 */
  timezone?: string;
}

export interface ReportTriggerRunCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  } | null;
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** PII */
  reportTrigger: {
    /** @format uuid */
    _id: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    telluId?: number | null;
    migrationFinalised?: boolean | null;
    /** @format date-time */
    migrationFinalisedDate?: string | null;
    customer: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    } | null;
    /** @default {"type":"parents","extra":[]} */
    share?: {
      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
      extra?: {
        /** @format uuid */
        _id: string;
        _ref: "Customer";
      }[];
    };
    config:
      | {
          type: "accessRequestAlert";
          filter?: {
            forced?: boolean;
          };
          theme?: "bhvk" | "default";
        }
      | {
          type: "accessRequestOverview";
          theme?: "bhvk" | "default";
          pagination: {
            /** @format date-time */
            after: string;
            order: "asc" | "desc";
            max: number;
          };
        }
      | {
          type: "alarmCenterStatus";
          exclude?: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          }[];
          timeframe: {
            type: "month" | "week" | "day" | "hour" | "minute";
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
          theme?: "bhvk" | "default";
        }
      | {
          type: "alarmCenterAnalytics";
          timeSeries: {
            granularity: {
              type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
              value: number;
            };
            timeframe: {
              type: "month" | "week" | "day" | "hour" | "minute";
              value: number;
              floorTo?: "month" | "week" | "day" | "hour" | "minute";
            };
          };
          theme?: "bhvk" | "default";
        }
      | {
          type: "alarms";
          excelFormat: "default" | "smc";
          excelColumns?: (
            | "customer"
            | "name"
            | "severity"
            | "type"
            | "asset"
            | "createdAt"
            | "timeOfFirstHelper"
            | "timeUntilFirstHelper"
            | "alarmCenter"
            | "ackedAt"
            | "ackMessage"
            | "position"
            | "assetPosition"
            | "helperCount.true"
            | "helperCount.null"
            | "helperCount.false"
            | "helperName.true"
            | "helperName.null"
            | "helperName.false"
            | "alarmManager"
            | "alarmId"
            | "assetId"
            | "hubspotId"
            | "alarmDate"
            | "customerName"
            | "assetName"
            | "simpleDescription"
            | "contractDeliveryDate"
            | "alarmName"
            | "onHelpProtocol"
            | "policeCalled"
          )[];
          filter?: {
            assets?: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            }[];
            assetGroups?: {
              /** @format uuid */
              _id: string;
              _ref: "AssetGroup";
            }[];
          };
          severities?: ("red" | "orange" | "green")[] | null;
          alarmTypes?: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[] | null;
          timeSeries: {
            granularity: {
              type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
              value: number;
            };
            timeframe: {
              type: "month" | "week" | "day" | "hour" | "minute";
              value: number;
              floorTo?: "month" | "week" | "day" | "hour" | "minute";
            };
          };
          theme?: "bhvk" | "default";
        }
      | {
          type: "appUsage";
          mode?: "hourlyUsage" | "license";
          filter?: {
            assets?: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            }[];
            assetGroups?: {
              /** @format uuid */
              _id: string;
              _ref: "AssetGroup";
            }[];
          };
          timeSeries: {
            granularity: {
              type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
              value: number;
            };
            timeframe: {
              type: "month" | "week";
              /**
               * @min 1
               * @max 1
               */
              value: number;
              floorTo?: "month" | "week" | "day" | "hour" | "minute";
            };
          };
          inactivityThreshold?:
            | {
                type: "minute";
                value: number;
              }
            | {
                type: "hour";
                value: number;
              }
            | {
                type: "day";
                /**
                 * @min 1
                 * @exclusiveMin false
                 * @max 14
                 * @exclusiveMax false
                 */
                value: number;
              };
          reduceEmailSize?: boolean;
          theme?: "bhvk" | "default";
        }
      | {
          type: "assetCertificationExpiryBulk";
        }
      | {
          type: "assetCertificationExpiry";
        }
      | {
          type: "assetHistory";
          asset: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          };
          timeSeries: {
            granularity: {
              type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
              value: number;
            };
            timeframe: {
              type: "month" | "week" | "day" | "hour" | "minute";
              value: number;
              floorTo?: "month" | "week" | "day" | "hour" | "minute";
            };
          };
          aggregatorOptions: {
            includeRaw: boolean;
            includeSimple: boolean;
          };
          theme?: "bhvk" | "default";
        }
      | {
          type: "assetVerificationCode";
          theme?: "bhvk" | "default";
        }
      | {
          type: "auditLog";
          subject?: (
            | "Alarm"
            | "AlarmCall"
            | "AlarmCallEvent"
            | "AlarmCallParticipant"
            | "AlarmEvent"
            | "AlarmHelper"
            | "AlarmPushSubscription"
            | "AlarmProfessionalResponder"
            | "Asset"
            | "AssetGroup"
            | "AssetPropertyVerification"
            | "AuditLog"
            | "Beacon"
            | "BillingAuditLog"
            | "BillingContract"
            | "BillingCustomer"
            | "BillingInvoice"
            | "ContactList"
            | "Customer"
            | "CustomerAlarmCenterRelation"
            | "CustomerUserRelation"
            | "Device"
            | "DeviceLogUpload"
            | "DomainLink"
            | "Observation"
            | "ObservationTrigger"
            | "Overlay"
            | "RegistrationTemplate"
            | "ReportTrigger"
            | "ReportTriggerRun"
            | "Role"
            | "StaticResponder"
            | "Webhook"
            | "User"
            | "Zone"
            | "Fingerprint"
            | "Visitor"
            | "VisitRecord"
            | "Report"
            | "DeviceLogUploadBatch"
            | "all"
          )[];
          operation?: string[];
          user?: {
            /** @format uuid */
            _id: string;
            _ref: "User";
          }[];
          reasonKey?: string[];
          ids?: string[];
          pagination: {
            /** @format date-time */
            after: string;
            order: "asc" | "desc";
            max: number;
          };
          exposeUsers?: boolean;
          exposeHistory?: boolean;
        }
      | {
          type: "badReviewOnSurvey";
          omitPiiFields?: ("phone" | "email")[];
        }
      | {
          type: "deviceLog";
          device?: {
            /** @format uuid */
            _id: string;
            _ref: "Device";
          }[];
          deviceLogUpload?: {
            /** @format uuid */
            _id: string;
            _ref: "DeviceLogUpload";
          }[];
          severity?: ("debug" | "info" | "warning" | "error")[];
          message?: string[];
          location?: string[];
          pagination: {
            /** @format date-time */
            after: string;
            order: "asc" | "desc";
            max: number;
          };
        }
      | {
          type: "gatewayAlive";
          lastSeenThreshold: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
        }
      | {
          type: "inactivityMonitor";
          lastSeenThreshold: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          assets?: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          }[];
          assetGroups?: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
          appMode?: ("off" | "on" | "risk")[];
          timeout?: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          theme?: "bhvk" | "default";
          omitPiiFields?: "address"[];
        }
      | {
          type: "inventoryItemsExpiry";
        }
      | {
          type: "newAlarm";
          filter?: {
            severities?: ("red" | "orange" | "green")[];
            alarmTypes?: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[];
            assets?: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            }[];
            assetGroups?: {
              /** @format uuid */
              _id: string;
              _ref: "AssetGroup";
            }[];
          };
          procedure?: string;
          info?: string;
          hideOpenInAppButton?: boolean;
          exposeAlarmCreatorProperties?: ("smsNumber" | "phoneNumber" | "email")[];
          theme?: "bhvk" | "default";
        }
      | {
          type: "surveyInvitation";
        }
      | {
          type: "surveyOverview";
          timeframe: {
            type: "month" | "week" | "day" | "hour" | "minute";
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
        }
      | {
          type: "unhealthyBeacons";
          lastSeenThreshold: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          theme?: "bhvk" | "default";
        }
      | {
          type: "zoneOverview";
          inactivityThreshold?: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          timeSeries: {
            granularity: {
              type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
              value: number;
            };
            timeframe: {
              type: "month" | "week" | "day" | "hour" | "minute";
              value: number;
              floorTo?: "month" | "week" | "day" | "hour" | "minute";
            };
          };
          minOccupancyMode?: "alert" | "overview";
          minOccupancy?: {
            /**
             * @min 0
             * @exclusiveMin false
             * @max 1
             * @exclusiveMax false
             */
            ratioThreshold: number;
            /**
             * @min 0
             * @exclusiveMin false
             */
            assetCount: number;
          };
          attachment?: {
            granularity: {
              type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
              value: number;
            };
            /**
             * @min 0
             * @exclusiveMin false
             * @max 1
             * @exclusiveMax false
             */
            availabilityThresholdRatio?: number;
          };
          zones?: {
            /** @format uuid */
            _id: string;
            _ref: "Zone";
          }[];
          assets?: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          }[];
          assetGroups?: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
          schedule?:
            | {
                entries: {
                  daysOfWeek: number[];
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeStart: string;
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeEnd: string;
                  /**
                   * @min 0
                   * @exclusiveMin false
                   */
                  minOccupancy: number;
                }[];
              }
            | {
                entries: {
                  daysOfWeek: number[];
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeStart: string;
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeEnd: string;
                }[];
              };
          theme?: "bhvk" | "default";
          disableCompressTimeseries?: boolean;
        }
      | {
          type: "visitorRegistrationQrCode";
        };
    channelOverrides?: {
      /** PII */
      unsubscribedEmails: string[];
    };
    channels: (
      | {
          type: "email";
          /** PII */
          address?: string[];
          contactLists?: {
            /** @format uuid */
            _id: string;
            _ref: "ContactList";
          }[];
          getters?: {
            /** @maxLength 1024 */
            path: string;
          }[];
          assets?: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          }[];
          assetGroups?: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
          config?: {
            /**
             * PII
             * @maxLength 1024
             */
            subjectOverride?: string;
            /**
             * PII
             * @maxLength 4096
             */
            headerOverride?: string;
          };
        }
      | {
          type: "sms";
          /** PII */
          numbers: string[];
          contactLists: {
            /** @format uuid */
            _id: string;
            _ref: "ContactList";
          }[];
        }
      | {
          type: "alarm";
          config: {
            severity: "red" | "orange" | "green";
            type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
            /**
             * PII
             * @maxLength 4096
             */
            procedure: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
          };
        }
      | {
          type: "observation";
        }
    )[];
    /** @default null */
    scheduleTrigger?: {
      interval: {
        type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
        value: number;
      };
      cooldown?: {
        type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
        value: number;
      };
      /** @format date-time */
      nextAt: string | null;
      /** @format date-time */
      lastAt: string | null;
      /** @format date-time */
      lastAttemptedAt: string | null;
    };
    /** @default null */
    eventTrigger?: {
      events: string[];
      executionDelay?: {
        type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
        value: number;
      };
      schedule?: {
        entries: {
          daysOfWeek: number[];
          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
          timeStart: string;
          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
          timeEnd: string;
        }[];
      };
    } | null;
    enabled: boolean;
    /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
    locale?: string;
    /** @maxLength 1024 */
    timezone?: string;
  };
  runReason: "schedule" | "event";
  /** @format date-time */
  generatedAt: string;
  /** PII */
  output: Record<string, any>;
  /** PII */
  channelResults: {
    success: boolean;
    data?: any;
  }[];
}

export interface ReportTriggerRunOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  } | null;
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** PII */
  reportTrigger: {
    /** @format uuid */
    _id: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    telluId?: number | null;
    migrationFinalised?: boolean | null;
    /** @format date-time */
    migrationFinalisedDate?: string | null;
    customer: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    } | null;
    /** @default {"type":"parents","extra":[]} */
    share?: {
      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
      extra?: {
        /** @format uuid */
        _id: string;
        _ref: "Customer";
      }[];
    };
    config:
      | {
          type: "accessRequestAlert";
          filter?: {
            forced?: boolean;
          };
          theme?: "bhvk" | "default";
        }
      | {
          type: "accessRequestOverview";
          theme?: "bhvk" | "default";
          pagination: {
            /** @format date-time */
            after: string;
            order: "asc" | "desc";
            max: number;
          };
        }
      | {
          type: "alarmCenterStatus";
          exclude?: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          }[];
          timeframe: {
            type: "month" | "week" | "day" | "hour" | "minute";
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
          theme?: "bhvk" | "default";
        }
      | {
          type: "alarmCenterAnalytics";
          timeSeries: {
            granularity: {
              type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
              value: number;
            };
            timeframe: {
              type: "month" | "week" | "day" | "hour" | "minute";
              value: number;
              floorTo?: "month" | "week" | "day" | "hour" | "minute";
            };
          };
          theme?: "bhvk" | "default";
        }
      | {
          type: "alarms";
          excelFormat: "default" | "smc";
          excelColumns?: (
            | "customer"
            | "name"
            | "severity"
            | "type"
            | "asset"
            | "createdAt"
            | "timeOfFirstHelper"
            | "timeUntilFirstHelper"
            | "alarmCenter"
            | "ackedAt"
            | "ackMessage"
            | "position"
            | "assetPosition"
            | "helperCount.true"
            | "helperCount.null"
            | "helperCount.false"
            | "helperName.true"
            | "helperName.null"
            | "helperName.false"
            | "alarmManager"
            | "alarmId"
            | "assetId"
            | "hubspotId"
            | "alarmDate"
            | "customerName"
            | "assetName"
            | "simpleDescription"
            | "contractDeliveryDate"
            | "alarmName"
            | "onHelpProtocol"
            | "policeCalled"
          )[];
          filter?: {
            assets?: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            }[];
            assetGroups?: {
              /** @format uuid */
              _id: string;
              _ref: "AssetGroup";
            }[];
          };
          severities?: ("red" | "orange" | "green")[] | null;
          alarmTypes?: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[] | null;
          timeSeries: {
            granularity: {
              type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
              value: number;
            };
            timeframe: {
              type: "month" | "week" | "day" | "hour" | "minute";
              value: number;
              floorTo?: "month" | "week" | "day" | "hour" | "minute";
            };
          };
          theme?: "bhvk" | "default";
        }
      | {
          type: "appUsage";
          mode?: "hourlyUsage" | "license";
          filter?: {
            assets?: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            }[];
            assetGroups?: {
              /** @format uuid */
              _id: string;
              _ref: "AssetGroup";
            }[];
          };
          timeSeries: {
            granularity: {
              type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
              value: number;
            };
            timeframe: {
              type: "month" | "week";
              /**
               * @min 1
               * @max 1
               */
              value: number;
              floorTo?: "month" | "week" | "day" | "hour" | "minute";
            };
          };
          inactivityThreshold?:
            | {
                type: "minute";
                value: number;
              }
            | {
                type: "hour";
                value: number;
              }
            | {
                type: "day";
                /**
                 * @min 1
                 * @exclusiveMin false
                 * @max 14
                 * @exclusiveMax false
                 */
                value: number;
              };
          reduceEmailSize?: boolean;
          theme?: "bhvk" | "default";
        }
      | {
          type: "assetCertificationExpiryBulk";
        }
      | {
          type: "assetCertificationExpiry";
        }
      | {
          type: "assetHistory";
          asset: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          };
          timeSeries: {
            granularity: {
              type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
              value: number;
            };
            timeframe: {
              type: "month" | "week" | "day" | "hour" | "minute";
              value: number;
              floorTo?: "month" | "week" | "day" | "hour" | "minute";
            };
          };
          aggregatorOptions: {
            includeRaw: boolean;
            includeSimple: boolean;
          };
          theme?: "bhvk" | "default";
        }
      | {
          type: "assetVerificationCode";
          theme?: "bhvk" | "default";
        }
      | {
          type: "auditLog";
          subject?: (
            | "Alarm"
            | "AlarmCall"
            | "AlarmCallEvent"
            | "AlarmCallParticipant"
            | "AlarmEvent"
            | "AlarmHelper"
            | "AlarmPushSubscription"
            | "AlarmProfessionalResponder"
            | "Asset"
            | "AssetGroup"
            | "AssetPropertyVerification"
            | "AuditLog"
            | "Beacon"
            | "BillingAuditLog"
            | "BillingContract"
            | "BillingCustomer"
            | "BillingInvoice"
            | "ContactList"
            | "Customer"
            | "CustomerAlarmCenterRelation"
            | "CustomerUserRelation"
            | "Device"
            | "DeviceLogUpload"
            | "DomainLink"
            | "Observation"
            | "ObservationTrigger"
            | "Overlay"
            | "RegistrationTemplate"
            | "ReportTrigger"
            | "ReportTriggerRun"
            | "Role"
            | "StaticResponder"
            | "Webhook"
            | "User"
            | "Zone"
            | "Fingerprint"
            | "Visitor"
            | "VisitRecord"
            | "Report"
            | "DeviceLogUploadBatch"
            | "all"
          )[];
          operation?: string[];
          user?: {
            /** @format uuid */
            _id: string;
            _ref: "User";
          }[];
          reasonKey?: string[];
          ids?: string[];
          pagination: {
            /** @format date-time */
            after: string;
            order: "asc" | "desc";
            max: number;
          };
          exposeUsers?: boolean;
          exposeHistory?: boolean;
        }
      | {
          type: "badReviewOnSurvey";
          omitPiiFields?: ("phone" | "email")[];
        }
      | {
          type: "deviceLog";
          device?: {
            /** @format uuid */
            _id: string;
            _ref: "Device";
          }[];
          deviceLogUpload?: {
            /** @format uuid */
            _id: string;
            _ref: "DeviceLogUpload";
          }[];
          severity?: ("debug" | "info" | "warning" | "error")[];
          message?: string[];
          location?: string[];
          pagination: {
            /** @format date-time */
            after: string;
            order: "asc" | "desc";
            max: number;
          };
        }
      | {
          type: "gatewayAlive";
          lastSeenThreshold: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
        }
      | {
          type: "inactivityMonitor";
          lastSeenThreshold: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          assets?: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          }[];
          assetGroups?: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
          appMode?: ("off" | "on" | "risk")[];
          timeout?: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          theme?: "bhvk" | "default";
          omitPiiFields?: "address"[];
        }
      | {
          type: "inventoryItemsExpiry";
        }
      | {
          type: "newAlarm";
          filter?: {
            severities?: ("red" | "orange" | "green")[];
            alarmTypes?: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[];
            assets?: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            }[];
            assetGroups?: {
              /** @format uuid */
              _id: string;
              _ref: "AssetGroup";
            }[];
          };
          procedure?: string;
          info?: string;
          hideOpenInAppButton?: boolean;
          exposeAlarmCreatorProperties?: ("smsNumber" | "phoneNumber" | "email")[];
          theme?: "bhvk" | "default";
        }
      | {
          type: "surveyInvitation";
        }
      | {
          type: "surveyOverview";
          timeframe: {
            type: "month" | "week" | "day" | "hour" | "minute";
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
        }
      | {
          type: "unhealthyBeacons";
          lastSeenThreshold: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          theme?: "bhvk" | "default";
        }
      | {
          type: "zoneOverview";
          inactivityThreshold?: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          timeSeries: {
            granularity: {
              type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
              value: number;
            };
            timeframe: {
              type: "month" | "week" | "day" | "hour" | "minute";
              value: number;
              floorTo?: "month" | "week" | "day" | "hour" | "minute";
            };
          };
          minOccupancyMode?: "alert" | "overview";
          minOccupancy?: {
            /**
             * @min 0
             * @exclusiveMin false
             * @max 1
             * @exclusiveMax false
             */
            ratioThreshold: number;
            /**
             * @min 0
             * @exclusiveMin false
             */
            assetCount: number;
          };
          attachment?: {
            granularity: {
              type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
              value: number;
            };
            /**
             * @min 0
             * @exclusiveMin false
             * @max 1
             * @exclusiveMax false
             */
            availabilityThresholdRatio?: number;
          };
          zones?: {
            /** @format uuid */
            _id: string;
            _ref: "Zone";
          }[];
          assets?: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          }[];
          assetGroups?: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
          schedule?:
            | {
                entries: {
                  daysOfWeek: number[];
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeStart: string;
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeEnd: string;
                  /**
                   * @min 0
                   * @exclusiveMin false
                   */
                  minOccupancy: number;
                }[];
              }
            | {
                entries: {
                  daysOfWeek: number[];
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeStart: string;
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeEnd: string;
                }[];
              };
          theme?: "bhvk" | "default";
          disableCompressTimeseries?: boolean;
        }
      | {
          type: "visitorRegistrationQrCode";
        };
    channelOverrides?: {
      /** PII */
      unsubscribedEmails: string[];
    };
    channels: (
      | {
          type: "email";
          /** PII */
          address?: string[];
          contactLists?: {
            /** @format uuid */
            _id: string;
            _ref: "ContactList";
          }[];
          getters?: {
            /** @maxLength 1024 */
            path: string;
          }[];
          assets?: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          }[];
          assetGroups?: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
          config?: {
            /**
             * PII
             * @maxLength 1024
             */
            subjectOverride?: string;
            /**
             * PII
             * @maxLength 4096
             */
            headerOverride?: string;
          };
        }
      | {
          type: "sms";
          /** PII */
          numbers: string[];
          contactLists: {
            /** @format uuid */
            _id: string;
            _ref: "ContactList";
          }[];
        }
      | {
          type: "alarm";
          config: {
            severity: "red" | "orange" | "green";
            type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
            /**
             * PII
             * @maxLength 4096
             */
            procedure: string | null;
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
          };
        }
      | {
          type: "observation";
        }
    )[];
    /** @default null */
    scheduleTrigger?: {
      interval: {
        type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
        value: number;
      };
      cooldown?: {
        type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
        value: number;
      };
      /** @format date-time */
      nextAt: string | null;
      /** @format date-time */
      lastAt: string | null;
      /** @format date-time */
      lastAttemptedAt: string | null;
    };
    /** @default null */
    eventTrigger?: {
      events: string[];
      executionDelay?: {
        type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
        value: number;
      };
      schedule?: {
        entries: {
          daysOfWeek: number[];
          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
          timeStart: string;
          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
          timeEnd: string;
        }[];
      };
    } | null;
    enabled: boolean;
    /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
    locale?: string;
    /** @maxLength 1024 */
    timezone?: string;
  };
  runReason: "schedule" | "event";
  /** @format date-time */
  generatedAt: string;
  /** PII */
  output: Record<string, any>;
  /** PII */
  channelResults: {
    success: boolean;
    data?: any;
  }[];
}

export interface ReportTriggerUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  } | null;
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  config?:
    | {
        type: "accessRequestAlert";
        filter?: {
          forced?: boolean;
        };
        theme?: "bhvk" | "default";
      }
    | {
        type: "accessRequestOverview";
        theme?: "bhvk" | "default";
        pagination: {
          /** @format date-time */
          after: string;
          order: "asc" | "desc";
          max: number;
        };
      }
    | {
        type: "alarmCenterStatus";
        exclude?: {
          /** @format uuid */
          _id: string;
          _ref: "Customer";
        }[];
        timeframe: {
          type: "month" | "week" | "day" | "hour" | "minute";
          value: number;
          floorTo?: "month" | "week" | "day" | "hour" | "minute";
        };
        theme?: "bhvk" | "default";
      }
    | {
        type: "alarmCenterAnalytics";
        timeSeries: {
          granularity: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          timeframe: {
            type: "month" | "week" | "day" | "hour" | "minute";
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
        };
        theme?: "bhvk" | "default";
      }
    | {
        type: "alarms";
        excelFormat: "default" | "smc";
        excelColumns?: (
          | "customer"
          | "name"
          | "severity"
          | "type"
          | "asset"
          | "createdAt"
          | "timeOfFirstHelper"
          | "timeUntilFirstHelper"
          | "alarmCenter"
          | "ackedAt"
          | "ackMessage"
          | "position"
          | "assetPosition"
          | "helperCount.true"
          | "helperCount.null"
          | "helperCount.false"
          | "helperName.true"
          | "helperName.null"
          | "helperName.false"
          | "alarmManager"
          | "alarmId"
          | "assetId"
          | "hubspotId"
          | "alarmDate"
          | "customerName"
          | "assetName"
          | "simpleDescription"
          | "contractDeliveryDate"
          | "alarmName"
          | "onHelpProtocol"
          | "policeCalled"
        )[];
        filter?: {
          assets?: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          }[];
          assetGroups?: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
        };
        severities?: ("red" | "orange" | "green")[] | null;
        alarmTypes?: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[] | null;
        timeSeries: {
          granularity: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          timeframe: {
            type: "month" | "week" | "day" | "hour" | "minute";
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
        };
        theme?: "bhvk" | "default";
      }
    | {
        type: "appUsage";
        mode?: "hourlyUsage" | "license";
        filter?: {
          assets?: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          }[];
          assetGroups?: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
        };
        timeSeries: {
          granularity: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          timeframe: {
            type: "month" | "week";
            /**
             * @min 1
             * @max 1
             */
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
        };
        inactivityThreshold?:
          | {
              type: "minute";
              value: number;
            }
          | {
              type: "hour";
              value: number;
            }
          | {
              type: "day";
              /**
               * @min 1
               * @exclusiveMin false
               * @max 14
               * @exclusiveMax false
               */
              value: number;
            };
        reduceEmailSize?: boolean;
        theme?: "bhvk" | "default";
      }
    | {
        type: "assetCertificationExpiryBulk";
      }
    | {
        type: "assetCertificationExpiry";
      }
    | {
        type: "assetHistory";
        asset: {
          /** @format uuid */
          _id: string;
          _ref: "Asset";
        };
        timeSeries: {
          granularity: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          timeframe: {
            type: "month" | "week" | "day" | "hour" | "minute";
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
        };
        aggregatorOptions: {
          includeRaw: boolean;
          includeSimple: boolean;
        };
        theme?: "bhvk" | "default";
      }
    | {
        type: "assetVerificationCode";
        theme?: "bhvk" | "default";
      }
    | {
        type: "auditLog";
        subject?: (
          | "Alarm"
          | "AlarmCall"
          | "AlarmCallEvent"
          | "AlarmCallParticipant"
          | "AlarmEvent"
          | "AlarmHelper"
          | "AlarmPushSubscription"
          | "AlarmProfessionalResponder"
          | "Asset"
          | "AssetGroup"
          | "AssetPropertyVerification"
          | "AuditLog"
          | "Beacon"
          | "BillingAuditLog"
          | "BillingContract"
          | "BillingCustomer"
          | "BillingInvoice"
          | "ContactList"
          | "Customer"
          | "CustomerAlarmCenterRelation"
          | "CustomerUserRelation"
          | "Device"
          | "DeviceLogUpload"
          | "DomainLink"
          | "Observation"
          | "ObservationTrigger"
          | "Overlay"
          | "RegistrationTemplate"
          | "ReportTrigger"
          | "ReportTriggerRun"
          | "Role"
          | "StaticResponder"
          | "Webhook"
          | "User"
          | "Zone"
          | "Fingerprint"
          | "Visitor"
          | "VisitRecord"
          | "Report"
          | "DeviceLogUploadBatch"
          | "all"
        )[];
        operation?: string[];
        user?: {
          /** @format uuid */
          _id: string;
          _ref: "User";
        }[];
        reasonKey?: string[];
        ids?: string[];
        pagination: {
          /** @format date-time */
          after: string;
          order: "asc" | "desc";
          max: number;
        };
        exposeUsers?: boolean;
        exposeHistory?: boolean;
      }
    | {
        type: "badReviewOnSurvey";
        omitPiiFields?: ("phone" | "email")[];
      }
    | {
        type: "deviceLog";
        device?: {
          /** @format uuid */
          _id: string;
          _ref: "Device";
        }[];
        deviceLogUpload?: {
          /** @format uuid */
          _id: string;
          _ref: "DeviceLogUpload";
        }[];
        severity?: ("debug" | "info" | "warning" | "error")[];
        message?: string[];
        location?: string[];
        pagination: {
          /** @format date-time */
          after: string;
          order: "asc" | "desc";
          max: number;
        };
      }
    | {
        type: "gatewayAlive";
        lastSeenThreshold: {
          type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
          value: number;
        };
      }
    | {
        type: "inactivityMonitor";
        lastSeenThreshold: {
          type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
          value: number;
        };
        assets?: {
          /** @format uuid */
          _id: string;
          _ref: "Asset";
        }[];
        assetGroups?: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        appMode?: ("off" | "on" | "risk")[];
        timeout?: {
          type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
          value: number;
        };
        theme?: "bhvk" | "default";
        omitPiiFields?: "address"[];
      }
    | {
        type: "inventoryItemsExpiry";
      }
    | {
        type: "newAlarm";
        filter?: {
          severities?: ("red" | "orange" | "green")[];
          alarmTypes?: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[];
          assets?: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          }[];
          assetGroups?: {
            /** @format uuid */
            _id: string;
            _ref: "AssetGroup";
          }[];
        };
        procedure?: string;
        info?: string;
        hideOpenInAppButton?: boolean;
        exposeAlarmCreatorProperties?: ("smsNumber" | "phoneNumber" | "email")[];
        theme?: "bhvk" | "default";
      }
    | {
        type: "surveyInvitation";
      }
    | {
        type: "surveyOverview";
        timeframe: {
          type: "month" | "week" | "day" | "hour" | "minute";
          value: number;
          floorTo?: "month" | "week" | "day" | "hour" | "minute";
        };
      }
    | {
        type: "unhealthyBeacons";
        lastSeenThreshold: {
          type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
          value: number;
        };
        theme?: "bhvk" | "default";
      }
    | {
        type: "zoneOverview";
        inactivityThreshold?: {
          type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
          value: number;
        };
        timeSeries: {
          granularity: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          timeframe: {
            type: "month" | "week" | "day" | "hour" | "minute";
            value: number;
            floorTo?: "month" | "week" | "day" | "hour" | "minute";
          };
        };
        minOccupancyMode?: "alert" | "overview";
        minOccupancy?: {
          /**
           * @min 0
           * @exclusiveMin false
           * @max 1
           * @exclusiveMax false
           */
          ratioThreshold: number;
          /**
           * @min 0
           * @exclusiveMin false
           */
          assetCount: number;
        };
        attachment?: {
          granularity: {
            type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
            value: number;
          };
          /**
           * @min 0
           * @exclusiveMin false
           * @max 1
           * @exclusiveMax false
           */
          availabilityThresholdRatio?: number;
        };
        zones?: {
          /** @format uuid */
          _id: string;
          _ref: "Zone";
        }[];
        assets?: {
          /** @format uuid */
          _id: string;
          _ref: "Asset";
        }[];
        assetGroups?: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        schedule?:
          | {
              entries: {
                daysOfWeek: number[];
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeStart: string;
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeEnd: string;
                /**
                 * @min 0
                 * @exclusiveMin false
                 */
                minOccupancy: number;
              }[];
            }
          | {
              entries: {
                daysOfWeek: number[];
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeStart: string;
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeEnd: string;
              }[];
            };
        theme?: "bhvk" | "default";
        disableCompressTimeseries?: boolean;
      }
    | {
        type: "visitorRegistrationQrCode";
      };
  channelOverrides?: {
    /** PII */
    unsubscribedEmails: string[];
  };
  channels?: (
    | {
        type: "email";
        /** PII */
        address?: string[];
        contactLists?: {
          /** @format uuid */
          _id: string;
          _ref: "ContactList";
        }[];
        getters?: {
          /** @maxLength 1024 */
          path: string;
        }[];
        assets?: {
          /** @format uuid */
          _id: string;
          _ref: "Asset";
        }[];
        assetGroups?: {
          /** @format uuid */
          _id: string;
          _ref: "AssetGroup";
        }[];
        config?: {
          /**
           * PII
           * @maxLength 1024
           */
          subjectOverride?: string;
          /**
           * PII
           * @maxLength 4096
           */
          headerOverride?: string;
        };
      }
    | {
        type: "sms";
        /** PII */
        numbers: string[];
        contactLists: {
          /** @format uuid */
          _id: string;
          _ref: "ContactList";
        }[];
      }
    | {
        type: "alarm";
        config: {
          severity: "red" | "orange" | "green";
          type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
          /**
           * PII
           * @maxLength 4096
           */
          procedure: string | null;
          /**
           * PII
           * @maxLength 1024
           */
          name: string;
        };
      }
    | {
        type: "observation";
      }
  )[];
  /** @default null */
  scheduleTrigger?: {
    interval: {
      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
      value: number;
    };
    cooldown?: {
      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
      value: number;
    };
    /** @format date-time */
    nextAt: string | null;
    /** @format date-time */
    lastAt: string | null;
    /** @format date-time */
    lastAttemptedAt: string | null;
  };
  /** @default null */
  eventTrigger?: {
    events: string[];
    executionDelay?: {
      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
      value: number;
    };
    schedule?: {
      entries: {
        daysOfWeek: number[];
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeStart: string;
        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
        timeEnd: string;
      }[];
    };
  } | null;
  enabled?: boolean;
  /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
  locale?: string;
  /** @maxLength 1024 */
  timezone?: string;
}

export interface RoleCreateDto {
  /** @maxLength 1024 */
  name: string;
  permissions: {
    subject:
      | "Alarm"
      | "AlarmCall"
      | "AlarmCallEvent"
      | "AlarmCallParticipant"
      | "AlarmEvent"
      | "AlarmHelper"
      | "AlarmPushSubscription"
      | "AlarmProfessionalResponder"
      | "Asset"
      | "AssetGroup"
      | "AssetPropertyVerification"
      | "AuditLog"
      | "Beacon"
      | "BillingAuditLog"
      | "BillingContract"
      | "BillingCustomer"
      | "BillingInvoice"
      | "ContactList"
      | "Customer"
      | "CustomerAlarmCenterRelation"
      | "CustomerUserRelation"
      | "Device"
      | "DeviceLogUpload"
      | "DomainLink"
      | "Observation"
      | "ObservationTrigger"
      | "Overlay"
      | "RegistrationTemplate"
      | "ReportTrigger"
      | "ReportTriggerRun"
      | "Role"
      | "StaticResponder"
      | "Webhook"
      | "User"
      | "Zone"
      | "Fingerprint"
      | "Visitor"
      | "VisitRecord"
      | "Report"
      | "DeviceLogUploadBatch"
      | "all";
    actions: string[];
    limit?: {
      connectedCustomers?: boolean;
      connectedCustomersViaRelation?: boolean;
      alarmsEscalatedToMyAlarmCenter?: boolean;
      alarmAgeLimitOfCustomer?: boolean;
      ownUserId?: boolean;
      notOwnUserId?: boolean;
      ownAssetId?: boolean;
      notOwnAssetId?: boolean;
      mode?: "default" | "asUser";
      fields?: string[];
      allowedRoles?: string[];
    };
  }[];
}

export interface RoleOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @maxLength 1024 */
  name: string;
  permissions: {
    subject:
      | "Alarm"
      | "AlarmCall"
      | "AlarmCallEvent"
      | "AlarmCallParticipant"
      | "AlarmEvent"
      | "AlarmHelper"
      | "AlarmPushSubscription"
      | "AlarmProfessionalResponder"
      | "Asset"
      | "AssetGroup"
      | "AssetPropertyVerification"
      | "AuditLog"
      | "Beacon"
      | "BillingAuditLog"
      | "BillingContract"
      | "BillingCustomer"
      | "BillingInvoice"
      | "ContactList"
      | "Customer"
      | "CustomerAlarmCenterRelation"
      | "CustomerUserRelation"
      | "Device"
      | "DeviceLogUpload"
      | "DomainLink"
      | "Observation"
      | "ObservationTrigger"
      | "Overlay"
      | "RegistrationTemplate"
      | "ReportTrigger"
      | "ReportTriggerRun"
      | "Role"
      | "StaticResponder"
      | "Webhook"
      | "User"
      | "Zone"
      | "Fingerprint"
      | "Visitor"
      | "VisitRecord"
      | "Report"
      | "DeviceLogUploadBatch"
      | "all";
    actions: string[];
    limit?: {
      connectedCustomers?: boolean;
      connectedCustomersViaRelation?: boolean;
      alarmsEscalatedToMyAlarmCenter?: boolean;
      alarmAgeLimitOfCustomer?: boolean;
      ownUserId?: boolean;
      notOwnUserId?: boolean;
      ownAssetId?: boolean;
      notOwnAssetId?: boolean;
      mode?: "default" | "asUser";
      fields?: string[];
      allowedRoles?: string[];
    };
  }[];
}

export interface RoleUpdateDto {
  permissions: {
    subject:
      | "Alarm"
      | "AlarmCall"
      | "AlarmCallEvent"
      | "AlarmCallParticipant"
      | "AlarmEvent"
      | "AlarmHelper"
      | "AlarmPushSubscription"
      | "AlarmProfessionalResponder"
      | "Asset"
      | "AssetGroup"
      | "AssetPropertyVerification"
      | "AuditLog"
      | "Beacon"
      | "BillingAuditLog"
      | "BillingContract"
      | "BillingCustomer"
      | "BillingInvoice"
      | "ContactList"
      | "Customer"
      | "CustomerAlarmCenterRelation"
      | "CustomerUserRelation"
      | "Device"
      | "DeviceLogUpload"
      | "DomainLink"
      | "Observation"
      | "ObservationTrigger"
      | "Overlay"
      | "RegistrationTemplate"
      | "ReportTrigger"
      | "ReportTriggerRun"
      | "Role"
      | "StaticResponder"
      | "Webhook"
      | "User"
      | "Zone"
      | "Fingerprint"
      | "Visitor"
      | "VisitRecord"
      | "Report"
      | "DeviceLogUploadBatch"
      | "all";
    actions: string[];
    limit?: {
      connectedCustomers?: boolean;
      connectedCustomersViaRelation?: boolean;
      alarmsEscalatedToMyAlarmCenter?: boolean;
      alarmAgeLimitOfCustomer?: boolean;
      ownUserId?: boolean;
      notOwnUserId?: boolean;
      ownAssetId?: boolean;
      notOwnAssetId?: boolean;
      mode?: "default" | "asUser";
      fields?: string[];
      allowedRoles?: string[];
    };
  }[];
}

export interface SecurityInventoryCategoryCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** @maxLength 1024 */
  name: string;
  /** @maxLength 1024 */
  icon: string;
  expiryInterval: {
    type: "day" | "week" | "month" | "year";
    value: number;
  };
  reminderPeriods: {
    type: "day" | "week" | "month" | "year";
    value: number;
  }[];
  notifiedPeople: {
    peopleToNotify: {
      /** @format uuid */
      _id: string;
      _ref: "Asset";
    }[];
    /** PII */
    emails: string[];
  };
  /** @maxLength 1024 */
  description?: string | null;
}

export interface SecurityInventoryCategoryOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** @maxLength 1024 */
  name: string;
  /** @maxLength 1024 */
  icon: string;
  expiryInterval: {
    type: "day" | "week" | "month" | "year";
    value: number;
  };
  reminderPeriods: {
    type: "day" | "week" | "month" | "year";
    value: number;
  }[];
  notifiedPeople: {
    peopleToNotify: {
      /** @format uuid */
      _id: string;
      _ref: "Asset";
    }[];
    /** PII */
    emails: string[];
  };
  /** @maxLength 1024 */
  description?: string | null;
}

export interface SecurityInventoryCategoryUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** @maxLength 1024 */
  name?: string;
  /** @maxLength 1024 */
  icon?: string;
  expiryInterval?: {
    type: "day" | "week" | "month" | "year";
    value: number;
  };
  reminderPeriods?: {
    type: "day" | "week" | "month" | "year";
    value: number;
  }[];
  notifiedPeople?: {
    peopleToNotify: {
      /** @format uuid */
      _id: string;
      _ref: "Asset";
    }[];
    /** PII */
    emails: string[];
  };
  /** @maxLength 1024 */
  description?: string | null;
}

export interface SecurityInventoryItemAddItemsDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  items: {
    /** @default {"type":"parents","extra":[]} */
    share?: {
      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
      extra?: {
        /** @format uuid */
        _id: string;
        _ref: "Customer";
      }[];
    };
    category: {
      /** @format uuid */
      _id: string;
      _ref: "SecurityInventoryCategory";
    };
    /** @maxLength 1024 */
    name: string;
    /**
     * @maxLength 1024
     * @default null
     */
    identifier?: string | null;
    /** PII */
    location: {
      type: "Point";
      /** PII */
      coordinates: number[];
      properties: {
        accuracy?: number;
        heading?: number;
        headingAccuracy?: number;
        speed?: number;
        speedAccuracy?: number;
        altitude?: number;
        altitudeAccuracy?: number;
        /** PII */
        address?: {
          /** @maxLength 1024 */
          countryCode?: string | null;
          /** @maxLength 1024 */
          state?: string | null;
          /** @maxLength 1024 */
          city?: string | null;
          /** @maxLength 1024 */
          streetName?: string | null;
          /** @maxLength 1024 */
          streetNumber?: string | null;
          floor?: number | null;
          /** @maxLength 1024 */
          formattedAddress?: string;
        };
        /** @format date-time */
        dateTime?: string;
        /** @maxLength 1024 */
        provider?: string;
      };
    };
    /** @format date-time */
    expiryDate: string;
  }[];
}

export interface SecurityInventoryItemCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  category: {
    /** @format uuid */
    _id: string;
    _ref: "SecurityInventoryCategory";
  };
  /** @maxLength 1024 */
  name: string;
  /**
   * @maxLength 1024
   * @default null
   */
  identifier?: string | null;
  /** PII */
  location: {
    type: "Point";
    /** PII */
    coordinates: number[];
    properties: {
      accuracy?: number;
      heading?: number;
      headingAccuracy?: number;
      speed?: number;
      speedAccuracy?: number;
      altitude?: number;
      altitudeAccuracy?: number;
      /** PII */
      address?: {
        /** @maxLength 1024 */
        countryCode?: string | null;
        /** @maxLength 1024 */
        state?: string | null;
        /** @maxLength 1024 */
        city?: string | null;
        /** @maxLength 1024 */
        streetName?: string | null;
        /** @maxLength 1024 */
        streetNumber?: string | null;
        floor?: number | null;
        /** @maxLength 1024 */
        formattedAddress?: string;
      };
      /** @format date-time */
      dateTime?: string;
      /** @maxLength 1024 */
      provider?: string;
    };
  };
  /** @format date-time */
  expiryDate: string;
}

export interface SecurityInventoryItemOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  category: {
    /** @format uuid */
    _id: string;
    _ref: "SecurityInventoryCategory";
  };
  /** @maxLength 1024 */
  name: string;
  /**
   * @maxLength 1024
   * @default null
   */
  identifier?: string | null;
  /** PII */
  location: {
    type: "Point";
    /** PII */
    coordinates: number[];
    properties: {
      accuracy?: number;
      heading?: number;
      headingAccuracy?: number;
      speed?: number;
      speedAccuracy?: number;
      altitude?: number;
      altitudeAccuracy?: number;
      /** PII */
      address?: {
        /** @maxLength 1024 */
        countryCode?: string | null;
        /** @maxLength 1024 */
        state?: string | null;
        /** @maxLength 1024 */
        city?: string | null;
        /** @maxLength 1024 */
        streetName?: string | null;
        /** @maxLength 1024 */
        streetNumber?: string | null;
        floor?: number | null;
        /** @maxLength 1024 */
        formattedAddress?: string;
      };
      /** @format date-time */
      dateTime?: string;
      /** @maxLength 1024 */
      provider?: string;
    };
  };
  /** @format date-time */
  lastInspectionDate: string;
  /** @format date-time */
  expiryDate: string;
  /**
   * @format date-time
   * @default null
   */
  plannedRenewalDate?: string | null;
}

export interface SecurityInventoryItemUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  category?: {
    /** @format uuid */
    _id: string;
    _ref: "SecurityInventoryCategory";
  };
  /** @maxLength 1024 */
  name?: string;
  /**
   * @maxLength 1024
   * @default null
   */
  identifier?: string | null;
  /** PII */
  location?: {
    type: "Point";
    /** PII */
    coordinates: number[];
    properties: {
      accuracy?: number;
      heading?: number;
      headingAccuracy?: number;
      speed?: number;
      speedAccuracy?: number;
      altitude?: number;
      altitudeAccuracy?: number;
      /** PII */
      address?: {
        /** @maxLength 1024 */
        countryCode?: string | null;
        /** @maxLength 1024 */
        state?: string | null;
        /** @maxLength 1024 */
        city?: string | null;
        /** @maxLength 1024 */
        streetName?: string | null;
        /** @maxLength 1024 */
        streetNumber?: string | null;
        floor?: number | null;
        /** @maxLength 1024 */
        formattedAddress?: string;
      };
      /** @format date-time */
      dateTime?: string;
      /** @maxLength 1024 */
      provider?: string;
    };
  };
  /** @format date-time */
  lastInspectionDate?: string;
  /** @format date-time */
  expiryDate?: string;
  /**
   * @format date-time
   * @default null
   */
  plannedRenewalDate?: string | null;
}

export interface SequrixCallbackRequestDto {
  SessionID: string;
  State: string;
  ObjectCode: string;
  /** @format date-time */
  Received?: string;
  /** @format date-time */
  Accepted?: string;
  /** @format date-time */
  Started?: string;
  /** @format date-time */
  OnLocation?: string;
  /** @format date-time */
  Ended?: string;
  SpentTime: string;
  Subcontractor?: string;
  Comment?: string;
  ContactActions: {
    Timestamp: string;
    Action: string;
  }[];
  Photos: {
    PhotoID: string;
    Timestamp: string;
  }[];
}

export interface SmsContactDto {
  to: string[];
  body: string;
}

export interface StaticResponderCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  /**
   * PII
   * @maxLength 1024
   */
  externalId: string | null;
  contact: {
    /**
     * PII
     * @pattern ^([\w+\-.]+@([\w-]+\.)+[\w-]{2,}[, ]*?)+?$
     */
    email: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    phone: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    sms: string | null;
    /** @maxLength 1024 */
    camera: string | null;
  };
  schedule: {
    entries: {
      daysOfWeek: number[];
      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
      timeStart: string;
      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
      timeEnd: string;
    }[];
  } | null;
  /** @maxLength 1024 */
  migrationKey?: string;
  integrations?: {
    sequrix: {
      enabled: boolean;
      /**
       * PII
       * @maxLength 1024
       */
      objectCode: string;
    };
  };
  /** PII */
  statistics?: {
    /**
     * @maxItems 10
     * @minItems 0
     */
    acceptSpeeds: {
      /** @format date-time */
      timestamp: string;
      /**
       * @min 0
       * @exclusiveMin false
       */
      speedMs: number;
    }[];
    /**
     * @maxItems 10
     * @minItems 0
     */
    onLocationSpeeds: {
      /** @format date-time */
      timestamp: string;
      /**
       * @min 0
       * @exclusiveMin false
       */
      speedMs: number;
    }[];
    /**
     * @maxItems 10
     * @minItems 0
     */
    finishSpeeds: {
      /** @format date-time */
      timestamp: string;
      /**
       * @min 0
       * @exclusiveMin false
       */
      speedMs: number;
    }[];
    /**
     * @min 0
     * @exclusiveMin false
     */
    amountRejected: number;
    /**
     * @min 0
     * @exclusiveMin false
     */
    amountAccepted: number;
  };
}

export interface StaticResponderOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  /**
   * PII
   * @maxLength 1024
   */
  externalId: string | null;
  contact: {
    /**
     * PII
     * @pattern ^([\w+\-.]+@([\w-]+\.)+[\w-]{2,}[, ]*?)+?$
     */
    email: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    phone: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    sms: string | null;
    /** @maxLength 1024 */
    camera: string | null;
  };
  schedule: {
    entries: {
      daysOfWeek: number[];
      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
      timeStart: string;
      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
      timeEnd: string;
    }[];
  } | null;
  /** @maxLength 1024 */
  migrationKey?: string;
  integrations?: {
    sequrix: {
      enabled: boolean;
      /**
       * PII
       * @maxLength 1024
       */
      objectCode: string;
    };
  };
  /** PII */
  statistics?: {
    /**
     * @maxItems 10
     * @minItems 0
     */
    acceptSpeeds: {
      /** @format date-time */
      timestamp: string;
      /**
       * @min 0
       * @exclusiveMin false
       */
      speedMs: number;
    }[];
    /**
     * @maxItems 10
     * @minItems 0
     */
    onLocationSpeeds: {
      /** @format date-time */
      timestamp: string;
      /**
       * @min 0
       * @exclusiveMin false
       */
      speedMs: number;
    }[];
    /**
     * @maxItems 10
     * @minItems 0
     */
    finishSpeeds: {
      /** @format date-time */
      timestamp: string;
      /**
       * @min 0
       * @exclusiveMin false
       */
      speedMs: number;
    }[];
    /**
     * @min 0
     * @exclusiveMin false
     */
    amountRejected: number;
    /**
     * @min 0
     * @exclusiveMin false
     */
    amountAccepted: number;
  };
}

export interface StaticResponderUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /**
   * PII
   * @maxLength 1024
   */
  name?: string;
  /**
   * PII
   * @maxLength 1024
   */
  externalId?: string | null;
  contact?: {
    /**
     * PII
     * @pattern ^([\w+\-.]+@([\w-]+\.)+[\w-]{2,}[, ]*?)+?$
     */
    email: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    phone: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    sms: string | null;
    /** @maxLength 1024 */
    camera: string | null;
  };
  schedule?: {
    entries: {
      daysOfWeek: number[];
      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
      timeStart: string;
      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
      timeEnd: string;
    }[];
  } | null;
  /** @maxLength 1024 */
  migrationKey?: string;
  integrations?: {
    sequrix: {
      enabled: boolean;
      /**
       * PII
       * @maxLength 1024
       */
      objectCode: string;
    };
  };
  /** PII */
  statistics?: {
    /**
     * @maxItems 10
     * @minItems 0
     */
    acceptSpeeds: {
      /** @format date-time */
      timestamp: string;
      /**
       * @min 0
       * @exclusiveMin false
       */
      speedMs: number;
    }[];
    /**
     * @maxItems 10
     * @minItems 0
     */
    onLocationSpeeds: {
      /** @format date-time */
      timestamp: string;
      /**
       * @min 0
       * @exclusiveMin false
       */
      speedMs: number;
    }[];
    /**
     * @maxItems 10
     * @minItems 0
     */
    finishSpeeds: {
      /** @format date-time */
      timestamp: string;
      /**
       * @min 0
       * @exclusiveMin false
       */
      speedMs: number;
    }[];
    /**
     * @min 0
     * @exclusiveMin false
     */
    amountRejected: number;
    /**
     * @min 0
     * @exclusiveMin false
     */
    amountAccepted: number;
  };
}

export interface SubmitFeedbackDto {
  project: "app";
  visitor?: string;
  comment: string;
  /** PII */
  deviceInfo?: {
    /** @maxLength 1024 */
    name: string;
    /** @maxLength 1024 */
    osName: string;
    /** @maxLength 1024 */
    osVersion: string;
    /** @maxLength 1024 */
    brand: string;
    /** @maxLength 1024 */
    model: string;
    /** @maxLength 1024 */
    appBundleId: string;
    /** @maxLength 1024 */
    appVersion: string;
  };
  client?: {
    url: string;
    screenWidth: number;
    screenHeight: number;
  };
  attachments?: {
    filename: string;
    mimetype: string;
    content: string;
  }[];
}

export interface SurveyQuestionCreateDto {
  /** @maxLength 1024 */
  question: string;
  type: "multipleChoice" | "followUp" | "openEnded" | "likertScale";
  options?: {
    value: number;
    /** @maxLength 1024 */
    label: string;
    variant: "primary" | "danger" | "success";
  }[];
}

export interface SurveyQuestionOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @maxLength 1024 */
  question: string;
  type: "multipleChoice" | "followUp" | "openEnded" | "likertScale";
  options?: {
    value: number;
    /** @maxLength 1024 */
    label: string;
    variant: "primary" | "danger" | "success";
  }[];
}

export interface SurveyQuestionUpdateDto {
  /** @maxLength 1024 */
  question?: string;
  type?: "multipleChoice" | "followUp" | "openEnded" | "likertScale";
  options?: {
    value: number;
    /** @maxLength 1024 */
    label: string;
    variant: "primary" | "danger" | "success";
  }[];
}

export interface SurveyResponseAnswerUpdateDto {
  answers: (
    | {
        type: "multipleChoice";
        /** PII */
        answer: {
          value: number;
          /** @maxLength 1024 */
          label: string;
        };
        question: {
          /** @format uuid */
          _id: string;
          _ref: "SurveyQuestion";
        };
      }
    | {
        type: "likertScale";
        answer: {
          value: number;
          /** @maxLength 1024 */
          label: string;
        };
        question: {
          /** @format uuid */
          _id: string;
          _ref: "SurveyQuestion";
        };
      }
    | {
        type: "followUp";
        answer: {
          value: number;
          /** @maxLength 1024 */
          label: string;
        }[];
        question: {
          /** @format uuid */
          _id: string;
          _ref: "SurveyQuestion";
        };
      }
    | {
        type: "openEnded";
        /**
         * PII
         * @maxLength 1024
         */
        answer: string;
        question: {
          /** @format uuid */
          _id: string;
          _ref: "SurveyQuestion";
        };
      }
  )[];
  isCompleted?: boolean;
}

export interface SurveyResponseCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  alarm: {
    /** @format uuid */
    _id: string;
    _ref: "Alarm";
  };
  answers?: (
    | {
        type: "multipleChoice";
        /** PII */
        answer: {
          value: number;
          /** @maxLength 1024 */
          label: string;
        };
        question: {
          /** @format uuid */
          _id: string;
          _ref: "SurveyQuestion";
        };
      }
    | {
        type: "likertScale";
        answer: {
          value: number;
          /** @maxLength 1024 */
          label: string;
        };
        question: {
          /** @format uuid */
          _id: string;
          _ref: "SurveyQuestion";
        };
      }
    | {
        type: "followUp";
        answer: {
          value: number;
          /** @maxLength 1024 */
          label: string;
        }[];
        question: {
          /** @format uuid */
          _id: string;
          _ref: "SurveyQuestion";
        };
      }
    | {
        type: "openEnded";
        /**
         * PII
         * @maxLength 1024
         */
        answer: string;
        question: {
          /** @format uuid */
          _id: string;
          _ref: "SurveyQuestion";
        };
      }
  )[];
  /** @maxLength 1024 */
  token: string;
  questions: {
    /** @format uuid */
    _id: string;
    _ref: "SurveyType";
  };
  /** @format date-time */
  completedAt?: string;
  responder: {
    /** @format uuid */
    _id: string;
    _ref: "User" | "AlarmHelper" | "StaticResponder" | "AlarmProfessionalResponder" | "Asset";
  };
}

export interface SurveyResponseOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  alarm: {
    /** @format uuid */
    _id: string;
    _ref: "Alarm";
  };
  answers?: (
    | {
        type: "multipleChoice";
        /** PII */
        answer: {
          value: number;
          /** @maxLength 1024 */
          label: string;
        };
        question: {
          /** @format uuid */
          _id: string;
          _ref: "SurveyQuestion";
        };
      }
    | {
        type: "likertScale";
        answer: {
          value: number;
          /** @maxLength 1024 */
          label: string;
        };
        question: {
          /** @format uuid */
          _id: string;
          _ref: "SurveyQuestion";
        };
      }
    | {
        type: "followUp";
        answer: {
          value: number;
          /** @maxLength 1024 */
          label: string;
        }[];
        question: {
          /** @format uuid */
          _id: string;
          _ref: "SurveyQuestion";
        };
      }
    | {
        type: "openEnded";
        /**
         * PII
         * @maxLength 1024
         */
        answer: string;
        question: {
          /** @format uuid */
          _id: string;
          _ref: "SurveyQuestion";
        };
      }
  )[];
  /** @maxLength 1024 */
  token: string;
  questions: {
    /** @format uuid */
    _id: string;
    _ref: "SurveyType";
  };
  /** @format date-time */
  completedAt?: string;
  responder: {
    /** @format uuid */
    _id: string;
    _ref: "User" | "AlarmHelper" | "StaticResponder" | "AlarmProfessionalResponder" | "Asset";
  };
}

export interface SurveyResponseUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  alarm?: {
    /** @format uuid */
    _id: string;
    _ref: "Alarm";
  };
  answers?: (
    | {
        type: "multipleChoice";
        /** PII */
        answer: {
          value: number;
          /** @maxLength 1024 */
          label: string;
        };
        question: {
          /** @format uuid */
          _id: string;
          _ref: "SurveyQuestion";
        };
      }
    | {
        type: "likertScale";
        answer: {
          value: number;
          /** @maxLength 1024 */
          label: string;
        };
        question: {
          /** @format uuid */
          _id: string;
          _ref: "SurveyQuestion";
        };
      }
    | {
        type: "followUp";
        answer: {
          value: number;
          /** @maxLength 1024 */
          label: string;
        }[];
        question: {
          /** @format uuid */
          _id: string;
          _ref: "SurveyQuestion";
        };
      }
    | {
        type: "openEnded";
        /**
         * PII
         * @maxLength 1024
         */
        answer: string;
        question: {
          /** @format uuid */
          _id: string;
          _ref: "SurveyQuestion";
        };
      }
  )[];
  /** @maxLength 1024 */
  token?: string;
  questions?: {
    /** @format uuid */
    _id: string;
    _ref: "SurveyType";
  };
  /** @format date-time */
  completedAt?: string;
  responder?: {
    /** @format uuid */
    _id: string;
    _ref: "User" | "AlarmHelper" | "StaticResponder" | "AlarmProfessionalResponder" | "Asset";
  };
}

export interface SurveyTypeCreateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  questions: {
    /** @format uuid */
    _id: string;
    _ref: "SurveyQuestion";
  }[];
  userType: "alarmCreator" | "alarmResponder" | "alarmCenter" | "AlarmProfessionalResponder";
}

export interface SurveyTypeOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  questions: {
    /** @format uuid */
    _id: string;
    _ref: "SurveyQuestion";
  }[];
  userType: "alarmCreator" | "alarmResponder" | "alarmCenter" | "AlarmProfessionalResponder";
}

export interface SurveyTypeUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  questions?: {
    /** @format uuid */
    _id: string;
    _ref: "SurveyQuestion";
  }[];
  userType?: "alarmCreator" | "alarmResponder" | "alarmCenter" | "AlarmProfessionalResponder";
}

export interface TriggerProcessingDto {
  secret: string;
  /** Max minutes passed since non alarm reports should have been ran */
  nonAlarmTimeframe: number;
  /** Max minutes passed since alarm reports should have been ran */
  alarmTimeframe: number;
}

export interface TwoFactorAuthStatusResponseDto {
  twoFactorMethods: {
    id: string;
    method: string;
  }[];
}

export interface TwoFactorGetSharedSecretResponseDto {
  secretBase32Encoded: string;
}

export interface UserCreateDto {
  /**
   * PII
   * @maxLength 1024
   */
  username: string;
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  properties: {
    /**
     * PII
     * @maxLength 1024
     */
    phoneNumber?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    smsNumber?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    email?: string | null;
    /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
    locale?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    image?: string | null;
    /** PII */
    rSim?: {
      /**
       * PII
       * @maxLength 1024
       */
      euicc: string;
      primary: {
        /**
         * PII
         * @maxLength 1024
         */
        msisdn: string;
        /**
         * PII
         * @maxLength 1024
         */
        iccid: string;
      };
      secondary: {
        /**
         * PII
         * @maxLength 1024
         */
        msisdn: string;
        /**
         * PII
         * @maxLength 1024
         */
        iccid: string;
      };
      enabled: boolean;
    } | null;
  };
  /** @default [] */
  globalRoles?: string[];
  /** @default [] */
  specialPermissions?: string[];
  isServiceAccount?: boolean;
  type?: "default" | "serviceAccount" | "kiosk";
  userPolicies?: {
    disablePasswordlessLogin?: boolean;
  };
}

export interface UserCreateWithRelationDto {
  user: {
    /**
     * PII
     * @maxLength 1024
     */
    username: string;
    /**
     * PII
     * @maxLength 1024
     */
    name: string;
    properties: {
      /**
       * PII
       * @maxLength 1024
       */
      phoneNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      smsNumber?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      email?: string | null;
      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
      locale?: string | null;
      /**
       * PII
       * @maxLength 1024
       */
      image?: string | null;
      /** PII */
      rSim?: {
        /**
         * PII
         * @maxLength 1024
         */
        euicc: string;
        primary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        secondary: {
          /**
           * PII
           * @maxLength 1024
           */
          msisdn: string;
          /**
           * PII
           * @maxLength 1024
           */
          iccid: string;
        };
        enabled: boolean;
      } | null;
    };
    /** @default [] */
    globalRoles?: string[];
    /** @default [] */
    specialPermissions?: string[];
    isServiceAccount?: boolean;
    type?: "default" | "serviceAccount" | "kiosk";
    userPolicies?: {
      disablePasswordlessLogin?: boolean;
    };
  };
  relation: {
    customer: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    };
    roles: string[];
    assetGroupRestrictions: {
      /** @format uuid */
      _id: string;
      _ref: "AssetGroup";
    }[];
  };
}

export interface UserOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /**
   * PII
   * @maxLength 1024
   */
  username: string;
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  properties: {
    /**
     * PII
     * @maxLength 1024
     */
    phoneNumber?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    smsNumber?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    email?: string | null;
    /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
    locale?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    image?: string | null;
    /** PII */
    rSim?: {
      /**
       * PII
       * @maxLength 1024
       */
      euicc: string;
      primary: {
        /**
         * PII
         * @maxLength 1024
         */
        msisdn: string;
        /**
         * PII
         * @maxLength 1024
         */
        iccid: string;
      };
      secondary: {
        /**
         * PII
         * @maxLength 1024
         */
        msisdn: string;
        /**
         * PII
         * @maxLength 1024
         */
        iccid: string;
      };
      enabled: boolean;
    } | null;
  };
  /** @default [] */
  globalRoles?: string[];
  /** @default [] */
  specialPermissions?: string[];
  isServiceAccount?: boolean;
  /**
   * PII
   * @format date-time
   */
  lastActiveAt?: string;
  type?: "default" | "serviceAccount" | "kiosk";
  userPolicies?: {
    disablePasswordlessLogin?: boolean;
  };
}

export interface UserUpdateDto {
  /**
   * PII
   * @maxLength 1024
   */
  username?: string;
  /**
   * PII
   * @maxLength 1024
   */
  name?: string;
  properties?: {
    /**
     * PII
     * @maxLength 1024
     */
    phoneNumber?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    smsNumber?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    email?: string | null;
    /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
    locale?: string | null;
    /**
     * PII
     * @maxLength 1024
     */
    image?: string | null;
    /** PII */
    rSim?: {
      /**
       * PII
       * @maxLength 1024
       */
      euicc: string;
      primary: {
        /**
         * PII
         * @maxLength 1024
         */
        msisdn: string;
        /**
         * PII
         * @maxLength 1024
         */
        iccid: string;
      };
      secondary: {
        /**
         * PII
         * @maxLength 1024
         */
        msisdn: string;
        /**
         * PII
         * @maxLength 1024
         */
        iccid: string;
      };
      enabled: boolean;
    } | null;
  };
  /** @default [] */
  globalRoles?: string[];
  /** @default [] */
  specialPermissions?: string[];
  isServiceAccount?: boolean;
  /**
   * PII
   * @format date-time
   */
  lastActiveAt?: string;
  type?: "default" | "serviceAccount" | "kiosk";
  userPolicies?: {
    disablePasswordlessLogin?: boolean;
  };
}

export interface ValidateEmailDomainDto {
  code: string;
  /** @format email */
  email: string;
}

export interface ValidateSpecialPermissionRequestDto {
  specialPermission: string;
}

export interface VerifiedAssetPropertyUpdateDto {
  /** @maxLength 1024 */
  phoneNumber?: string;
  /** @maxLength 1024 */
  smsNumber?: string;
  /** @maxLength 1024 */
  email?: string;
  appUniqueId: string;
}

export interface VisitorCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /**
   * PII
   * @maxLength 1024
   */
  firstName: string;
  /**
   * PII
   * @maxLength 1024
   */
  lastName: string;
  /**
   * PII
   * @format email
   * @maxLength 1024
   */
  email: string;
  /**
   * PII
   * @maxLength 1024
   */
  visitorCompany?: string;
  /** @format date-time */
  accessValidUntil?: string;
}

export interface VisitorOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /**
   * PII
   * @maxLength 1024
   */
  firstName: string;
  /**
   * PII
   * @maxLength 1024
   */
  lastName: string;
  /**
   * PII
   * @format email
   * @maxLength 1024
   */
  email: string;
  /**
   * PII
   * @maxLength 1024
   */
  visitorCompany?: string;
  /** @format date-time */
  accessValidUntil?: string;
}

export interface VisitorUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /**
   * PII
   * @maxLength 1024
   */
  firstName?: string;
  /**
   * PII
   * @maxLength 1024
   */
  lastName?: string;
  /**
   * PII
   * @format email
   * @maxLength 1024
   */
  email?: string;
  /**
   * PII
   * @maxLength 1024
   */
  visitorCompany?: string;
  /** @format date-time */
  accessValidUntil?: string;
}

export interface VisitRecordCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** @maxLength 1024 */
  description?: string;
  /** @format date-time */
  scheduledStartAt?: string;
  /** @format date-time */
  scheduledEndAt?: string;
  /** PII */
  kioskZone: {
    /** @format uuid */
    _id: string;
    _ref: "Zone";
  };
  /** PII */
  host: {
    /**
     * PII
     * @maxLength 1024
     */
    name: string;
    /**
     * PII
     * @format email
     * @maxLength 1024
     */
    email?: string;
  };
  attendees: {
    /** PII */
    personalInformation: {
      /** @format uuid */
      _id: string;
      _ref: "Visitor";
    };
    checkInRecord?: {
      /** @format date-time */
      timestamp: string;
      /** PII */
      kiosk: {
        /** @format uuid */
        _id: string;
        _ref: "Asset";
      };
    };
    checkOutRecord?: {
      /** @format date-time */
      timestamp: string;
      /** PII */
      kiosk: {
        /** @format uuid */
        _id: string;
        _ref: "Asset";
      };
    };
  }[];
  visitRecordType: "SCHEDULED" | "SPONTANEOUS" | "RECURRING";
}

export interface VisitRecordOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** @maxLength 1024 */
  description?: string;
  /** @format date-time */
  scheduledStartAt?: string;
  /** @format date-time */
  scheduledEndAt?: string;
  /** PII */
  kioskZone: {
    /** @format uuid */
    _id: string;
    _ref: "Zone";
  };
  /** PII */
  host: {
    /**
     * PII
     * @maxLength 1024
     */
    name: string;
    /**
     * PII
     * @format email
     * @maxLength 1024
     */
    email?: string;
  };
  attendees: {
    /** PII */
    personalInformation: {
      /** @format uuid */
      _id: string;
      _ref: "Visitor";
    };
    checkInRecord?: {
      /** @format date-time */
      timestamp: string;
      /** PII */
      kiosk: {
        /** @format uuid */
        _id: string;
        _ref: "Asset";
      };
    };
    checkOutRecord?: {
      /** @format date-time */
      timestamp: string;
      /** PII */
      kiosk: {
        /** @format uuid */
        _id: string;
        _ref: "Asset";
      };
    };
  }[];
  visitRecordType: "SCHEDULED" | "SPONTANEOUS" | "RECURRING";
}

export interface VisitRecordUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  /** @maxLength 1024 */
  description?: string;
  /** @format date-time */
  scheduledStartAt?: string;
  /** @format date-time */
  scheduledEndAt?: string;
  /** PII */
  kioskZone?: {
    /** @format uuid */
    _id: string;
    _ref: "Zone";
  };
  /** PII */
  host?: {
    /**
     * PII
     * @maxLength 1024
     */
    name: string;
    /**
     * PII
     * @format email
     * @maxLength 1024
     */
    email?: string;
  };
  attendees?: {
    /** PII */
    personalInformation: {
      /** @format uuid */
      _id: string;
      _ref: "Visitor";
    };
    checkInRecord?: {
      /** @format date-time */
      timestamp: string;
      /** PII */
      kiosk: {
        /** @format uuid */
        _id: string;
        _ref: "Asset";
      };
    };
    checkOutRecord?: {
      /** @format date-time */
      timestamp: string;
      /** PII */
      kiosk: {
        /** @format uuid */
        _id: string;
        _ref: "Asset";
      };
    };
  }[];
  visitRecordType?: "SCHEDULED" | "SPONTANEOUS" | "RECURRING";
}

export interface WebhookCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  } | null;
  /** @maxLength 1024 */
  migrationKey?: string | null;
  webhookQuery: {
    operation: "create" | "update" | "remove";
    entityTypes: string[];
    filter: Record<string, any>;
  };
  /** @default {} */
  deliveryStats?: {
    /**
     * @format date-time
     * @default null
     */
    lastDeliveryDate?: string | null;
    /** @default 0 */
    numDeliverySucceeded?: number;
    /** @default 0 */
    numDeliveryFailed?: number;
  };
  deliveryConfig: {
    /** @format uri */
    url: string;
    method: "POST" | "GET" | "PUT" | "PATCH" | "DELETE";
    /** @default null */
    headers?: Record<string, any>;
  };
  /**
   * @maxLength 1024
   * @default null
   */
  transformer?: string | null;
  /** @default true */
  enableWebhook?: boolean;
}

export interface WebhookDeliveryUpdateDto {
  succeeded: boolean;
}

export interface WebhookOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  } | null;
  /** @maxLength 1024 */
  migrationKey?: string | null;
  webhookQuery: {
    operation: "create" | "update" | "remove";
    entityTypes: string[];
    filter: Record<string, any>;
  };
  /** @default {} */
  deliveryStats?: {
    /**
     * @format date-time
     * @default null
     */
    lastDeliveryDate?: string | null;
    /** @default 0 */
    numDeliverySucceeded?: number;
    /** @default 0 */
    numDeliveryFailed?: number;
  };
  deliveryConfig: {
    /** @format uri */
    url: string;
    method: "POST" | "GET" | "PUT" | "PATCH" | "DELETE";
    /** @default null */
    headers?: Record<string, any>;
  };
  /**
   * @maxLength 1024
   * @default null
   */
  transformer?: string | null;
  /** @default true */
  enableWebhook?: boolean;
}

export interface WebhookUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  } | null;
  /** @maxLength 1024 */
  migrationKey?: string | null;
  webhookQuery?: {
    operation: "create" | "update" | "remove";
    entityTypes: string[];
    filter: Record<string, any>;
  };
  /** @default {} */
  deliveryStats?: {
    /**
     * @format date-time
     * @default null
     */
    lastDeliveryDate?: string | null;
    /** @default 0 */
    numDeliverySucceeded?: number;
    /** @default 0 */
    numDeliveryFailed?: number;
  };
  deliveryConfig?: {
    /** @format uri */
    url: string;
    method: "POST" | "GET" | "PUT" | "PATCH" | "DELETE";
    /** @default null */
    headers?: Record<string, any>;
  };
  /**
   * @maxLength 1024
   * @default null
   */
  transformer?: string | null;
  /** @default true */
  enableWebhook?: boolean;
}

export interface ZoneCreateDto {
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  type:
    | "default"
    | "responseArea"
    | "policeDepartment"
    | "assetMonitoredArea"
    | "fingerprinted"
    | "building"
    | "evacuationPoint";
  /** PII */
  location:
    | {
        type: "Polygon";
        /** PII */
        coordinates: number[][][];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      }
    | {
        type: "MultiPolygon";
        coordinates: number[][][][];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      };
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  /**
   * PII
   * @maxLength 1024
   * @default null
   */
  description?: string | null;
  /** @default [] */
  staticResponders?: {
    staticResponder: {
      /** @format uuid */
      _id: string;
      _ref: "StaticResponder";
    };
    priority: number;
  }[];
  /** @default null */
  responsePriority?: number | null;
  syncToAms?: boolean;
}

export interface ZoneOutputDto {
  /** @format uuid */
  _id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  customer: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  type:
    | "default"
    | "responseArea"
    | "policeDepartment"
    | "assetMonitoredArea"
    | "fingerprinted"
    | "building"
    | "evacuationPoint";
  /** PII */
  location:
    | {
        type: "Polygon";
        /** PII */
        coordinates: number[][][];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      }
    | {
        type: "MultiPolygon";
        coordinates: number[][][][];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      };
  /**
   * PII
   * @maxLength 1024
   */
  name: string;
  /**
   * PII
   * @maxLength 1024
   * @default null
   */
  description?: string | null;
  /** @default [] */
  staticResponders?: {
    staticResponder: {
      /** @format uuid */
      _id: string;
      _ref: "StaticResponder";
    };
    priority: number;
  }[];
  /** @default null */
  responsePriority?: number | null;
  assetsInside: {
    /** @format uuid */
    _id: string;
    _ref: "Asset";
  }[];
  syncToAms?: boolean;
}

export interface ZoneUpdateDto {
  customer?: {
    /** @format uuid */
    _id: string;
    _ref: "Customer";
  };
  /** @default {"type":"parents","extra":[]} */
  share?: {
    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
    extra?: {
      /** @format uuid */
      _id: string;
      _ref: "Customer";
    }[];
  };
  type?:
    | "default"
    | "responseArea"
    | "policeDepartment"
    | "assetMonitoredArea"
    | "fingerprinted"
    | "building"
    | "evacuationPoint";
  /** PII */
  location?:
    | {
        type: "Polygon";
        /** PII */
        coordinates: number[][][];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      }
    | {
        type: "MultiPolygon";
        coordinates: number[][][][];
        properties: {
          accuracy?: number;
          heading?: number;
          headingAccuracy?: number;
          speed?: number;
          speedAccuracy?: number;
          altitude?: number;
          altitudeAccuracy?: number;
          /** PII */
          address?: {
            /** @maxLength 1024 */
            countryCode?: string | null;
            /** @maxLength 1024 */
            state?: string | null;
            /** @maxLength 1024 */
            city?: string | null;
            /** @maxLength 1024 */
            streetName?: string | null;
            /** @maxLength 1024 */
            streetNumber?: string | null;
            floor?: number | null;
            /** @maxLength 1024 */
            formattedAddress?: string;
          };
          /** @format date-time */
          dateTime?: string;
          /** @maxLength 1024 */
          provider?: string;
        };
      };
  /**
   * PII
   * @maxLength 1024
   */
  name?: string;
  /**
   * PII
   * @maxLength 1024
   * @default null
   */
  description?: string | null;
  /** @default [] */
  staticResponders?: {
    staticResponder: {
      /** @format uuid */
      _id: string;
      _ref: "StaticResponder";
    };
    priority: number;
  }[];
  /** @default null */
  responsePriority?: number | null;
  syncToAms?: boolean;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "https://api.x-guard.dev" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title @x-guard/xgac-node-main-api
 * @version 1.31.3
 * @baseUrl https://api.x-guard.dev
 * @contact
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name AppControllerInfo
   * @request GET:/
   */
  appControllerInfo = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/`,
      method: "GET",
      ...params,
    });

  alarmCallEvents = {
    /**
     * @description Paginates AlarmCallEvent
     *
     * @tags AlarmCallEvent
     * @name AlarmCallEventsControllerPaginate
     * @request GET:/alarm-call-events
     * @secure
     */
    alarmCallEventsControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            alarmCall: {
              /** @format uuid */
              _id: string;
              _ref: "AlarmCall";
            };
            /** @maxLength 1024 */
            participant: string;
            asset?: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            };
            user?: {
              /** @format uuid */
              _id: string;
              _ref: "User";
            };
            content:
              | {
                  type: "chat";
                  state:
                    | {
                        phase: "started";
                        /** @format date-time */
                        startedAt: string;
                        canceledAt: any;
                        publishedAt: any;
                        text: any;
                      }
                    | {
                        phase: "canceled";
                        /** @format date-time */
                        startedAt: string;
                        /** @format date-time */
                        canceledAt: string;
                        publishedAt: any;
                        text: any;
                      }
                    | {
                        phase: "published";
                        /** @format date-time */
                        startedAt: string;
                        canceledAt: any;
                        /** @format date-time */
                        publishedAt: string;
                        /** @maxLength 1024 */
                        text: string;
                      };
                  /** @format date-time */
                  lastHeartbeatAt: string;
                  /** @format uuid */
                  idempotencyKey: string;
                }
              | {
                  type: "audio";
                  state:
                    | {
                        phase: "started";
                        /** @format date-time */
                        startedAt: string;
                        canceledAt: any;
                        processingAt: any;
                        publishedAt: any;
                        deletedAt: any;
                        metadata: any;
                        src: any;
                      }
                    | {
                        phase: "canceled";
                        /** @format date-time */
                        startedAt: string;
                        /** @format date-time */
                        canceledAt: string;
                        processingAt: any;
                        publishedAt: any;
                        deletedAt: any;
                        metadata: any;
                        src: any;
                      }
                    | {
                        phase: "processing";
                        /** @format date-time */
                        startedAt: string;
                        canceledAt: any;
                        /** @format date-time */
                        processingAt: string;
                        publishedAt: any;
                        deletedAt: any;
                        metadata: {
                          lengthBytes: number;
                          durationMs: number;
                          waveform: number[];
                          /** @maxLength 4096 */
                          transcript: string | null;
                        };
                        src: any;
                      }
                    | {
                        phase: "published";
                        /** @format date-time */
                        startedAt: string;
                        canceledAt: any;
                        /** @format date-time */
                        processingAt: string;
                        /** @format date-time */
                        publishedAt: string;
                        deletedAt: any;
                        metadata: {
                          lengthBytes: number;
                          durationMs: number;
                          waveform: number[];
                          /** @maxLength 4096 */
                          transcript: string | null;
                        };
                        /** @maxLength 1024 */
                        src: string;
                      }
                    | {
                        phase: "deleted";
                        /** @format date-time */
                        startedAt: string;
                        canceledAt: any;
                        /** @format date-time */
                        processingAt: string;
                        /** @format date-time */
                        publishedAt: string;
                        /** @format date-time */
                        deletedAt: string;
                        metadata: any;
                        src: any;
                      };
                  /** @format date-time */
                  lastHeartbeatAt: string;
                  /** @format uuid */
                  idempotencyKey: string;
                }
              | {
                  type: "event.positionUpdate";
                };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/alarm-call-events`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  alarmCallParticipants = {
    /**
     * @description Paginates AlarmCallParticipant
     *
     * @tags AlarmCallParticipant
     * @name AlarmCallParticipantsControllerPaginate
     * @request GET:/alarm-call-participants
     * @secure
     */
    alarmCallParticipantsControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            alarmCall: {
              /** @format uuid */
              _id: string;
              _ref: "AlarmCall";
            };
            ref:
              | {
                  /** @format uuid */
                  _id: string;
                  _ref: "User";
                }
              | {
                  /** @format uuid */
                  _id: string;
                  _ref: "Asset";
                }
              | null;
            /** @maxLength 1024 */
            name: string;
            state: {
              /** @maxLength 1024 */
              sid: string;
              muted: boolean;
              speaking: boolean;
              /** @format date-time */
              connectedAt: string | null;
              /** @format date-time */
              disconnectedAt: string | null;
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/alarm-call-participants`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a AlarmCallParticipant by id
     *
     * @tags AlarmCallParticipant
     * @name AlarmCallParticipantsControllerFindById
     * @request GET:/alarm-call-participants/{id}
     * @secure
     */
    alarmCallParticipantsControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AlarmCallParticipantOutputDto, any>({
        path: `/alarm-call-participants/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Searches AlarmCallParticipant
     *
     * @tags AlarmCallParticipant
     * @name AlarmCallParticipantsControllerSearch
     * @request GET:/alarm-call-participants/search
     * @secure
     */
    alarmCallParticipantsControllerSearch: (
      query: {
        /** The search query string */
        q: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            alarmCall: {
              /** @format uuid */
              _id: string;
              _ref: "AlarmCall";
            };
            ref:
              | {
                  /** @format uuid */
                  _id: string;
                  _ref: "User";
                }
              | {
                  /** @format uuid */
                  _id: string;
                  _ref: "Asset";
                }
              | null;
            /** @maxLength 1024 */
            name: string;
            state: {
              /** @maxLength 1024 */
              sid: string;
              muted: boolean;
              speaking: boolean;
              /** @format date-time */
              connectedAt: string | null;
              /** @format date-time */
              disconnectedAt: string | null;
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/alarm-call-participants/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  alarmCalls = {
    /**
     * @description Paginates AlarmCall
     *
     * @tags AlarmCall
     * @name AlarmCallsControllerPaginate
     * @request GET:/alarm-calls
     * @secure
     */
    alarmCallsControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            alarm: {
              /** @format uuid */
              _id: string;
              _ref: "Alarm";
            } | null;
            asset: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            } | null;
            type: "alarmCall" | "helperCall";
            /** @maxLength 1024 */
            callSid: string;
            /** @maxLength 1024 */
            conferenceSid: string | null;
            /** @format date-time */
            endedAt: string | null;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/alarm-calls`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AlarmCall
     * @name AlarmCallsControllerCancelAlarmCallAudioEvent
     * @request POST:/alarm-calls/{alarmId}/alarm-call-events/audio/cancel
     * @secure
     */
    alarmCallsControllerCancelAlarmCallAudioEvent: (
      alarmId: string,
      data: AlarmCallEventAudioCancelDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AlarmCallEventOutputDto, any>({
        path: `/alarm-calls/${alarmId}/alarm-call-events/audio/cancel`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AlarmCall
     * @name AlarmCallsControllerHeartbeatAlarmCallAudioEvent
     * @request POST:/alarm-calls/{alarmId}/alarm-call-events/audio/heartbeat
     * @secure
     */
    alarmCallsControllerHeartbeatAlarmCallAudioEvent: (
      alarmId: string,
      data: AlarmCallEventAudioHeartbeatDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AlarmCallEventOutputDto, any>({
        path: `/alarm-calls/${alarmId}/alarm-call-events/audio/heartbeat`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AlarmCall
     * @name AlarmCallsControllerPublishAlarmCallAudioEvent
     * @request POST:/alarm-calls/{alarmId}/alarm-call-events/audio/publish
     * @secure
     */
    alarmCallsControllerPublishAlarmCallAudioEvent: (
      alarmId: string,
      data: {
        /** @format uuid */
        participant: string;
        /** @format uuid */
        idempotencyKey: string;
        /**
         * audio/wav, audio/x-wav, audio/vnd.wave
         * @format binary
         */
        sound: File;
      },
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AlarmCallEventOutputDto, any>({
        path: `/alarm-calls/${alarmId}/alarm-call-events/audio/publish`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AlarmCall
     * @name AlarmCallsControllerHeartbeatAlarmCallChatEvent
     * @request POST:/alarm-calls/{alarmId}/alarm-call-events/chat/heartbeat
     * @secure
     */
    alarmCallsControllerHeartbeatAlarmCallChatEvent: (
      alarmId: string,
      data: AlarmCallEventChatHeartbeatDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AlarmCallEventOutputDto, any>({
        path: `/alarm-calls/${alarmId}/alarm-call-events/chat/heartbeat`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AlarmCall
     * @name AlarmCallsControllerPublishAlarmCallChatEvent
     * @request POST:/alarm-calls/{alarmId}/alarm-call-events/chat/publish
     * @secure
     */
    alarmCallsControllerPublishAlarmCallChatEvent: (
      alarmId: string,
      data: AlarmCallEventChatPublishDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AlarmCallEventOutputDto, any>({
        path: `/alarm-calls/${alarmId}/alarm-call-events/chat/publish`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a AlarmCall by id
     *
     * @tags AlarmCall
     * @name AlarmCallsControllerFindById
     * @request GET:/alarm-calls/{id}
     * @secure
     */
    alarmCallsControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AlarmCallOutputDto, any>({
        path: `/alarm-calls/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates AlarmCallEvent
     *
     * @tags AlarmCall
     * @name AlarmCallsControllerPaginateEvents
     * @request GET:/alarm-calls/{id}/alarm-call-events
     * @secure
     */
    alarmCallsControllerPaginateEvents: (
      id: string,
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            alarmCall: {
              /** @format uuid */
              _id: string;
              _ref: "AlarmCall";
            };
            /** @maxLength 1024 */
            participant: string;
            asset?: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            };
            user?: {
              /** @format uuid */
              _id: string;
              _ref: "User";
            };
            content:
              | {
                  type: "chat";
                  state:
                    | {
                        phase: "started";
                        /** @format date-time */
                        startedAt: string;
                        canceledAt: any;
                        publishedAt: any;
                        text: any;
                      }
                    | {
                        phase: "canceled";
                        /** @format date-time */
                        startedAt: string;
                        /** @format date-time */
                        canceledAt: string;
                        publishedAt: any;
                        text: any;
                      }
                    | {
                        phase: "published";
                        /** @format date-time */
                        startedAt: string;
                        canceledAt: any;
                        /** @format date-time */
                        publishedAt: string;
                        /** @maxLength 1024 */
                        text: string;
                      };
                  /** @format date-time */
                  lastHeartbeatAt: string;
                  /** @format uuid */
                  idempotencyKey: string;
                }
              | {
                  type: "audio";
                  state:
                    | {
                        phase: "started";
                        /** @format date-time */
                        startedAt: string;
                        canceledAt: any;
                        processingAt: any;
                        publishedAt: any;
                        deletedAt: any;
                        metadata: any;
                        src: any;
                      }
                    | {
                        phase: "canceled";
                        /** @format date-time */
                        startedAt: string;
                        /** @format date-time */
                        canceledAt: string;
                        processingAt: any;
                        publishedAt: any;
                        deletedAt: any;
                        metadata: any;
                        src: any;
                      }
                    | {
                        phase: "processing";
                        /** @format date-time */
                        startedAt: string;
                        canceledAt: any;
                        /** @format date-time */
                        processingAt: string;
                        publishedAt: any;
                        deletedAt: any;
                        metadata: {
                          lengthBytes: number;
                          durationMs: number;
                          waveform: number[];
                          /** @maxLength 4096 */
                          transcript: string | null;
                        };
                        src: any;
                      }
                    | {
                        phase: "published";
                        /** @format date-time */
                        startedAt: string;
                        canceledAt: any;
                        /** @format date-time */
                        processingAt: string;
                        /** @format date-time */
                        publishedAt: string;
                        deletedAt: any;
                        metadata: {
                          lengthBytes: number;
                          durationMs: number;
                          waveform: number[];
                          /** @maxLength 4096 */
                          transcript: string | null;
                        };
                        /** @maxLength 1024 */
                        src: string;
                      }
                    | {
                        phase: "deleted";
                        /** @format date-time */
                        startedAt: string;
                        canceledAt: any;
                        /** @format date-time */
                        processingAt: string;
                        /** @format date-time */
                        publishedAt: string;
                        /** @format date-time */
                        deletedAt: string;
                        metadata: any;
                        src: any;
                      };
                  /** @format date-time */
                  lastHeartbeatAt: string;
                  /** @format uuid */
                  idempotencyKey: string;
                }
              | {
                  type: "event.positionUpdate";
                };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/alarm-calls/${id}/alarm-call-events`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates AlarmCallParticipant
     *
     * @tags AlarmCall
     * @name AlarmCallsControllerPaginateParticipants
     * @request GET:/alarm-calls/{id}/alarm-call-participants
     * @secure
     */
    alarmCallsControllerPaginateParticipants: (
      id: string,
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            alarmCall: {
              /** @format uuid */
              _id: string;
              _ref: "AlarmCall";
            };
            ref:
              | {
                  /** @format uuid */
                  _id: string;
                  _ref: "User";
                }
              | {
                  /** @format uuid */
                  _id: string;
                  _ref: "Asset";
                }
              | null;
            /** @maxLength 1024 */
            name: string;
            state: {
              /** @maxLength 1024 */
              sid: string;
              muted: boolean;
              speaking: boolean;
              /** @format date-time */
              connectedAt: string | null;
              /** @format date-time */
              disconnectedAt: string | null;
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/alarm-calls/${id}/alarm-call-participants`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Searches AlarmCall
     *
     * @tags AlarmCall
     * @name AlarmCallsControllerSearch
     * @request GET:/alarm-calls/search
     * @secure
     */
    alarmCallsControllerSearch: (
      query: {
        /** The search query string */
        q: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            alarm: {
              /** @format uuid */
              _id: string;
              _ref: "Alarm";
            } | null;
            asset: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            } | null;
            type: "alarmCall" | "helperCall";
            /** @maxLength 1024 */
            callSid: string;
            /** @maxLength 1024 */
            conferenceSid: string | null;
            /** @format date-time */
            endedAt: string | null;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/alarm-calls/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AlarmCall
     * @name AlarmCallsControllerCreateTwiml
     * @request POST:/alarm-calls/twiml/create
     * @secure
     */
    alarmCallsControllerCreateTwiml: (
      data: AlarmCallTwimlCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/alarm-calls/twiml/create`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AlarmCall
     * @name AlarmCallsControllerUpdateTwiml
     * @request POST:/alarm-calls/twiml/status
     * @secure
     */
    alarmCallsControllerUpdateTwiml: (
      data: AlarmCallTwimlStatusDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/alarm-calls/twiml/status`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  alarmProcesss = {
    /**
     * @description Creates a AlarmProcess
     *
     * @tags AlarmProcess
     * @name AlarmProcessControllerCreate
     * @request POST:/alarm-processs
     * @secure
     */
    alarmProcessControllerCreate: (
      data: AlarmProcessCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AlarmProcessOutputDto, any>({
        path: `/alarm-processs`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates AlarmProcess
     *
     * @tags AlarmProcess
     * @name AlarmProcessControllerPaginate
     * @request GET:/alarm-processs
     * @secure
     */
    alarmProcessControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            } | null;
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /**
             * PII
             * @maxLength 4096
             */
            description: string;
            tasks: (
              | {
                  /** @format uuid */
                  _id: string;
                  taskName: "call";
                  dataScript: {
                    scriptName: "getAssets";
                    options: {
                      filter: any;
                      max: number;
                    };
                  };
                  /** @maxLength 1024 */
                  forceLocale?: string | null;
                }
              | {
                  /** @format uuid */
                  _id: string;
                  taskName: "sms";
                  dataScript: {
                    scriptName: "getAssets";
                    options: {
                      filter: any;
                      max: number;
                    };
                  };
                  /** @maxLength 1024 */
                  forceLocale?: string | null;
                }
              | {
                  /** @format uuid */
                  _id: string;
                  taskName: "delay";
                  delaySeconds: number;
                }
              | {
                  /** @format uuid */
                  _id: string;
                  taskName: "split";
                  tasks: (
                    | {
                        /** @format uuid */
                        _id: string;
                        taskName: "call";
                        dataScript: {
                          scriptName: "getAssets";
                          options: {
                            filter: any;
                            max: number;
                          };
                        };
                        /** @maxLength 1024 */
                        forceLocale?: string | null;
                      }
                    | {
                        /** @format uuid */
                        _id: string;
                        taskName: "sms";
                        dataScript: {
                          scriptName: "getAssets";
                          options: {
                            filter: any;
                            max: number;
                          };
                        };
                        /** @maxLength 1024 */
                        forceLocale?: string | null;
                      }
                    | {
                        /** @format uuid */
                        _id: string;
                        taskName: "delay";
                        delaySeconds: number;
                      }
                    | {
                        /** @format uuid */
                        _id: string;
                        taskName: "schedule";
                        branches: {
                          schedule: {
                            entries: {
                              daysOfWeek: number[];
                              /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                              timeStart: string;
                              /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                              timeEnd: string;
                            }[];
                          };
                          tasks: (
                            | {
                                /** @format uuid */
                                _id: string;
                                taskName: "call";
                                dataScript: {
                                  scriptName: "getAssets";
                                  options: {
                                    filter: any;
                                    max: number;
                                  };
                                };
                                /** @maxLength 1024 */
                                forceLocale?: string | null;
                              }
                            | {
                                /** @format uuid */
                                _id: string;
                                taskName: "sms";
                                dataScript: {
                                  scriptName: "getAssets";
                                  options: {
                                    filter: any;
                                    max: number;
                                  };
                                };
                                /** @maxLength 1024 */
                                forceLocale?: string | null;
                              }
                            | {
                                /** @format uuid */
                                _id: string;
                                taskName: "delay";
                                delaySeconds: number;
                              }
                            | {
                                /** @format uuid */
                                _id: string;
                                taskName: "goto";
                                /** @format uuid */
                                targetTaskId: string;
                                maxExecutions?: number;
                              }
                          )[][];
                        }[];
                        defaultTasks?: (
                          | {
                              /** @format uuid */
                              _id: string;
                              taskName: "call";
                              dataScript: {
                                scriptName: "getAssets";
                                options: {
                                  filter: any;
                                  max: number;
                                };
                              };
                              /** @maxLength 1024 */
                              forceLocale?: string | null;
                            }
                          | {
                              /** @format uuid */
                              _id: string;
                              taskName: "sms";
                              dataScript: {
                                scriptName: "getAssets";
                                options: {
                                  filter: any;
                                  max: number;
                                };
                              };
                              /** @maxLength 1024 */
                              forceLocale?: string | null;
                            }
                          | {
                              /** @format uuid */
                              _id: string;
                              taskName: "delay";
                              delaySeconds: number;
                            }
                          | {
                              /** @format uuid */
                              _id: string;
                              taskName: "goto";
                              /** @format uuid */
                              targetTaskId: string;
                              maxExecutions?: number;
                            }
                        )[][];
                      }
                    | {
                        /** @format uuid */
                        _id: string;
                        taskName: "goto";
                        /** @format uuid */
                        targetTaskId: string;
                        maxExecutions?: number;
                      }
                  )[][];
                }
              | {
                  /** @format uuid */
                  _id: string;
                  taskName: "goto";
                  /** @format uuid */
                  targetTaskId: string;
                  maxExecutions?: number;
                }
            )[][];
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/alarm-processs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a AlarmProcess by id
     *
     * @tags AlarmProcess
     * @name AlarmProcessControllerFindById
     * @request GET:/alarm-processs/{id}
     * @secure
     */
    alarmProcessControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AlarmProcessOutputDto, any>({
        path: `/alarm-processs/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a AlarmProcess
     *
     * @tags AlarmProcess
     * @name AlarmProcessControllerUpdate
     * @request PATCH:/alarm-processs/{id}
     * @secure
     */
    alarmProcessControllerUpdate: (
      id: string,
      data: AlarmProcessUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AlarmProcessOutputDto, any>({
        path: `/alarm-processs/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a AlarmProcess by id
     *
     * @tags AlarmProcess
     * @name AlarmProcessControllerRemove
     * @request DELETE:/alarm-processs/{id}
     * @secure
     */
    alarmProcessControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/alarm-processs/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
  };
  alarmProfessionalResponders = {
    /**
     * @description Paginates AlarmProfessionalResponder
     *
     * @tags AlarmProfessionalResponder
     * @name AlarmProfessionalRespondersControllerPaginate
     * @request GET:/alarm-professional-responders
     * @secure
     */
    alarmProfessionalRespondersControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            type: "sequrix";
            active: boolean;
            status: "invited" | "accepted" | "rejected" | "started" | "onLocation" | "finished" | "error" | "canceled";
            alarm: {
              /** @format uuid */
              _id: string;
              _ref: "Alarm";
            };
            asset: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            };
            staticResponder: {
              /** @format uuid */
              _id: string;
              _ref: "StaticResponder";
            };
            /** PII */
            statistics: {
              /** @format date-time */
              invitedAt: string;
              /** @format date-time */
              acceptedAt: string | null;
              /** @format date-time */
              rejectedAt: string | null;
              /** @format date-time */
              startedAt: string | null;
              /** @format date-time */
              onLocationAt: string | null;
              /** @format date-time */
              finishedAt: string | null;
            };
            meta: {
              /**
               * PII
               * @maxLength 4096
               */
              comment?: string;
              /** PII */
              photos?: {
                /** @format date-time */
                timestamp: string;
                /** @maxLength 1024 */
                url: string;
              }[];
              /**
               * PII
               * @maxLength 1024
               */
              overridePhoneNumber?: string;
            };
            supersededBy: {
              /** @format uuid */
              _id: string;
              _ref: "AlarmProfessionalResponder";
            } | null;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/alarm-professional-responders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a AlarmProfessionalResponder by id
     *
     * @tags AlarmProfessionalResponder
     * @name AlarmProfessionalRespondersControllerFindById
     * @request GET:/alarm-professional-responders/{id}
     * @secure
     */
    alarmProfessionalRespondersControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AlarmProfessionalRespondersOutputDto, any>({
        path: `/alarm-professional-responders/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AlarmProfessionalResponder
     * @name AlarmProfessionalRespondersControllerSequrixCallback
     * @request POST:/alarm-professional-responders/sequrix/callback
     * @secure
     */
    alarmProfessionalRespondersControllerSequrixCallback: (
      data: SequrixCallbackRequestDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/alarm-professional-responders/sequrix/callback`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  alarms = {
    /**
     * @description Creates a Alarm
     *
     * @tags Alarm
     * @name AlarmsControllerCreate
     * @request POST:/alarms
     * @secure
     */
    alarmsControllerCreate: (
      data: AlarmCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AlarmOutputDto, any>({
        path: `/alarms`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates Alarm
     *
     * @tags Alarm
     * @name AlarmsControllerPaginate
     * @request GET:/alarms
     * @secure
     */
    alarmsControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
            asset: {
              /** @format uuid */
              _id: string;
              /** @format date-time */
              createdAt: string;
              /** @format date-time */
              updatedAt: string;
              telluId?: number | null;
              migrationFinalised?: boolean | null;
              /** @format date-time */
              migrationFinalisedDate?: string | null;
              customer: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              };
              /** @default {"type":"parents","extra":[]} */
              share?: {
                type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                extra?: {
                  /** @format uuid */
                  _id: string;
                  _ref: "Customer";
                }[];
              };
              user: {
                /** @format uuid */
                _id: string;
                _ref: "User";
              } | null;
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
              /**
               * PII
               * @maxLength 1024
               */
              externalId?: string | null;
              propertiesOwnership?: "override" | "inherit";
              /** @default {} */
              properties?: {
                /**
                 * PII
                 * @maxLength 1024
                 */
                phoneNumber?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                smsNumber?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                email?: string | null;
                /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                locale?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                image?: string | null;
                /** PII */
                rSim?: {
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  euicc: string;
                  primary: {
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    msisdn: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    iccid: string;
                  };
                  secondary: {
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    msisdn: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    iccid: string;
                  };
                  enabled: boolean;
                } | null;
              };
              /**
               * PII
               * @default null
               */
              position?: {
                type: "Point";
                /** PII */
                coordinates: number[];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              };
              available: boolean;
              /** @default true */
              allowContactOnOwnAlarms?: boolean;
              app?: {
                mode: "off" | "on" | "risk";
              } | null;
              insideZones: {
                /** @format uuid */
                _id: string;
                _ref: "Zone";
              }[];
              assetGroups: {
                /** @format uuid */
                _id: string;
                _ref: "AssetGroup";
              }[];
              /** @default [] */
              staticResponders?: {
                staticResponder: {
                  /** @format uuid */
                  _id: string;
                  _ref: "StaticResponder";
                };
                priority: number;
              }[];
              /** @format date-time */
              lastObservationAt?: string;
              /** @default false */
              invisibleResponder?: boolean;
              /**
               * PII
               * @maxLength 4096
               */
              description?: string;
              /** @default [] */
              certifications?: {
                /** @format uuid */
                _id: string;
                certificationCategory: {
                  /** @format uuid */
                  _id: string;
                  _ref: "CertificationCategory";
                };
                /** @format date-time */
                firstIssuedOn: string;
                /** @format date-time */
                lastReceivedOn: string;
                /** @format date-time */
                expiryDate: string;
                /**
                 * @format date-time
                 * @default null
                 */
                plannedRenewalDate?: string | null;
                /** @maxLength 1024 */
                documentaryProof?: string | null;
              }[];
              type?: "default" | "kiosk";
            };
            ack: {
              needed: boolean;
              value: boolean;
              ackedBy: {
                /** @format uuid */
                _id: string;
                _ref: "User";
                /**
                 * PII
                 * @maxLength 1024
                 */
                name: string;
              } | null;
              /**
               * PII
               * @maxLength 1024
               */
              comment: string | null;
              /** @format date-time */
              ackedAt: string | null;
            };
            /** PII */
            position: {
              type: "Point";
              /** PII */
              coordinates: number[];
              properties: {
                accuracy?: number;
                heading?: number;
                headingAccuracy?: number;
                speed?: number;
                speedAccuracy?: number;
                altitude?: number;
                altitudeAccuracy?: number;
                /** PII */
                address?: {
                  /** @maxLength 1024 */
                  countryCode?: string | null;
                  /** @maxLength 1024 */
                  state?: string | null;
                  /** @maxLength 1024 */
                  city?: string | null;
                  /** @maxLength 1024 */
                  streetName?: string | null;
                  /** @maxLength 1024 */
                  streetNumber?: string | null;
                  floor?: number | null;
                  /** @maxLength 1024 */
                  formattedAddress?: string;
                };
                /** @format date-time */
                dateTime?: string;
                /** @maxLength 1024 */
                provider?: string;
              };
            };
            severity: "red" | "orange" | "green";
            /**
             * PII
             * @maxLength 4096
             */
            procedure: string | null;
            meta?: {
              observationTrigger?: {
                /** @format uuid */
                _id: string;
                /** @format date-time */
                createdAt: string;
                /** @format date-time */
                updatedAt: string;
                telluId?: number | null;
                migrationFinalised?: boolean | null;
                /** @format date-time */
                migrationFinalisedDate?: string | null;
                customer: {
                  /** @format uuid */
                  _id: string;
                  _ref: "Customer";
                };
                /** @default {"type":"parents","extra":[]} */
                share?: {
                  type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                  extra?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  }[];
                };
                /** @maxLength 1024 */
                name: string;
                eventCodes: string[];
                /** @maxLength 1024 */
                description: string;
                status: "active" | "inactive";
                actions: (
                  | {
                      type: "alarm";
                      config: {
                        severity: "red" | "orange" | "green";
                        type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
                        /** @maxLength 4096 */
                        procedure: string | null;
                        /** @maxLength 1024 */
                        name: string;
                      };
                    }
                  | {
                      type: "sms";
                      config: {
                        /** PII */
                        toRaw: string[];
                        toContactList: {
                          /** @format uuid */
                          _id: string;
                          _ref: "ContactList";
                        }[];
                        toTriggerUser: boolean;
                        /** @maxLength 1024 */
                        message: string;
                      };
                    }
                  | {
                      type: "email";
                      config: {
                        /** PII */
                        toRaw: string[];
                        toContactList: {
                          /** @format uuid */
                          _id: string;
                          _ref: "ContactList";
                        }[];
                        toTriggerUser: boolean;
                        /** @maxLength 1024 */
                        message: string;
                        /** @maxLength 1024 */
                        subject: string;
                        /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                        locale?: string;
                      };
                    }
                  | {
                      type: "assetUpdate";
                      config: {
                        available?: boolean;
                        app?: {
                          mode: "off" | "on" | "risk";
                        };
                      };
                    }
                )[];
                filter:
                  | {
                      type: "operator/and";
                      operands: (
                        | {
                            type: "operator/or";
                            operands: (
                              | {
                                  type: "operator/not";
                                  operand:
                                    | {
                                        type: "constraint/asset";
                                        assets: {
                                          /** @format uuid */
                                          _id: string;
                                          _ref: "Asset";
                                        }[];
                                      }
                                    | {
                                        type: "constraint/assetGroup";
                                        groups: {
                                          /** @format uuid */
                                          _id: string;
                                          _ref: "AssetGroup";
                                        }[];
                                      }
                                    | {
                                        type: "constraint/zone";
                                        zone: {
                                          /** @format uuid */
                                          _id: string;
                                          _ref: "Zone";
                                        };
                                      }
                                    | {
                                        type: "constraint/schedule";
                                        schedule: {
                                          entries: {
                                            daysOfWeek: number[];
                                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                            timeStart: string;
                                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                            timeEnd: string;
                                          }[];
                                        };
                                      };
                                }
                              | {
                                  type: "constraint/asset";
                                  assets: {
                                    /** @format uuid */
                                    _id: string;
                                    _ref: "Asset";
                                  }[];
                                }
                              | {
                                  type: "constraint/assetGroup";
                                  groups: {
                                    /** @format uuid */
                                    _id: string;
                                    _ref: "AssetGroup";
                                  }[];
                                }
                              | {
                                  type: "constraint/zone";
                                  zone: {
                                    /** @format uuid */
                                    _id: string;
                                    _ref: "Zone";
                                  };
                                }
                              | {
                                  type: "constraint/schedule";
                                  schedule: {
                                    entries: {
                                      daysOfWeek: number[];
                                      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                      timeStart: string;
                                      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                      timeEnd: string;
                                    }[];
                                  };
                                }
                            )[];
                          }
                        | {
                            type: "constraint/asset";
                            assets: {
                              /** @format uuid */
                              _id: string;
                              _ref: "Asset";
                            }[];
                          }
                        | {
                            type: "constraint/assetGroup";
                            groups: {
                              /** @format uuid */
                              _id: string;
                              _ref: "AssetGroup";
                            }[];
                          }
                        | {
                            type: "constraint/zone";
                            zone: {
                              /** @format uuid */
                              _id: string;
                              _ref: "Zone";
                            };
                          }
                        | {
                            type: "constraint/schedule";
                            schedule: {
                              entries: {
                                daysOfWeek: number[];
                                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                timeStart: string;
                                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                timeEnd: string;
                              }[];
                            };
                          }
                      )[];
                    }
                  | {
                      type: "constraint/asset";
                      assets: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Asset";
                      }[];
                    }
                  | {
                      type: "constraint/assetGroup";
                      groups: {
                        /** @format uuid */
                        _id: string;
                        _ref: "AssetGroup";
                      }[];
                    }
                  | {
                      type: "constraint/zone";
                      zone: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Zone";
                      };
                    }
                  | {
                      type: "constraint/schedule";
                      schedule: {
                        entries: {
                          daysOfWeek: number[];
                          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                          timeStart: string;
                          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                          timeEnd: string;
                        }[];
                      };
                    };
              };
              /** PII */
              observation?: {
                /** @format uuid */
                _id: string;
                /** @maxLength 1024 */
                event: string;
                asset: {
                  /** @format uuid */
                  _id: string;
                  /** @format date-time */
                  createdAt: string;
                  /** @format date-time */
                  updatedAt: string;
                  telluId?: number | null;
                  migrationFinalised?: boolean | null;
                  /** @format date-time */
                  migrationFinalisedDate?: string | null;
                  customer: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  };
                  /** @default {"type":"parents","extra":[]} */
                  share?: {
                    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                    extra?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    }[];
                  };
                  user: {
                    /** @format uuid */
                    _id: string;
                    _ref: "User";
                  } | null;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  name: string;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  externalId?: string | null;
                  propertiesOwnership?: "override" | "inherit";
                  /** @default {} */
                  properties?: {
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    phoneNumber?: string | null;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    smsNumber?: string | null;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    email?: string | null;
                    /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                    locale?: string | null;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    image?: string | null;
                    /** PII */
                    rSim?: {
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      euicc: string;
                      primary: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        msisdn: string;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        iccid: string;
                      };
                      secondary: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        msisdn: string;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        iccid: string;
                      };
                      enabled: boolean;
                    } | null;
                  };
                  /**
                   * PII
                   * @default null
                   */
                  position?: {
                    type: "Point";
                    /** PII */
                    coordinates: number[];
                    properties: {
                      accuracy?: number;
                      heading?: number;
                      headingAccuracy?: number;
                      speed?: number;
                      speedAccuracy?: number;
                      altitude?: number;
                      altitudeAccuracy?: number;
                      /** PII */
                      address?: {
                        /** @maxLength 1024 */
                        countryCode?: string | null;
                        /** @maxLength 1024 */
                        state?: string | null;
                        /** @maxLength 1024 */
                        city?: string | null;
                        /** @maxLength 1024 */
                        streetName?: string | null;
                        /** @maxLength 1024 */
                        streetNumber?: string | null;
                        floor?: number | null;
                        /** @maxLength 1024 */
                        formattedAddress?: string;
                      };
                      /** @format date-time */
                      dateTime?: string;
                      /** @maxLength 1024 */
                      provider?: string;
                    };
                  };
                  available: boolean;
                  /** @default true */
                  allowContactOnOwnAlarms?: boolean;
                  app?: {
                    mode: "off" | "on" | "risk";
                  } | null;
                  insideZones: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Zone";
                  }[];
                  assetGroups: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[];
                  /** @default [] */
                  staticResponders?: {
                    staticResponder: {
                      /** @format uuid */
                      _id: string;
                      _ref: "StaticResponder";
                    };
                    priority: number;
                  }[];
                  /** @format date-time */
                  lastObservationAt?: string;
                  /** @default false */
                  invisibleResponder?: boolean;
                  /**
                   * PII
                   * @maxLength 4096
                   */
                  description?: string;
                  /** @default [] */
                  certifications?: {
                    /** @format uuid */
                    _id: string;
                    certificationCategory: {
                      /** @format uuid */
                      _id: string;
                      _ref: "CertificationCategory";
                    };
                    /** @format date-time */
                    firstIssuedOn: string;
                    /** @format date-time */
                    lastReceivedOn: string;
                    /** @format date-time */
                    expiryDate: string;
                    /**
                     * @format date-time
                     * @default null
                     */
                    plannedRenewalDate?: string | null;
                    /** @maxLength 1024 */
                    documentaryProof?: string | null;
                  }[];
                  type?: "default" | "kiosk";
                  _ref: "Asset";
                };
                customer: {
                  /** @format uuid */
                  _id: string;
                  _ref: "Customer";
                };
                device: {
                  /** @format uuid */
                  _id: string;
                  _ref: "Device";
                };
                user: {
                  /** @format uuid */
                  _id: string;
                  _ref: "User";
                };
                /** PII */
                position?: {
                  type: "Point";
                  /** PII */
                  coordinates: number[];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                };
                beacons?:
                  | {
                      /** @maxLength 1024 */
                      code: string;
                      rssi: number;
                      battery?: number;
                      /** @format date-time */
                      dateTime: string;
                      beacon: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Beacon";
                      } | null;
                      calc: number | null;
                      valid: boolean;
                    }[]
                  | {
                      /** @maxLength 1024 */
                      code: string;
                      rssi: number;
                      battery?: number;
                      /** @format date-time */
                      dateTime: string;
                    }[];
                /** PII */
                meta?: {
                  asset?: {
                    /** @format uuid */
                    _id: string;
                    /** @format date-time */
                    createdAt: string;
                    /** @format date-time */
                    updatedAt: string;
                    telluId?: number | null;
                    migrationFinalised?: boolean | null;
                    /** @format date-time */
                    migrationFinalisedDate?: string | null;
                    customer: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    /** @default {"type":"parents","extra":[]} */
                    share?: {
                      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                      extra?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      }[];
                    };
                    user: {
                      /** @format uuid */
                      _id: string;
                      _ref: "User";
                    } | null;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    name: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    externalId?: string | null;
                    propertiesOwnership?: "override" | "inherit";
                    /** @default {} */
                    properties?: {
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      phoneNumber?: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      smsNumber?: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      email?: string | null;
                      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                      locale?: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      image?: string | null;
                      /** PII */
                      rSim?: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        euicc: string;
                        primary: {
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          msisdn: string;
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          iccid: string;
                        };
                        secondary: {
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          msisdn: string;
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          iccid: string;
                        };
                        enabled: boolean;
                      } | null;
                    };
                    /**
                     * PII
                     * @default null
                     */
                    position?: {
                      type: "Point";
                      /** PII */
                      coordinates: number[];
                      properties: {
                        accuracy?: number;
                        heading?: number;
                        headingAccuracy?: number;
                        speed?: number;
                        speedAccuracy?: number;
                        altitude?: number;
                        altitudeAccuracy?: number;
                        /** PII */
                        address?: {
                          /** @maxLength 1024 */
                          countryCode?: string | null;
                          /** @maxLength 1024 */
                          state?: string | null;
                          /** @maxLength 1024 */
                          city?: string | null;
                          /** @maxLength 1024 */
                          streetName?: string | null;
                          /** @maxLength 1024 */
                          streetNumber?: string | null;
                          floor?: number | null;
                          /** @maxLength 1024 */
                          formattedAddress?: string;
                        };
                        /** @format date-time */
                        dateTime?: string;
                        /** @maxLength 1024 */
                        provider?: string;
                      };
                    };
                    available: boolean;
                    /** @default true */
                    allowContactOnOwnAlarms?: boolean;
                    app?: {
                      mode: "off" | "on" | "risk";
                    } | null;
                    insideZones: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    }[];
                    assetGroups: {
                      /** @format uuid */
                      _id: string;
                      _ref: "AssetGroup";
                    }[];
                    /** @default [] */
                    staticResponders?: {
                      staticResponder: {
                        /** @format uuid */
                        _id: string;
                        _ref: "StaticResponder";
                      };
                      priority: number;
                    }[];
                    /** @format date-time */
                    lastObservationAt?: string;
                    /** @default false */
                    invisibleResponder?: boolean;
                    /**
                     * PII
                     * @maxLength 4096
                     */
                    description?: string;
                    /** @default [] */
                    certifications?: {
                      /** @format uuid */
                      _id: string;
                      certificationCategory: {
                        /** @format uuid */
                        _id: string;
                        _ref: "CertificationCategory";
                      };
                      /** @format date-time */
                      firstIssuedOn: string;
                      /** @format date-time */
                      lastReceivedOn: string;
                      /** @format date-time */
                      expiryDate: string;
                      /**
                       * @format date-time
                       * @default null
                       */
                      plannedRenewalDate?: string | null;
                      /** @maxLength 1024 */
                      documentaryProof?: string | null;
                    }[];
                    type?: "default" | "kiosk";
                  };
                  battery?: number;
                  rssi?: number;
                  snr?: number;
                  /** @format date-time */
                  dateTime?: string;
                  /** @format date-time */
                  deviceDateTime?: string;
                  /** @format date-time */
                  gatewayDateTime?: string;
                  insideGpsZones?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Zone";
                  }[];
                  insideIpsZones?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Zone";
                  }[];
                  zone?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Zone";
                  };
                  callRequest?: boolean;
                  forceLoraCustomer?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  };
                  knnResult?: {
                    distance: number;
                    debugInfo?: any;
                  };
                  available?: boolean;
                };
                deltas?: {
                  main: {
                    /** @format date-time */
                    start: string;
                    /** @format date-time */
                    end: string;
                    value?: number;
                  };
                  steps?: {
                    gps?: {
                      /** @format date-time */
                      start: string;
                      /** @format date-time */
                      end: string;
                      value?: number;
                    };
                    ips?: {
                      /** @format date-time */
                      start: string;
                      /** @format date-time */
                      end: string;
                      value?: number;
                    };
                    context?: {
                      /** @format date-time */
                      start: string;
                      /** @format date-time */
                      end: string;
                      value?: number;
                    };
                  };
                };
                validPosition?: {
                  value: boolean;
                  /** @maxLength 1024 */
                  reason?: string;
                };
                isSystemEvent?: boolean;
              };
              /** PII */
              frozenInfo?: {
                staticResponse: {
                  type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
                  priority: number;
                  zone?: {
                    /** @format uuid */
                    _id: string;
                    customer?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    type?:
                      | "default"
                      | "responseArea"
                      | "policeDepartment"
                      | "assetMonitoredArea"
                      | "fingerprinted"
                      | "building"
                      | "evacuationPoint";
                    /** PII */
                    location:
                      | {
                          type: "Point";
                          /** PII */
                          coordinates: number[];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        }
                      | {
                          type: "Polygon";
                          /** PII */
                          coordinates: number[][][];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        }
                      | {
                          type: "MultiPolygon";
                          coordinates: number[][][][];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        };
                    /** @maxLength 1024 */
                    name: string;
                    staticResponders: {
                      staticResponder: {
                        /** @format uuid */
                        _id: string;
                        _ref: "StaticResponder";
                      };
                      priority: number;
                    }[];
                  };
                  responders: {
                    info: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset" | "StaticResponder";
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      name: string;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      image: string | null;
                      /** PII */
                      position: {
                        type: "Point";
                        /** PII */
                        coordinates: number[];
                        properties: {
                          accuracy?: number;
                          heading?: number;
                          headingAccuracy?: number;
                          speed?: number;
                          speedAccuracy?: number;
                          altitude?: number;
                          altitudeAccuracy?: number;
                          /** PII */
                          address?: {
                            /** @maxLength 1024 */
                            countryCode?: string | null;
                            /** @maxLength 1024 */
                            state?: string | null;
                            /** @maxLength 1024 */
                            city?: string | null;
                            /** @maxLength 1024 */
                            streetName?: string | null;
                            /** @maxLength 1024 */
                            streetNumber?: string | null;
                            floor?: number | null;
                            /** @maxLength 1024 */
                            formattedAddress?: string;
                          };
                          /** @format date-time */
                          dateTime?: string;
                          /** @maxLength 1024 */
                          provider?: string;
                        };
                      };
                      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                      locale: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      contactCode: string | null;
                    };
                    distanceKm: number | null;
                    actions: {
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      call: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      sms: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      email: string | null;
                      notification: boolean;
                    };
                    priority: number;
                    professionalResponder?: {
                      available: boolean;
                      inProgress: boolean;
                    };
                  }[];
                }[];
                dynamicResponse: {
                  type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
                  priority: number;
                  zone?: {
                    /** @format uuid */
                    _id: string;
                    customer?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    type?:
                      | "default"
                      | "responseArea"
                      | "policeDepartment"
                      | "assetMonitoredArea"
                      | "fingerprinted"
                      | "building"
                      | "evacuationPoint";
                    /** PII */
                    location:
                      | {
                          type: "Point";
                          /** PII */
                          coordinates: number[];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        }
                      | {
                          type: "Polygon";
                          /** PII */
                          coordinates: number[][][];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        }
                      | {
                          type: "MultiPolygon";
                          coordinates: number[][][][];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        };
                    /** @maxLength 1024 */
                    name: string;
                    staticResponders: {
                      staticResponder: {
                        /** @format uuid */
                        _id: string;
                        _ref: "StaticResponder";
                      };
                      priority: number;
                    }[];
                  };
                  responders: {
                    info: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset" | "StaticResponder";
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      name: string;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      image: string | null;
                      /** PII */
                      position: {
                        type: "Point";
                        /** PII */
                        coordinates: number[];
                        properties: {
                          accuracy?: number;
                          heading?: number;
                          headingAccuracy?: number;
                          speed?: number;
                          speedAccuracy?: number;
                          altitude?: number;
                          altitudeAccuracy?: number;
                          /** PII */
                          address?: {
                            /** @maxLength 1024 */
                            countryCode?: string | null;
                            /** @maxLength 1024 */
                            state?: string | null;
                            /** @maxLength 1024 */
                            city?: string | null;
                            /** @maxLength 1024 */
                            streetName?: string | null;
                            /** @maxLength 1024 */
                            streetNumber?: string | null;
                            floor?: number | null;
                            /** @maxLength 1024 */
                            formattedAddress?: string;
                          };
                          /** @format date-time */
                          dateTime?: string;
                          /** @maxLength 1024 */
                          provider?: string;
                        };
                      };
                      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                      locale: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      contactCode: string | null;
                    };
                    distanceKm: number | null;
                    actions: {
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      call: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      sms: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      email: string | null;
                      notification: boolean;
                    };
                    priority: number;
                    professionalResponder?: {
                      available: boolean;
                      inProgress: boolean;
                    };
                  }[];
                }[];
                professionalResponders?: {
                  /** @format uuid */
                  _id: string;
                  /** @format date-time */
                  createdAt: string;
                  /** @format date-time */
                  updatedAt: string;
                  telluId?: number | null;
                  migrationFinalised?: boolean | null;
                  /** @format date-time */
                  migrationFinalisedDate?: string | null;
                  customer: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  };
                  /** @default {"type":"parents","extra":[]} */
                  share?: {
                    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                    extra?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    }[];
                  };
                  type: "sequrix";
                  active: boolean;
                  status:
                    | "invited"
                    | "accepted"
                    | "rejected"
                    | "started"
                    | "onLocation"
                    | "finished"
                    | "error"
                    | "canceled";
                  alarm: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Alarm";
                  };
                  asset: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Asset";
                  };
                  staticResponder: {
                    /** @format uuid */
                    _id: string;
                    /** @format date-time */
                    createdAt: string;
                    /** @format date-time */
                    updatedAt: string;
                    telluId?: number | null;
                    migrationFinalised?: boolean | null;
                    /** @format date-time */
                    migrationFinalisedDate?: string | null;
                    customer: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    /** @default {"type":"parents","extra":[]} */
                    share?: {
                      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                      extra?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      }[];
                    };
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    name: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    externalId: string | null;
                    contact: {
                      /**
                       * PII
                       * @pattern ^([\w+\-.]+@([\w-]+\.)+[\w-]{2,}[, ]*?)+?$
                       */
                      email: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      phone: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      sms: string | null;
                      /** @maxLength 1024 */
                      camera: string | null;
                    };
                    schedule: {
                      entries: {
                        daysOfWeek: number[];
                        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                        timeStart: string;
                        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                        timeEnd: string;
                      }[];
                    } | null;
                    /** @maxLength 1024 */
                    migrationKey?: string;
                    integrations?: {
                      sequrix: {
                        enabled: boolean;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        objectCode: string;
                      };
                    };
                    /** PII */
                    statistics?: {
                      /**
                       * @maxItems 10
                       * @minItems 0
                       */
                      acceptSpeeds: {
                        /** @format date-time */
                        timestamp: string;
                        /**
                         * @min 0
                         * @exclusiveMin false
                         */
                        speedMs: number;
                      }[];
                      /**
                       * @maxItems 10
                       * @minItems 0
                       */
                      onLocationSpeeds: {
                        /** @format date-time */
                        timestamp: string;
                        /**
                         * @min 0
                         * @exclusiveMin false
                         */
                        speedMs: number;
                      }[];
                      /**
                       * @maxItems 10
                       * @minItems 0
                       */
                      finishSpeeds: {
                        /** @format date-time */
                        timestamp: string;
                        /**
                         * @min 0
                         * @exclusiveMin false
                         */
                        speedMs: number;
                      }[];
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      amountRejected: number;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      amountAccepted: number;
                    };
                    _ref: "StaticResponder";
                  };
                  /** PII */
                  statistics: {
                    /** @format date-time */
                    invitedAt: string;
                    /** @format date-time */
                    acceptedAt: string | null;
                    /** @format date-time */
                    rejectedAt: string | null;
                    /** @format date-time */
                    startedAt: string | null;
                    /** @format date-time */
                    onLocationAt: string | null;
                    /** @format date-time */
                    finishedAt: string | null;
                  };
                  meta: {
                    /**
                     * PII
                     * @maxLength 4096
                     */
                    comment?: string;
                    /** PII */
                    photos?: {
                      /** @format date-time */
                      timestamp: string;
                      /** @maxLength 1024 */
                      url: string;
                    }[];
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    overridePhoneNumber?: string;
                  };
                  supersededBy: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AlarmProfessionalResponder";
                  } | null;
                }[];
              };
            };
            alarmCenter: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
            } | null;
            /** @format date-time */
            lastMergedAt?: string;
            /** @format date-time */
            lastPublishedToStreamAt?: string;
            /** PII */
            mergeHistory?: {
              /** @format uuid */
              _id: string;
              /** @maxLength 1024 */
              name: string;
              /** @format date-time */
              createdAt: string;
              /** PII */
              position: {
                type: "Point";
                /** PII */
                coordinates: number[];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              };
              meta?: {
                observationTrigger?: {
                  /** @format uuid */
                  _id: string;
                  /** @format date-time */
                  createdAt: string;
                  /** @format date-time */
                  updatedAt: string;
                  telluId?: number | null;
                  migrationFinalised?: boolean | null;
                  /** @format date-time */
                  migrationFinalisedDate?: string | null;
                  customer: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  };
                  /** @default {"type":"parents","extra":[]} */
                  share?: {
                    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                    extra?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    }[];
                  };
                  /** @maxLength 1024 */
                  name: string;
                  eventCodes: string[];
                  /** @maxLength 1024 */
                  description: string;
                  status: "active" | "inactive";
                  actions: (
                    | {
                        type: "alarm";
                        config: {
                          severity: "red" | "orange" | "green";
                          type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
                          /** @maxLength 4096 */
                          procedure: string | null;
                          /** @maxLength 1024 */
                          name: string;
                        };
                      }
                    | {
                        type: "sms";
                        config: {
                          /** PII */
                          toRaw: string[];
                          toContactList: {
                            /** @format uuid */
                            _id: string;
                            _ref: "ContactList";
                          }[];
                          toTriggerUser: boolean;
                          /** @maxLength 1024 */
                          message: string;
                        };
                      }
                    | {
                        type: "email";
                        config: {
                          /** PII */
                          toRaw: string[];
                          toContactList: {
                            /** @format uuid */
                            _id: string;
                            _ref: "ContactList";
                          }[];
                          toTriggerUser: boolean;
                          /** @maxLength 1024 */
                          message: string;
                          /** @maxLength 1024 */
                          subject: string;
                          /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                          locale?: string;
                        };
                      }
                    | {
                        type: "assetUpdate";
                        config: {
                          available?: boolean;
                          app?: {
                            mode: "off" | "on" | "risk";
                          };
                        };
                      }
                  )[];
                  filter:
                    | {
                        type: "constraint/asset";
                        assets: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Asset";
                        }[];
                      }
                    | {
                        type: "constraint/assetGroup";
                        groups: {
                          /** @format uuid */
                          _id: string;
                          _ref: "AssetGroup";
                        }[];
                      }
                    | {
                        type: "constraint/zone";
                        zone: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Zone";
                        };
                      }
                    | {
                        type: "constraint/schedule";
                        schedule: {
                          entries: {
                            daysOfWeek: number[];
                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                            timeStart: string;
                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                            timeEnd: string;
                          }[];
                        };
                      };
                };
                /** PII */
                observation?: {
                  /** @format uuid */
                  _id: string;
                  /** @maxLength 1024 */
                  event: string;
                  asset: {
                    /** @format uuid */
                    _id: string;
                    /** @format date-time */
                    createdAt: string;
                    /** @format date-time */
                    updatedAt: string;
                    telluId?: number | null;
                    migrationFinalised?: boolean | null;
                    /** @format date-time */
                    migrationFinalisedDate?: string | null;
                    customer: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    /** @default {"type":"parents","extra":[]} */
                    share?: {
                      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                      extra?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      }[];
                    };
                    user: {
                      /** @format uuid */
                      _id: string;
                      _ref: "User";
                    } | null;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    name: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    externalId?: string | null;
                    propertiesOwnership?: "override" | "inherit";
                    /** @default {} */
                    properties?: {
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      phoneNumber?: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      smsNumber?: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      email?: string | null;
                      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                      locale?: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      image?: string | null;
                      /** PII */
                      rSim?: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        euicc: string;
                        primary: {
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          msisdn: string;
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          iccid: string;
                        };
                        secondary: {
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          msisdn: string;
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          iccid: string;
                        };
                        enabled: boolean;
                      } | null;
                    };
                    /**
                     * PII
                     * @default null
                     */
                    position?: {
                      type: "Point";
                      /** PII */
                      coordinates: number[];
                      properties: {
                        accuracy?: number;
                        heading?: number;
                        headingAccuracy?: number;
                        speed?: number;
                        speedAccuracy?: number;
                        altitude?: number;
                        altitudeAccuracy?: number;
                        /** PII */
                        address?: {
                          /** @maxLength 1024 */
                          countryCode?: string | null;
                          /** @maxLength 1024 */
                          state?: string | null;
                          /** @maxLength 1024 */
                          city?: string | null;
                          /** @maxLength 1024 */
                          streetName?: string | null;
                          /** @maxLength 1024 */
                          streetNumber?: string | null;
                          floor?: number | null;
                          /** @maxLength 1024 */
                          formattedAddress?: string;
                        };
                        /** @format date-time */
                        dateTime?: string;
                        /** @maxLength 1024 */
                        provider?: string;
                      };
                    };
                    available: boolean;
                    /** @default true */
                    allowContactOnOwnAlarms?: boolean;
                    app?: {
                      mode: "off" | "on" | "risk";
                    } | null;
                    insideZones: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    }[];
                    assetGroups: {
                      /** @format uuid */
                      _id: string;
                      _ref: "AssetGroup";
                    }[];
                    /** @default [] */
                    staticResponders?: {
                      staticResponder: {
                        /** @format uuid */
                        _id: string;
                        _ref: "StaticResponder";
                      };
                      priority: number;
                    }[];
                    /** @format date-time */
                    lastObservationAt?: string;
                    /** @default false */
                    invisibleResponder?: boolean;
                    /**
                     * PII
                     * @maxLength 4096
                     */
                    description?: string;
                    /** @default [] */
                    certifications?: {
                      /** @format uuid */
                      _id: string;
                      certificationCategory: {
                        /** @format uuid */
                        _id: string;
                        _ref: "CertificationCategory";
                      };
                      /** @format date-time */
                      firstIssuedOn: string;
                      /** @format date-time */
                      lastReceivedOn: string;
                      /** @format date-time */
                      expiryDate: string;
                      /**
                       * @format date-time
                       * @default null
                       */
                      plannedRenewalDate?: string | null;
                      /** @maxLength 1024 */
                      documentaryProof?: string | null;
                    }[];
                    type?: "default" | "kiosk";
                    _ref: "Asset";
                  };
                  customer: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  };
                  device: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Device";
                  };
                  user: {
                    /** @format uuid */
                    _id: string;
                    _ref: "User";
                  };
                  /** PII */
                  position?: {
                    type: "Point";
                    /** PII */
                    coordinates: number[];
                    properties: {
                      accuracy?: number;
                      heading?: number;
                      headingAccuracy?: number;
                      speed?: number;
                      speedAccuracy?: number;
                      altitude?: number;
                      altitudeAccuracy?: number;
                      /** PII */
                      address?: {
                        /** @maxLength 1024 */
                        countryCode?: string | null;
                        /** @maxLength 1024 */
                        state?: string | null;
                        /** @maxLength 1024 */
                        city?: string | null;
                        /** @maxLength 1024 */
                        streetName?: string | null;
                        /** @maxLength 1024 */
                        streetNumber?: string | null;
                        floor?: number | null;
                        /** @maxLength 1024 */
                        formattedAddress?: string;
                      };
                      /** @format date-time */
                      dateTime?: string;
                      /** @maxLength 1024 */
                      provider?: string;
                    };
                  };
                  beacons?:
                    | {
                        /** @maxLength 1024 */
                        code: string;
                        rssi: number;
                        battery?: number;
                        /** @format date-time */
                        dateTime: string;
                        beacon: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Beacon";
                        } | null;
                        calc: number | null;
                        valid: boolean;
                      }[]
                    | {
                        /** @maxLength 1024 */
                        code: string;
                        rssi: number;
                        battery?: number;
                        /** @format date-time */
                        dateTime: string;
                      }[];
                  /** PII */
                  meta?: {
                    asset?: {
                      /** @format uuid */
                      _id: string;
                      /** @format date-time */
                      createdAt: string;
                      /** @format date-time */
                      updatedAt: string;
                      telluId?: number | null;
                      migrationFinalised?: boolean | null;
                      /** @format date-time */
                      migrationFinalisedDate?: string | null;
                      customer: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      };
                      /** @default {"type":"parents","extra":[]} */
                      share?: {
                        type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                        extra?: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Customer";
                        }[];
                      };
                      user: {
                        /** @format uuid */
                        _id: string;
                        _ref: "User";
                      } | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      name: string;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      externalId?: string | null;
                      propertiesOwnership?: "override" | "inherit";
                      /** @default {} */
                      properties?: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        phoneNumber?: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        smsNumber?: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        email?: string | null;
                        /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                        locale?: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        image?: string | null;
                        /** PII */
                        rSim?: {
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          euicc: string;
                          primary: {
                            /**
                             * PII
                             * @maxLength 1024
                             */
                            msisdn: string;
                            /**
                             * PII
                             * @maxLength 1024
                             */
                            iccid: string;
                          };
                          secondary: {
                            /**
                             * PII
                             * @maxLength 1024
                             */
                            msisdn: string;
                            /**
                             * PII
                             * @maxLength 1024
                             */
                            iccid: string;
                          };
                          enabled: boolean;
                        } | null;
                      };
                      /**
                       * PII
                       * @default null
                       */
                      position?: {
                        type: "Point";
                        /** PII */
                        coordinates: number[];
                        properties: {
                          accuracy?: number;
                          heading?: number;
                          headingAccuracy?: number;
                          speed?: number;
                          speedAccuracy?: number;
                          altitude?: number;
                          altitudeAccuracy?: number;
                          /** PII */
                          address?: {
                            /** @maxLength 1024 */
                            countryCode?: string | null;
                            /** @maxLength 1024 */
                            state?: string | null;
                            /** @maxLength 1024 */
                            city?: string | null;
                            /** @maxLength 1024 */
                            streetName?: string | null;
                            /** @maxLength 1024 */
                            streetNumber?: string | null;
                            floor?: number | null;
                            /** @maxLength 1024 */
                            formattedAddress?: string;
                          };
                          /** @format date-time */
                          dateTime?: string;
                          /** @maxLength 1024 */
                          provider?: string;
                        };
                      };
                      available: boolean;
                      /** @default true */
                      allowContactOnOwnAlarms?: boolean;
                      app?: {
                        mode: "off" | "on" | "risk";
                      } | null;
                      insideZones: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Zone";
                      }[];
                      assetGroups: {
                        /** @format uuid */
                        _id: string;
                        _ref: "AssetGroup";
                      }[];
                      /** @default [] */
                      staticResponders?: {
                        staticResponder: {
                          /** @format uuid */
                          _id: string;
                          _ref: "StaticResponder";
                        };
                        priority: number;
                      }[];
                      /** @format date-time */
                      lastObservationAt?: string;
                      /** @default false */
                      invisibleResponder?: boolean;
                      /**
                       * PII
                       * @maxLength 4096
                       */
                      description?: string;
                      /** @default [] */
                      certifications?: {
                        /** @format uuid */
                        _id: string;
                        certificationCategory: {
                          /** @format uuid */
                          _id: string;
                          _ref: "CertificationCategory";
                        };
                        /** @format date-time */
                        firstIssuedOn: string;
                        /** @format date-time */
                        lastReceivedOn: string;
                        /** @format date-time */
                        expiryDate: string;
                        /**
                         * @format date-time
                         * @default null
                         */
                        plannedRenewalDate?: string | null;
                        /** @maxLength 1024 */
                        documentaryProof?: string | null;
                      }[];
                      type?: "default" | "kiosk";
                    };
                    battery?: number;
                    rssi?: number;
                    snr?: number;
                    /** @format date-time */
                    dateTime?: string;
                    /** @format date-time */
                    deviceDateTime?: string;
                    /** @format date-time */
                    gatewayDateTime?: string;
                    insideGpsZones?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    }[];
                    insideIpsZones?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    }[];
                    zone?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    };
                    callRequest?: boolean;
                    forceLoraCustomer?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    knnResult?: {
                      distance: number;
                      debugInfo?: any;
                    };
                    available?: boolean;
                  };
                  deltas?: {
                    main: {
                      /** @format date-time */
                      start: string;
                      /** @format date-time */
                      end: string;
                      value?: number;
                    };
                    steps?: {
                      gps?: {
                        /** @format date-time */
                        start: string;
                        /** @format date-time */
                        end: string;
                        value?: number;
                      };
                      ips?: {
                        /** @format date-time */
                        start: string;
                        /** @format date-time */
                        end: string;
                        value?: number;
                      };
                      context?: {
                        /** @format date-time */
                        start: string;
                        /** @format date-time */
                        end: string;
                        value?: number;
                      };
                    };
                  };
                  validPosition?: {
                    value: boolean;
                    /** @maxLength 1024 */
                    reason?: string;
                  };
                  isSystemEvent?: boolean;
                };
                /** PII */
                frozenInfo?: {
                  staticResponse: {
                    type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
                    priority: number;
                    zone?: {
                      /** @format uuid */
                      _id: string;
                      customer?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      };
                      type?:
                        | "default"
                        | "responseArea"
                        | "policeDepartment"
                        | "assetMonitoredArea"
                        | "fingerprinted"
                        | "building"
                        | "evacuationPoint";
                      /** PII */
                      location:
                        | {
                            type: "Point";
                            /** PII */
                            coordinates: number[];
                            properties: {
                              accuracy?: number;
                              heading?: number;
                              headingAccuracy?: number;
                              speed?: number;
                              speedAccuracy?: number;
                              altitude?: number;
                              altitudeAccuracy?: number;
                              /** PII */
                              address?: {
                                /** @maxLength 1024 */
                                countryCode?: string | null;
                                /** @maxLength 1024 */
                                state?: string | null;
                                /** @maxLength 1024 */
                                city?: string | null;
                                /** @maxLength 1024 */
                                streetName?: string | null;
                                /** @maxLength 1024 */
                                streetNumber?: string | null;
                                floor?: number | null;
                                /** @maxLength 1024 */
                                formattedAddress?: string;
                              };
                              /** @format date-time */
                              dateTime?: string;
                              /** @maxLength 1024 */
                              provider?: string;
                            };
                          }
                        | {
                            type: "Polygon";
                            /** PII */
                            coordinates: number[][][];
                            properties: {
                              accuracy?: number;
                              heading?: number;
                              headingAccuracy?: number;
                              speed?: number;
                              speedAccuracy?: number;
                              altitude?: number;
                              altitudeAccuracy?: number;
                              /** PII */
                              address?: {
                                /** @maxLength 1024 */
                                countryCode?: string | null;
                                /** @maxLength 1024 */
                                state?: string | null;
                                /** @maxLength 1024 */
                                city?: string | null;
                                /** @maxLength 1024 */
                                streetName?: string | null;
                                /** @maxLength 1024 */
                                streetNumber?: string | null;
                                floor?: number | null;
                                /** @maxLength 1024 */
                                formattedAddress?: string;
                              };
                              /** @format date-time */
                              dateTime?: string;
                              /** @maxLength 1024 */
                              provider?: string;
                            };
                          }
                        | {
                            type: "MultiPolygon";
                            coordinates: number[][][][];
                            properties: {
                              accuracy?: number;
                              heading?: number;
                              headingAccuracy?: number;
                              speed?: number;
                              speedAccuracy?: number;
                              altitude?: number;
                              altitudeAccuracy?: number;
                              /** PII */
                              address?: {
                                /** @maxLength 1024 */
                                countryCode?: string | null;
                                /** @maxLength 1024 */
                                state?: string | null;
                                /** @maxLength 1024 */
                                city?: string | null;
                                /** @maxLength 1024 */
                                streetName?: string | null;
                                /** @maxLength 1024 */
                                streetNumber?: string | null;
                                floor?: number | null;
                                /** @maxLength 1024 */
                                formattedAddress?: string;
                              };
                              /** @format date-time */
                              dateTime?: string;
                              /** @maxLength 1024 */
                              provider?: string;
                            };
                          };
                      /** @maxLength 1024 */
                      name: string;
                      staticResponders: {
                        staticResponder: {
                          /** @format uuid */
                          _id: string;
                          _ref: "StaticResponder";
                        };
                        priority: number;
                      }[];
                    };
                    responders: {
                      info: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Asset" | "StaticResponder";
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        name: string;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        image: string | null;
                        /** PII */
                        position: {
                          type: "Point";
                          /** PII */
                          coordinates: number[];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        };
                        /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                        locale: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        contactCode: string | null;
                      };
                      distanceKm: number | null;
                      actions: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        call: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        sms: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        email: string | null;
                        notification: boolean;
                      };
                      priority: number;
                      professionalResponder?: {
                        available: boolean;
                        inProgress: boolean;
                      };
                    }[];
                  }[];
                  dynamicResponse: {
                    type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
                    priority: number;
                    zone?: {
                      /** @format uuid */
                      _id: string;
                      customer?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      };
                      type?:
                        | "default"
                        | "responseArea"
                        | "policeDepartment"
                        | "assetMonitoredArea"
                        | "fingerprinted"
                        | "building"
                        | "evacuationPoint";
                      /** PII */
                      location:
                        | {
                            type: "Point";
                            /** PII */
                            coordinates: number[];
                            properties: {
                              accuracy?: number;
                              heading?: number;
                              headingAccuracy?: number;
                              speed?: number;
                              speedAccuracy?: number;
                              altitude?: number;
                              altitudeAccuracy?: number;
                              /** PII */
                              address?: {
                                /** @maxLength 1024 */
                                countryCode?: string | null;
                                /** @maxLength 1024 */
                                state?: string | null;
                                /** @maxLength 1024 */
                                city?: string | null;
                                /** @maxLength 1024 */
                                streetName?: string | null;
                                /** @maxLength 1024 */
                                streetNumber?: string | null;
                                floor?: number | null;
                                /** @maxLength 1024 */
                                formattedAddress?: string;
                              };
                              /** @format date-time */
                              dateTime?: string;
                              /** @maxLength 1024 */
                              provider?: string;
                            };
                          }
                        | {
                            type: "Polygon";
                            /** PII */
                            coordinates: number[][][];
                            properties: {
                              accuracy?: number;
                              heading?: number;
                              headingAccuracy?: number;
                              speed?: number;
                              speedAccuracy?: number;
                              altitude?: number;
                              altitudeAccuracy?: number;
                              /** PII */
                              address?: {
                                /** @maxLength 1024 */
                                countryCode?: string | null;
                                /** @maxLength 1024 */
                                state?: string | null;
                                /** @maxLength 1024 */
                                city?: string | null;
                                /** @maxLength 1024 */
                                streetName?: string | null;
                                /** @maxLength 1024 */
                                streetNumber?: string | null;
                                floor?: number | null;
                                /** @maxLength 1024 */
                                formattedAddress?: string;
                              };
                              /** @format date-time */
                              dateTime?: string;
                              /** @maxLength 1024 */
                              provider?: string;
                            };
                          }
                        | {
                            type: "MultiPolygon";
                            coordinates: number[][][][];
                            properties: {
                              accuracy?: number;
                              heading?: number;
                              headingAccuracy?: number;
                              speed?: number;
                              speedAccuracy?: number;
                              altitude?: number;
                              altitudeAccuracy?: number;
                              /** PII */
                              address?: {
                                /** @maxLength 1024 */
                                countryCode?: string | null;
                                /** @maxLength 1024 */
                                state?: string | null;
                                /** @maxLength 1024 */
                                city?: string | null;
                                /** @maxLength 1024 */
                                streetName?: string | null;
                                /** @maxLength 1024 */
                                streetNumber?: string | null;
                                floor?: number | null;
                                /** @maxLength 1024 */
                                formattedAddress?: string;
                              };
                              /** @format date-time */
                              dateTime?: string;
                              /** @maxLength 1024 */
                              provider?: string;
                            };
                          };
                      /** @maxLength 1024 */
                      name: string;
                      staticResponders: {
                        staticResponder: {
                          /** @format uuid */
                          _id: string;
                          _ref: "StaticResponder";
                        };
                        priority: number;
                      }[];
                    };
                    responders: {
                      info: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Asset" | "StaticResponder";
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        name: string;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        image: string | null;
                        /** PII */
                        position: {
                          type: "Point";
                          /** PII */
                          coordinates: number[];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        };
                        /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                        locale: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        contactCode: string | null;
                      };
                      distanceKm: number | null;
                      actions: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        call: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        sms: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        email: string | null;
                        notification: boolean;
                      };
                      priority: number;
                      professionalResponder?: {
                        available: boolean;
                        inProgress: boolean;
                      };
                    }[];
                  }[];
                  professionalResponders?: {
                    /** @format uuid */
                    _id: string;
                    /** @format date-time */
                    createdAt: string;
                    /** @format date-time */
                    updatedAt: string;
                    telluId?: number | null;
                    migrationFinalised?: boolean | null;
                    /** @format date-time */
                    migrationFinalisedDate?: string | null;
                    customer: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    /** @default {"type":"parents","extra":[]} */
                    share?: {
                      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                      extra?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      }[];
                    };
                    type: "sequrix";
                    active: boolean;
                    status:
                      | "invited"
                      | "accepted"
                      | "rejected"
                      | "started"
                      | "onLocation"
                      | "finished"
                      | "error"
                      | "canceled";
                    alarm: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Alarm";
                    };
                    asset: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset";
                    };
                    staticResponder: {
                      /** @format uuid */
                      _id: string;
                      /** @format date-time */
                      createdAt: string;
                      /** @format date-time */
                      updatedAt: string;
                      telluId?: number | null;
                      migrationFinalised?: boolean | null;
                      /** @format date-time */
                      migrationFinalisedDate?: string | null;
                      customer: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      };
                      /** @default {"type":"parents","extra":[]} */
                      share?: {
                        type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                        extra?: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Customer";
                        }[];
                      };
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      name: string;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      externalId: string | null;
                      contact: {
                        /**
                         * PII
                         * @pattern ^([\w+\-.]+@([\w-]+\.)+[\w-]{2,}[, ]*?)+?$
                         */
                        email: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        phone: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        sms: string | null;
                        /** @maxLength 1024 */
                        camera: string | null;
                      };
                      schedule: {
                        entries: {
                          daysOfWeek: number[];
                          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                          timeStart: string;
                          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                          timeEnd: string;
                        }[];
                      } | null;
                      /** @maxLength 1024 */
                      migrationKey?: string;
                      integrations?: {
                        sequrix: {
                          enabled: boolean;
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          objectCode: string;
                        };
                      };
                      /** PII */
                      statistics?: {
                        /**
                         * @maxItems 10
                         * @minItems 0
                         */
                        acceptSpeeds: {
                          /** @format date-time */
                          timestamp: string;
                          /**
                           * @min 0
                           * @exclusiveMin false
                           */
                          speedMs: number;
                        }[];
                        /**
                         * @maxItems 10
                         * @minItems 0
                         */
                        onLocationSpeeds: {
                          /** @format date-time */
                          timestamp: string;
                          /**
                           * @min 0
                           * @exclusiveMin false
                           */
                          speedMs: number;
                        }[];
                        /**
                         * @maxItems 10
                         * @minItems 0
                         */
                        finishSpeeds: {
                          /** @format date-time */
                          timestamp: string;
                          /**
                           * @min 0
                           * @exclusiveMin false
                           */
                          speedMs: number;
                        }[];
                        /**
                         * @min 0
                         * @exclusiveMin false
                         */
                        amountRejected: number;
                        /**
                         * @min 0
                         * @exclusiveMin false
                         */
                        amountAccepted: number;
                      };
                      _ref: "StaticResponder";
                    };
                    /** PII */
                    statistics: {
                      /** @format date-time */
                      invitedAt: string;
                      /** @format date-time */
                      acceptedAt: string | null;
                      /** @format date-time */
                      rejectedAt: string | null;
                      /** @format date-time */
                      startedAt: string | null;
                      /** @format date-time */
                      onLocationAt: string | null;
                      /** @format date-time */
                      finishedAt: string | null;
                    };
                    meta: {
                      /**
                       * PII
                       * @maxLength 4096
                       */
                      comment?: string;
                      /** PII */
                      photos?: {
                        /** @format date-time */
                        timestamp: string;
                        /** @maxLength 1024 */
                        url: string;
                      }[];
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      overridePhoneNumber?: string;
                    };
                    supersededBy: {
                      /** @format uuid */
                      _id: string;
                      _ref: "AlarmProfessionalResponder";
                    } | null;
                  }[];
                };
              };
            }[];
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/alarms`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a Alarm by id
     *
     * @tags Alarm
     * @name AlarmsControllerFindById
     * @request GET:/alarms/{id}
     * @secure
     */
    alarmsControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AlarmOutputDto, any>({
        path: `/alarms/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Alarm
     * @name AlarmsControllerAcknowledge
     * @request POST:/alarms/{id}/acknowledge
     * @secure
     */
    alarmsControllerAcknowledge: (
      id: string,
      data: AlarmAcknowledgeDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/alarms/${id}/acknowledge`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Alarm
     * @name AlarmsControllerPostAlarmEvent
     * @request POST:/alarms/{id}/alarm-events
     * @secure
     */
    alarmsControllerPostAlarmEvent: (
      id: string,
      data: AlarmEventCreateBase,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/alarms/${id}/alarm-events`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Paginates AlarmEvent
     *
     * @tags Alarm
     * @name AlarmsControllerPaginateAlarmEvents
     * @request GET:/alarms/{id}/alarm-events
     * @secure
     */
    alarmsControllerPaginateAlarmEvents: (
      id: string,
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            alarm: {
              /** @format uuid */
              _id: string;
              _ref: "Alarm";
            };
            user: {
              /** @format uuid */
              _id: string;
              /** @format date-time */
              createdAt: string;
              /** @format date-time */
              updatedAt: string;
              telluId?: number | null;
              migrationFinalised?: boolean | null;
              /** @format date-time */
              migrationFinalisedDate?: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              username: string;
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
              properties: {
                /**
                 * PII
                 * @maxLength 1024
                 */
                phoneNumber?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                smsNumber?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                email?: string | null;
                /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                locale?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                image?: string | null;
                /** PII */
                rSim?: {
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  euicc: string;
                  primary: {
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    msisdn: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    iccid: string;
                  };
                  secondary: {
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    msisdn: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    iccid: string;
                  };
                  enabled: boolean;
                } | null;
              };
              /** @default [] */
              globalRoles?: string[];
              /** @default [] */
              specialPermissions?: string[];
              isServiceAccount?: boolean;
              /**
               * PII
               * @format date-time
               */
              lastActiveAt?: string;
              type?: "default" | "serviceAccount" | "kiosk";
              userPolicies?: {
                disablePasswordlessLogin?: boolean;
              };
            };
            /**
             * PII
             * @maxLength 4096
             */
            text: string;
            type: "user" | "system" | "action" | "hidden";
            /** @maxLength 1024 */
            action: string;
            /** PII */
            meta?: Record<string, any>;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/alarms/${id}/alarm-events`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Alarm
     * @name AlarmsControllerPostHelper
     * @request POST:/alarms/{id}/alarm-helpers
     * @secure
     */
    alarmsControllerPostHelper: (
      id: string,
      data: AlarmHelperDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/alarms/${id}/alarm-helpers`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Alarm
     * @name AlarmsControllerPatchHelper
     * @request PATCH:/alarms/{id}/alarm-helpers
     * @secure
     */
    alarmsControllerPatchHelper: (
      id: string,
      data: AlarmHelperDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/alarms/${id}/alarm-helpers`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Alarm
     * @name AlarmsControllerPutHelper
     * @request PUT:/alarms/{id}/alarm-helpers
     * @secure
     */
    alarmsControllerPutHelper: (
      id: string,
      data: AlarmHelperPutDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/alarms/${id}/alarm-helpers`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Paginates AlarmHelper
     *
     * @tags Alarm
     * @name AlarmsControllerGetHelpers
     * @request GET:/alarms/{id}/alarm-helpers
     * @secure
     */
    alarmsControllerGetHelpers: (
      id: string,
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            telluId?: number | null;
            migrationFinalised?: boolean | null;
            /** @format date-time */
            migrationFinalisedDate?: string | null;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            asset: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
              customer: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              };
              user: {
                /** @format uuid */
                _id: string;
                _ref: "User";
              } | null;
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
              /**
               * PII
               * @maxLength 1024
               */
              externalId?: string | null;
              /** @default {} */
              properties?: {
                /**
                 * PII
                 * @maxLength 1024
                 */
                phoneNumber?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                smsNumber?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                email?: string | null;
                /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                locale?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                image?: string | null;
                /** PII */
                rSim?: {
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  euicc: string;
                  primary: {
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    msisdn: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    iccid: string;
                  };
                  secondary: {
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    msisdn: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    iccid: string;
                  };
                  enabled: boolean;
                } | null;
              };
              /**
               * PII
               * @default null
               */
              position?: {
                type: "Point";
                /** PII */
                coordinates: number[];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              };
              available: boolean;
              app?: {
                mode: "off" | "on" | "risk";
              } | null;
              insideZones: {
                /** @format uuid */
                _id: string;
                _ref: "Zone";
              }[];
              /** @default [] */
              staticResponders?: {
                staticResponder: {
                  /** @format uuid */
                  _id: string;
                  _ref: "StaticResponder";
                };
                priority: number;
              }[];
              type?: "default" | "kiosk";
              /** @format date-time */
              updatedAt: string;
              assetGroups?: {
                /** @format uuid */
                _id: string;
                _ref: "AssetGroup";
              }[];
            };
            alarm: {
              /** @format uuid */
              _id: string;
              _ref: "Alarm";
            };
            confirmedHelping: boolean | null;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/alarms/${id}/alarm-helpers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates AlarmLogEvent
     *
     * @tags Alarm
     * @name AlarmsControllerPaginateAlarmLogEvents
     * @request GET:/alarms/{id}/alarm-log-events
     * @secure
     */
    alarmsControllerPaginateAlarmLogEvents: (
      id: string,
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            alarm: {
              /** @format uuid */
              _id: string;
              _ref: "Alarm";
            };
            createdBy:
              | {
                  /** @format uuid */
                  _id: string;
                  _ref: "User";
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  name: string;
                  properties?: {
                    locale?: string | null;
                    /** PII */
                    image?: string | null;
                  };
                  isServiceAccount?: boolean;
                }
              | {
                  /** @format uuid */
                  _id: string;
                  _ref: "Asset";
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  name: string;
                  properties?: {
                    /** PII */
                    image?: string | null;
                  };
                };
            type: "user" | "system" | "action" | "hidden";
            data:
              | {
                  eventType: "chat";
                  /**
                   * PII
                   * @maxLength 4096
                   */
                  message: string;
                  /** @maxLength 1024 */
                  prefixDisplayName?: string;
                  asset?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Asset";
                  };
                }
              | {
                  eventType: "notification";
                  to: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Asset";
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    name: string;
                  };
                }
              | {
                  eventType: "manualNotify";
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  name: string;
                  suppressChatMessages?: boolean;
                }
              | {
                  eventType: "sms";
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  name: string;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  phone: string;
                }
              | {
                  eventType: "email";
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  name: string;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  email?: string;
                }
              | {
                  eventType: "actionCall";
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  name: string;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  phone: string;
                  targetAsset?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Asset";
                  };
                  targetUser?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "User";
                  };
                  kind:
                    | "initiated"
                    | "resultCancelled"
                    | "resultNotReachable"
                    | "resultNoResponse"
                    | "resultResponding";
                }
              | {
                  eventType: "actionCallStaticResponder";
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  name: string;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  phone: string;
                  targetAsset?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Asset";
                  };
                  targetUser?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "User";
                  };
                  kind:
                    | "initiated"
                    | "resultCancelled"
                    | "resultNotReachable"
                    | "resultNoResponse"
                    | "resultResponding";
                  staticResponder: {
                    /** @format uuid */
                    _id: string;
                    _ref: "StaticResponder";
                  };
                }
              | {
                  eventType: "callSession";
                  alarmCall: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AlarmCall";
                  } | null;
                  callType: "alarmCall" | "helperCall";
                  phase: "started" | "join" | "leave" | "ended";
                }
              | {
                  eventType: "responseConfirmation";
                  value?: boolean;
                  revision?: boolean;
                }
              | {
                  eventType: "protocol";
                  kind: "help" | "verification";
                }
              | {
                  eventType: "acknowledge";
                  /**
                   * PII
                   * @maxLength 4096
                   */
                  comment?: string;
                  /**
                   * PII
                   * @maxLength 4096
                   */
                  survey?: string;
                  /** @maxLength 1024 */
                  systemAck?: string;
                }
              | {
                  eventType: "alarmMerged";
                }
              | {
                  eventType: "alarmRepublished";
                }
              | {
                  eventType: "severityIncreased";
                  from: "red" | "orange" | "green";
                  to: "red" | "orange" | "green";
                }
              | {
                  eventType: "callMeta";
                  kind: "available";
                  /** @maxLength 1024 */
                  test?: string;
                }
              | {
                  eventType: "professionalResponder";
                  /** @maxLength 1024 */
                  responderName: string;
                  alarmProfessionalResponder: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AlarmProfessionalResponder";
                  };
                  details:
                    | {
                        kind: "note";
                        /**
                         * PII
                         * @maxLength 4096
                         */
                        note: string;
                        photoCount?: number;
                        photos?: {
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          url: string;
                          /** @format date-time */
                          timestamp: string;
                        }[];
                      }
                    | {
                        kind:
                          | "invited"
                          | "accepted"
                          | "canceled"
                          | "cancelFailed"
                          | "cancelRequested"
                          | "error"
                          | "finished"
                          | "onLocation"
                          | "rejected";
                      };
                };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/alarms/${id}/alarm-log-events`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates Alarm
     *
     * @tags Alarm
     * @name AlarmsControllerGetProfessionalResponders
     * @request GET:/alarms/{id}/alarm-professional-responders
     * @secure
     */
    alarmsControllerGetProfessionalResponders: (
      id: string,
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
            asset: {
              /** @format uuid */
              _id: string;
              /** @format date-time */
              createdAt: string;
              /** @format date-time */
              updatedAt: string;
              telluId?: number | null;
              migrationFinalised?: boolean | null;
              /** @format date-time */
              migrationFinalisedDate?: string | null;
              customer: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              };
              /** @default {"type":"parents","extra":[]} */
              share?: {
                type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                extra?: {
                  /** @format uuid */
                  _id: string;
                  _ref: "Customer";
                }[];
              };
              user: {
                /** @format uuid */
                _id: string;
                _ref: "User";
              } | null;
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
              /**
               * PII
               * @maxLength 1024
               */
              externalId?: string | null;
              propertiesOwnership?: "override" | "inherit";
              /** @default {} */
              properties?: {
                /**
                 * PII
                 * @maxLength 1024
                 */
                phoneNumber?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                smsNumber?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                email?: string | null;
                /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                locale?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                image?: string | null;
                /** PII */
                rSim?: {
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  euicc: string;
                  primary: {
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    msisdn: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    iccid: string;
                  };
                  secondary: {
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    msisdn: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    iccid: string;
                  };
                  enabled: boolean;
                } | null;
              };
              /**
               * PII
               * @default null
               */
              position?: {
                type: "Point";
                /** PII */
                coordinates: number[];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              };
              available: boolean;
              /** @default true */
              allowContactOnOwnAlarms?: boolean;
              app?: {
                mode: "off" | "on" | "risk";
              } | null;
              insideZones: {
                /** @format uuid */
                _id: string;
                _ref: "Zone";
              }[];
              assetGroups: {
                /** @format uuid */
                _id: string;
                _ref: "AssetGroup";
              }[];
              /** @default [] */
              staticResponders?: {
                staticResponder: {
                  /** @format uuid */
                  _id: string;
                  _ref: "StaticResponder";
                };
                priority: number;
              }[];
              /** @format date-time */
              lastObservationAt?: string;
              /** @default false */
              invisibleResponder?: boolean;
              /**
               * PII
               * @maxLength 4096
               */
              description?: string;
              /** @default [] */
              certifications?: {
                /** @format uuid */
                _id: string;
                certificationCategory: {
                  /** @format uuid */
                  _id: string;
                  _ref: "CertificationCategory";
                };
                /** @format date-time */
                firstIssuedOn: string;
                /** @format date-time */
                lastReceivedOn: string;
                /** @format date-time */
                expiryDate: string;
                /**
                 * @format date-time
                 * @default null
                 */
                plannedRenewalDate?: string | null;
                /** @maxLength 1024 */
                documentaryProof?: string | null;
              }[];
              type?: "default" | "kiosk";
            };
            ack: {
              needed: boolean;
              value: boolean;
              ackedBy: {
                /** @format uuid */
                _id: string;
                _ref: "User";
                /**
                 * PII
                 * @maxLength 1024
                 */
                name: string;
              } | null;
              /**
               * PII
               * @maxLength 1024
               */
              comment: string | null;
              /** @format date-time */
              ackedAt: string | null;
            };
            /** PII */
            position: {
              type: "Point";
              /** PII */
              coordinates: number[];
              properties: {
                accuracy?: number;
                heading?: number;
                headingAccuracy?: number;
                speed?: number;
                speedAccuracy?: number;
                altitude?: number;
                altitudeAccuracy?: number;
                /** PII */
                address?: {
                  /** @maxLength 1024 */
                  countryCode?: string | null;
                  /** @maxLength 1024 */
                  state?: string | null;
                  /** @maxLength 1024 */
                  city?: string | null;
                  /** @maxLength 1024 */
                  streetName?: string | null;
                  /** @maxLength 1024 */
                  streetNumber?: string | null;
                  floor?: number | null;
                  /** @maxLength 1024 */
                  formattedAddress?: string;
                };
                /** @format date-time */
                dateTime?: string;
                /** @maxLength 1024 */
                provider?: string;
              };
            };
            severity: "red" | "orange" | "green";
            /**
             * PII
             * @maxLength 4096
             */
            procedure: string | null;
            meta?: {
              observationTrigger?: {
                /** @format uuid */
                _id: string;
                /** @format date-time */
                createdAt: string;
                /** @format date-time */
                updatedAt: string;
                telluId?: number | null;
                migrationFinalised?: boolean | null;
                /** @format date-time */
                migrationFinalisedDate?: string | null;
                customer: {
                  /** @format uuid */
                  _id: string;
                  _ref: "Customer";
                };
                /** @default {"type":"parents","extra":[]} */
                share?: {
                  type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                  extra?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  }[];
                };
                /** @maxLength 1024 */
                name: string;
                eventCodes: string[];
                /** @maxLength 1024 */
                description: string;
                status: "active" | "inactive";
                actions: (
                  | {
                      type: "alarm";
                      config: {
                        severity: "red" | "orange" | "green";
                        type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
                        /** @maxLength 4096 */
                        procedure: string | null;
                        /** @maxLength 1024 */
                        name: string;
                      };
                    }
                  | {
                      type: "sms";
                      config: {
                        /** PII */
                        toRaw: string[];
                        toContactList: {
                          /** @format uuid */
                          _id: string;
                          _ref: "ContactList";
                        }[];
                        toTriggerUser: boolean;
                        /** @maxLength 1024 */
                        message: string;
                      };
                    }
                  | {
                      type: "email";
                      config: {
                        /** PII */
                        toRaw: string[];
                        toContactList: {
                          /** @format uuid */
                          _id: string;
                          _ref: "ContactList";
                        }[];
                        toTriggerUser: boolean;
                        /** @maxLength 1024 */
                        message: string;
                        /** @maxLength 1024 */
                        subject: string;
                        /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                        locale?: string;
                      };
                    }
                  | {
                      type: "assetUpdate";
                      config: {
                        available?: boolean;
                        app?: {
                          mode: "off" | "on" | "risk";
                        };
                      };
                    }
                )[];
                filter:
                  | {
                      type: "operator/and";
                      operands: (
                        | {
                            type: "operator/or";
                            operands: (
                              | {
                                  type: "operator/not";
                                  operand:
                                    | {
                                        type: "constraint/asset";
                                        assets: {
                                          /** @format uuid */
                                          _id: string;
                                          _ref: "Asset";
                                        }[];
                                      }
                                    | {
                                        type: "constraint/assetGroup";
                                        groups: {
                                          /** @format uuid */
                                          _id: string;
                                          _ref: "AssetGroup";
                                        }[];
                                      }
                                    | {
                                        type: "constraint/zone";
                                        zone: {
                                          /** @format uuid */
                                          _id: string;
                                          _ref: "Zone";
                                        };
                                      }
                                    | {
                                        type: "constraint/schedule";
                                        schedule: {
                                          entries: {
                                            daysOfWeek: number[];
                                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                            timeStart: string;
                                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                            timeEnd: string;
                                          }[];
                                        };
                                      };
                                }
                              | {
                                  type: "constraint/asset";
                                  assets: {
                                    /** @format uuid */
                                    _id: string;
                                    _ref: "Asset";
                                  }[];
                                }
                              | {
                                  type: "constraint/assetGroup";
                                  groups: {
                                    /** @format uuid */
                                    _id: string;
                                    _ref: "AssetGroup";
                                  }[];
                                }
                              | {
                                  type: "constraint/zone";
                                  zone: {
                                    /** @format uuid */
                                    _id: string;
                                    _ref: "Zone";
                                  };
                                }
                              | {
                                  type: "constraint/schedule";
                                  schedule: {
                                    entries: {
                                      daysOfWeek: number[];
                                      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                      timeStart: string;
                                      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                      timeEnd: string;
                                    }[];
                                  };
                                }
                            )[];
                          }
                        | {
                            type: "constraint/asset";
                            assets: {
                              /** @format uuid */
                              _id: string;
                              _ref: "Asset";
                            }[];
                          }
                        | {
                            type: "constraint/assetGroup";
                            groups: {
                              /** @format uuid */
                              _id: string;
                              _ref: "AssetGroup";
                            }[];
                          }
                        | {
                            type: "constraint/zone";
                            zone: {
                              /** @format uuid */
                              _id: string;
                              _ref: "Zone";
                            };
                          }
                        | {
                            type: "constraint/schedule";
                            schedule: {
                              entries: {
                                daysOfWeek: number[];
                                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                timeStart: string;
                                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                timeEnd: string;
                              }[];
                            };
                          }
                      )[];
                    }
                  | {
                      type: "constraint/asset";
                      assets: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Asset";
                      }[];
                    }
                  | {
                      type: "constraint/assetGroup";
                      groups: {
                        /** @format uuid */
                        _id: string;
                        _ref: "AssetGroup";
                      }[];
                    }
                  | {
                      type: "constraint/zone";
                      zone: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Zone";
                      };
                    }
                  | {
                      type: "constraint/schedule";
                      schedule: {
                        entries: {
                          daysOfWeek: number[];
                          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                          timeStart: string;
                          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                          timeEnd: string;
                        }[];
                      };
                    };
              };
              /** PII */
              observation?: {
                /** @format uuid */
                _id: string;
                /** @maxLength 1024 */
                event: string;
                asset: {
                  /** @format uuid */
                  _id: string;
                  /** @format date-time */
                  createdAt: string;
                  /** @format date-time */
                  updatedAt: string;
                  telluId?: number | null;
                  migrationFinalised?: boolean | null;
                  /** @format date-time */
                  migrationFinalisedDate?: string | null;
                  customer: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  };
                  /** @default {"type":"parents","extra":[]} */
                  share?: {
                    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                    extra?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    }[];
                  };
                  user: {
                    /** @format uuid */
                    _id: string;
                    _ref: "User";
                  } | null;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  name: string;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  externalId?: string | null;
                  propertiesOwnership?: "override" | "inherit";
                  /** @default {} */
                  properties?: {
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    phoneNumber?: string | null;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    smsNumber?: string | null;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    email?: string | null;
                    /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                    locale?: string | null;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    image?: string | null;
                    /** PII */
                    rSim?: {
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      euicc: string;
                      primary: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        msisdn: string;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        iccid: string;
                      };
                      secondary: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        msisdn: string;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        iccid: string;
                      };
                      enabled: boolean;
                    } | null;
                  };
                  /**
                   * PII
                   * @default null
                   */
                  position?: {
                    type: "Point";
                    /** PII */
                    coordinates: number[];
                    properties: {
                      accuracy?: number;
                      heading?: number;
                      headingAccuracy?: number;
                      speed?: number;
                      speedAccuracy?: number;
                      altitude?: number;
                      altitudeAccuracy?: number;
                      /** PII */
                      address?: {
                        /** @maxLength 1024 */
                        countryCode?: string | null;
                        /** @maxLength 1024 */
                        state?: string | null;
                        /** @maxLength 1024 */
                        city?: string | null;
                        /** @maxLength 1024 */
                        streetName?: string | null;
                        /** @maxLength 1024 */
                        streetNumber?: string | null;
                        floor?: number | null;
                        /** @maxLength 1024 */
                        formattedAddress?: string;
                      };
                      /** @format date-time */
                      dateTime?: string;
                      /** @maxLength 1024 */
                      provider?: string;
                    };
                  };
                  available: boolean;
                  /** @default true */
                  allowContactOnOwnAlarms?: boolean;
                  app?: {
                    mode: "off" | "on" | "risk";
                  } | null;
                  insideZones: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Zone";
                  }[];
                  assetGroups: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[];
                  /** @default [] */
                  staticResponders?: {
                    staticResponder: {
                      /** @format uuid */
                      _id: string;
                      _ref: "StaticResponder";
                    };
                    priority: number;
                  }[];
                  /** @format date-time */
                  lastObservationAt?: string;
                  /** @default false */
                  invisibleResponder?: boolean;
                  /**
                   * PII
                   * @maxLength 4096
                   */
                  description?: string;
                  /** @default [] */
                  certifications?: {
                    /** @format uuid */
                    _id: string;
                    certificationCategory: {
                      /** @format uuid */
                      _id: string;
                      _ref: "CertificationCategory";
                    };
                    /** @format date-time */
                    firstIssuedOn: string;
                    /** @format date-time */
                    lastReceivedOn: string;
                    /** @format date-time */
                    expiryDate: string;
                    /**
                     * @format date-time
                     * @default null
                     */
                    plannedRenewalDate?: string | null;
                    /** @maxLength 1024 */
                    documentaryProof?: string | null;
                  }[];
                  type?: "default" | "kiosk";
                  _ref: "Asset";
                };
                customer: {
                  /** @format uuid */
                  _id: string;
                  _ref: "Customer";
                };
                device: {
                  /** @format uuid */
                  _id: string;
                  _ref: "Device";
                };
                user: {
                  /** @format uuid */
                  _id: string;
                  _ref: "User";
                };
                /** PII */
                position?: {
                  type: "Point";
                  /** PII */
                  coordinates: number[];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                };
                beacons?:
                  | {
                      /** @maxLength 1024 */
                      code: string;
                      rssi: number;
                      battery?: number;
                      /** @format date-time */
                      dateTime: string;
                      beacon: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Beacon";
                      } | null;
                      calc: number | null;
                      valid: boolean;
                    }[]
                  | {
                      /** @maxLength 1024 */
                      code: string;
                      rssi: number;
                      battery?: number;
                      /** @format date-time */
                      dateTime: string;
                    }[];
                /** PII */
                meta?: {
                  asset?: {
                    /** @format uuid */
                    _id: string;
                    /** @format date-time */
                    createdAt: string;
                    /** @format date-time */
                    updatedAt: string;
                    telluId?: number | null;
                    migrationFinalised?: boolean | null;
                    /** @format date-time */
                    migrationFinalisedDate?: string | null;
                    customer: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    /** @default {"type":"parents","extra":[]} */
                    share?: {
                      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                      extra?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      }[];
                    };
                    user: {
                      /** @format uuid */
                      _id: string;
                      _ref: "User";
                    } | null;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    name: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    externalId?: string | null;
                    propertiesOwnership?: "override" | "inherit";
                    /** @default {} */
                    properties?: {
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      phoneNumber?: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      smsNumber?: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      email?: string | null;
                      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                      locale?: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      image?: string | null;
                      /** PII */
                      rSim?: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        euicc: string;
                        primary: {
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          msisdn: string;
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          iccid: string;
                        };
                        secondary: {
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          msisdn: string;
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          iccid: string;
                        };
                        enabled: boolean;
                      } | null;
                    };
                    /**
                     * PII
                     * @default null
                     */
                    position?: {
                      type: "Point";
                      /** PII */
                      coordinates: number[];
                      properties: {
                        accuracy?: number;
                        heading?: number;
                        headingAccuracy?: number;
                        speed?: number;
                        speedAccuracy?: number;
                        altitude?: number;
                        altitudeAccuracy?: number;
                        /** PII */
                        address?: {
                          /** @maxLength 1024 */
                          countryCode?: string | null;
                          /** @maxLength 1024 */
                          state?: string | null;
                          /** @maxLength 1024 */
                          city?: string | null;
                          /** @maxLength 1024 */
                          streetName?: string | null;
                          /** @maxLength 1024 */
                          streetNumber?: string | null;
                          floor?: number | null;
                          /** @maxLength 1024 */
                          formattedAddress?: string;
                        };
                        /** @format date-time */
                        dateTime?: string;
                        /** @maxLength 1024 */
                        provider?: string;
                      };
                    };
                    available: boolean;
                    /** @default true */
                    allowContactOnOwnAlarms?: boolean;
                    app?: {
                      mode: "off" | "on" | "risk";
                    } | null;
                    insideZones: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    }[];
                    assetGroups: {
                      /** @format uuid */
                      _id: string;
                      _ref: "AssetGroup";
                    }[];
                    /** @default [] */
                    staticResponders?: {
                      staticResponder: {
                        /** @format uuid */
                        _id: string;
                        _ref: "StaticResponder";
                      };
                      priority: number;
                    }[];
                    /** @format date-time */
                    lastObservationAt?: string;
                    /** @default false */
                    invisibleResponder?: boolean;
                    /**
                     * PII
                     * @maxLength 4096
                     */
                    description?: string;
                    /** @default [] */
                    certifications?: {
                      /** @format uuid */
                      _id: string;
                      certificationCategory: {
                        /** @format uuid */
                        _id: string;
                        _ref: "CertificationCategory";
                      };
                      /** @format date-time */
                      firstIssuedOn: string;
                      /** @format date-time */
                      lastReceivedOn: string;
                      /** @format date-time */
                      expiryDate: string;
                      /**
                       * @format date-time
                       * @default null
                       */
                      plannedRenewalDate?: string | null;
                      /** @maxLength 1024 */
                      documentaryProof?: string | null;
                    }[];
                    type?: "default" | "kiosk";
                  };
                  battery?: number;
                  rssi?: number;
                  snr?: number;
                  /** @format date-time */
                  dateTime?: string;
                  /** @format date-time */
                  deviceDateTime?: string;
                  /** @format date-time */
                  gatewayDateTime?: string;
                  insideGpsZones?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Zone";
                  }[];
                  insideIpsZones?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Zone";
                  }[];
                  zone?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Zone";
                  };
                  callRequest?: boolean;
                  forceLoraCustomer?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  };
                  knnResult?: {
                    distance: number;
                    debugInfo?: any;
                  };
                  available?: boolean;
                };
                deltas?: {
                  main: {
                    /** @format date-time */
                    start: string;
                    /** @format date-time */
                    end: string;
                    value?: number;
                  };
                  steps?: {
                    gps?: {
                      /** @format date-time */
                      start: string;
                      /** @format date-time */
                      end: string;
                      value?: number;
                    };
                    ips?: {
                      /** @format date-time */
                      start: string;
                      /** @format date-time */
                      end: string;
                      value?: number;
                    };
                    context?: {
                      /** @format date-time */
                      start: string;
                      /** @format date-time */
                      end: string;
                      value?: number;
                    };
                  };
                };
                validPosition?: {
                  value: boolean;
                  /** @maxLength 1024 */
                  reason?: string;
                };
                isSystemEvent?: boolean;
              };
              /** PII */
              frozenInfo?: {
                staticResponse: {
                  type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
                  priority: number;
                  zone?: {
                    /** @format uuid */
                    _id: string;
                    customer?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    type?:
                      | "default"
                      | "responseArea"
                      | "policeDepartment"
                      | "assetMonitoredArea"
                      | "fingerprinted"
                      | "building"
                      | "evacuationPoint";
                    /** PII */
                    location:
                      | {
                          type: "Point";
                          /** PII */
                          coordinates: number[];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        }
                      | {
                          type: "Polygon";
                          /** PII */
                          coordinates: number[][][];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        }
                      | {
                          type: "MultiPolygon";
                          coordinates: number[][][][];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        };
                    /** @maxLength 1024 */
                    name: string;
                    staticResponders: {
                      staticResponder: {
                        /** @format uuid */
                        _id: string;
                        _ref: "StaticResponder";
                      };
                      priority: number;
                    }[];
                  };
                  responders: {
                    info: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset" | "StaticResponder";
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      name: string;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      image: string | null;
                      /** PII */
                      position: {
                        type: "Point";
                        /** PII */
                        coordinates: number[];
                        properties: {
                          accuracy?: number;
                          heading?: number;
                          headingAccuracy?: number;
                          speed?: number;
                          speedAccuracy?: number;
                          altitude?: number;
                          altitudeAccuracy?: number;
                          /** PII */
                          address?: {
                            /** @maxLength 1024 */
                            countryCode?: string | null;
                            /** @maxLength 1024 */
                            state?: string | null;
                            /** @maxLength 1024 */
                            city?: string | null;
                            /** @maxLength 1024 */
                            streetName?: string | null;
                            /** @maxLength 1024 */
                            streetNumber?: string | null;
                            floor?: number | null;
                            /** @maxLength 1024 */
                            formattedAddress?: string;
                          };
                          /** @format date-time */
                          dateTime?: string;
                          /** @maxLength 1024 */
                          provider?: string;
                        };
                      };
                      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                      locale: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      contactCode: string | null;
                    };
                    distanceKm: number | null;
                    actions: {
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      call: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      sms: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      email: string | null;
                      notification: boolean;
                    };
                    priority: number;
                    professionalResponder?: {
                      available: boolean;
                      inProgress: boolean;
                    };
                  }[];
                }[];
                dynamicResponse: {
                  type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
                  priority: number;
                  zone?: {
                    /** @format uuid */
                    _id: string;
                    customer?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    type?:
                      | "default"
                      | "responseArea"
                      | "policeDepartment"
                      | "assetMonitoredArea"
                      | "fingerprinted"
                      | "building"
                      | "evacuationPoint";
                    /** PII */
                    location:
                      | {
                          type: "Point";
                          /** PII */
                          coordinates: number[];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        }
                      | {
                          type: "Polygon";
                          /** PII */
                          coordinates: number[][][];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        }
                      | {
                          type: "MultiPolygon";
                          coordinates: number[][][][];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        };
                    /** @maxLength 1024 */
                    name: string;
                    staticResponders: {
                      staticResponder: {
                        /** @format uuid */
                        _id: string;
                        _ref: "StaticResponder";
                      };
                      priority: number;
                    }[];
                  };
                  responders: {
                    info: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset" | "StaticResponder";
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      name: string;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      image: string | null;
                      /** PII */
                      position: {
                        type: "Point";
                        /** PII */
                        coordinates: number[];
                        properties: {
                          accuracy?: number;
                          heading?: number;
                          headingAccuracy?: number;
                          speed?: number;
                          speedAccuracy?: number;
                          altitude?: number;
                          altitudeAccuracy?: number;
                          /** PII */
                          address?: {
                            /** @maxLength 1024 */
                            countryCode?: string | null;
                            /** @maxLength 1024 */
                            state?: string | null;
                            /** @maxLength 1024 */
                            city?: string | null;
                            /** @maxLength 1024 */
                            streetName?: string | null;
                            /** @maxLength 1024 */
                            streetNumber?: string | null;
                            floor?: number | null;
                            /** @maxLength 1024 */
                            formattedAddress?: string;
                          };
                          /** @format date-time */
                          dateTime?: string;
                          /** @maxLength 1024 */
                          provider?: string;
                        };
                      };
                      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                      locale: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      contactCode: string | null;
                    };
                    distanceKm: number | null;
                    actions: {
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      call: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      sms: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      email: string | null;
                      notification: boolean;
                    };
                    priority: number;
                    professionalResponder?: {
                      available: boolean;
                      inProgress: boolean;
                    };
                  }[];
                }[];
                professionalResponders?: {
                  /** @format uuid */
                  _id: string;
                  /** @format date-time */
                  createdAt: string;
                  /** @format date-time */
                  updatedAt: string;
                  telluId?: number | null;
                  migrationFinalised?: boolean | null;
                  /** @format date-time */
                  migrationFinalisedDate?: string | null;
                  customer: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  };
                  /** @default {"type":"parents","extra":[]} */
                  share?: {
                    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                    extra?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    }[];
                  };
                  type: "sequrix";
                  active: boolean;
                  status:
                    | "invited"
                    | "accepted"
                    | "rejected"
                    | "started"
                    | "onLocation"
                    | "finished"
                    | "error"
                    | "canceled";
                  alarm: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Alarm";
                  };
                  asset: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Asset";
                  };
                  staticResponder: {
                    /** @format uuid */
                    _id: string;
                    /** @format date-time */
                    createdAt: string;
                    /** @format date-time */
                    updatedAt: string;
                    telluId?: number | null;
                    migrationFinalised?: boolean | null;
                    /** @format date-time */
                    migrationFinalisedDate?: string | null;
                    customer: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    /** @default {"type":"parents","extra":[]} */
                    share?: {
                      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                      extra?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      }[];
                    };
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    name: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    externalId: string | null;
                    contact: {
                      /**
                       * PII
                       * @pattern ^([\w+\-.]+@([\w-]+\.)+[\w-]{2,}[, ]*?)+?$
                       */
                      email: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      phone: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      sms: string | null;
                      /** @maxLength 1024 */
                      camera: string | null;
                    };
                    schedule: {
                      entries: {
                        daysOfWeek: number[];
                        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                        timeStart: string;
                        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                        timeEnd: string;
                      }[];
                    } | null;
                    /** @maxLength 1024 */
                    migrationKey?: string;
                    integrations?: {
                      sequrix: {
                        enabled: boolean;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        objectCode: string;
                      };
                    };
                    /** PII */
                    statistics?: {
                      /**
                       * @maxItems 10
                       * @minItems 0
                       */
                      acceptSpeeds: {
                        /** @format date-time */
                        timestamp: string;
                        /**
                         * @min 0
                         * @exclusiveMin false
                         */
                        speedMs: number;
                      }[];
                      /**
                       * @maxItems 10
                       * @minItems 0
                       */
                      onLocationSpeeds: {
                        /** @format date-time */
                        timestamp: string;
                        /**
                         * @min 0
                         * @exclusiveMin false
                         */
                        speedMs: number;
                      }[];
                      /**
                       * @maxItems 10
                       * @minItems 0
                       */
                      finishSpeeds: {
                        /** @format date-time */
                        timestamp: string;
                        /**
                         * @min 0
                         * @exclusiveMin false
                         */
                        speedMs: number;
                      }[];
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      amountRejected: number;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      amountAccepted: number;
                    };
                    _ref: "StaticResponder";
                  };
                  /** PII */
                  statistics: {
                    /** @format date-time */
                    invitedAt: string;
                    /** @format date-time */
                    acceptedAt: string | null;
                    /** @format date-time */
                    rejectedAt: string | null;
                    /** @format date-time */
                    startedAt: string | null;
                    /** @format date-time */
                    onLocationAt: string | null;
                    /** @format date-time */
                    finishedAt: string | null;
                  };
                  meta: {
                    /**
                     * PII
                     * @maxLength 4096
                     */
                    comment?: string;
                    /** PII */
                    photos?: {
                      /** @format date-time */
                      timestamp: string;
                      /** @maxLength 1024 */
                      url: string;
                    }[];
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    overridePhoneNumber?: string;
                  };
                  supersededBy: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AlarmProfessionalResponder";
                  } | null;
                }[];
              };
            };
            alarmCenter: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
            } | null;
            /** @format date-time */
            lastMergedAt?: string;
            /** @format date-time */
            lastPublishedToStreamAt?: string;
            /** PII */
            mergeHistory?: {
              /** @format uuid */
              _id: string;
              /** @maxLength 1024 */
              name: string;
              /** @format date-time */
              createdAt: string;
              /** PII */
              position: {
                type: "Point";
                /** PII */
                coordinates: number[];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              };
              meta?: {
                observationTrigger?: {
                  /** @format uuid */
                  _id: string;
                  /** @format date-time */
                  createdAt: string;
                  /** @format date-time */
                  updatedAt: string;
                  telluId?: number | null;
                  migrationFinalised?: boolean | null;
                  /** @format date-time */
                  migrationFinalisedDate?: string | null;
                  customer: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  };
                  /** @default {"type":"parents","extra":[]} */
                  share?: {
                    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                    extra?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    }[];
                  };
                  /** @maxLength 1024 */
                  name: string;
                  eventCodes: string[];
                  /** @maxLength 1024 */
                  description: string;
                  status: "active" | "inactive";
                  actions: (
                    | {
                        type: "alarm";
                        config: {
                          severity: "red" | "orange" | "green";
                          type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
                          /** @maxLength 4096 */
                          procedure: string | null;
                          /** @maxLength 1024 */
                          name: string;
                        };
                      }
                    | {
                        type: "sms";
                        config: {
                          /** PII */
                          toRaw: string[];
                          toContactList: {
                            /** @format uuid */
                            _id: string;
                            _ref: "ContactList";
                          }[];
                          toTriggerUser: boolean;
                          /** @maxLength 1024 */
                          message: string;
                        };
                      }
                    | {
                        type: "email";
                        config: {
                          /** PII */
                          toRaw: string[];
                          toContactList: {
                            /** @format uuid */
                            _id: string;
                            _ref: "ContactList";
                          }[];
                          toTriggerUser: boolean;
                          /** @maxLength 1024 */
                          message: string;
                          /** @maxLength 1024 */
                          subject: string;
                          /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                          locale?: string;
                        };
                      }
                    | {
                        type: "assetUpdate";
                        config: {
                          available?: boolean;
                          app?: {
                            mode: "off" | "on" | "risk";
                          };
                        };
                      }
                  )[];
                  filter:
                    | {
                        type: "constraint/asset";
                        assets: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Asset";
                        }[];
                      }
                    | {
                        type: "constraint/assetGroup";
                        groups: {
                          /** @format uuid */
                          _id: string;
                          _ref: "AssetGroup";
                        }[];
                      }
                    | {
                        type: "constraint/zone";
                        zone: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Zone";
                        };
                      }
                    | {
                        type: "constraint/schedule";
                        schedule: {
                          entries: {
                            daysOfWeek: number[];
                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                            timeStart: string;
                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                            timeEnd: string;
                          }[];
                        };
                      };
                };
                /** PII */
                observation?: {
                  /** @format uuid */
                  _id: string;
                  /** @maxLength 1024 */
                  event: string;
                  asset: {
                    /** @format uuid */
                    _id: string;
                    /** @format date-time */
                    createdAt: string;
                    /** @format date-time */
                    updatedAt: string;
                    telluId?: number | null;
                    migrationFinalised?: boolean | null;
                    /** @format date-time */
                    migrationFinalisedDate?: string | null;
                    customer: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    /** @default {"type":"parents","extra":[]} */
                    share?: {
                      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                      extra?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      }[];
                    };
                    user: {
                      /** @format uuid */
                      _id: string;
                      _ref: "User";
                    } | null;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    name: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    externalId?: string | null;
                    propertiesOwnership?: "override" | "inherit";
                    /** @default {} */
                    properties?: {
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      phoneNumber?: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      smsNumber?: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      email?: string | null;
                      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                      locale?: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      image?: string | null;
                      /** PII */
                      rSim?: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        euicc: string;
                        primary: {
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          msisdn: string;
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          iccid: string;
                        };
                        secondary: {
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          msisdn: string;
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          iccid: string;
                        };
                        enabled: boolean;
                      } | null;
                    };
                    /**
                     * PII
                     * @default null
                     */
                    position?: {
                      type: "Point";
                      /** PII */
                      coordinates: number[];
                      properties: {
                        accuracy?: number;
                        heading?: number;
                        headingAccuracy?: number;
                        speed?: number;
                        speedAccuracy?: number;
                        altitude?: number;
                        altitudeAccuracy?: number;
                        /** PII */
                        address?: {
                          /** @maxLength 1024 */
                          countryCode?: string | null;
                          /** @maxLength 1024 */
                          state?: string | null;
                          /** @maxLength 1024 */
                          city?: string | null;
                          /** @maxLength 1024 */
                          streetName?: string | null;
                          /** @maxLength 1024 */
                          streetNumber?: string | null;
                          floor?: number | null;
                          /** @maxLength 1024 */
                          formattedAddress?: string;
                        };
                        /** @format date-time */
                        dateTime?: string;
                        /** @maxLength 1024 */
                        provider?: string;
                      };
                    };
                    available: boolean;
                    /** @default true */
                    allowContactOnOwnAlarms?: boolean;
                    app?: {
                      mode: "off" | "on" | "risk";
                    } | null;
                    insideZones: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    }[];
                    assetGroups: {
                      /** @format uuid */
                      _id: string;
                      _ref: "AssetGroup";
                    }[];
                    /** @default [] */
                    staticResponders?: {
                      staticResponder: {
                        /** @format uuid */
                        _id: string;
                        _ref: "StaticResponder";
                      };
                      priority: number;
                    }[];
                    /** @format date-time */
                    lastObservationAt?: string;
                    /** @default false */
                    invisibleResponder?: boolean;
                    /**
                     * PII
                     * @maxLength 4096
                     */
                    description?: string;
                    /** @default [] */
                    certifications?: {
                      /** @format uuid */
                      _id: string;
                      certificationCategory: {
                        /** @format uuid */
                        _id: string;
                        _ref: "CertificationCategory";
                      };
                      /** @format date-time */
                      firstIssuedOn: string;
                      /** @format date-time */
                      lastReceivedOn: string;
                      /** @format date-time */
                      expiryDate: string;
                      /**
                       * @format date-time
                       * @default null
                       */
                      plannedRenewalDate?: string | null;
                      /** @maxLength 1024 */
                      documentaryProof?: string | null;
                    }[];
                    type?: "default" | "kiosk";
                    _ref: "Asset";
                  };
                  customer: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  };
                  device: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Device";
                  };
                  user: {
                    /** @format uuid */
                    _id: string;
                    _ref: "User";
                  };
                  /** PII */
                  position?: {
                    type: "Point";
                    /** PII */
                    coordinates: number[];
                    properties: {
                      accuracy?: number;
                      heading?: number;
                      headingAccuracy?: number;
                      speed?: number;
                      speedAccuracy?: number;
                      altitude?: number;
                      altitudeAccuracy?: number;
                      /** PII */
                      address?: {
                        /** @maxLength 1024 */
                        countryCode?: string | null;
                        /** @maxLength 1024 */
                        state?: string | null;
                        /** @maxLength 1024 */
                        city?: string | null;
                        /** @maxLength 1024 */
                        streetName?: string | null;
                        /** @maxLength 1024 */
                        streetNumber?: string | null;
                        floor?: number | null;
                        /** @maxLength 1024 */
                        formattedAddress?: string;
                      };
                      /** @format date-time */
                      dateTime?: string;
                      /** @maxLength 1024 */
                      provider?: string;
                    };
                  };
                  beacons?:
                    | {
                        /** @maxLength 1024 */
                        code: string;
                        rssi: number;
                        battery?: number;
                        /** @format date-time */
                        dateTime: string;
                        beacon: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Beacon";
                        } | null;
                        calc: number | null;
                        valid: boolean;
                      }[]
                    | {
                        /** @maxLength 1024 */
                        code: string;
                        rssi: number;
                        battery?: number;
                        /** @format date-time */
                        dateTime: string;
                      }[];
                  /** PII */
                  meta?: {
                    asset?: {
                      /** @format uuid */
                      _id: string;
                      /** @format date-time */
                      createdAt: string;
                      /** @format date-time */
                      updatedAt: string;
                      telluId?: number | null;
                      migrationFinalised?: boolean | null;
                      /** @format date-time */
                      migrationFinalisedDate?: string | null;
                      customer: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      };
                      /** @default {"type":"parents","extra":[]} */
                      share?: {
                        type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                        extra?: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Customer";
                        }[];
                      };
                      user: {
                        /** @format uuid */
                        _id: string;
                        _ref: "User";
                      } | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      name: string;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      externalId?: string | null;
                      propertiesOwnership?: "override" | "inherit";
                      /** @default {} */
                      properties?: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        phoneNumber?: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        smsNumber?: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        email?: string | null;
                        /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                        locale?: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        image?: string | null;
                        /** PII */
                        rSim?: {
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          euicc: string;
                          primary: {
                            /**
                             * PII
                             * @maxLength 1024
                             */
                            msisdn: string;
                            /**
                             * PII
                             * @maxLength 1024
                             */
                            iccid: string;
                          };
                          secondary: {
                            /**
                             * PII
                             * @maxLength 1024
                             */
                            msisdn: string;
                            /**
                             * PII
                             * @maxLength 1024
                             */
                            iccid: string;
                          };
                          enabled: boolean;
                        } | null;
                      };
                      /**
                       * PII
                       * @default null
                       */
                      position?: {
                        type: "Point";
                        /** PII */
                        coordinates: number[];
                        properties: {
                          accuracy?: number;
                          heading?: number;
                          headingAccuracy?: number;
                          speed?: number;
                          speedAccuracy?: number;
                          altitude?: number;
                          altitudeAccuracy?: number;
                          /** PII */
                          address?: {
                            /** @maxLength 1024 */
                            countryCode?: string | null;
                            /** @maxLength 1024 */
                            state?: string | null;
                            /** @maxLength 1024 */
                            city?: string | null;
                            /** @maxLength 1024 */
                            streetName?: string | null;
                            /** @maxLength 1024 */
                            streetNumber?: string | null;
                            floor?: number | null;
                            /** @maxLength 1024 */
                            formattedAddress?: string;
                          };
                          /** @format date-time */
                          dateTime?: string;
                          /** @maxLength 1024 */
                          provider?: string;
                        };
                      };
                      available: boolean;
                      /** @default true */
                      allowContactOnOwnAlarms?: boolean;
                      app?: {
                        mode: "off" | "on" | "risk";
                      } | null;
                      insideZones: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Zone";
                      }[];
                      assetGroups: {
                        /** @format uuid */
                        _id: string;
                        _ref: "AssetGroup";
                      }[];
                      /** @default [] */
                      staticResponders?: {
                        staticResponder: {
                          /** @format uuid */
                          _id: string;
                          _ref: "StaticResponder";
                        };
                        priority: number;
                      }[];
                      /** @format date-time */
                      lastObservationAt?: string;
                      /** @default false */
                      invisibleResponder?: boolean;
                      /**
                       * PII
                       * @maxLength 4096
                       */
                      description?: string;
                      /** @default [] */
                      certifications?: {
                        /** @format uuid */
                        _id: string;
                        certificationCategory: {
                          /** @format uuid */
                          _id: string;
                          _ref: "CertificationCategory";
                        };
                        /** @format date-time */
                        firstIssuedOn: string;
                        /** @format date-time */
                        lastReceivedOn: string;
                        /** @format date-time */
                        expiryDate: string;
                        /**
                         * @format date-time
                         * @default null
                         */
                        plannedRenewalDate?: string | null;
                        /** @maxLength 1024 */
                        documentaryProof?: string | null;
                      }[];
                      type?: "default" | "kiosk";
                    };
                    battery?: number;
                    rssi?: number;
                    snr?: number;
                    /** @format date-time */
                    dateTime?: string;
                    /** @format date-time */
                    deviceDateTime?: string;
                    /** @format date-time */
                    gatewayDateTime?: string;
                    insideGpsZones?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    }[];
                    insideIpsZones?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    }[];
                    zone?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    };
                    callRequest?: boolean;
                    forceLoraCustomer?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    knnResult?: {
                      distance: number;
                      debugInfo?: any;
                    };
                    available?: boolean;
                  };
                  deltas?: {
                    main: {
                      /** @format date-time */
                      start: string;
                      /** @format date-time */
                      end: string;
                      value?: number;
                    };
                    steps?: {
                      gps?: {
                        /** @format date-time */
                        start: string;
                        /** @format date-time */
                        end: string;
                        value?: number;
                      };
                      ips?: {
                        /** @format date-time */
                        start: string;
                        /** @format date-time */
                        end: string;
                        value?: number;
                      };
                      context?: {
                        /** @format date-time */
                        start: string;
                        /** @format date-time */
                        end: string;
                        value?: number;
                      };
                    };
                  };
                  validPosition?: {
                    value: boolean;
                    /** @maxLength 1024 */
                    reason?: string;
                  };
                  isSystemEvent?: boolean;
                };
                /** PII */
                frozenInfo?: {
                  staticResponse: {
                    type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
                    priority: number;
                    zone?: {
                      /** @format uuid */
                      _id: string;
                      customer?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      };
                      type?:
                        | "default"
                        | "responseArea"
                        | "policeDepartment"
                        | "assetMonitoredArea"
                        | "fingerprinted"
                        | "building"
                        | "evacuationPoint";
                      /** PII */
                      location:
                        | {
                            type: "Point";
                            /** PII */
                            coordinates: number[];
                            properties: {
                              accuracy?: number;
                              heading?: number;
                              headingAccuracy?: number;
                              speed?: number;
                              speedAccuracy?: number;
                              altitude?: number;
                              altitudeAccuracy?: number;
                              /** PII */
                              address?: {
                                /** @maxLength 1024 */
                                countryCode?: string | null;
                                /** @maxLength 1024 */
                                state?: string | null;
                                /** @maxLength 1024 */
                                city?: string | null;
                                /** @maxLength 1024 */
                                streetName?: string | null;
                                /** @maxLength 1024 */
                                streetNumber?: string | null;
                                floor?: number | null;
                                /** @maxLength 1024 */
                                formattedAddress?: string;
                              };
                              /** @format date-time */
                              dateTime?: string;
                              /** @maxLength 1024 */
                              provider?: string;
                            };
                          }
                        | {
                            type: "Polygon";
                            /** PII */
                            coordinates: number[][][];
                            properties: {
                              accuracy?: number;
                              heading?: number;
                              headingAccuracy?: number;
                              speed?: number;
                              speedAccuracy?: number;
                              altitude?: number;
                              altitudeAccuracy?: number;
                              /** PII */
                              address?: {
                                /** @maxLength 1024 */
                                countryCode?: string | null;
                                /** @maxLength 1024 */
                                state?: string | null;
                                /** @maxLength 1024 */
                                city?: string | null;
                                /** @maxLength 1024 */
                                streetName?: string | null;
                                /** @maxLength 1024 */
                                streetNumber?: string | null;
                                floor?: number | null;
                                /** @maxLength 1024 */
                                formattedAddress?: string;
                              };
                              /** @format date-time */
                              dateTime?: string;
                              /** @maxLength 1024 */
                              provider?: string;
                            };
                          }
                        | {
                            type: "MultiPolygon";
                            coordinates: number[][][][];
                            properties: {
                              accuracy?: number;
                              heading?: number;
                              headingAccuracy?: number;
                              speed?: number;
                              speedAccuracy?: number;
                              altitude?: number;
                              altitudeAccuracy?: number;
                              /** PII */
                              address?: {
                                /** @maxLength 1024 */
                                countryCode?: string | null;
                                /** @maxLength 1024 */
                                state?: string | null;
                                /** @maxLength 1024 */
                                city?: string | null;
                                /** @maxLength 1024 */
                                streetName?: string | null;
                                /** @maxLength 1024 */
                                streetNumber?: string | null;
                                floor?: number | null;
                                /** @maxLength 1024 */
                                formattedAddress?: string;
                              };
                              /** @format date-time */
                              dateTime?: string;
                              /** @maxLength 1024 */
                              provider?: string;
                            };
                          };
                      /** @maxLength 1024 */
                      name: string;
                      staticResponders: {
                        staticResponder: {
                          /** @format uuid */
                          _id: string;
                          _ref: "StaticResponder";
                        };
                        priority: number;
                      }[];
                    };
                    responders: {
                      info: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Asset" | "StaticResponder";
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        name: string;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        image: string | null;
                        /** PII */
                        position: {
                          type: "Point";
                          /** PII */
                          coordinates: number[];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        };
                        /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                        locale: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        contactCode: string | null;
                      };
                      distanceKm: number | null;
                      actions: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        call: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        sms: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        email: string | null;
                        notification: boolean;
                      };
                      priority: number;
                      professionalResponder?: {
                        available: boolean;
                        inProgress: boolean;
                      };
                    }[];
                  }[];
                  dynamicResponse: {
                    type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
                    priority: number;
                    zone?: {
                      /** @format uuid */
                      _id: string;
                      customer?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      };
                      type?:
                        | "default"
                        | "responseArea"
                        | "policeDepartment"
                        | "assetMonitoredArea"
                        | "fingerprinted"
                        | "building"
                        | "evacuationPoint";
                      /** PII */
                      location:
                        | {
                            type: "Point";
                            /** PII */
                            coordinates: number[];
                            properties: {
                              accuracy?: number;
                              heading?: number;
                              headingAccuracy?: number;
                              speed?: number;
                              speedAccuracy?: number;
                              altitude?: number;
                              altitudeAccuracy?: number;
                              /** PII */
                              address?: {
                                /** @maxLength 1024 */
                                countryCode?: string | null;
                                /** @maxLength 1024 */
                                state?: string | null;
                                /** @maxLength 1024 */
                                city?: string | null;
                                /** @maxLength 1024 */
                                streetName?: string | null;
                                /** @maxLength 1024 */
                                streetNumber?: string | null;
                                floor?: number | null;
                                /** @maxLength 1024 */
                                formattedAddress?: string;
                              };
                              /** @format date-time */
                              dateTime?: string;
                              /** @maxLength 1024 */
                              provider?: string;
                            };
                          }
                        | {
                            type: "Polygon";
                            /** PII */
                            coordinates: number[][][];
                            properties: {
                              accuracy?: number;
                              heading?: number;
                              headingAccuracy?: number;
                              speed?: number;
                              speedAccuracy?: number;
                              altitude?: number;
                              altitudeAccuracy?: number;
                              /** PII */
                              address?: {
                                /** @maxLength 1024 */
                                countryCode?: string | null;
                                /** @maxLength 1024 */
                                state?: string | null;
                                /** @maxLength 1024 */
                                city?: string | null;
                                /** @maxLength 1024 */
                                streetName?: string | null;
                                /** @maxLength 1024 */
                                streetNumber?: string | null;
                                floor?: number | null;
                                /** @maxLength 1024 */
                                formattedAddress?: string;
                              };
                              /** @format date-time */
                              dateTime?: string;
                              /** @maxLength 1024 */
                              provider?: string;
                            };
                          }
                        | {
                            type: "MultiPolygon";
                            coordinates: number[][][][];
                            properties: {
                              accuracy?: number;
                              heading?: number;
                              headingAccuracy?: number;
                              speed?: number;
                              speedAccuracy?: number;
                              altitude?: number;
                              altitudeAccuracy?: number;
                              /** PII */
                              address?: {
                                /** @maxLength 1024 */
                                countryCode?: string | null;
                                /** @maxLength 1024 */
                                state?: string | null;
                                /** @maxLength 1024 */
                                city?: string | null;
                                /** @maxLength 1024 */
                                streetName?: string | null;
                                /** @maxLength 1024 */
                                streetNumber?: string | null;
                                floor?: number | null;
                                /** @maxLength 1024 */
                                formattedAddress?: string;
                              };
                              /** @format date-time */
                              dateTime?: string;
                              /** @maxLength 1024 */
                              provider?: string;
                            };
                          };
                      /** @maxLength 1024 */
                      name: string;
                      staticResponders: {
                        staticResponder: {
                          /** @format uuid */
                          _id: string;
                          _ref: "StaticResponder";
                        };
                        priority: number;
                      }[];
                    };
                    responders: {
                      info: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Asset" | "StaticResponder";
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        name: string;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        image: string | null;
                        /** PII */
                        position: {
                          type: "Point";
                          /** PII */
                          coordinates: number[];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        };
                        /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                        locale: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        contactCode: string | null;
                      };
                      distanceKm: number | null;
                      actions: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        call: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        sms: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        email: string | null;
                        notification: boolean;
                      };
                      priority: number;
                      professionalResponder?: {
                        available: boolean;
                        inProgress: boolean;
                      };
                    }[];
                  }[];
                  professionalResponders?: {
                    /** @format uuid */
                    _id: string;
                    /** @format date-time */
                    createdAt: string;
                    /** @format date-time */
                    updatedAt: string;
                    telluId?: number | null;
                    migrationFinalised?: boolean | null;
                    /** @format date-time */
                    migrationFinalisedDate?: string | null;
                    customer: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    /** @default {"type":"parents","extra":[]} */
                    share?: {
                      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                      extra?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      }[];
                    };
                    type: "sequrix";
                    active: boolean;
                    status:
                      | "invited"
                      | "accepted"
                      | "rejected"
                      | "started"
                      | "onLocation"
                      | "finished"
                      | "error"
                      | "canceled";
                    alarm: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Alarm";
                    };
                    asset: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset";
                    };
                    staticResponder: {
                      /** @format uuid */
                      _id: string;
                      /** @format date-time */
                      createdAt: string;
                      /** @format date-time */
                      updatedAt: string;
                      telluId?: number | null;
                      migrationFinalised?: boolean | null;
                      /** @format date-time */
                      migrationFinalisedDate?: string | null;
                      customer: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      };
                      /** @default {"type":"parents","extra":[]} */
                      share?: {
                        type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                        extra?: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Customer";
                        }[];
                      };
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      name: string;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      externalId: string | null;
                      contact: {
                        /**
                         * PII
                         * @pattern ^([\w+\-.]+@([\w-]+\.)+[\w-]{2,}[, ]*?)+?$
                         */
                        email: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        phone: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        sms: string | null;
                        /** @maxLength 1024 */
                        camera: string | null;
                      };
                      schedule: {
                        entries: {
                          daysOfWeek: number[];
                          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                          timeStart: string;
                          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                          timeEnd: string;
                        }[];
                      } | null;
                      /** @maxLength 1024 */
                      migrationKey?: string;
                      integrations?: {
                        sequrix: {
                          enabled: boolean;
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          objectCode: string;
                        };
                      };
                      /** PII */
                      statistics?: {
                        /**
                         * @maxItems 10
                         * @minItems 0
                         */
                        acceptSpeeds: {
                          /** @format date-time */
                          timestamp: string;
                          /**
                           * @min 0
                           * @exclusiveMin false
                           */
                          speedMs: number;
                        }[];
                        /**
                         * @maxItems 10
                         * @minItems 0
                         */
                        onLocationSpeeds: {
                          /** @format date-time */
                          timestamp: string;
                          /**
                           * @min 0
                           * @exclusiveMin false
                           */
                          speedMs: number;
                        }[];
                        /**
                         * @maxItems 10
                         * @minItems 0
                         */
                        finishSpeeds: {
                          /** @format date-time */
                          timestamp: string;
                          /**
                           * @min 0
                           * @exclusiveMin false
                           */
                          speedMs: number;
                        }[];
                        /**
                         * @min 0
                         * @exclusiveMin false
                         */
                        amountRejected: number;
                        /**
                         * @min 0
                         * @exclusiveMin false
                         */
                        amountAccepted: number;
                      };
                      _ref: "StaticResponder";
                    };
                    /** PII */
                    statistics: {
                      /** @format date-time */
                      invitedAt: string;
                      /** @format date-time */
                      acceptedAt: string | null;
                      /** @format date-time */
                      rejectedAt: string | null;
                      /** @format date-time */
                      startedAt: string | null;
                      /** @format date-time */
                      onLocationAt: string | null;
                      /** @format date-time */
                      finishedAt: string | null;
                    };
                    meta: {
                      /**
                       * PII
                       * @maxLength 4096
                       */
                      comment?: string;
                      /** PII */
                      photos?: {
                        /** @format date-time */
                        timestamp: string;
                        /** @maxLength 1024 */
                        url: string;
                      }[];
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      overridePhoneNumber?: string;
                    };
                    supersededBy: {
                      /** @format uuid */
                      _id: string;
                      _ref: "AlarmProfessionalResponder";
                    } | null;
                  }[];
                };
              };
            }[];
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/alarms/${id}/alarm-professional-responders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Alarm
     * @name AlarmsControllerCreateProfessionalResponder
     * @request POST:/alarms/{id}/alarm-professional-responders
     * @secure
     */
    alarmsControllerCreateProfessionalResponder: (
      id: string,
      data: AlarmCreateProfessionalResponderDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/alarms/${id}/alarm-professional-responders`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Alarm
     * @name AlarmsControllerGetProfessionalResponder
     * @request GET:/alarms/{id}/alarm-professional-responders/{aprId}
     * @secure
     */
    alarmsControllerGetProfessionalResponder: (
      id: string,
      aprId: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @format uuid */
          _id: string;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          updatedAt: string;
          telluId?: number | null;
          migrationFinalised?: boolean | null;
          /** @format date-time */
          migrationFinalisedDate?: string | null;
          customer: {
            /** @format uuid */
            _id: string;
            _ref: "Customer";
          };
          /** @default {"type":"parents","extra":[]} */
          share?: {
            type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
            extra?: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            }[];
          };
          type: "sequrix";
          active: boolean;
          status: "invited" | "accepted" | "rejected" | "started" | "onLocation" | "finished" | "error" | "canceled";
          alarm: {
            /** @format uuid */
            _id: string;
            _ref: "Alarm";
          };
          asset: {
            /** @format uuid */
            _id: string;
            _ref: "Asset";
          };
          staticResponder: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            telluId?: number | null;
            migrationFinalised?: boolean | null;
            /** @format date-time */
            migrationFinalisedDate?: string | null;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /**
             * PII
             * @maxLength 1024
             */
            externalId: string | null;
            contact: {
              /**
               * PII
               * @pattern ^([\w+\-.]+@([\w-]+\.)+[\w-]{2,}[, ]*?)+?$
               */
              email: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              phone: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              sms: string | null;
              /** @maxLength 1024 */
              camera: string | null;
            };
            schedule: {
              entries: {
                daysOfWeek: number[];
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeStart: string;
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeEnd: string;
              }[];
            } | null;
            /** @maxLength 1024 */
            migrationKey?: string;
            integrations?: {
              sequrix: {
                enabled: boolean;
                /**
                 * PII
                 * @maxLength 1024
                 */
                objectCode: string;
              };
            };
            /** PII */
            statistics?: {
              /**
               * @maxItems 10
               * @minItems 0
               */
              acceptSpeeds: {
                /** @format date-time */
                timestamp: string;
                /**
                 * @min 0
                 * @exclusiveMin false
                 */
                speedMs: number;
              }[];
              /**
               * @maxItems 10
               * @minItems 0
               */
              onLocationSpeeds: {
                /** @format date-time */
                timestamp: string;
                /**
                 * @min 0
                 * @exclusiveMin false
                 */
                speedMs: number;
              }[];
              /**
               * @maxItems 10
               * @minItems 0
               */
              finishSpeeds: {
                /** @format date-time */
                timestamp: string;
                /**
                 * @min 0
                 * @exclusiveMin false
                 */
                speedMs: number;
              }[];
              /**
               * @min 0
               * @exclusiveMin false
               */
              amountRejected: number;
              /**
               * @min 0
               * @exclusiveMin false
               */
              amountAccepted: number;
            };
            _ref: "StaticResponder";
          };
          /** PII */
          statistics: {
            /** @format date-time */
            invitedAt: string;
            /** @format date-time */
            acceptedAt: string | null;
            /** @format date-time */
            rejectedAt: string | null;
            /** @format date-time */
            startedAt: string | null;
            /** @format date-time */
            onLocationAt: string | null;
            /** @format date-time */
            finishedAt: string | null;
          };
          meta: {
            /**
             * PII
             * @maxLength 4096
             */
            comment?: string;
            /** PII */
            photos?: {
              /** @format date-time */
              timestamp: string;
              /** @maxLength 1024 */
              url: string;
            }[];
            /**
             * PII
             * @maxLength 1024
             */
            overridePhoneNumber?: string;
          };
          supersededBy: {
            /** @format uuid */
            _id: string;
            _ref: "AlarmProfessionalResponder";
          } | null;
        },
        any
      >({
        path: `/alarms/${id}/alarm-professional-responders/${aprId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Alarm
     * @name AlarmsControllerUpdateProfessionalResponder
     * @request PATCH:/alarms/{id}/alarm-professional-responders/{aprId}
     * @secure
     */
    alarmsControllerUpdateProfessionalResponder: (
      id: string,
      aprId: string,
      data: AlarmPatchProfessionalResponderDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/alarms/${id}/alarm-professional-responders/${aprId}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Alarm
     * @name AlarmsControllerCreateAlarmPushSubscription
     * @request POST:/alarms/{id}/alarm-push-subscriptions
     * @secure
     */
    alarmsControllerCreateAlarmPushSubscription: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/alarms/${id}/alarm-push-subscriptions`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Alarm
     * @name AlarmsControllerDeleteAlarmPushSubscription
     * @request DELETE:/alarms/{id}/alarm-push-subscriptions
     * @secure
     */
    alarmsControllerDeleteAlarmPushSubscription: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/alarms/${id}/alarm-push-subscriptions`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Alarm
     * @name AlarmsControllerGetAlarmCalls
     * @request GET:/alarms/{id}/calls
     * @secure
     */
    alarmsControllerGetAlarmCalls: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AlarmCallOutputDto[], any>({
        path: `/alarms/${id}/calls`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Alarm
     * @name AlarmsControllerEscalate
     * @request PATCH:/alarms/{id}/escalate
     * @secure
     */
    alarmsControllerEscalate: (
      id: string,
      data: AlarmUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/alarms/${id}/escalate`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Paginates Overlay
     *
     * @tags Alarm
     * @name AlarmsControllerGetOverlays
     * @request GET:/alarms/{id}/overlays
     * @secure
     */
    alarmsControllerGetOverlays: (
      id: string,
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /** @format uri */
            imageUrl: string | null;
            /** @default 0 */
            level?: number;
            /** PII */
            points: {
              sw: {
                lat: number;
                lng: number;
              };
              ne: {
                lat: number;
                lng: number;
              };
              nw: {
                lat: number;
                lng: number;
              };
              se: {
                lat: number;
                lng: number;
              };
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/alarms/${id}/overlays`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Alarm
     * @name AlarmsControllerAlarmResponseDynamic
     * @request GET:/alarms/{id}/response/dynamic
     * @secure
     */
    alarmsControllerAlarmResponseDynamic: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AlarmResponseResponseDto, any>({
        path: `/alarms/${id}/response/dynamic`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Alarm
     * @name AlarmsControllerAlarmResponseStatic
     * @request GET:/alarms/{id}/response/static
     * @secure
     */
    alarmsControllerAlarmResponseStatic: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AlarmResponseResponseDto, any>({
        path: `/alarms/${id}/response/static`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Alarm
     * @name AlarmsControllerCount
     * @request GET:/alarms/count
     * @secure
     */
    alarmsControllerCount: (
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AlarmCountResponseDto, any>({
        path: `/alarms/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Alarm
     * @name AlarmsControllerMassAcknowledge
     * @request POST:/alarms/mass-acknowledge
     * @secure
     */
    alarmsControllerMassAcknowledge: (
      data: AlarmMassAcknowledgeDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/alarms/mass-acknowledge`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Searches Alarm
     *
     * @tags Alarm
     * @name AlarmsControllerSearch
     * @request GET:/alarms/search
     * @secure
     */
    alarmsControllerSearch: (
      query: {
        /** The search query string */
        q: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
            asset: {
              /** @format uuid */
              _id: string;
              /** @format date-time */
              createdAt: string;
              /** @format date-time */
              updatedAt: string;
              telluId?: number | null;
              migrationFinalised?: boolean | null;
              /** @format date-time */
              migrationFinalisedDate?: string | null;
              customer: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              };
              /** @default {"type":"parents","extra":[]} */
              share?: {
                type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                extra?: {
                  /** @format uuid */
                  _id: string;
                  _ref: "Customer";
                }[];
              };
              user: {
                /** @format uuid */
                _id: string;
                _ref: "User";
              } | null;
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
              /**
               * PII
               * @maxLength 1024
               */
              externalId?: string | null;
              propertiesOwnership?: "override" | "inherit";
              /** @default {} */
              properties?: {
                /**
                 * PII
                 * @maxLength 1024
                 */
                phoneNumber?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                smsNumber?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                email?: string | null;
                /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                locale?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                image?: string | null;
                /** PII */
                rSim?: {
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  euicc: string;
                  primary: {
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    msisdn: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    iccid: string;
                  };
                  secondary: {
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    msisdn: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    iccid: string;
                  };
                  enabled: boolean;
                } | null;
              };
              /**
               * PII
               * @default null
               */
              position?: {
                type: "Point";
                /** PII */
                coordinates: number[];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              };
              available: boolean;
              /** @default true */
              allowContactOnOwnAlarms?: boolean;
              app?: {
                mode: "off" | "on" | "risk";
              } | null;
              insideZones: {
                /** @format uuid */
                _id: string;
                _ref: "Zone";
              }[];
              assetGroups: {
                /** @format uuid */
                _id: string;
                _ref: "AssetGroup";
              }[];
              /** @default [] */
              staticResponders?: {
                staticResponder: {
                  /** @format uuid */
                  _id: string;
                  _ref: "StaticResponder";
                };
                priority: number;
              }[];
              /** @format date-time */
              lastObservationAt?: string;
              /** @default false */
              invisibleResponder?: boolean;
              /**
               * PII
               * @maxLength 4096
               */
              description?: string;
              /** @default [] */
              certifications?: {
                /** @format uuid */
                _id: string;
                certificationCategory: {
                  /** @format uuid */
                  _id: string;
                  _ref: "CertificationCategory";
                };
                /** @format date-time */
                firstIssuedOn: string;
                /** @format date-time */
                lastReceivedOn: string;
                /** @format date-time */
                expiryDate: string;
                /**
                 * @format date-time
                 * @default null
                 */
                plannedRenewalDate?: string | null;
                /** @maxLength 1024 */
                documentaryProof?: string | null;
              }[];
              type?: "default" | "kiosk";
            };
            ack: {
              needed: boolean;
              value: boolean;
              ackedBy: {
                /** @format uuid */
                _id: string;
                _ref: "User";
                /**
                 * PII
                 * @maxLength 1024
                 */
                name: string;
              } | null;
              /**
               * PII
               * @maxLength 1024
               */
              comment: string | null;
              /** @format date-time */
              ackedAt: string | null;
            };
            /** PII */
            position: {
              type: "Point";
              /** PII */
              coordinates: number[];
              properties: {
                accuracy?: number;
                heading?: number;
                headingAccuracy?: number;
                speed?: number;
                speedAccuracy?: number;
                altitude?: number;
                altitudeAccuracy?: number;
                /** PII */
                address?: {
                  /** @maxLength 1024 */
                  countryCode?: string | null;
                  /** @maxLength 1024 */
                  state?: string | null;
                  /** @maxLength 1024 */
                  city?: string | null;
                  /** @maxLength 1024 */
                  streetName?: string | null;
                  /** @maxLength 1024 */
                  streetNumber?: string | null;
                  floor?: number | null;
                  /** @maxLength 1024 */
                  formattedAddress?: string;
                };
                /** @format date-time */
                dateTime?: string;
                /** @maxLength 1024 */
                provider?: string;
              };
            };
            severity: "red" | "orange" | "green";
            /**
             * PII
             * @maxLength 4096
             */
            procedure: string | null;
            meta?: {
              observationTrigger?: {
                /** @format uuid */
                _id: string;
                /** @format date-time */
                createdAt: string;
                /** @format date-time */
                updatedAt: string;
                telluId?: number | null;
                migrationFinalised?: boolean | null;
                /** @format date-time */
                migrationFinalisedDate?: string | null;
                customer: {
                  /** @format uuid */
                  _id: string;
                  _ref: "Customer";
                };
                /** @default {"type":"parents","extra":[]} */
                share?: {
                  type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                  extra?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  }[];
                };
                /** @maxLength 1024 */
                name: string;
                eventCodes: string[];
                /** @maxLength 1024 */
                description: string;
                status: "active" | "inactive";
                actions: (
                  | {
                      type: "alarm";
                      config: {
                        severity: "red" | "orange" | "green";
                        type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
                        /** @maxLength 4096 */
                        procedure: string | null;
                        /** @maxLength 1024 */
                        name: string;
                      };
                    }
                  | {
                      type: "sms";
                      config: {
                        /** PII */
                        toRaw: string[];
                        toContactList: {
                          /** @format uuid */
                          _id: string;
                          _ref: "ContactList";
                        }[];
                        toTriggerUser: boolean;
                        /** @maxLength 1024 */
                        message: string;
                      };
                    }
                  | {
                      type: "email";
                      config: {
                        /** PII */
                        toRaw: string[];
                        toContactList: {
                          /** @format uuid */
                          _id: string;
                          _ref: "ContactList";
                        }[];
                        toTriggerUser: boolean;
                        /** @maxLength 1024 */
                        message: string;
                        /** @maxLength 1024 */
                        subject: string;
                        /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                        locale?: string;
                      };
                    }
                  | {
                      type: "assetUpdate";
                      config: {
                        available?: boolean;
                        app?: {
                          mode: "off" | "on" | "risk";
                        };
                      };
                    }
                )[];
                filter:
                  | {
                      type: "operator/and";
                      operands: (
                        | {
                            type: "operator/or";
                            operands: (
                              | {
                                  type: "operator/not";
                                  operand:
                                    | {
                                        type: "constraint/asset";
                                        assets: {
                                          /** @format uuid */
                                          _id: string;
                                          _ref: "Asset";
                                        }[];
                                      }
                                    | {
                                        type: "constraint/assetGroup";
                                        groups: {
                                          /** @format uuid */
                                          _id: string;
                                          _ref: "AssetGroup";
                                        }[];
                                      }
                                    | {
                                        type: "constraint/zone";
                                        zone: {
                                          /** @format uuid */
                                          _id: string;
                                          _ref: "Zone";
                                        };
                                      }
                                    | {
                                        type: "constraint/schedule";
                                        schedule: {
                                          entries: {
                                            daysOfWeek: number[];
                                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                            timeStart: string;
                                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                            timeEnd: string;
                                          }[];
                                        };
                                      };
                                }
                              | {
                                  type: "constraint/asset";
                                  assets: {
                                    /** @format uuid */
                                    _id: string;
                                    _ref: "Asset";
                                  }[];
                                }
                              | {
                                  type: "constraint/assetGroup";
                                  groups: {
                                    /** @format uuid */
                                    _id: string;
                                    _ref: "AssetGroup";
                                  }[];
                                }
                              | {
                                  type: "constraint/zone";
                                  zone: {
                                    /** @format uuid */
                                    _id: string;
                                    _ref: "Zone";
                                  };
                                }
                              | {
                                  type: "constraint/schedule";
                                  schedule: {
                                    entries: {
                                      daysOfWeek: number[];
                                      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                      timeStart: string;
                                      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                      timeEnd: string;
                                    }[];
                                  };
                                }
                            )[];
                          }
                        | {
                            type: "constraint/asset";
                            assets: {
                              /** @format uuid */
                              _id: string;
                              _ref: "Asset";
                            }[];
                          }
                        | {
                            type: "constraint/assetGroup";
                            groups: {
                              /** @format uuid */
                              _id: string;
                              _ref: "AssetGroup";
                            }[];
                          }
                        | {
                            type: "constraint/zone";
                            zone: {
                              /** @format uuid */
                              _id: string;
                              _ref: "Zone";
                            };
                          }
                        | {
                            type: "constraint/schedule";
                            schedule: {
                              entries: {
                                daysOfWeek: number[];
                                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                timeStart: string;
                                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                timeEnd: string;
                              }[];
                            };
                          }
                      )[];
                    }
                  | {
                      type: "constraint/asset";
                      assets: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Asset";
                      }[];
                    }
                  | {
                      type: "constraint/assetGroup";
                      groups: {
                        /** @format uuid */
                        _id: string;
                        _ref: "AssetGroup";
                      }[];
                    }
                  | {
                      type: "constraint/zone";
                      zone: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Zone";
                      };
                    }
                  | {
                      type: "constraint/schedule";
                      schedule: {
                        entries: {
                          daysOfWeek: number[];
                          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                          timeStart: string;
                          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                          timeEnd: string;
                        }[];
                      };
                    };
              };
              /** PII */
              observation?: {
                /** @format uuid */
                _id: string;
                /** @maxLength 1024 */
                event: string;
                asset: {
                  /** @format uuid */
                  _id: string;
                  /** @format date-time */
                  createdAt: string;
                  /** @format date-time */
                  updatedAt: string;
                  telluId?: number | null;
                  migrationFinalised?: boolean | null;
                  /** @format date-time */
                  migrationFinalisedDate?: string | null;
                  customer: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  };
                  /** @default {"type":"parents","extra":[]} */
                  share?: {
                    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                    extra?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    }[];
                  };
                  user: {
                    /** @format uuid */
                    _id: string;
                    _ref: "User";
                  } | null;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  name: string;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  externalId?: string | null;
                  propertiesOwnership?: "override" | "inherit";
                  /** @default {} */
                  properties?: {
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    phoneNumber?: string | null;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    smsNumber?: string | null;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    email?: string | null;
                    /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                    locale?: string | null;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    image?: string | null;
                    /** PII */
                    rSim?: {
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      euicc: string;
                      primary: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        msisdn: string;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        iccid: string;
                      };
                      secondary: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        msisdn: string;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        iccid: string;
                      };
                      enabled: boolean;
                    } | null;
                  };
                  /**
                   * PII
                   * @default null
                   */
                  position?: {
                    type: "Point";
                    /** PII */
                    coordinates: number[];
                    properties: {
                      accuracy?: number;
                      heading?: number;
                      headingAccuracy?: number;
                      speed?: number;
                      speedAccuracy?: number;
                      altitude?: number;
                      altitudeAccuracy?: number;
                      /** PII */
                      address?: {
                        /** @maxLength 1024 */
                        countryCode?: string | null;
                        /** @maxLength 1024 */
                        state?: string | null;
                        /** @maxLength 1024 */
                        city?: string | null;
                        /** @maxLength 1024 */
                        streetName?: string | null;
                        /** @maxLength 1024 */
                        streetNumber?: string | null;
                        floor?: number | null;
                        /** @maxLength 1024 */
                        formattedAddress?: string;
                      };
                      /** @format date-time */
                      dateTime?: string;
                      /** @maxLength 1024 */
                      provider?: string;
                    };
                  };
                  available: boolean;
                  /** @default true */
                  allowContactOnOwnAlarms?: boolean;
                  app?: {
                    mode: "off" | "on" | "risk";
                  } | null;
                  insideZones: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Zone";
                  }[];
                  assetGroups: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[];
                  /** @default [] */
                  staticResponders?: {
                    staticResponder: {
                      /** @format uuid */
                      _id: string;
                      _ref: "StaticResponder";
                    };
                    priority: number;
                  }[];
                  /** @format date-time */
                  lastObservationAt?: string;
                  /** @default false */
                  invisibleResponder?: boolean;
                  /**
                   * PII
                   * @maxLength 4096
                   */
                  description?: string;
                  /** @default [] */
                  certifications?: {
                    /** @format uuid */
                    _id: string;
                    certificationCategory: {
                      /** @format uuid */
                      _id: string;
                      _ref: "CertificationCategory";
                    };
                    /** @format date-time */
                    firstIssuedOn: string;
                    /** @format date-time */
                    lastReceivedOn: string;
                    /** @format date-time */
                    expiryDate: string;
                    /**
                     * @format date-time
                     * @default null
                     */
                    plannedRenewalDate?: string | null;
                    /** @maxLength 1024 */
                    documentaryProof?: string | null;
                  }[];
                  type?: "default" | "kiosk";
                  _ref: "Asset";
                };
                customer: {
                  /** @format uuid */
                  _id: string;
                  _ref: "Customer";
                };
                device: {
                  /** @format uuid */
                  _id: string;
                  _ref: "Device";
                };
                user: {
                  /** @format uuid */
                  _id: string;
                  _ref: "User";
                };
                /** PII */
                position?: {
                  type: "Point";
                  /** PII */
                  coordinates: number[];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                };
                beacons?:
                  | {
                      /** @maxLength 1024 */
                      code: string;
                      rssi: number;
                      battery?: number;
                      /** @format date-time */
                      dateTime: string;
                      beacon: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Beacon";
                      } | null;
                      calc: number | null;
                      valid: boolean;
                    }[]
                  | {
                      /** @maxLength 1024 */
                      code: string;
                      rssi: number;
                      battery?: number;
                      /** @format date-time */
                      dateTime: string;
                    }[];
                /** PII */
                meta?: {
                  asset?: {
                    /** @format uuid */
                    _id: string;
                    /** @format date-time */
                    createdAt: string;
                    /** @format date-time */
                    updatedAt: string;
                    telluId?: number | null;
                    migrationFinalised?: boolean | null;
                    /** @format date-time */
                    migrationFinalisedDate?: string | null;
                    customer: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    /** @default {"type":"parents","extra":[]} */
                    share?: {
                      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                      extra?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      }[];
                    };
                    user: {
                      /** @format uuid */
                      _id: string;
                      _ref: "User";
                    } | null;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    name: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    externalId?: string | null;
                    propertiesOwnership?: "override" | "inherit";
                    /** @default {} */
                    properties?: {
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      phoneNumber?: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      smsNumber?: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      email?: string | null;
                      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                      locale?: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      image?: string | null;
                      /** PII */
                      rSim?: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        euicc: string;
                        primary: {
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          msisdn: string;
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          iccid: string;
                        };
                        secondary: {
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          msisdn: string;
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          iccid: string;
                        };
                        enabled: boolean;
                      } | null;
                    };
                    /**
                     * PII
                     * @default null
                     */
                    position?: {
                      type: "Point";
                      /** PII */
                      coordinates: number[];
                      properties: {
                        accuracy?: number;
                        heading?: number;
                        headingAccuracy?: number;
                        speed?: number;
                        speedAccuracy?: number;
                        altitude?: number;
                        altitudeAccuracy?: number;
                        /** PII */
                        address?: {
                          /** @maxLength 1024 */
                          countryCode?: string | null;
                          /** @maxLength 1024 */
                          state?: string | null;
                          /** @maxLength 1024 */
                          city?: string | null;
                          /** @maxLength 1024 */
                          streetName?: string | null;
                          /** @maxLength 1024 */
                          streetNumber?: string | null;
                          floor?: number | null;
                          /** @maxLength 1024 */
                          formattedAddress?: string;
                        };
                        /** @format date-time */
                        dateTime?: string;
                        /** @maxLength 1024 */
                        provider?: string;
                      };
                    };
                    available: boolean;
                    /** @default true */
                    allowContactOnOwnAlarms?: boolean;
                    app?: {
                      mode: "off" | "on" | "risk";
                    } | null;
                    insideZones: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    }[];
                    assetGroups: {
                      /** @format uuid */
                      _id: string;
                      _ref: "AssetGroup";
                    }[];
                    /** @default [] */
                    staticResponders?: {
                      staticResponder: {
                        /** @format uuid */
                        _id: string;
                        _ref: "StaticResponder";
                      };
                      priority: number;
                    }[];
                    /** @format date-time */
                    lastObservationAt?: string;
                    /** @default false */
                    invisibleResponder?: boolean;
                    /**
                     * PII
                     * @maxLength 4096
                     */
                    description?: string;
                    /** @default [] */
                    certifications?: {
                      /** @format uuid */
                      _id: string;
                      certificationCategory: {
                        /** @format uuid */
                        _id: string;
                        _ref: "CertificationCategory";
                      };
                      /** @format date-time */
                      firstIssuedOn: string;
                      /** @format date-time */
                      lastReceivedOn: string;
                      /** @format date-time */
                      expiryDate: string;
                      /**
                       * @format date-time
                       * @default null
                       */
                      plannedRenewalDate?: string | null;
                      /** @maxLength 1024 */
                      documentaryProof?: string | null;
                    }[];
                    type?: "default" | "kiosk";
                  };
                  battery?: number;
                  rssi?: number;
                  snr?: number;
                  /** @format date-time */
                  dateTime?: string;
                  /** @format date-time */
                  deviceDateTime?: string;
                  /** @format date-time */
                  gatewayDateTime?: string;
                  insideGpsZones?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Zone";
                  }[];
                  insideIpsZones?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Zone";
                  }[];
                  zone?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Zone";
                  };
                  callRequest?: boolean;
                  forceLoraCustomer?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  };
                  knnResult?: {
                    distance: number;
                    debugInfo?: any;
                  };
                  available?: boolean;
                };
                deltas?: {
                  main: {
                    /** @format date-time */
                    start: string;
                    /** @format date-time */
                    end: string;
                    value?: number;
                  };
                  steps?: {
                    gps?: {
                      /** @format date-time */
                      start: string;
                      /** @format date-time */
                      end: string;
                      value?: number;
                    };
                    ips?: {
                      /** @format date-time */
                      start: string;
                      /** @format date-time */
                      end: string;
                      value?: number;
                    };
                    context?: {
                      /** @format date-time */
                      start: string;
                      /** @format date-time */
                      end: string;
                      value?: number;
                    };
                  };
                };
                validPosition?: {
                  value: boolean;
                  /** @maxLength 1024 */
                  reason?: string;
                };
                isSystemEvent?: boolean;
              };
              /** PII */
              frozenInfo?: {
                staticResponse: {
                  type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
                  priority: number;
                  zone?: {
                    /** @format uuid */
                    _id: string;
                    customer?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    type?:
                      | "default"
                      | "responseArea"
                      | "policeDepartment"
                      | "assetMonitoredArea"
                      | "fingerprinted"
                      | "building"
                      | "evacuationPoint";
                    /** PII */
                    location:
                      | {
                          type: "Point";
                          /** PII */
                          coordinates: number[];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        }
                      | {
                          type: "Polygon";
                          /** PII */
                          coordinates: number[][][];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        }
                      | {
                          type: "MultiPolygon";
                          coordinates: number[][][][];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        };
                    /** @maxLength 1024 */
                    name: string;
                    staticResponders: {
                      staticResponder: {
                        /** @format uuid */
                        _id: string;
                        _ref: "StaticResponder";
                      };
                      priority: number;
                    }[];
                  };
                  responders: {
                    info: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset" | "StaticResponder";
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      name: string;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      image: string | null;
                      /** PII */
                      position: {
                        type: "Point";
                        /** PII */
                        coordinates: number[];
                        properties: {
                          accuracy?: number;
                          heading?: number;
                          headingAccuracy?: number;
                          speed?: number;
                          speedAccuracy?: number;
                          altitude?: number;
                          altitudeAccuracy?: number;
                          /** PII */
                          address?: {
                            /** @maxLength 1024 */
                            countryCode?: string | null;
                            /** @maxLength 1024 */
                            state?: string | null;
                            /** @maxLength 1024 */
                            city?: string | null;
                            /** @maxLength 1024 */
                            streetName?: string | null;
                            /** @maxLength 1024 */
                            streetNumber?: string | null;
                            floor?: number | null;
                            /** @maxLength 1024 */
                            formattedAddress?: string;
                          };
                          /** @format date-time */
                          dateTime?: string;
                          /** @maxLength 1024 */
                          provider?: string;
                        };
                      };
                      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                      locale: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      contactCode: string | null;
                    };
                    distanceKm: number | null;
                    actions: {
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      call: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      sms: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      email: string | null;
                      notification: boolean;
                    };
                    priority: number;
                    professionalResponder?: {
                      available: boolean;
                      inProgress: boolean;
                    };
                  }[];
                }[];
                dynamicResponse: {
                  type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
                  priority: number;
                  zone?: {
                    /** @format uuid */
                    _id: string;
                    customer?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    type?:
                      | "default"
                      | "responseArea"
                      | "policeDepartment"
                      | "assetMonitoredArea"
                      | "fingerprinted"
                      | "building"
                      | "evacuationPoint";
                    /** PII */
                    location:
                      | {
                          type: "Point";
                          /** PII */
                          coordinates: number[];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        }
                      | {
                          type: "Polygon";
                          /** PII */
                          coordinates: number[][][];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        }
                      | {
                          type: "MultiPolygon";
                          coordinates: number[][][][];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        };
                    /** @maxLength 1024 */
                    name: string;
                    staticResponders: {
                      staticResponder: {
                        /** @format uuid */
                        _id: string;
                        _ref: "StaticResponder";
                      };
                      priority: number;
                    }[];
                  };
                  responders: {
                    info: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset" | "StaticResponder";
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      name: string;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      image: string | null;
                      /** PII */
                      position: {
                        type: "Point";
                        /** PII */
                        coordinates: number[];
                        properties: {
                          accuracy?: number;
                          heading?: number;
                          headingAccuracy?: number;
                          speed?: number;
                          speedAccuracy?: number;
                          altitude?: number;
                          altitudeAccuracy?: number;
                          /** PII */
                          address?: {
                            /** @maxLength 1024 */
                            countryCode?: string | null;
                            /** @maxLength 1024 */
                            state?: string | null;
                            /** @maxLength 1024 */
                            city?: string | null;
                            /** @maxLength 1024 */
                            streetName?: string | null;
                            /** @maxLength 1024 */
                            streetNumber?: string | null;
                            floor?: number | null;
                            /** @maxLength 1024 */
                            formattedAddress?: string;
                          };
                          /** @format date-time */
                          dateTime?: string;
                          /** @maxLength 1024 */
                          provider?: string;
                        };
                      };
                      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                      locale: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      contactCode: string | null;
                    };
                    distanceKm: number | null;
                    actions: {
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      call: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      sms: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      email: string | null;
                      notification: boolean;
                    };
                    priority: number;
                    professionalResponder?: {
                      available: boolean;
                      inProgress: boolean;
                    };
                  }[];
                }[];
                professionalResponders?: {
                  /** @format uuid */
                  _id: string;
                  /** @format date-time */
                  createdAt: string;
                  /** @format date-time */
                  updatedAt: string;
                  telluId?: number | null;
                  migrationFinalised?: boolean | null;
                  /** @format date-time */
                  migrationFinalisedDate?: string | null;
                  customer: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  };
                  /** @default {"type":"parents","extra":[]} */
                  share?: {
                    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                    extra?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    }[];
                  };
                  type: "sequrix";
                  active: boolean;
                  status:
                    | "invited"
                    | "accepted"
                    | "rejected"
                    | "started"
                    | "onLocation"
                    | "finished"
                    | "error"
                    | "canceled";
                  alarm: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Alarm";
                  };
                  asset: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Asset";
                  };
                  staticResponder: {
                    /** @format uuid */
                    _id: string;
                    /** @format date-time */
                    createdAt: string;
                    /** @format date-time */
                    updatedAt: string;
                    telluId?: number | null;
                    migrationFinalised?: boolean | null;
                    /** @format date-time */
                    migrationFinalisedDate?: string | null;
                    customer: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    /** @default {"type":"parents","extra":[]} */
                    share?: {
                      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                      extra?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      }[];
                    };
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    name: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    externalId: string | null;
                    contact: {
                      /**
                       * PII
                       * @pattern ^([\w+\-.]+@([\w-]+\.)+[\w-]{2,}[, ]*?)+?$
                       */
                      email: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      phone: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      sms: string | null;
                      /** @maxLength 1024 */
                      camera: string | null;
                    };
                    schedule: {
                      entries: {
                        daysOfWeek: number[];
                        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                        timeStart: string;
                        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                        timeEnd: string;
                      }[];
                    } | null;
                    /** @maxLength 1024 */
                    migrationKey?: string;
                    integrations?: {
                      sequrix: {
                        enabled: boolean;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        objectCode: string;
                      };
                    };
                    /** PII */
                    statistics?: {
                      /**
                       * @maxItems 10
                       * @minItems 0
                       */
                      acceptSpeeds: {
                        /** @format date-time */
                        timestamp: string;
                        /**
                         * @min 0
                         * @exclusiveMin false
                         */
                        speedMs: number;
                      }[];
                      /**
                       * @maxItems 10
                       * @minItems 0
                       */
                      onLocationSpeeds: {
                        /** @format date-time */
                        timestamp: string;
                        /**
                         * @min 0
                         * @exclusiveMin false
                         */
                        speedMs: number;
                      }[];
                      /**
                       * @maxItems 10
                       * @minItems 0
                       */
                      finishSpeeds: {
                        /** @format date-time */
                        timestamp: string;
                        /**
                         * @min 0
                         * @exclusiveMin false
                         */
                        speedMs: number;
                      }[];
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      amountRejected: number;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      amountAccepted: number;
                    };
                    _ref: "StaticResponder";
                  };
                  /** PII */
                  statistics: {
                    /** @format date-time */
                    invitedAt: string;
                    /** @format date-time */
                    acceptedAt: string | null;
                    /** @format date-time */
                    rejectedAt: string | null;
                    /** @format date-time */
                    startedAt: string | null;
                    /** @format date-time */
                    onLocationAt: string | null;
                    /** @format date-time */
                    finishedAt: string | null;
                  };
                  meta: {
                    /**
                     * PII
                     * @maxLength 4096
                     */
                    comment?: string;
                    /** PII */
                    photos?: {
                      /** @format date-time */
                      timestamp: string;
                      /** @maxLength 1024 */
                      url: string;
                    }[];
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    overridePhoneNumber?: string;
                  };
                  supersededBy: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AlarmProfessionalResponder";
                  } | null;
                }[];
              };
            };
            alarmCenter: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
            } | null;
            /** @format date-time */
            lastMergedAt?: string;
            /** @format date-time */
            lastPublishedToStreamAt?: string;
            /** PII */
            mergeHistory?: {
              /** @format uuid */
              _id: string;
              /** @maxLength 1024 */
              name: string;
              /** @format date-time */
              createdAt: string;
              /** PII */
              position: {
                type: "Point";
                /** PII */
                coordinates: number[];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              };
              meta?: {
                observationTrigger?: {
                  /** @format uuid */
                  _id: string;
                  /** @format date-time */
                  createdAt: string;
                  /** @format date-time */
                  updatedAt: string;
                  telluId?: number | null;
                  migrationFinalised?: boolean | null;
                  /** @format date-time */
                  migrationFinalisedDate?: string | null;
                  customer: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  };
                  /** @default {"type":"parents","extra":[]} */
                  share?: {
                    type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                    extra?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    }[];
                  };
                  /** @maxLength 1024 */
                  name: string;
                  eventCodes: string[];
                  /** @maxLength 1024 */
                  description: string;
                  status: "active" | "inactive";
                  actions: (
                    | {
                        type: "alarm";
                        config: {
                          severity: "red" | "orange" | "green";
                          type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
                          /** @maxLength 4096 */
                          procedure: string | null;
                          /** @maxLength 1024 */
                          name: string;
                        };
                      }
                    | {
                        type: "sms";
                        config: {
                          /** PII */
                          toRaw: string[];
                          toContactList: {
                            /** @format uuid */
                            _id: string;
                            _ref: "ContactList";
                          }[];
                          toTriggerUser: boolean;
                          /** @maxLength 1024 */
                          message: string;
                        };
                      }
                    | {
                        type: "email";
                        config: {
                          /** PII */
                          toRaw: string[];
                          toContactList: {
                            /** @format uuid */
                            _id: string;
                            _ref: "ContactList";
                          }[];
                          toTriggerUser: boolean;
                          /** @maxLength 1024 */
                          message: string;
                          /** @maxLength 1024 */
                          subject: string;
                          /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                          locale?: string;
                        };
                      }
                    | {
                        type: "assetUpdate";
                        config: {
                          available?: boolean;
                          app?: {
                            mode: "off" | "on" | "risk";
                          };
                        };
                      }
                  )[];
                  filter:
                    | {
                        type: "constraint/asset";
                        assets: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Asset";
                        }[];
                      }
                    | {
                        type: "constraint/assetGroup";
                        groups: {
                          /** @format uuid */
                          _id: string;
                          _ref: "AssetGroup";
                        }[];
                      }
                    | {
                        type: "constraint/zone";
                        zone: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Zone";
                        };
                      }
                    | {
                        type: "constraint/schedule";
                        schedule: {
                          entries: {
                            daysOfWeek: number[];
                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                            timeStart: string;
                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                            timeEnd: string;
                          }[];
                        };
                      };
                };
                /** PII */
                observation?: {
                  /** @format uuid */
                  _id: string;
                  /** @maxLength 1024 */
                  event: string;
                  asset: {
                    /** @format uuid */
                    _id: string;
                    /** @format date-time */
                    createdAt: string;
                    /** @format date-time */
                    updatedAt: string;
                    telluId?: number | null;
                    migrationFinalised?: boolean | null;
                    /** @format date-time */
                    migrationFinalisedDate?: string | null;
                    customer: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    /** @default {"type":"parents","extra":[]} */
                    share?: {
                      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                      extra?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      }[];
                    };
                    user: {
                      /** @format uuid */
                      _id: string;
                      _ref: "User";
                    } | null;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    name: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    externalId?: string | null;
                    propertiesOwnership?: "override" | "inherit";
                    /** @default {} */
                    properties?: {
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      phoneNumber?: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      smsNumber?: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      email?: string | null;
                      /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                      locale?: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      image?: string | null;
                      /** PII */
                      rSim?: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        euicc: string;
                        primary: {
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          msisdn: string;
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          iccid: string;
                        };
                        secondary: {
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          msisdn: string;
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          iccid: string;
                        };
                        enabled: boolean;
                      } | null;
                    };
                    /**
                     * PII
                     * @default null
                     */
                    position?: {
                      type: "Point";
                      /** PII */
                      coordinates: number[];
                      properties: {
                        accuracy?: number;
                        heading?: number;
                        headingAccuracy?: number;
                        speed?: number;
                        speedAccuracy?: number;
                        altitude?: number;
                        altitudeAccuracy?: number;
                        /** PII */
                        address?: {
                          /** @maxLength 1024 */
                          countryCode?: string | null;
                          /** @maxLength 1024 */
                          state?: string | null;
                          /** @maxLength 1024 */
                          city?: string | null;
                          /** @maxLength 1024 */
                          streetName?: string | null;
                          /** @maxLength 1024 */
                          streetNumber?: string | null;
                          floor?: number | null;
                          /** @maxLength 1024 */
                          formattedAddress?: string;
                        };
                        /** @format date-time */
                        dateTime?: string;
                        /** @maxLength 1024 */
                        provider?: string;
                      };
                    };
                    available: boolean;
                    /** @default true */
                    allowContactOnOwnAlarms?: boolean;
                    app?: {
                      mode: "off" | "on" | "risk";
                    } | null;
                    insideZones: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    }[];
                    assetGroups: {
                      /** @format uuid */
                      _id: string;
                      _ref: "AssetGroup";
                    }[];
                    /** @default [] */
                    staticResponders?: {
                      staticResponder: {
                        /** @format uuid */
                        _id: string;
                        _ref: "StaticResponder";
                      };
                      priority: number;
                    }[];
                    /** @format date-time */
                    lastObservationAt?: string;
                    /** @default false */
                    invisibleResponder?: boolean;
                    /**
                     * PII
                     * @maxLength 4096
                     */
                    description?: string;
                    /** @default [] */
                    certifications?: {
                      /** @format uuid */
                      _id: string;
                      certificationCategory: {
                        /** @format uuid */
                        _id: string;
                        _ref: "CertificationCategory";
                      };
                      /** @format date-time */
                      firstIssuedOn: string;
                      /** @format date-time */
                      lastReceivedOn: string;
                      /** @format date-time */
                      expiryDate: string;
                      /**
                       * @format date-time
                       * @default null
                       */
                      plannedRenewalDate?: string | null;
                      /** @maxLength 1024 */
                      documentaryProof?: string | null;
                    }[];
                    type?: "default" | "kiosk";
                    _ref: "Asset";
                  };
                  customer: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  };
                  device: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Device";
                  };
                  user: {
                    /** @format uuid */
                    _id: string;
                    _ref: "User";
                  };
                  /** PII */
                  position?: {
                    type: "Point";
                    /** PII */
                    coordinates: number[];
                    properties: {
                      accuracy?: number;
                      heading?: number;
                      headingAccuracy?: number;
                      speed?: number;
                      speedAccuracy?: number;
                      altitude?: number;
                      altitudeAccuracy?: number;
                      /** PII */
                      address?: {
                        /** @maxLength 1024 */
                        countryCode?: string | null;
                        /** @maxLength 1024 */
                        state?: string | null;
                        /** @maxLength 1024 */
                        city?: string | null;
                        /** @maxLength 1024 */
                        streetName?: string | null;
                        /** @maxLength 1024 */
                        streetNumber?: string | null;
                        floor?: number | null;
                        /** @maxLength 1024 */
                        formattedAddress?: string;
                      };
                      /** @format date-time */
                      dateTime?: string;
                      /** @maxLength 1024 */
                      provider?: string;
                    };
                  };
                  beacons?:
                    | {
                        /** @maxLength 1024 */
                        code: string;
                        rssi: number;
                        battery?: number;
                        /** @format date-time */
                        dateTime: string;
                        beacon: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Beacon";
                        } | null;
                        calc: number | null;
                        valid: boolean;
                      }[]
                    | {
                        /** @maxLength 1024 */
                        code: string;
                        rssi: number;
                        battery?: number;
                        /** @format date-time */
                        dateTime: string;
                      }[];
                  /** PII */
                  meta?: {
                    asset?: {
                      /** @format uuid */
                      _id: string;
                      /** @format date-time */
                      createdAt: string;
                      /** @format date-time */
                      updatedAt: string;
                      telluId?: number | null;
                      migrationFinalised?: boolean | null;
                      /** @format date-time */
                      migrationFinalisedDate?: string | null;
                      customer: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      };
                      /** @default {"type":"parents","extra":[]} */
                      share?: {
                        type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                        extra?: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Customer";
                        }[];
                      };
                      user: {
                        /** @format uuid */
                        _id: string;
                        _ref: "User";
                      } | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      name: string;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      externalId?: string | null;
                      propertiesOwnership?: "override" | "inherit";
                      /** @default {} */
                      properties?: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        phoneNumber?: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        smsNumber?: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        email?: string | null;
                        /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                        locale?: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        image?: string | null;
                        /** PII */
                        rSim?: {
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          euicc: string;
                          primary: {
                            /**
                             * PII
                             * @maxLength 1024
                             */
                            msisdn: string;
                            /**
                             * PII
                             * @maxLength 1024
                             */
                            iccid: string;
                          };
                          secondary: {
                            /**
                             * PII
                             * @maxLength 1024
                             */
                            msisdn: string;
                            /**
                             * PII
                             * @maxLength 1024
                             */
                            iccid: string;
                          };
                          enabled: boolean;
                        } | null;
                      };
                      /**
                       * PII
                       * @default null
                       */
                      position?: {
                        type: "Point";
                        /** PII */
                        coordinates: number[];
                        properties: {
                          accuracy?: number;
                          heading?: number;
                          headingAccuracy?: number;
                          speed?: number;
                          speedAccuracy?: number;
                          altitude?: number;
                          altitudeAccuracy?: number;
                          /** PII */
                          address?: {
                            /** @maxLength 1024 */
                            countryCode?: string | null;
                            /** @maxLength 1024 */
                            state?: string | null;
                            /** @maxLength 1024 */
                            city?: string | null;
                            /** @maxLength 1024 */
                            streetName?: string | null;
                            /** @maxLength 1024 */
                            streetNumber?: string | null;
                            floor?: number | null;
                            /** @maxLength 1024 */
                            formattedAddress?: string;
                          };
                          /** @format date-time */
                          dateTime?: string;
                          /** @maxLength 1024 */
                          provider?: string;
                        };
                      };
                      available: boolean;
                      /** @default true */
                      allowContactOnOwnAlarms?: boolean;
                      app?: {
                        mode: "off" | "on" | "risk";
                      } | null;
                      insideZones: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Zone";
                      }[];
                      assetGroups: {
                        /** @format uuid */
                        _id: string;
                        _ref: "AssetGroup";
                      }[];
                      /** @default [] */
                      staticResponders?: {
                        staticResponder: {
                          /** @format uuid */
                          _id: string;
                          _ref: "StaticResponder";
                        };
                        priority: number;
                      }[];
                      /** @format date-time */
                      lastObservationAt?: string;
                      /** @default false */
                      invisibleResponder?: boolean;
                      /**
                       * PII
                       * @maxLength 4096
                       */
                      description?: string;
                      /** @default [] */
                      certifications?: {
                        /** @format uuid */
                        _id: string;
                        certificationCategory: {
                          /** @format uuid */
                          _id: string;
                          _ref: "CertificationCategory";
                        };
                        /** @format date-time */
                        firstIssuedOn: string;
                        /** @format date-time */
                        lastReceivedOn: string;
                        /** @format date-time */
                        expiryDate: string;
                        /**
                         * @format date-time
                         * @default null
                         */
                        plannedRenewalDate?: string | null;
                        /** @maxLength 1024 */
                        documentaryProof?: string | null;
                      }[];
                      type?: "default" | "kiosk";
                    };
                    battery?: number;
                    rssi?: number;
                    snr?: number;
                    /** @format date-time */
                    dateTime?: string;
                    /** @format date-time */
                    deviceDateTime?: string;
                    /** @format date-time */
                    gatewayDateTime?: string;
                    insideGpsZones?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    }[];
                    insideIpsZones?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    }[];
                    zone?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    };
                    callRequest?: boolean;
                    forceLoraCustomer?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    knnResult?: {
                      distance: number;
                      debugInfo?: any;
                    };
                    available?: boolean;
                  };
                  deltas?: {
                    main: {
                      /** @format date-time */
                      start: string;
                      /** @format date-time */
                      end: string;
                      value?: number;
                    };
                    steps?: {
                      gps?: {
                        /** @format date-time */
                        start: string;
                        /** @format date-time */
                        end: string;
                        value?: number;
                      };
                      ips?: {
                        /** @format date-time */
                        start: string;
                        /** @format date-time */
                        end: string;
                        value?: number;
                      };
                      context?: {
                        /** @format date-time */
                        start: string;
                        /** @format date-time */
                        end: string;
                        value?: number;
                      };
                    };
                  };
                  validPosition?: {
                    value: boolean;
                    /** @maxLength 1024 */
                    reason?: string;
                  };
                  isSystemEvent?: boolean;
                };
                /** PII */
                frozenInfo?: {
                  staticResponse: {
                    type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
                    priority: number;
                    zone?: {
                      /** @format uuid */
                      _id: string;
                      customer?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      };
                      type?:
                        | "default"
                        | "responseArea"
                        | "policeDepartment"
                        | "assetMonitoredArea"
                        | "fingerprinted"
                        | "building"
                        | "evacuationPoint";
                      /** PII */
                      location:
                        | {
                            type: "Point";
                            /** PII */
                            coordinates: number[];
                            properties: {
                              accuracy?: number;
                              heading?: number;
                              headingAccuracy?: number;
                              speed?: number;
                              speedAccuracy?: number;
                              altitude?: number;
                              altitudeAccuracy?: number;
                              /** PII */
                              address?: {
                                /** @maxLength 1024 */
                                countryCode?: string | null;
                                /** @maxLength 1024 */
                                state?: string | null;
                                /** @maxLength 1024 */
                                city?: string | null;
                                /** @maxLength 1024 */
                                streetName?: string | null;
                                /** @maxLength 1024 */
                                streetNumber?: string | null;
                                floor?: number | null;
                                /** @maxLength 1024 */
                                formattedAddress?: string;
                              };
                              /** @format date-time */
                              dateTime?: string;
                              /** @maxLength 1024 */
                              provider?: string;
                            };
                          }
                        | {
                            type: "Polygon";
                            /** PII */
                            coordinates: number[][][];
                            properties: {
                              accuracy?: number;
                              heading?: number;
                              headingAccuracy?: number;
                              speed?: number;
                              speedAccuracy?: number;
                              altitude?: number;
                              altitudeAccuracy?: number;
                              /** PII */
                              address?: {
                                /** @maxLength 1024 */
                                countryCode?: string | null;
                                /** @maxLength 1024 */
                                state?: string | null;
                                /** @maxLength 1024 */
                                city?: string | null;
                                /** @maxLength 1024 */
                                streetName?: string | null;
                                /** @maxLength 1024 */
                                streetNumber?: string | null;
                                floor?: number | null;
                                /** @maxLength 1024 */
                                formattedAddress?: string;
                              };
                              /** @format date-time */
                              dateTime?: string;
                              /** @maxLength 1024 */
                              provider?: string;
                            };
                          }
                        | {
                            type: "MultiPolygon";
                            coordinates: number[][][][];
                            properties: {
                              accuracy?: number;
                              heading?: number;
                              headingAccuracy?: number;
                              speed?: number;
                              speedAccuracy?: number;
                              altitude?: number;
                              altitudeAccuracy?: number;
                              /** PII */
                              address?: {
                                /** @maxLength 1024 */
                                countryCode?: string | null;
                                /** @maxLength 1024 */
                                state?: string | null;
                                /** @maxLength 1024 */
                                city?: string | null;
                                /** @maxLength 1024 */
                                streetName?: string | null;
                                /** @maxLength 1024 */
                                streetNumber?: string | null;
                                floor?: number | null;
                                /** @maxLength 1024 */
                                formattedAddress?: string;
                              };
                              /** @format date-time */
                              dateTime?: string;
                              /** @maxLength 1024 */
                              provider?: string;
                            };
                          };
                      /** @maxLength 1024 */
                      name: string;
                      staticResponders: {
                        staticResponder: {
                          /** @format uuid */
                          _id: string;
                          _ref: "StaticResponder";
                        };
                        priority: number;
                      }[];
                    };
                    responders: {
                      info: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Asset" | "StaticResponder";
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        name: string;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        image: string | null;
                        /** PII */
                        position: {
                          type: "Point";
                          /** PII */
                          coordinates: number[];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        };
                        /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                        locale: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        contactCode: string | null;
                      };
                      distanceKm: number | null;
                      actions: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        call: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        sms: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        email: string | null;
                        notification: boolean;
                      };
                      priority: number;
                      professionalResponder?: {
                        available: boolean;
                        inProgress: boolean;
                      };
                    }[];
                  }[];
                  dynamicResponse: {
                    type: "nearby" | "personal" | "zone" | "police" | "alarmProfessionalResponder";
                    priority: number;
                    zone?: {
                      /** @format uuid */
                      _id: string;
                      customer?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      };
                      type?:
                        | "default"
                        | "responseArea"
                        | "policeDepartment"
                        | "assetMonitoredArea"
                        | "fingerprinted"
                        | "building"
                        | "evacuationPoint";
                      /** PII */
                      location:
                        | {
                            type: "Point";
                            /** PII */
                            coordinates: number[];
                            properties: {
                              accuracy?: number;
                              heading?: number;
                              headingAccuracy?: number;
                              speed?: number;
                              speedAccuracy?: number;
                              altitude?: number;
                              altitudeAccuracy?: number;
                              /** PII */
                              address?: {
                                /** @maxLength 1024 */
                                countryCode?: string | null;
                                /** @maxLength 1024 */
                                state?: string | null;
                                /** @maxLength 1024 */
                                city?: string | null;
                                /** @maxLength 1024 */
                                streetName?: string | null;
                                /** @maxLength 1024 */
                                streetNumber?: string | null;
                                floor?: number | null;
                                /** @maxLength 1024 */
                                formattedAddress?: string;
                              };
                              /** @format date-time */
                              dateTime?: string;
                              /** @maxLength 1024 */
                              provider?: string;
                            };
                          }
                        | {
                            type: "Polygon";
                            /** PII */
                            coordinates: number[][][];
                            properties: {
                              accuracy?: number;
                              heading?: number;
                              headingAccuracy?: number;
                              speed?: number;
                              speedAccuracy?: number;
                              altitude?: number;
                              altitudeAccuracy?: number;
                              /** PII */
                              address?: {
                                /** @maxLength 1024 */
                                countryCode?: string | null;
                                /** @maxLength 1024 */
                                state?: string | null;
                                /** @maxLength 1024 */
                                city?: string | null;
                                /** @maxLength 1024 */
                                streetName?: string | null;
                                /** @maxLength 1024 */
                                streetNumber?: string | null;
                                floor?: number | null;
                                /** @maxLength 1024 */
                                formattedAddress?: string;
                              };
                              /** @format date-time */
                              dateTime?: string;
                              /** @maxLength 1024 */
                              provider?: string;
                            };
                          }
                        | {
                            type: "MultiPolygon";
                            coordinates: number[][][][];
                            properties: {
                              accuracy?: number;
                              heading?: number;
                              headingAccuracy?: number;
                              speed?: number;
                              speedAccuracy?: number;
                              altitude?: number;
                              altitudeAccuracy?: number;
                              /** PII */
                              address?: {
                                /** @maxLength 1024 */
                                countryCode?: string | null;
                                /** @maxLength 1024 */
                                state?: string | null;
                                /** @maxLength 1024 */
                                city?: string | null;
                                /** @maxLength 1024 */
                                streetName?: string | null;
                                /** @maxLength 1024 */
                                streetNumber?: string | null;
                                floor?: number | null;
                                /** @maxLength 1024 */
                                formattedAddress?: string;
                              };
                              /** @format date-time */
                              dateTime?: string;
                              /** @maxLength 1024 */
                              provider?: string;
                            };
                          };
                      /** @maxLength 1024 */
                      name: string;
                      staticResponders: {
                        staticResponder: {
                          /** @format uuid */
                          _id: string;
                          _ref: "StaticResponder";
                        };
                        priority: number;
                      }[];
                    };
                    responders: {
                      info: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Asset" | "StaticResponder";
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        name: string;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        image: string | null;
                        /** PII */
                        position: {
                          type: "Point";
                          /** PII */
                          coordinates: number[];
                          properties: {
                            accuracy?: number;
                            heading?: number;
                            headingAccuracy?: number;
                            speed?: number;
                            speedAccuracy?: number;
                            altitude?: number;
                            altitudeAccuracy?: number;
                            /** PII */
                            address?: {
                              /** @maxLength 1024 */
                              countryCode?: string | null;
                              /** @maxLength 1024 */
                              state?: string | null;
                              /** @maxLength 1024 */
                              city?: string | null;
                              /** @maxLength 1024 */
                              streetName?: string | null;
                              /** @maxLength 1024 */
                              streetNumber?: string | null;
                              floor?: number | null;
                              /** @maxLength 1024 */
                              formattedAddress?: string;
                            };
                            /** @format date-time */
                            dateTime?: string;
                            /** @maxLength 1024 */
                            provider?: string;
                          };
                        };
                        /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                        locale: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        contactCode: string | null;
                      };
                      distanceKm: number | null;
                      actions: {
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        call: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        sms: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        email: string | null;
                        notification: boolean;
                      };
                      priority: number;
                      professionalResponder?: {
                        available: boolean;
                        inProgress: boolean;
                      };
                    }[];
                  }[];
                  professionalResponders?: {
                    /** @format uuid */
                    _id: string;
                    /** @format date-time */
                    createdAt: string;
                    /** @format date-time */
                    updatedAt: string;
                    telluId?: number | null;
                    migrationFinalised?: boolean | null;
                    /** @format date-time */
                    migrationFinalisedDate?: string | null;
                    customer: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    };
                    /** @default {"type":"parents","extra":[]} */
                    share?: {
                      type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                      extra?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      }[];
                    };
                    type: "sequrix";
                    active: boolean;
                    status:
                      | "invited"
                      | "accepted"
                      | "rejected"
                      | "started"
                      | "onLocation"
                      | "finished"
                      | "error"
                      | "canceled";
                    alarm: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Alarm";
                    };
                    asset: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset";
                    };
                    staticResponder: {
                      /** @format uuid */
                      _id: string;
                      /** @format date-time */
                      createdAt: string;
                      /** @format date-time */
                      updatedAt: string;
                      telluId?: number | null;
                      migrationFinalised?: boolean | null;
                      /** @format date-time */
                      migrationFinalisedDate?: string | null;
                      customer: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Customer";
                      };
                      /** @default {"type":"parents","extra":[]} */
                      share?: {
                        type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                        extra?: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Customer";
                        }[];
                      };
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      name: string;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      externalId: string | null;
                      contact: {
                        /**
                         * PII
                         * @pattern ^([\w+\-.]+@([\w-]+\.)+[\w-]{2,}[, ]*?)+?$
                         */
                        email: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        phone: string | null;
                        /**
                         * PII
                         * @maxLength 1024
                         */
                        sms: string | null;
                        /** @maxLength 1024 */
                        camera: string | null;
                      };
                      schedule: {
                        entries: {
                          daysOfWeek: number[];
                          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                          timeStart: string;
                          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                          timeEnd: string;
                        }[];
                      } | null;
                      /** @maxLength 1024 */
                      migrationKey?: string;
                      integrations?: {
                        sequrix: {
                          enabled: boolean;
                          /**
                           * PII
                           * @maxLength 1024
                           */
                          objectCode: string;
                        };
                      };
                      /** PII */
                      statistics?: {
                        /**
                         * @maxItems 10
                         * @minItems 0
                         */
                        acceptSpeeds: {
                          /** @format date-time */
                          timestamp: string;
                          /**
                           * @min 0
                           * @exclusiveMin false
                           */
                          speedMs: number;
                        }[];
                        /**
                         * @maxItems 10
                         * @minItems 0
                         */
                        onLocationSpeeds: {
                          /** @format date-time */
                          timestamp: string;
                          /**
                           * @min 0
                           * @exclusiveMin false
                           */
                          speedMs: number;
                        }[];
                        /**
                         * @maxItems 10
                         * @minItems 0
                         */
                        finishSpeeds: {
                          /** @format date-time */
                          timestamp: string;
                          /**
                           * @min 0
                           * @exclusiveMin false
                           */
                          speedMs: number;
                        }[];
                        /**
                         * @min 0
                         * @exclusiveMin false
                         */
                        amountRejected: number;
                        /**
                         * @min 0
                         * @exclusiveMin false
                         */
                        amountAccepted: number;
                      };
                      _ref: "StaticResponder";
                    };
                    /** PII */
                    statistics: {
                      /** @format date-time */
                      invitedAt: string;
                      /** @format date-time */
                      acceptedAt: string | null;
                      /** @format date-time */
                      rejectedAt: string | null;
                      /** @format date-time */
                      startedAt: string | null;
                      /** @format date-time */
                      onLocationAt: string | null;
                      /** @format date-time */
                      finishedAt: string | null;
                    };
                    meta: {
                      /**
                       * PII
                       * @maxLength 4096
                       */
                      comment?: string;
                      /** PII */
                      photos?: {
                        /** @format date-time */
                        timestamp: string;
                        /** @maxLength 1024 */
                        url: string;
                      }[];
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      overridePhoneNumber?: string;
                    };
                    supersededBy: {
                      /** @format uuid */
                      _id: string;
                      _ref: "AlarmProfessionalResponder";
                    } | null;
                  }[];
                };
              };
            }[];
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/alarms/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  assetGroups = {
    /**
     * @description Creates a AssetGroup
     *
     * @tags AssetGroup
     * @name AssetGroupsControllerCreate
     * @request POST:/asset-groups
     * @secure
     */
    assetGroupsControllerCreate: (
      data: AssetGroupCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetGroupOutputDto, any>({
        path: `/asset-groups`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates AssetGroup
     *
     * @tags AssetGroup
     * @name AssetGroupsControllerPaginate
     * @request GET:/asset-groups
     * @secure
     */
    assetGroupsControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /** @maxLength 1024 */
            description?: string | null;
            assets: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            }[];
            clientConfig?: {
              app?: {
                definitions: (
                  | {
                      type: "key";
                      key: string;
                      value: any;
                      editableBy?: ("AssetGroup" | "Device")[];
                    }
                  | {
                      type: "group";
                      group: {
                        /** @format uuid */
                        _id: string;
                        _ref: "ClientConfigGroup";
                      };
                    }
                )[];
                filter?: {
                  type: "osFilter";
                  osType: "ios" | "android";
                  /** @maxLength 1024 */
                  osVersionRange?: string;
                };
              }[];
              kiosk?: {
                definitions: (
                  | {
                      type: "key";
                      key: string;
                      value: any;
                      editableBy?: ("AssetGroup" | "Device")[];
                    }
                  | {
                      type: "group";
                      group: {
                        /** @format uuid */
                        _id: string;
                        _ref: "ClientConfigGroup";
                      };
                    }
                )[];
                filter?: {
                  type: "osFilter";
                  osType: "ios" | "android";
                  /** @maxLength 1024 */
                  osVersionRange?: string;
                };
              }[];
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/asset-groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a AssetGroup by id
     *
     * @tags AssetGroup
     * @name AssetGroupsControllerFindById
     * @request GET:/asset-groups/{id}
     * @secure
     */
    assetGroupsControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetGroupOutputDto, any>({
        path: `/asset-groups/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a AssetGroup
     *
     * @tags AssetGroup
     * @name AssetGroupsControllerUpdate
     * @request PATCH:/asset-groups/{id}
     * @secure
     */
    assetGroupsControllerUpdate: (
      id: string,
      data: AssetGroupUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetGroupOutputDto, any>({
        path: `/asset-groups/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a AssetGroup by id
     *
     * @tags AssetGroup
     * @name AssetGroupsControllerRemove
     * @request DELETE:/asset-groups/{id}
     * @secure
     */
    assetGroupsControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/asset-groups/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AssetGroup
     * @name AssetGroupsControllerAddAssets
     * @request POST:/asset-groups/{id}/assets
     * @secure
     */
    assetGroupsControllerAddAssets: (
      id: string,
      data: AssetGroupAddAssetsDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/asset-groups/${id}/assets`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AssetGroup
     * @name AssetGroupsControllerMassUpdate
     * @request POST:/asset-groups/mass-update
     * @secure
     */
    assetGroupsControllerMassUpdate: (
      data: AssetGroupMassUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/asset-groups/mass-update`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Searches AssetGroup
     *
     * @tags AssetGroup
     * @name AssetGroupsControllerSearch
     * @request GET:/asset-groups/search
     * @secure
     */
    assetGroupsControllerSearch: (
      query: {
        /** The search query string */
        q: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /** @maxLength 1024 */
            description?: string | null;
            assets: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            }[];
            clientConfig?: {
              app?: {
                definitions: (
                  | {
                      type: "key";
                      key: string;
                      value: any;
                      editableBy?: ("AssetGroup" | "Device")[];
                    }
                  | {
                      type: "group";
                      group: {
                        /** @format uuid */
                        _id: string;
                        _ref: "ClientConfigGroup";
                      };
                    }
                )[];
                filter?: {
                  type: "osFilter";
                  osType: "ios" | "android";
                  /** @maxLength 1024 */
                  osVersionRange?: string;
                };
              }[];
              kiosk?: {
                definitions: (
                  | {
                      type: "key";
                      key: string;
                      value: any;
                      editableBy?: ("AssetGroup" | "Device")[];
                    }
                  | {
                      type: "group";
                      group: {
                        /** @format uuid */
                        _id: string;
                        _ref: "ClientConfigGroup";
                      };
                    }
                )[];
                filter?: {
                  type: "osFilter";
                  osType: "ios" | "android";
                  /** @maxLength 1024 */
                  osVersionRange?: string;
                };
              }[];
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/asset-groups/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  assetPropertyVerifications = {
    /**
     * @description Creates a AssetPropertyVerification
     *
     * @tags AssetPropertyVerification
     * @name AssetPropertyVerificationsControllerCreate
     * @request POST:/asset-property-verifications
     * @secure
     */
    assetPropertyVerificationsControllerCreate: (
      data: AssetPropertyVerificationCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetPropertyVerificationOutputDto, any>({
        path: `/asset-property-verifications`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a AssetPropertyVerification
     *
     * @tags AssetPropertyVerification
     * @name AssetPropertyVerificationsControllerVerify
     * @request POST:/asset-property-verifications/verify
     * @secure
     */
    assetPropertyVerificationsControllerVerify: (
      data: AssetPropertyVerifyCodeDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetPropertyVerificationOutputDto, any>({
        path: `/asset-property-verifications/verify`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  assets = {
    /**
     * @description Creates a Asset
     *
     * @tags Asset
     * @name AssetsControllerCreate
     * @request POST:/assets
     * @secure
     */
    assetsControllerCreate: (
      data: AssetCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetOutputDto, any>({
        path: `/assets`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates Asset
     *
     * @tags Asset
     * @name AssetsControllerPaginate
     * @request GET:/assets
     * @secure
     */
    assetsControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            user: {
              /** @format uuid */
              _id: string;
              _ref: "User";
            } | null;
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /**
             * PII
             * @maxLength 1024
             */
            externalId?: string | null;
            propertiesOwnership?: "override" | "inherit";
            /** @default {} */
            properties?: {
              /**
               * PII
               * @maxLength 1024
               */
              phoneNumber?: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              smsNumber?: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              email?: string | null;
              /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
              locale?: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              image?: string | null;
              /** PII */
              rSim?: {
                /**
                 * PII
                 * @maxLength 1024
                 */
                euicc: string;
                primary: {
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  msisdn: string;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  iccid: string;
                };
                secondary: {
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  msisdn: string;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  iccid: string;
                };
                enabled: boolean;
              } | null;
            };
            /**
             * PII
             * @default null
             */
            position?: {
              type: "Point";
              /** PII */
              coordinates: number[];
              properties: {
                accuracy?: number;
                heading?: number;
                headingAccuracy?: number;
                speed?: number;
                speedAccuracy?: number;
                altitude?: number;
                altitudeAccuracy?: number;
                /** PII */
                address?: {
                  /** @maxLength 1024 */
                  countryCode?: string | null;
                  /** @maxLength 1024 */
                  state?: string | null;
                  /** @maxLength 1024 */
                  city?: string | null;
                  /** @maxLength 1024 */
                  streetName?: string | null;
                  /** @maxLength 1024 */
                  streetNumber?: string | null;
                  floor?: number | null;
                  /** @maxLength 1024 */
                  formattedAddress?: string;
                };
                /** @format date-time */
                dateTime?: string;
                /** @maxLength 1024 */
                provider?: string;
              };
            };
            available: boolean;
            /** @default true */
            allowContactOnOwnAlarms?: boolean;
            app?: {
              mode: "off" | "on" | "risk";
            } | null;
            insideZones: {
              /** @format uuid */
              _id: string;
              _ref: "Zone";
            }[];
            assetGroups: {
              /** @format uuid */
              _id: string;
              _ref: "AssetGroup";
            }[];
            /** @default [] */
            staticResponders?: {
              staticResponder: {
                /** @format uuid */
                _id: string;
                _ref: "StaticResponder";
              };
              priority: number;
            }[];
            /** @format date-time */
            lastObservationAt?: string;
            /** @default false */
            invisibleResponder?: boolean;
            /**
             * PII
             * @maxLength 4096
             */
            description?: string;
            /** @default [] */
            certifications?: {
              /** @format uuid */
              _id: string;
              certificationCategory: {
                /** @format uuid */
                _id: string;
                _ref: "CertificationCategory";
              };
              /** @format date-time */
              firstIssuedOn: string;
              /** @format date-time */
              lastReceivedOn: string;
              /** @format date-time */
              expiryDate: string;
              /**
               * @format date-time
               * @default null
               */
              plannedRenewalDate?: string | null;
              /** @maxLength 1024 */
              documentaryProof?: string | null;
            }[];
            type?: "default" | "kiosk";
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/assets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a Asset by id
     *
     * @tags Asset
     * @name AssetsControllerFindById
     * @request GET:/assets/{id}
     * @secure
     */
    assetsControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetOutputDto, any>({
        path: `/assets/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a Asset
     *
     * @tags Asset
     * @name AssetsControllerUpdate
     * @request PATCH:/assets/{id}
     * @secure
     */
    assetsControllerUpdate: (
      id: string,
      data: AssetUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetOutputDto, any>({
        path: `/assets/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a Asset by id
     *
     * @tags Asset
     * @name AssetsControllerRemove
     * @request DELETE:/assets/{id}
     * @secure
     */
    assetsControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/assets/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name AssetsControllerCreateAssetCertification
     * @request POST:/assets/{id}/certifications
     * @secure
     */
    assetsControllerCreateAssetCertification: (
      id: string,
      data: AssetCertificationCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/assets/${id}/certifications`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name AssetsControllerUpdateAssetCertification
     * @request PATCH:/assets/{id}/certifications/{certificationId}
     * @secure
     */
    assetsControllerUpdateAssetCertification: (
      id: string,
      certificationId: string,
      data: AssetCertificationUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/assets/${id}/certifications/${certificationId}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name AssetsControllerDeleteAssetCertification
     * @request DELETE:/assets/{id}/certifications/{certificationId}
     * @secure
     */
    assetsControllerDeleteAssetCertification: (
      id: string,
      certificationId: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/assets/${id}/certifications/${certificationId}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name AssetsControllerUpdateAssetCertificationDocument
     * @request POST:/assets/{id}/certifications/{certificationId}/document
     * @secure
     */
    assetsControllerUpdateAssetCertificationDocument: (
      id: string,
      certificationId: string,
      data: {
        /** @format binary */
        document: File;
      },
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetCertificationDocumentUploadDto, any>({
        path: `/assets/${id}/certifications/${certificationId}/document`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a Asset
     *
     * @tags Asset
     * @name AssetsControllerUpdateVerifiedProperties
     * @request PATCH:/assets/{id}/verified-properties
     * @secure
     */
    assetsControllerUpdateVerifiedProperties: (
      id: string,
      data: VerifiedAssetPropertyUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetOutputDto, any>({
        path: `/assets/${id}/verified-properties`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name AssetsControllerDeleteViaApp
     * @request DELETE:/assets/app
     * @secure
     */
    assetsControllerDeleteViaApp: (
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/assets/app`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name AssetsControllerDeleteAppUser
     * @request DELETE:/assets/app-user
     * @secure
     */
    assetsControllerDeleteAppUser: (
      data: AssetAppUserDeleteDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/assets/app-user`,
        method: "DELETE",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name AssetsControllerAppMode
     * @request PATCH:/assets/app/mode
     * @secure
     */
    assetsControllerAppMode: (
      data: AssetAppUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/assets/app/mode`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name AssetsControllerAddPhoto
     * @request POST:/assets/app/photo
     * @secure
     */
    assetsControllerAddPhoto: (
      data: {
        /** File to upload, or the string "null" to remove the existing file. */
        photo_url?: File | "null";
      },
      query?: {
        /** Asset id parameter, optional */
        id?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ImageUploadDto, any>({
        path: `/assets/app/photo`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name AssetsControllerAtsResponse
     * @request POST:/assets/ats-response
     * @secure
     */
    assetsControllerAtsResponse: (
      data: AssetGetAtsResponseDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/assets/ats-response`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name AssetsControllerPublishCertificationsToReport
     * @request POST:/assets/certifications/to-report
     * @secure
     */
    assetsControllerPublishCertificationsToReport: (
      data: PublishCertificationsToReportDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/assets/certifications/to-report`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name AssetsControllerGetCountOfCertificationsConsideredExpiring
     * @request GET:/assets/count-of-certifications-considered-expiring/{customerId}
     * @secure
     */
    assetsControllerGetCountOfCertificationsConsideredExpiring: (
      customerId: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/assets/count-of-certifications-considered-expiring/${customerId}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name AssetsControllerMoveAsset
     * @request POST:/assets/move
     * @secure
     */
    assetsControllerMoveAsset: (
      data: AssetMoveDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/assets/move`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Searches Asset
     *
     * @tags Asset
     * @name AssetsControllerSearch
     * @request GET:/assets/search
     * @secure
     */
    assetsControllerSearch: (
      query: {
        /** The search query string */
        q: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            user: {
              /** @format uuid */
              _id: string;
              _ref: "User";
            } | null;
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /**
             * PII
             * @maxLength 1024
             */
            externalId?: string | null;
            propertiesOwnership?: "override" | "inherit";
            /** @default {} */
            properties?: {
              /**
               * PII
               * @maxLength 1024
               */
              phoneNumber?: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              smsNumber?: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              email?: string | null;
              /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
              locale?: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              image?: string | null;
              /** PII */
              rSim?: {
                /**
                 * PII
                 * @maxLength 1024
                 */
                euicc: string;
                primary: {
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  msisdn: string;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  iccid: string;
                };
                secondary: {
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  msisdn: string;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  iccid: string;
                };
                enabled: boolean;
              } | null;
            };
            /**
             * PII
             * @default null
             */
            position?: {
              type: "Point";
              /** PII */
              coordinates: number[];
              properties: {
                accuracy?: number;
                heading?: number;
                headingAccuracy?: number;
                speed?: number;
                speedAccuracy?: number;
                altitude?: number;
                altitudeAccuracy?: number;
                /** PII */
                address?: {
                  /** @maxLength 1024 */
                  countryCode?: string | null;
                  /** @maxLength 1024 */
                  state?: string | null;
                  /** @maxLength 1024 */
                  city?: string | null;
                  /** @maxLength 1024 */
                  streetName?: string | null;
                  /** @maxLength 1024 */
                  streetNumber?: string | null;
                  floor?: number | null;
                  /** @maxLength 1024 */
                  formattedAddress?: string;
                };
                /** @format date-time */
                dateTime?: string;
                /** @maxLength 1024 */
                provider?: string;
              };
            };
            available: boolean;
            /** @default true */
            allowContactOnOwnAlarms?: boolean;
            app?: {
              mode: "off" | "on" | "risk";
            } | null;
            insideZones: {
              /** @format uuid */
              _id: string;
              _ref: "Zone";
            }[];
            assetGroups: {
              /** @format uuid */
              _id: string;
              _ref: "AssetGroup";
            }[];
            /** @default [] */
            staticResponders?: {
              staticResponder: {
                /** @format uuid */
                _id: string;
                _ref: "StaticResponder";
              };
              priority: number;
            }[];
            /** @format date-time */
            lastObservationAt?: string;
            /** @default false */
            invisibleResponder?: boolean;
            /**
             * PII
             * @maxLength 4096
             */
            description?: string;
            /** @default [] */
            certifications?: {
              /** @format uuid */
              _id: string;
              certificationCategory: {
                /** @format uuid */
                _id: string;
                _ref: "CertificationCategory";
              };
              /** @format date-time */
              firstIssuedOn: string;
              /** @format date-time */
              lastReceivedOn: string;
              /** @format date-time */
              expiryDate: string;
              /**
               * @format date-time
               * @default null
               */
              plannedRenewalDate?: string | null;
              /** @maxLength 1024 */
              documentaryProof?: string | null;
            }[];
            type?: "default" | "kiosk";
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/assets/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  beacons = {
    /**
     * @description Creates a Beacon
     *
     * @tags Beacon
     * @name BeaconsControllerCreate
     * @request POST:/beacons
     * @secure
     */
    beaconsControllerCreate: (
      data: BeaconCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BeaconOutputDto, any>({
        path: `/beacons`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates Beacon
     *
     * @tags Beacon
     * @name BeaconsControllerPaginate
     * @request GET:/beacons
     * @secure
     */
    beaconsControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            codes: string[];
            /**
             * @min 0
             * @exclusiveMin false
             */
            rssiAddend: number;
            type: "default" | "tag";
            state: {
              lastSeenBy?: {
                /** @format uuid */
                _id: string;
                _ref: "Asset";
              } | null;
              /** @format date-time */
              lastSeenAt?: string | null;
              battery?: number | null;
            };
            zone?: {
              /** @format uuid */
              _id: string;
              _ref: "Zone";
            } | null;
            /** PII */
            location?:
              | {
                  type: "Point";
                  /** PII */
                  coordinates: number[];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                }
              | {
                  type: "Polygon";
                  /** PII */
                  coordinates: number[][][];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                }
              | {
                  type: "MultiPolygon";
                  coordinates: number[][][][];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/beacons`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a Beacon by id
     *
     * @tags Beacon
     * @name BeaconsControllerFindById
     * @request GET:/beacons/{id}
     * @secure
     */
    beaconsControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BeaconOutputDto, any>({
        path: `/beacons/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a Beacon
     *
     * @tags Beacon
     * @name BeaconsControllerUpdate
     * @request PATCH:/beacons/{id}
     * @secure
     */
    beaconsControllerUpdate: (
      id: string,
      data: BeaconUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BeaconOutputDto, any>({
        path: `/beacons/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a Beacon by id
     *
     * @tags Beacon
     * @name BeaconsControllerRemove
     * @request DELETE:/beacons/{id}
     * @secure
     */
    beaconsControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/beacons/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Beacon
     * @name BeaconsControllerObserve
     * @request POST:/beacons/observe
     * @secure
     */
    beaconsControllerObserve: (
      data: ObserveBeaconsDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ObserveBeaconsResponse, any>({
        path: `/beacons/observe`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Searches Beacon
     *
     * @tags Beacon
     * @name BeaconsControllerSearch
     * @request GET:/beacons/search
     * @secure
     */
    beaconsControllerSearch: (
      query: {
        /** The search query string */
        q: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            codes: string[];
            /**
             * @min 0
             * @exclusiveMin false
             */
            rssiAddend: number;
            type: "default" | "tag";
            state: {
              lastSeenBy?: {
                /** @format uuid */
                _id: string;
                _ref: "Asset";
              } | null;
              /** @format date-time */
              lastSeenAt?: string | null;
              battery?: number | null;
            };
            zone?: {
              /** @format uuid */
              _id: string;
              _ref: "Zone";
            } | null;
            /** PII */
            location?:
              | {
                  type: "Point";
                  /** PII */
                  coordinates: number[];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                }
              | {
                  type: "Polygon";
                  /** PII */
                  coordinates: number[][][];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                }
              | {
                  type: "MultiPolygon";
                  coordinates: number[][][][];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/beacons/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  certificationCategories = {
    /**
     * @description Creates a CertificationCategory
     *
     * @tags CertificationCategory
     * @name CertificationCategoriesControllerCreate
     * @request POST:/certification-categories
     * @secure
     */
    certificationCategoriesControllerCreate: (
      data: CertificationCategoryCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CertificationCategoryOutputDto, any>({
        path: `/certification-categories`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates CertificationCategory
     *
     * @tags CertificationCategory
     * @name CertificationCategoriesControllerPaginate
     * @request GET:/certification-categories
     * @secure
     */
    certificationCategoriesControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /** @maxLength 1024 */
            name: string;
            /** @maxLength 1024 */
            description?: string | null;
            validityPeriod: {
              type: "day" | "week" | "month" | "year";
              value: number;
            };
            reminderPeriods: {
              type: "day" | "week" | "month" | "year";
              value: number;
            }[];
            notifiedPeople: {
              peopleToNotify: {
                /** @format uuid */
                _id: string;
                _ref: "Asset";
              }[];
              /** @default true */
              isCertificationHolderNotified?: boolean;
              /** PII */
              emails: string[];
            };
            /** @default false */
            isDocumentaryProofRequired?: boolean;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/certification-categories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a CertificationCategory by id
     *
     * @tags CertificationCategory
     * @name CertificationCategoriesControllerFindById
     * @request GET:/certification-categories/{id}
     * @secure
     */
    certificationCategoriesControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CertificationCategoryOutputDto, any>({
        path: `/certification-categories/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a CertificationCategory
     *
     * @tags CertificationCategory
     * @name CertificationCategoriesControllerUpdate
     * @request PATCH:/certification-categories/{id}
     * @secure
     */
    certificationCategoriesControllerUpdate: (
      id: string,
      data: CertificationCategoryUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CertificationCategoryOutputDto, any>({
        path: `/certification-categories/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a CertificationCategory by id
     *
     * @tags CertificationCategory
     * @name CertificationCategoriesControllerRemove
     * @request DELETE:/certification-categories/{id}
     * @secure
     */
    certificationCategoriesControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/certification-categories/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Searches CertificationCategory
     *
     * @tags CertificationCategory
     * @name CertificationCategoriesControllerSearch
     * @request GET:/certification-categories/search
     * @secure
     */
    certificationCategoriesControllerSearch: (
      query: {
        /** The search query string */
        q: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /** @maxLength 1024 */
            name: string;
            /** @maxLength 1024 */
            description?: string | null;
            validityPeriod: {
              type: "day" | "week" | "month" | "year";
              value: number;
            };
            reminderPeriods: {
              type: "day" | "week" | "month" | "year";
              value: number;
            }[];
            notifiedPeople: {
              peopleToNotify: {
                /** @format uuid */
                _id: string;
                _ref: "Asset";
              }[];
              /** @default true */
              isCertificationHolderNotified?: boolean;
              /** PII */
              emails: string[];
            };
            /** @default false */
            isDocumentaryProofRequired?: boolean;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/certification-categories/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  clientConfig = {
    /**
     * @description Creates a ClientConfigGroup
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerCreateGroup
     * @request POST:/client-config/groups
     * @secure
     */
    clientConfigControllerCreateGroup: (
      data: ClientConfigGroupCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ClientConfigGroupOutputDto, any>({
        path: `/client-config/groups`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates ClientConfigGroup
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerPaginateGroups
     * @request GET:/client-config/groups
     * @secure
     */
    clientConfigControllerPaginateGroups: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            /** PII */
            name: string;
            clientConfig: {
              app?: {
                definitions: (
                  | {
                      type: "key";
                      key: string;
                      value: any;
                      editableBy?: ("AssetGroup" | "Device")[];
                    }
                  | {
                      type: "group";
                      group: {
                        /** @format uuid */
                        _id: string;
                        _ref: "ClientConfigGroup";
                      };
                    }
                )[];
                filter?: {
                  type: "osFilter";
                  osType: "ios" | "android";
                  /** @maxLength 1024 */
                  osVersionRange?: string;
                };
              }[];
              kiosk?: {
                definitions: (
                  | {
                      type: "key";
                      key: string;
                      value: any;
                      editableBy?: ("AssetGroup" | "Device")[];
                    }
                  | {
                      type: "group";
                      group: {
                        /** @format uuid */
                        _id: string;
                        _ref: "ClientConfigGroup";
                      };
                    }
                )[];
                filter?: {
                  type: "osFilter";
                  osType: "ios" | "android";
                  /** @maxLength 1024 */
                  osVersionRange?: string;
                };
              }[];
            };
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            } | null;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/client-config/groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a ClientConfigGroup by id
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerFindGroupById
     * @request GET:/client-config/groups/{id}
     * @secure
     */
    clientConfigControllerFindGroupById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ClientConfigGroupOutputDto, any>({
        path: `/client-config/groups/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a ClientConfigGroup
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerUpdateGroup
     * @request PATCH:/client-config/groups/{id}
     * @secure
     */
    clientConfigControllerUpdateGroup: (
      id: string,
      data: ClientConfigGroupUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ClientConfigGroupOutputDto, any>({
        path: `/client-config/groups/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a ClientConfigGroup by id
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerRemoveGroup
     * @request DELETE:/client-config/groups/{id}
     * @secure
     */
    clientConfigControllerRemoveGroup: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/client-config/groups/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Paginates ClientConfigKey
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerPaginateKeys
     * @request GET:/client-config/keys
     * @secure
     */
    clientConfigControllerPaginateKeys: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            platform: "app" | "kiosk";
            editableBy: ("Customer" | "AssetGroup" | "Device")[];
            key: string;
            defaultValue: any;
            overrides?: {
              value: any;
              editableBy?: ("Customer" | "AssetGroup" | "Device")[];
              filter: {
                type: "osFilter";
                osType: "ios" | "android";
                /** @maxLength 1024 */
                osVersionRange?: string;
              };
            }[];
            version: number;
            manuallyUpdated?: boolean;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/client-config/keys`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a ClientConfigKey by id
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerFindKeyById
     * @request GET:/client-config/keys/{id}
     * @secure
     */
    clientConfigControllerFindKeyById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ClientConfigKeyOutputDto, any>({
        path: `/client-config/keys/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a ClientConfigKey
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerUpdateKey
     * @request PATCH:/client-config/keys/{id}
     * @secure
     */
    clientConfigControllerUpdateKey: (
      id: string,
      data: ClientConfigKeyUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ClientConfigKeyOutputDto, any>({
        path: `/client-config/keys/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a ClientConfigKey by id
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerRemoveKey
     * @request DELETE:/client-config/keys/{id}
     * @secure
     */
    clientConfigControllerRemoveKey: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/client-config/keys/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerResolveAppAssetGroupConfigV0
     * @request GET:/client-config/resolve/app/0/assetGroup/{id}
     * @secure
     */
    clientConfigControllerResolveAppAssetGroupConfigV0: (id: string, params: RequestParams = {}) =>
      this.request<ClientConfigResolveAppV0Dto, any>({
        path: `/client-config/resolve/app/0/assetGroup/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerResolveAppCustomerConfigV0
     * @request GET:/client-config/resolve/app/0/customer/{id}
     * @secure
     */
    clientConfigControllerResolveAppCustomerConfigV0: (id: string, params: RequestParams = {}) =>
      this.request<ClientConfigResolveAppV0Dto, any>({
        path: `/client-config/resolve/app/0/customer/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerResolveAppDefaultConfigV0
     * @request GET:/client-config/resolve/app/0/default
     * @secure
     */
    clientConfigControllerResolveAppDefaultConfigV0: (params: RequestParams = {}) =>
      this.request<ClientConfigResolveAppV0Dto, any>({
        path: `/client-config/resolve/app/0/default`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerResolveAppDeviceConfigV0
     * @request GET:/client-config/resolve/app/0/device/{id}
     * @secure
     */
    clientConfigControllerResolveAppDeviceConfigV0: (id: string, params: RequestParams = {}) =>
      this.request<ClientConfigResolveAppV0Dto, any>({
        path: `/client-config/resolve/app/0/device/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerResolveKioskAssetGroupConfigV0
     * @request GET:/client-config/resolve/kiosk/0/assetGroup/{id}
     * @secure
     */
    clientConfigControllerResolveKioskAssetGroupConfigV0: (id: string, params: RequestParams = {}) =>
      this.request<ClientConfigResolveKioskV0Dto, any>({
        path: `/client-config/resolve/kiosk/0/assetGroup/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerResolveKioskCustomerConfigV0
     * @request GET:/client-config/resolve/kiosk/0/customer/{id}
     * @secure
     */
    clientConfigControllerResolveKioskCustomerConfigV0: (id: string, params: RequestParams = {}) =>
      this.request<ClientConfigResolveKioskV0Dto, any>({
        path: `/client-config/resolve/kiosk/0/customer/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerResolveKioskDefaultConfigV0
     * @request GET:/client-config/resolve/kiosk/0/default
     * @secure
     */
    clientConfigControllerResolveKioskDefaultConfigV0: (params: RequestParams = {}) =>
      this.request<ClientConfigResolveKioskV0Dto, any>({
        path: `/client-config/resolve/kiosk/0/default`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerResolveKioskDeviceConfigV0
     * @request GET:/client-config/resolve/kiosk/0/device/{id}
     * @secure
     */
    clientConfigControllerResolveKioskDeviceConfigV0: (id: string, params: RequestParams = {}) =>
      this.request<ClientConfigResolveKioskV0Dto, any>({
        path: `/client-config/resolve/kiosk/0/device/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerUpdateAppDeviceConfigV0
     * @request PUT:/client-config/update/app/0/device/{id}
     * @secure
     */
    clientConfigControllerUpdateAppDeviceConfigV0: (
      id: string,
      data: ClientConfigUpdateAppV0Dto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/client-config/update/app/0/device/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientConfigGroup, ClientConfigKey
     * @name ClientConfigControllerUpdateKioskDeviceConfigV0
     * @request PUT:/client-config/update/kiosk/0/device/{id}
     * @secure
     */
    clientConfigControllerUpdateKioskDeviceConfigV0: (
      id: string,
      data: ClientConfigUpdateKioskV0Dto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/client-config/update/kiosk/0/device/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  contactLists = {
    /**
     * @description Creates a ContactList
     *
     * @tags ContactList
     * @name ContactListsControllerCreate
     * @request POST:/contact-lists
     * @secure
     */
    contactListsControllerCreate: (
      data: ContactListCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContactListOutputDto, any>({
        path: `/contact-lists`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates ContactList
     *
     * @tags ContactList
     * @name ContactListsControllerPaginate
     * @request GET:/contact-lists
     * @secure
     */
    contactListsControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /**
             * PII
             * @maxLength 1024
             * @default null
             */
            description?: string | null;
            contacts: {
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
              /**
               * PII
               * @maxLength 1024
               */
              phone: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              email: string | null;
            }[];
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/contact-lists`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a ContactList by id
     *
     * @tags ContactList
     * @name ContactListsControllerFindById
     * @request GET:/contact-lists/{id}
     * @secure
     */
    contactListsControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContactListOutputDto, any>({
        path: `/contact-lists/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a ContactList
     *
     * @tags ContactList
     * @name ContactListsControllerUpdate
     * @request PATCH:/contact-lists/{id}
     * @secure
     */
    contactListsControllerUpdate: (
      id: string,
      data: ContactListUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContactListOutputDto, any>({
        path: `/contact-lists/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a ContactList by id
     *
     * @tags ContactList
     * @name ContactListsControllerRemove
     * @request DELETE:/contact-lists/{id}
     * @secure
     */
    contactListsControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/contact-lists/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
  };
  contact = {
    /**
     * No description
     *
     * @tags Contact
     * @name ContactControllerEmail
     * @request POST:/contact/email
     * @secure
     */
    contactControllerEmail: (
      data: EmailContactDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/contact/email`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contact
     * @name ContactControllerSms
     * @request POST:/contact/sms
     * @secure
     */
    contactControllerSms: (
      data: SmsContactDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/contact/sms`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  context = {
    /**
     * No description
     *
     * @tags Context
     * @name ContextControllerContext
     * @request GET:/context
     * @secure
     */
    contextControllerContext: (
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetContextResponse, any>({
        path: `/context`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  customerAlarmCenterRelations = {
    /**
     * @description Creates a CustomerAlarmCenterRelation
     *
     * @tags CustomerAlarmCenterRelation
     * @name CustomerAlarmCenterRelationsControllerCreate
     * @request POST:/customer-alarm-center-relations
     * @secure
     */
    customerAlarmCenterRelationsControllerCreate: (
      data: CustomerAlarmCenterRelationCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerAlarmCenterRelationOutputDto, any>({
        path: `/customer-alarm-center-relations`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates CustomerAlarmCenterRelation
     *
     * @tags CustomerAlarmCenterRelation
     * @name CustomerAlarmCenterRelationsControllerPaginate
     * @request GET:/customer-alarm-center-relations
     * @secure
     */
    customerAlarmCenterRelationsControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            /** @maxLength 1024 */
            migrationKey?: string;
            alarmCenter: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            enabled: boolean;
            zones:
              | {
                  /** @format uuid */
                  _id: string;
                  _ref: "Zone";
                }[]
              | null;
            priority?: number;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/customer-alarm-center-relations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a CustomerAlarmCenterRelation by id
     *
     * @tags CustomerAlarmCenterRelation
     * @name CustomerAlarmCenterRelationsControllerFindById
     * @request GET:/customer-alarm-center-relations/{id}
     * @secure
     */
    customerAlarmCenterRelationsControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerAlarmCenterRelationOutputDto, any>({
        path: `/customer-alarm-center-relations/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a CustomerAlarmCenterRelation
     *
     * @tags CustomerAlarmCenterRelation
     * @name CustomerAlarmCenterRelationsControllerUpdate
     * @request PATCH:/customer-alarm-center-relations/{id}
     * @secure
     */
    customerAlarmCenterRelationsControllerUpdate: (
      id: string,
      data: CustomerAlarmCenterRelationUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerAlarmCenterRelationOutputDto, any>({
        path: `/customer-alarm-center-relations/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a CustomerAlarmCenterRelation by id
     *
     * @tags CustomerAlarmCenterRelation
     * @name CustomerAlarmCenterRelationsControllerRemove
     * @request DELETE:/customer-alarm-center-relations/{id}
     * @secure
     */
    customerAlarmCenterRelationsControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/customer-alarm-center-relations/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerAlarmCenterRelation
     * @name CustomerAlarmCenterRelationsControllerGetOutboundPhoneNumbersByCustomer
     * @request GET:/customer-alarm-center-relations/customer/{customerId}/outbound-phone-numbers
     * @secure
     */
    customerAlarmCenterRelationsControllerGetOutboundPhoneNumbersByCustomer: (
      customerId: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerAlarmCenterRelationOutboundPhoneNumbersOutputDto[], any>({
        path: `/customer-alarm-center-relations/customer/${customerId}/outbound-phone-numbers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerAlarmCenterRelation
     * @name CustomerAlarmCenterRelationsControllerPopulate
     * @request GET:/customer-alarm-center-relations/populated
     * @secure
     */
    customerAlarmCenterRelationsControllerPopulate: (
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerAlarmCenterRelationOutputDto, any>({
        path: `/customer-alarm-center-relations/populated`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  customerAlarmProcessRelations = {
    /**
     * @description Creates a CustomerAlarmProcessRelation
     *
     * @tags CustomerAlarmProcessRelation
     * @name CustomerAlarmProcessRelationControllerCreate
     * @request POST:/customer-alarm-process-relations
     * @secure
     */
    customerAlarmProcessRelationControllerCreate: (
      data: CustomerAlarmProcessRelationCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerAlarmProcessRelationOutputDto, any>({
        path: `/customer-alarm-process-relations`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates CustomerAlarmProcessRelation
     *
     * @tags CustomerAlarmProcessRelation
     * @name CustomerAlarmProcessRelationControllerPaginate
     * @request GET:/customer-alarm-process-relations
     * @secure
     */
    customerAlarmProcessRelationControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            alarmProcess: {
              /** @format uuid */
              _id: string;
              _ref: "AlarmProcess";
            }[];
            filter: {
              alarmSeverities: {
                include: ("red" | "orange" | "green")[];
                exclude: ("red" | "orange" | "green")[];
              };
              alarmTypes: {
                include: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[];
                exclude: ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[];
              };
              assetGroups: {
                include: {
                  someGroups: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[];
                  multipleGroups: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[];
                  exactMatchGroups: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[];
                };
                exclude: {
                  someGroups: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[];
                  multipleGroups: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[];
                  exactMatchGroups: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[];
                };
              };
            }[];
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/customer-alarm-process-relations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a CustomerAlarmProcessRelation by id
     *
     * @tags CustomerAlarmProcessRelation
     * @name CustomerAlarmProcessRelationControllerFindById
     * @request GET:/customer-alarm-process-relations/{id}
     * @secure
     */
    customerAlarmProcessRelationControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerAlarmProcessRelationOutputDto, any>({
        path: `/customer-alarm-process-relations/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a CustomerAlarmProcessRelation
     *
     * @tags CustomerAlarmProcessRelation
     * @name CustomerAlarmProcessRelationControllerUpdate
     * @request PATCH:/customer-alarm-process-relations/{id}
     * @secure
     */
    customerAlarmProcessRelationControllerUpdate: (
      id: string,
      data: CustomerAlarmProcessRelationUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerAlarmProcessRelationOutputDto, any>({
        path: `/customer-alarm-process-relations/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a CustomerAlarmProcessRelation by id
     *
     * @tags CustomerAlarmProcessRelation
     * @name CustomerAlarmProcessRelationControllerRemove
     * @request DELETE:/customer-alarm-process-relations/{id}
     * @secure
     */
    customerAlarmProcessRelationControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/customer-alarm-process-relations/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
  };
  customerUserRelations = {
    /**
     * @description Creates a CustomerUserRelation
     *
     * @tags CustomerUserRelation
     * @name CustomerUserRelationsControllerCreate
     * @request POST:/customer-user-relations
     * @secure
     */
    customerUserRelationsControllerCreate: (
      data: CustomerUserRelationCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerUserRelationOutputDto, any>({
        path: `/customer-user-relations`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates CustomerUserRelation
     *
     * @tags CustomerUserRelation
     * @name CustomerUserRelationsControllerPaginate
     * @request GET:/customer-user-relations
     * @secure
     */
    customerUserRelationsControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            /** @maxLength 1024 */
            migrationKey?: string;
            user: {
              /** @format uuid */
              _id: string;
              _ref: "User";
            };
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** PII */
            roles: string[];
            assetGroupRestrictions?:
              | {
                  /** @format uuid */
                  _id: string;
                  _ref: "AssetGroup";
                }[]
              | null;
            accessRequest?: {
              /** @format date-time */
              validUntil: string;
              reason: string;
              review:
                | {
                    type: "approved";
                    /** PII */
                    reviewedBy: {
                      /** @format uuid */
                      _id: string;
                      _ref: "User";
                    };
                    /** @format date-time */
                    reviewedAt: string;
                    forced: boolean;
                  }
                | {
                    type: "rejected";
                    /** PII */
                    reviewedBy: {
                      /** @format uuid */
                      _id: string;
                      _ref: "User";
                    };
                    /** @format date-time */
                    reviewedAt: string;
                    reason: string;
                  }
                | null;
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/customer-user-relations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a CustomerUserRelation by id
     *
     * @tags CustomerUserRelation
     * @name CustomerUserRelationsControllerFindById
     * @request GET:/customer-user-relations/{id}
     * @secure
     */
    customerUserRelationsControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerUserRelationOutputDto, any>({
        path: `/customer-user-relations/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a CustomerUserRelation
     *
     * @tags CustomerUserRelation
     * @name CustomerUserRelationsControllerUpdate
     * @request PATCH:/customer-user-relations/{id}
     * @secure
     */
    customerUserRelationsControllerUpdate: (
      id: string,
      data: CustomerUserRelationUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerUserRelationOutputDto, any>({
        path: `/customer-user-relations/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a CustomerUserRelation by id
     *
     * @tags CustomerUserRelation
     * @name CustomerUserRelationsControllerRemove
     * @request DELETE:/customer-user-relations/{id}
     * @secure
     */
    customerUserRelationsControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/customer-user-relations/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerUserRelation
     * @name CustomerUserRelationsControllerCreateAccessRequest
     * @request POST:/customer-user-relations/access-request
     * @secure
     */
    customerUserRelationsControllerCreateAccessRequest: (
      data: CustomerUserRelationCreateAccessRequestDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, CustomerUserRelationOutputDto>({
        path: `/customer-user-relations/access-request`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerUserRelation
     * @name CustomerUserRelationsControllerReviewAccessRequest
     * @request POST:/customer-user-relations/review-access-request/{id}
     * @secure
     */
    customerUserRelationsControllerReviewAccessRequest: (
      id: string,
      data: CustomerUserRelationReviewAccessRequestDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, CustomerUserRelationOutputDto>({
        path: `/customer-user-relations/review-access-request/${id}`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  customers = {
    /**
     * @description Creates a Customer
     *
     * @tags Customer
     * @name CustomersControllerCreate
     * @request POST:/customers
     * @secure
     */
    customersControllerCreate: (
      data: CustomerCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerOutputDto, any>({
        path: `/customers`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates Customer
     *
     * @tags Customer
     * @name CustomersControllerPaginate
     * @request GET:/customers
     * @secure
     */
    customersControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /** @default null */
            parent?: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            } | null;
            parents: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            }[];
            children: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            }[];
            /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
            locale: string;
            /**
             * @maxLength 1024
             * @default "Europe/Amsterdam"
             */
            timeZone?: string;
            /**
             * PII
             * @default null
             */
            alarmCenter?: {
              enabled: boolean;
              /** @maxLength 1024 */
              queueName?: string;
              /**
               * PII
               * @maxLength 1024
               */
              callbackPhoneNumber?: string;
              /** PII */
              outboundPhoneNumbers?: string[];
            } | null;
            survey?: {
              enabled: boolean;
            };
            /**
             * PII
             * @default null
             */
            responsePartner?: {
              enabled: boolean;
            } | null;
            /** @default [] */
            responsePartners?: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            }[];
            /** @default [] */
            billingContracts?: string[];
            preferences?: {
              alarmAgeLimit?: {
                type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                value: number;
              } | null;
              mergeConfig?: {
                enabled: boolean;
                onlyMergeWhenSame: {
                  name: boolean;
                  severity: boolean;
                  type: boolean;
                };
                maxTimeBetweenAlarmsMs: number;
                retriggerAtsAfterMs: number;
              } | null;
              disableAutomaticGenerationOfButtonZones?: boolean | null;
              recurringTasksEnabled?: boolean | null;
              securityInventoryEnabled?: boolean | null;
              enableZoneEnterExitEvents?: boolean | null;
            };
            loraConfig?:
              | (
                  | {
                      type: "adeunis.arf8123aa";
                      config: {
                        /** @maxLength 1024 */
                        fieldTest: string;
                      };
                    }
                  | {
                      type: "iotracker.v2";
                      config: {
                        /** @maxLength 1024 */
                        beaconScan: string;
                        /** @maxLength 1024 */
                        gps: string;
                        /** @maxLength 1024 */
                        preMandown: string;
                        /** @maxLength 1024 */
                        mandown: string;
                        /** @maxLength 1024 */
                        movement: string;
                        /** @maxLength 1024 */
                        alarmSeverity: string;
                        /** @maxLength 1024 */
                        alive: string;
                      };
                    }
                  | {
                      type: "milesight.ws101";
                      config: {
                        /** @maxLength 1024 */
                        beaconScan: string;
                        /** @maxLength 1024 */
                        alarmSeverity: string;
                        /** @maxLength 1024 */
                        alive: string;
                      };
                    }
                  | {
                      type: "sensative.1301001";
                      config: {
                        /** @maxLength 1024 */
                        alarmSeverity: string;
                        /** @maxLength 1024 */
                        alive: string;
                        /** @maxLength 1024 */
                        floodDetected: string;
                        /** @maxLength 1024 */
                        noFloodDetected: string;
                      };
                    }
                )[]
              | null;
            kioskConfig?: {
              /** @default false */
              managed?: boolean;
              zone?: {
                /** @format uuid */
                _id: string;
                _ref: "Zone";
              } | null;
              exposeAssets?:
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[]
                | null;
              exposeLabels?:
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                    countLabel?: boolean;
                  }[]
                | null;
              schedule?: {
                entries: {
                  daysOfWeek: number[];
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeStart: string;
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeEnd: string;
                }[];
              } | null;
              homepage?: {
                incidentCounter?: {
                  /** @default true */
                  enabled?: boolean;
                  /** @format date-time */
                  countFromDate?: string | null;
                  /**
                   * @min 0
                   * @exclusiveMin false
                   * @default 0
                   */
                  threshold?: number;
                };
                /** @default true */
                anonymous?: boolean;
                /** @format uri */
                logo?: string | null;
              };
              alarm?: {
                /** @default true */
                enabled?: boolean;
                focus?: {
                  red?: {
                    flash?: boolean | null;
                    sound?: {
                      enabled: boolean;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 100
                       * @exclusiveMax false
                       */
                      volume?: number | null;
                      sound?:
                        | "alarm"
                        | "alarmClock"
                        | "alarmRetro"
                        | "announcement"
                        | "attention"
                        | "bassPulse"
                        | "beepBeep"
                        | "beepBurglar"
                        | "beepContinuous"
                        | "beepHighSoft"
                        | "beepIncremental"
                        | "bell"
                        | "car"
                        | "chickens"
                        | "chime"
                        | "chirpSoft"
                        | "clockMelody"
                        | "countdownSonar"
                        | "doorbell"
                        | "escalate"
                        | "fancy"
                        | "fastAndNervous"
                        | "harp"
                        | "incomingPhone"
                        | "introduction"
                        | "intrusive"
                        | "invasion"
                        | "jungle"
                        | "lofiChords"
                        | "loopLow"
                        | "melodySoft"
                        | "notifySubtle"
                        | "onOff"
                        | "orchestral"
                        | "pling"
                        | "plingHigh"
                        | "plingLow"
                        | "pluckSong"
                        | "quick"
                        | "scanning"
                        | "shake"
                        | "silence"
                        | "sirenHigh"
                        | "sirenLow"
                        | "soft"
                        | "spaceship"
                        | "startup"
                        | "threeTones"
                        | "tornado"
                        | "wailing"
                        | "wakeup"
                        | null;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      stopAfterSeconds?: number | null;
                      stopAfterTouch?: boolean | null;
                    };
                  };
                  orange?: {
                    flash?: boolean | null;
                    sound?: {
                      enabled: boolean;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 100
                       * @exclusiveMax false
                       */
                      volume?: number | null;
                      sound?:
                        | "alarm"
                        | "alarmClock"
                        | "alarmRetro"
                        | "announcement"
                        | "attention"
                        | "bassPulse"
                        | "beepBeep"
                        | "beepBurglar"
                        | "beepContinuous"
                        | "beepHighSoft"
                        | "beepIncremental"
                        | "bell"
                        | "car"
                        | "chickens"
                        | "chime"
                        | "chirpSoft"
                        | "clockMelody"
                        | "countdownSonar"
                        | "doorbell"
                        | "escalate"
                        | "fancy"
                        | "fastAndNervous"
                        | "harp"
                        | "incomingPhone"
                        | "introduction"
                        | "intrusive"
                        | "invasion"
                        | "jungle"
                        | "lofiChords"
                        | "loopLow"
                        | "melodySoft"
                        | "notifySubtle"
                        | "onOff"
                        | "orchestral"
                        | "pling"
                        | "plingHigh"
                        | "plingLow"
                        | "pluckSong"
                        | "quick"
                        | "scanning"
                        | "shake"
                        | "silence"
                        | "sirenHigh"
                        | "sirenLow"
                        | "soft"
                        | "spaceship"
                        | "startup"
                        | "threeTones"
                        | "tornado"
                        | "wailing"
                        | "wakeup"
                        | null;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      stopAfterSeconds?: number | null;
                      stopAfterTouch?: boolean | null;
                    };
                  };
                  green?: {
                    flash?: boolean | null;
                    sound?: {
                      enabled: boolean;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 100
                       * @exclusiveMax false
                       */
                      volume?: number | null;
                      sound?:
                        | "alarm"
                        | "alarmClock"
                        | "alarmRetro"
                        | "announcement"
                        | "attention"
                        | "bassPulse"
                        | "beepBeep"
                        | "beepBurglar"
                        | "beepContinuous"
                        | "beepHighSoft"
                        | "beepIncremental"
                        | "bell"
                        | "car"
                        | "chickens"
                        | "chime"
                        | "chirpSoft"
                        | "clockMelody"
                        | "countdownSonar"
                        | "doorbell"
                        | "escalate"
                        | "fancy"
                        | "fastAndNervous"
                        | "harp"
                        | "incomingPhone"
                        | "introduction"
                        | "intrusive"
                        | "invasion"
                        | "jungle"
                        | "lofiChords"
                        | "loopLow"
                        | "melodySoft"
                        | "notifySubtle"
                        | "onOff"
                        | "orchestral"
                        | "pling"
                        | "plingHigh"
                        | "plingLow"
                        | "pluckSong"
                        | "quick"
                        | "scanning"
                        | "shake"
                        | "silence"
                        | "sirenHigh"
                        | "sirenLow"
                        | "soft"
                        | "spaceship"
                        | "startup"
                        | "threeTones"
                        | "tornado"
                        | "wailing"
                        | "wakeup"
                        | null;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      stopAfterSeconds?: number | null;
                      stopAfterTouch?: boolean | null;
                    };
                  };
                };
                /** @default true */
                showPositionLabels?: boolean;
                /** @default true */
                anonymous?: boolean;
                acknowledge?: {
                  enabled?: boolean;
                  /** @pattern ^[0-9]{4,6}$ */
                  pin?: string | null;
                  messagePresets?: string[] | null;
                };
                mode?: "zoneBased" | "customerBased" | null;
              };
              manageAvailability?: {
                /** @default true */
                enabled?: boolean;
                /** @pattern ^[0-9]{4,6}$ */
                pin?: string | null;
                /** @default true */
                showAppBanner?: boolean;
                /** @default false */
                forceShowSearch?: boolean;
                /** @default false */
                forceShowLabelFilter?: boolean;
              };
              hardware?: {
                /**
                 * @min 0
                 * @exclusiveMin false
                 * @max 100
                 * @exclusiveMax false
                 */
                screenBrightness?: number | null;
              };
            };
            type?: "default" | "bhvk_paid" | "bhvk_trial";
            userPolicies?: {
              disablePasswordlessLogin?: boolean;
            };
            clientConfig?: {
              app?: {
                definitions: (
                  | {
                      type: "key";
                      key: string;
                      value: any;
                      editableBy?: ("AssetGroup" | "Device")[];
                    }
                  | {
                      type: "group";
                      group: {
                        /** @format uuid */
                        _id: string;
                        _ref: "ClientConfigGroup";
                      };
                    }
                )[];
                filter?: {
                  type: "osFilter";
                  osType: "ios" | "android";
                  /** @maxLength 1024 */
                  osVersionRange?: string;
                };
              }[];
              kiosk?: {
                definitions: (
                  | {
                      type: "key";
                      key: string;
                      value: any;
                      editableBy?: ("AssetGroup" | "Device")[];
                    }
                  | {
                      type: "group";
                      group: {
                        /** @format uuid */
                        _id: string;
                        _ref: "ClientConfigGroup";
                      };
                    }
                )[];
                filter?: {
                  type: "osFilter";
                  osType: "ios" | "android";
                  /** @maxLength 1024 */
                  osVersionRange?: string;
                };
              }[];
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/customers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a Customer by id
     *
     * @tags Customer
     * @name CustomersControllerFindById
     * @request GET:/customers/{id}
     * @secure
     */
    customersControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerOutputDto, any>({
        path: `/customers/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a Customer
     *
     * @tags Customer
     * @name CustomersControllerUpdate
     * @request PATCH:/customers/{id}
     * @secure
     */
    customersControllerUpdate: (
      id: string,
      data: CustomerUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerOutputDto, any>({
        path: `/customers/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a Customer by id
     *
     * @tags Customer
     * @name CustomersControllerRemove
     * @request DELETE:/customers/{id}
     * @secure
     */
    customersControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/customers/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomersControllerAddPhoto
     * @request POST:/customers/kiosk/photo
     * @secure
     */
    customersControllerAddPhoto: (
      query: {
        /** customer id parameter */
        id: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      data: {
        /** @format binary */
        photo_url: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<ImageUploadDto, any>({
        path: `/customers/kiosk/photo`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates Customer
     *
     * @tags Customer
     * @name CustomersControllerPaginateList
     * @request GET:/customers/list
     * @secure
     */
    customersControllerPaginateList: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /** @default null */
            parent?: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            } | null;
            parents: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            }[];
            children: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            }[];
            /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
            locale: string;
            /**
             * @maxLength 1024
             * @default "Europe/Amsterdam"
             */
            timeZone?: string;
            /**
             * PII
             * @default null
             */
            alarmCenter?: {
              enabled: boolean;
              /** @maxLength 1024 */
              queueName?: string;
              /**
               * PII
               * @maxLength 1024
               */
              callbackPhoneNumber?: string;
              /** PII */
              outboundPhoneNumbers?: string[];
            } | null;
            survey?: {
              enabled: boolean;
            };
            /**
             * PII
             * @default null
             */
            responsePartner?: {
              enabled: boolean;
            } | null;
            /** @default [] */
            responsePartners?: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            }[];
            /** @default [] */
            billingContracts?: string[];
            preferences?: {
              alarmAgeLimit?: {
                type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                value: number;
              } | null;
              mergeConfig?: {
                enabled: boolean;
                onlyMergeWhenSame: {
                  name: boolean;
                  severity: boolean;
                  type: boolean;
                };
                maxTimeBetweenAlarmsMs: number;
                retriggerAtsAfterMs: number;
              } | null;
              disableAutomaticGenerationOfButtonZones?: boolean | null;
              recurringTasksEnabled?: boolean | null;
              securityInventoryEnabled?: boolean | null;
              enableZoneEnterExitEvents?: boolean | null;
            };
            loraConfig?:
              | (
                  | {
                      type: "adeunis.arf8123aa";
                      config: {
                        /** @maxLength 1024 */
                        fieldTest: string;
                      };
                    }
                  | {
                      type: "iotracker.v2";
                      config: {
                        /** @maxLength 1024 */
                        beaconScan: string;
                        /** @maxLength 1024 */
                        gps: string;
                        /** @maxLength 1024 */
                        preMandown: string;
                        /** @maxLength 1024 */
                        mandown: string;
                        /** @maxLength 1024 */
                        movement: string;
                        /** @maxLength 1024 */
                        alarmSeverity: string;
                        /** @maxLength 1024 */
                        alive: string;
                      };
                    }
                  | {
                      type: "milesight.ws101";
                      config: {
                        /** @maxLength 1024 */
                        beaconScan: string;
                        /** @maxLength 1024 */
                        alarmSeverity: string;
                        /** @maxLength 1024 */
                        alive: string;
                      };
                    }
                  | {
                      type: "sensative.1301001";
                      config: {
                        /** @maxLength 1024 */
                        alarmSeverity: string;
                        /** @maxLength 1024 */
                        alive: string;
                        /** @maxLength 1024 */
                        floodDetected: string;
                        /** @maxLength 1024 */
                        noFloodDetected: string;
                      };
                    }
                )[]
              | null;
            kioskConfig?: {
              /** @default false */
              managed?: boolean;
              zone?: {
                /** @format uuid */
                _id: string;
                _ref: "Zone";
              } | null;
              exposeAssets?:
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[]
                | null;
              exposeLabels?:
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                    countLabel?: boolean;
                  }[]
                | null;
              schedule?: {
                entries: {
                  daysOfWeek: number[];
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeStart: string;
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeEnd: string;
                }[];
              } | null;
              homepage?: {
                incidentCounter?: {
                  /** @default true */
                  enabled?: boolean;
                  /** @format date-time */
                  countFromDate?: string | null;
                  /**
                   * @min 0
                   * @exclusiveMin false
                   * @default 0
                   */
                  threshold?: number;
                };
                /** @default true */
                anonymous?: boolean;
                /** @format uri */
                logo?: string | null;
              };
              alarm?: {
                /** @default true */
                enabled?: boolean;
                focus?: {
                  red?: {
                    flash?: boolean | null;
                    sound?: {
                      enabled: boolean;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 100
                       * @exclusiveMax false
                       */
                      volume?: number | null;
                      sound?:
                        | "alarm"
                        | "alarmClock"
                        | "alarmRetro"
                        | "announcement"
                        | "attention"
                        | "bassPulse"
                        | "beepBeep"
                        | "beepBurglar"
                        | "beepContinuous"
                        | "beepHighSoft"
                        | "beepIncremental"
                        | "bell"
                        | "car"
                        | "chickens"
                        | "chime"
                        | "chirpSoft"
                        | "clockMelody"
                        | "countdownSonar"
                        | "doorbell"
                        | "escalate"
                        | "fancy"
                        | "fastAndNervous"
                        | "harp"
                        | "incomingPhone"
                        | "introduction"
                        | "intrusive"
                        | "invasion"
                        | "jungle"
                        | "lofiChords"
                        | "loopLow"
                        | "melodySoft"
                        | "notifySubtle"
                        | "onOff"
                        | "orchestral"
                        | "pling"
                        | "plingHigh"
                        | "plingLow"
                        | "pluckSong"
                        | "quick"
                        | "scanning"
                        | "shake"
                        | "silence"
                        | "sirenHigh"
                        | "sirenLow"
                        | "soft"
                        | "spaceship"
                        | "startup"
                        | "threeTones"
                        | "tornado"
                        | "wailing"
                        | "wakeup"
                        | null;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      stopAfterSeconds?: number | null;
                      stopAfterTouch?: boolean | null;
                    };
                  };
                  orange?: {
                    flash?: boolean | null;
                    sound?: {
                      enabled: boolean;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 100
                       * @exclusiveMax false
                       */
                      volume?: number | null;
                      sound?:
                        | "alarm"
                        | "alarmClock"
                        | "alarmRetro"
                        | "announcement"
                        | "attention"
                        | "bassPulse"
                        | "beepBeep"
                        | "beepBurglar"
                        | "beepContinuous"
                        | "beepHighSoft"
                        | "beepIncremental"
                        | "bell"
                        | "car"
                        | "chickens"
                        | "chime"
                        | "chirpSoft"
                        | "clockMelody"
                        | "countdownSonar"
                        | "doorbell"
                        | "escalate"
                        | "fancy"
                        | "fastAndNervous"
                        | "harp"
                        | "incomingPhone"
                        | "introduction"
                        | "intrusive"
                        | "invasion"
                        | "jungle"
                        | "lofiChords"
                        | "loopLow"
                        | "melodySoft"
                        | "notifySubtle"
                        | "onOff"
                        | "orchestral"
                        | "pling"
                        | "plingHigh"
                        | "plingLow"
                        | "pluckSong"
                        | "quick"
                        | "scanning"
                        | "shake"
                        | "silence"
                        | "sirenHigh"
                        | "sirenLow"
                        | "soft"
                        | "spaceship"
                        | "startup"
                        | "threeTones"
                        | "tornado"
                        | "wailing"
                        | "wakeup"
                        | null;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      stopAfterSeconds?: number | null;
                      stopAfterTouch?: boolean | null;
                    };
                  };
                  green?: {
                    flash?: boolean | null;
                    sound?: {
                      enabled: boolean;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 100
                       * @exclusiveMax false
                       */
                      volume?: number | null;
                      sound?:
                        | "alarm"
                        | "alarmClock"
                        | "alarmRetro"
                        | "announcement"
                        | "attention"
                        | "bassPulse"
                        | "beepBeep"
                        | "beepBurglar"
                        | "beepContinuous"
                        | "beepHighSoft"
                        | "beepIncremental"
                        | "bell"
                        | "car"
                        | "chickens"
                        | "chime"
                        | "chirpSoft"
                        | "clockMelody"
                        | "countdownSonar"
                        | "doorbell"
                        | "escalate"
                        | "fancy"
                        | "fastAndNervous"
                        | "harp"
                        | "incomingPhone"
                        | "introduction"
                        | "intrusive"
                        | "invasion"
                        | "jungle"
                        | "lofiChords"
                        | "loopLow"
                        | "melodySoft"
                        | "notifySubtle"
                        | "onOff"
                        | "orchestral"
                        | "pling"
                        | "plingHigh"
                        | "plingLow"
                        | "pluckSong"
                        | "quick"
                        | "scanning"
                        | "shake"
                        | "silence"
                        | "sirenHigh"
                        | "sirenLow"
                        | "soft"
                        | "spaceship"
                        | "startup"
                        | "threeTones"
                        | "tornado"
                        | "wailing"
                        | "wakeup"
                        | null;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      stopAfterSeconds?: number | null;
                      stopAfterTouch?: boolean | null;
                    };
                  };
                };
                /** @default true */
                showPositionLabels?: boolean;
                /** @default true */
                anonymous?: boolean;
                acknowledge?: {
                  enabled?: boolean;
                  /** @pattern ^[0-9]{4,6}$ */
                  pin?: string | null;
                  messagePresets?: string[] | null;
                };
                mode?: "zoneBased" | "customerBased" | null;
              };
              manageAvailability?: {
                /** @default true */
                enabled?: boolean;
                /** @pattern ^[0-9]{4,6}$ */
                pin?: string | null;
                /** @default true */
                showAppBanner?: boolean;
                /** @default false */
                forceShowSearch?: boolean;
                /** @default false */
                forceShowLabelFilter?: boolean;
              };
              hardware?: {
                /**
                 * @min 0
                 * @exclusiveMin false
                 * @max 100
                 * @exclusiveMax false
                 */
                screenBrightness?: number | null;
              };
            };
            type?: "default" | "bhvk_paid" | "bhvk_trial";
            userPolicies?: {
              disablePasswordlessLogin?: boolean;
            };
            clientConfig?: {
              app?: {
                definitions: (
                  | {
                      type: "key";
                      key: string;
                      value: any;
                      editableBy?: ("AssetGroup" | "Device")[];
                    }
                  | {
                      type: "group";
                      group: {
                        /** @format uuid */
                        _id: string;
                        _ref: "ClientConfigGroup";
                      };
                    }
                )[];
                filter?: {
                  type: "osFilter";
                  osType: "ios" | "android";
                  /** @maxLength 1024 */
                  osVersionRange?: string;
                };
              }[];
              kiosk?: {
                definitions: (
                  | {
                      type: "key";
                      key: string;
                      value: any;
                      editableBy?: ("AssetGroup" | "Device")[];
                    }
                  | {
                      type: "group";
                      group: {
                        /** @format uuid */
                        _id: string;
                        _ref: "ClientConfigGroup";
                      };
                    }
                )[];
                filter?: {
                  type: "osFilter";
                  osType: "ios" | "android";
                  /** @maxLength 1024 */
                  osVersionRange?: string;
                };
              }[];
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/customers/list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CustomersControllerCheckMigrationStatus
     * @request POST:/customers/migration-status
     * @secure
     */
    customersControllerCheckMigrationStatus: (
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/customers/migration-status`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Searches Customer
     *
     * @tags Customer
     * @name CustomersControllerSearch
     * @request GET:/customers/search
     * @secure
     */
    customersControllerSearch: (
      query: {
        /** The search query string */
        q: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /** @default null */
            parent?: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            } | null;
            parents: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            }[];
            children: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            }[];
            /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
            locale: string;
            /**
             * @maxLength 1024
             * @default "Europe/Amsterdam"
             */
            timeZone?: string;
            /**
             * PII
             * @default null
             */
            alarmCenter?: {
              enabled: boolean;
              /** @maxLength 1024 */
              queueName?: string;
              /**
               * PII
               * @maxLength 1024
               */
              callbackPhoneNumber?: string;
              /** PII */
              outboundPhoneNumbers?: string[];
            } | null;
            survey?: {
              enabled: boolean;
            };
            /**
             * PII
             * @default null
             */
            responsePartner?: {
              enabled: boolean;
            } | null;
            /** @default [] */
            responsePartners?: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            }[];
            /** @default [] */
            billingContracts?: string[];
            preferences?: {
              alarmAgeLimit?: {
                type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                value: number;
              } | null;
              mergeConfig?: {
                enabled: boolean;
                onlyMergeWhenSame: {
                  name: boolean;
                  severity: boolean;
                  type: boolean;
                };
                maxTimeBetweenAlarmsMs: number;
                retriggerAtsAfterMs: number;
              } | null;
              disableAutomaticGenerationOfButtonZones?: boolean | null;
              recurringTasksEnabled?: boolean | null;
              securityInventoryEnabled?: boolean | null;
              enableZoneEnterExitEvents?: boolean | null;
            };
            loraConfig?:
              | (
                  | {
                      type: "adeunis.arf8123aa";
                      config: {
                        /** @maxLength 1024 */
                        fieldTest: string;
                      };
                    }
                  | {
                      type: "iotracker.v2";
                      config: {
                        /** @maxLength 1024 */
                        beaconScan: string;
                        /** @maxLength 1024 */
                        gps: string;
                        /** @maxLength 1024 */
                        preMandown: string;
                        /** @maxLength 1024 */
                        mandown: string;
                        /** @maxLength 1024 */
                        movement: string;
                        /** @maxLength 1024 */
                        alarmSeverity: string;
                        /** @maxLength 1024 */
                        alive: string;
                      };
                    }
                  | {
                      type: "milesight.ws101";
                      config: {
                        /** @maxLength 1024 */
                        beaconScan: string;
                        /** @maxLength 1024 */
                        alarmSeverity: string;
                        /** @maxLength 1024 */
                        alive: string;
                      };
                    }
                  | {
                      type: "sensative.1301001";
                      config: {
                        /** @maxLength 1024 */
                        alarmSeverity: string;
                        /** @maxLength 1024 */
                        alive: string;
                        /** @maxLength 1024 */
                        floodDetected: string;
                        /** @maxLength 1024 */
                        noFloodDetected: string;
                      };
                    }
                )[]
              | null;
            kioskConfig?: {
              /** @default false */
              managed?: boolean;
              zone?: {
                /** @format uuid */
                _id: string;
                _ref: "Zone";
              } | null;
              exposeAssets?:
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[]
                | null;
              exposeLabels?:
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                    countLabel?: boolean;
                  }[]
                | null;
              schedule?: {
                entries: {
                  daysOfWeek: number[];
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeStart: string;
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeEnd: string;
                }[];
              } | null;
              homepage?: {
                incidentCounter?: {
                  /** @default true */
                  enabled?: boolean;
                  /** @format date-time */
                  countFromDate?: string | null;
                  /**
                   * @min 0
                   * @exclusiveMin false
                   * @default 0
                   */
                  threshold?: number;
                };
                /** @default true */
                anonymous?: boolean;
                /** @format uri */
                logo?: string | null;
              };
              alarm?: {
                /** @default true */
                enabled?: boolean;
                focus?: {
                  red?: {
                    flash?: boolean | null;
                    sound?: {
                      enabled: boolean;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 100
                       * @exclusiveMax false
                       */
                      volume?: number | null;
                      sound?:
                        | "alarm"
                        | "alarmClock"
                        | "alarmRetro"
                        | "announcement"
                        | "attention"
                        | "bassPulse"
                        | "beepBeep"
                        | "beepBurglar"
                        | "beepContinuous"
                        | "beepHighSoft"
                        | "beepIncremental"
                        | "bell"
                        | "car"
                        | "chickens"
                        | "chime"
                        | "chirpSoft"
                        | "clockMelody"
                        | "countdownSonar"
                        | "doorbell"
                        | "escalate"
                        | "fancy"
                        | "fastAndNervous"
                        | "harp"
                        | "incomingPhone"
                        | "introduction"
                        | "intrusive"
                        | "invasion"
                        | "jungle"
                        | "lofiChords"
                        | "loopLow"
                        | "melodySoft"
                        | "notifySubtle"
                        | "onOff"
                        | "orchestral"
                        | "pling"
                        | "plingHigh"
                        | "plingLow"
                        | "pluckSong"
                        | "quick"
                        | "scanning"
                        | "shake"
                        | "silence"
                        | "sirenHigh"
                        | "sirenLow"
                        | "soft"
                        | "spaceship"
                        | "startup"
                        | "threeTones"
                        | "tornado"
                        | "wailing"
                        | "wakeup"
                        | null;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      stopAfterSeconds?: number | null;
                      stopAfterTouch?: boolean | null;
                    };
                  };
                  orange?: {
                    flash?: boolean | null;
                    sound?: {
                      enabled: boolean;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 100
                       * @exclusiveMax false
                       */
                      volume?: number | null;
                      sound?:
                        | "alarm"
                        | "alarmClock"
                        | "alarmRetro"
                        | "announcement"
                        | "attention"
                        | "bassPulse"
                        | "beepBeep"
                        | "beepBurglar"
                        | "beepContinuous"
                        | "beepHighSoft"
                        | "beepIncremental"
                        | "bell"
                        | "car"
                        | "chickens"
                        | "chime"
                        | "chirpSoft"
                        | "clockMelody"
                        | "countdownSonar"
                        | "doorbell"
                        | "escalate"
                        | "fancy"
                        | "fastAndNervous"
                        | "harp"
                        | "incomingPhone"
                        | "introduction"
                        | "intrusive"
                        | "invasion"
                        | "jungle"
                        | "lofiChords"
                        | "loopLow"
                        | "melodySoft"
                        | "notifySubtle"
                        | "onOff"
                        | "orchestral"
                        | "pling"
                        | "plingHigh"
                        | "plingLow"
                        | "pluckSong"
                        | "quick"
                        | "scanning"
                        | "shake"
                        | "silence"
                        | "sirenHigh"
                        | "sirenLow"
                        | "soft"
                        | "spaceship"
                        | "startup"
                        | "threeTones"
                        | "tornado"
                        | "wailing"
                        | "wakeup"
                        | null;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      stopAfterSeconds?: number | null;
                      stopAfterTouch?: boolean | null;
                    };
                  };
                  green?: {
                    flash?: boolean | null;
                    sound?: {
                      enabled: boolean;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 100
                       * @exclusiveMax false
                       */
                      volume?: number | null;
                      sound?:
                        | "alarm"
                        | "alarmClock"
                        | "alarmRetro"
                        | "announcement"
                        | "attention"
                        | "bassPulse"
                        | "beepBeep"
                        | "beepBurglar"
                        | "beepContinuous"
                        | "beepHighSoft"
                        | "beepIncremental"
                        | "bell"
                        | "car"
                        | "chickens"
                        | "chime"
                        | "chirpSoft"
                        | "clockMelody"
                        | "countdownSonar"
                        | "doorbell"
                        | "escalate"
                        | "fancy"
                        | "fastAndNervous"
                        | "harp"
                        | "incomingPhone"
                        | "introduction"
                        | "intrusive"
                        | "invasion"
                        | "jungle"
                        | "lofiChords"
                        | "loopLow"
                        | "melodySoft"
                        | "notifySubtle"
                        | "onOff"
                        | "orchestral"
                        | "pling"
                        | "plingHigh"
                        | "plingLow"
                        | "pluckSong"
                        | "quick"
                        | "scanning"
                        | "shake"
                        | "silence"
                        | "sirenHigh"
                        | "sirenLow"
                        | "soft"
                        | "spaceship"
                        | "startup"
                        | "threeTones"
                        | "tornado"
                        | "wailing"
                        | "wakeup"
                        | null;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      stopAfterSeconds?: number | null;
                      stopAfterTouch?: boolean | null;
                    };
                  };
                };
                /** @default true */
                showPositionLabels?: boolean;
                /** @default true */
                anonymous?: boolean;
                acknowledge?: {
                  enabled?: boolean;
                  /** @pattern ^[0-9]{4,6}$ */
                  pin?: string | null;
                  messagePresets?: string[] | null;
                };
                mode?: "zoneBased" | "customerBased" | null;
              };
              manageAvailability?: {
                /** @default true */
                enabled?: boolean;
                /** @pattern ^[0-9]{4,6}$ */
                pin?: string | null;
                /** @default true */
                showAppBanner?: boolean;
                /** @default false */
                forceShowSearch?: boolean;
                /** @default false */
                forceShowLabelFilter?: boolean;
              };
              hardware?: {
                /**
                 * @min 0
                 * @exclusiveMin false
                 * @max 100
                 * @exclusiveMax false
                 */
                screenBrightness?: number | null;
              };
            };
            type?: "default" | "bhvk_paid" | "bhvk_trial";
            userPolicies?: {
              disablePasswordlessLogin?: boolean;
            };
            clientConfig?: {
              app?: {
                definitions: (
                  | {
                      type: "key";
                      key: string;
                      value: any;
                      editableBy?: ("AssetGroup" | "Device")[];
                    }
                  | {
                      type: "group";
                      group: {
                        /** @format uuid */
                        _id: string;
                        _ref: "ClientConfigGroup";
                      };
                    }
                )[];
                filter?: {
                  type: "osFilter";
                  osType: "ios" | "android";
                  /** @maxLength 1024 */
                  osVersionRange?: string;
                };
              }[];
              kiosk?: {
                definitions: (
                  | {
                      type: "key";
                      key: string;
                      value: any;
                      editableBy?: ("AssetGroup" | "Device")[];
                    }
                  | {
                      type: "group";
                      group: {
                        /** @format uuid */
                        _id: string;
                        _ref: "ClientConfigGroup";
                      };
                    }
                )[];
                filter?: {
                  type: "osFilter";
                  osType: "ios" | "android";
                  /** @maxLength 1024 */
                  osVersionRange?: string;
                };
              }[];
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/customers/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  deviceLogUploads = {
    /**
     * @description Creates a DeviceLogUpload
     *
     * @tags DeviceLogUpload
     * @name DeviceLogUploadsControllerCreate
     * @request POST:/device-log-uploads
     * @secure
     */
    deviceLogUploadsControllerCreate: (
      data: DeviceLogUploadCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeviceLogUploadOutputDto, any>({
        path: `/device-log-uploads`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates DeviceLogUpload
     *
     * @tags DeviceLogUpload
     * @name DeviceLogUploadsControllerPaginate
     * @request GET:/device-log-uploads
     * @secure
     */
    deviceLogUploadsControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            device: {
              /** @format uuid */
              _id: string;
              _ref: "Device";
            };
            logCount: number;
            logCountBySeverity: {
              debug: number;
              info: number;
              warning: number;
              error: number;
            };
            /** @format date-time */
            startDate: string;
            /** @format date-time */
            endDate: string;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/device-log-uploads`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a DeviceLogUpload by id
     *
     * @tags DeviceLogUpload
     * @name DeviceLogUploadsControllerFindById
     * @request GET:/device-log-uploads/{id}
     * @secure
     */
    deviceLogUploadsControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeviceLogUploadOutputDto, any>({
        path: `/device-log-uploads/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a DeviceLogUpload by id
     *
     * @tags DeviceLogUpload
     * @name DeviceLogUploadsControllerRemove
     * @request DELETE:/device-log-uploads/{id}
     * @secure
     */
    deviceLogUploadsControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/device-log-uploads/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
  };
  devices = {
    /**
     * @description Creates a Device
     *
     * @tags Device
     * @name DevicesControllerCreate
     * @request POST:/devices
     * @secure
     */
    devicesControllerCreate: (
      data: DeviceCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeviceOutputDto, any>({
        path: `/devices`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates Device
     *
     * @tags Device
     * @name DevicesControllerPaginate
     * @request GET:/devices
     * @secure
     */
    devicesControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            asset: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            } | null;
            /**
             * PII
             * @maxLength 1024
             */
            name?: string;
            /**
             * PII
             * @maxLength 1024
             */
            deviceId: string;
            type: "appDevice" | "lora" | "loraGateway" | "flic" | "generic" | "kiosk";
            loraConfig?:
              | {
                  type: "adeunis.arf8123aa";
                  config: {
                    /** @maxLength 1024 */
                    fieldTest: string;
                  };
                }
              | {
                  type: "iotracker.v2";
                  config: {
                    /** @maxLength 1024 */
                    beaconScan: string;
                    /** @maxLength 1024 */
                    gps: string;
                    /** @maxLength 1024 */
                    preMandown: string;
                    /** @maxLength 1024 */
                    mandown: string;
                    /** @maxLength 1024 */
                    movement: string;
                    /** @maxLength 1024 */
                    alarmSeverity: string;
                    /** @maxLength 1024 */
                    alive: string;
                  };
                }
              | {
                  type: "milesight.ws101";
                  config: {
                    /** @maxLength 1024 */
                    beaconScan: string;
                    /** @maxLength 1024 */
                    alarmSeverity: string;
                    /** @maxLength 1024 */
                    alive: string;
                  };
                }
              | {
                  type: "sensative.1301001";
                  config: {
                    /** @maxLength 1024 */
                    alarmSeverity: string;
                    /** @maxLength 1024 */
                    alive: string;
                    /** @maxLength 1024 */
                    floodDetected: string;
                    /** @maxLength 1024 */
                    noFloodDetected: string;
                  };
                }
              | null;
            kioskConfig?: {
              /** @default false */
              managed?: boolean;
              zone?: {
                /** @format uuid */
                _id: string;
                _ref: "Zone";
              } | null;
              exposeAssets?:
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[]
                | null;
              exposeLabels?:
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                    countLabel?: boolean;
                  }[]
                | null;
              schedule?: {
                entries: {
                  daysOfWeek: number[];
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeStart: string;
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeEnd: string;
                }[];
              } | null;
              homepage?: {
                incidentCounter?: {
                  /** @default true */
                  enabled?: boolean;
                  /** @format date-time */
                  countFromDate?: string | null;
                  /**
                   * @min 0
                   * @exclusiveMin false
                   * @default 0
                   */
                  threshold?: number;
                };
                /** @default true */
                anonymous?: boolean;
                /** @format uri */
                logo?: string | null;
              };
              alarm?: {
                /** @default true */
                enabled?: boolean;
                focus?: {
                  red?: {
                    flash?: boolean | null;
                    sound?: {
                      enabled: boolean;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 100
                       * @exclusiveMax false
                       */
                      volume?: number | null;
                      sound?:
                        | "alarm"
                        | "alarmClock"
                        | "alarmRetro"
                        | "announcement"
                        | "attention"
                        | "bassPulse"
                        | "beepBeep"
                        | "beepBurglar"
                        | "beepContinuous"
                        | "beepHighSoft"
                        | "beepIncremental"
                        | "bell"
                        | "car"
                        | "chickens"
                        | "chime"
                        | "chirpSoft"
                        | "clockMelody"
                        | "countdownSonar"
                        | "doorbell"
                        | "escalate"
                        | "fancy"
                        | "fastAndNervous"
                        | "harp"
                        | "incomingPhone"
                        | "introduction"
                        | "intrusive"
                        | "invasion"
                        | "jungle"
                        | "lofiChords"
                        | "loopLow"
                        | "melodySoft"
                        | "notifySubtle"
                        | "onOff"
                        | "orchestral"
                        | "pling"
                        | "plingHigh"
                        | "plingLow"
                        | "pluckSong"
                        | "quick"
                        | "scanning"
                        | "shake"
                        | "silence"
                        | "sirenHigh"
                        | "sirenLow"
                        | "soft"
                        | "spaceship"
                        | "startup"
                        | "threeTones"
                        | "tornado"
                        | "wailing"
                        | "wakeup"
                        | null;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      stopAfterSeconds?: number | null;
                      stopAfterTouch?: boolean | null;
                    };
                  };
                  orange?: {
                    flash?: boolean | null;
                    sound?: {
                      enabled: boolean;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 100
                       * @exclusiveMax false
                       */
                      volume?: number | null;
                      sound?:
                        | "alarm"
                        | "alarmClock"
                        | "alarmRetro"
                        | "announcement"
                        | "attention"
                        | "bassPulse"
                        | "beepBeep"
                        | "beepBurglar"
                        | "beepContinuous"
                        | "beepHighSoft"
                        | "beepIncremental"
                        | "bell"
                        | "car"
                        | "chickens"
                        | "chime"
                        | "chirpSoft"
                        | "clockMelody"
                        | "countdownSonar"
                        | "doorbell"
                        | "escalate"
                        | "fancy"
                        | "fastAndNervous"
                        | "harp"
                        | "incomingPhone"
                        | "introduction"
                        | "intrusive"
                        | "invasion"
                        | "jungle"
                        | "lofiChords"
                        | "loopLow"
                        | "melodySoft"
                        | "notifySubtle"
                        | "onOff"
                        | "orchestral"
                        | "pling"
                        | "plingHigh"
                        | "plingLow"
                        | "pluckSong"
                        | "quick"
                        | "scanning"
                        | "shake"
                        | "silence"
                        | "sirenHigh"
                        | "sirenLow"
                        | "soft"
                        | "spaceship"
                        | "startup"
                        | "threeTones"
                        | "tornado"
                        | "wailing"
                        | "wakeup"
                        | null;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      stopAfterSeconds?: number | null;
                      stopAfterTouch?: boolean | null;
                    };
                  };
                  green?: {
                    flash?: boolean | null;
                    sound?: {
                      enabled: boolean;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 100
                       * @exclusiveMax false
                       */
                      volume?: number | null;
                      sound?:
                        | "alarm"
                        | "alarmClock"
                        | "alarmRetro"
                        | "announcement"
                        | "attention"
                        | "bassPulse"
                        | "beepBeep"
                        | "beepBurglar"
                        | "beepContinuous"
                        | "beepHighSoft"
                        | "beepIncremental"
                        | "bell"
                        | "car"
                        | "chickens"
                        | "chime"
                        | "chirpSoft"
                        | "clockMelody"
                        | "countdownSonar"
                        | "doorbell"
                        | "escalate"
                        | "fancy"
                        | "fastAndNervous"
                        | "harp"
                        | "incomingPhone"
                        | "introduction"
                        | "intrusive"
                        | "invasion"
                        | "jungle"
                        | "lofiChords"
                        | "loopLow"
                        | "melodySoft"
                        | "notifySubtle"
                        | "onOff"
                        | "orchestral"
                        | "pling"
                        | "plingHigh"
                        | "plingLow"
                        | "pluckSong"
                        | "quick"
                        | "scanning"
                        | "shake"
                        | "silence"
                        | "sirenHigh"
                        | "sirenLow"
                        | "soft"
                        | "spaceship"
                        | "startup"
                        | "threeTones"
                        | "tornado"
                        | "wailing"
                        | "wakeup"
                        | null;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      stopAfterSeconds?: number | null;
                      stopAfterTouch?: boolean | null;
                    };
                  };
                };
                /** @default true */
                showPositionLabels?: boolean;
                /** @default true */
                anonymous?: boolean;
                acknowledge?: {
                  enabled?: boolean;
                  /** @pattern ^[0-9]{4,6}$ */
                  pin?: string | null;
                  messagePresets?: string[] | null;
                };
                mode?: "zoneBased" | "customerBased" | null;
              };
              manageAvailability?: {
                /** @default true */
                enabled?: boolean;
                /** @pattern ^[0-9]{4,6}$ */
                pin?: string | null;
                /** @default true */
                showAppBanner?: boolean;
                /** @default false */
                forceShowSearch?: boolean;
                /** @default false */
                forceShowLabelFilter?: boolean;
              };
              hardware?: {
                /**
                 * @min 0
                 * @exclusiveMin false
                 * @max 100
                 * @exclusiveMax false
                 */
                screenBrightness?: number | null;
              };
            };
            battery?: number;
            rssi?: number;
            snr?: number;
            app?: {
              permissions?: {
                calendar?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                camera?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                contacts?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                microphone?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                notifications?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                criticalNotifications?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                motion?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                bluetooth?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                locationAlways?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                locationWhenInUse?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                physical?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                batteryOptimization?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                overlay?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
              };
              deviceOs?: {
                osType: "ios" | "android";
                /** @maxLength 1024 */
                osVersion: string;
                /** @maxLength 1024 */
                osId?: string;
                /** @maxLength 1024 */
                buildNumber?: string;
                /** @maxLength 1024 */
                bundleId?: string;
              };
              profile?: {
                /** @maxLength 1024 */
                name?: string;
                /** @maxLength 1024 */
                brand?: string;
                /** @maxLength 1024 */
                model?: string;
                /** @maxLength 1024 */
                carrier?: string;
              };
            } | null;
            clientConfig?: {
              app?: {
                definitions: (
                  | {
                      type: "key";
                      key: string;
                      value: any;
                      editableBy?: ("AssetGroup" | "Device")[];
                    }
                  | {
                      type: "group";
                      group: {
                        /** @format uuid */
                        _id: string;
                        _ref: "ClientConfigGroup";
                      };
                    }
                )[];
                filter?: {
                  type: "osFilter";
                  osType: "ios" | "android";
                  /** @maxLength 1024 */
                  osVersionRange?: string;
                };
              }[];
              kiosk?: {
                definitions: (
                  | {
                      type: "key";
                      key: string;
                      value: any;
                      editableBy?: ("AssetGroup" | "Device")[];
                    }
                  | {
                      type: "group";
                      group: {
                        /** @format uuid */
                        _id: string;
                        _ref: "ClientConfigGroup";
                      };
                    }
                )[];
                filter?: {
                  type: "osFilter";
                  osType: "ios" | "android";
                  /** @maxLength 1024 */
                  osVersionRange?: string;
                };
              }[];
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/devices`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a Device by id
     *
     * @tags Device
     * @name DevicesControllerFindById
     * @request GET:/devices/{id}
     * @secure
     */
    devicesControllerFindById: (
      id: string,
      query?: {
        populateAsset?: boolean;
        populateAssetCheckUpdate?: boolean;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeviceOutputDto, any>({
        path: `/devices/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a Device
     *
     * @tags Device
     * @name DevicesControllerUpdate
     * @request PATCH:/devices/{id}
     * @secure
     */
    devicesControllerUpdate: (
      id: string,
      data: DeviceUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeviceOutputDto, any>({
        path: `/devices/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a Device by id
     *
     * @tags Device
     * @name DevicesControllerRemove
     * @request DELETE:/devices/{id}
     * @secure
     */
    devicesControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/devices/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DevicesControllerGetSyncToAmsZones
     * @request POST:/devices/ams-zones
     * @secure
     */
    devicesControllerGetSyncToAmsZones: (
      data: DeviceGetSyncToAmsZonesRequestDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeviceGetSyncToAmsZonesResponseDto, any>({
        path: `/devices/ams-zones`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DevicesControllerGetHasBeaconsOrFingerprints
     * @request POST:/devices/has-beacons-or-fingerprints
     * @secure
     */
    devicesControllerGetHasBeaconsOrFingerprints: (
      data: DeviceHasBeaconsOrFingerprintsRequestDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeviceHasBeaconsOrFingerprintsResponseDto, any>({
        path: `/devices/has-beacons-or-fingerprints`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DevicesControllerSendReloginNotification
     * @request POST:/devices/relogin-notification
     * @secure
     */
    devicesControllerSendReloginNotification: (
      data: DeviceReloginNotificationDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/devices/relogin-notification`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Searches Device
     *
     * @tags Device
     * @name DevicesControllerSearch
     * @request GET:/devices/search
     * @secure
     */
    devicesControllerSearch: (
      query: {
        /** The search query string */
        q: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            asset: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            } | null;
            /**
             * PII
             * @maxLength 1024
             */
            name?: string;
            /**
             * PII
             * @maxLength 1024
             */
            deviceId: string;
            type: "appDevice" | "lora" | "loraGateway" | "flic" | "generic" | "kiosk";
            loraConfig?:
              | {
                  type: "adeunis.arf8123aa";
                  config: {
                    /** @maxLength 1024 */
                    fieldTest: string;
                  };
                }
              | {
                  type: "iotracker.v2";
                  config: {
                    /** @maxLength 1024 */
                    beaconScan: string;
                    /** @maxLength 1024 */
                    gps: string;
                    /** @maxLength 1024 */
                    preMandown: string;
                    /** @maxLength 1024 */
                    mandown: string;
                    /** @maxLength 1024 */
                    movement: string;
                    /** @maxLength 1024 */
                    alarmSeverity: string;
                    /** @maxLength 1024 */
                    alive: string;
                  };
                }
              | {
                  type: "milesight.ws101";
                  config: {
                    /** @maxLength 1024 */
                    beaconScan: string;
                    /** @maxLength 1024 */
                    alarmSeverity: string;
                    /** @maxLength 1024 */
                    alive: string;
                  };
                }
              | {
                  type: "sensative.1301001";
                  config: {
                    /** @maxLength 1024 */
                    alarmSeverity: string;
                    /** @maxLength 1024 */
                    alive: string;
                    /** @maxLength 1024 */
                    floodDetected: string;
                    /** @maxLength 1024 */
                    noFloodDetected: string;
                  };
                }
              | null;
            kioskConfig?: {
              /** @default false */
              managed?: boolean;
              zone?: {
                /** @format uuid */
                _id: string;
                _ref: "Zone";
              } | null;
              exposeAssets?:
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[]
                | null;
              exposeLabels?:
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                    countLabel?: boolean;
                  }[]
                | null;
              schedule?: {
                entries: {
                  daysOfWeek: number[];
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeStart: string;
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeEnd: string;
                }[];
              } | null;
              homepage?: {
                incidentCounter?: {
                  /** @default true */
                  enabled?: boolean;
                  /** @format date-time */
                  countFromDate?: string | null;
                  /**
                   * @min 0
                   * @exclusiveMin false
                   * @default 0
                   */
                  threshold?: number;
                };
                /** @default true */
                anonymous?: boolean;
                /** @format uri */
                logo?: string | null;
              };
              alarm?: {
                /** @default true */
                enabled?: boolean;
                focus?: {
                  red?: {
                    flash?: boolean | null;
                    sound?: {
                      enabled: boolean;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 100
                       * @exclusiveMax false
                       */
                      volume?: number | null;
                      sound?:
                        | "alarm"
                        | "alarmClock"
                        | "alarmRetro"
                        | "announcement"
                        | "attention"
                        | "bassPulse"
                        | "beepBeep"
                        | "beepBurglar"
                        | "beepContinuous"
                        | "beepHighSoft"
                        | "beepIncremental"
                        | "bell"
                        | "car"
                        | "chickens"
                        | "chime"
                        | "chirpSoft"
                        | "clockMelody"
                        | "countdownSonar"
                        | "doorbell"
                        | "escalate"
                        | "fancy"
                        | "fastAndNervous"
                        | "harp"
                        | "incomingPhone"
                        | "introduction"
                        | "intrusive"
                        | "invasion"
                        | "jungle"
                        | "lofiChords"
                        | "loopLow"
                        | "melodySoft"
                        | "notifySubtle"
                        | "onOff"
                        | "orchestral"
                        | "pling"
                        | "plingHigh"
                        | "plingLow"
                        | "pluckSong"
                        | "quick"
                        | "scanning"
                        | "shake"
                        | "silence"
                        | "sirenHigh"
                        | "sirenLow"
                        | "soft"
                        | "spaceship"
                        | "startup"
                        | "threeTones"
                        | "tornado"
                        | "wailing"
                        | "wakeup"
                        | null;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      stopAfterSeconds?: number | null;
                      stopAfterTouch?: boolean | null;
                    };
                  };
                  orange?: {
                    flash?: boolean | null;
                    sound?: {
                      enabled: boolean;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 100
                       * @exclusiveMax false
                       */
                      volume?: number | null;
                      sound?:
                        | "alarm"
                        | "alarmClock"
                        | "alarmRetro"
                        | "announcement"
                        | "attention"
                        | "bassPulse"
                        | "beepBeep"
                        | "beepBurglar"
                        | "beepContinuous"
                        | "beepHighSoft"
                        | "beepIncremental"
                        | "bell"
                        | "car"
                        | "chickens"
                        | "chime"
                        | "chirpSoft"
                        | "clockMelody"
                        | "countdownSonar"
                        | "doorbell"
                        | "escalate"
                        | "fancy"
                        | "fastAndNervous"
                        | "harp"
                        | "incomingPhone"
                        | "introduction"
                        | "intrusive"
                        | "invasion"
                        | "jungle"
                        | "lofiChords"
                        | "loopLow"
                        | "melodySoft"
                        | "notifySubtle"
                        | "onOff"
                        | "orchestral"
                        | "pling"
                        | "plingHigh"
                        | "plingLow"
                        | "pluckSong"
                        | "quick"
                        | "scanning"
                        | "shake"
                        | "silence"
                        | "sirenHigh"
                        | "sirenLow"
                        | "soft"
                        | "spaceship"
                        | "startup"
                        | "threeTones"
                        | "tornado"
                        | "wailing"
                        | "wakeup"
                        | null;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      stopAfterSeconds?: number | null;
                      stopAfterTouch?: boolean | null;
                    };
                  };
                  green?: {
                    flash?: boolean | null;
                    sound?: {
                      enabled: boolean;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 100
                       * @exclusiveMax false
                       */
                      volume?: number | null;
                      sound?:
                        | "alarm"
                        | "alarmClock"
                        | "alarmRetro"
                        | "announcement"
                        | "attention"
                        | "bassPulse"
                        | "beepBeep"
                        | "beepBurglar"
                        | "beepContinuous"
                        | "beepHighSoft"
                        | "beepIncremental"
                        | "bell"
                        | "car"
                        | "chickens"
                        | "chime"
                        | "chirpSoft"
                        | "clockMelody"
                        | "countdownSonar"
                        | "doorbell"
                        | "escalate"
                        | "fancy"
                        | "fastAndNervous"
                        | "harp"
                        | "incomingPhone"
                        | "introduction"
                        | "intrusive"
                        | "invasion"
                        | "jungle"
                        | "lofiChords"
                        | "loopLow"
                        | "melodySoft"
                        | "notifySubtle"
                        | "onOff"
                        | "orchestral"
                        | "pling"
                        | "plingHigh"
                        | "plingLow"
                        | "pluckSong"
                        | "quick"
                        | "scanning"
                        | "shake"
                        | "silence"
                        | "sirenHigh"
                        | "sirenLow"
                        | "soft"
                        | "spaceship"
                        | "startup"
                        | "threeTones"
                        | "tornado"
                        | "wailing"
                        | "wakeup"
                        | null;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      stopAfterSeconds?: number | null;
                      stopAfterTouch?: boolean | null;
                    };
                  };
                };
                /** @default true */
                showPositionLabels?: boolean;
                /** @default true */
                anonymous?: boolean;
                acknowledge?: {
                  enabled?: boolean;
                  /** @pattern ^[0-9]{4,6}$ */
                  pin?: string | null;
                  messagePresets?: string[] | null;
                };
                mode?: "zoneBased" | "customerBased" | null;
              };
              manageAvailability?: {
                /** @default true */
                enabled?: boolean;
                /** @pattern ^[0-9]{4,6}$ */
                pin?: string | null;
                /** @default true */
                showAppBanner?: boolean;
                /** @default false */
                forceShowSearch?: boolean;
                /** @default false */
                forceShowLabelFilter?: boolean;
              };
              hardware?: {
                /**
                 * @min 0
                 * @exclusiveMin false
                 * @max 100
                 * @exclusiveMax false
                 */
                screenBrightness?: number | null;
              };
            };
            battery?: number;
            rssi?: number;
            snr?: number;
            app?: {
              permissions?: {
                calendar?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                camera?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                contacts?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                microphone?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                notifications?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                criticalNotifications?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                motion?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                bluetooth?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                locationAlways?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                locationWhenInUse?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                physical?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                batteryOptimization?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
                overlay?: {
                  status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                  /** @default false */
                  alreadyAsked?: boolean;
                };
              };
              deviceOs?: {
                osType: "ios" | "android";
                /** @maxLength 1024 */
                osVersion: string;
                /** @maxLength 1024 */
                osId?: string;
                /** @maxLength 1024 */
                buildNumber?: string;
                /** @maxLength 1024 */
                bundleId?: string;
              };
              profile?: {
                /** @maxLength 1024 */
                name?: string;
                /** @maxLength 1024 */
                brand?: string;
                /** @maxLength 1024 */
                model?: string;
                /** @maxLength 1024 */
                carrier?: string;
              };
            } | null;
            clientConfig?: {
              app?: {
                definitions: (
                  | {
                      type: "key";
                      key: string;
                      value: any;
                      editableBy?: ("AssetGroup" | "Device")[];
                    }
                  | {
                      type: "group";
                      group: {
                        /** @format uuid */
                        _id: string;
                        _ref: "ClientConfigGroup";
                      };
                    }
                )[];
                filter?: {
                  type: "osFilter";
                  osType: "ios" | "android";
                  /** @maxLength 1024 */
                  osVersionRange?: string;
                };
              }[];
              kiosk?: {
                definitions: (
                  | {
                      type: "key";
                      key: string;
                      value: any;
                      editableBy?: ("AssetGroup" | "Device")[];
                    }
                  | {
                      type: "group";
                      group: {
                        /** @format uuid */
                        _id: string;
                        _ref: "ClientConfigGroup";
                      };
                    }
                )[];
                filter?: {
                  type: "osFilter";
                  osType: "ios" | "android";
                  /** @maxLength 1024 */
                  osVersionRange?: string;
                };
              }[];
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/devices/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DevicesControllerGetWithoutApp
     * @request GET:/devices/without-app
     * @secure
     */
    devicesControllerGetWithoutApp: (
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/devices/without-app`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  domainLinks = {
    /**
     * @description Creates a DomainLink
     *
     * @tags DomainLink
     * @name DomainLinksControllerCreate
     * @request POST:/domain-links
     * @secure
     */
    domainLinksControllerCreate: (
      data: DomainLinkCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DomainLinkOutputDto, any>({
        path: `/domain-links`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates DomainLink
     *
     * @tags DomainLink
     * @name DomainLinksControllerPaginate
     * @request GET:/domain-links
     * @secure
     */
    domainLinksControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customers: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            }[];
            /** PII */
            domains: string[];
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/domain-links`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a DomainLink by id
     *
     * @tags DomainLink
     * @name DomainLinksControllerFindById
     * @request GET:/domain-links/{id}
     * @secure
     */
    domainLinksControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DomainLinkOutputDto, any>({
        path: `/domain-links/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a DomainLink
     *
     * @tags DomainLink
     * @name DomainLinksControllerUpdate
     * @request PATCH:/domain-links/{id}
     * @secure
     */
    domainLinksControllerUpdate: (
      id: string,
      data: DomainLinkUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DomainLinkOutputDto, any>({
        path: `/domain-links/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a DomainLink by id
     *
     * @tags DomainLink
     * @name DomainLinksControllerRemove
     * @request DELETE:/domain-links/{id}
     * @secure
     */
    domainLinksControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/domain-links/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
  };
  fingerprints = {
    /**
     * @description Creates a Fingerprint
     *
     * @tags Fingerprint
     * @name FingerprintsControllerCreate
     * @request POST:/fingerprints
     * @secure
     */
    fingerprintsControllerCreate: (
      data: FingerprintCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FingerprintOutputDto, any>({
        path: `/fingerprints`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates Fingerprint
     *
     * @tags Fingerprint
     * @name FingerprintsControllerPaginate
     * @request GET:/fingerprints
     * @secure
     */
    fingerprintsControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            zone: {
              /** @format uuid */
              _id: string;
              _ref: "Zone";
            };
            /** PII */
            deviceInfo: {
              /** @maxLength 1024 */
              name: string;
              /** @maxLength 1024 */
              osName: string;
              /** @maxLength 1024 */
              osVersion: string;
              /** @maxLength 1024 */
              brand: string;
              /** @maxLength 1024 */
              model: string;
              /** @maxLength 1024 */
              appBundleId: string;
              /** @maxLength 1024 */
              appVersion: string;
            };
            /**
             * @maxLength 1024
             * @default null
             */
            description?: string | null;
            data: {
              /** @maxLength 1024 */
              code: string;
              rssi: number;
            }[][];
            beaconCodes?: string[];
            user: {
              /** @format uuid */
              _id: string;
              _ref: "User";
            };
            dataCount: number;
            enabled: boolean;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/fingerprints`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a Fingerprint by id
     *
     * @tags Fingerprint
     * @name FingerprintsControllerFindById
     * @request GET:/fingerprints/{id}
     * @secure
     */
    fingerprintsControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FingerprintOutputDto, any>({
        path: `/fingerprints/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a Fingerprint
     *
     * @tags Fingerprint
     * @name FingerprintsControllerUpdate
     * @request PATCH:/fingerprints/{id}
     * @secure
     */
    fingerprintsControllerUpdate: (
      id: string,
      data: FingerprintUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FingerprintOutputDto, any>({
        path: `/fingerprints/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a Fingerprint by id
     *
     * @tags Fingerprint
     * @name FingerprintsControllerRemove
     * @request DELETE:/fingerprints/{id}
     * @secure
     */
    fingerprintsControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/fingerprints/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fingerprint
     * @name FingerprintsControllerCreateBeaconsFromFingerprints
     * @request POST:/fingerprints/create-beacons
     * @secure
     */
    fingerprintsControllerCreateBeaconsFromFingerprints: (
      data: FingerPrintCustomerDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/fingerprints/create-beacons`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fingerprint
     * @name FingerprintsControllerFingerPrintBeaconCount
     * @request GET:/fingerprints/stats/beacon-count/{id}
     * @secure
     */
    fingerprintsControllerFingerPrintBeaconCount: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/fingerprints/stats/beacon-count/${id}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fingerprint
     * @name FingerprintsControllerFindCommonBeacons
     * @request GET:/fingerprints/stats/common-beacons/{id}
     * @secure
     */
    fingerprintsControllerFindCommonBeacons: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/fingerprints/stats/common-beacons/${id}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fingerprint
     * @name FingerprintsControllerFingerPrintDevices
     * @request GET:/fingerprints/stats/devices/{id}
     * @secure
     */
    fingerprintsControllerFingerPrintDevices: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/fingerprints/stats/devices/${id}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fingerprint
     * @name FingerprintsControllerFindEnoughBeacons
     * @request GET:/fingerprints/stats/enough-beacons/{id}
     * @secure
     */
    fingerprintsControllerFindEnoughBeacons: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/fingerprints/stats/enough-beacons/${id}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fingerprint
     * @name FingerprintsControllerFingerPrintProgress
     * @request GET:/fingerprints/stats/fingerprint-progress/{id}
     * @secure
     */
    fingerprintsControllerFingerPrintProgress: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/fingerprints/stats/fingerprint-progress/${id}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fingerprint
     * @name FingerprintsControllerFindMissingBeacons
     * @request GET:/fingerprints/stats/missing-beacons/{id}
     * @secure
     */
    fingerprintsControllerFindMissingBeacons: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/fingerprints/stats/missing-beacons/${id}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fingerprint
     * @name FingerprintsControllerFindFingerprintSimilarityByCustomer
     * @request POST:/fingerprints/stats/similarities
     * @secure
     */
    fingerprintsControllerFindFingerprintSimilarityByCustomer: (
      data: FingerPrintCustomerDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/fingerprints/stats/similarities`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  health = {
    /**
     * No description
     *
     * @tags Health
     * @name HealthControllerLastObservationHealth
     * @request POST:/health/last-observation
     * @secure
     */
    healthControllerLastObservationHealth: (
      data: LastObservationDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/health/last-observation`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Health
     * @name HealthControllerOpenAlarmsHealth
     * @request POST:/health/open-alarms
     * @secure
     */
    healthControllerOpenAlarmsHealth: (
      data: OpenAlarmDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/health/open-alarms`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Health
     * @name HealthControllerOpenAlarmsHealthAdmin
     * @request POST:/health/open-alarms/admin
     * @secure
     */
    healthControllerOpenAlarmsHealthAdmin: (
      data: OpenAlarmDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/health/open-alarms/admin`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Health
     * @name HealthControllerTriggerProcessing
     * @request POST:/health/trigger-processing
     * @secure
     */
    healthControllerTriggerProcessing: (
      data: TriggerProcessingDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/health/trigger-processing`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  observationTriggers = {
    /**
     * @description Creates a ObservationTrigger
     *
     * @tags ObservationTrigger
     * @name ObservationTriggersControllerCreate
     * @request POST:/observation-triggers
     * @secure
     */
    observationTriggersControllerCreate: (
      data: ObservationTriggerCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ObservationTriggerOutputDto, any>({
        path: `/observation-triggers`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates ObservationTrigger
     *
     * @tags ObservationTrigger
     * @name ObservationTriggersControllerPaginate
     * @request GET:/observation-triggers
     * @secure
     */
    observationTriggersControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /** @maxLength 1024 */
            name: string;
            eventCodes: string[];
            /** @maxLength 1024 */
            description: string;
            status: "active" | "inactive";
            actions: (
              | {
                  type: "alarm";
                  config: {
                    severity: "red" | "orange" | "green";
                    type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
                    /** @maxLength 4096 */
                    procedure: string | null;
                    /** @maxLength 1024 */
                    name: string;
                  };
                }
              | {
                  type: "sms";
                  config: {
                    /** PII */
                    toRaw: string[];
                    toContactList: {
                      /** @format uuid */
                      _id: string;
                      _ref: "ContactList";
                    }[];
                    toTriggerUser: boolean;
                    /** @maxLength 1024 */
                    message: string;
                  };
                }
              | {
                  type: "email";
                  config: {
                    /** PII */
                    toRaw: string[];
                    toContactList: {
                      /** @format uuid */
                      _id: string;
                      _ref: "ContactList";
                    }[];
                    toTriggerUser: boolean;
                    /** @maxLength 1024 */
                    message: string;
                    /** @maxLength 1024 */
                    subject: string;
                    /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                    locale?: string;
                  };
                }
              | {
                  type: "assetUpdate";
                  config: {
                    available?: boolean;
                    app?: {
                      mode: "off" | "on" | "risk";
                    };
                  };
                }
            )[];
            filter:
              | {
                  type: "operator/and";
                  operands: (
                    | {
                        type: "operator/or";
                        operands: (
                          | {
                              type: "operator/not";
                              operand:
                                | {
                                    type: "constraint/asset";
                                    assets: {
                                      /** @format uuid */
                                      _id: string;
                                      _ref: "Asset";
                                    }[];
                                  }
                                | {
                                    type: "constraint/assetGroup";
                                    groups: {
                                      /** @format uuid */
                                      _id: string;
                                      _ref: "AssetGroup";
                                    }[];
                                  }
                                | {
                                    type: "constraint/zone";
                                    zone: {
                                      /** @format uuid */
                                      _id: string;
                                      _ref: "Zone";
                                    };
                                  }
                                | {
                                    type: "constraint/schedule";
                                    schedule: {
                                      entries: {
                                        daysOfWeek: number[];
                                        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                        timeStart: string;
                                        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                        timeEnd: string;
                                      }[];
                                    };
                                  };
                            }
                          | {
                              type: "constraint/asset";
                              assets: {
                                /** @format uuid */
                                _id: string;
                                _ref: "Asset";
                              }[];
                            }
                          | {
                              type: "constraint/assetGroup";
                              groups: {
                                /** @format uuid */
                                _id: string;
                                _ref: "AssetGroup";
                              }[];
                            }
                          | {
                              type: "constraint/zone";
                              zone: {
                                /** @format uuid */
                                _id: string;
                                _ref: "Zone";
                              };
                            }
                          | {
                              type: "constraint/schedule";
                              schedule: {
                                entries: {
                                  daysOfWeek: number[];
                                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                  timeStart: string;
                                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                  timeEnd: string;
                                }[];
                              };
                            }
                        )[];
                      }
                    | {
                        type: "constraint/asset";
                        assets: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Asset";
                        }[];
                      }
                    | {
                        type: "constraint/assetGroup";
                        groups: {
                          /** @format uuid */
                          _id: string;
                          _ref: "AssetGroup";
                        }[];
                      }
                    | {
                        type: "constraint/zone";
                        zone: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Zone";
                        };
                      }
                    | {
                        type: "constraint/schedule";
                        schedule: {
                          entries: {
                            daysOfWeek: number[];
                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                            timeStart: string;
                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                            timeEnd: string;
                          }[];
                        };
                      }
                  )[];
                }
              | {
                  type: "constraint/asset";
                  assets: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Asset";
                  }[];
                }
              | {
                  type: "constraint/assetGroup";
                  groups: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[];
                }
              | {
                  type: "constraint/zone";
                  zone: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Zone";
                  };
                }
              | {
                  type: "constraint/schedule";
                  schedule: {
                    entries: {
                      daysOfWeek: number[];
                      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                      timeStart: string;
                      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                      timeEnd: string;
                    }[];
                  };
                };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/observation-triggers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a ObservationTrigger by id
     *
     * @tags ObservationTrigger
     * @name ObservationTriggersControllerFindById
     * @request GET:/observation-triggers/{id}
     * @secure
     */
    observationTriggersControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ObservationTriggerOutputDto, any>({
        path: `/observation-triggers/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a ObservationTrigger
     *
     * @tags ObservationTrigger
     * @name ObservationTriggersControllerUpdate
     * @request PATCH:/observation-triggers/{id}
     * @secure
     */
    observationTriggersControllerUpdate: (
      id: string,
      data: ObservationTriggerUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ObservationTriggerOutputDto, any>({
        path: `/observation-triggers/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a ObservationTrigger by id
     *
     * @tags ObservationTrigger
     * @name ObservationTriggersControllerRemove
     * @request DELETE:/observation-triggers/{id}
     * @secure
     */
    observationTriggersControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/observation-triggers/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ObservationTrigger
     * @name ObservationTriggersControllerGetForEvent
     * @request GET:/observation-triggers/for-code/{event}
     * @secure
     */
    observationTriggersControllerGetForEvent: (
      event: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ObservationTriggerOutputDto[], any>({
        path: `/observation-triggers/for-code/${event}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Searches ObservationTrigger
     *
     * @tags ObservationTrigger
     * @name ObservationTriggersControllerSearch
     * @request GET:/observation-triggers/search
     * @secure
     */
    observationTriggersControllerSearch: (
      query: {
        /** The search query string */
        q: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /** @maxLength 1024 */
            name: string;
            eventCodes: string[];
            /** @maxLength 1024 */
            description: string;
            status: "active" | "inactive";
            actions: (
              | {
                  type: "alarm";
                  config: {
                    severity: "red" | "orange" | "green";
                    type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
                    /** @maxLength 4096 */
                    procedure: string | null;
                    /** @maxLength 1024 */
                    name: string;
                  };
                }
              | {
                  type: "sms";
                  config: {
                    /** PII */
                    toRaw: string[];
                    toContactList: {
                      /** @format uuid */
                      _id: string;
                      _ref: "ContactList";
                    }[];
                    toTriggerUser: boolean;
                    /** @maxLength 1024 */
                    message: string;
                  };
                }
              | {
                  type: "email";
                  config: {
                    /** PII */
                    toRaw: string[];
                    toContactList: {
                      /** @format uuid */
                      _id: string;
                      _ref: "ContactList";
                    }[];
                    toTriggerUser: boolean;
                    /** @maxLength 1024 */
                    message: string;
                    /** @maxLength 1024 */
                    subject: string;
                    /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                    locale?: string;
                  };
                }
              | {
                  type: "assetUpdate";
                  config: {
                    available?: boolean;
                    app?: {
                      mode: "off" | "on" | "risk";
                    };
                  };
                }
            )[];
            filter:
              | {
                  type: "operator/and";
                  operands: (
                    | {
                        type: "operator/or";
                        operands: (
                          | {
                              type: "operator/not";
                              operand:
                                | {
                                    type: "constraint/asset";
                                    assets: {
                                      /** @format uuid */
                                      _id: string;
                                      _ref: "Asset";
                                    }[];
                                  }
                                | {
                                    type: "constraint/assetGroup";
                                    groups: {
                                      /** @format uuid */
                                      _id: string;
                                      _ref: "AssetGroup";
                                    }[];
                                  }
                                | {
                                    type: "constraint/zone";
                                    zone: {
                                      /** @format uuid */
                                      _id: string;
                                      _ref: "Zone";
                                    };
                                  }
                                | {
                                    type: "constraint/schedule";
                                    schedule: {
                                      entries: {
                                        daysOfWeek: number[];
                                        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                        timeStart: string;
                                        /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                        timeEnd: string;
                                      }[];
                                    };
                                  };
                            }
                          | {
                              type: "constraint/asset";
                              assets: {
                                /** @format uuid */
                                _id: string;
                                _ref: "Asset";
                              }[];
                            }
                          | {
                              type: "constraint/assetGroup";
                              groups: {
                                /** @format uuid */
                                _id: string;
                                _ref: "AssetGroup";
                              }[];
                            }
                          | {
                              type: "constraint/zone";
                              zone: {
                                /** @format uuid */
                                _id: string;
                                _ref: "Zone";
                              };
                            }
                          | {
                              type: "constraint/schedule";
                              schedule: {
                                entries: {
                                  daysOfWeek: number[];
                                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                  timeStart: string;
                                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                                  timeEnd: string;
                                }[];
                              };
                            }
                        )[];
                      }
                    | {
                        type: "constraint/asset";
                        assets: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Asset";
                        }[];
                      }
                    | {
                        type: "constraint/assetGroup";
                        groups: {
                          /** @format uuid */
                          _id: string;
                          _ref: "AssetGroup";
                        }[];
                      }
                    | {
                        type: "constraint/zone";
                        zone: {
                          /** @format uuid */
                          _id: string;
                          _ref: "Zone";
                        };
                      }
                    | {
                        type: "constraint/schedule";
                        schedule: {
                          entries: {
                            daysOfWeek: number[];
                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                            timeStart: string;
                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                            timeEnd: string;
                          }[];
                        };
                      }
                  )[];
                }
              | {
                  type: "constraint/asset";
                  assets: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Asset";
                  }[];
                }
              | {
                  type: "constraint/assetGroup";
                  groups: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[];
                }
              | {
                  type: "constraint/zone";
                  zone: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Zone";
                  };
                }
              | {
                  type: "constraint/schedule";
                  schedule: {
                    entries: {
                      daysOfWeek: number[];
                      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                      timeStart: string;
                      /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                      timeEnd: string;
                    }[];
                  };
                };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/observation-triggers/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  overlays = {
    /**
     * @description Creates a Overlay
     *
     * @tags Overlay
     * @name OverlaysControllerCreate
     * @request POST:/overlays
     * @secure
     */
    overlaysControllerCreate: (
      data: OverlayCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OverlayOutputDto, any>({
        path: `/overlays`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates Overlay
     *
     * @tags Overlay
     * @name OverlaysControllerPaginate
     * @request GET:/overlays
     * @secure
     */
    overlaysControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /** @format uri */
            imageUrl: string | null;
            /** @default 0 */
            level?: number;
            /** PII */
            points: {
              sw: {
                lat: number;
                lng: number;
              };
              ne: {
                lat: number;
                lng: number;
              };
              nw: {
                lat: number;
                lng: number;
              };
              se: {
                lat: number;
                lng: number;
              };
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/overlays`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a Overlay by id
     *
     * @tags Overlay
     * @name OverlaysControllerFindById
     * @request GET:/overlays/{id}
     * @secure
     */
    overlaysControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OverlayOutputDto, any>({
        path: `/overlays/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a Overlay
     *
     * @tags Overlay
     * @name OverlaysControllerUpdate
     * @request PATCH:/overlays/{id}
     * @secure
     */
    overlaysControllerUpdate: (
      id: string,
      data: OverlayUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OverlayOutputDto, any>({
        path: `/overlays/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a Overlay by id
     *
     * @tags Overlay
     * @name OverlaysControllerRemove
     * @request DELETE:/overlays/{id}
     * @secure
     */
    overlaysControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/overlays/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Overlay
     * @name OverlaysControllerAddPhoto
     * @request POST:/overlays/app/photo
     * @secure
     */
    overlaysControllerAddPhoto: (
      query: {
        /** Overlay id parameter */
        id: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      data: {
        /** @format binary */
        photo_url: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<ImageUploadDto, any>({
        path: `/overlays/app/photo`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Searches Overlay
     *
     * @tags Overlay
     * @name OverlaysControllerSearch
     * @request GET:/overlays/search
     * @secure
     */
    overlaysControllerSearch: (
      query: {
        /** The search query string */
        q: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /** @format uri */
            imageUrl: string | null;
            /** @default 0 */
            level?: number;
            /** PII */
            points: {
              sw: {
                lat: number;
                lng: number;
              };
              ne: {
                lat: number;
                lng: number;
              };
              nw: {
                lat: number;
                lng: number;
              };
              se: {
                lat: number;
                lng: number;
              };
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/overlays/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  registrationTemplates = {
    /**
     * @description Creates a RegistrationTemplate
     *
     * @tags RegistrationTemplate
     * @name RegistrationTemplatesControllerCreate
     * @request POST:/registration-templates
     * @secure
     */
    registrationTemplatesControllerCreate: (
      data: RegistrationTemplateCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RegistrationTemplateOutputDto, any>({
        path: `/registration-templates`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates RegistrationTemplate
     *
     * @tags RegistrationTemplate
     * @name RegistrationTemplatesControllerPaginate
     * @request GET:/registration-templates
     * @secure
     */
    registrationTemplatesControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /** @maxLength 1024 */
            name: string;
            code: string[];
            numberUsed: number;
            /** @format date-time */
            lastUsed: string | null;
            profile: {
              /** @default [] */
              assetGroups?: {
                /** @format uuid */
                _id: string;
                _ref: "AssetGroup";
              }[];
              /** @default [] */
              configGroups?: {
                /** @format uuid */
                _id: string;
                _ref: "ClientConfigGroup";
              }[];
              /** @default [] */
              assetGroupLimit?: {
                /** @format uuid */
                _id: string;
                _ref: "AssetGroup";
              }[];
              /** @default [] */
              legacyConfigGroups?: string[];
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/registration-templates`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a RegistrationTemplate by id
     *
     * @tags RegistrationTemplate
     * @name RegistrationTemplatesControllerFindById
     * @request GET:/registration-templates/{id}
     * @secure
     */
    registrationTemplatesControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RegistrationTemplateOutputDto, any>({
        path: `/registration-templates/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a RegistrationTemplate
     *
     * @tags RegistrationTemplate
     * @name RegistrationTemplatesControllerUpdate
     * @request PATCH:/registration-templates/{id}
     * @secure
     */
    registrationTemplatesControllerUpdate: (
      id: string,
      data: RegistrationTemplateUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RegistrationTemplateOutputDto, any>({
        path: `/registration-templates/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RegistrationTemplate
     * @name RegistrationTemplatesControllerAdminRegister
     * @request POST:/registration-templates/admin-register
     * @secure
     */
    registrationTemplatesControllerAdminRegister: (
      data: RegistrationDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/registration-templates/admin-register`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags RegistrationTemplate
     * @name RegistrationTemplatesControllerRegister
     * @request POST:/registration-templates/register
     * @secure
     */
    registrationTemplatesControllerRegister: (
      data: RegistrationDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/registration-templates/register`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Searches RegistrationTemplate
     *
     * @tags RegistrationTemplate
     * @name RegistrationTemplatesControllerSearch
     * @request GET:/registration-templates/search
     * @secure
     */
    registrationTemplatesControllerSearch: (
      query: {
        /** The search query string */
        q: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /** @maxLength 1024 */
            name: string;
            code: string[];
            numberUsed: number;
            /** @format date-time */
            lastUsed: string | null;
            profile: {
              /** @default [] */
              assetGroups?: {
                /** @format uuid */
                _id: string;
                _ref: "AssetGroup";
              }[];
              /** @default [] */
              configGroups?: {
                /** @format uuid */
                _id: string;
                _ref: "ClientConfigGroup";
              }[];
              /** @default [] */
              assetGroupLimit?: {
                /** @format uuid */
                _id: string;
                _ref: "AssetGroup";
              }[];
              /** @default [] */
              legacyConfigGroups?: string[];
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/registration-templates/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RegistrationTemplate
     * @name RegistrationTemplatesControllerValidateEmailDomain
     * @request POST:/registration-templates/validate-email-domain
     * @secure
     */
    registrationTemplatesControllerValidateEmailDomain: (
      data: ValidateEmailDomainDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/registration-templates/validate-email-domain`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  reportTriggerRuns = {
    /**
     * @description Creates a ReportTriggerRun
     *
     * @tags ReportTriggerRun
     * @name ReportTriggerRunControllerCreate
     * @request POST:/report-trigger-runs
     * @secure
     */
    reportTriggerRunControllerCreate: (
      data: ReportTriggerRunCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReportTriggerRunOutputDto, any>({
        path: `/report-trigger-runs`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates ReportTriggerRun
     *
     * @tags ReportTriggerRun
     * @name ReportTriggerRunControllerPaginate
     * @request GET:/report-trigger-runs
     * @secure
     */
    reportTriggerRunControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            } | null;
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /** PII */
            reportTrigger: {
              /** @format uuid */
              _id: string;
              /** @format date-time */
              createdAt: string;
              /** @format date-time */
              updatedAt: string;
              telluId?: number | null;
              migrationFinalised?: boolean | null;
              /** @format date-time */
              migrationFinalisedDate?: string | null;
              customer: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              } | null;
              /** @default {"type":"parents","extra":[]} */
              share?: {
                type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                extra?: {
                  /** @format uuid */
                  _id: string;
                  _ref: "Customer";
                }[];
              };
              config:
                | {
                    type: "accessRequestAlert";
                    filter?: {
                      forced?: boolean;
                    };
                    theme?: "bhvk" | "default";
                  }
                | {
                    type: "accessRequestOverview";
                    theme?: "bhvk" | "default";
                    pagination: {
                      /** @format date-time */
                      after: string;
                      order: "asc" | "desc";
                      max: number;
                    };
                  }
                | {
                    type: "alarmCenterStatus";
                    exclude?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Customer";
                    }[];
                    timeframe: {
                      type: "month" | "week" | "day" | "hour" | "minute";
                      value: number;
                      floorTo?: "month" | "week" | "day" | "hour" | "minute";
                    };
                    theme?: "bhvk" | "default";
                  }
                | {
                    type: "alarmCenterAnalytics";
                    timeSeries: {
                      granularity: {
                        type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                        value: number;
                      };
                      timeframe: {
                        type: "month" | "week" | "day" | "hour" | "minute";
                        value: number;
                        floorTo?: "month" | "week" | "day" | "hour" | "minute";
                      };
                    };
                    theme?: "bhvk" | "default";
                  }
                | {
                    type: "alarms";
                    excelFormat: "default" | "smc";
                    excelColumns?: (
                      | "customer"
                      | "name"
                      | "severity"
                      | "type"
                      | "asset"
                      | "createdAt"
                      | "timeOfFirstHelper"
                      | "timeUntilFirstHelper"
                      | "alarmCenter"
                      | "ackedAt"
                      | "ackMessage"
                      | "position"
                      | "assetPosition"
                      | "helperCount.true"
                      | "helperCount.null"
                      | "helperCount.false"
                      | "helperName.true"
                      | "helperName.null"
                      | "helperName.false"
                      | "alarmManager"
                      | "alarmId"
                      | "assetId"
                      | "hubspotId"
                      | "alarmDate"
                      | "customerName"
                      | "assetName"
                      | "simpleDescription"
                      | "contractDeliveryDate"
                      | "alarmName"
                      | "onHelpProtocol"
                      | "policeCalled"
                    )[];
                    filter?: {
                      assets?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Asset";
                      }[];
                      assetGroups?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "AssetGroup";
                      }[];
                    };
                    severities?: ("red" | "orange" | "green")[] | null;
                    alarmTypes?:
                      | ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[]
                      | null;
                    timeSeries: {
                      granularity: {
                        type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                        value: number;
                      };
                      timeframe: {
                        type: "month" | "week" | "day" | "hour" | "minute";
                        value: number;
                        floorTo?: "month" | "week" | "day" | "hour" | "minute";
                      };
                    };
                    theme?: "bhvk" | "default";
                  }
                | {
                    type: "appUsage";
                    mode?: "hourlyUsage" | "license";
                    filter?: {
                      assets?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Asset";
                      }[];
                      assetGroups?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "AssetGroup";
                      }[];
                    };
                    timeSeries: {
                      granularity: {
                        type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                        value: number;
                      };
                      timeframe: {
                        type: "month" | "week";
                        /**
                         * @min 1
                         * @max 1
                         */
                        value: number;
                        floorTo?: "month" | "week" | "day" | "hour" | "minute";
                      };
                    };
                    inactivityThreshold?:
                      | {
                          type: "minute";
                          value: number;
                        }
                      | {
                          type: "hour";
                          value: number;
                        }
                      | {
                          type: "day";
                          /**
                           * @min 1
                           * @exclusiveMin false
                           * @max 14
                           * @exclusiveMax false
                           */
                          value: number;
                        };
                    reduceEmailSize?: boolean;
                    theme?: "bhvk" | "default";
                  }
                | {
                    type: "assetCertificationExpiryBulk";
                  }
                | {
                    type: "assetCertificationExpiry";
                  }
                | {
                    type: "assetHistory";
                    asset: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset";
                    };
                    timeSeries: {
                      granularity: {
                        type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                        value: number;
                      };
                      timeframe: {
                        type: "month" | "week" | "day" | "hour" | "minute";
                        value: number;
                        floorTo?: "month" | "week" | "day" | "hour" | "minute";
                      };
                    };
                    aggregatorOptions: {
                      includeRaw: boolean;
                      includeSimple: boolean;
                    };
                    theme?: "bhvk" | "default";
                  }
                | {
                    type: "assetVerificationCode";
                    theme?: "bhvk" | "default";
                  }
                | {
                    type: "auditLog";
                    subject?: (
                      | "Alarm"
                      | "AlarmCall"
                      | "AlarmCallEvent"
                      | "AlarmCallParticipant"
                      | "AlarmEvent"
                      | "AlarmHelper"
                      | "AlarmPushSubscription"
                      | "AlarmProfessionalResponder"
                      | "Asset"
                      | "AssetGroup"
                      | "AssetPropertyVerification"
                      | "AuditLog"
                      | "Beacon"
                      | "BillingAuditLog"
                      | "BillingContract"
                      | "BillingCustomer"
                      | "BillingInvoice"
                      | "ContactList"
                      | "Customer"
                      | "CustomerAlarmCenterRelation"
                      | "CustomerUserRelation"
                      | "Device"
                      | "DeviceLogUpload"
                      | "DomainLink"
                      | "Observation"
                      | "ObservationTrigger"
                      | "Overlay"
                      | "RegistrationTemplate"
                      | "ReportTrigger"
                      | "ReportTriggerRun"
                      | "Role"
                      | "StaticResponder"
                      | "Webhook"
                      | "User"
                      | "Zone"
                      | "Fingerprint"
                      | "Visitor"
                      | "VisitRecord"
                      | "Report"
                      | "DeviceLogUploadBatch"
                      | "all"
                    )[];
                    operation?: string[];
                    user?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "User";
                    }[];
                    reasonKey?: string[];
                    ids?: string[];
                    pagination: {
                      /** @format date-time */
                      after: string;
                      order: "asc" | "desc";
                      max: number;
                    };
                    exposeUsers?: boolean;
                    exposeHistory?: boolean;
                  }
                | {
                    type: "badReviewOnSurvey";
                    omitPiiFields?: ("phone" | "email")[];
                  }
                | {
                    type: "deviceLog";
                    device?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Device";
                    }[];
                    deviceLogUpload?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "DeviceLogUpload";
                    }[];
                    severity?: ("debug" | "info" | "warning" | "error")[];
                    message?: string[];
                    location?: string[];
                    pagination: {
                      /** @format date-time */
                      after: string;
                      order: "asc" | "desc";
                      max: number;
                    };
                  }
                | {
                    type: "gatewayAlive";
                    lastSeenThreshold: {
                      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                      value: number;
                    };
                  }
                | {
                    type: "inactivityMonitor";
                    lastSeenThreshold: {
                      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                      value: number;
                    };
                    assets?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset";
                    }[];
                    assetGroups?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "AssetGroup";
                    }[];
                    appMode?: ("off" | "on" | "risk")[];
                    timeout?: {
                      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                      value: number;
                    };
                    theme?: "bhvk" | "default";
                    omitPiiFields?: "address"[];
                  }
                | {
                    type: "inventoryItemsExpiry";
                  }
                | {
                    type: "newAlarm";
                    filter?: {
                      severities?: ("red" | "orange" | "green")[];
                      alarmTypes?: (
                        | "panic"
                        | "assistance"
                        | "test"
                        | "outage"
                        | "fire"
                        | "medical"
                        | "mandown"
                        | "other"
                      )[];
                      assets?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "Asset";
                      }[];
                      assetGroups?: {
                        /** @format uuid */
                        _id: string;
                        _ref: "AssetGroup";
                      }[];
                    };
                    procedure?: string;
                    info?: string;
                    hideOpenInAppButton?: boolean;
                    exposeAlarmCreatorProperties?: ("smsNumber" | "phoneNumber" | "email")[];
                    theme?: "bhvk" | "default";
                  }
                | {
                    type: "surveyInvitation";
                  }
                | {
                    type: "surveyOverview";
                    timeframe: {
                      type: "month" | "week" | "day" | "hour" | "minute";
                      value: number;
                      floorTo?: "month" | "week" | "day" | "hour" | "minute";
                    };
                  }
                | {
                    type: "unhealthyBeacons";
                    lastSeenThreshold: {
                      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                      value: number;
                    };
                    theme?: "bhvk" | "default";
                  }
                | {
                    type: "zoneOverview";
                    inactivityThreshold?: {
                      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                      value: number;
                    };
                    timeSeries: {
                      granularity: {
                        type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                        value: number;
                      };
                      timeframe: {
                        type: "month" | "week" | "day" | "hour" | "minute";
                        value: number;
                        floorTo?: "month" | "week" | "day" | "hour" | "minute";
                      };
                    };
                    minOccupancyMode?: "alert" | "overview";
                    minOccupancy?: {
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 1
                       * @exclusiveMax false
                       */
                      ratioThreshold: number;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      assetCount: number;
                    };
                    attachment?: {
                      granularity: {
                        type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                        value: number;
                      };
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 1
                       * @exclusiveMax false
                       */
                      availabilityThresholdRatio?: number;
                    };
                    zones?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Zone";
                    }[];
                    assets?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset";
                    }[];
                    assetGroups?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "AssetGroup";
                    }[];
                    schedule?:
                      | {
                          entries: {
                            daysOfWeek: number[];
                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                            timeStart: string;
                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                            timeEnd: string;
                            /**
                             * @min 0
                             * @exclusiveMin false
                             */
                            minOccupancy: number;
                          }[];
                        }
                      | {
                          entries: {
                            daysOfWeek: number[];
                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                            timeStart: string;
                            /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                            timeEnd: string;
                          }[];
                        };
                    theme?: "bhvk" | "default";
                    disableCompressTimeseries?: boolean;
                  }
                | {
                    type: "visitorRegistrationQrCode";
                  };
              channelOverrides?: {
                /** PII */
                unsubscribedEmails: string[];
              };
              channels: (
                | {
                    type: "email";
                    /** PII */
                    address?: string[];
                    contactLists?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "ContactList";
                    }[];
                    getters?: {
                      /** @maxLength 1024 */
                      path: string;
                    }[];
                    assets?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset";
                    }[];
                    assetGroups?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "AssetGroup";
                    }[];
                    config?: {
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      subjectOverride?: string;
                      /**
                       * PII
                       * @maxLength 4096
                       */
                      headerOverride?: string;
                    };
                  }
                | {
                    type: "sms";
                    /** PII */
                    numbers: string[];
                    contactLists: {
                      /** @format uuid */
                      _id: string;
                      _ref: "ContactList";
                    }[];
                  }
                | {
                    type: "alarm";
                    config: {
                      severity: "red" | "orange" | "green";
                      type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
                      /**
                       * PII
                       * @maxLength 4096
                       */
                      procedure: string | null;
                      /**
                       * PII
                       * @maxLength 1024
                       */
                      name: string;
                    };
                  }
                | {
                    type: "observation";
                  }
              )[];
              /** @default null */
              scheduleTrigger?: {
                interval: {
                  type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                  value: number;
                };
                cooldown?: {
                  type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                  value: number;
                };
                /** @format date-time */
                nextAt: string | null;
                /** @format date-time */
                lastAt: string | null;
                /** @format date-time */
                lastAttemptedAt: string | null;
              };
              /** @default null */
              eventTrigger?: {
                events: string[];
                executionDelay?: {
                  type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                  value: number;
                };
                schedule?: {
                  entries: {
                    daysOfWeek: number[];
                    /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                    timeStart: string;
                    /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                    timeEnd: string;
                  }[];
                };
              } | null;
              enabled: boolean;
              /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
              locale?: string;
              /** @maxLength 1024 */
              timezone?: string;
            };
            runReason: "schedule" | "event";
            /** @format date-time */
            generatedAt: string;
            /** PII */
            output: Record<string, any>;
            /** PII */
            channelResults: {
              success: boolean;
              data?: any;
            }[];
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/report-trigger-runs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a ReportTriggerRun by id
     *
     * @tags ReportTriggerRun
     * @name ReportTriggerRunControllerFindById
     * @request GET:/report-trigger-runs/{id}
     * @secure
     */
    reportTriggerRunControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReportTriggerRunOutputDto, any>({
        path: `/report-trigger-runs/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportTriggerRun
     * @name ReportTriggerRunControllerUpdateChannelResult
     * @request PATCH:/report-trigger-runs/{id}/channel-result/{channelIndex}
     * @secure
     */
    reportTriggerRunControllerUpdateChannelResult: (
      id: string,
      channelIndex: number,
      data: ReportTriggerChannelResultUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/report-trigger-runs/${id}/channel-result/${channelIndex}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  reportTriggers = {
    /**
     * @description Creates a ReportTrigger
     *
     * @tags ReportTrigger
     * @name ReportTriggersControllerCreate
     * @request POST:/report-triggers
     * @secure
     */
    reportTriggersControllerCreate: (
      data: ReportTriggerCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReportTriggerOutputDto, any>({
        path: `/report-triggers`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates ReportTrigger
     *
     * @tags ReportTrigger
     * @name ReportTriggersControllerPaginate
     * @request GET:/report-triggers
     * @secure
     */
    reportTriggersControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            } | null;
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            config:
              | {
                  type: "accessRequestAlert";
                  filter?: {
                    forced?: boolean;
                  };
                  theme?: "bhvk" | "default";
                }
              | {
                  type: "accessRequestOverview";
                  theme?: "bhvk" | "default";
                  pagination: {
                    /** @format date-time */
                    after: string;
                    order: "asc" | "desc";
                    max: number;
                  };
                }
              | {
                  type: "alarmCenterStatus";
                  exclude?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Customer";
                  }[];
                  timeframe: {
                    type: "month" | "week" | "day" | "hour" | "minute";
                    value: number;
                    floorTo?: "month" | "week" | "day" | "hour" | "minute";
                  };
                  theme?: "bhvk" | "default";
                }
              | {
                  type: "alarmCenterAnalytics";
                  timeSeries: {
                    granularity: {
                      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                      value: number;
                    };
                    timeframe: {
                      type: "month" | "week" | "day" | "hour" | "minute";
                      value: number;
                      floorTo?: "month" | "week" | "day" | "hour" | "minute";
                    };
                  };
                  theme?: "bhvk" | "default";
                }
              | {
                  type: "alarms";
                  excelFormat: "default" | "smc";
                  excelColumns?: (
                    | "customer"
                    | "name"
                    | "severity"
                    | "type"
                    | "asset"
                    | "createdAt"
                    | "timeOfFirstHelper"
                    | "timeUntilFirstHelper"
                    | "alarmCenter"
                    | "ackedAt"
                    | "ackMessage"
                    | "position"
                    | "assetPosition"
                    | "helperCount.true"
                    | "helperCount.null"
                    | "helperCount.false"
                    | "helperName.true"
                    | "helperName.null"
                    | "helperName.false"
                    | "alarmManager"
                    | "alarmId"
                    | "assetId"
                    | "hubspotId"
                    | "alarmDate"
                    | "customerName"
                    | "assetName"
                    | "simpleDescription"
                    | "contractDeliveryDate"
                    | "alarmName"
                    | "onHelpProtocol"
                    | "policeCalled"
                  )[];
                  filter?: {
                    assets?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset";
                    }[];
                    assetGroups?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "AssetGroup";
                    }[];
                  };
                  severities?: ("red" | "orange" | "green")[] | null;
                  alarmTypes?:
                    | ("panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other")[]
                    | null;
                  timeSeries: {
                    granularity: {
                      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                      value: number;
                    };
                    timeframe: {
                      type: "month" | "week" | "day" | "hour" | "minute";
                      value: number;
                      floorTo?: "month" | "week" | "day" | "hour" | "minute";
                    };
                  };
                  theme?: "bhvk" | "default";
                }
              | {
                  type: "appUsage";
                  mode?: "hourlyUsage" | "license";
                  filter?: {
                    assets?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset";
                    }[];
                    assetGroups?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "AssetGroup";
                    }[];
                  };
                  timeSeries: {
                    granularity: {
                      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                      value: number;
                    };
                    timeframe: {
                      type: "month" | "week";
                      /**
                       * @min 1
                       * @max 1
                       */
                      value: number;
                      floorTo?: "month" | "week" | "day" | "hour" | "minute";
                    };
                  };
                  inactivityThreshold?:
                    | {
                        type: "minute";
                        value: number;
                      }
                    | {
                        type: "hour";
                        value: number;
                      }
                    | {
                        type: "day";
                        /**
                         * @min 1
                         * @exclusiveMin false
                         * @max 14
                         * @exclusiveMax false
                         */
                        value: number;
                      };
                  reduceEmailSize?: boolean;
                  theme?: "bhvk" | "default";
                }
              | {
                  type: "assetCertificationExpiryBulk";
                }
              | {
                  type: "assetCertificationExpiry";
                }
              | {
                  type: "assetHistory";
                  asset: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Asset";
                  };
                  timeSeries: {
                    granularity: {
                      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                      value: number;
                    };
                    timeframe: {
                      type: "month" | "week" | "day" | "hour" | "minute";
                      value: number;
                      floorTo?: "month" | "week" | "day" | "hour" | "minute";
                    };
                  };
                  aggregatorOptions: {
                    includeRaw: boolean;
                    includeSimple: boolean;
                  };
                  theme?: "bhvk" | "default";
                }
              | {
                  type: "assetVerificationCode";
                  theme?: "bhvk" | "default";
                }
              | {
                  type: "auditLog";
                  subject?: (
                    | "Alarm"
                    | "AlarmCall"
                    | "AlarmCallEvent"
                    | "AlarmCallParticipant"
                    | "AlarmEvent"
                    | "AlarmHelper"
                    | "AlarmPushSubscription"
                    | "AlarmProfessionalResponder"
                    | "Asset"
                    | "AssetGroup"
                    | "AssetPropertyVerification"
                    | "AuditLog"
                    | "Beacon"
                    | "BillingAuditLog"
                    | "BillingContract"
                    | "BillingCustomer"
                    | "BillingInvoice"
                    | "ContactList"
                    | "Customer"
                    | "CustomerAlarmCenterRelation"
                    | "CustomerUserRelation"
                    | "Device"
                    | "DeviceLogUpload"
                    | "DomainLink"
                    | "Observation"
                    | "ObservationTrigger"
                    | "Overlay"
                    | "RegistrationTemplate"
                    | "ReportTrigger"
                    | "ReportTriggerRun"
                    | "Role"
                    | "StaticResponder"
                    | "Webhook"
                    | "User"
                    | "Zone"
                    | "Fingerprint"
                    | "Visitor"
                    | "VisitRecord"
                    | "Report"
                    | "DeviceLogUploadBatch"
                    | "all"
                  )[];
                  operation?: string[];
                  user?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "User";
                  }[];
                  reasonKey?: string[];
                  ids?: string[];
                  pagination: {
                    /** @format date-time */
                    after: string;
                    order: "asc" | "desc";
                    max: number;
                  };
                  exposeUsers?: boolean;
                  exposeHistory?: boolean;
                }
              | {
                  type: "badReviewOnSurvey";
                  omitPiiFields?: ("phone" | "email")[];
                }
              | {
                  type: "deviceLog";
                  device?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Device";
                  }[];
                  deviceLogUpload?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "DeviceLogUpload";
                  }[];
                  severity?: ("debug" | "info" | "warning" | "error")[];
                  message?: string[];
                  location?: string[];
                  pagination: {
                    /** @format date-time */
                    after: string;
                    order: "asc" | "desc";
                    max: number;
                  };
                }
              | {
                  type: "gatewayAlive";
                  lastSeenThreshold: {
                    type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                    value: number;
                  };
                }
              | {
                  type: "inactivityMonitor";
                  lastSeenThreshold: {
                    type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                    value: number;
                  };
                  assets?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Asset";
                  }[];
                  assetGroups?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[];
                  appMode?: ("off" | "on" | "risk")[];
                  timeout?: {
                    type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                    value: number;
                  };
                  theme?: "bhvk" | "default";
                  omitPiiFields?: "address"[];
                }
              | {
                  type: "inventoryItemsExpiry";
                }
              | {
                  type: "newAlarm";
                  filter?: {
                    severities?: ("red" | "orange" | "green")[];
                    alarmTypes?: (
                      | "panic"
                      | "assistance"
                      | "test"
                      | "outage"
                      | "fire"
                      | "medical"
                      | "mandown"
                      | "other"
                    )[];
                    assets?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "Asset";
                    }[];
                    assetGroups?: {
                      /** @format uuid */
                      _id: string;
                      _ref: "AssetGroup";
                    }[];
                  };
                  procedure?: string;
                  info?: string;
                  hideOpenInAppButton?: boolean;
                  exposeAlarmCreatorProperties?: ("smsNumber" | "phoneNumber" | "email")[];
                  theme?: "bhvk" | "default";
                }
              | {
                  type: "surveyInvitation";
                }
              | {
                  type: "surveyOverview";
                  timeframe: {
                    type: "month" | "week" | "day" | "hour" | "minute";
                    value: number;
                    floorTo?: "month" | "week" | "day" | "hour" | "minute";
                  };
                }
              | {
                  type: "unhealthyBeacons";
                  lastSeenThreshold: {
                    type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                    value: number;
                  };
                  theme?: "bhvk" | "default";
                }
              | {
                  type: "zoneOverview";
                  inactivityThreshold?: {
                    type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                    value: number;
                  };
                  timeSeries: {
                    granularity: {
                      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                      value: number;
                    };
                    timeframe: {
                      type: "month" | "week" | "day" | "hour" | "minute";
                      value: number;
                      floorTo?: "month" | "week" | "day" | "hour" | "minute";
                    };
                  };
                  minOccupancyMode?: "alert" | "overview";
                  minOccupancy?: {
                    /**
                     * @min 0
                     * @exclusiveMin false
                     * @max 1
                     * @exclusiveMax false
                     */
                    ratioThreshold: number;
                    /**
                     * @min 0
                     * @exclusiveMin false
                     */
                    assetCount: number;
                  };
                  attachment?: {
                    granularity: {
                      type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                      value: number;
                    };
                    /**
                     * @min 0
                     * @exclusiveMin false
                     * @max 1
                     * @exclusiveMax false
                     */
                    availabilityThresholdRatio?: number;
                  };
                  zones?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Zone";
                  }[];
                  assets?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Asset";
                  }[];
                  assetGroups?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[];
                  schedule?:
                    | {
                        entries: {
                          daysOfWeek: number[];
                          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                          timeStart: string;
                          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                          timeEnd: string;
                          /**
                           * @min 0
                           * @exclusiveMin false
                           */
                          minOccupancy: number;
                        }[];
                      }
                    | {
                        entries: {
                          daysOfWeek: number[];
                          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                          timeStart: string;
                          /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                          timeEnd: string;
                        }[];
                      };
                  theme?: "bhvk" | "default";
                  disableCompressTimeseries?: boolean;
                }
              | {
                  type: "visitorRegistrationQrCode";
                };
            channelOverrides?: {
              /** PII */
              unsubscribedEmails: string[];
            };
            channels: (
              | {
                  type: "email";
                  /** PII */
                  address?: string[];
                  contactLists?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "ContactList";
                  }[];
                  getters?: {
                    /** @maxLength 1024 */
                    path: string;
                  }[];
                  assets?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "Asset";
                  }[];
                  assetGroups?: {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[];
                  config?: {
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    subjectOverride?: string;
                    /**
                     * PII
                     * @maxLength 4096
                     */
                    headerOverride?: string;
                  };
                }
              | {
                  type: "sms";
                  /** PII */
                  numbers: string[];
                  contactLists: {
                    /** @format uuid */
                    _id: string;
                    _ref: "ContactList";
                  }[];
                }
              | {
                  type: "alarm";
                  config: {
                    severity: "red" | "orange" | "green";
                    type: "panic" | "assistance" | "test" | "outage" | "fire" | "medical" | "mandown" | "other";
                    /**
                     * PII
                     * @maxLength 4096
                     */
                    procedure: string | null;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    name: string;
                  };
                }
              | {
                  type: "observation";
                }
            )[];
            /** @default null */
            scheduleTrigger?: {
              interval: {
                type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                value: number;
              };
              cooldown?: {
                type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                value: number;
              };
              /** @format date-time */
              nextAt: string | null;
              /** @format date-time */
              lastAt: string | null;
              /** @format date-time */
              lastAttemptedAt: string | null;
            };
            /** @default null */
            eventTrigger?: {
              events: string[];
              executionDelay?: {
                type: "minute" | "hour" | "day" | "week" | "month" | "quarter" | "year";
                value: number;
              };
              schedule?: {
                entries: {
                  daysOfWeek: number[];
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeStart: string;
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeEnd: string;
                }[];
              };
            } | null;
            enabled: boolean;
            /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
            locale?: string;
            /** @maxLength 1024 */
            timezone?: string;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/report-triggers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a ReportTrigger by id
     *
     * @tags ReportTrigger
     * @name ReportTriggersControllerFindById
     * @request GET:/report-triggers/{id}
     * @secure
     */
    reportTriggersControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReportTriggerOutputDto, any>({
        path: `/report-triggers/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a ReportTrigger
     *
     * @tags ReportTrigger
     * @name ReportTriggersControllerUpdate
     * @request PATCH:/report-triggers/{id}
     * @secure
     */
    reportTriggersControllerUpdate: (
      id: string,
      data: ReportTriggerUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReportTriggerOutputDto, any>({
        path: `/report-triggers/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a ReportTrigger by id
     *
     * @tags ReportTrigger
     * @name ReportTriggersControllerRemove
     * @request DELETE:/report-triggers/{id}
     * @secure
     */
    reportTriggersControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/report-triggers/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportTrigger
     * @name ReportTriggersControllerUnsubscribe
     * @request GET:/report-triggers/{id}/unsubscribe
     * @secure
     */
    reportTriggersControllerUnsubscribe: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/report-triggers/${id}/unsubscribe`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportTrigger
     * @name ReportTriggersControllerAdhocPopulate
     * @request POST:/report-triggers/adhoc-populate
     * @secure
     */
    reportTriggersControllerAdhocPopulate: (
      data: ReportTriggerAdhocPopulateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/report-triggers/adhoc-populate`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportTrigger
     * @name ReportTriggersControllerToProcessSchedule
     * @request GET:/report-triggers/to-process
     * @secure
     */
    reportTriggersControllerToProcessSchedule: (
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/report-triggers/to-process`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  roles = {
    /**
     * @description Creates a Role
     *
     * @tags Role
     * @name RolesControllerCreate
     * @request POST:/roles
     * @secure
     */
    rolesControllerCreate: (
      data: RoleCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RoleOutputDto, any>({
        path: `/roles`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates Role
     *
     * @tags Role
     * @name RolesControllerPaginate
     * @request GET:/roles
     * @secure
     */
    rolesControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            /** @maxLength 1024 */
            name: string;
            permissions: {
              subject:
                | "Alarm"
                | "AlarmCall"
                | "AlarmCallEvent"
                | "AlarmCallParticipant"
                | "AlarmEvent"
                | "AlarmHelper"
                | "AlarmPushSubscription"
                | "AlarmProfessionalResponder"
                | "Asset"
                | "AssetGroup"
                | "AssetPropertyVerification"
                | "AuditLog"
                | "Beacon"
                | "BillingAuditLog"
                | "BillingContract"
                | "BillingCustomer"
                | "BillingInvoice"
                | "ContactList"
                | "Customer"
                | "CustomerAlarmCenterRelation"
                | "CustomerUserRelation"
                | "Device"
                | "DeviceLogUpload"
                | "DomainLink"
                | "Observation"
                | "ObservationTrigger"
                | "Overlay"
                | "RegistrationTemplate"
                | "ReportTrigger"
                | "ReportTriggerRun"
                | "Role"
                | "StaticResponder"
                | "Webhook"
                | "User"
                | "Zone"
                | "Fingerprint"
                | "Visitor"
                | "VisitRecord"
                | "Report"
                | "DeviceLogUploadBatch"
                | "all";
              actions: string[];
              limit?: {
                connectedCustomers?: boolean;
                connectedCustomersViaRelation?: boolean;
                alarmsEscalatedToMyAlarmCenter?: boolean;
                alarmAgeLimitOfCustomer?: boolean;
                ownUserId?: boolean;
                notOwnUserId?: boolean;
                ownAssetId?: boolean;
                notOwnAssetId?: boolean;
                mode?: "default" | "asUser";
                fields?: string[];
                allowedRoles?: string[];
              };
            }[];
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/roles`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a Role
     *
     * @tags Role
     * @name RolesControllerUpdate
     * @request PATCH:/roles/{id}
     * @secure
     */
    rolesControllerUpdate: (
      id: string,
      data: RoleUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RoleOutputDto, any>({
        path: `/roles/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a Role by id
     *
     * @tags Role
     * @name RolesControllerFindById
     * @request GET:/roles/{id}
     * @secure
     */
    rolesControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RoleOutputDto, any>({
        path: `/roles/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a Role by id
     *
     * @tags Role
     * @name RolesControllerRemove
     * @request DELETE:/roles/{id}
     * @secure
     */
    rolesControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/roles/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Role
     * @name RolesControllerGetPermissionLimits
     * @request GET:/roles/permission-limits
     * @secure
     */
    rolesControllerGetPermissionLimits: (
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/roles/permission-limits`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  securityInventoryCategories = {
    /**
     * @description Creates a SecurityInventoryCategory
     *
     * @tags SecurityInventoryCategory
     * @name SecurityInventoryCategoriesControllerCreate
     * @request POST:/security-inventory-categories
     * @secure
     */
    securityInventoryCategoriesControllerCreate: (
      data: SecurityInventoryCategoryCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SecurityInventoryCategoryOutputDto, any>({
        path: `/security-inventory-categories`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates SecurityInventoryCategory
     *
     * @tags SecurityInventoryCategory
     * @name SecurityInventoryCategoriesControllerPaginate
     * @request GET:/security-inventory-categories
     * @secure
     */
    securityInventoryCategoriesControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /** @maxLength 1024 */
            name: string;
            /** @maxLength 1024 */
            icon: string;
            expiryInterval: {
              type: "day" | "week" | "month" | "year";
              value: number;
            };
            reminderPeriods: {
              type: "day" | "week" | "month" | "year";
              value: number;
            }[];
            notifiedPeople: {
              peopleToNotify: {
                /** @format uuid */
                _id: string;
                _ref: "Asset";
              }[];
              /** PII */
              emails: string[];
            };
            /** @maxLength 1024 */
            description?: string | null;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/security-inventory-categories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a SecurityInventoryCategory by id
     *
     * @tags SecurityInventoryCategory
     * @name SecurityInventoryCategoriesControllerFindById
     * @request GET:/security-inventory-categories/{id}
     * @secure
     */
    securityInventoryCategoriesControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SecurityInventoryCategoryOutputDto, any>({
        path: `/security-inventory-categories/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a SecurityInventoryCategory
     *
     * @tags SecurityInventoryCategory
     * @name SecurityInventoryCategoriesControllerUpdate
     * @request PATCH:/security-inventory-categories/{id}
     * @secure
     */
    securityInventoryCategoriesControllerUpdate: (
      id: string,
      data: SecurityInventoryCategoryUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SecurityInventoryCategoryOutputDto, any>({
        path: `/security-inventory-categories/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a SecurityInventoryCategory by id
     *
     * @tags SecurityInventoryCategory
     * @name SecurityInventoryCategoriesControllerRemove
     * @request DELETE:/security-inventory-categories/{id}
     * @secure
     */
    securityInventoryCategoriesControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/security-inventory-categories/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Searches SecurityInventoryCategory
     *
     * @tags SecurityInventoryCategory
     * @name SecurityInventoryCategoriesControllerSearch
     * @request GET:/security-inventory-categories/search
     * @secure
     */
    securityInventoryCategoriesControllerSearch: (
      query: {
        /** The search query string */
        q: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /** @maxLength 1024 */
            name: string;
            /** @maxLength 1024 */
            icon: string;
            expiryInterval: {
              type: "day" | "week" | "month" | "year";
              value: number;
            };
            reminderPeriods: {
              type: "day" | "week" | "month" | "year";
              value: number;
            }[];
            notifiedPeople: {
              peopleToNotify: {
                /** @format uuid */
                _id: string;
                _ref: "Asset";
              }[];
              /** PII */
              emails: string[];
            };
            /** @maxLength 1024 */
            description?: string | null;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/security-inventory-categories/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  securityInventoryItems = {
    /**
     * @description Creates a SecurityInventoryItem
     *
     * @tags SecurityInventoryItem
     * @name SecurityInventoryItemsControllerCreate
     * @request POST:/security-inventory-items
     * @secure
     */
    securityInventoryItemsControllerCreate: (
      data: SecurityInventoryItemCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SecurityInventoryItemOutputDto, any>({
        path: `/security-inventory-items`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates SecurityInventoryItem
     *
     * @tags SecurityInventoryItem
     * @name SecurityInventoryItemsControllerPaginate
     * @request GET:/security-inventory-items
     * @secure
     */
    securityInventoryItemsControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            category: {
              /** @format uuid */
              _id: string;
              _ref: "SecurityInventoryCategory";
            };
            /** @maxLength 1024 */
            name: string;
            /**
             * @maxLength 1024
             * @default null
             */
            identifier?: string | null;
            /** PII */
            location: {
              type: "Point";
              /** PII */
              coordinates: number[];
              properties: {
                accuracy?: number;
                heading?: number;
                headingAccuracy?: number;
                speed?: number;
                speedAccuracy?: number;
                altitude?: number;
                altitudeAccuracy?: number;
                /** PII */
                address?: {
                  /** @maxLength 1024 */
                  countryCode?: string | null;
                  /** @maxLength 1024 */
                  state?: string | null;
                  /** @maxLength 1024 */
                  city?: string | null;
                  /** @maxLength 1024 */
                  streetName?: string | null;
                  /** @maxLength 1024 */
                  streetNumber?: string | null;
                  floor?: number | null;
                  /** @maxLength 1024 */
                  formattedAddress?: string;
                };
                /** @format date-time */
                dateTime?: string;
                /** @maxLength 1024 */
                provider?: string;
              };
            };
            /** @format date-time */
            lastInspectionDate: string;
            /** @format date-time */
            expiryDate: string;
            /**
             * @format date-time
             * @default null
             */
            plannedRenewalDate?: string | null;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/security-inventory-items`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a SecurityInventoryItem by id
     *
     * @tags SecurityInventoryItem
     * @name SecurityInventoryItemsControllerFindById
     * @request GET:/security-inventory-items/{id}
     * @secure
     */
    securityInventoryItemsControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SecurityInventoryItemOutputDto, any>({
        path: `/security-inventory-items/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a SecurityInventoryItem
     *
     * @tags SecurityInventoryItem
     * @name SecurityInventoryItemsControllerUpdate
     * @request PATCH:/security-inventory-items/{id}
     * @secure
     */
    securityInventoryItemsControllerUpdate: (
      id: string,
      data: SecurityInventoryItemUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SecurityInventoryItemOutputDto, any>({
        path: `/security-inventory-items/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a SecurityInventoryItem by id
     *
     * @tags SecurityInventoryItem
     * @name SecurityInventoryItemsControllerRemove
     * @request DELETE:/security-inventory-items/{id}
     * @secure
     */
    securityInventoryItemsControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/security-inventory-items/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SecurityInventoryItem
     * @name SecurityInventoryItemsControllerAddItems
     * @request POST:/security-inventory-items/add-items
     * @secure
     */
    securityInventoryItemsControllerAddItems: (
      data: SecurityInventoryItemAddItemsDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          count: number;
        },
        any
      >({
        path: `/security-inventory-items/add-items`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Searches SecurityInventoryItem
     *
     * @tags SecurityInventoryItem
     * @name SecurityInventoryItemsControllerSearch
     * @request GET:/security-inventory-items/search
     * @secure
     */
    securityInventoryItemsControllerSearch: (
      query: {
        /** The search query string */
        q: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            category: {
              /** @format uuid */
              _id: string;
              _ref: "SecurityInventoryCategory";
            };
            /** @maxLength 1024 */
            name: string;
            /**
             * @maxLength 1024
             * @default null
             */
            identifier?: string | null;
            /** PII */
            location: {
              type: "Point";
              /** PII */
              coordinates: number[];
              properties: {
                accuracy?: number;
                heading?: number;
                headingAccuracy?: number;
                speed?: number;
                speedAccuracy?: number;
                altitude?: number;
                altitudeAccuracy?: number;
                /** PII */
                address?: {
                  /** @maxLength 1024 */
                  countryCode?: string | null;
                  /** @maxLength 1024 */
                  state?: string | null;
                  /** @maxLength 1024 */
                  city?: string | null;
                  /** @maxLength 1024 */
                  streetName?: string | null;
                  /** @maxLength 1024 */
                  streetNumber?: string | null;
                  floor?: number | null;
                  /** @maxLength 1024 */
                  formattedAddress?: string;
                };
                /** @format date-time */
                dateTime?: string;
                /** @maxLength 1024 */
                provider?: string;
              };
            };
            /** @format date-time */
            lastInspectionDate: string;
            /** @format date-time */
            expiryDate: string;
            /**
             * @format date-time
             * @default null
             */
            plannedRenewalDate?: string | null;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/security-inventory-items/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SecurityInventoryItem
     * @name SecurityInventoryItemsControllerPublishSecurityInventoryItemsToReport
     * @request POST:/security-inventory-items/to-report
     * @secure
     */
    securityInventoryItemsControllerPublishSecurityInventoryItemsToReport: (
      data: PublishInventoryItemsToReportDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/security-inventory-items/to-report`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  specials = {
    /**
     * No description
     *
     * @tags App
     * @name AppControllerGetMapboxToken
     * @request POST:/specials/app/mapbox-token
     */
    appControllerGetMapboxToken: (params: RequestParams = {}) =>
      this.request<CreateMapboxTokenOutputDto, any>({
        path: `/specials/app/mapbox-token`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags App
     * @name AppControllerGetSupportChatIdentity
     * @request POST:/specials/app/support-chat-identity
     */
    appControllerGetSupportChatIdentity: (params: RequestParams = {}) =>
      this.request<CreateSupportChatIdentityOutputDto, any>({
        path: `/specials/app/support-chat-identity`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags App
     * @name AppControllerGetTwilioVoiceToken
     * @request POST:/specials/app/twilio-voice-token
     */
    appControllerGetTwilioVoiceToken: (data: CreateTwilioVoiceTokenDto, params: RequestParams = {}) =>
      this.request<CreateTwilioVoiceTokenOutputDto, any>({
        path: `/specials/app/twilio-voice-token`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BHV Knop
     * @name BhvKnopControllerAddDevices
     * @request POST:/specials/bhv-knop/add-devices
     * @secure
     */
    bhvKnopControllerAddDevices: (
      data: BHVKnopAddDevicesDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/specials/bhv-knop/add-devices`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BHV Knop
     * @name BhvKnopControllerAddAddtionalResources
     * @request POST:/specials/bhv-knop/addon
     * @secure
     */
    bhvKnopControllerAddAddtionalResources: (
      data: BHVKnopAddAddtionalPaidResourcesDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/specials/bhv-knop/addon`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BHV Knop
     * @name BhvKnopControllerAssignHardware
     * @request POST:/specials/bhv-knop/assign-hardware
     * @secure
     */
    bhvKnopControllerAssignHardware: (
      data: BHVKnopAssignHardwareDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BHVKnopAssignHardwareResponseDto, any>({
        path: `/specials/bhv-knop/assign-hardware`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BHV Knop
     * @name BhvKnopControllerAssetsWithDeviceList
     * @request GET:/specials/bhv-knop/device-list
     * @secure
     */
    bhvKnopControllerAssetsWithDeviceList: (
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BHVKnopAssetsWithDeviceListResponseDto, any>({
        path: `/specials/bhv-knop/device-list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BHV Knop
     * @name BhvKnopControllerGetNextSequenceNumber
     * @request POST:/specials/bhv-knop/next-sequence-number
     * @secure
     */
    bhvKnopControllerGetNextSequenceNumber: (
      data: BHVKnopGetNextSequenceNumberDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BHVKnopGetNextSequenceNumberResponseDto, any>({
        path: `/specials/bhv-knop/next-sequence-number`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BHV Knop
     * @name BhvKnopControllerCreatePaid
     * @request POST:/specials/bhv-knop/paid
     * @secure
     */
    bhvKnopControllerCreatePaid: (
      data: BHVKnopCreateOrConvertToPaidDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BHVKnopCreateOrConvertToPaidResponseDto, any>({
        path: `/specials/bhv-knop/paid`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BHV Knop
     * @name BhvKnopControllerRemoveDevices
     * @request POST:/specials/bhv-knop/remove-unpaid-devices
     * @secure
     */
    bhvKnopControllerRemoveDevices: (
      data: BHVKnopRemoveDevicesDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/specials/bhv-knop/remove-unpaid-devices`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BHV Knop
     * @name BhvKnopControllerGetSequenceNumbers
     * @request POST:/specials/bhv-knop/sequence-numbers
     * @secure
     */
    bhvKnopControllerGetSequenceNumbers: (
      data: BHVKnopGetSequenceNumbersDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BHVKnopGetSequenceNumbersResponseDto, any>({
        path: `/specials/bhv-knop/sequence-numbers`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BHV Knop
     * @name BhvKnopControllerCreateTrial
     * @request POST:/specials/bhv-knop/trial
     * @secure
     */
    bhvKnopControllerCreateTrial: (
      data: BHVKnopCreateTrialDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BHVKnopCreateTrialResponseDto, any>({
        path: `/specials/bhv-knop/trial`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BHV Knop
     * @name BhvKnopControllerUpdateMonitoredZones
     * @request POST:/specials/bhv-knop/update-monitored-zones
     * @secure
     */
    bhvKnopControllerUpdateMonitoredZones: (
      data: BHVKnopUpdateMonitoredZonesDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/specials/bhv-knop/update-monitored-zones`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a KioskUser
     *
     * @tags KioskUser
     * @name KioskUserControllerCreate
     * @request POST:/specials/kiosk-user
     * @secure
     */
    kioskUserControllerCreate: (
      data: KioskUserCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<KioskUserOutputDto, any>({
        path: `/specials/kiosk-user`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates KioskUser
     *
     * @tags KioskUser
     * @name KioskUserControllerPaginate
     * @request GET:/specials/kiosk-user
     * @secure
     */
    kioskUserControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            _id: string;
            user: {
              /** @format uuid */
              _id: string;
              /** @format date-time */
              createdAt: string;
              /** @format date-time */
              updatedAt: string;
              telluId?: number | null;
              migrationFinalised?: boolean | null;
              /** @format date-time */
              migrationFinalisedDate?: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              username: string;
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
              properties: {
                /**
                 * PII
                 * @maxLength 1024
                 */
                phoneNumber?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                smsNumber?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                email?: string | null;
                /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                locale?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                image?: string | null;
                /** PII */
                rSim?: {
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  euicc: string;
                  primary: {
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    msisdn: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    iccid: string;
                  };
                  secondary: {
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    msisdn: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    iccid: string;
                  };
                  enabled: boolean;
                } | null;
              };
              /** @default [] */
              globalRoles?: string[];
              /** @default [] */
              specialPermissions?: string[];
              isServiceAccount?: boolean;
              /**
               * PII
               * @format date-time
               */
              lastActiveAt?: string;
              type?: "default" | "serviceAccount" | "kiosk";
              userPolicies?: {
                disablePasswordlessLogin?: boolean;
              };
            };
            device: {
              /** @format uuid */
              _id: string;
              /** @format date-time */
              createdAt: string;
              /** @format date-time */
              updatedAt: string;
              telluId?: number | null;
              migrationFinalised?: boolean | null;
              /** @format date-time */
              migrationFinalisedDate?: string | null;
              customer: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              };
              /** @default {"type":"parents","extra":[]} */
              share?: {
                type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                extra?: {
                  /** @format uuid */
                  _id: string;
                  _ref: "Customer";
                }[];
              };
              asset: {
                /** @format uuid */
                _id: string;
                _ref: "Asset";
              } | null;
              /**
               * PII
               * @maxLength 1024
               */
              name?: string;
              /**
               * PII
               * @maxLength 1024
               */
              deviceId: string;
              type: "appDevice" | "lora" | "loraGateway" | "flic" | "generic" | "kiosk";
              loraConfig?:
                | {
                    type: "adeunis.arf8123aa";
                    config: {
                      /** @maxLength 1024 */
                      fieldTest: string;
                    };
                  }
                | {
                    type: "iotracker.v2";
                    config: {
                      /** @maxLength 1024 */
                      beaconScan: string;
                      /** @maxLength 1024 */
                      gps: string;
                      /** @maxLength 1024 */
                      preMandown: string;
                      /** @maxLength 1024 */
                      mandown: string;
                      /** @maxLength 1024 */
                      movement: string;
                      /** @maxLength 1024 */
                      alarmSeverity: string;
                      /** @maxLength 1024 */
                      alive: string;
                    };
                  }
                | {
                    type: "milesight.ws101";
                    config: {
                      /** @maxLength 1024 */
                      beaconScan: string;
                      /** @maxLength 1024 */
                      alarmSeverity: string;
                      /** @maxLength 1024 */
                      alive: string;
                    };
                  }
                | {
                    type: "sensative.1301001";
                    config: {
                      /** @maxLength 1024 */
                      alarmSeverity: string;
                      /** @maxLength 1024 */
                      alive: string;
                      /** @maxLength 1024 */
                      floodDetected: string;
                      /** @maxLength 1024 */
                      noFloodDetected: string;
                    };
                  }
                | null;
              kioskConfig?: {
                /** @default false */
                managed?: boolean;
                zone?: {
                  /** @format uuid */
                  _id: string;
                  _ref: "Zone";
                } | null;
                exposeAssets?:
                  | {
                      /** @format uuid */
                      _id: string;
                      _ref: "AssetGroup";
                    }[]
                  | null;
                exposeLabels?:
                  | {
                      /** @format uuid */
                      _id: string;
                      _ref: "AssetGroup";
                      countLabel?: boolean;
                    }[]
                  | null;
                schedule?: {
                  entries: {
                    daysOfWeek: number[];
                    /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                    timeStart: string;
                    /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                    timeEnd: string;
                  }[];
                } | null;
                homepage?: {
                  incidentCounter?: {
                    /** @default true */
                    enabled?: boolean;
                    /** @format date-time */
                    countFromDate?: string | null;
                    /**
                     * @min 0
                     * @exclusiveMin false
                     * @default 0
                     */
                    threshold?: number;
                  };
                  /** @default true */
                  anonymous?: boolean;
                  /** @format uri */
                  logo?: string | null;
                };
                alarm?: {
                  /** @default true */
                  enabled?: boolean;
                  focus?: {
                    red?: {
                      flash?: boolean | null;
                      sound?: {
                        enabled: boolean;
                        /**
                         * @min 0
                         * @exclusiveMin false
                         * @max 100
                         * @exclusiveMax false
                         */
                        volume?: number | null;
                        sound?:
                          | "alarm"
                          | "alarmClock"
                          | "alarmRetro"
                          | "announcement"
                          | "attention"
                          | "bassPulse"
                          | "beepBeep"
                          | "beepBurglar"
                          | "beepContinuous"
                          | "beepHighSoft"
                          | "beepIncremental"
                          | "bell"
                          | "car"
                          | "chickens"
                          | "chime"
                          | "chirpSoft"
                          | "clockMelody"
                          | "countdownSonar"
                          | "doorbell"
                          | "escalate"
                          | "fancy"
                          | "fastAndNervous"
                          | "harp"
                          | "incomingPhone"
                          | "introduction"
                          | "intrusive"
                          | "invasion"
                          | "jungle"
                          | "lofiChords"
                          | "loopLow"
                          | "melodySoft"
                          | "notifySubtle"
                          | "onOff"
                          | "orchestral"
                          | "pling"
                          | "plingHigh"
                          | "plingLow"
                          | "pluckSong"
                          | "quick"
                          | "scanning"
                          | "shake"
                          | "silence"
                          | "sirenHigh"
                          | "sirenLow"
                          | "soft"
                          | "spaceship"
                          | "startup"
                          | "threeTones"
                          | "tornado"
                          | "wailing"
                          | "wakeup"
                          | null;
                        /**
                         * @min 0
                         * @exclusiveMin false
                         */
                        stopAfterSeconds?: number | null;
                        stopAfterTouch?: boolean | null;
                      };
                    };
                    orange?: {
                      flash?: boolean | null;
                      sound?: {
                        enabled: boolean;
                        /**
                         * @min 0
                         * @exclusiveMin false
                         * @max 100
                         * @exclusiveMax false
                         */
                        volume?: number | null;
                        sound?:
                          | "alarm"
                          | "alarmClock"
                          | "alarmRetro"
                          | "announcement"
                          | "attention"
                          | "bassPulse"
                          | "beepBeep"
                          | "beepBurglar"
                          | "beepContinuous"
                          | "beepHighSoft"
                          | "beepIncremental"
                          | "bell"
                          | "car"
                          | "chickens"
                          | "chime"
                          | "chirpSoft"
                          | "clockMelody"
                          | "countdownSonar"
                          | "doorbell"
                          | "escalate"
                          | "fancy"
                          | "fastAndNervous"
                          | "harp"
                          | "incomingPhone"
                          | "introduction"
                          | "intrusive"
                          | "invasion"
                          | "jungle"
                          | "lofiChords"
                          | "loopLow"
                          | "melodySoft"
                          | "notifySubtle"
                          | "onOff"
                          | "orchestral"
                          | "pling"
                          | "plingHigh"
                          | "plingLow"
                          | "pluckSong"
                          | "quick"
                          | "scanning"
                          | "shake"
                          | "silence"
                          | "sirenHigh"
                          | "sirenLow"
                          | "soft"
                          | "spaceship"
                          | "startup"
                          | "threeTones"
                          | "tornado"
                          | "wailing"
                          | "wakeup"
                          | null;
                        /**
                         * @min 0
                         * @exclusiveMin false
                         */
                        stopAfterSeconds?: number | null;
                        stopAfterTouch?: boolean | null;
                      };
                    };
                    green?: {
                      flash?: boolean | null;
                      sound?: {
                        enabled: boolean;
                        /**
                         * @min 0
                         * @exclusiveMin false
                         * @max 100
                         * @exclusiveMax false
                         */
                        volume?: number | null;
                        sound?:
                          | "alarm"
                          | "alarmClock"
                          | "alarmRetro"
                          | "announcement"
                          | "attention"
                          | "bassPulse"
                          | "beepBeep"
                          | "beepBurglar"
                          | "beepContinuous"
                          | "beepHighSoft"
                          | "beepIncremental"
                          | "bell"
                          | "car"
                          | "chickens"
                          | "chime"
                          | "chirpSoft"
                          | "clockMelody"
                          | "countdownSonar"
                          | "doorbell"
                          | "escalate"
                          | "fancy"
                          | "fastAndNervous"
                          | "harp"
                          | "incomingPhone"
                          | "introduction"
                          | "intrusive"
                          | "invasion"
                          | "jungle"
                          | "lofiChords"
                          | "loopLow"
                          | "melodySoft"
                          | "notifySubtle"
                          | "onOff"
                          | "orchestral"
                          | "pling"
                          | "plingHigh"
                          | "plingLow"
                          | "pluckSong"
                          | "quick"
                          | "scanning"
                          | "shake"
                          | "silence"
                          | "sirenHigh"
                          | "sirenLow"
                          | "soft"
                          | "spaceship"
                          | "startup"
                          | "threeTones"
                          | "tornado"
                          | "wailing"
                          | "wakeup"
                          | null;
                        /**
                         * @min 0
                         * @exclusiveMin false
                         */
                        stopAfterSeconds?: number | null;
                        stopAfterTouch?: boolean | null;
                      };
                    };
                  };
                  /** @default true */
                  showPositionLabels?: boolean;
                  /** @default true */
                  anonymous?: boolean;
                  acknowledge?: {
                    enabled?: boolean;
                    /** @pattern ^[0-9]{4,6}$ */
                    pin?: string | null;
                    messagePresets?: string[] | null;
                  };
                  mode?: "zoneBased" | "customerBased" | null;
                };
                manageAvailability?: {
                  /** @default true */
                  enabled?: boolean;
                  /** @pattern ^[0-9]{4,6}$ */
                  pin?: string | null;
                  /** @default true */
                  showAppBanner?: boolean;
                  /** @default false */
                  forceShowSearch?: boolean;
                  /** @default false */
                  forceShowLabelFilter?: boolean;
                };
                hardware?: {
                  /**
                   * @min 0
                   * @exclusiveMin false
                   * @max 100
                   * @exclusiveMax false
                   */
                  screenBrightness?: number | null;
                };
              };
              battery?: number;
              rssi?: number;
              snr?: number;
              app?: {
                permissions?: {
                  calendar?: {
                    status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                    /** @default false */
                    alreadyAsked?: boolean;
                  };
                  camera?: {
                    status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                    /** @default false */
                    alreadyAsked?: boolean;
                  };
                  contacts?: {
                    status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                    /** @default false */
                    alreadyAsked?: boolean;
                  };
                  microphone?: {
                    status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                    /** @default false */
                    alreadyAsked?: boolean;
                  };
                  notifications?: {
                    status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                    /** @default false */
                    alreadyAsked?: boolean;
                  };
                  criticalNotifications?: {
                    status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                    /** @default false */
                    alreadyAsked?: boolean;
                  };
                  motion?: {
                    status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                    /** @default false */
                    alreadyAsked?: boolean;
                  };
                  bluetooth?: {
                    status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                    /** @default false */
                    alreadyAsked?: boolean;
                  };
                  locationAlways?: {
                    status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                    /** @default false */
                    alreadyAsked?: boolean;
                  };
                  locationWhenInUse?: {
                    status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                    /** @default false */
                    alreadyAsked?: boolean;
                  };
                  physical?: {
                    status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                    /** @default false */
                    alreadyAsked?: boolean;
                  };
                  batteryOptimization?: {
                    status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                    /** @default false */
                    alreadyAsked?: boolean;
                  };
                  overlay?: {
                    status: "granted" | "limited" | "denied" | "blocked" | "unavailable";
                    /** @default false */
                    alreadyAsked?: boolean;
                  };
                };
                deviceOs?: {
                  osType: "ios" | "android";
                  /** @maxLength 1024 */
                  osVersion: string;
                  /** @maxLength 1024 */
                  osId?: string;
                  /** @maxLength 1024 */
                  buildNumber?: string;
                  /** @maxLength 1024 */
                  bundleId?: string;
                };
                profile?: {
                  /** @maxLength 1024 */
                  name?: string;
                  /** @maxLength 1024 */
                  brand?: string;
                  /** @maxLength 1024 */
                  model?: string;
                  /** @maxLength 1024 */
                  carrier?: string;
                };
              } | null;
              clientConfig?: {
                app?: {
                  definitions: (
                    | {
                        type: "key";
                        key: string;
                        value: any;
                        editableBy?: ("AssetGroup" | "Device")[];
                      }
                    | {
                        type: "group";
                        group: {
                          /** @format uuid */
                          _id: string;
                          _ref: "ClientConfigGroup";
                        };
                      }
                  )[];
                  filter?: {
                    type: "osFilter";
                    osType: "ios" | "android";
                    /** @maxLength 1024 */
                    osVersionRange?: string;
                  };
                }[];
                kiosk?: {
                  definitions: (
                    | {
                        type: "key";
                        key: string;
                        value: any;
                        editableBy?: ("AssetGroup" | "Device")[];
                      }
                    | {
                        type: "group";
                        group: {
                          /** @format uuid */
                          _id: string;
                          _ref: "ClientConfigGroup";
                        };
                      }
                  )[];
                  filter?: {
                    type: "osFilter";
                    osType: "ios" | "android";
                    /** @maxLength 1024 */
                    osVersionRange?: string;
                  };
                }[];
              };
            };
            asset: {
              /** @format uuid */
              _id: string;
              /** @format date-time */
              createdAt: string;
              /** @format date-time */
              updatedAt: string;
              telluId?: number | null;
              migrationFinalised?: boolean | null;
              /** @format date-time */
              migrationFinalisedDate?: string | null;
              customer: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              };
              /** @default {"type":"parents","extra":[]} */
              share?: {
                type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
                extra?: {
                  /** @format uuid */
                  _id: string;
                  _ref: "Customer";
                }[];
              };
              user: {
                /** @format uuid */
                _id: string;
                _ref: "User";
              } | null;
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
              /**
               * PII
               * @maxLength 1024
               */
              externalId?: string | null;
              propertiesOwnership?: "override" | "inherit";
              /** @default {} */
              properties?: {
                /**
                 * PII
                 * @maxLength 1024
                 */
                phoneNumber?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                smsNumber?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                email?: string | null;
                /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
                locale?: string | null;
                /**
                 * PII
                 * @maxLength 1024
                 */
                image?: string | null;
                /** PII */
                rSim?: {
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  euicc: string;
                  primary: {
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    msisdn: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    iccid: string;
                  };
                  secondary: {
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    msisdn: string;
                    /**
                     * PII
                     * @maxLength 1024
                     */
                    iccid: string;
                  };
                  enabled: boolean;
                } | null;
              };
              /**
               * PII
               * @default null
               */
              position?: {
                type: "Point";
                /** PII */
                coordinates: number[];
                properties: {
                  accuracy?: number;
                  heading?: number;
                  headingAccuracy?: number;
                  speed?: number;
                  speedAccuracy?: number;
                  altitude?: number;
                  altitudeAccuracy?: number;
                  /** PII */
                  address?: {
                    /** @maxLength 1024 */
                    countryCode?: string | null;
                    /** @maxLength 1024 */
                    state?: string | null;
                    /** @maxLength 1024 */
                    city?: string | null;
                    /** @maxLength 1024 */
                    streetName?: string | null;
                    /** @maxLength 1024 */
                    streetNumber?: string | null;
                    floor?: number | null;
                    /** @maxLength 1024 */
                    formattedAddress?: string;
                  };
                  /** @format date-time */
                  dateTime?: string;
                  /** @maxLength 1024 */
                  provider?: string;
                };
              };
              available: boolean;
              /** @default true */
              allowContactOnOwnAlarms?: boolean;
              app?: {
                mode: "off" | "on" | "risk";
              } | null;
              insideZones: {
                /** @format uuid */
                _id: string;
                _ref: "Zone";
              }[];
              assetGroups: {
                /** @format uuid */
                _id: string;
                _ref: "AssetGroup";
              }[];
              /** @default [] */
              staticResponders?: {
                staticResponder: {
                  /** @format uuid */
                  _id: string;
                  _ref: "StaticResponder";
                };
                priority: number;
              }[];
              /** @format date-time */
              lastObservationAt?: string;
              /** @default false */
              invisibleResponder?: boolean;
              /**
               * PII
               * @maxLength 4096
               */
              description?: string;
              /** @default [] */
              certifications?: {
                /** @format uuid */
                _id: string;
                certificationCategory: {
                  /** @format uuid */
                  _id: string;
                  _ref: "CertificationCategory";
                };
                /** @format date-time */
                firstIssuedOn: string;
                /** @format date-time */
                lastReceivedOn: string;
                /** @format date-time */
                expiryDate: string;
                /**
                 * @format date-time
                 * @default null
                 */
                plannedRenewalDate?: string | null;
                /** @maxLength 1024 */
                documentaryProof?: string | null;
              }[];
              type?: "default" | "kiosk";
            };
            kioskConfig: {
              /** @default false */
              managed?: boolean;
              zone: {
                /** @format uuid */
                _id: string;
                _ref: "Zone";
              } | null;
              exposeAssets:
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                  }[]
                | null;
              exposeLabels:
                | {
                    /** @format uuid */
                    _id: string;
                    _ref: "AssetGroup";
                    countLabel?: boolean;
                  }[]
                | null;
              schedule: {
                entries: {
                  daysOfWeek: number[];
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeStart: string;
                  /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                  timeEnd: string;
                }[];
              } | null;
              homepage: {
                incidentCounter: {
                  /** @default true */
                  enabled?: boolean;
                  /** @format date-time */
                  countFromDate: string | null;
                  /**
                   * @min 0
                   * @exclusiveMin false
                   * @default 0
                   */
                  threshold?: number;
                };
                /** @default true */
                anonymous?: boolean;
                /** @format uri */
                logo: string | null;
              };
              alarm: {
                /** @default true */
                enabled?: boolean;
                focus?: {
                  red?: {
                    flash?: boolean | null;
                    sound?: {
                      enabled: boolean;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 100
                       * @exclusiveMax false
                       */
                      volume?: number | null;
                      sound?:
                        | "alarm"
                        | "alarmClock"
                        | "alarmRetro"
                        | "announcement"
                        | "attention"
                        | "bassPulse"
                        | "beepBeep"
                        | "beepBurglar"
                        | "beepContinuous"
                        | "beepHighSoft"
                        | "beepIncremental"
                        | "bell"
                        | "car"
                        | "chickens"
                        | "chime"
                        | "chirpSoft"
                        | "clockMelody"
                        | "countdownSonar"
                        | "doorbell"
                        | "escalate"
                        | "fancy"
                        | "fastAndNervous"
                        | "harp"
                        | "incomingPhone"
                        | "introduction"
                        | "intrusive"
                        | "invasion"
                        | "jungle"
                        | "lofiChords"
                        | "loopLow"
                        | "melodySoft"
                        | "notifySubtle"
                        | "onOff"
                        | "orchestral"
                        | "pling"
                        | "plingHigh"
                        | "plingLow"
                        | "pluckSong"
                        | "quick"
                        | "scanning"
                        | "shake"
                        | "silence"
                        | "sirenHigh"
                        | "sirenLow"
                        | "soft"
                        | "spaceship"
                        | "startup"
                        | "threeTones"
                        | "tornado"
                        | "wailing"
                        | "wakeup"
                        | null;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      stopAfterSeconds?: number | null;
                      stopAfterTouch?: boolean | null;
                    };
                  };
                  orange?: {
                    flash?: boolean | null;
                    sound?: {
                      enabled: boolean;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 100
                       * @exclusiveMax false
                       */
                      volume?: number | null;
                      sound?:
                        | "alarm"
                        | "alarmClock"
                        | "alarmRetro"
                        | "announcement"
                        | "attention"
                        | "bassPulse"
                        | "beepBeep"
                        | "beepBurglar"
                        | "beepContinuous"
                        | "beepHighSoft"
                        | "beepIncremental"
                        | "bell"
                        | "car"
                        | "chickens"
                        | "chime"
                        | "chirpSoft"
                        | "clockMelody"
                        | "countdownSonar"
                        | "doorbell"
                        | "escalate"
                        | "fancy"
                        | "fastAndNervous"
                        | "harp"
                        | "incomingPhone"
                        | "introduction"
                        | "intrusive"
                        | "invasion"
                        | "jungle"
                        | "lofiChords"
                        | "loopLow"
                        | "melodySoft"
                        | "notifySubtle"
                        | "onOff"
                        | "orchestral"
                        | "pling"
                        | "plingHigh"
                        | "plingLow"
                        | "pluckSong"
                        | "quick"
                        | "scanning"
                        | "shake"
                        | "silence"
                        | "sirenHigh"
                        | "sirenLow"
                        | "soft"
                        | "spaceship"
                        | "startup"
                        | "threeTones"
                        | "tornado"
                        | "wailing"
                        | "wakeup"
                        | null;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      stopAfterSeconds?: number | null;
                      stopAfterTouch?: boolean | null;
                    };
                  };
                  green?: {
                    flash?: boolean | null;
                    sound?: {
                      enabled: boolean;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       * @max 100
                       * @exclusiveMax false
                       */
                      volume?: number | null;
                      sound?:
                        | "alarm"
                        | "alarmClock"
                        | "alarmRetro"
                        | "announcement"
                        | "attention"
                        | "bassPulse"
                        | "beepBeep"
                        | "beepBurglar"
                        | "beepContinuous"
                        | "beepHighSoft"
                        | "beepIncremental"
                        | "bell"
                        | "car"
                        | "chickens"
                        | "chime"
                        | "chirpSoft"
                        | "clockMelody"
                        | "countdownSonar"
                        | "doorbell"
                        | "escalate"
                        | "fancy"
                        | "fastAndNervous"
                        | "harp"
                        | "incomingPhone"
                        | "introduction"
                        | "intrusive"
                        | "invasion"
                        | "jungle"
                        | "lofiChords"
                        | "loopLow"
                        | "melodySoft"
                        | "notifySubtle"
                        | "onOff"
                        | "orchestral"
                        | "pling"
                        | "plingHigh"
                        | "plingLow"
                        | "pluckSong"
                        | "quick"
                        | "scanning"
                        | "shake"
                        | "silence"
                        | "sirenHigh"
                        | "sirenLow"
                        | "soft"
                        | "spaceship"
                        | "startup"
                        | "threeTones"
                        | "tornado"
                        | "wailing"
                        | "wakeup"
                        | null;
                      /**
                       * @min 0
                       * @exclusiveMin false
                       */
                      stopAfterSeconds?: number | null;
                      stopAfterTouch?: boolean | null;
                    };
                  };
                };
                /** @default true */
                showPositionLabels?: boolean;
                /** @default true */
                anonymous?: boolean;
                acknowledge?: {
                  enabled: boolean;
                  /** @pattern ^[0-9]{4,6}$ */
                  pin: string | null;
                  messagePresets: string[] | null;
                };
                mode?: "zoneBased" | "customerBased" | null;
              };
              manageAvailability: {
                /** @default true */
                enabled?: boolean;
                /** @pattern ^[0-9]{4,6}$ */
                pin: string | null;
                /** @default true */
                showAppBanner?: boolean;
                /** @default false */
                forceShowSearch?: boolean;
                /** @default false */
                forceShowLabelFilter?: boolean;
              };
              hardware: {
                /**
                 * @min 0
                 * @exclusiveMin false
                 * @max 100
                 * @exclusiveMax false
                 */
                screenBrightness: number | null;
              };
            };
            password?: string;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/specials/kiosk-user`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a KioskUser by id
     *
     * @tags KioskUser
     * @name KioskUserControllerFindById
     * @request GET:/specials/kiosk-user/{id}
     * @secure
     */
    kioskUserControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<KioskUserOutputDto, any>({
        path: `/specials/kiosk-user/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a KioskUser
     *
     * @tags KioskUser
     * @name KioskUserControllerUpdate
     * @request PATCH:/specials/kiosk-user/{id}
     * @secure
     */
    kioskUserControllerUpdate: (
      id: string,
      data: KioskUserUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<KioskUserOutputDto, any>({
        path: `/specials/kiosk-user/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a KioskUser by id
     *
     * @tags KioskUser
     * @name KioskUserControllerRemove
     * @request DELETE:/specials/kiosk-user/{id}
     * @secure
     */
    kioskUserControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/specials/kiosk-user/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags KioskUser
     * @name KioskUserControllerMoveKioskUser
     * @request POST:/specials/kiosk-user/{id}/move
     * @secure
     */
    kioskUserControllerMoveKioskUser: (
      id: string,
      data: KioskMoveCustomerDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/specials/kiosk-user/${id}/move`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags KioskUser
     * @name KioskUserControllerObserveAsset
     * @request POST:/specials/kiosk-user/{id}/observe-asset
     * @secure
     */
    kioskUserControllerObserveAsset: (
      id: string,
      data: KioskUserObserveAsset,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/specials/kiosk-user/${id}/observe-asset`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags KioskUser
     * @name KioskUserControllerRegenerateCredentials
     * @request POST:/specials/kiosk-user/{id}/regenerate-credentials
     * @secure
     */
    kioskUserControllerRegenerateCredentials: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/specials/kiosk-user/${id}/regenerate-credentials`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Gets the createdAt value of latest non-green alarm
     *
     * @tags KioskUser
     * @name KioskUserControllerGetIncidentScoreboardValue
     * @request GET:/specials/kiosk-user/{id}/safetyScoreboard
     * @secure
     */
    kioskUserControllerGetIncidentScoreboardValue: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<KioskUserSafetyScoreboardOutputDto, any>({
        path: `/specials/kiosk-user/${id}/safetyScoreboard`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KioskUser
     * @name KioskUserControllerAddPhoto
     * @request POST:/specials/kiosk-user/photo
     * @secure
     */
    kioskUserControllerAddPhoto: (
      query: {
        /** Device id parameter */
        id: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      data: {
        /** @format binary */
        photo_url: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<ImageUploadDto, any>({
        path: `/specials/kiosk-user/photo`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Usersnap
     * @name UsersnapControllerSubmitFeedback
     * @request POST:/specials/usersnap/feedback
     */
    usersnapControllerSubmitFeedback: (data: SubmitFeedbackDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/specials/usersnap/feedback`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  staticResponders = {
    /**
     * @description Creates a StaticResponder
     *
     * @tags StaticResponder
     * @name StaticRespondersControllerCreate
     * @request POST:/static-responders
     * @secure
     */
    staticRespondersControllerCreate: (
      data: StaticResponderCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StaticResponderOutputDto, any>({
        path: `/static-responders`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates StaticResponder
     *
     * @tags StaticResponder
     * @name StaticRespondersControllerPaginate
     * @request GET:/static-responders
     * @secure
     */
    staticRespondersControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /**
             * PII
             * @maxLength 1024
             */
            externalId: string | null;
            contact: {
              /**
               * PII
               * @pattern ^([\w+\-.]+@([\w-]+\.)+[\w-]{2,}[, ]*?)+?$
               */
              email: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              phone: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              sms: string | null;
              /** @maxLength 1024 */
              camera: string | null;
            };
            schedule: {
              entries: {
                daysOfWeek: number[];
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeStart: string;
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeEnd: string;
              }[];
            } | null;
            /** @maxLength 1024 */
            migrationKey?: string;
            integrations?: {
              sequrix: {
                enabled: boolean;
                /**
                 * PII
                 * @maxLength 1024
                 */
                objectCode: string;
              };
            };
            /** PII */
            statistics?: {
              /**
               * @maxItems 10
               * @minItems 0
               */
              acceptSpeeds: {
                /** @format date-time */
                timestamp: string;
                /**
                 * @min 0
                 * @exclusiveMin false
                 */
                speedMs: number;
              }[];
              /**
               * @maxItems 10
               * @minItems 0
               */
              onLocationSpeeds: {
                /** @format date-time */
                timestamp: string;
                /**
                 * @min 0
                 * @exclusiveMin false
                 */
                speedMs: number;
              }[];
              /**
               * @maxItems 10
               * @minItems 0
               */
              finishSpeeds: {
                /** @format date-time */
                timestamp: string;
                /**
                 * @min 0
                 * @exclusiveMin false
                 */
                speedMs: number;
              }[];
              /**
               * @min 0
               * @exclusiveMin false
               */
              amountRejected: number;
              /**
               * @min 0
               * @exclusiveMin false
               */
              amountAccepted: number;
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/static-responders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a StaticResponder by id
     *
     * @tags StaticResponder
     * @name StaticRespondersControllerFindById
     * @request GET:/static-responders/{id}
     * @secure
     */
    staticRespondersControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StaticResponderOutputDto, any>({
        path: `/static-responders/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a StaticResponder
     *
     * @tags StaticResponder
     * @name StaticRespondersControllerUpdate
     * @request PATCH:/static-responders/{id}
     * @secure
     */
    staticRespondersControllerUpdate: (
      id: string,
      data: StaticResponderUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StaticResponderOutputDto, any>({
        path: `/static-responders/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a StaticResponder by id
     *
     * @tags StaticResponder
     * @name StaticRespondersControllerRemove
     * @request DELETE:/static-responders/{id}
     * @secure
     */
    staticRespondersControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/static-responders/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Searches StaticResponder
     *
     * @tags StaticResponder
     * @name StaticRespondersControllerSearch
     * @request GET:/static-responders/search
     * @secure
     */
    staticRespondersControllerSearch: (
      query: {
        /** The search query string */
        q: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /**
             * PII
             * @maxLength 1024
             */
            externalId: string | null;
            contact: {
              /**
               * PII
               * @pattern ^([\w+\-.]+@([\w-]+\.)+[\w-]{2,}[, ]*?)+?$
               */
              email: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              phone: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              sms: string | null;
              /** @maxLength 1024 */
              camera: string | null;
            };
            schedule: {
              entries: {
                daysOfWeek: number[];
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeStart: string;
                /** @pattern ^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$ */
                timeEnd: string;
              }[];
            } | null;
            /** @maxLength 1024 */
            migrationKey?: string;
            integrations?: {
              sequrix: {
                enabled: boolean;
                /**
                 * PII
                 * @maxLength 1024
                 */
                objectCode: string;
              };
            };
            /** PII */
            statistics?: {
              /**
               * @maxItems 10
               * @minItems 0
               */
              acceptSpeeds: {
                /** @format date-time */
                timestamp: string;
                /**
                 * @min 0
                 * @exclusiveMin false
                 */
                speedMs: number;
              }[];
              /**
               * @maxItems 10
               * @minItems 0
               */
              onLocationSpeeds: {
                /** @format date-time */
                timestamp: string;
                /**
                 * @min 0
                 * @exclusiveMin false
                 */
                speedMs: number;
              }[];
              /**
               * @maxItems 10
               * @minItems 0
               */
              finishSpeeds: {
                /** @format date-time */
                timestamp: string;
                /**
                 * @min 0
                 * @exclusiveMin false
                 */
                speedMs: number;
              }[];
              /**
               * @min 0
               * @exclusiveMin false
               */
              amountRejected: number;
              /**
               * @min 0
               * @exclusiveMin false
               */
              amountAccepted: number;
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/static-responders/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  surveyQuestions = {
    /**
     * @description Paginates SurveyQuestion
     *
     * @tags SurveyQuestion
     * @name SurveyQuestionsControllerPaginate
     * @request GET:/survey-questions
     * @secure
     */
    surveyQuestionsControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            /** @maxLength 1024 */
            question: string;
            type: "multipleChoice" | "followUp" | "openEnded" | "likertScale";
            options?: {
              value: number;
              /** @maxLength 1024 */
              label: string;
              variant: "primary" | "danger" | "success";
            }[];
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/survey-questions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a SurveyQuestion
     *
     * @tags SurveyQuestion
     * @name SurveyQuestionsControllerCreate
     * @request POST:/survey-questions
     * @secure
     */
    surveyQuestionsControllerCreate: (
      data: SurveyQuestionCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SurveyQuestionOutputDto, any>({
        path: `/survey-questions`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a SurveyQuestion by id
     *
     * @tags SurveyQuestion
     * @name SurveyQuestionsControllerFindById
     * @request GET:/survey-questions/{id}
     * @secure
     */
    surveyQuestionsControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SurveyQuestionOutputDto, any>({
        path: `/survey-questions/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a SurveyQuestion
     *
     * @tags SurveyQuestion
     * @name SurveyQuestionsControllerUpdate
     * @request PATCH:/survey-questions/{id}
     * @secure
     */
    surveyQuestionsControllerUpdate: (
      id: string,
      data: SurveyQuestionUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SurveyQuestionOutputDto, any>({
        path: `/survey-questions/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a SurveyQuestion by id
     *
     * @tags SurveyQuestion
     * @name SurveyQuestionsControllerRemove
     * @request DELETE:/survey-questions/{id}
     * @secure
     */
    surveyQuestionsControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/survey-questions/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
  };
  surveyResponses = {
    /**
     * @description Paginates SurveyResponse
     *
     * @tags SurveyResponse
     * @name SurveyResponsesControllerPaginate
     * @request GET:/survey-responses
     * @secure
     */
    surveyResponsesControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            alarm: {
              /** @format uuid */
              _id: string;
              _ref: "Alarm";
            };
            answers?: (
              | {
                  type: "multipleChoice";
                  /** PII */
                  answer: {
                    value: number;
                    /** @maxLength 1024 */
                    label: string;
                  };
                  question: {
                    /** @format uuid */
                    _id: string;
                    _ref: "SurveyQuestion";
                  };
                }
              | {
                  type: "likertScale";
                  answer: {
                    value: number;
                    /** @maxLength 1024 */
                    label: string;
                  };
                  question: {
                    /** @format uuid */
                    _id: string;
                    _ref: "SurveyQuestion";
                  };
                }
              | {
                  type: "followUp";
                  answer: {
                    value: number;
                    /** @maxLength 1024 */
                    label: string;
                  }[];
                  question: {
                    /** @format uuid */
                    _id: string;
                    _ref: "SurveyQuestion";
                  };
                }
              | {
                  type: "openEnded";
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  answer: string;
                  question: {
                    /** @format uuid */
                    _id: string;
                    _ref: "SurveyQuestion";
                  };
                }
            )[];
            /** @maxLength 1024 */
            token: string;
            questions: {
              /** @format uuid */
              _id: string;
              _ref: "SurveyType";
            };
            /** @format date-time */
            completedAt?: string;
            responder: {
              /** @format uuid */
              _id: string;
              _ref: "User" | "AlarmHelper" | "StaticResponder" | "AlarmProfessionalResponder" | "Asset";
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/survey-responses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a SurveyResponse
     *
     * @tags SurveyResponse
     * @name SurveyResponsesControllerCreate
     * @request POST:/survey-responses
     * @secure
     */
    surveyResponsesControllerCreate: (
      data: SurveyResponseCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SurveyResponseOutputDto, any>({
        path: `/survey-responses`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a SurveyResponse by id
     *
     * @tags SurveyResponse
     * @name SurveyResponsesControllerFindById
     * @request GET:/survey-responses/{id}
     * @secure
     */
    surveyResponsesControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SurveyResponseOutputDto, any>({
        path: `/survey-responses/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a SurveyResponse
     *
     * @tags SurveyResponse
     * @name SurveyResponsesControllerUpdate
     * @request PATCH:/survey-responses/{id}
     * @secure
     */
    surveyResponsesControllerUpdate: (
      id: string,
      data: SurveyResponseUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SurveyResponseOutputDto, any>({
        path: `/survey-responses/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a SurveyResponse by id
     *
     * @tags SurveyResponse
     * @name SurveyResponsesControllerRemove
     * @request DELETE:/survey-responses/{id}
     * @secure
     */
    surveyResponsesControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/survey-responses/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyResponse
     * @name SurveyResponsesControllerGetSurveyResponseQuestionsByToken
     * @request GET:/survey-responses/questions/{token}
     * @secure
     */
    surveyResponsesControllerGetSurveyResponseQuestionsByToken: (
      token: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/survey-responses/questions/${token}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Partially updates a SurveyResponse
     *
     * @tags SurveyResponse
     * @name SurveyResponsesControllerSubmitResponse
     * @request PATCH:/survey-responses/submit
     * @secure
     */
    surveyResponsesControllerSubmitResponse: (
      id: string,
      data: SurveyResponseAnswerUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SurveyResponseOutputDto, any>({
        path: `/survey-responses/submit`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  surveyTypes = {
    /**
     * @description Paginates SurveyType
     *
     * @tags SurveyType
     * @name SurveyTypesControllerPaginate
     * @request GET:/survey-types
     * @secure
     */
    surveyTypesControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer?: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            questions: {
              /** @format uuid */
              _id: string;
              _ref: "SurveyQuestion";
            }[];
            userType: "alarmCreator" | "alarmResponder" | "alarmCenter" | "AlarmProfessionalResponder";
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/survey-types`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a SurveyType
     *
     * @tags SurveyType
     * @name SurveyTypesControllerCreate
     * @request POST:/survey-types
     * @secure
     */
    surveyTypesControllerCreate: (
      data: SurveyTypeCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SurveyTypeOutputDto, any>({
        path: `/survey-types`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a SurveyType by id
     *
     * @tags SurveyType
     * @name SurveyTypesControllerFindById
     * @request GET:/survey-types/{id}
     * @secure
     */
    surveyTypesControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SurveyTypeOutputDto, any>({
        path: `/survey-types/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a SurveyType
     *
     * @tags SurveyType
     * @name SurveyTypesControllerUpdate
     * @request PATCH:/survey-types/{id}
     * @secure
     */
    surveyTypesControllerUpdate: (
      id: string,
      data: SurveyTypeUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SurveyTypeOutputDto, any>({
        path: `/survey-types/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a SurveyType by id
     *
     * @tags SurveyType
     * @name SurveyTypesControllerRemove
     * @request DELETE:/survey-types/{id}
     * @secure
     */
    surveyTypesControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/survey-types/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
  };
  users = {
    /**
     * @description Creates a User
     *
     * @tags User
     * @name UsersControllerCreate
     * @request POST:/users
     * @secure
     */
    usersControllerCreate: (
      data: UserCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserOutputDto, any>({
        path: `/users`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates User
     *
     * @tags User
     * @name UsersControllerPaginate
     * @request GET:/users
     * @secure
     */
    usersControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            /**
             * PII
             * @maxLength 1024
             */
            username: string;
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            properties: {
              /**
               * PII
               * @maxLength 1024
               */
              phoneNumber?: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              smsNumber?: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              email?: string | null;
              /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
              locale?: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              image?: string | null;
              /** PII */
              rSim?: {
                /**
                 * PII
                 * @maxLength 1024
                 */
                euicc: string;
                primary: {
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  msisdn: string;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  iccid: string;
                };
                secondary: {
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  msisdn: string;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  iccid: string;
                };
                enabled: boolean;
              } | null;
            };
            /** @default [] */
            globalRoles?: string[];
            /** @default [] */
            specialPermissions?: string[];
            isServiceAccount?: boolean;
            /**
             * PII
             * @format date-time
             */
            lastActiveAt?: string;
            type?: "default" | "serviceAccount" | "kiosk";
            userPolicies?: {
              disablePasswordlessLogin?: boolean;
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a User by id
     *
     * @tags User
     * @name UsersControllerFindById
     * @request GET:/users/{id}
     * @secure
     */
    usersControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserOutputDto, any>({
        path: `/users/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a User
     *
     * @tags User
     * @name UsersControllerUpdate
     * @request PATCH:/users/{id}
     * @secure
     */
    usersControllerUpdate: (
      id: string,
      data: UserUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserOutputDto, any>({
        path: `/users/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a User by id
     *
     * @tags User
     * @name UsersControllerRemove
     * @request DELETE:/users/{id}
     * @secure
     */
    usersControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/users/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersControllerValidateSpecialPermission
     * @request POST:/users/{id}/validate-special-permission
     * @secure
     */
    usersControllerValidateSpecialPermission: (
      id: string,
      data: ValidateSpecialPermissionRequestDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/users/${id}/validate-special-permission`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersControllerPost2FaDisable
     * @request POST:/users/2fa/disable/{id}
     * @secure
     */
    usersControllerPost2FaDisable: (
      id: string,
      data: DisableTwoFactorAuthRequestDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DisableTwoFactorAuthResponseDto, any>({
        path: `/users/2fa/disable/${id}`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersControllerPost2FaEnable
     * @request POST:/users/2fa/enable/{id}
     * @secure
     */
    usersControllerPost2FaEnable: (
      id: string,
      data: EnableTwoFactorAuthRequestDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EnableTwoFactorAuthResponseDto, any>({
        path: `/users/2fa/enable/${id}`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersControllerGet2FaSharedSecret
     * @request GET:/users/2fa/shared-secret/{id}
     * @secure
     */
    usersControllerGet2FaSharedSecret: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TwoFactorGetSharedSecretResponseDto, any>({
        path: `/users/2fa/shared-secret/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersControllerGet2FaStatus
     * @request GET:/users/2fa/status/{id}
     * @secure
     */
    usersControllerGet2FaStatus: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TwoFactorAuthStatusResponseDto, any>({
        path: `/users/2fa/status/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersControllerAddPhoto
     * @request POST:/users/app/photo
     * @secure
     */
    usersControllerAddPhoto: (
      data: {
        /** @format binary */
        photo_url: File;
      },
      query?: {
        /** User id parameter, optional */
        id?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ImageUploadDto, any>({
        path: `/users/app/photo`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersControllerCheckUsername
     * @request POST:/users/check-username
     * @secure
     */
    usersControllerCheckUsername: (
      data: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/users/check-username`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersControllerCreateUserAndReturnAccessToken
     * @request GET:/users/obtain-access-token/{id}
     * @secure
     */
    usersControllerCreateUserAndReturnAccessToken: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/users/obtain-access-token/${id}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersControllerGetResetPassword
     * @request GET:/users/reset-password/{id}
     * @secure
     */
    usersControllerGetResetPassword: (
      id: string,
      query: {
        bhvk: boolean;
        admin_role_assigned: boolean;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/users/reset-password/${id}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Searches User
     *
     * @tags User
     * @name UsersControllerSearch
     * @request GET:/users/search
     * @secure
     */
    usersControllerSearch: (
      query: {
        /** The search query string */
        q: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            /**
             * PII
             * @maxLength 1024
             */
            username: string;
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            properties: {
              /**
               * PII
               * @maxLength 1024
               */
              phoneNumber?: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              smsNumber?: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              email?: string | null;
              /** Locale, accepts the following values. 'en, nl, no, fr, de', default to en otherwise. */
              locale?: string | null;
              /**
               * PII
               * @maxLength 1024
               */
              image?: string | null;
              /** PII */
              rSim?: {
                /**
                 * PII
                 * @maxLength 1024
                 */
                euicc: string;
                primary: {
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  msisdn: string;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  iccid: string;
                };
                secondary: {
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  msisdn: string;
                  /**
                   * PII
                   * @maxLength 1024
                   */
                  iccid: string;
                };
                enabled: boolean;
              } | null;
            };
            /** @default [] */
            globalRoles?: string[];
            /** @default [] */
            specialPermissions?: string[];
            isServiceAccount?: boolean;
            /**
             * PII
             * @format date-time
             */
            lastActiveAt?: string;
            type?: "default" | "serviceAccount" | "kiosk";
            userPolicies?: {
              disablePasswordlessLogin?: boolean;
            };
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/users/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersControllerGetSetPasswordToBase
     * @request GET:/users/to-base-password/{id}
     * @secure
     */
    usersControllerGetSetPasswordToBase: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/users/to-base-password/${id}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersControllerPostWithRelation
     * @request POST:/users/with-relation
     * @secure
     */
    usersControllerPostWithRelation: (
      data: UserCreateWithRelationDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/users/with-relation`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersControllerGetWithoutApp
     * @request GET:/users/without-app
     * @secure
     */
    usersControllerGetWithoutApp: (
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/users/without-app`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  validators = {
    /**
     * No description
     *
     * @tags Validator
     * @name ValidatorControllerValidate
     * @request POST:/validators/validate
     * @secure
     */
    validatorControllerValidate: (
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/validators/validate`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),
  };
  visitRecords = {
    /**
     * @description Creates a VisitRecord
     *
     * @tags VisitRecord
     * @name VisitRecordsControllerCreate
     * @request POST:/visit-records
     * @secure
     */
    visitRecordsControllerCreate: (
      data: VisitRecordCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VisitRecordOutputDto, any>({
        path: `/visit-records`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates VisitRecord
     *
     * @tags VisitRecord
     * @name VisitRecordsControllerPaginate
     * @request GET:/visit-records
     * @secure
     */
    visitRecordsControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /** @maxLength 1024 */
            description?: string;
            /** @format date-time */
            scheduledStartAt?: string;
            /** @format date-time */
            scheduledEndAt?: string;
            /** PII */
            kioskZone: {
              /** @format uuid */
              _id: string;
              _ref: "Zone";
            };
            /** PII */
            host: {
              /**
               * PII
               * @maxLength 1024
               */
              name: string;
              /**
               * PII
               * @format email
               * @maxLength 1024
               */
              email?: string;
            };
            attendees: {
              /** PII */
              personalInformation: {
                /** @format uuid */
                _id: string;
                _ref: "Visitor";
              };
              checkInRecord?: {
                /** @format date-time */
                timestamp: string;
                /** PII */
                kiosk: {
                  /** @format uuid */
                  _id: string;
                  _ref: "Asset";
                };
              };
              checkOutRecord?: {
                /** @format date-time */
                timestamp: string;
                /** PII */
                kiosk: {
                  /** @format uuid */
                  _id: string;
                  _ref: "Asset";
                };
              };
            }[];
            visitRecordType: "SCHEDULED" | "SPONTANEOUS" | "RECURRING";
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/visit-records`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a VisitRecord by id
     *
     * @tags VisitRecord
     * @name VisitRecordsControllerFindById
     * @request GET:/visit-records/{id}
     * @secure
     */
    visitRecordsControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VisitRecordOutputDto, any>({
        path: `/visit-records/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a VisitRecord
     *
     * @tags VisitRecord
     * @name VisitRecordsControllerUpdate
     * @request PATCH:/visit-records/{id}
     * @secure
     */
    visitRecordsControllerUpdate: (
      id: string,
      data: VisitRecordUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VisitRecordOutputDto, any>({
        path: `/visit-records/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a VisitRecord by id
     *
     * @tags VisitRecord
     * @name VisitRecordsControllerRemove
     * @request DELETE:/visit-records/{id}
     * @secure
     */
    visitRecordsControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/visit-records/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Partially updates a VisitRecord
     *
     * @tags VisitRecord
     * @name VisitRecordsControllerUpdateAttendee
     * @request PATCH:/visit-records/{id}/attendees/{visitorId}
     * @secure
     */
    visitRecordsControllerUpdateAttendee: (
      id: string,
      visitorId: string,
      data: AttendeeUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VisitRecordOutputDto, any>({
        path: `/visit-records/${id}/attendees/${visitorId}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a VisitRecord
     *
     * @tags VisitRecord
     * @name VisitRecordsControllerValidateQrCode
     * @request POST:/visit-records/{id}/attendees/{visitorId}/check-in-out-records
     * @secure
     */
    visitRecordsControllerValidateQrCode: (
      id: string,
      visitorId: string,
      data: CheckInOutRecordDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VisitRecordOutputDto, any>({
        path: `/visit-records/${id}/attendees/${visitorId}/check-in-out-records`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a VisitRecord
     *
     * @tags VisitRecord
     * @name VisitRecordsControllerCreatePublic
     * @request POST:/visit-records/public
     * @secure
     */
    visitRecordsControllerCreatePublic: (
      data: VisitRecordCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VisitRecordOutputDto, any>({
        path: `/visit-records/public`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  visitors = {
    /**
     * @description Creates a Visitor
     *
     * @tags Visitor
     * @name VisitorsControllerCreate
     * @request POST:/visitors
     * @secure
     */
    visitorsControllerCreate: (
      data: VisitorCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VisitorOutputDto, any>({
        path: `/visitors`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates Visitor
     *
     * @tags Visitor
     * @name VisitorsControllerPaginate
     * @request GET:/visitors
     * @secure
     */
    visitorsControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            /**
             * PII
             * @maxLength 1024
             */
            firstName: string;
            /**
             * PII
             * @maxLength 1024
             */
            lastName: string;
            /**
             * PII
             * @format email
             * @maxLength 1024
             */
            email: string;
            /**
             * PII
             * @maxLength 1024
             */
            visitorCompany?: string;
            /** @format date-time */
            accessValidUntil?: string;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/visitors`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a Visitor by id
     *
     * @tags Visitor
     * @name VisitorsControllerFindById
     * @request GET:/visitors/{id}
     * @secure
     */
    visitorsControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VisitorOutputDto, any>({
        path: `/visitors/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a Visitor
     *
     * @tags Visitor
     * @name VisitorsControllerUpdate
     * @request PATCH:/visitors/{id}
     * @secure
     */
    visitorsControllerUpdate: (
      id: string,
      data: VisitorUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VisitorOutputDto, any>({
        path: `/visitors/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a Visitor by id
     *
     * @tags Visitor
     * @name VisitorsControllerRemove
     * @request DELETE:/visitors/{id}
     * @secure
     */
    visitorsControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/visitors/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Creates a Visitor
     *
     * @tags Visitor
     * @name VisitorsControllerCreatePublic
     * @request POST:/visitors/public
     * @secure
     */
    visitorsControllerCreatePublic: (
      data: VisitorCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VisitorOutputDto, any>({
        path: `/visitors/public`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  webhooks = {
    /**
     * @description Creates a Webhook
     *
     * @tags Webhook
     * @name WebhookControllerCreate
     * @request POST:/webhooks
     * @secure
     */
    webhookControllerCreate: (
      data: WebhookCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebhookOutputDto, any>({
        path: `/webhooks`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates Webhook
     *
     * @tags Webhook
     * @name WebhookControllerPaginate
     * @request GET:/webhooks
     * @secure
     */
    webhookControllerPaginate: (
      query?: {
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            } | null;
            /** @maxLength 1024 */
            migrationKey?: string | null;
            webhookQuery: {
              operation: "create" | "update" | "remove";
              entityTypes: string[];
              filter: Record<string, any>;
            };
            /** @default {} */
            deliveryStats?: {
              /**
               * @format date-time
               * @default null
               */
              lastDeliveryDate?: string | null;
              /** @default 0 */
              numDeliverySucceeded?: number;
              /** @default 0 */
              numDeliveryFailed?: number;
            };
            deliveryConfig: {
              /** @format uri */
              url: string;
              method: "POST" | "GET" | "PUT" | "PATCH" | "DELETE";
              /** @default null */
              headers?: Record<string, any>;
            };
            /**
             * @maxLength 1024
             * @default null
             */
            transformer?: string | null;
            /** @default true */
            enableWebhook?: boolean;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/webhooks`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a Webhook by id
     *
     * @tags Webhook
     * @name WebhookControllerFindById
     * @request GET:/webhooks/{id}
     * @secure
     */
    webhookControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebhookOutputDto, any>({
        path: `/webhooks/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a Webhook
     *
     * @tags Webhook
     * @name WebhookControllerUpdate
     * @request PATCH:/webhooks/{id}
     * @secure
     */
    webhookControllerUpdate: (
      id: string,
      data: WebhookUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebhookOutputDto, any>({
        path: `/webhooks/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a Webhook by id
     *
     * @tags Webhook
     * @name WebhookControllerRemove
     * @request DELETE:/webhooks/{id}
     * @secure
     */
    webhookControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/webhooks/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhook
     * @name WebhookControllerDeliveryStatUpdate
     * @request POST:/webhooks/delivery/{id}
     * @secure
     */
    webhookControllerDeliveryStatUpdate: (
      id: string,
      data: WebhookDeliveryUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/webhooks/delivery/${id}`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Searches Webhook
     *
     * @tags Webhook
     * @name WebhookControllerSearch
     * @request GET:/webhooks/search
     * @secure
     */
    webhookControllerSearch: (
      query: {
        /** The search query string */
        q: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            } | null;
            /** @maxLength 1024 */
            migrationKey?: string | null;
            webhookQuery: {
              operation: "create" | "update" | "remove";
              entityTypes: string[];
              filter: Record<string, any>;
            };
            /** @default {} */
            deliveryStats?: {
              /**
               * @format date-time
               * @default null
               */
              lastDeliveryDate?: string | null;
              /** @default 0 */
              numDeliverySucceeded?: number;
              /** @default 0 */
              numDeliveryFailed?: number;
            };
            deliveryConfig: {
              /** @format uri */
              url: string;
              method: "POST" | "GET" | "PUT" | "PATCH" | "DELETE";
              /** @default null */
              headers?: Record<string, any>;
            };
            /**
             * @maxLength 1024
             * @default null
             */
            transformer?: string | null;
            /** @default true */
            enableWebhook?: boolean;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/webhooks/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  zones = {
    /**
     * @description Creates a Zone
     *
     * @tags Zone
     * @name ZonesControllerCreate
     * @request POST:/zones
     * @secure
     */
    zonesControllerCreate: (
      data: ZoneCreateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ZoneOutputDto, any>({
        path: `/zones`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates Zone
     *
     * @tags Zone
     * @name ZonesControllerPaginate
     * @request GET:/zones
     * @secure
     */
    zonesControllerPaginate: (
      query?: {
        includeFingerprints?: boolean;
        /** Number of documents to skip */
        $offset?: number;
        /** Maximum number of documents to return */
        $max?: number;
        /** Projection to include in the response */
        $select?: string;
        /** Fields to exclude from the response */
        $omit?: string;
        /** Comma delimited list of exposed fields to sort by */
        $sort?: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            type:
              | "default"
              | "responseArea"
              | "policeDepartment"
              | "assetMonitoredArea"
              | "fingerprinted"
              | "building"
              | "evacuationPoint";
            /** PII */
            location:
              | {
                  type: "Polygon";
                  /** PII */
                  coordinates: number[][][];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                }
              | {
                  type: "MultiPolygon";
                  coordinates: number[][][][];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                };
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /**
             * PII
             * @maxLength 1024
             * @default null
             */
            description?: string | null;
            /** @default [] */
            staticResponders?: {
              staticResponder: {
                /** @format uuid */
                _id: string;
                _ref: "StaticResponder";
              };
              priority: number;
            }[];
            /** @default null */
            responsePriority?: number | null;
            assetsInside: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            }[];
            syncToAms?: boolean;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/zones`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finds a Zone by id
     *
     * @tags Zone
     * @name ZonesControllerFindById
     * @request GET:/zones/{id}
     * @secure
     */
    zonesControllerFindById: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ZoneOutputDto, any>({
        path: `/zones/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially updates a Zone
     *
     * @tags Zone
     * @name ZonesControllerUpdate
     * @request PATCH:/zones/{id}
     * @secure
     */
    zonesControllerUpdate: (
      id: string,
      data: ZoneUpdateDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ZoneOutputDto, any>({
        path: `/zones/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Removes a Zone by id
     *
     * @tags Zone
     * @name ZonesControllerRemove
     * @request DELETE:/zones/{id}
     * @secure
     */
    zonesControllerRemove: (
      id: string,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/zones/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zone
     * @name ZonesControllerAlarmProfessionalResponderCount
     * @request GET:/zones/alarm-professional-responder-count
     * @secure
     */
    zonesControllerAlarmProfessionalResponderCount: (
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AlarmProfessionalResponderCountOutputDto[], any>({
        path: `/zones/alarm-professional-responder-count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zone
     * @name ZonesControllerGeoIntersectsPointPost
     * @request POST:/zones/intersect
     * @secure
     */
    zonesControllerGeoIntersectsPointPost: (
      data: IntersectsPointDto,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ZoneOutputDto[], any>({
        path: `/zones/intersect`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zone
     * @name ZonesControllerReverseGeocode
     * @request GET:/zones/reverse-geocode/{lat}/{lng}
     * @secure
     */
    zonesControllerReverseGeocode: (
      lat: number,
      lng: number,
      query?: {
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/zones/reverse-geocode/${lat}/${lng}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Searches Zone
     *
     * @tags Zone
     * @name ZonesControllerSearch
     * @request GET:/zones/search
     * @secure
     */
    zonesControllerSearch: (
      query: {
        includeFingerprints?: boolean;
        /** The search query string */
        q: string;
        /** @format uuid */
        customer?: string;
        /**
         * User to impersonate during the request
         * @format uuid
         */
        asUser?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          result: {
            /** @format uuid */
            _id: string;
            /** @format date-time */
            createdAt: string;
            /** @format date-time */
            updatedAt: string;
            customer: {
              /** @format uuid */
              _id: string;
              _ref: "Customer";
            };
            /** @default {"type":"parents","extra":[]} */
            share?: {
              type: "publicRead" | "private" | "inherit" | "parents" | "children" | "family";
              extra?: {
                /** @format uuid */
                _id: string;
                _ref: "Customer";
              }[];
            };
            type:
              | "default"
              | "responseArea"
              | "policeDepartment"
              | "assetMonitoredArea"
              | "fingerprinted"
              | "building"
              | "evacuationPoint";
            /** PII */
            location:
              | {
                  type: "Polygon";
                  /** PII */
                  coordinates: number[][][];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                }
              | {
                  type: "MultiPolygon";
                  coordinates: number[][][][];
                  properties: {
                    accuracy?: number;
                    heading?: number;
                    headingAccuracy?: number;
                    speed?: number;
                    speedAccuracy?: number;
                    altitude?: number;
                    altitudeAccuracy?: number;
                    /** PII */
                    address?: {
                      /** @maxLength 1024 */
                      countryCode?: string | null;
                      /** @maxLength 1024 */
                      state?: string | null;
                      /** @maxLength 1024 */
                      city?: string | null;
                      /** @maxLength 1024 */
                      streetName?: string | null;
                      /** @maxLength 1024 */
                      streetNumber?: string | null;
                      floor?: number | null;
                      /** @maxLength 1024 */
                      formattedAddress?: string;
                    };
                    /** @format date-time */
                    dateTime?: string;
                    /** @maxLength 1024 */
                    provider?: string;
                  };
                };
            /**
             * PII
             * @maxLength 1024
             */
            name: string;
            /**
             * PII
             * @maxLength 1024
             * @default null
             */
            description?: string | null;
            /** @default [] */
            staticResponders?: {
              staticResponder: {
                /** @format uuid */
                _id: string;
                _ref: "StaticResponder";
              };
              priority: number;
            }[];
            /** @default null */
            responsePriority?: number | null;
            assetsInside: {
              /** @format uuid */
              _id: string;
              _ref: "Asset";
            }[];
            syncToAms?: boolean;
          }[];
          total: number;
          max: number;
          offset: number;
        },
        any
      >({
        path: `/zones/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
